/*!
   angular-block-ui v0.1.1
   (c) 2014 (null) McNull https://github.com/McNull/angular-block-ui
   License: MIT
*/
(function(angular) {

var blkUI = angular.module('blockUI', []);

blkUI.config(["$provide", "$httpProvider", function($provide, $httpProvider) {

  $provide.decorator('$exceptionHandler', ['$delegate', '$injector',
    function($delegate, $injector) {
      var blockUI, blockUIConfig;

      return function(exception, cause) {

        blockUIConfig = blockUIConfig || $injector.get('blockUIConfig');

        if (blockUIConfig.resetOnException) {
          try {
            blockUI = blockUI || $injector.get('blockUI');
            blockUI.instances.reset();
          } catch(ex) {
            console.log('$exceptionHandler', exception);
          }
        }

        $delegate(exception, cause);
      };
    }
  ]);

  $httpProvider.interceptors.push('blockUIHttpInterceptor');
}]);

blkUI.run(["$document", "blockUIConfig", "$templateCache", function($document, blockUIConfig, $templateCache) {
  if(blockUIConfig.autoInjectBodyBlock) {
    $document.find('body').attr('block-ui', 'main');
  }

  if (blockUIConfig.template) {

    // Swap the builtin template with the custom template.
    // Create a magic cache key and place the template in the cache.

    blockUIConfig.templateUrl = '$$block-ui-template$$';
    $templateCache.put(blockUIConfig.templateUrl, blockUIConfig.template);
  }
}]);

blkUI.directive('blockUiContainer', ["blockUIConfig", "blockUiContainerLinkFn", function (blockUIConfig, blockUiContainerLinkFn) {
  return {
    scope: true,
    restrict: 'A',
    templateUrl: blockUIConfig.templateUrl,
    compile: function($element) {
      return blockUiContainerLinkFn;
    }
  };
}]).factory('blockUiContainerLinkFn', ["blockUI", "blockUIUtils", function (blockUI, blockUIUtils) {

  return function ($scope, $element, $attrs) {

    var srvInstance = $element.inheritedData('block-ui');

    if (!srvInstance) {
      throw new Error('No parent block-ui service instance located.');
    }

    // Expose the state on the scope

    $scope.state = srvInstance.state();

//    $scope.$watch('state.blocking', function(value) {
//      $element.toggleClass('block-ui-visible', !!value);
//    });
//
//    $scope.$watch('state.blockCount > 0', function(value) {
//      $element.toggleClass('block-ui-active', !!value);
//    });
  };
}]);
blkUI.directive('blockUi', ["blockUiCompileFn", function (blockUiCompileFn) {

  return {
    scope: true,
    restrict: 'A',
    compile: blockUiCompileFn
  };

}]).factory('blockUiCompileFn', ["blockUiPreLinkFn", function (blockUiPreLinkFn) {

  return function ($element, $attrs) {

    // Class should be added here to prevent an animation delay error.

    $element.append('<div block-ui-container class="block-ui-container"></div>');

    return {
      pre: blockUiPreLinkFn
    };

  };

}]).factory('blockUiPreLinkFn', ["blockUI", "blockUIUtils", "blockUIConfig", function (blockUI, blockUIUtils, blockUIConfig) {

  return function ($scope, $element, $attrs) {

    // If the element does not have the class "block-ui" set, we set the
    // default css classes from the config.

    if (!$element.hasClass('block-ui')) {
      $element.addClass(blockUIConfig.cssClass);
    }

    // Expose the blockUiMessageClass attribute value on the scope

    $attrs.$observe('blockUiMessageClass', function (value) {
      $scope.$_blockUiMessageClass = value;
    });

    // Create the blockUI instance
    // Prefix underscore to prevent integers:
    // https://github.com/McNull/angular-block-ui/pull/8

    var instanceId = $attrs.blockUi || '_' + $scope.$id;
    var srvInstance = blockUI.instances.get(instanceId);

    // If this is the main (topmost) block element we'll also need to block any
    // location changes while the block is active.

    if (instanceId === 'main' && blockUIConfig.preventRouting) {

      // After the initial content has been loaded we'll spy on any location
      // changes and discard them when needed.

      var fn = $scope.$on('$viewContentLoaded', function () {

        // Unhook the view loaded and hook a function that will prevent
        // location changes while the block is active.

        fn();

        $scope.$on('$locationChangeStart', function (event) {
          if (srvInstance.state().blockCount > 0) {
            event.preventDefault();
          }
        });

      });
    } else {
      // Locate the parent blockUI instance
      var parentInstance = $element.inheritedData('block-ui');

      if (parentInstance) {
        // TODO: assert if parent is already set to something else
        srvInstance._parent = parentInstance;
      }
    }

    // Ensure the instance is released when the scope is destroyed

    $scope.$on('$destroy', function () {
      srvInstance.release();
    });

    // Increase the reference count

    srvInstance.addRef();

    // Expose the state on the scope

    $scope.$_blockUiState = srvInstance.state();

    $scope.$watch('$_blockUiState.blocking', function (value) {
      // Set the aria-busy attribute if needed
      $element.attr('aria-busy', !!value);
      $element.toggleClass('block-ui-visible', !!value);
    });

    $scope.$watch('$_blockUiState.blockCount > 0', function (value) {
      $element.toggleClass('block-ui-active', !!value);
    });

    // If a pattern is provided assign it to the state

    var pattern = $attrs.blockUiPattern;

    if (pattern) {
      var regExp = blockUIUtils.buildRegExp(pattern);
      srvInstance.pattern(regExp);
    }

    // Store a reference to the service instance on the element

    $element.data('block-ui', srvInstance);

  };

}]);
//.factory('blockUiPostLinkFn', function(blockUIUtils) {
//
//  return function($scope, $element, $attrs) {
//
//    var $message;
//
//    $attrs.$observe('blockUiMessageClass', function(value) {
//
//      $message = $message || blockUIUtils.findElement($element, function($e) {
//        return $e.hasClass('block-ui-message');
//      });
//
//      $message.addClass(value);
//
//    });
//  };
//
//});
blkUI.constant('blockUIConfig', {
    templateUrl: 'angular-block-ui/angular-block-ui.ng.html',
    delay: 250,
    message: "Loading ...",
    autoBlock: true,
    resetOnException: true,
    requestFilter: angular.noop,
    autoInjectBodyBlock: true,
    cssClass: 'block-ui block-ui-anim-fade',
    preventRouting: true
});


blkUI.factory('blockUIHttpInterceptor', ["$q", "$injector", "blockUIConfig", "$templateCache", function($q, $injector, blockUIConfig, $templateCache) {

  var blockUI;

  function injectBlockUI() {
    blockUI = blockUI || $injector.get('blockUI');
  }

  function stopBlockUI(config) {
    if (blockUIConfig.autoBlock && (config && !config.$_noBlock && config.$_blocks)) {
      injectBlockUI();
      config.$_blocks.stop();
    }
  }

  function error(rejection) {

    try {
      stopBlockUI(rejection.config);
    } catch(ex) {
      console.log('httpRequestError', ex);
    }

    return $q.reject(rejection);
  }

  return {
    request: function(config) {

      // Only block when autoBlock is enabled ...
      // ... and the request doesn't match a cached template.

      if (blockUIConfig.autoBlock &&
        !(config.method == 'GET' && $templateCache.get(config.url))) {

        // Don't block excluded requests

        var result = blockUIConfig.requestFilter(config);

        if (result === false) {
          // Tag the config so we don't unblock this request
          config.$_noBlock = true;
        } else {

          injectBlockUI();

          config.$_blocks = blockUI.instances.locate(config);
          config.$_blocks.start(result);
        }
      }

      return config;
    },

    requestError: error,

    response: function(response) {
      stopBlockUI(response.config);
      return response;
    },

    responseError: error
  };

}]);

blkUI.factory('blockUI', ["blockUIConfig", "$timeout", "blockUIUtils", "$document", function(blockUIConfig, $timeout, blockUIUtils, $document) {

  var $body = $document.find('body');

  function BlockUI(id) {

    var self = this;

    var state = {
      id: id,
      blockCount: 0,
      message: blockUIConfig.message,
      blocking: false
    }, startPromise, doneCallbacks = [];

    this._id = id;

    this._refs = 0;

    this.start = function(message) {

      if(state.blockCount > 0) {
        message = message || state.message || blockUIConfig.message;
      } else {
        message = message || blockUIConfig.message;
      }

      state.message = message;

      state.blockCount++;

      // Check if the focused element is part of the block scope

      var $ae = angular.element($document[0].activeElement);

      if($ae.length && blockUIUtils.isElementInBlockScope($ae, self)) {

        // Let the active element lose focus and store a reference 
        // to restore focus when we're done (reset)

        self._restoreFocus = $ae[0];

        // https://github.com/McNull/angular-block-ui/issues/13
        // http://stackoverflow.com/questions/22698058/apply-already-in-progress-error-when-using-typeahead-plugin-found-to-be-relate
        // Queue the blur after any ng-blur expression.

        $timeout(function() {
          // Ensure we still need to blur
          if(self._restoreFocus) {
            self._restoreFocus.blur();
          }
        });
      }

      if (!startPromise) {
        startPromise = $timeout(function() {
          startPromise = null;
          state.blocking = true;
        }, blockUIConfig.delay);
      }
    };

    this._cancelStartTimeout = function() {
      if (startPromise) {
        $timeout.cancel(startPromise);
        startPromise = null;
      }
    };

    this.stop = function() {
      state.blockCount = Math.max(0, --state.blockCount);

      if (state.blockCount === 0) {
        self.reset(true);
      }
    };

    this.message = function(value) {
      state.message = value;
    };

    this.pattern = function(regexp) {
      if (regexp !== undefined) {
        self._pattern = regexp;
      }

      return self._pattern;
    };

    this.reset = function(executeCallbacks) {
      
      self._cancelStartTimeout();
      state.blockCount = 0;
      state.blocking = false;

      // Restore the focus to the element that was active
      // before the block start, but not if the user has 
      // focused something else while the block was active.

      if(self._restoreFocus && 
         (!$document[0].activeElement || $document[0].activeElement === $body[0])) {
        self._restoreFocus.focus();
        self._restoreFocus = null;
      }
      
      try {
        if (executeCallbacks) {
          angular.forEach(doneCallbacks, function(cb) {
            cb();
          });
        }
      } finally {
        doneCallbacks.length = 0;
      }
    };

    this.done = function(fn) {
      doneCallbacks.push(fn);
    };

    this.state = function() {
      return state;
    };

    this.addRef = function() {
      self._refs += 1;
    };

    this.release = function() {
      if(--self._refs <= 0) {
        mainBlock.instances._destroy(self);
      }
    };
  }

  var instances = [];

  instances.get = function(id) {

    if(!isNaN(id)) {
      throw new Error('BlockUI id cannot be a number');
    }

    var instance = instances[id];

    if(!instance) {
      // TODO: ensure no array instance trashing [xxx] -- current workaround: '_' + $scope.$id
      instance = instances[id] = new BlockUI(id);
      instances.push(instance);
    }

    return instance;
  };

  instances._destroy = function(idOrInstance) {
    if (angular.isString(idOrInstance)) {
      idOrInstance = instances[idOrInstance];
    }

    if (idOrInstance) {
      idOrInstance.reset();

      var i = blockUIUtils.indexOf(instances, idOrInstance);
      instances.splice(i, 1);

      delete instances[idOrInstance.state().id];
    }
  };
  
  instances.locate = function(request) {

    var result = [];

    // Add function wrappers that will be executed on every item
    // in the array.
    
    blockUIUtils.forEachFnHook(result, 'start');
    blockUIUtils.forEachFnHook(result, 'stop');

    var i = instances.length;

    while(i--) {
      var instance = instances[i];
      var pattern = instance._pattern;

      if(pattern && pattern.test(request.url)) {
        result.push(instance);
      }
    }

    if(result.length === 0) {
      result.push(mainBlock);
    }

    return result;
  };

  // Propagate the reset to all instances

  blockUIUtils.forEachFnHook(instances, 'reset');

  var mainBlock = instances.get('main');

  mainBlock.addRef();
  mainBlock.instances = instances;

  return mainBlock;
}]);


blkUI.factory('blockUIUtils', function() {

  var $ = angular.element;

  var utils = {
    buildRegExp: function(pattern) {
      var match = pattern.match(/^\/(.*)\/([gim]*)$/), regExp;

      if(match) {
        regExp = new RegExp(match[1], match[2]);
      } else {
        throw Error('Incorrect regular expression format: ' + pattern);
      }

      return regExp;
    },
    forEachFn: function(arr, fnName, args) {
      var i = arr.length;
      while(i--) {
        var t = arr[i];
        t[fnName].apply(t, args);
      }
    },
    forEachFnHook: function(arr, fnName) {
      arr[fnName] = function() {
        utils.forEachFn(this, fnName, arguments);
      }
    },
    isElementInBlockScope: function($element, blockScope) {
      var c = $element.inheritedData('block-ui');

      while(c) {
        if(c === blockScope) {
          return true;
        }

        c = c._parent;
      }

      return false;
    },
    findElement: function ($element, predicateFn, traverse) {
      var ret = null;

      if (predicateFn($element)) {
        ret = $element;
      } else {

        var $elements;

        if (traverse) {
          $elements = $element.parent();
        } else {
          $elements = $element.children();
        }

        var i = $elements.length;
        while (!ret && i--) {
          ret = utils.findElement($($elements[i]), predicateFn, traverse);
        }
      }

      return ret;
    },
    indexOf: function(arr, obj, start) {
//      if(Array.prototype.indexOf) {
//        return arr.indexOf(obj, start);
//      }

      for (var i = (start || 0), j = arr.length; i < j; i++) {
        if (arr[i] === obj) {
          return i;
        }
      }

      return -1;
    }
  };

  return utils;

});
// Automatically generated.
// This file is already embedded in your main javascript output, there's no need to include this file
// manually in the index.html. This file is only here for your debugging pleasures.
angular.module('blockUI').run(['$templateCache', function($templateCache){
  $templateCache.put('angular-block-ui/angular-block-ui.ng.html', '<div class=\"block-ui-overlay\"></div><div class=\"block-ui-message-container\" aria-live=\"assertive\" aria-atomic=\"true\"><div class=\"block-ui-message\" ng-class=\"$_blockUiMessageClass\">{{ state.message }}</div></div>');
}]);
})(angular);
// sourceMappingURL=angular-block-ui.js.map
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  var trimLeft = /^\s+/;
  var trimRight = /\s+$/;
  function tinycolor(color, opts) {
    color = color ? color : "";
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = Math.round(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: Math.round(this._r),
        g: Math.round(this._g),
        b: Math.round(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: Math.round(bound01(this._r, 255) * 100) + "%",
        g: Math.round(bound01(this._g, 255) * 100) + "%",
        b: Math.round(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
      return this._applyCombination(polyad, [3]);
    },
    tetrad: function tetrad() {
      return this._applyCombination(polyad, [4]);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) return false;
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: Math.random(),
      g: Math.random(),
      b: Math.random()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function polyad(color, number) {
    if (isNaN(number) || number <= 0) {
      throw new Error("Argument to polyad must be a positive number");
    }
    var hsl = tinycolor(color).toHsl();
    var result = [tinycolor(color)];
    var step = 360 / number;
    for (var i = 1; i < number; i++) {
      result.push(tinycolor({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
      }));
    }
    return result;
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      level: level,
      size: size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <https://www.w3.org/TR/css-color-4/#named-colors>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) n = "100%";
    var processPercent = isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == "transparent") {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        a: convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      level: "AA",
      size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      level: level,
      size: size
    };
  }

  return tinycolor;

}));

/*!
 * angularjs-color-picker v0.6.11
 * https://github.com/ruhley/angular-color-picker/
 *
 * Copyright 2015 ruhley
 *
 * 2015-11-19 08:25:57
 *
 */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'color.picker';
}

(function() {
    'use strict';

    angular.module('color.picker', []);
})();

(function() {
    'use strict';

    var colorPicker = function ($document, $timeout) {
        return {
            restrict: 'E',
            require: ['^ngModel'],
            scope: {
                ngModel: '=',
                colorPickerAlpha: '=',
                colorPickerCase: '=',
                colorPickerFormat: '=',
                colorPickerPos: '=',
                colorPickerSwatch: '=',
                colorPickerSwatchOnly: '=',
                colorPickerSwatchPos: '=',
                colorPickerSwatchBootstrap: '='
            },
            templateUrl: 'template/color-picker/directive.html',
            link: function ($scope, element, attrs, control) {
                $scope.init = function () {
                    if ($scope.ngModel === undefined) {
                        $scope.hue = 0;
                        $scope.saturation = 0;
                        $scope.lightness = 100;
                    } else {
                        var color = tinycolor($scope.ngModel);

                        if (color.isValid()) {
                            var hsl = color.toHsv();
                            $scope.hue = hsl.h;
                            $scope.saturation = hsl.s * 100;
                            $scope.lightness = hsl.v * 100;
                            $scope.opacity = hsl.a * 100;
                        }
                    }
                    $scope.initConfig();

                    $document.on('click', $scope.onClick);
                };

                $scope.onClick = function(event) {
                    if ($scope.find(event.target).length === 0) {
                        $scope.log('Color Picker: Document Click Event');
                        $scope.hide();
                    }
                };

                $scope.initConfig = function() {
                    $scope.config = {};
                    $scope.config.alpha = $scope.colorPickerAlpha === undefined ? true : $scope.colorPickerAlpha;
                    $scope.config.case = $scope.colorPickerCase === undefined ? 'upper' : $scope.colorPickerCase;
                    $scope.config.format = $scope.colorPickerFormat === undefined ? 'hsl' : $scope.colorPickerFormat;
                    $scope.config.pos = $scope.colorPickerPos === undefined ? 'bottom left' : $scope.colorPickerPos;
                    $scope.config.swatch = $scope.colorPickerSwatch === undefined ? true : $scope.colorPickerSwatch;
                    $scope.config.swatchOnly = $scope.colorPickerSwatchOnly === undefined ? false : $scope.colorPickerSwatchOnly;
                    $scope.config.swatchPos = $scope.colorPickerSwatchPos === undefined ? 'left' : $scope.colorPickerSwatchPos;
                    $scope.config.swatchBootstrap = $scope.colorPickerSwatchBootstrap === undefined ? true : $scope.colorPickerSwatchBootstrap;
                    $scope.log('Color Picker: Config', $scope.config);
                };

                $scope.focus = function () {
                    $scope.log('Color Picker: Focus Event');
                    $scope.find('.color-picker-input')[0].focus();
                };

                $scope.show = function () {
                    $scope.log('Color Picker: Show Event');
                    $scope.visible = true;
                    $scope.hueMouse = false;
                    $scope.opacityMouse = false;
                    $scope.colorMouse = false;

                    // force the grid selection circle to redraw and fix its position
                    $scope.saturationUpdate();
                    $scope.lightnessUpdate();
                };

                $scope.hide = function () {
                    if ($scope.visible || element[0].querySelector('.color-picker-panel').offsetParent !== null) {
                        $scope.log('Color Picker: Hide Event');

                        $scope.visible = false;
                        $scope.$apply();
                    }
                };

                $scope.update = function () {
                    if ($scope.hue !== undefined && $scope.saturation !== undefined && $scope.lightness !== undefined) {
                        var color = tinycolor({h: $scope.hue, s: $scope.saturation / 100, v: $scope.lightness / 100}),
                            colorString;

                        if ($scope.config.alpha) {
                            color.setAlpha($scope.opacity / 100);
                        }

                        $scope.log('Color Picker: COLOR CHANGED TO ', color, $scope.hue, $scope.saturation, $scope.lightness, $scope.opacity);

                        $scope.swatchColor = color.toHslString();

                        switch ($scope.config.format) {
                            case 'rgb':
                                colorString = color.toRgbString();
                                break;

                            case 'hex':
                                colorString = color.toHexString();
                                if ($scope.config.case === 'lower') {
                                    colorString = colorString.toLowerCase();
                                } else {
                                    colorString = colorString.toUpperCase();
                                }
                                break;

                            case 'hex8':
                                colorString = color.toHex8String();
                                if ($scope.config.case === 'lower') {
                                    colorString = colorString.toLowerCase();
                                } else {
                                    colorString = colorString.toUpperCase();
                                }
                                break;

                            case 'hsv':
                                colorString = color.toHsvString();
                                break;

                            default:
                                colorString = color.toHslString();
                                break;
                        }

                        $scope.ngModel = colorString;
                    }
                };

                $scope.$watch('ngModel', function (newValue, oldValue) {
                    if (typeof newValue === 'string' && newValue !== oldValue && newValue.length > 4) {
                        $scope.log('Color Picker: MODEL - CHANGED', newValue);
                        var color = tinycolor(newValue);

                        if (color.isValid()) {
                            var hsl = color.toHsv();

                            $scope.hue = hsl.h;
                            $scope.saturation = hsl.s * 100;
                            $scope.lightness = hsl.v * 100;

                            if ($scope.config.alpha) {
                                $scope.opacity = hsl.a * 100;
                            }

                            $scope.isValid = true;
                        } else {
                            $scope.isValid = false;
                        }

                        control[0].$setValidity(attrs.name, $scope.isValid);

                        if (oldValue !== undefined && typeof control[0].$setDirty === 'function') {
                            control[0].$setDirty();
                        }
                    } else {
                        $scope.swatchColor = '';
                    }
                });

                $scope.$watch('colorPickerFormat', function (newValue, oldValue) {
                    if (newValue !== undefined && newValue !== oldValue) {
                        if (newValue === 'hex') {
                            $scope.colorPickerAlpha = false;
                        }

                        $scope.initConfig();
                        $scope.update();
                    }
                });

                $scope.$watchGroup(
                    ['colorPickerAlpha', 'colorPickerCase'],
                    function (newValue, oldValue) {
                        if (newValue !== undefined) {
                            $scope.initConfig();
                            $scope.update();
                        }
                    }
                );

                $scope.$watchGroup(
                    ['colorPickerSwatchPos', 'colorPickerSwatchBootstrap', 'colorPickerSwatchOnly', 'colorPickerSwatch', 'colorPickerPos'],
                    function (newValue, oldValue) {
                        if (newValue !== undefined) {
                            $scope.initConfig();
                        }
                    }
                );

                //---------------------------
                // HUE
                //---------------------------
                $scope.hueDown = function () {
                    $scope.log('Color Picker: HUE - MOUSE DOWN');
                    $scope.hueMouse = true;
                };

                $scope.hueUp = function () {
                    $scope.log('Color Picker: HUE - MOUSE UP');
                    $scope.hueMouse = false;
                };

                $scope.hueChange = function (evt, forceRun) {
                    if ($scope.hueMouse || forceRun) {
                        $scope.log('Color Picker: HUE - MOUSE CHANGE');
                        var el = $scope.find('.color-picker-hue');
                        $scope.hue = (1 - ((evt.pageY - $scope.offset(el).top) / el.prop('offsetHeight'))) * 360;
                    }
                };

                $scope.hueUpdate = function() {
                    if ($scope.hue !== undefined) {
                        $scope.log('Color Picker: HUE - CHANGED');
                        $scope.huePos = (1 - ($scope.hue / 360)) * 100;
                        $scope.grid = tinycolor({h: $scope.hue, s: 100, v: 1}).toHslString();

                        if ($scope.huePos < 0) {
                            $scope.huePos = 0;
                        } else if ($scope.huePos > 100) {
                            $scope.huePos = 100;
                        }

                        $scope.update();
                    }
                };

                $scope.$watch('hue', function (newValue, oldValue) {
                    $scope.hueUpdate();
                });

                //---------------------------
                // OPACITY
                //---------------------------
                $scope.opacityDown = function () {
                    $scope.log('Color Picker: OPACITY - MOUSE DOWN');
                    $scope.opacityMouse = true;
                };

                $scope.opacityUp = function () {
                    $scope.log('Color Picker: OPACITY - MOUSE UP');
                    $scope.opacityMouse = false;
                };

                $scope.opacityChange = function (evt, forceRun) {
                    if ($scope.opacityMouse || forceRun) {
                        $scope.log('Color Picker: OPACITY - MOUSE CHANGE');
                        var el = $scope.find('.color-picker-opacity');
                        $scope.opacity = (1 - ((evt.pageY - $scope.offset(el).top) / el.prop('offsetHeight'))) * 100;
                    }
                };

                $scope.opacityUpdate = function() {
                    if ($scope.opacity !== undefined) {
                        $scope.log('Color Picker: OPACITY - CHANGED');
                        $scope.opacityPos = (1 - ($scope.opacity / 100)) * 100;

                        if ($scope.opacityPos < 0) {
                            $scope.opacityPos = 0;
                        } else if ($scope.opacityPos > 100) {
                            $scope.opacityPos = 100;
                        }

                        $scope.update();
                    }
                };

                $scope.$watch('opacity', function (newValue, oldValue) {
                    $scope.opacityUpdate();
                });

                //---------------------------
                // COLOR
                //---------------------------
                $scope.colorDown = function () {
                    $scope.log('Color Picker: COLOR - MOUSE DOWN');
                    $scope.colorMouse = true;
                };

                $scope.colorUp = function () {
                    $scope.log('Color Picker: COLOR - MOUSE UP');
                    $scope.colorMouse = false;
                };

                $scope.colorChange = function (evt, forceRun) {
                    if ($scope.colorMouse || forceRun) {
                        $scope.log('Color Picker: COLOR - MOUSE CHANGE');
                        var el = $scope.find('.color-picker-grid-inner');
                        var offset = $scope.offset(el);

                        $scope.saturation = ((evt.pageX - offset.left) / el.prop('offsetWidth')) * 100;
                        $scope.lightness = (1 - ((evt.pageY - offset.top) / el.prop('offsetHeight'))) * 100;
                    }
                };

                $scope.saturationUpdate = function(oldValue) {
                    if ($scope.saturation !== undefined && $scope.saturation !== oldValue) {
                        $scope.log('Color Picker: SATURATION - CHANGED');
                        $scope.saturationPos = ($scope.saturation / 100) * 100;

                        if ($scope.saturationPos < 0) {
                            $scope.saturationPos = 0;
                        } else if ($scope.saturationPos > 100) {
                            $scope.saturationPos = 100;
                        }

                        $scope.update();
                    }
                };

                $scope.$watch('saturation', function (newValue, oldValue) {
                    $scope.saturationUpdate(oldValue);
                });

                $scope.lightnessUpdate = function(oldValue) {
                    if ($scope.lightness !== undefined && $scope.lightness !== oldValue) {
                        $scope.log('Color Picker: LIGHTNESS - CHANGED');
                        $scope.lightnessPos = (1 - ($scope.lightness / 100)) * 100;

                        if ($scope.lightnessPos < 0) {
                            $scope.lightnessPos = 0;
                        } else if ($scope.lightnessPos > 100) {
                            $scope.lightnessPos = 100;
                        }

                        $scope.update();
                    }
                };

                $scope.$watch('lightness', function (newValue, oldValue) {
                    $scope.lightnessUpdate(oldValue);
                });


                //---------------------------
                // HELPER FUNCTIONS
                //---------------------------
                $scope.log = function () {
                    // console.log.apply(console, arguments);
                };

                // taken and modified from jQuery's find
                $scope.find = function (selector) {
                    var context = $scope.wrapper ? $scope.wrapper[0] : element[0],
                        results = [],
                        nodeType;


                    // Same basic safeguard as Sizzle
                    if (!selector) {
                        return results;
                    }

                    if (typeof selector === 'string') {
                        // Early return if context is not an element or document
                        if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
                            return [];
                        }

                        results = context.querySelectorAll(selector);

                    } else {
                        if (context.contains(selector)) {
                            results.push(selector);
                        }
                    }

                    return angular.element(results);
                };

                // taken and modified from jQuery's offset
                $scope.offset = function (el) {
            		var docElem, win, rect, doc, elem = el[0];

            		if (!elem) {
            			return;
            		}

            		// Support: IE<=11+
            		// Running getBoundingClientRect on a
            		// disconnected node in IE throws an error
            		if (!elem.getClientRects().length) {
            			return {top: 0, left: 0};
            		}

            		rect = elem.getBoundingClientRect();

            		// Make sure element is not hidden (display: none)
            		if ( rect.width || rect.height ) {
            			doc = elem.ownerDocument;
            			win = doc !== null && doc === doc.window ? doc : doc.nodeType === 9 && doc.defaultView;
            			docElem = doc.documentElement;

                        // hack for small chrome screens not position the clicks properly when the page is scrolled
                        if (window.chrome && screen.width <= 768) {
                            return {
                				top: rect.top - docElem.clientTop,
                				left: rect.left - docElem.clientLeft
                			};
                        }

            			return {
            				top: rect.top + win.pageYOffset - docElem.clientTop,
            				left: rect.left + win.pageXOffset - docElem.clientLeft
            			};
            		}


            		return rect;
                };


                $scope.init();

                $scope.$on('$destroy', function() {
                    $document.off('click', $scope.onClick);
                });
            }
        };
    };

    colorPicker.$inject = ['$document', '$timeout'];

    angular.module('color.picker').directive('colorPicker', colorPicker);
})();

angular.module('color.picker').run(['$templateCache', function($templateCache) {
    $templateCache.put('template/color-picker/directive.html',
        '<div class="color-picker-wrapper" ng-class="{\'color-picker-swatch-only\': config.swatchOnly}">\n' +
        '   <div ng-class="{\'input-group\': config.swatchBootstrap && config.swatch}">\n' +
        '       <span ng-if="config.swatchPos === \'left\'" ng-attr-style="background-color: {{swatchColor}};" class="color-picker-swatch" ng-click="focus()" ng-show="config.swatch" ng-class="{\'color-picker-swatch-left\': config.swatchPos !== \'right\', \'color-picker-swatch-right\': config.swatchPos === \'right\', \'input-group-addon\': config.swatchBootstrap}"></span>\n' +
        '       <input class="color-picker-input form-control" type="text" ng-model="ngModel" size="7" ng-focus="show()" ng-class="{\'color-picker-input-swatch\': config.swatch && !config.swatchOnly && config.swatchPos === \'left\'}">\n' +
        '       <span ng-if="config.swatchPos === \'right\'" ng-attr-style="background-color: {{swatchColor}};" class="color-picker-swatch" ng-click="focus()" ng-show="config.swatch" ng-class="{\'color-picker-swatch-left\': config.swatchPos !== \'right\', \'color-picker-swatch-right\': config.swatchPos === \'right\', \'input-group-addon\': config.swatchBootstrap}"></span>\n' +
        '   </div>\n' +
        '   <div class="color-picker-panel" ng-show="visible" ng-class="{\n' +
        '       \'color-picker-panel-top color-picker-panel-right\': config.pos === \'top right\',\n' +
        '       \'color-picker-panel-top color-picker-panel-left\': config.pos === \'top left\',\n' +
        '       \'color-picker-panel-bottom color-picker-panel-right\': config.pos === \'bottom right\',\n' +
        '       \'color-picker-panel-bottom color-picker-panel-left\': config.pos === \'bottom left\',\n' +
        '   }">\n' +
        '       <div class="color-picker-hue color-picker-sprite" ng-click="hueChange($event, true)" ng-mousemove="hueChange($event, false)" ng-mousedown="hueDown()" ng-mouseup="hueUp()">\n' +
        '           <div class="color-picker-slider" ng-attr-style="top: {{huePos}}%;"></div>\n' +
        '       </div>\n' +
        '       <div class="color-picker-opacity color-picker-sprite" ng-show="config.alpha" ng-click="opacityChange($event, true)" ng-mousemove="opacityChange($event, false)" ng-mousedown="opacityDown()" ng-mouseup="opacityUp()">\n' +
        '           <div class="color-picker-slider" ng-attr-style="top: {{opacityPos}}%;"></div>\n' +
        '           </div>\n' +
        '       <div class="color-picker-grid color-picker-sprite" ng-attr-style="background-color: {{grid}};" ng-click="colorChange($event, true)" ng-mousemove="colorChange($event, false)" ng-mousedown="colorDown()" ng-mouseup="colorUp()">\n' +
        '           <div class="color-picker-grid-inner"></div>\n' +
        '           <div class="color-picker-picker" ng-attr-style="top: {{lightnessPos}}%; left: {{saturationPos}}%;">\n' +
        '               <div></div>\n' +
        '           </div>\n' +
        '       </div>\n' +
        '   </div>\n' +
        '</div>'
    );

}]);

/**
 * Angular Dynamic Locale - 0.1.37
 * https://github.com/lgalfaso/angular-dynamic-locale
 * License: MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {
  'use strict';
  angular.module('tmh.dynamicLocale', []).config(['$provide', function($provide) {
    function makeStateful($delegate) {
      $delegate.$stateful = true;
      return $delegate;
    }

    $provide.decorator('dateFilter', ['$delegate', makeStateful]);
    $provide.decorator('numberFilter', ['$delegate', makeStateful]);
    $provide.decorator('currencyFilter', ['$delegate', makeStateful]);

  }])
    .constant('tmhDynamicLocale.STORAGE_KEY', 'tmhDynamicLocale.locale')
    .provider('tmhDynamicLocale', ['tmhDynamicLocale.STORAGE_KEY', function(STORAGE_KEY) {

      var defaultLocale,
        localeLocationPattern = 'angular/i18n/angular-locale_{{locale}}.js',
        nodeToAppend,
        storageFactory = 'tmhDynamicLocaleStorageCache',
        storage,
        storageKey = STORAGE_KEY,
        storageGet = 'get',
        storagePut = 'put',
        promiseCache = {},
        activeLocale,
        extraProperties = {};

      /**
   * Loads a script asynchronously
   *
   * @param {string} url The url for the script
   @ @param {function} callback A function to be called once the script is loaded
   */
      function loadScript(url, callback, errorCallback, $timeout) {
        var script = document.createElement('script'),
          element = nodeToAppend ? nodeToAppend : document.getElementsByTagName('body')[0],
          removed = false;

        script.type = 'text/javascript';
        if (script.readyState) { // IE
          script.onreadystatechange = function () {
            if (script.readyState === 'complete' ||
            script.readyState === 'loaded') {
              script.onreadystatechange = null;
              $timeout(
                function () {
                  if (removed) return;
                  removed = true;
                  if (script.parentNode === element) {
                    element.removeChild(script);
                  }
                  callback();
                }, 30, false);
            }
          };
        } else { // Others
          script.onload = function () {
            if (removed) return;
            removed = true;
            if (script.parentNode === element) {
              element.removeChild(script);
            }
            callback();
          };
          script.onerror = function () {
            if (removed) return;
            removed = true;
            if (script.parentNode === element) {
              element.removeChild(script);
            }
            errorCallback();
          };
        }
        script.src = url;
        script.async = true;
        element.appendChild(script);
      }

      /**
   * Loads a locale and replaces the properties from the current locale with the new locale information
   *
   * @param {string} localeUrl The path to the new locale
   * @param {Object} $locale The locale at the curent scope
   * @param {string} localeId The locale id to load
   * @param {Object} $rootScope The application $rootScope
   * @param {Object} $q The application $q
   * @param {Object} localeCache The current locale cache
   * @param {Object} $timeout The application $timeout
   */
      function loadLocale(localeUrl, $locale, localeId, $rootScope, $q, localeCache, $timeout) {

        function overrideValues(oldObject, newObject) {
          if (activeLocale !== localeId) {
            return;
          }
          angular.forEach(oldObject, function(value, key) {
            if (!newObject[key]) {
              delete oldObject[key];
            } else if (angular.isArray(newObject[key])) {
              oldObject[key].length = newObject[key].length;
            }
          });
          angular.forEach(newObject, function(value, key) {
            if (angular.isArray(newObject[key]) || angular.isObject(newObject[key])) {
              if (!oldObject[key]) {
                oldObject[key] = angular.isArray(newObject[key]) ? [] : {};
              }
              overrideValues(oldObject[key], newObject[key]);
            } else {
              oldObject[key] = newObject[key];
            }
          });
        }


        if (promiseCache[localeId]) {
          activeLocale = localeId;
          return promiseCache[localeId];
        }

        var cachedLocale,
          deferred = $q.defer();
        if (localeId === activeLocale) {
          deferred.resolve($locale);
        } else if ((cachedLocale = localeCache.get(localeId))) {
          activeLocale = localeId;
          $rootScope.$evalAsync(function() {
            overrideValues($locale, cachedLocale);
            storage[storagePut](storageKey, localeId);
            $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
            deferred.resolve($locale);
          });
        } else {
          activeLocale = localeId;
          promiseCache[localeId] = deferred.promise;
          loadScript(localeUrl, function() {
            // Create a new injector with the new locale
            var localInjector = angular.injector(['ngLocale']),
              externalLocale = localInjector.get('$locale');

            overrideValues($locale, externalLocale);
            localeCache.put(localeId, externalLocale);
            delete promiseCache[localeId];

            $rootScope.$applyAsync(function() {
              storage[storagePut](storageKey, localeId);
              $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
              deferred.resolve($locale);
            });
          }, function() {
            delete promiseCache[localeId];

            $rootScope.$applyAsync(function() {
              if (activeLocale === localeId) {
                activeLocale = $locale.id;
              }
              $rootScope.$broadcast('$localeChangeError', localeId);
              deferred.reject(localeId);
            });
          }, $timeout);
        }
        return deferred.promise;
      }

      this.localeLocationPattern = function(value) {
        if (value) {
          localeLocationPattern = value;
          return this;
        } else {
          return localeLocationPattern;
        }
      };

      this.appendScriptTo = function(nodeElement) {
        nodeToAppend = nodeElement;
      };

      this.useStorage = function(storageName) {
        storageFactory = storageName;
        storageGet = 'get';
        storagePut = 'put';
      };

      this.useCookieStorage = function() {
        if (angular.version.minor < 7) {
          this.useStorage('$cookieStore');
        } else {
          this.useStorage('$cookies');
          storageGet = 'getObject';
          storagePut = 'putObject';
        }
      };

      this.defaultLocale = function(value) {
        defaultLocale = value;
      };

      this.storageKey = function(value) {
        if (value) {
          storageKey = value;
          return this;
        } else {
          return storageKey;
        }
      };

      this.addLocalePatternValue = function(key, value) {
        extraProperties[key] = value;
      };

      this.$get = ['$rootScope', '$injector', '$interpolate', '$locale', '$q', 'tmhDynamicLocaleCache', '$timeout', function($rootScope, $injector, interpolate, locale, $q, tmhDynamicLocaleCache, $timeout) {
        var localeLocation = interpolate(localeLocationPattern);

        storage = $injector.get(storageFactory);
        $rootScope.$evalAsync(function() {
          var initialLocale;
          if ((initialLocale = (storage[storageGet](storageKey) || defaultLocale))) {
            loadLocaleFn(initialLocale);
          }
        });
        return {
          /**
       * @ngdoc method
       * @description
       * @param {string} value Sets the locale to the new locale. Changing the locale will trigger
       *    a background task that will retrieve the new locale and configure the current $locale
       *    instance with the information from the new locale
       */
          set: loadLocaleFn,
          /**
       * @ngdoc method
       * @description Returns the configured locale
       */
          get: function() {
            return activeLocale;
          }
        };

        function loadLocaleFn(localeId) {
          var baseProperties = {locale: localeId, angularVersion: angular.version.full};
          return loadLocale(localeLocation(angular.extend({}, extraProperties, baseProperties)), locale, localeId, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
        }
      }];
    }]).provider('tmhDynamicLocaleCache', function() {
      this.$get = ['$cacheFactory', function($cacheFactory) {
        return $cacheFactory('tmh.dynamicLocales');
      }];
    }).provider('tmhDynamicLocaleStorageCache', function() {
      this.$get = ['$cacheFactory', function($cacheFactory) {
        return $cacheFactory('tmh.dynamicLocales.store');
      }];
    }).run(['tmhDynamicLocale', angular.noop]);

  return 'tmh.dynamicLocale';

}));

/*
 * angular-elastic v2.5.1
 * (c) 2014 Monospaced http://monospaced.com
 * License: MIT
 */

if (typeof module !== 'undefined' &&
    typeof exports !== 'undefined' &&
    module.exports === exports){
  module.exports = 'monospaced.elastic';
}

angular.module('monospaced.elastic', [])

  .constant('msdElasticConfig', {
    append: ''
  })

  .directive('msdElastic', [
    '$timeout', '$window', 'msdElasticConfig',
    function($timeout, $window, config) {
      'use strict';

      return {
        require: 'ngModel',
        restrict: 'A, C',
        link: function(scope, element, attrs, ngModel) {

          // cache a reference to the DOM element
          var ta = element[0],
              $ta = element;

          // ensure the element is a textarea, and browser is capable
          if (ta.nodeName !== 'TEXTAREA' || !$window.getComputedStyle) {
            return;
          }

          // set these properties before measuring dimensions
          $ta.css({
            'overflow': 'hidden',
            'overflow-y': 'hidden',
            'word-wrap': 'break-word'
          });

          // force text reflow
          var text = ta.value;
          ta.value = '';
          ta.value = text;

          var append = attrs.msdElastic ? attrs.msdElastic.replace(/\\n/g, '\n') : config.append,
              $win = angular.element($window),
              mirrorInitStyle = 'position: absolute; top: -999px; right: auto; bottom: auto;' +
                                'left: 0; overflow: hidden; -webkit-box-sizing: content-box;' +
                                '-moz-box-sizing: content-box; box-sizing: content-box;' +
                                'min-height: 0 !important; height: 0 !important; padding: 0;' +
                                'word-wrap: break-word; border: 0;',
              $mirror = angular.element('<textarea aria-hidden="true" tabindex="-1" ' +
                                        'style="' + mirrorInitStyle + '"/>').data('elastic', true),
              mirror = $mirror[0],
              taStyle = getComputedStyle(ta),
              resize = taStyle.getPropertyValue('resize'),
              borderBox = taStyle.getPropertyValue('box-sizing') === 'border-box' ||
                          taStyle.getPropertyValue('-moz-box-sizing') === 'border-box' ||
                          taStyle.getPropertyValue('-webkit-box-sizing') === 'border-box',
              boxOuter = !borderBox ? {width: 0, height: 0} : {
                            width:  parseInt(taStyle.getPropertyValue('border-right-width'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-right'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-left'), 10) +
                                    parseInt(taStyle.getPropertyValue('border-left-width'), 10),
                            height: parseInt(taStyle.getPropertyValue('border-top-width'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-top'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-bottom'), 10) +
                                    parseInt(taStyle.getPropertyValue('border-bottom-width'), 10)
                          },
              minHeightValue = parseInt(taStyle.getPropertyValue('min-height'), 10),
              heightValue = parseInt(taStyle.getPropertyValue('height'), 10),
              minHeight = Math.max(minHeightValue, heightValue) - boxOuter.height,
              maxHeight = parseInt(taStyle.getPropertyValue('max-height'), 10),
              mirrored,
              active,
              copyStyle = ['font-family',
                           'font-size',
                           'font-weight',
                           'font-style',
                           'letter-spacing',
                           'line-height',
                           'text-transform',
                           'word-spacing',
                           'text-indent'];

          // exit if elastic already applied (or is the mirror element)
          if ($ta.data('elastic')) {
            return;
          }

          // Opera returns max-height of -1 if not set
          maxHeight = maxHeight && maxHeight > 0 ? maxHeight : 9e4;

          // append mirror to the DOM
          if (mirror.parentNode !== document.body) {
            angular.element(document.body).append(mirror);
          }

          // set resize and apply elastic
          $ta.css({
            'resize': (resize === 'none' || resize === 'vertical') ? 'none' : 'horizontal'
          }).data('elastic', true);

          /*
           * methods
           */

          function initMirror() {
            var mirrorStyle = mirrorInitStyle;

            mirrored = ta;
            // copy the essential styles from the textarea to the mirror
            taStyle = getComputedStyle(ta);
            angular.forEach(copyStyle, function(val) {
              mirrorStyle += val + ':' + taStyle.getPropertyValue(val) + ';';
            });
            mirror.setAttribute('style', mirrorStyle);
          }

          function adjust() {
            var taHeight,
                taComputedStyleWidth,
                mirrorHeight,
                width,
                overflow;

            if (mirrored !== ta) {
              initMirror();
            }

            // active flag prevents actions in function from calling adjust again
            if (!active) {
              active = true;

              mirror.value = ta.value + append; // optional whitespace to improve animation
              mirror.style.overflowY = ta.style.overflowY;

              taHeight = ta.style.height === '' ? 'auto' : parseInt(ta.style.height, 10);

              taComputedStyleWidth = getComputedStyle(ta).getPropertyValue('width');

              // ensure getComputedStyle has returned a readable 'used value' pixel width
              if (taComputedStyleWidth.substr(taComputedStyleWidth.length - 2, 2) === 'px') {
                // update mirror width in case the textarea width has changed
                width = parseInt(taComputedStyleWidth, 10) - boxOuter.width;
                mirror.style.width = width + 'px';
              }

              mirrorHeight = mirror.scrollHeight;

              if (mirrorHeight > maxHeight) {
                mirrorHeight = maxHeight;
                overflow = 'scroll';
              } else if (mirrorHeight < minHeight) {
                mirrorHeight = minHeight;
              }
              mirrorHeight += boxOuter.height;
              ta.style.overflowY = overflow || 'hidden';

              if (taHeight !== mirrorHeight) {
                scope.$emit('elastic:resize', $ta, taHeight, mirrorHeight);
                ta.style.height = mirrorHeight + 'px';
              }

              // small delay to prevent an infinite loop
              $timeout(function() {
                active = false;
              }, 1, false);

            }
          }

          function forceAdjust() {
            active = false;
            adjust();
          }

          /*
           * initialise
           */

          // listen
          if ('onpropertychange' in ta && 'oninput' in ta) {
            // IE9
            ta['oninput'] = ta.onkeyup = adjust;
          } else {
            ta['oninput'] = adjust;
          }

          $win.bind('resize', forceAdjust);

          scope.$watch(function() {
            return ngModel.$modelValue;
          }, function(newValue) {
            forceAdjust();
          });

          scope.$on('elastic:adjust', function() {
            initMirror();
            forceAdjust();
          });

          $timeout(adjust, 0, false);

          /*
           * destroy
           */

          scope.$on('$destroy', function() {
            $mirror.remove();
            $win.unbind('resize', forceAdjust);
          });
        }
      };
    }
  ]);

/*
 angular-file-upload v2.6.1
 https://github.com/nervgh/angular-file-upload
*/

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["angular-file-upload"]=t():e["angular-file-upload"]=t()}(this,function(){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}var r=o(1),i=n(r),s=o(2),a=n(s),u=o(3),l=n(u),p=o(4),c=n(p),f=o(5),d=n(f),h=o(6),y=n(h),m=o(7),v=n(m),_=o(8),g=n(_),b=o(9),F=n(b),O=o(10),C=n(O),T=o(11),I=n(T),w=o(12),A=n(w),U=o(13),x=n(U);angular.module(i.default.name,[]).value("fileUploaderOptions",a.default).factory("FileUploader",l.default).factory("FileLikeObject",c.default).factory("FileItem",d.default).factory("FileDirective",y.default).factory("FileSelect",v.default).factory("FileDrop",F.default).factory("FileOver",C.default).factory("Pipeline",g.default).directive("nvFileSelect",I.default).directive("nvFileDrop",A.default).directive("nvFileOver",x.default).run(["FileUploader","FileLikeObject","FileItem","FileDirective","FileSelect","FileDrop","FileOver","Pipeline",function(e,t,o,n,r,i,s,a){e.FileLikeObject=t,e.FileItem=o,e.FileDirective=n,e.FileSelect=r,e.FileDrop=i,e.FileOver=s,e.Pipeline=a}])},function(e,t){e.exports={name:"angularFileUpload"}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={url:"/",alias:"file",headers:{},queue:[],progress:0,autoUpload:!1,removeAfterUpload:!1,method:"POST",filters:[],formData:[],queueLimit:Number.MAX_VALUE,withCredentials:!1,disableMultipart:!1}},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t,o,n,i,a,u,g){var b=n.File,F=n.FormData,O=function(){function n(t){r(this,n);var o=p(e);c(this,o,t,{isUploading:!1,_nextIndex:0,_directives:{select:[],drop:[],over:[]}}),this.filters.unshift({name:"queueLimit",fn:this._queueLimitFilter}),this.filters.unshift({name:"folder",fn:this._folderFilter})}return n.prototype.addToQueue=function(e,t,o){var n=this,r=this.isArrayLikeObject(e)?Array.prototype.slice.call(e):[e],i=this._getFilters(o),l=this.queue.length,p=[],c=function e(){var o=r.shift();if(v(o))return f();var l=n.isFile(o)?o:new a(o),c=n._convertFiltersToPipes(i),d=new g(c),h=function(t){var o=t.pipe.originalFilter,r=s(t.args,2),i=r[0],a=r[1];n._onWhenAddingFileFailed(i,o,a),e()},y=function(t,o){var r=new u(n,t,o);p.push(r),n.queue.push(r),n._onAfterAddingFile(r),e()};d.onThrown=h,d.onSuccessful=y,d.exec(l,t)},f=function(){n.queue.length!==l&&(n._onAfterAddingAll(p),n.progress=n._getTotalProgress()),n._render(),n.autoUpload&&n.uploadAll()};c()},n.prototype.removeFromQueue=function(e){var t=this.getIndexOfItem(e),o=this.queue[t];o.isUploading&&o.cancel(),this.queue.splice(t,1),o._destroy(),this.progress=this._getTotalProgress()},n.prototype.clearQueue=function(){for(;this.queue.length;)this.queue[0].remove();this.progress=0},n.prototype.uploadItem=function(e){var t=this.getIndexOfItem(e),o=this.queue[t],n=this.isHTML5?"_xhrTransport":"_iframeTransport";o._prepareToUploading(),this.isUploading||(this._onBeforeUploadItem(o),o.isCancel||(o.isUploading=!0,this.isUploading=!0,this[n](o),this._render()))},n.prototype.cancelItem=function(e){var t=this,o=this.getIndexOfItem(e),n=this.queue[o],r=this.isHTML5?"_xhr":"_form";if(n)if(n.isCancel=!0,n.isUploading)n[r].abort();else{var s=[void 0,0,{}],a=function(){t._onCancelItem.apply(t,[n].concat(s)),t._onCompleteItem.apply(t,[n].concat(s))};i(a)}},n.prototype.uploadAll=function(){var e=this.getNotUploadedItems().filter(function(e){return!e.isUploading});e.length&&(f(e,function(e){return e._prepareToUploading()}),e[0].upload())},n.prototype.cancelAll=function(){var e=this.getNotUploadedItems();f(e,function(e){return e.cancel()})},n.prototype.isFile=function(e){return this.constructor.isFile(e)},n.prototype.isFileLikeObject=function(e){return this.constructor.isFileLikeObject(e)},n.prototype.isArrayLikeObject=function(e){return this.constructor.isArrayLikeObject(e)},n.prototype.getIndexOfItem=function(e){return h(e)?e:this.queue.indexOf(e)},n.prototype.getNotUploadedItems=function(){return this.queue.filter(function(e){return!e.isUploaded})},n.prototype.getReadyItems=function(){return this.queue.filter(function(e){return e.isReady&&!e.isUploading}).sort(function(e,t){return e.index-t.index})},n.prototype.destroy=function(){var e=this;f(this._directives,function(t){f(e._directives[t],function(e){e.destroy()})})},n.prototype.onAfterAddingAll=function(e){},n.prototype.onAfterAddingFile=function(e){},n.prototype.onWhenAddingFileFailed=function(e,t,o){},n.prototype.onBeforeUploadItem=function(e){},n.prototype.onProgressItem=function(e,t){},n.prototype.onProgressAll=function(e){},n.prototype.onSuccessItem=function(e,t,o,n){},n.prototype.onErrorItem=function(e,t,o,n){},n.prototype.onCancelItem=function(e,t,o,n){},n.prototype.onCompleteItem=function(e,t,o,n){},n.prototype.onTimeoutItem=function(e){},n.prototype.onCompleteAll=function(){},n.prototype._getTotalProgress=function(e){if(this.removeAfterUpload)return e||0;var t=this.getNotUploadedItems().length,o=t?this.queue.length-t:this.queue.length,n=100/this.queue.length,r=(e||0)*n/100;return Math.round(o*n+r)},n.prototype._getFilters=function(e){if(!e)return this.filters;if(m(e))return e;var t=e.match(/[^\s,]+/g);return this.filters.filter(function(e){return t.indexOf(e.name)!==-1})},n.prototype._convertFiltersToPipes=function(e){var t=this;return e.map(function(e){var o=l(t,e.fn);return o.isAsync=3===e.fn.length,o.originalFilter=e,o})},n.prototype._render=function(){t.$$phase||t.$apply()},n.prototype._folderFilter=function(e){return!(!e.size&&!e.type)},n.prototype._queueLimitFilter=function(){return this.queue.length<this.queueLimit},n.prototype._isSuccessCode=function(e){return e>=200&&e<300||304===e},n.prototype._transformResponse=function(e,t){var n=this._headersGetter(t);return f(o.defaults.transformResponse,function(t){e=t(e,n)}),e},n.prototype._parseHeaders=function(e){var t,o,n,r={};return e?(f(e.split("\n"),function(e){n=e.indexOf(":"),t=e.slice(0,n).trim().toLowerCase(),o=e.slice(n+1).trim(),t&&(r[t]=r[t]?r[t]+", "+o:o)}),r):r},n.prototype._headersGetter=function(e){return function(t){return t?e[t.toLowerCase()]||null:e}},n.prototype._xhrTransport=function(e){var t,o=this,n=e._xhr=new XMLHttpRequest;if(e.disableMultipart?t=e._file:(t=new F,f(e.formData,function(e){f(e,function(e,o){t.append(o,e)})}),t.append(e.alias,e._file,e.file.name)),"number"!=typeof e._file.size)throw new TypeError("The file specified is no longer valid");n.upload.onprogress=function(t){var n=Math.round(t.lengthComputable?100*t.loaded/t.total:0);o._onProgressItem(e,n)},n.onload=function(){var t=o._parseHeaders(n.getAllResponseHeaders()),r=o._transformResponse(n.response,t),i=o._isSuccessCode(n.status)?"Success":"Error",s="_on"+i+"Item";o[s](e,r,n.status,t),o._onCompleteItem(e,r,n.status,t)},n.onerror=function(){var t=o._parseHeaders(n.getAllResponseHeaders()),r=o._transformResponse(n.response,t);o._onErrorItem(e,r,n.status,t),o._onCompleteItem(e,r,n.status,t)},n.onabort=function(){var t=o._parseHeaders(n.getAllResponseHeaders()),r=o._transformResponse(n.response,t);o._onCancelItem(e,r,n.status,t),o._onCompleteItem(e,r,n.status,t)},n.ontimeout=function(t){var r=o._parseHeaders(n.getAllResponseHeaders()),i="Request Timeout.";o._onTimeoutItem(e),o._onCompleteItem(e,i,408,r)},n.open(e.method,e.url,!0),n.timeout=e.timeout||0,n.withCredentials=e.withCredentials,f(e.headers,function(e,t){n.setRequestHeader(t,e)}),n.send(t)},n.prototype._iframeTransport=function(e){var t=this,o=_('<form style="display: none;" />'),n=_('<iframe name="iframeTransport'+Date.now()+'">'),r=e._input,i=0,s=null,a=!1;e._form&&e._form.replaceWith(r),e._form=o,r.prop("name",e.alias),f(e.formData,function(e){f(e,function(e,t){var n=_('<input type="hidden" name="'+t+'" />');n.val(e),o.append(n)})}),o.prop({action:e.url,method:"POST",target:n.prop("name"),enctype:"multipart/form-data",encoding:"multipart/form-data"}),n.bind("load",function(){var o="",r=200;try{o=n[0].contentDocument.body.innerHTML}catch(e){r=500}if(s&&clearTimeout(s),s=null,a)return!1;var i={response:o,status:r,dummy:!0},u={},l=t._transformResponse(i.response,u);t._onSuccessItem(e,l,i.status,u),t._onCompleteItem(e,l,i.status,u)}),o.abort=function(){var i,s={status:0,dummy:!0},a={};n.unbind("load").prop("src","javascript:false;"),o.replaceWith(r),t._onCancelItem(e,i,s.status,a),t._onCompleteItem(e,i,s.status,a)},r.after(o),o.append(r).append(n),i=e.timeout||0,s=null,i&&(s=setTimeout(function(){a=!0,e.isCancel=!0,e.isUploading&&(n.unbind("load").prop("src","javascript:false;"),o.replaceWith(r));var i={},s="Request Timeout.";t._onTimeoutItem(e),t._onCompleteItem(e,s,408,i)},i)),o[0].submit()},n.prototype._onWhenAddingFileFailed=function(e,t,o){this.onWhenAddingFileFailed(e,t,o)},n.prototype._onAfterAddingFile=function(e){this.onAfterAddingFile(e)},n.prototype._onAfterAddingAll=function(e){this.onAfterAddingAll(e)},n.prototype._onBeforeUploadItem=function(e){e._onBeforeUpload(),this.onBeforeUploadItem(e)},n.prototype._onProgressItem=function(e,t){var o=this._getTotalProgress(t);this.progress=o,e._onProgress(t),this.onProgressItem(e,t),this.onProgressAll(o),this._render()},n.prototype._onSuccessItem=function(e,t,o,n){e._onSuccess(t,o,n),this.onSuccessItem(e,t,o,n)},n.prototype._onErrorItem=function(e,t,o,n){e._onError(t,o,n),this.onErrorItem(e,t,o,n)},n.prototype._onCancelItem=function(e,t,o,n){e._onCancel(t,o,n),this.onCancelItem(e,t,o,n)},n.prototype._onCompleteItem=function(e,t,o,n){e._onComplete(t,o,n),this.onCompleteItem(e,t,o,n);var r=this.getReadyItems()[0];return this.isUploading=!1,y(r)?void r.upload():(this.onCompleteAll(),this.progress=this._getTotalProgress(),void this._render())},n.prototype._onTimeoutItem=function(e){e._onTimeout(),this.onTimeoutItem(e)},n.isFile=function(e){return b&&e instanceof b},n.isFileLikeObject=function(e){return e instanceof a},n.isArrayLikeObject=function(e){return d(e)&&"length"in e},n.inherit=function(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.super_=t},n}();return O.prototype.isHTML5=!(!b||!F),O.isHTML5=O.prototype.isHTML5,O}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){var o=[],n=!0,r=!1,i=void 0;try{for(var s,a=e[Symbol.iterator]();!(n=(s=a.next()).done)&&(o.push(s.value),!t||o.length!==t);n=!0);}catch(e){r=!0,i=e}finally{try{!n&&a.return&&a.return()}finally{if(r)throw i}}return o}return function(t,o){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,o);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();t.default=i;var a=o(1),u=(n(a),angular),l=u.bind,p=u.copy,c=u.extend,f=u.forEach,d=u.isObject,h=u.isNumber,y=u.isDefined,m=u.isArray,v=u.isUndefined,_=u.element;i.$inject=["fileUploaderOptions","$rootScope","$http","$window","$timeout","FileLikeObject","FileItem","Pipeline"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){return function(){function e(t){r(this,e);var o=l(t),n=o?t.value:t,i=p(n)?"FakePath":"Object",s="_createFrom"+i;this[s](n,t)}return e.prototype._createFromFakePath=function(e,t){this.lastModifiedDate=null,this.size=null,this.type="like/"+e.slice(e.lastIndexOf(".")+1).toLowerCase(),this.name=e.slice(e.lastIndexOf("/")+e.lastIndexOf("\\")+2),this.input=t},e.prototype._createFromObject=function(e){this.lastModifiedDate=u(e.lastModifiedDate),this.size=e.size,this.type=e.type,this.name=e.name,this.input=e.input},e}()}Object.defineProperty(t,"__esModule",{value:!0}),t.default=i;var s=o(1),a=(n(s),angular),u=a.copy,l=a.isElement,p=a.isString},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){return function(){function o(e,n,i){r(this,o);var s=!!n.input,a=s?p(n.input):null,c=s?null:n;l(this,{url:e.url,alias:e.alias,headers:u(e.headers),formData:u(e.formData),removeAfterUpload:e.removeAfterUpload,withCredentials:e.withCredentials,disableMultipart:e.disableMultipart,method:e.method,timeout:e.timeout},i,{uploader:e,file:new t(n),isReady:!1,isUploading:!1,isUploaded:!1,isSuccess:!1,isCancel:!1,isError:!1,progress:0,index:null,_file:c,_input:a}),a&&this._replaceNode(a)}return o.prototype.upload=function(){try{this.uploader.uploadItem(this)}catch(t){var e=t.name+":"+t.message;this.uploader._onCompleteItem(this,e,t.code,[]),this.uploader._onErrorItem(this,e,t.code,[])}},o.prototype.cancel=function(){this.uploader.cancelItem(this)},o.prototype.remove=function(){this.uploader.removeFromQueue(this)},o.prototype.onBeforeUpload=function(){},o.prototype.onProgress=function(e){},o.prototype.onSuccess=function(e,t,o){},o.prototype.onError=function(e,t,o){},o.prototype.onCancel=function(e,t,o){},o.prototype.onComplete=function(e,t,o){},o.prototype.onTimeout=function(){},o.prototype._onBeforeUpload=function(){this.isReady=!0,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!1,this.isError=!1,this.progress=0,this.onBeforeUpload()},o.prototype._onProgress=function(e){this.progress=e,this.onProgress(e)},o.prototype._onSuccess=function(e,t,o){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!0,this.isCancel=!1,this.isError=!1,this.progress=100,this.index=null,this.onSuccess(e,t,o)},o.prototype._onError=function(e,t,o){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!1,this.isCancel=!1,this.isError=!0,this.progress=0,this.index=null,this.onError(e,t,o)},o.prototype._onCancel=function(e,t,o){this.isReady=!1,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!0,this.isError=!1,this.progress=0,this.index=null,this.onCancel(e,t,o)},o.prototype._onComplete=function(e,t,o){this.onComplete(e,t,o),this.removeAfterUpload&&this.remove()},o.prototype._onTimeout=function(){this.isReady=!1,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!1,this.isError=!0,this.progress=0,this.index=null,this.onTimeout()},o.prototype._destroy=function(){this._input&&this._input.remove(),this._form&&this._form.remove(),delete this._form,delete this._input},o.prototype._prepareToUploading=function(){this.index=this.index||++this.uploader._nextIndex,this.isReady=!0},o.prototype._replaceNode=function(t){var o=e(t.clone())(t.scope());o.prop("value",null),t.css("display","none"),t.after(o)},o}()}Object.defineProperty(t,"__esModule",{value:!0}),t.default=i;var s=o(1),a=(n(s),angular),u=a.copy,l=a.extend,p=a.element;a.isElement;i.$inject=["$compile","FileLikeObject"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){var e=function(){function e(t){r(this,e),u(this,t),this.uploader._directives[this.prop].push(this),this._saveLinks(),this.bind()}return e.prototype.bind=function(){for(var e in this.events){var t=this.events[e];this.element.bind(e,this[t])}},e.prototype.unbind=function(){for(var e in this.events)this.element.unbind(e,this.events[e])},e.prototype.destroy=function(){var e=this.uploader._directives[this.prop].indexOf(this);this.uploader._directives[this.prop].splice(e,1),this.unbind()},e.prototype._saveLinks=function(){for(var e in this.events){var t=this.events[e];this[t]=this[t].bind(this)}},e}();return e.prototype.events={},e}Object.defineProperty(t,"__esModule",{value:!0}),t.default=i;var s=o(1),a=(n(s),angular),u=a.extend},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t){return function(t){function o(e){r(this,o);var n=p(e,{events:{$destroy:"destroy",change:"onChange"},prop:"select"}),s=i(this,t.call(this,n));return s.uploader.isHTML5||s.element.removeAttr("multiple"),s.element.prop("value",null),s}return s(o,t),o.prototype.getOptions=function(){},o.prototype.getFilters=function(){},o.prototype.isEmptyAfterSelection=function(){return!!this.element.attr("multiple")},o.prototype.onChange=function(){var t=this.uploader.isHTML5?this.element[0].files:this.element[0],o=this.getOptions(),n=this.getFilters();this.uploader.isHTML5||this.destroy(),this.uploader.addToQueue(t,o,n),this.isEmptyAfterSelection()&&(this.element.prop("value",null),this.element.replaceWith(e(this.element.clone())(this.scope)))},o}(t)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=a;var u=o(1),l=(n(u),angular),p=l.extend;a.$inject=["$compile","FileDirective"]},function(e,t){"use strict";function o(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e){return function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];n(this,t),this.pipes=e}return t.prototype.next=function(t){var n=this.pipes.shift();if(a(n))return void this.onSuccessful.apply(this,o(t));var r=new Error("The filter has not passed");if(r.pipe=n,r.args=t,n.isAsync){var i=e.defer(),u=s(this,this.next,t),l=s(this,this.onThrown,r);i.promise.then(u,l),n.apply(void 0,o(t).concat([i]))}else{var p=Boolean(n.apply(void 0,o(t)));p?this.next(t):this.onThrown(r)}},t.prototype.exec=function(){for(var e=arguments.length,t=Array(e),o=0;o<e;o++)t[o]=arguments[o];this.next(t)},t.prototype.onThrown=function(e){},t.prototype.onSuccessful=function(){},t}()}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var i=angular,s=i.bind,a=i.isUndefined;r.$inject=["$q"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return function(e){function t(o){r(this,t);var n=p(o,{events:{$destroy:"destroy",drop:"onDrop",dragover:"onDragOver",dragleave:"onDragLeave"},prop:"drop"});return i(this,e.call(this,n))}return s(t,e),t.prototype.getOptions=function(){},t.prototype.getFilters=function(){},t.prototype.onDrop=function(e){var t=this._getTransfer(e);if(t){var o=this.getOptions(),n=this.getFilters();this._preventAndStop(e),c(this.uploader._directives.over,this._removeOverClass,this),this.uploader.addToQueue(t.files,o,n)}},t.prototype.onDragOver=function(e){var t=this._getTransfer(e);this._haveFiles(t.types)&&(t.dropEffect="copy",this._preventAndStop(e),c(this.uploader._directives.over,this._addOverClass,this))},t.prototype.onDragLeave=function(e){e.currentTarget!==this.element[0]&&(this._preventAndStop(e),c(this.uploader._directives.over,this._removeOverClass,this))},t.prototype._getTransfer=function(e){return e.dataTransfer?e.dataTransfer:e.originalEvent.dataTransfer},t.prototype._preventAndStop=function(e){e.preventDefault(),e.stopPropagation()},t.prototype._haveFiles=function(e){return!!e&&(e.indexOf?e.indexOf("Files")!==-1:!!e.contains&&e.contains("Files"))},t.prototype._addOverClass=function(e){e.addOverClass()},t.prototype._removeOverClass=function(e){e.removeOverClass()},t}(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=a;var u=o(1),l=(n(u),angular),p=l.extend,c=l.forEach;a.$inject=["FileDirective"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return function(e){function t(o){r(this,t);var n=p(o,{events:{$destroy:"destroy"},prop:"over",overClass:"nv-file-over"});return i(this,e.call(this,n))}return s(t,e),t.prototype.addOverClass=function(){this.element.addClass(this.getOverClass())},t.prototype.removeOverClass=function(){this.element.removeClass(this.getOverClass())},t.prototype.getOverClass=function(){return this.overClass},t}(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=a;var u=o(1),l=(n(u),angular),p=l.extend;a.$inject=["FileDirective"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t,o){return{link:function(n,r,i){var s=n.$eval(i.uploader);if(!(s instanceof t))throw new TypeError('"Uploader" must be an instance of FileUploader');var a=new o({uploader:s,element:r,scope:n});a.getOptions=e(i.options).bind(a,n),a.getFilters=function(){return i.filters}}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var i=o(1);n(i);r.$inject=["$parse","FileUploader","FileSelect"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t,o){return{link:function(n,r,i){var s=n.$eval(i.uploader);if(!(s instanceof t))throw new TypeError('"Uploader" must be an instance of FileUploader');if(s.isHTML5){var a=new o({uploader:s,element:r});a.getOptions=e(i.options).bind(a,n),a.getFilters=function(){return i.filters}}}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var i=o(1);n(i);r.$inject=["$parse","FileUploader","FileDrop"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function r(e,t){return{link:function(o,n,r){var i=o.$eval(r.uploader);if(!(i instanceof e))throw new TypeError('"Uploader" must be an instance of FileUploader');var s=new t({uploader:i,element:n});s.getOverClass=function(){return r.overClass||s.overClass}}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var i=o(1);n(i);r.$inject=["FileUploader","FileOver"]}])});
// sourceMappingURL=angular-file-upload.min.js.map
/**
 * Bunch of useful filters for angularJS(with no external dependencies!)
 * @version v0.5.17 - 2017-09-22 * @link https://github.com/a8m/angular-filter
 * @author Ariel Mashraki <ariel@mashraki.co.il>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function ( window, angular, undefined ) {
/*jshint globalstrict:true*/
'use strict';

var isDefined = angular.isDefined,
    isUndefined = angular.isUndefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isNumber = angular.isNumber,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    equals = angular.equals;


/**
 * @description
 * get an object and return array of values
 * @param object
 * @returns {Array}
 */
function toArray(object) {
  return isArray(object) 
    ? object 
    : Object.keys(object).map(function(key) {
      return object[key];
    });
}

/**
 * @param value
 * @returns {boolean}
 */
function isNull(value) {
    return value === null;
}

/**
 * @description
 * return if object contains partial object
 * @param partial{object}
 * @param object{object}
 * @returns {boolean}
 */
function objectContains(partial, object) {
  var keys = Object.keys(partial);

  return keys.map(function(el) {
    return (object[el] !== undefined) && (object[el] == partial[el]);
  }).indexOf(false) == -1;

}

/**
 * @description
 * search for approximate pattern in string
 * @param word
 * @param pattern
 * @returns {*}
 */
function hasApproxPattern(word, pattern) {
  // cheaper version of indexOf; instead of creating each
  // iteration new str.
  function indexOf(word, p, c) {
    var j = 0;
    while ((p + j) <= word.length) {
      if (word.charAt(p + j) == c) return j;
      j++;
    }
    return -1;
  }
  var p = 0;
  for (var i = 0; i <= pattern.length; i++) {
    var index = indexOf(word, p, pattern.charAt(i));
    if (index == -1) return false;
    p += index + 1;
  }
  return true
}

/**
 * @description
 * return the first n element of an array,
 * if expression provided, is returns as long the expression return truthy
 * @param array
 * @param n {number}
 * @param expression {$parse}
 * @return array or single object
 */
function getFirstMatches(array, n, expression) {
  var count = 0;

  return array.filter(function(elm) {
    var rest = isDefined(expression) ? (count < n && expression(elm)) : count < n;
    count = rest ? count+1 : count;

    return rest;
  });
}
/**
 * Polyfill to ECMA6 String.prototype.contains
 */
if (!String.prototype.contains) {
  String.prototype.contains = function() {
    return String.prototype.indexOf.apply(this, arguments) !== -1;
  };
}

/**
 * @param num {Number}
 * @param decimal {Number}
 * @returns {Number}
 */
function convertToDecimal(num, decimal){
  return Math.round(num * Math.pow(10,decimal)) / (Math.pow(10, decimal));
}

/**
 * @description
 * Get an object, and return an array composed of it's properties names(nested too).
 * @param obj {Object}
 * @param stack {Array}
 * @param parent {String}
 * @returns {Array}
 * @example
 * parseKeys({ a:1, b: { c:2, d: { e: 3 } } }) ==> ["a", "b.c", "b.d.e"]
 */
function deepKeys(obj, stack, parent) {
  stack = stack || [];
  var keys = Object.keys(obj);

  keys.forEach(function(el) {
    //if it's a nested object
    if(isObject(obj[el]) && !isArray(obj[el])) {
      //concatenate the new parent if exist
      var p = parent ? parent + '.' + el : parent;
      deepKeys(obj[el], stack, p || el);
    } else {
      //create and save the key
      var key = parent ? parent + '.' + el : el;
      stack.push(key)
    }
  });
  return stack
}

/**
 * @description
 * Test if given object is a Scope instance
 * @param obj
 * @returns {Boolean}
 */
function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}

/**
 * @ngdoc filter
 * @name a8m.angular
 * @kind function
 *
 * @description
 * reference to angular function
 */

angular.module('a8m.angular', [])

    .filter('isUndefined', function () {
      return function (input) {
        return angular.isUndefined(input);
      }
    })
    .filter('isDefined', function() {
      return function (input) {
        return angular.isDefined(input);
      }
    })
    .filter('isFunction', function() {
      return function (input) {
        return angular.isFunction(input);
      }
    })
    .filter('isString', function() {
      return function (input) {
        return angular.isString(input)
      }
    })
    .filter('isNumber', function() {
      return function (input) {
        return angular.isNumber(input);
      }
    })
    .filter('isArray', function() {
      return function (input) {
        return angular.isArray(input);
      }
    })
    .filter('isObject', function() {
      return function (input) {
        return angular.isObject(input);
      }
    })
    .filter('isEqual', function() {
      return function (o1, o2) {
        return angular.equals(o1, o2);
      }
    });

/**
 * @ngdoc filter
 * @name a8m.conditions
 * @kind function
 *
 * @description
 * reference to math conditions
 */
 angular.module('a8m.conditions', [])

  .filter({
    isGreaterThan  : isGreaterThanFilter,
    '>'            : isGreaterThanFilter,

    isGreaterThanOrEqualTo  : isGreaterThanOrEqualToFilter,
    '>='                    : isGreaterThanOrEqualToFilter,

    isLessThan  : isLessThanFilter,
    '<'         : isLessThanFilter,

    isLessThanOrEqualTo  : isLessThanOrEqualToFilter,
    '<='                 : isLessThanOrEqualToFilter,

    isEqualTo  : isEqualToFilter,
    '=='       : isEqualToFilter,

    isNotEqualTo  : isNotEqualToFilter,
    '!='          : isNotEqualToFilter,

    isIdenticalTo  : isIdenticalToFilter,
    '==='          : isIdenticalToFilter,

    isNotIdenticalTo  : isNotIdenticalToFilter,
    '!=='             : isNotIdenticalToFilter
  });

  function isGreaterThanFilter() {
    return function (input, check) {
      return input > check;
    };
  }

  function isGreaterThanOrEqualToFilter() {
    return function (input, check) {
      return input >= check;
    };
  }

  function isLessThanFilter() {
    return function (input, check) {
      return input < check;
    };
  }

  function isLessThanOrEqualToFilter() {
    return function (input, check) {
      return input <= check;
    };
  }

  function isEqualToFilter() {
    return function (input, check) {
      return input == check;
    };
  }

  function isNotEqualToFilter() {
    return function (input, check) {
      return input != check;
    };
  }

  function isIdenticalToFilter() {
    return function (input, check) {
      return input === check;
    };
  }

  function isNotIdenticalToFilter() {
    return function (input, check) {
      return input !== check;
    };
  }
/**
 * @ngdoc filter
 * @name isNull
 * @kind function
 *
 * @description
 * checks if value is null or not
 * @return Boolean
 */
angular.module('a8m.is-null', [])
    .filter('isNull', function () {
      return function(input) {
        return isNull(input);
      }
    });

/**
 * @ngdoc filter
 * @name after-where
 * @kind function
 *
 * @description
 * get a collection and properties object, and returns all of the items
 * in the collection after the first that found with the given properties.
 *
 */
angular.module('a8m.after-where', [])
    .filter('afterWhere', function() {
      return function (collection, object) {

        collection = isObject(collection)
          ? toArray(collection)
          : collection;

        if(!isArray(collection) || isUndefined(object)) return collection;

        var index = collection.map( function( elm ) {
          return objectContains(object, elm);
        }).indexOf( true );

        return collection.slice((index === -1) ? 0 : index);
      }
    });

/**
 * @ngdoc filter
 * @name after
 * @kind function
 *
 * @description
 * get a collection and specified count, and returns all of the items
 * in the collection after the specified count.
 *
 */

angular.module('a8m.after', [])
    .filter('after', function() {
      return function (collection, count) {
        collection = isObject(collection)
          ? toArray(collection)
          : collection;

        return (isArray(collection))
          ? collection.slice(count)
          : collection;
      }
    });

/**
 * @ngdoc filter
 * @name before-where
 * @kind function
 *
 * @description
 * get a collection and properties object, and returns all of the items
 * in the collection before the first that found with the given properties.
 */
angular.module('a8m.before-where', [])
  .filter('beforeWhere', function() {
    return function (collection, object) {

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection) || isUndefined(object)) return collection;

      var index = collection.map( function( elm ) {
        return objectContains(object, elm);
      }).indexOf( true );

      return collection.slice(0, (index === -1) ? collection.length : ++index);
    }
  });

/**
 * @ngdoc filter
 * @name before
 * @kind function
 *
 * @description
 * get a collection and specified count, and returns all of the items
 * in the collection before the specified count.
 */
angular.module('a8m.before', [])
    .filter('before', function() {
      return function (collection, count) {
        collection = isObject(collection)
          ? toArray(collection)
          : collection;

        return (isArray(collection))
          ? collection.slice(0, (!count) ? count : --count)
          : collection;
      }
    });

/**
 * @ngdoc filter
 * @name chunkBy
 * @kind function
 *
 * @description
 * Collect data into fixed-length chunks or blocks
 */

angular.module('a8m.chunk-by', ['a8m.filter-watcher'])
    .filter('chunkBy', ['filterWatcher', function (filterWatcher) {
      return function (array, n, fillVal) {

        return filterWatcher.isMemoized('chunkBy', arguments) ||
            filterWatcher.memoize('chunkBy', arguments, this,
                _chunkBy(array, n, fillVal));
        /**
         * @description
         * Get array with size `n` in `val` inside it.
         * @param n
         * @param val
         * @returns {Array}
         */
        function fill(n, val) {
          var ret = [];
          while (n--) ret[n] = val;
          return ret;
        }

        function _chunkBy(array, n, fillVal) {
          if (!isArray(array)) return array;
          return array.map(function (el, i, self) {
            i = i * n;
            el = self.slice(i, i + n);
            return !isUndefined(fillVal) && el.length < n
                ? el.concat(fill(n - el.length, fillVal))
                : el;
          }).slice(0, Math.ceil(array.length / n));
        }
      }
    }]);

/**
 * @ngdoc filter
 * @name concat
 * @kind function
 *
 * @description
 * get (array/object, object/array) and return merged collection
 */
angular.module('a8m.concat', [])
  .filter('concat', [function () {
    return function (collection, joined) {

      if (isUndefined(joined)) return collection;

      if (isArray(collection)) {
        return isObject(joined)
          ? collection.concat(toArray(joined))
          : collection.concat(joined);
      }

      if (isObject(collection)) {
        var array = toArray(collection);
        return (isObject(joined))
          ? array.concat(toArray(joined))
          : array.concat(joined);
      }
      return collection;
    };
  }
]);

/**
 * @ngdoc filter
 * @name contains
 * @kind function
 *
 * @description
 * Checks if given expression is present in one or more object in the collection
 */
angular.module('a8m.contains', [])
  .filter({
    contains: ['$parse', containsFilter],
    some: ['$parse', containsFilter]
  });

function containsFilter($parse) {
    return function (collection, expression) {

      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return false;
      }

      return collection.some(function(elm) {
        return ((isString(expression) && isObject(elm)) || isFunction(expression))
          ? $parse(expression)(elm)
          : elm === expression;
      });

    }
 }

/**
 * @ngdoc filter
 * @name countBy
 * @kind function
 *
 * @description
 * Sorts a list into groups and returns a count for the number of objects in each group.
 */

angular.module('a8m.count-by', [])

  .filter('countBy', [ '$parse', function ( $parse ) {
    return function (collection, property) {

      var result = {},
        get = $parse(property),
        prop;

      collection = (isObject(collection)) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(property)) {
        return collection;
      }

      collection.forEach( function( elm ) {
        prop = get(elm);

        if(!result[prop]) {
          result[prop] = 0;
        }

        result[prop]++;
      });

      return result;
    }
  }]);

/**
 * @ngdoc filter
 * @name defaults
 * @kind function
 *
 * @description
 * defaultsFilter allows to specify a default fallback value for properties that resolve to undefined.
 */
angular.module('a8m.defaults', [])
  .filter('defaults', ['$parse', function( $parse ) {
    return function(collection, defaults) {

      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || !isObject(defaults)) {
        return collection;
      }

      var keys = deepKeys(defaults);

      collection.forEach(function(elm) {
        //loop through all the keys
        keys.forEach(function(key) {
          var getter = $parse(key);
          var setter = getter.assign;
          //if it's not exist
          if(isUndefined(getter(elm))) {
            //get from defaults, and set to the returned object
            setter(elm, getter(defaults))
          }
        });
      });

      return collection;
    }
  }]);
/**
 * @ngdoc filter
 * @name every
 * @kind function
 *
 * @description
 * Checks if given expression is present in all members in the collection
 *
 */
angular.module('a8m.every', [])
  .filter('every', ['$parse', function($parse) {
    return function (collection, expression) {
      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return true;
      }

      return collection.every( function(elm) {
        return (isObject(elm) || isFunction(expression))
          ? $parse(expression)(elm)
          : elm === expression;
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name filterBy
 * @kind function
 *
 * @description
 * filter by specific properties, avoid the rest
 */
angular.module('a8m.filter-by', [])
  .filter('filterBy', ['$parse', function( $parse ) {
    return function(collection, properties, search, strict) {
      var comparator;

      search = (isString(search) || isNumber(search)) ?
        String(search).toLowerCase() : undefined;

      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(search)) {
        return collection;
      }

      return collection.filter(function(elm) {
        return properties.some(function(prop) {

          /**
           * check if there is concatenate properties
           * example:
           * object: { first: 'foo', last:'bar' }
           * filterBy: ['first + last'] => search by full name(i.e 'foo bar')
           */
          if(!~prop.indexOf('+')) {
            comparator = $parse(prop)(elm)
          } else {
            var propList = prop.replace(/\s+/g, '').split('+');
            comparator = propList
              .map(function(prop) { return $parse(prop)(elm); })
              .join(' ');
          }

          if (!isString(comparator) && !isNumber(comparator)) {
            return false;
          }

          comparator = String(comparator).toLowerCase();

          return strict ? comparator === search : comparator.contains(search);
        });
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name first
 * @kind function
 *
 * @description
 * Gets the first element or first n elements of an array
 * if callback is provided, is returns as long the callback return truthy
 */
angular.module('a8m.first', [])
  .filter('first', ['$parse', function( $parse ) {
    return function(collection) {
      var n
        , getter
        , args;

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection)) {
        return collection;
      }

      args = Array.prototype.slice.call(arguments, 1);
      n = (isNumber(args[0])) ? args[0] : 1;
      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;

      return (args.length) ? getFirstMatches(collection, n,(getter) ? $parse(getter) : getter) :
        collection[0];
    }
  }]);

/**
 * @ngdoc filter
 * @name flatten
 * @kind function
 *
 * @description
 * Flattens a nested array (the nesting can be to any depth).
 * If you pass shallow, the array will only be flattened a single level
 */
angular.module('a8m.flatten', [])
  .filter('flatten', function () {
    return function(collection, shallow) {

      shallow = shallow || false;
      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection)) {
        return collection;
      }

      return !shallow
        ? flatten(collection, 0)
        : [].concat.apply([], collection);
    }
  });

/**
 * flatten nested array (the nesting can be to any depth).
 * @param array {Array}
 * @param i {int}
 * @returns {Array}
 * @private
 */
function flatten(array, i) {
  i = i || 0;

  if(i >= array.length)
    return array;

  if(isArray(array[i])) {
    return flatten(array.slice(0,i)
      .concat(array[i], array.slice(i+1)), i);
  }
  return flatten(array, i+1);
}

/**
 * @ngdoc filter
 * @name fuzzyByKey
 * @kind function
 *
 * @description
 * fuzzy string searching by key
 */
angular.module('a8m.fuzzy-by', [])
  .filter('fuzzyBy', ['$parse', function ( $parse ) {
    return function (collection, property, search, csensitive) {

      var sensitive = csensitive || false,
        prop, getter;

      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(property)
        || isUndefined(search)) {
        return collection;
      }

      getter = $parse(property);

      return collection.filter(function(elm) {

        prop = getter(elm);
        if(!isString(prop)) {
          return false;
        }

        prop = (sensitive) ? prop : prop.toLowerCase();
        search = (sensitive) ? search : search.toLowerCase();

        return hasApproxPattern(prop, search) !== false
      })
    }

 }]);
/**
 * @ngdoc filter
 * @name fuzzy
 * @kind function
 *
 * @description
 * fuzzy string searching for array of strings, objects
 */
angular.module('a8m.fuzzy', [])
  .filter('fuzzy', function () {
    return function (collection, search, csensitive) {
      var sensitive = csensitive || false;
      collection = isObject(collection) ? toArray(collection) : collection;

      if(!isArray(collection) || isUndefined(search)) {
        return collection;
      }

      search = (sensitive) ? search : search.toLowerCase();

      return collection.filter(function(elm) {
        if(isString(elm)) {
          elm = (sensitive) ? elm : elm.toLowerCase();
          return hasApproxPattern(elm, search) !== false
        }
        return (isObject(elm)) ? _hasApproximateKey(elm, search) : false;
      });

      /**
       * checks if object has key{string} that match
       * to fuzzy search pattern
       * @param object
       * @param search
       * @returns {boolean}
       * @private
       */
      function _hasApproximateKey(object, search) {
        var properties = Object.keys(object),
          prop, flag;
        return 0 < properties.filter(function (elm) {
          prop = object[elm];

          //avoid iteration if we found some key that equal[performance]
          if(flag) return true;

          if (isString(prop)) {
            prop = (sensitive) ? prop : prop.toLowerCase();
            return flag = (hasApproxPattern(prop, search) !== false);
          }

          return false;

        }).length;
      }
    }
  });

/**
 * @ngdoc filter
 * @name groupBy
 * @kind function
 *
 * @description
 * Create an object composed of keys generated from the result of running each element of a collection,
 * each key is an array of the elements.
 */

angular.module('a8m.group-by', [ 'a8m.filter-watcher' ])
  .filter('groupBy', [ '$parse', 'filterWatcher', function ( $parse, filterWatcher ) {
    return function (collection, property) {

      if(!isObject(collection) || isUndefined(property)) {
        return collection;
      }

      return filterWatcher.isMemoized('groupBy', arguments) ||
        filterWatcher.memoize('groupBy', arguments, this,
          _groupBy(collection, $parse(property)));

      /**
       * groupBy function
       * @param collection
       * @param getter
       * @returns {{}}
       */
      function _groupBy(collection, getter) {
        var result = {};
        var prop;

        forEach( collection, function( elm ) {
          prop = getter(elm);

          if(!result[prop]) {
            result[prop] = [];
          }
          result[prop].push(elm);
        });
        return result;
      }
    }
 }]);

/**
 * @ngdoc filter
 * @name isEmpty
 * @kind function
 *
 * @description
 * get collection or string and return if it empty
 */
angular.module('a8m.is-empty', [])
  .filter('isEmpty', function () {
    return function(collection) {
      return isObject(collection)
        ? !toArray(collection).length
        : !collection.length;
    }
  });

/**
 * @ngdoc filter
 * @name join
 * @kind function
 *
 * @description
 * join a collection by a provided delimiter (space by default)
 */
angular.module('a8m.join', [])
  .filter('join', function () {
    return function (input, delimiter) {
      if (isUndefined(input) || !isArray(input)) {
        return input;
      }
      if (isUndefined(delimiter)) delimiter = ' ';

      return input.join(delimiter);
    };
  })
;

/**
 * @ngdoc filter
 * @name last
 * @kind function
 *
 * @description
 * Gets the last element or last n elements of an array
 * if callback is provided, is returns as long the callback return truthy
 */
angular.module('a8m.last', [])
  .filter('last', ['$parse', function( $parse ) {
    return function(collection) {
      var n
        , getter
        , args
        //cuz reverse change our src collection
        //and we don't want side effects
        , reversed = copy(collection);

      reversed = isObject(reversed)
        ? toArray(reversed)
        : reversed;

      if(!isArray(reversed)) {
        return reversed;
      }

      args = Array.prototype.slice.call(arguments, 1);
      n = (isNumber(args[0])) ? args[0] : 1;
      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;

      return (args.length)
        //send reversed collection as arguments, and reverse it back as result
        ? getFirstMatches(reversed.reverse(), n,(getter) ? $parse(getter) : getter).reverse()
        //get the last element
        : reversed[reversed.length-1];
    }
  }]);

/**
 * @ngdoc filter
 * @name map
 * @kind function
 *
 * @description
 * Returns a new collection of the results of each expression execution.
 */
angular.module('a8m.map', [])
  .filter('map', ['$parse', function($parse) {
    return function (collection, expression) {

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return collection;
      }

      return collection.map(function (elm) {
        return $parse(expression)(elm);
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name omit
 * @kind function
 *
 * @description
 * filter collection by expression
 */

angular.module('a8m.omit', [])

  .filter('omit', ['$parse', function($parse) {
    return function (collection, expression) {

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return collection;
      }

      return collection.filter(function (elm) {
        return !($parse(expression)(elm));
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name pick
 * @kind function
 *
 * @description
 * filter collection by expression
 */

angular.module('a8m.pick', [])

  .filter('pick', ['$parse', function($parse) {
    return function (collection, expression) {

      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      if(!isArray(collection) || isUndefined(expression)) {
        return collection;
      }

      return collection.filter(function (elm) {
        return $parse(expression)(elm);
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name range
 * @kind function
 *
 * @description
 * rangeFilter provides some support for a for loop using numbers
 */
angular.module('a8m.range', [])
  .filter('range', function () {
    return function (input, total, start, increment, cb) {
      start = start || 0;
      increment = increment || 1;
      for (var i = 0; i < parseInt(total); i++) {
        var j = start + i * increment;
        input.push(isFunction(cb) ? cb(j) : j);
      }
      return input;
    };
  });
/**
 * @ngdoc filter
 * @name removeWith
 * @kind function
 *
 * @description
 * get collection and properties object, and removed elements
 * with this properties
 */

angular.module('a8m.remove-with', [])
  .filter('removeWith', function() {
    return function (collection, object) {

      if(isUndefined(object)) {
        return collection;
      }
      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      return collection.filter(function (elm) {
        return !objectContains(object, elm);
      });
    }
  });


/**
 * @ngdoc filter
 * @name remove
 * @kind function
 *
 * @description
 * remove specific members from collection
 */

angular.module('a8m.remove', [])

  .filter('remove', function () {
    return function (collection) {
      collection = isObject(collection) ? toArray(collection) : collection;
      var args = Array.prototype.slice.call(arguments, 1);

      if(!isArray(collection)) {
        return collection;
      }

      return collection.filter( function( member ) {
        return !args.some(function(nest) {
          return equals(nest, member);
        })
      });
    }
  });

/**
 * @ngdoc filter
 * @name reverse
 * @kind function
 *
 * @description
 * Reverses a string or collection
 */
angular.module('a8m.reverse', [])
    .filter('reverse',[ function () {
      return function (input) {
        input = isObject(input) ? toArray(input) : input;

        if(isString(input)) {
          return input.split('').reverse().join('');
        }

        return isArray(input)
          ? input.slice().reverse()
          : input;
      }
    }]);

/**
 * @ngdoc filter
 * @name searchField
 * @kind function
 *
 * @description
 * for each member, join several strings field and add them to
 * new field called 'searchField' (use for search filtering)
 */
angular.module('a8m.search-field', [])
  .filter('searchField', ['$parse', function ($parse) {
    return function (collection) {

      var get, field;

      collection = isObject(collection) ? toArray(collection) : collection;

      var args = Array.prototype.slice.call(arguments, 1);

      if(!isArray(collection) || !args.length) {
        return collection;
      }

      return collection.map(function(member) {

        field = args.map(function(field) {
          get = $parse(field);
          return get(member);
        }).join(' ');

        return extend(member, { searchField: field });
      });
    }
  }]);

/**
 * @ngdoc filter
 * @name toArray
 * @kind function
 *
 * @description
 * Convert objects into stable arrays.
 * if addKey set to true,the filter also attaches a new property
 * $key to the value containing the original key that was used in
 * the object we are iterating over to reference the property
 */
angular.module('a8m.to-array', [])
  .filter('toArray', function() {
    return function (collection, addKey) {

      if(!isObject(collection)) {
        return collection;
      }

      return !addKey
        ? toArray(collection)
        : Object.keys(collection).map(function (key) {
            return extend(collection[key], { $key: key });
          });
    }
  });

/**
 * @ngdoc filter
 * @name unique/uniq
 * @kind function
 *
 * @description
 * get collection and filter duplicate members
 * if uniqueFilter get a property(nested to) as argument it's
 * filter by this property as unique identifier
 */

angular.module('a8m.unique', [])
  .filter({
      unique: ['$parse', uniqFilter],
      uniq: ['$parse', uniqFilter]
    });

function uniqFilter($parse) {
    return function (collection, property) {

      collection = isObject(collection) ? toArray(collection) : collection;

      if (!isArray(collection)) {
        return collection;
      }

      //store all unique identifiers
      var uniqueItems = [],
          get = $parse(property);

      return (isUndefined(property))
        //if it's kind of primitive array
        ? collection.filter(function (elm, pos, self) {
          return self.indexOf(elm) === pos;
        })
        //else compare with equals
        : collection.filter(function (elm) {
          var prop = get(elm);
          if(some(uniqueItems, prop)) {
            return false;
          }
          uniqueItems.push(prop);
          return true;
      });

      //checked if the unique identifier is already exist
      function some(array, member) {
        if(isUndefined(member)) {
          return false;
        }
        return array.some(function(el) {
          return equals(el, member);
        });
      }
    }
}

/**
 * @ngdoc filter
 * @name where
 * @kind function
 *
 * @description
 * of each element in a collection to the given properties object,
 * returning an array of all elements that have equivalent property values.
 *
 */
angular.module('a8m.where', [])
  .filter('where', function() {
    return function (collection, object) {
      if(isUndefined(object)) return collection;
      collection = isObject(collection)
        ? toArray(collection)
        : collection;

      return collection.filter(function (elm) {
        return objectContains(object, elm);
      });
    }
  });

/**
 * @ngdoc filter
 * @name xor
 * @kind function
 *
 * @description
 * Exclusive or filter by expression
 */

angular.module('a8m.xor', [])

  .filter('xor', ['$parse', function($parse) {
    return function (col1, col2, expression) {

      expression = expression || false;

      col1 = isObject(col1) ? toArray(col1) : col1;
      col2 = isObject(col2) ? toArray(col2) : col2;

      if(!isArray(col1) || !isArray(col2)) return col1;

      return col1.concat(col2)
        .filter(function(elm) {
          return !(some(elm, col1) && some(elm, col2));
        });

      function some(el, col) {
        var getter = $parse(expression);
        return col.some(function(dElm) {
          return expression
            ? equals(getter(dElm), getter(el))
            : equals(dElm, el);
        });
      }
    }
  }]);

/**
 * @ngdoc filter
 * @name abs
 * @kind function
 *
 * @description
 * Will return the absolute value of a number
 */
angular.module('a8m.math.abs', [])
  .filter('abs', function () {
    return function (input) {
      return Math.abs(input);
    }
  });

/**
 * @ngdoc filter
 * @name formatBytes
 * @kind function
 *
 * @description
 * Convert bytes into appropriate display 
 * 1024 bytes => 1 KB
 */
angular.module('a8m.math.byteFmt', [])
  .filter('byteFmt', function () {
    var compared = [{str: 'B', val: 1024}];
    ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'].forEach(function(el, i) {
      compared.push({str: el, val: compared[i].val * 1024 });
    });
    return function (bytes, decimal) {
      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(bytes) && isFinite(bytes)) {
        var i = 0;
        while (i < compared.length-1 && bytes >= compared[i].val) i++;
        bytes /= i > 0 ? compared[i-1].val : 1;
        return convertToDecimal(bytes, decimal) + ' ' + compared[i].str;
      }
      return 'NaN';
    }
  });

/**
 * @ngdoc filter
 * @name degrees
 * @kind function
 *
 * @description
 * Convert angle from radians to degrees
 */
angular.module('a8m.math.degrees', [])
  .filter('degrees', function () {
    return function (radians, decimal) {
      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
      // if degrees is not a real number, we cannot do also. quit with error "NaN"
      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(radians) && isFinite(radians)) {
        var degrees = (radians * 180) / Math.PI;
        return Math.round(degrees * Math.pow(10,decimal)) / (Math.pow(10,decimal));
      } else {
        return 'NaN';
      }
    }
  });

 
 
/**
 * @ngdoc filter
 * @name formatBytes
 * @kind function
 *
 * @description
 * Convert bytes into appropriate display 
 * 1024 kilobytes => 1 MB
 */
angular.module('a8m.math.kbFmt', [])
  .filter('kbFmt', function () {
    var compared = [{str: 'KB', val: 1024}];
    ['MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'].forEach(function(el, i) {
      compared.push({str: el, val: compared[i].val * 1024 });
    });
    return function (bytes, decimal) {
      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(bytes) && isFinite(bytes)) {
        var i = 0;
        while (i < compared.length-1 && bytes >= compared[i].val) i++;
        bytes /= i > 0 ? compared[i-1].val : 1;
        return convertToDecimal(bytes, decimal) + ' ' + compared[i].str;
      }
      return 'NaN';
    }
  });
/**
 * @ngdoc filter
 * @name max
 * @kind function
 *
 * @description
 * Math.max will get an array and return the max value. if an expression
 * is provided, will return max value by expression.
 */
angular.module('a8m.math.max', [])
  .filter('max', ['$parse', function ($parse) {
    return function (input, expression) {

      if(!isArray(input)) {
        return input;
      }
      return isUndefined(expression)
        ? Math.max.apply(Math, input)
        : input[indexByMax(input, expression)];
    };

    /**
     * @private
     * @param array
     * @param exp
     * @returns {number|*|Number}
     */
    function indexByMax(array, exp) {
      var mappedArray = array.map(function(elm){
        return $parse(exp)(elm);
      });
      return mappedArray.indexOf(Math.max.apply(Math, mappedArray));
    }
  }]);
/**
 * @ngdoc filter
 * @name min
 * @kind function
 *
 * @description
 * Math.min will get an array and return the min value. if an expression
 * is provided, will return min value by expression.
 */
angular.module('a8m.math.min', [])
  .filter('min', ['$parse', function ($parse) {
    return function (input, expression) {

      if(!isArray(input)) {
        return input;
      }
      return isUndefined(expression)
        ? Math.min.apply(Math, input)
        : input[indexByMin(input, expression)];
    };

    /**
     * @private
     * @param array
     * @param exp
     * @returns {number|*|Number}
     */
    function indexByMin(array, exp) {
      var mappedArray = array.map(function(elm){
        return $parse(exp)(elm);
      });
      return mappedArray.indexOf(Math.min.apply(Math, mappedArray));
    }
  }]);
/**
 * @ngdoc filter
 * @name Percent
 * @kind function
 *
 * @description
 * percentage between two numbers
 */
angular.module('a8m.math.percent', [])
  .filter('percent', function () {
    return function (input, divided, round) {

      var divider = isString(input) ? Number(input) : input;
      divided = divided || 100;
      round = round || false;

      if (!isNumber(divider) || isNaN(divider)) return input;

      return round
        ? Math.round((divider / divided) * 100)
        : (divider / divided) * 100;
    }
  });

/**
 * @ngdoc filter
 * @name toRadians
 * @kind function
 *
 * @description
 * Convert angle from degrees to radians
 */
angular.module('a8m.math.radians', [])
  .filter('radians', function() {
    return function (degrees, decimal) {
      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
      // if degrees is not a real number, we cannot do also. quit with error "NaN"
      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(degrees) && isFinite(degrees)) {
        var radians = (degrees * 3.14159265359) / 180;
        return Math.round(radians * Math.pow(10,decimal)) / (Math.pow(10,decimal));
      }
      return 'NaN';
    }
  });

 
 
/**
 * @ngdoc filter
 * @name Radix
 * @kind function
 *
 * @description
 * converting decimal numbers to different bases(radix)
 */
angular.module('a8m.math.radix', [])
  .filter('radix', function () {
    return function (input, radix) {
      var RANGE = /^[2-9]$|^[1-2]\d$|^3[0-6]$/;

      if(!isNumber(input) || !RANGE.test(radix)) {
        return input;
      }

      return input.toString(radix).toUpperCase();
    }
  });

/**
 * @ngdoc filter
 * @name formatBytes
 * @kind function
 *
 * @description
 * Convert number into abbreviations.
 * i.e: K for one thousand, M for Million, B for billion
 * e.g: number of users:235,221, decimal:1 => 235.2 K
 */
angular.module('a8m.math.shortFmt', [])
  .filter('shortFmt', function () {
    return function (number, decimal) {
      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
        isNumber(number) && isFinite(number)){
        if(number < 1e3) {
          return '' + number;  // Coerce to string
        } else if(number < 1e6) {
          return convertToDecimal((number / 1e3), decimal) + ' K';
        } else if(number < 1e9){
          return convertToDecimal((number / 1e6), decimal) + ' M';
        } else {
          return convertToDecimal((number / 1e9), decimal) + ' B';
        }

      }
      return 'NaN';
    }
  });
/**
 * @ngdoc filter
 * @name sum
 * @kind function
 *
 * @description
 * Sum up all values within an array
 */
angular.module('a8m.math.sum', [])
  .filter('sum', function () {
    return function (input, initial) {
      return !isArray(input)
        ? input
        : input.reduce(function(prev, curr) {
          return prev + curr;
        }, initial || 0);
    }
  });

/**
 * @ngdoc filter
 * @name endsWith
 * @kind function
 *
 * @description
 * checks whether string ends with the ends parameter.
 */
angular.module('a8m.ends-with', [])

  .filter('endsWith', function () {
    return function (input, ends, csensitive) {

      var sensitive = csensitive || false,
        position;

      if(!isString(input) || isUndefined(ends)) {
        return input;
      }

      input = (sensitive) ? input : input.toLowerCase();
      position = input.length - ends.length;

      return input.indexOf((sensitive) ? ends : ends.toLowerCase(), position) !== -1;
    }
  });

/**
 * @ngdoc filter
 * @name latinize
 * @kind function
 *
 * @description
 * remove accents/diacritics from a string
 */
angular.module('a8m.latinize', [])
  .filter('latinize',[ function () {
    var defaultDiacriticsRemovalap = [
      {'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
      {'base':'AA','letters':'\uA732'},
      {'base':'AE','letters':'\u00C6\u01FC\u01E2'},
      {'base':'AO','letters':'\uA734'},
      {'base':'AU','letters':'\uA736'},
      {'base':'AV','letters':'\uA738\uA73A'},
      {'base':'AY','letters':'\uA73C'},
      {'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
      {'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
      {'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
      {'base':'DZ','letters':'\u01F1\u01C4'},
      {'base':'Dz','letters':'\u01F2\u01C5'},
      {'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
      {'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
      {'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
      {'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
      {'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
      {'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
      {'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
      {'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
      {'base':'LJ','letters':'\u01C7'},
      {'base':'Lj','letters':'\u01C8'},
      {'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
      {'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
      {'base':'NJ','letters':'\u01CA'},
      {'base':'Nj','letters':'\u01CB'},
      {'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
      {'base':'OI','letters':'\u01A2'},
      {'base':'OO','letters':'\uA74E'},
      {'base':'OU','letters':'\u0222'},
      {'base':'OE','letters':'\u008C\u0152'},
      {'base':'oe','letters':'\u009C\u0153'},
      {'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
      {'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
      {'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
      {'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
      {'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
      {'base':'TZ','letters':'\uA728'},
      {'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
      {'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
      {'base':'VY','letters':'\uA760'},
      {'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
      {'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
      {'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
      {'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
      {'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
      {'base':'aa','letters':'\uA733'},
      {'base':'ae','letters':'\u00E6\u01FD\u01E3'},
      {'base':'ao','letters':'\uA735'},
      {'base':'au','letters':'\uA737'},
      {'base':'av','letters':'\uA739\uA73B'},
      {'base':'ay','letters':'\uA73D'},
      {'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
      {'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
      {'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
      {'base':'dz','letters':'\u01F3\u01C6'},
      {'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
      {'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
      {'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
      {'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
      {'base':'hv','letters':'\u0195'},
      {'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
      {'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
      {'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
      {'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
      {'base':'lj','letters':'\u01C9'},
      {'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
      {'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
      {'base':'nj','letters':'\u01CC'},
      {'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
      {'base':'oi','letters':'\u01A3'},
      {'base':'ou','letters':'\u0223'},
      {'base':'oo','letters':'\uA74F'},
      {'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
      {'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
      {'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
      {'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
      {'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
      {'base':'tz','letters':'\uA729'},
      {'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
      {'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
      {'base':'vy','letters':'\uA761'},
      {'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
      {'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
      {'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
      {'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
    ];

    var diacriticsMap = {};
    for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
      var letters = defaultDiacriticsRemovalap[i].letters.split("");
      for (var j = 0; j < letters.length ; j++){
        diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
      }
    }

    // "what?" version ... http://jsperf.com/diacritics/12
    function removeDiacritics (str) {
      return str.replace(/[^\u0000-\u007E]/g, function(a){
        return diacriticsMap[a] || a;
      });
    }

    return function (input) {

      return isString(input)
        ? removeDiacritics(input)
        : input;
    }
  }]);

/**
 * @ngdoc filter
 * @name ltrim
 * @kind function
 *
 * @description
 * Left trim. Similar to trimFilter, but only for left side.
 */
angular.module('a8m.ltrim', [])
  .filter('ltrim', function () {
    return function(input, chars) {

      var trim = chars || '\\s';

      return isString(input)
        ? input.replace(new RegExp('^' + trim + '+'), '')
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name match
 * @kind function
 *
 * @description
 * Return the matched pattern in a string.
 */
angular.module('a8m.match', [])
  .filter('match', function () {
    return function (input, pattern, flag) {

      var reg = new RegExp(pattern, flag);

      return isString(input)
        ? input.match(reg)
        : null;
    }
  });

/**
 * @ngdoc filter
 * @name phone-us
 * @kind function
 *
 * @description
 * format a string or a number into a us-style
 * phone number in the form (***) ***-****
 */
angular.module('a8m.phoneUS', [])
  .filter('phoneUS', function () {
    return function(num) {
      num += '';
      return '(' + num.slice(0, 3) + ') ' + num.slice(3, 6) + '-' + num.slice(6);
    }
  });

/**
 * @ngdoc filter
 * @name repeat
 * @kind function
 *
 * @description
 * Repeats a string n times
 */
angular.module('a8m.repeat', [])
  .filter('repeat',[ function () {
    return function (input, n, separator) {

      var times = ~~n;

      if(!isString(input)) {
        return input;
      }

      return !times
        ? input
        : strRepeat(input, --n, separator || '');
    }
  }]);

/**
 * Repeats a string n times with given separator
 * @param str string to repeat
 * @param n number of times
 * @param sep separator
 * @returns {*}
 */
function strRepeat(str, n, sep) {
  if(!n) {
    return str;
  }
  return str + sep + strRepeat(str, --n, sep);
}
/**
* @ngdoc filter
* @name rtrim
* @kind function
*
* @description
* Right trim. Similar to trimFilter, but only for right side.
*/
angular.module('a8m.rtrim', [])
  .filter('rtrim', function () {
    return function(input, chars) {

      var trim = chars || '\\s';

      return isString(input)
        ? input.replace(new RegExp(trim + '+$'), '')
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name slugify
 * @kind function
 *
 * @description
 * remove spaces from string, replace with "-" or given argument
 */
angular.module('a8m.slugify', [])
  .filter('slugify',[ function () {
    return function (input, sub) {

      var replace = (isUndefined(sub)) ? '-' : sub;

      return isString(input)
        ? input.toLowerCase().replace(/\s+/g, replace)
        : input;
    }
  }]);

/**
 * @ngdoc filter
 * @name split
 * @kind function
 *
 * @description
 * split a string by a provided delimiter (none '' by default) and skip first n-delimiters
 */
angular.module('a8m.split', [])
  .filter('split', function () {
    function escapeRegExp(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    return function (input, delimiter, skip) {
      var _regexp, _matches, _splitted, _temp;

      if (isUndefined(input) || !isString(input)) {
        return null;
      }
      if (isUndefined(delimiter)) delimiter = '';
      if (isNaN(skip)) skip = 0;

      _regexp = new RegExp(escapeRegExp(delimiter), 'g');
      _matches = input.match(_regexp);
      
      if (isNull(_matches) || skip >= _matches.length) {
        return [input];
      }

      if (skip === 0) return input.split(delimiter);
      
      _splitted = input.split(delimiter);
      _temp = _splitted.splice(0, skip + 1);
      _splitted.unshift(_temp.join(delimiter));
    
      return _splitted;
    };
  })
;

/**
 * @ngdoc filter
 * @name startWith
 * @kind function
 *
 * @description
 * checks whether string starts with the starts parameter.
 */
angular.module('a8m.starts-with', [])
  .filter('startsWith', function () {
    return function (input, start, csensitive) {

      var sensitive = csensitive || false;

      if(!isString(input) || isUndefined(start)) {
        return input;
      }

      input = (sensitive) ? input : input.toLowerCase();

      return !input.indexOf((sensitive) ? start : start.toLowerCase());
    }
  });

/**
 * @ngdoc filter
 * @name stringular
 * @kind function
 *
 * @description
 * get string with {n} and replace match with enumeration values
 */
angular.module('a8m.stringular', [])
  .filter('stringular', function () {
    return function(input) {

      var args = Array.prototype.slice.call(arguments, 1);

      return input.replace(/{(\d+)}/g, function (match, number) {
        return isUndefined(args[number]) ? match : args[number];
      });
    }
  });

/**
 * @ngdoc filter
 * @name stripTags
 * @kind function
 *
 * @description
 * strip html tags from string
 */
angular.module('a8m.strip-tags', [])
  .filter('stripTags', function () {
    return function(input) {
      return isString(input)
        ? input.replace(/<\S[^><]*>/g, '')
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name test
 * @kind function
 *
 * @description
 * test if a string match a pattern.
 */
angular.module('a8m.test', [])
  .filter('test', function () {
    return function (input, pattern, flag) {

      var reg = new RegExp(pattern, flag);

      return isString(input)
        ? reg.test(input)
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name trim
 * @kind function
 *
 * @description
 *  Strip whitespace (or other characters) from the beginning and end of a string
 */
angular.module('a8m.trim', [])
  .filter('trim', function () {
    return function(input, chars) {

      var trim = chars || '\\s';

      return isString(input)
        ? input.replace(new RegExp('^' + trim + '+|' + trim + '+$', 'g'), '')
        : input;
    }
  });

/**
 * @ngdoc filter
 * @name truncate
 * @kind function
 *
 * @description
 * truncates a string given a specified length, providing a custom string to denote an omission.
 */
angular.module('a8m.truncate', [])
  .filter('truncate', function () {
    return function(input, length, suffix, preserve) {

      length = isUndefined(length) ? input.length : length;
      preserve = preserve || false;
      suffix = suffix || '';

      if(!isString(input) || (input.length <= length)) return input;

      return input.substring(0, (preserve)
        ? ((input.indexOf(' ', length) === -1) ? input.length : input.indexOf(' ', length))
        : length) + suffix;
    };
  });

/**
 * @ngdoc filter
 * @name ucfirst
 * @kind function
 *
 * @description
 * ucfirst
 */
angular.module('a8m.ucfirst', [])
  .filter({
    ucfirst: ucfirstFilter,
    titleize: ucfirstFilter
  });

function ucfirstFilter() {
  return function (input) {
    return isString(input)
      ? input
      .split(' ')
      .map(function (ch) {
        return ch.charAt(0).toUpperCase() + ch.substring(1);
      })
      .join(' ')
      : input;
  }
}

/**
 * @ngdoc filter
 * @name uriComponentEncode
 * @kind function
 *
 * @description
 * get string as parameter and return encoded string
 */
angular.module('a8m.uri-component-encode', [])
  .filter('uriComponentEncode',['$window', function ($window) {
      return function (input) {
        return isString(input)
          ? $window.encodeURIComponent(input)
          : input;
      }
    }]);

/**
 * @ngdoc filter
 * @name uriEncode
 * @kind function
 *
 * @description
 * get string as parameter and return encoded string
 */
angular.module('a8m.uri-encode', [])
  .filter('uriEncode',['$window', function ($window) {
      return function (input) {
        return isString(input)
          ? $window.encodeURI(input)
          : input;
      }
    }]);

/**
 * @ngdoc filter
 * @name wrap
 * @kind function
 *
 * @description
 * Wrap a string with another string
 */
angular.module('a8m.wrap', [])
  .filter('wrap', function () {
    return function(input, wrap, ends) {
      return isString(input) && isDefined(wrap)
        ? [wrap, input, ends || wrap].join('')
        : input;
    }
  });

/**
 * @ngdoc provider
 * @name filterWatcher
 * @kind function
 *
 * @description
 * store specific filters result in $$cache, based on scope life time(avoid memory leak).
 * on scope.$destroy remove it's cache from $$cache container
 */

angular.module('a8m.filter-watcher', [])
  .provider('filterWatcher', function() {

    this.$get = ['$window', '$rootScope', function($window, $rootScope) {

      /**
       * Cache storing
       * @type {Object}
       */
      var $$cache = {};

      /**
       * Scope listeners container
       * scope.$destroy => remove all cache keys
       * bind to current scope.
       * @type {Object}
       */
      var $$listeners = {};

      /**
       * $timeout without triggering the digest cycle
       * @type {function}
       */
      var $$timeout = $window.setTimeout;

      /**
       * @description
       * get `HashKey` string based on the given arguments.
       * @param fName
       * @param args
       * @returns {string}
       */
      function getHashKey(fName, args) {
        function replacerFactory() {
          var cache = [];
          return function(key, val) {
            if(isObject(val) && !isNull(val)) {
              if (~cache.indexOf(val)) return '[Circular]';
              cache.push(val)
            }
            if($window == val) return '$WINDOW';
            if($window.document == val) return '$DOCUMENT';
            if(isScope(val)) return '$SCOPE';
            return val;
          }
        }
        return [fName, JSON.stringify(args, replacerFactory())]
          .join('#')
          .replace(/"/g,'');
      }

      /**
       * @description
       * fir on $scope.$destroy,
       * remove cache based scope from `$$cache`,
       * and remove itself from `$$listeners`
       * @param event
       */
      function removeCache(event) {
        var id = event.targetScope.$id;
        forEach($$listeners[id], function(key) {
          delete $$cache[key];
        });
        delete $$listeners[id];
      }

      /**
       * @description
       * for angular version that greater than v.1.3.0
       * it clear cache when the digest cycle is end.
       */
      function cleanStateless() {
        $$timeout(function() {
          if(!$rootScope.$$phase)
            $$cache = {};
        }, 2000);
      }

      /**
       * @description
       * Store hashKeys in $$listeners container
       * on scope.$destroy, remove them all(bind an event).
       * @param scope
       * @param hashKey
       * @returns {*}
       */
      function addListener(scope, hashKey) {
        var id = scope.$id;
        if(isUndefined($$listeners[id])) {
          scope.$on('$destroy', removeCache);
          $$listeners[id] = [];
        }
        return $$listeners[id].push(hashKey);
      }

      /**
       * @description
       * return the `cacheKey` or undefined.
       * @param filterName
       * @param args
       * @returns {*}
       */
      function $$isMemoized(filterName, args) {
        var hashKey = getHashKey(filterName, args);
        return $$cache[hashKey];
      }

      /**
       * @description
       * store `result` in `$$cache` container, based on the hashKey.
       * add $destroy listener and return result
       * @param filterName
       * @param args
       * @param scope
       * @param result
       * @returns {*}
       */
      function $$memoize(filterName, args, scope, result) {
        var hashKey = getHashKey(filterName, args);
        //store result in `$$cache` container
        $$cache[hashKey] = result;
        // for angular versions that less than 1.3
        // add to `$destroy` listener, a cleaner callback
        if(isScope(scope)) {
          addListener(scope, hashKey);
        } else {
          cleanStateless();
        }
        return result;
      }

      return {
        isMemoized: $$isMemoized,
        memoize: $$memoize
      }
    }];
  });
  

/**
 * @ngdoc module
 * @name angular.filters
 * @description
 * Bunch of useful filters for angularJS
 */

angular.module('angular.filter', [

  'a8m.ucfirst',
  'a8m.uri-encode',
  'a8m.uri-component-encode',
  'a8m.slugify',
  'a8m.latinize',
  'a8m.strip-tags',
  'a8m.stringular',
  'a8m.truncate',
  'a8m.starts-with',
  'a8m.ends-with',
  'a8m.wrap',
  'a8m.trim',
  'a8m.ltrim',
  'a8m.rtrim',
  'a8m.repeat',
  'a8m.test',
  'a8m.match',
  'a8m.split',
  'a8m.phoneUS',

  'a8m.to-array',
  'a8m.concat',
  'a8m.contains',
  'a8m.unique',
  'a8m.is-empty',
  'a8m.after',
  'a8m.after-where',
  'a8m.before',
  'a8m.before-where',
  'a8m.defaults',
  'a8m.where',
  'a8m.reverse',
  'a8m.remove',
  'a8m.remove-with',
  'a8m.group-by',
  'a8m.count-by',
  'a8m.chunk-by',
  'a8m.search-field',
  'a8m.fuzzy-by',
  'a8m.fuzzy',
  'a8m.omit',
  'a8m.pick',
  'a8m.every',
  'a8m.filter-by',
  'a8m.xor',
  'a8m.map',
  'a8m.first',
  'a8m.last',
  'a8m.flatten',
  'a8m.join',
  'a8m.range',

  'a8m.math.max',
  'a8m.math.min',
  'a8m.math.abs',
  'a8m.math.percent',
  'a8m.math.radix',
  'a8m.math.sum',
  'a8m.math.degrees',
  'a8m.math.radians',
  'a8m.math.byteFmt',
  'a8m.math.kbFmt',
  'a8m.math.shortFmt',

  'a8m.angular',
  'a8m.conditions',
  'a8m.is-null',

  'a8m.filter-watcher'
]);
})( window, window.angular );
/* angular-load.js / v0.2.0 / (c) 2014 Uri Shaked / MIT Licence */

(function () {
	'use strict';

	angular.module('angularLoad', [])
		.service('angularLoad', ['$document', '$q', '$timeout', function ($document, $q, $timeout) {

			/**
			 * Dynamically loads the given script
			 * @param src The url of the script to load dynamically
			 * @returns {*} Promise that will be resolved once the script has been loaded.
			 */
			this.loadScript = function (src) {
				var deferred = $q.defer();
				var script = $document[0].createElement('script');
				script.onload = script.onreadystatechange = function (e) {
					$timeout(function () {
						deferred.resolve(e);
					});
				};
				script.onerror = function (e) {
					$timeout(function () {
						deferred.reject(e);
					});
				};
				script.src = src;
				$document[0].body.appendChild(script);
				return deferred.promise;
			};

			/**
			 * Dynamically loads the given CSS file
			 * @param href The url of the CSS to load dynamically
			 * @returns {*} Promise that will be resolved once the CSS file has been loaded.
			 */
			this.loadCSS = function (href) {
				var deferred = $q.defer();
				var style = $document[0].createElement('link');
				style.rel = 'stylesheet';
				style.type = 'text/css';
				style.href = href;
				style.onload = style.onreadystatechange = function (e) {
					$timeout(function () {
						deferred.resolve(e);
					});
				};
				style.onerror = function (e) {
					$timeout(function () {
						deferred.reject(e);
					});
				};
				$document[0].head.appendChild(style);
				return deferred.promise;
			};
		}]);
})();

/**
 * @license AngularJS v1.4.14
 * (c) 2010-2015 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular, undefined) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * # ngSanitize
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 *
 * <div doc-module-components="ngSanitize"></div>
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/*
 * HTML Parser By Misko Hevery (misko@hevery.com)
 * based on:  HTML Parser By John Resig (ejohn.org)
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 *
 * // Use like so:
 * htmlParser(htmlString, {
 *     start: function(tag, attrs, unary) {},
 *     end: function(tag) {},
 *     chars: function(text) {},
 *     comment: function(text) {}
 * });
 *
 */


/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to properly escaped html string. This means that no unsafe input can make
 *   it into the returned string, however, since our parser is more strict than a typical browser
 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getInnerHtml()).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */
function $SanitizeProvider() {
  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, angular.noop);
  writer.chars(chars);
  return buf.join('');
}


// Regular Expressions for parsing tags and attributes
var START_TAG_REGEXP =
       /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
  END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
  ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
  BEGIN_TAG_REGEXP = /^</,
  BEGING_END_TAGE_REGEXP = /^<\//,
  COMMENT_REGEXP = /<!--(.*?)-->/g,
  DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
  CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
  SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
  // Match everything outside of normal chars and " (quote character)
  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;


// Good source of info about elements and attributes
// http://dev.w3.org/html5/spec/Overview.html#semantics
// http://simon.html5.org/html-elements

// Safe Void Elements - HTML5
// http://dev.w3.org/html5/spec/Overview.html#void-elements
var voidElements = makeMap("area,br,col,hr,img,wbr");

// Elements that you can, intentionally, leave open (and which close themselves)
// http://dev.w3.org/html5/spec/Overview.html#optional-tags
var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
    optionalEndTagInlineElements = makeMap("rp,rt"),
    optionalEndTagElements = angular.extend({},
                                            optionalEndTagInlineElements,
                                            optionalEndTagBlockElements);

// Safe Block Elements - HTML5
var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));

// Inline Elements - HTML5
var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));

// SVG Elements
// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
// Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
// They can potentially allow for arbitrary javascript to be executed. See #11290
var svgElements = makeMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
        "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
        "radialGradient,rect,stop,svg,switch,text,title,tspan,use");

// Special Elements (can contain anything)
var specialElements = makeMap("script,style");

var validElements = angular.extend({},
                                   voidElements,
                                   blockElements,
                                   inlineElements,
                                   optionalEndTagElements,
                                   svgElements);

//Attributes that have href and hence need to be sanitized
var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");

var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
    'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
    'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
    'valign,value,vspace,width');

// SVG attributes (without "id" and "name" attributes)
// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
    'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
    'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
    'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
    'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
    'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
    'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
    'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
    'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
    'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
    'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
    'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
    'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
    'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
    'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

var validAttrs = angular.extend({},
                                uriAttrs,
                                svgAttrs,
                                htmlAttrs);

function makeMap(str, lowercaseKeys) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[lowercaseKeys ? angular.lowercase(items[i]) : items[i]] = true;
  }
  return obj;
}


/**
 * @example
 * htmlParser(htmlString, {
 *     start: function(tag, attrs, unary) {},
 *     end: function(tag) {},
 *     chars: function(text) {},
 *     comment: function(text) {}
 * });
 *
 * @param {string} html string
 * @param {object} handler
 */
function htmlParser(html, handler) {
  if (typeof html !== 'string') {
    if (html === null || typeof html === 'undefined') {
      html = '';
    } else {
      html = '' + html;
    }
  }
  var index, chars, match, stack = [], last = html, text;
  stack.last = function() { return stack[stack.length - 1]; };

  while (html) {
    text = '';
    chars = true;

    // Make sure we're not in a script or style element
    if (!stack.last() || !specialElements[stack.last()]) {

      // Comment
      if (html.indexOf("<!--") === 0) {
        // comments containing -- are not allowed unless they terminate the comment
        index = html.indexOf("--", 4);

        if (index >= 0 && html.lastIndexOf("-->", index) === index) {
          if (handler.comment) handler.comment(html.substring(4, index));
          html = html.substring(index + 3);
          chars = false;
        }
      // DOCTYPE
      } else if (DOCTYPE_REGEXP.test(html)) {
        match = html.match(DOCTYPE_REGEXP);

        if (match) {
          html = html.replace(match[0], '');
          chars = false;
        }
      // end tag
      } else if (BEGING_END_TAGE_REGEXP.test(html)) {
        match = html.match(END_TAG_REGEXP);

        if (match) {
          html = html.substring(match[0].length);
          match[0].replace(END_TAG_REGEXP, parseEndTag);
          chars = false;
        }

      // start tag
      } else if (BEGIN_TAG_REGEXP.test(html)) {
        match = html.match(START_TAG_REGEXP);

        if (match) {
          // We only have a valid start-tag if there is a '>'.
          if (match[4]) {
            html = html.substring(match[0].length);
            match[0].replace(START_TAG_REGEXP, parseStartTag);
          }
          chars = false;
        } else {
          // no ending tag found --- this piece should be encoded as an entity.
          text += '<';
          html = html.substring(1);
        }
      }

      if (chars) {
        index = html.indexOf("<");

        text += index < 0 ? html : html.substring(0, index);
        html = index < 0 ? "" : html.substring(index);

        if (handler.chars) handler.chars(decodeEntities(text));
      }

    } else {
      // IE versions 9 and 10 do not understand the regex '[^]', so using a workaround with [\W\w].
      html = html.replace(new RegExp("([\\W\\w]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
        function(all, text) {
          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");

          if (handler.chars) handler.chars(decodeEntities(text));

          return "";
      });

      parseEndTag("", stack.last());
    }

    if (html == last) {
      throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
                                        "of html: {0}", html);
    }
    last = html;
  }

  // Clean up any remaining tags
  parseEndTag();

  function parseStartTag(tag, tagName, rest, unary) {
    tagName = angular.lowercase(tagName);
    if (blockElements[tagName]) {
      while (stack.last() && inlineElements[stack.last()]) {
        parseEndTag("", stack.last());
      }
    }

    if (optionalEndTagElements[tagName] && stack.last() == tagName) {
      parseEndTag("", tagName);
    }

    unary = voidElements[tagName] || !!unary;

    if (!unary) {
      stack.push(tagName);
    }

    var attrs = {};

    rest.replace(ATTR_REGEXP,
      function(match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
        var value = doubleQuotedValue
          || singleQuotedValue
          || unquotedValue
          || '';

        attrs[name] = decodeEntities(value);
    });
    if (handler.start) handler.start(tagName, attrs, unary);
  }

  function parseEndTag(tag, tagName) {
    var pos = 0, i;
    tagName = angular.lowercase(tagName);
    if (tagName) {
      // Find the closest opened tag of the same type
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos] == tagName) break;
      }
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (i = stack.length - 1; i >= pos; i--)
        if (handler.end) handler.end(stack[i]);

      // Remove the open elements from the stack
      stack.length = pos;
    }
  }
}

var hiddenPre=document.createElement("pre");
/**
 * decodes all entities into regular string
 * @param value
 * @returns {string} A string with decoded entities.
 */
function decodeEntities(value) {
  if (!value) { return ''; }

  hiddenPre.innerHTML = value.replace(/</g,"&lt;");
  // innerText depends on styling as it doesn't display hidden elements.
  // Therefore, it's better to use textContent not to cause unnecessary reflows.
  return hiddenPre.textContent;
}

/**
 * Escapes all potentially dangerous characters, so that the
 * resulting string can be safely inserted into attribute or
 * element text.
 * @param value
 * @returns {string} escaped text
 */
function encodeEntities(value) {
  return value.
    replace(/&/g, '&amp;').
    replace(SURROGATE_PAIR_REGEXP, function(value) {
      var hi = value.charCodeAt(0);
      var low = value.charCodeAt(1);
      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
    }).
    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
      return '&#' + value.charCodeAt(0) + ';';
    }).
    replace(/</g, '&lt;').
    replace(/>/g, '&gt;');
}

/**
 * create an HTML/XML writer which writes to buffer
 * @param {Array} buf use buf.jain('') to get out sanitized html string
 * @returns {object} in the form of {
 *     start: function(tag, attrs, unary) {},
 *     end: function(tag) {},
 *     chars: function(text) {},
 *     comment: function(text) {}
 * }
 */
function htmlSanitizeWriter(buf, uriValidator) {
  var ignore = false;
  var out = angular.bind(buf, buf.push);
  return {
    start: function(tag, attrs, unary) {
      tag = angular.lowercase(tag);
      if (!ignore && specialElements[tag]) {
        ignore = tag;
      }
      if (!ignore && validElements[tag] === true) {
        out('<');
        out(tag);
        angular.forEach(attrs, function(value, key) {
          var lkey=angular.lowercase(key);
          var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
          if (validAttrs[lkey] === true &&
            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
            out(' ');
            out(key);
            out('="');
            out(encodeEntities(value));
            out('"');
          }
        });
        out(unary ? '/>' : '>');
      }
    },
    end: function(tag) {
        tag = angular.lowercase(tag);
        if (!ignore && validElements[tag] === true) {
          out('</');
          out(tag);
          out('>');
        }
        if (tag == ignore) {
          ignore = false;
        }
      },
    chars: function(chars) {
        if (!ignore) {
          out(encodeEntities(chars));
        }
      }
  };
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);

/* global sanitizeText: false */

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
 * @returns {string} Html-linkified text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js">
     <file name="index.html">
       <script>
         angular.module('linkyExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.snippet =
               'Pretty text with some links:\n'+
               'http://angularjs.org/,\n'+
               'mailto:us@somewhere.org,\n'+
               'another@somewhere.org,\n'+
               'and one more: ftp://127.0.0.1/.';
             $scope.snippetWithTarget = 'http://angularjs.org/';
           }]);
       </script>
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Filter</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  return function(text, target) {
    if (!text) return text;
    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      html.push('<a ');
      if (angular.isDefined(target)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);

/*!
 * angular-translate - v2.19.1 - 2024-01-21
 * 
 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

/**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */
runTranslate.$inject = ['$translate'];
$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
translateAttrDirective.$inject = ['$translate', '$rootScope'];
translateCloakDirective.$inject = ['$translate', '$rootScope'];
translateFilterFactory.$inject = ['$parse', '$translate'];
$translationCache.$inject = ['$cacheFactory'];
angular.module('pascalprecht.translate', ['ng'])
  .run(runTranslate);

function runTranslate($translate) {

  'use strict';

  var key = $translate.storageKey(),
    storage = $translate.storage();

  var fallbackFromIncorrectStorageValue = function () {
    var preferred = $translate.preferredLanguage();
    if (angular.isString(preferred)) {
      $translate.use(preferred);
      // $translate.use() will also remember the language.
      // So, we don't need to call storage.put() here.
    } else {
      storage.put(key, $translate.use());
    }
  };

  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

  if (storage) {
    if (!storage.get(key)) {
      fallbackFromIncorrectStorageValue();
    } else {
      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
    }
  } else if (angular.isString($translate.preferredLanguage())) {
    $translate.use($translate.preferredLanguage());
  }
}

runTranslate.displayName = 'runTranslate';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */
angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

function $translateSanitizationProvider () {

  'use strict';

  var $sanitize,
      $sce,
      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
      hasConfiguredStrategy = false,
      hasShownNoStrategyConfiguredWarning = false,
      strategies;

  /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */

  /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */

  strategies = {
    sanitize: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlSanitizeValue(value);
      }
      return value;
    },
    escape: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlEscapeValue(value);
      }
      return value;
    },
    sanitizeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlSanitizeValue);
      }
      return value;
    },
    escapeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlEscapeValue);
      }
      return value;
    },
    sce: function (value, mode, context) {
      if (mode === 'text') {
        value = htmlTrustValue(value);
      } else if (mode === 'params') {
        if (context !== 'filter') {
          // do html escape in filter context #1101
          value = mapInterpolationParameters(value, htmlEscapeValue);
        }
      }
      return value;
    },
    sceParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlTrustValue);
      }
      return value;
    }
  };
  // Support legacy strategy name 'escaped' for backwards compatibility.
  // TODO should be removed in 3.0
  strategies.escaped = strategies.escapeParameters;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */
  this.addStrategy = function (strategyName, strategyFunction) {
    strategies[strategyName] = strategyFunction;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */
  this.removeStrategy = function (strategyName) {
    delete strategies[strategyName];
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */
  this.useStrategy = function (strategy) {
    hasConfiguredStrategy = true;
    currentStrategy = strategy;
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */
  this.$get = ['$injector', '$log', function ($injector, $log) {

    var cachedStrategyMap = {};

    var applyStrategies = function (value, mode, context, selectedStrategies) {
      angular.forEach(selectedStrategies, function (selectedStrategy) {
        if (angular.isFunction(selectedStrategy)) {
          value = selectedStrategy(value, mode, context);
        } else if (angular.isFunction(strategies[selectedStrategy])) {
          value = strategies[selectedStrategy](value, mode, context);
        } else if (angular.isString(strategies[selectedStrategy])) {
          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
            try {
              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
            } catch (e) {
              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
            }
          }
          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
        } else {
          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
        }
      });
      return value;
    };

    // TODO: should be removed in 3.0
    var showNoStrategyConfiguredWarning = function () {
      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
        hasShownNoStrategyConfiguredWarning = true;
      }
    };

    if ($injector.has('$sanitize')) {
      $sanitize = $injector.get('$sanitize');
    }
    if ($injector.has('$sce')) {
      $sce = $injector.get('$sce');
    }

    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */
      useStrategy: (function (self) {
        return function (strategy) {
          self.useStrategy(strategy);
        };
      })(this),

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @param {string} [context] The context of this call: filter, service. Default is service
       * @returns {string|object} sanitized value
       */
      sanitize: function (value, mode, strategy, context) {
        if (!currentStrategy) {
          showNoStrategyConfiguredWarning();
        }

        if (!strategy && strategy !== null) {
          strategy = currentStrategy;
        }

        if (!strategy) {
          return value;
        }

        if (!context) {
          context = 'service';
        }

        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
        return applyStrategies(value, mode, context, selectedStrategies);
      }
    };
  }];

  var htmlEscapeValue = function (value) {
    var element = angular.element('<div></div>');
    element.text(value); // not chainable, see #1044
    return element.html();
  };

  var htmlSanitizeValue = function (value) {
    if (!$sanitize) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
    }
    return $sanitize(value);
  };

  var htmlTrustValue = function (value) {
    if (!$sce) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
    }
    return $sce.trustAsHtml(value);
  };

  var mapInterpolationParameters = function (value, iteratee, stack) {
    if (angular.isDate(value)) {
      return value;
    } else if (angular.isObject(value)) {
      var result = angular.isArray(value) ? [] : {};

      if (!stack) {
        stack = [];
      } else {
        if (stack.indexOf(value) > -1) {
          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
        }
      }

      stack.push(value);
      angular.forEach(value, function (propertyValue, propertyKey) {

        /* Skipping function properties. */
        if (angular.isFunction(propertyValue)) {
          return;
        }

        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
      });
      stack.splice(-1, 1); // remove last

      return result;
    } else if (angular.isNumber(value)) {
      return value;
    } else if (value === true || value === false) {
      return value;
    } else if (!angular.isUndefined(value) && value !== null) {
      return iteratee(value);
    } else {
      return value;
    }
  };
}

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */
angular.module('pascalprecht.translate')
  .constant('pascalprechtTranslateOverrider', {})
  .provider('$translate', $translate);

function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

  'use strict';

  var $translationTable = {},
    $preferredLanguage,
    $availableLanguageKeys = [],
    $languageKeyAliases,
    $fallbackLanguage,
    $fallbackWasString,
    $uses,
    $nextLang,
    $storageFactory,
    $storageKey = $STORAGE_KEY,
    $storagePrefix,
    $missingTranslationHandlerFactory,
    $interpolationFactory,
    $interpolatorFactories = [],
    $loaderFactory,
    $cloakClassName = 'translate-cloak',
    $loaderOptions,
    $notFoundIndicatorLeft,
    $notFoundIndicatorRight,
    $postCompilingEnabled = false,
    $forceAsyncReloadEnabled = false,
    $allowNamespaces = true,
    $nestedObjectDelimeter = '.',
    $isReady = false,
    $keepContent = false,
    loaderCache,
    directivePriority = 0,
    statefulFilter = true,
    postProcessFn,
    uniformLanguageTagResolver = 'default',
    languageTagResolver = {
      'default' : function (tag) {
        return (tag || '').split('-').join('_');
      },
      java : function (tag) {
        var temp = (tag || '').split('-').join('_');
        var parts = temp.split('_');
        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
      },
      bcp47 : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');

        switch (parts.length) {
          case 1: // language only
            parts[0] = parts[0].toLowerCase();
            break;
          case 2: // language-script or language-region
            parts[0] = parts[0].toLowerCase();
            if (parts[1].length === 4) { // parts[1] is script
              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            } else { // parts[1] is region
              parts[1] = parts[1].toUpperCase();
            }
            break;
          case 3: // language-script-region
            parts[0] = parts[0].toLowerCase();
            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            parts[2] = parts[2].toUpperCase();
            break;
          default:
            return temp;
        }

        return parts.join('-');
      },
      'iso639-1' : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');
        return parts[0].toLowerCase();
      }
    };

  var version = '2.19.1';

  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {

    // internal purpose only
    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
      return pascalprechtTranslateOverrider.getLocale();
    }

    var nav = $windowProvider.$get().navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

  // tries to determine the browsers locale
  var getLocale = function () {
    var locale = getFirstBrowserLanguage() || '';
    if (languageTagResolver[uniformLanguageTagResolver]) {
      locale = languageTagResolver[uniformLanguageTagResolver](locale);
    }
    return locale;
  };
  getLocale.displayName = 'angular-translate/service: getLocale';

  /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */
  var indexOf = function (array, searchElement) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === searchElement) {
        return i;
      }
    }
    return -1;
  };

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function () {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  var negotiateLocale = function (preferred) {
    if (!preferred) {
      return;
    }

    var avail = [],
      locale = lowercase(preferred),
      i = 0,
      n = $availableLanguageKeys.length;

    for (; i < n; i++) {
      avail.push(lowercase($availableLanguageKeys[i]));
    }

    // Check for an exact match in our list of available keys
    i = indexOf(avail, locale);
    if (i > -1) {
      return $availableLanguageKeys[i];
    }

    if ($languageKeyAliases) {
      var alias;
      for (var langKeyAlias in $languageKeyAliases) {
        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
          var hasWildcardKey = false;
          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
            lowercase(langKeyAlias) === lowercase(preferred);

          if (langKeyAlias.slice(-1) === '*') {
            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
          }
          if (hasExactKey || hasWildcardKey) {
            alias = $languageKeyAliases[langKeyAlias];
            if (indexOf(avail, lowercase(alias)) > -1) {
              return alias;
            }
          }
        }
      }
    }

    // Check for a language code without region
    var parts = preferred.split('_');

    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
      return parts[0];
    }

    // If everything fails, return undefined.
    return;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} langKey A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */
  var translations = function (langKey, translationTable) {

    if (!langKey && !translationTable) {
      return $translationTable;
    }

    if (langKey && !translationTable) {
      if (angular.isString(langKey)) {
        return $translationTable[langKey];
      }
    } else {
      if (!angular.isObject($translationTable[langKey])) {
        $translationTable[langKey] = {};
      }
      angular.extend($translationTable[langKey], flatObject(translationTable));
    }
    return this;
  };

  this.translations = translations;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */
  this.cloakClassName = function (name) {
    if (!name) {
      return $cloakClassName;
    }
    $cloakClassName = name;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#allowNamespaces
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Let's you disable namespaces, if you don't need nested translation
   * object files. Disabling namespaces can improve performance.
   *
   * Default value is `true`. Namespaces are enabled by default.
   *
   * @param {boolean} namespacesEnabled - namespaces are enabled or not
   */
  this.allowNamespaces = function (namespacesEnabled) {
    if (namespacesEnabled === undefined) {
      return $allowNamespaces;
    }
    $allowNamespaces = namespacesEnabled;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */
  this.nestedObjectDelimeter = function (delimiter) {
    if (!delimiter) {
      return $nestedObjectDelimeter;
    }
    $nestedObjectDelimeter = delimiter;
    return this;
  };

  /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */
  var flatObject = function (data, path, result, prevKey) {
    var key, keyWithPath, keyWithShortPath, val;

    if (!path) {
      path = [];
    }
    if (!result) {
      result = {};
    }
    if (!$allowNamespaces) {
      return data;
    }
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue;
      }
      val = data[key];
      if (angular.isObject(val)) {
        flatObject(val, path.concat(key), result, key);
      } else {
        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
        if (path.length && key === prevKey) {
          // Create shortcut path (foo.bar == foo.bar.bar)
          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
          // Link it to original path
          result[keyWithShortPath] = '@:' + keyWithPath;
        }
        result[keyWithPath] = val;
      }
    }
    return result;
  };
  flatObject.displayName = 'flatObject';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */
  this.addInterpolation = function (factory) {
    $interpolatorFactories.push(factory);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */
  this.useMessageFormatInterpolation = function () {
    return this.useInterpolation('$translateMessageFormatInterpolation');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */
  this.useInterpolation = function (factory) {
    $interpolationFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */
  this.useSanitizeValueStrategy = function (value) {
    $translateSanitizationProvider.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
   *
   * @param {string} langKey A language key.
   */
  this.preferredLanguage = function (langKey) {
    if (langKey) {
      setupPreferredLanguage(langKey);
      return this;
    }
    return $preferredLanguage;
  };
  var setupPreferredLanguage = function (langKey) {
    if (langKey) {
      $preferredLanguage = langKey;
    }
    return $preferredLanguage;
  };
  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */
  this.translationNotFoundIndicator = function (indicator) {
    this.translationNotFoundIndicatorLeft(indicator);
    this.translationNotFoundIndicatorRight(indicator);
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorLeft = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorLeft;
    }
    $notFoundIndicatorLeft = indicator;
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorRight = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorRight;
    }
    $notFoundIndicatorRight = indicator;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */
  this.fallbackLanguage = function (langKey) {
    fallbackStack(langKey);
    return this;
  };

  var fallbackStack = function (langKey) {
    if (langKey) {
      if (angular.isString(langKey)) {
        $fallbackWasString = true;
        $fallbackLanguage = [langKey];
      } else if (angular.isArray(langKey)) {
        $fallbackWasString = false;
        $fallbackLanguage = langKey;
      }
      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
        $fallbackLanguage.push($preferredLanguage);
      }

      return this;
    } else {
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */
  this.use = function (langKey) {
    if (langKey) {
      if (!$translationTable[langKey] && (!$loaderFactory)) {
        // only throw an error, when not loading translation data asynchronously
        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
      }
      $uses = langKey;
      return this;
    }
    return $uses;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
   *
   * @returns {string} the current client/browser language key
   */
  this.resolveClientLocale = function () {
    return getLocale();
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */
  var storageKey = function (key) {
    if (!key) {
      if ($storagePrefix) {
        return $storagePrefix + $storageKey;
      }
      return $storageKey;
    }
    $storageKey = key;
    return this;
  };

  this.storageKey = storageKey;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */
  this.useUrlLoader = function (url, options) {
    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */
  this.useStaticFilesLoader = function (options) {
    return this.useLoader('$translateStaticFilesLoader', options);
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */
  this.useLoader = function (loaderFactory, options) {
    $loaderFactory = loaderFactory;
    $loaderOptions = options || {};
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */
  this.useLocalStorage = function () {
    return this.useStorage('$translateLocalStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */
  this.useCookieStorage = function () {
    return this.useStorage('$translateCookieStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */
  this.useStorage = function (storageFactory) {
    $storageFactory = storageFactory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */
  this.storagePrefix = function (prefix) {
    if (!prefix) {
      return prefix;
    }
    $storagePrefix = prefix;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */
  this.useMissingTranslationHandlerLog = function () {
    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.useMissingTranslationHandler = function (factory) {
    $missingTranslationHandlerFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.usePostCompiling = function (value) {
    $postCompilingEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.forceAsyncReload = function (value) {
    $forceAsyncReloadEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     EN => en
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *     sr-latn => sr-Latn
   *     sr-latn-rs => sr-Latn-RS
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */
  this.uniformLanguageTag = function (options) {

    if (!options) {
      options = {};
    } else if (angular.isString(options)) {
      options = {
        standard : options
      };
    }

    uniformLanguageTagResolver = options.standard;

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */
  this.determinePreferredLanguage = function (fn) {

    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

    if (!$availableLanguageKeys.length) {
      $preferredLanguage = locale;
    } else {
      $preferredLanguage = negotiateLocale(locale) || locale;
    }

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */
  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
    if (languageKeys) {
      $availableLanguageKeys = languageKeys;
      if (aliases) {
        $languageKeyAliases = aliases;
      }
      return this;
    }
    return $availableLanguageKeys;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */
  this.useLoaderCache = function (cache) {
    if (cache === false) {
      // disable cache
      loaderCache = undefined;
    } else if (cache === true) {
      // enable cache using AJS defaults
      loaderCache = true;
    } else if (typeof(cache) === 'undefined') {
      // enable cache using default
      loaderCache = '$translationCache';
    } else if (cache) {
      // enable cache using given one (see $cacheFactory)
      loaderCache = cache;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */
  this.directivePriority = function (priority) {
    if (priority === undefined) {
      // getter
      return directivePriority;
    } else {
      // setter with chaining
      directivePriority = priority;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */
  this.statefulFilter = function (state) {
    if (state === undefined) {
      // getter
      return statefulFilter;
    } else {
      // setter with chaining
      statefulFilter = state;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#postProcess
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * The post processor will be intercept right after the translation result. It can modify the result.
   *
   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
   */
  this.postProcess = function (fn) {
    if (fn) {
      postProcessFn = fn;
    } else {
      postProcessFn = undefined;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#keepContent
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If keepContent is set to true than translate directive will always use innerHTML
   * as a default translation
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.keepContent(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.keepContent = function (value) {
    $keepContent = !(!value);
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} [interpolateParams={}] An object hash for dynamic values
   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
   *                                        as default text in case it is not found in any configured language
   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
   * @returns {object} promise
   */
  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

    var Storage,
      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
      pendingLoader = false,
      interpolatorHashMap = {},
      langPromises = {},
      fallbackIndex,
      startFallbackIteration;

    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
      if (!$uses && $preferredLanguage) {
        $uses = $preferredLanguage;
      }
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        // Inspired by Q.allSettled by Kris Kowal
        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
        // This transforms all promises regardless resolved or rejected
        var translateAll = function (translationIds) {
          var results = {}; // storing the actual results
          var promises = []; // promises to wait for
          // Wraps the promise a) being always resolved and b) storing the link id->value
          var translate = function (translationId) {
            var deferred = $q.defer();
            var regardless = function (value) {
              results[translationId] = value;
              deferred.resolve([translationId, value]);
            };
            // we don't care whether the promise was resolved or rejected; just store the values
            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
            return deferred.promise;
          };
          for (var i = 0, c = translationIds.length; i < c; i++) {
            promises.push(translate(translationIds[i]));
          }
          // wait for all (including storing to results)
          return $q.all(promises).then(function () {
            // return the results
            return results;
          });
        };
        return translateAll(translationId);
      }

      var deferred = $q.defer();

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      } else {
        throw new TypeError('translationId must be a not empty string');
      }

      var promiseToWaitFor = (function () {
        var promise = langPromises[uses] || langPromises[$preferredLanguage];

        fallbackIndex = 0;

        if ($storageFactory && !promise) {
          // looks like there's no pending promise for $preferredLanguage or
          // $uses. Maybe there's one pending for a language that comes from
          // storage.
          var langKey = Storage.get($storageKey);
          promise = langPromises[langKey];

          if ($fallbackLanguage && $fallbackLanguage.length) {
            var index = indexOf($fallbackLanguage, langKey);
            // maybe the language from storage is also defined as fallback language
            // we increase the fallback language index to not search in that language
            // as fallback, since it's probably the first used language
            // in that case the index starts after the first element
            fallbackIndex = (index === 0) ? 1 : 0;

            // but we can make sure to ALWAYS fallback to preferred language at least
            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
              $fallbackLanguage.push($preferredLanguage);
            }
          }
        }
        return promise;
      }());

      if (!promiseToWaitFor) {
        // no promise to wait for? okay. Then there's no loader registered
        // nor is a one pending for language that comes from storage.
        // We can just translate.
        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
      } else {
        var promiseResolved = function () {
          // $uses may have changed while waiting
          if (!forceLanguage) {
            uses = $uses;
          }
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
        };
        promiseResolved.displayName = 'promiseResolved';

        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
      }
      return deferred.promise;
    };

    /**
     * @name applyNotFoundIndicators
     * @private
     *
     * @description
     * Applies not fount indicators to given translation id, if needed.
     * This function gets only executed, if a translation id doesn't exist,
     * which is why a translation id is expected as argument.
     *
     * @param {string} translationId Translation id.
     * @returns {string} Same as given translation id but applied with not found
     * indicators.
     */
    var applyNotFoundIndicators = function (translationId) {
      // applying notFoundIndicators
      if ($notFoundIndicatorLeft) {
        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
      }
      if ($notFoundIndicatorRight) {
        translationId = [translationId, $notFoundIndicatorRight].join(' ');
      }
      return translationId;
    };

    /**
     * @name useLanguage
     * @private
     *
     * @description
     * Makes actual use of a language by setting a given language key as used
     * language and informs registered interpolators to also use the given
     * key as locale.
     *
     * @param {string} key Locale key.
     */
    var useLanguage = function (key) {
      $uses = key;

      // make sure to store new language key before triggering success event
      if ($storageFactory) {
        Storage.put($translate.storageKey(), $uses);
      }

      $rootScope.$emit('$translateChangeSuccess', {language : key});

      // inform default interpolator
      defaultInterpolator.setLocale($uses);

      var eachInterpolator = function (interpolator, id) {
        interpolatorHashMap[id].setLocale($uses);
      };
      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

      // inform all others too!
      angular.forEach(interpolatorHashMap, eachInterpolator);
      $rootScope.$emit('$translateChangeEnd', {language : key});
    };

    /**
     * @name loadAsync
     * @private
     *
     * @description
     * Kicks off registered async loader using `$injector` and applies existing
     * loader options. When resolved, it updates translation tables accordingly
     * or rejects with given language key.
     *
     * @param {string} key Language key.
     * @return {Promise} A promise.
     */
    var loadAsync = function (key) {
      if (!key) {
        throw 'No language key specified for loading.';
      }

      var deferred = $q.defer();

      $rootScope.$emit('$translateLoadingStart', {language : key});
      pendingLoader = true;

      var cache = loaderCache;
      if (typeof(cache) === 'string') {
        // getting on-demand instance of loader
        cache = $injector.get(cache);
      }

      var loaderOptions = angular.extend({}, $loaderOptions, {
        key : key,
        $http : angular.extend({}, {
          cache : cache
        }, $loaderOptions.$http)
      });

      var onLoaderSuccess = function (data) {
        var translationTable = {};
        $rootScope.$emit('$translateLoadingSuccess', {language : key});

        if (angular.isArray(data)) {
          angular.forEach(data, function (table) {
            angular.extend(translationTable, flatObject(table));
          });
        } else {
          angular.extend(translationTable, flatObject(data));
        }
        pendingLoader = false;
        deferred.resolve({
          key : key,
          table : translationTable
        });
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderSuccess.displayName = 'onLoaderSuccess';

      var onLoaderError = function (key) {
        $rootScope.$emit('$translateLoadingError', {language : key});
        deferred.reject(key);
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderError.displayName = 'onLoaderError';

      $injector.get($loaderFactory)(loaderOptions)
        .then(onLoaderSuccess, onLoaderError);

      return deferred.promise;
    };

    if ($storageFactory) {
      Storage = $injector.get($storageFactory);

      if (!Storage.get || !Storage.put) {
        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
      }
    }

    // if we have additional interpolations that were added via
    // $translateProvider.addInterpolation(), we have to map'em
    if ($interpolatorFactories.length) {
      var eachInterpolationFactory = function (interpolatorFactory) {
        var interpolator = $injector.get(interpolatorFactory);
        // setting initial locale for each interpolation service
        interpolator.setLocale($preferredLanguage || $uses);
        // make'em recognizable through id
        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
      };
      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

      angular.forEach($interpolatorFactories, eachInterpolationFactory);
    }

    /**
     * @name getTranslationTable
     * @private
     *
     * @description
     * Returns a promise that resolves to the translation table
     * or is rejected if an error occurred.
     *
     * @param langKey
     * @returns {Q.promise}
     */
    var getTranslationTable = function (langKey) {
      var deferred = $q.defer();
      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
        deferred.resolve($translationTable[langKey]);
      } else if (langPromises[langKey]) {
        var onResolve = function (data) {
          translations(data.key, data.table);
          deferred.resolve(data.table);
        };
        onResolve.displayName = 'translationTableResolver';
        langPromises[langKey].then(onResolve, deferred.reject);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    };

    /**
     * @name getFallbackTranslation
     * @private
     *
     * @description
     * Returns a promise that will resolve to the translation
     * or be rejected if no translation was found for the language.
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {Q.promise}
     */
    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var deferred = $q.defer();

      var onResolve = function (translationTable) {
        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
          Interpolator.setLocale(langKey);
          var translation = translationTable[translationId];
          if (translation.substr(0, 2) === '@:') {
            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
              .then(deferred.resolve, deferred.reject);
          } else {
            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

            deferred.resolve(interpolatedValue);

          }
          Interpolator.setLocale($uses);
        } else {
          deferred.reject();
        }
      };
      onResolve.displayName = 'fallbackTranslationResolver';

      getTranslationTable(langKey).then(onResolve, deferred.reject);

      return deferred.promise;
    };

    /**
     * @name getFallbackTranslationInstant
     * @private
     *
     * @description
     * Returns a translation
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns {string} translation
     */
    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result, translationTable = $translationTable[langKey];

      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
        Interpolator.setLocale(langKey);
        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
        // workaround for TrustedValueHolderType
        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
          var result2 = result.$$unwrapTrustedValue();
          if (result2.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
          }
        } else if (result.substr(0, 2) === '@:') {
          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
        }
        Interpolator.setLocale($uses);
      }

      return result;
    };


    /**
     * @name translateByHandler
     * @private
     *
     * Translate by missing translation handler.
     *
     * @param translationId
     * @param interpolateParams
     * @param defaultTranslationText
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
     * absent
     */
    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
      // If we have a handler factory - we might also call it here to determine if it provides
      // a default text for a translationid that can't be found anywhere in our tables
      if ($missingTranslationHandlerFactory) {
        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
      } else {
        return translationId;
      }
    };

    /**
     * @name resolveForFallbackLanguage
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise that will resolve to the translation.
     */
    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      var deferred = $q.defer();

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
          function (data) {
            deferred.resolve(data);
          },
          function () {
            // Look in the next fallback language for a translation.
            // It delays the resolving by passing another promise to resolve.
            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          }
        );
      } else {
        // No translation found in any fallback language
        // if a default translation text is set in the directive, then return this as a result
        if (defaultTranslationText) {
          deferred.resolve(defaultTranslationText);
        } else {
          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

          // if no default translation is set and an error handler is defined, send it to the handler
          // and then return the result if it isn't undefined
          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
            deferred.resolve(missingTranslationHandlerTranslation);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    /**
     * @name resolveForFallbackLanguageInstant
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {string} translation
     */
    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result;

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
        if (!result && result !== '') {
          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
        }
      }
      return result;
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise, that resolves to the translation.
     */
    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {String} translation
     */
    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
    };

    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

      var deferred = $q.defer();

      var table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {

          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
            .then(deferred.resolve, deferred.reject);
        } else {
          //
          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
          deferred.resolve(resolvedTranslation);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
            .then(function (translation) {
              deferred.resolve(translation);
            }, function (_translationId) {
              deferred.reject(applyNotFoundIndicators(_translationId));
            });
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.resolve(missingTranslationHandlerTranslation);
          }
        } else {
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

      var result, table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = defaultInterpolator;

      // if the interpolation id exists use custom interpolator
      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
        Interpolator = interpolatorHashMap[interpolationId];
      }

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {
          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
        } else {
          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackIndex = 0;
          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          result = missingTranslationHandlerTranslation;
        } else {
          result = applyNotFoundIndicators(translationId);
        }
      }

      return result;
    };

    var clearNextLangAndPromise = function (key) {
      if ($nextLang === key) {
        $nextLang = undefined;
      }
      langPromises[key] = undefined;
    };

    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
      var fn = postProcessFn;

      if (fn) {

        if (typeof(fn) === 'string') {
          // getting on-demand instance
          fn = $injector.get(fn);
        }
        if (fn) {
          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
        }
      }

      return resolvedTranslation;
    };

    var loadTranslationsIfMissing = function (key) {
      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          return translation;
        });
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#preferredLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the preferred language.
     *
     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
     *
     * @return {string} preferred language key
     */
    $translate.preferredLanguage = function (langKey) {
      if (langKey) {
        setupPreferredLanguage(langKey);
      }
      return $preferredLanguage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#cloakClassName
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured class name for `translate-cloak` directive.
     *
     * @return {string} cloakClassName
     */
    $translate.cloakClassName = function () {
      return $cloakClassName;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#allowNamespaces
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns if namespaces are enabled
     *
     * @return {boolean} allowNamespaces value
     */
    $translate.allowNamespaces = function () {
      return $allowNamespaces;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured delimiter for nested namespaces.
     *
     * @return {string} nestedObjectDelimeter
     */
    $translate.nestedObjectDelimeter = function () {
      return $nestedObjectDelimeter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#fallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the fallback languages or sets a new fallback stack.
     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
     *
     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
     *
     * @return {string||array} fallback language key
     */
    $translate.fallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        fallbackStack(langKey);

        // as we might have an async loader initiated and a new translation language might have been defined
        // we need to add the promise to the stack also. So - iterate.
        if ($loaderFactory) {
          if ($fallbackLanguage && $fallbackLanguage.length) {
            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
              if (!langPromises[$fallbackLanguage[i]]) {
                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
              }
            }
          }
        }
        $translate.use($translate.use());
      }
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#useFallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Sets the first key of the fallback language stack to be used for translation.
     * Therefore all languages in the fallback array BEFORE this key will be skipped!
     *
     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
     * get back to the whole stack
     */
    $translate.useFallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        if (!langKey) {
          startFallbackIteration = 0;
        } else {
          var langKeyPosition = indexOf($fallbackLanguage, langKey);
          if (langKeyPosition > -1) {
            startFallbackIteration = langKeyPosition;
          }
        }

      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#proposedLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key of language that is currently loaded asynchronously.
     *
     * @return {string} language key
     */
    $translate.proposedLanguage = function () {
      return $nextLang;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns registered storage.
     *
     * @return {object} Storage
     */
    $translate.storage = function () {
      return Storage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#negotiateLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a language key based on available languages and language aliases. If a
     * language key cannot be resolved, returns undefined.
     *
     * If no or a falsy key is given, returns undefined.
     *
     * @param {string} [key] Language key
     * @return {string|undefined} Language key or undefined if no language key is found.
     */
    $translate.negotiateLocale = negotiateLocale;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#use
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Tells angular-translate which language to use by given language key. This method is
     * used to change language at runtime. It also takes care of storing the language
     * key in a configured store to let your app remember the choosed language.
     *
     * When trying to 'use' a language which isn't available it tries to load it
     * asynchronously with registered loaders.
     *
     * Returns promise object with loaded language file data or string of the currently used language.
     *
     * If no or a falsy key is given it returns the currently used language key.
     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
     * @example
     * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
     *
     * @param {string=} key Language key
     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
     */
    $translate.use = function (key) {
      if (!key) {
        return $uses;
      }

      var deferred = $q.defer();
      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

      $rootScope.$emit('$translateChangeStart', {language : key});

      // Try to get the aliased language key
      var aliasedKey = negotiateLocale(key);
      // Ensure only registered language keys will be loaded
      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
        return $q.reject(key);
      }

      if (aliasedKey) {
        key = aliasedKey;
      }

      // if there isn't a translation table for the language we've requested,
      // we load it asynchronously
      $nextLang = key;
      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          deferred.resolve(translation.key);
          if ($nextLang === key) {
            useLanguage(translation.key);
          }
          return translation;
        }, function (key) {
          $rootScope.$emit('$translateChangeError', {language : key});
          deferred.reject(key);
          $rootScope.$emit('$translateChangeEnd', {language : key});
          return $q.reject(key);
        });
        langPromises[key]['finally'](function () {
          clearNextLangAndPromise(key);
        })['catch'](angular.noop); // we don't care about errors (clearing)
      } else if (langPromises[key]) {
        // we are already loading this asynchronously
        // resolve our new deferred when the old langPromise is resolved
        langPromises[key].then(function (translation) {
          if ($nextLang === translation.key) {
            useLanguage(translation.key);
          }
          deferred.resolve(translation.key);
          return translation;
        }, function (key) {
          // find first available fallback language if that request has failed
          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
          } else {
            return deferred.reject(key);
          }
        });
      } else {
        deferred.resolve(key);
        useLanguage(key);
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#resolveClientLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */
    $translate.resolveClientLocale = function () {
      return getLocale();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storageKey
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the key for the storage.
     *
     * @return {string} storage key
     */
    $translate.storageKey = function () {
      return storageKey();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether post compiling is enabled or not
     *
     * @return {bool} storage key
     */
    $translate.isPostCompilingEnabled = function () {
      return $postCompilingEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether force async reload is enabled or not
     *
     * @return {boolean} forceAsyncReload value
     */
    $translate.isForceAsyncReloadEnabled = function () {
      return $forceAsyncReloadEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isKeepContent
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether keepContent or not
     *
     * @return {boolean} keepContent value
     */
    $translate.isKeepContent = function () {
      return $keepContent;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#refresh
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
     * the module will drop all existent translation tables and load new version of those which
     * are currently in use.
     *
     * Refresh means that the module will drop target translation table and try to load it again.
     *
     * In case there are no loaders registered the refresh() method will throw an Error.
     *
     * If the module is able to refresh translation tables refresh() method will broadcast
     * $translateRefreshStart and $translateRefreshEnd events.
     *
     * @example
     * // this will drop all currently existent translation tables and reload those which are
     * // currently in use
     * $translate.refresh();
     * // this will refresh a translation table for the en_US language
     * $translate.refresh('en_US');
     *
     * @param {string} langKey A language key of the table, which has to be refreshed
     *
     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
     * process is finished successfully, and reject if not.
     */
    $translate.refresh = function (langKey) {
      if (!$loaderFactory) {
        throw new Error('Couldn\'t refresh translation table, no loader registered!');
      }

      $rootScope.$emit('$translateRefreshStart', {language : langKey});

      var deferred = $q.defer(), updatedLanguages = {};

      //private helper
      function loadNewData(languageKey) {
        var promise = loadAsync(languageKey);
        //update the load promise cache for this language
        langPromises[languageKey] = promise;
        //register a data handler for the promise
        promise.then(function (data) {
            //clear the cache for this language
            $translationTable[languageKey] = {};
            //add the new data for this language
            translations(languageKey, data.table);
            //track that we updated this language
            updatedLanguages[languageKey] = true;
          },
          //handle rejection to appease the $q validation
          angular.noop);
        return promise;
      }

      //set up post-processing
      deferred.promise.then(
        function () {
          for (var key in $translationTable) {
            if ($translationTable.hasOwnProperty(key)) {
              //delete cache entries that were not updated
              if (!(key in updatedLanguages)) {
                delete $translationTable[key];
              }
            }
          }
          if ($uses) {
            useLanguage($uses);
          }
        },
        //handle rejection to appease the $q validation
        angular.noop
      )['finally'](
        function () {
          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
        }
      );

      if (!langKey) {
        // if there's no language key specified we refresh ALL THE THINGS!
        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
        if ($uses && languagesToReload.indexOf($uses) === -1) {
          languagesToReload.push($uses);
        }
        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

      } else if ($translationTable[langKey]) {
        //just refresh the specified language cache
        loadNewData(langKey).then(deferred.resolve, deferred.reject);

      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#instant
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a translation instantly from the internal state of loaded translation. All rules
     * regarding the current language, the preferred language of even fallback languages will be
     * used except any promise handling. If a language was not found, an asynchronous loading
     * will be invoked in the background.
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function's promise returns an object where
     *                                     each key is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] Params
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     *
     * @return {string|object} translation
     */
    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

      // we don't want to re-negotiate $uses
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Detect undefined and null values to shorten the execution and prevent exceptions
      if (translationId === null || angular.isUndefined(translationId)) {
        return translationId;
      }

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        var results = {};
        for (var i = 0, c = translationId.length; i < c; i++) {
          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
        }
        return results;
      }

      // We discarded unacceptable values. So we just need to verify if translationId is empty String
      if (angular.isString(translationId) && translationId.length < 1) {
        return translationId;
      }

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var result, possibleLangKeys = [];
      if ($preferredLanguage) {
        possibleLangKeys.push($preferredLanguage);
      }
      if (uses) {
        possibleLangKeys.push(uses);
      }
      if ($fallbackLanguage && $fallbackLanguage.length) {
        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
      }
      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
        var possibleLangKey = possibleLangKeys[j];
        if ($translationTable[possibleLangKey]) {
          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
          }
        }
        if (typeof result !== 'undefined') {
          break;
        }
      }

      if (!result && result !== '') {
        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
          result = applyNotFoundIndicators(translationId);
        } else {
          // Return translation of default interpolator if not found anything.
          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          var missingTranslationHandlerTranslation;
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
          }

          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            result = missingTranslationHandlerTranslation;
          }
        }
      }

      return result;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#versionInfo
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the current version information for the angular-translate library
     *
     * @return {string} angular-translate version
     */
    $translate.versionInfo = function () {
      return version;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#loaderCache
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the defined loaderCache.
     *
     * @return {boolean|string|object} current value of loaderCache
     */
    $translate.loaderCache = function () {
      return loaderCache;
    };

    // internal purpose only
    $translate.directivePriority = function () {
      return directivePriority;
    };

    // internal purpose only
    $translate.statefulFilter = function () {
      return statefulFilter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
     *
     * @return {boolean} current value of ready
     */
    $translate.isReady = function () {
      return $isReady;
    };

    var $onReadyDeferred = $q.defer();
    $onReadyDeferred.promise.then(function () {
      $isReady = true;
    });

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#onReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
     *
     * @param {Function=} fn Function to invoke when service is ready
     * @return {object} Promise resolved when service is ready
     */
    $translate.onReady = function (fn) {
      var deferred = $q.defer();
      if (angular.isFunction(fn)) {
        deferred.promise.then(fn);
      }
      if ($isReady) {
        deferred.resolve();
      } else {
        $onReadyDeferred.promise.then(deferred.resolve);
      }
      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This function simply returns the registered language keys being defined before in the config phase
     * With this, an application can use the array to provide a language selection dropdown or similar
     * without any additional effort
     *
     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
     */
    $translate.getAvailableLanguageKeys = function () {
      if ($availableLanguageKeys.length > 0) {
        return $availableLanguageKeys;
      }
      return null;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getTranslationTable
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns translation table by the given language key.
     *
     * Unless a language is provided it returns a translation table of the current one.
     * Note: If translation dictionary is currently downloading or in progress
     * it will return null.
     *
     * @param {string} langKey A token which represents a translation id
     *
     * @return {object} a copy of angular-translate $translationTable
     */
    $translate.getTranslationTable = function (langKey) {
      langKey = langKey || $translate.use();
      if (langKey && $translationTable[langKey]) {
        return angular.copy($translationTable[langKey]);
      }
      return null;
    };

    // Whenever $translateReady is being fired, this will ensure the state of $isReady
    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
      $onReadyDeferred.resolve();
      globalOnReadyListener(); // one time only
      globalOnReadyListener = null;
    });
    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
      $onReadyDeferred.resolve();
      globalOnChangeListener(); // one time only
      globalOnChangeListener = null;
    });

    if ($loaderFactory) {

      // If at least one async loader is defined and there are no
      // (default) translations available we should try to load them.
      if (angular.equals($translationTable, {})) {
        if ($translate.use()) {
          $translate.use($translate.use());
        }
      }

      // Also, if there are any fallback language registered, we start
      // loading them asynchronously as soon as we can.
      if ($fallbackLanguage && $fallbackLanguage.length) {
        var processAsyncResult = function (translation) {
          translations(translation.key, translation.table);
          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
          return translation;
        };
        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
          var fallbackLanguageId = $fallbackLanguage[i];
          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
          }
        }
      }
    } else {
      $rootScope.$emit('$translateReady', {language : $translate.use()});
    }

    return $translate;
  }];
}

$translate.displayName = 'displayName';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */
angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

  'use strict';

  var $translateInterpolator = {},
      $locale,
      $identifier = 'default';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $locale = locale;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given value agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
   *
   * @param {string} value translation
   * @param {object} [interpolationParams={}] interpolation params
   * @param {string} [context=undefined] current context (filter, directive, service)
   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
   * @param {string} translationId current translationId
   *
   * @returns {string} interpolated string
   */
  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

    var interpolatedText;
    if (angular.isNumber(value)) {
      // numbers are safe
      interpolatedText = '' + value;
    } else if (angular.isString(value)) {
      // strings must be interpolated (that's the job here)
      interpolatedText = $interpolate(value)(interpolationParams);
      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
    } else {
      // neither a number or a string, cant interpolate => empty string
      interpolatedText = '';
    }

    return interpolatedText;
  };

  return $translateInterpolator;
}

$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $interpolate,
 * @requires $compile,
 * @requires $parse,
 * @requires $rootScope
 * @restrict AE
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses $translate service to translate the translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
    </file>
   </example>
 */
.directive('translate', translateDirective);
function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

  'use strict';

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  return {
    restrict: 'AE',
    scope: true,
    priority: $translate.directivePriority(),
    compile: function (tElement, tAttr) {

      var translateValuesExist = (tAttr.translateValues) ?
        tAttr.translateValues : undefined;

      var translateInterpolation = (tAttr.translateInterpolation) ?
        tAttr.translateInterpolation : undefined;

      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
        tAttr.translateSanitizeStrategy : undefined;

      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

      return function linkFn(scope, iElement, iAttr) {

        scope.interpolateParams = {};
        scope.preText = '';
        scope.postText = '';
        scope.translateNamespace = getTranslateNamespace(scope);
        var translationIds = {};

        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
          // initial setup
          if (iAttr.translateValues) {
            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
          }
          // initially fetch all attributes if existing and fill the params
          if (translateValueExist) {
            for (var attr in tAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                interpolateParams[attributeName] = tAttr[attr];
              }
            }
          }
        };

        // Ensures any change of the attribute "translate" containing the id will
        // be re-stored to the scope's "translationId".
        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
        var observeElementTranslation = function (translationId) {

          // Remove any old watcher
          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
            observeElementTranslation._unwatchOld();
            observeElementTranslation._unwatchOld = undefined;
          }

          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');

            // Resolve translation id by inner html if required
            var interpolateMatches = iElementText.match(interpolateRegExp);
            // Interpolate translation id if required
            if (angular.isArray(interpolateMatches)) {
              scope.preText = interpolateMatches[1];
              scope.postText = interpolateMatches[3];
              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
              var watcherMatches = iElementText.match(watcherRegExp);
              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                  translationIds.translate = newValue;
                  updateTranslations();
                });
              }
            } else {
              // do not assigne the translation id if it is empty.
              translationIds.translate = !iElementText ? undefined : iElementText;
            }
          } else {
            translationIds.translate = translationId;
          }
          updateTranslations();
        };

        var observeAttributeTranslation = function (translateAttr) {
          iAttr.$observe(translateAttr, function (translationId) {
            translationIds[translateAttr] = translationId;
            updateTranslations();
          });
        };

        // initial setup with values
        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

        var firstAttributeChangedEvent = true;
        iAttr.$observe('translate', function (translationId) {
          if (typeof translationId === 'undefined') {
            // case of element "<translate>xyz</translate>"
            observeElementTranslation('');
          } else {
            // case of regular attribute
            if (translationId !== '' || !firstAttributeChangedEvent) {
              translationIds.translate = translationId;
              updateTranslations();
            }
          }
          firstAttributeChangedEvent = false;
        });

        for (var translateAttr in iAttr) {
          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
            observeAttributeTranslation(translateAttr);
          }
        }

        iAttr.$observe('translateDefault', function (value) {
          scope.defaultText = value;
          updateTranslations();
        });

        if (translateSanitizeStrategyExist) {
          iAttr.$observe('translateSanitizeStrategy', function (value) {
            scope.sanitizeStrategy = $parse(value)(scope.$parent);
            updateTranslations();
          });
        }

        if (translateValuesExist) {
          iAttr.$observe('translateValues', function (interpolateParams) {
            if (interpolateParams) {
              scope.$parent.$watch(function () {
                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
              });
            }
          });
        }

        if (translateValueExist) {
          var observeValueAttribute = function (attrName) {
            iAttr.$observe(attrName, function (value) {
              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
              scope.interpolateParams[attributeName] = value;
            });
          };
          for (var attr in iAttr) {
            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
              observeValueAttribute(attr);
            }
          }
        }

        // Master update function
        var updateTranslations = function () {
          for (var key in translationIds) {
            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
            }
          }
        };

        // Put translation processing function outside loop
        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
          if (translationId) {
            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (translateNamespace && translationId.charAt(0) === '.') {
              translationId = translateNamespace + translationId;
            }

            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
              .then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
          } else {
            // as an empty string cannot be translated, we can solve this using successful=false
            applyTranslation(translationId, scope, false, translateAttr);
          }
        };

        var applyTranslation = function (value, scope, successful, translateAttr) {
          if (!successful) {
            if (typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
          }
          if (translateAttr === 'translate') {
            // default translate into innerHTML
            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
              iElement.empty().append(scope.preText + value + scope.postText);
            }
            var globallyEnabled = $translate.isPostCompilingEnabled();
            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
              $compile(iElement.contents())(scope);
            }
          } else {
            // translate attribute
            var attributeName = iAttr.$attr[translateAttr];
            if (attributeName.substr(0, 5) === 'data-') {
              // ensure html5 data prefix is stripped
              attributeName = attributeName.substr(5);
            }
            attributeName = attributeName.substr(15);
            iElement.attr(attributeName, value);
          }
        };

        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
          scope.$watch('interpolateParams', updateTranslations, true);
        }

        // Replaced watcher on translateLanguage with event listener
        scope.$on('translateLanguageChanged', updateTranslations);

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        // ensure translation will be looked up at least one
        if (iElement.text().length) {
          if (iAttr.translate) {
            observeElementTranslation(iAttr.translate);
          } else {
            observeElementTranslation('');
          }
        } else if (iAttr.translate) {
          // ensure attribute will be not skipped
          observeElementTranslation(iAttr.translate);
        }
        updateTranslations();
        scope.$on('$destroy', unbind);
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateDirective.displayName = 'translateDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate-attr
 * @restrict A
 *
 * @description
 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
 * Internally it uses `translate` service to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
    </file>
   </example>
 */
.directive('translateAttr', translateAttrDirective);
function translateAttrDirective($translate, $rootScope) {

  'use strict';

  return {
    restrict: 'A',
    priority: $translate.directivePriority(),
    link: function linkFn(scope, element, attr) {

      var translateAttr,
          translateValues,
          translateSanitizeStrategy,
          previousAttributes = {};

      // Main update translations function
      var updateTranslations = function () {
        angular.forEach(translateAttr, function (translationId, attributeName) {
          if (!translationId) {
            return;
          }
          previousAttributes[attributeName] = true;

          // if translation id starts with '.' and translateNamespace given, prepend namespace
          if (scope.translateNamespace && translationId.charAt(0) === '.') {
            translationId = scope.translateNamespace + translationId;
          }
          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
            .then(function (translation) {
              element.attr(attributeName, translation);
            }, function (translationId) {
              element.attr(attributeName, translationId);
            });
        });

        // Removing unused attributes that were previously used
        angular.forEach(previousAttributes, function (flag, attributeName) {
          if (!translateAttr[attributeName]) {
            element.removeAttr(attributeName);
            delete previousAttributes[attributeName];
          }
        });
      };

      // Watch for attribute changes
      watchAttribute(
        scope,
        attr.translateAttr,
        function (newValue) { translateAttr = newValue; },
        updateTranslations
      );
      // Watch for value changes
      watchAttribute(
        scope,
        attr.translateValues,
        function (newValue) { translateValues = newValue; },
        updateTranslations
      );
      // Watch for sanitize strategy changes
      watchAttribute(
        scope,
        attr.translateSanitizeStrategy,
        function (newValue) { translateSanitizeStrategy = newValue; },
        updateTranslations
      );

      if (attr.translateValues) {
        scope.$watch(attr.translateValues, updateTranslations, true);
      }

      // Replaced watcher on translateLanguage with event listener
      scope.$on('translateLanguageChanged', updateTranslations);

      // Ensures the text will be refreshed after the current language was changed
      // w/ $translate.use(...)
      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

      updateTranslations();
      scope.$on('$destroy', unbind);
    }
  };
}

function watchAttribute(scope, attribute, valueCallback, changeCallback) {
  'use strict';
  if (!attribute) {
    return;
  }
  if (attribute.substr(0, 2) === '::') {
    attribute = attribute.substr(2);
  } else {
    scope.$watch(attribute, function(newValue) {
      valueCallback(newValue);
      changeCallback();
    }, true);
  }
  valueCallback(scope.$eval(attribute));
}

translateAttrDirective.displayName = 'translateAttrDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */
.directive('translateCloak', translateCloakDirective);

function translateCloakDirective($translate, $rootScope) {

  'use strict';

  return {
    compile : function (tElement) {
      var applyCloak = function (element) {
          element.addClass($translate.cloakClassName());
        },
        removeCloak = function (element) {
          element.removeClass($translate.cloakClassName());
        };
      applyCloak(tElement);

      return function linkFn(scope, iElement, iAttr) {
        //Create bound functions that incorporate the active DOM element.
        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
        if (iAttr.translateCloak && iAttr.translateCloak.length) {
          // Register a watcher for the defined translation allowing a fine tuned cloak
          iAttr.$observe('translateCloak', function (translationId) {
            $translate(translationId).then(iRemoveCloak, iApplyCloak);
          });
          $rootScope.$on('$translateChangeSuccess', function () {
            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
          });
        } else {
          $translate.onReady(iRemoveCloak);
        }
      };
    }
  };
}

translateCloakDirective.displayName = 'translateCloakDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It is possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateNamespace', translateNamespaceDirective);

function translateNamespaceDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function (scope, iElement, iAttrs) {
          scope.translateNamespace = _getTranslateNamespace(scope);

          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
            scope.translateNamespace += iAttrs.translateNamespace;
          } else {
            scope.translateNamespace = iAttrs.translateNamespace;
          }
        }
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function _getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return _getTranslateNamespace(scope.$parent);
  }
}

translateNamespaceDirective.displayName = 'translateNamespaceDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateLanguage
 * @restrict A
 *
 * @description
 * Forces the language to the directives in the underlying scope.
 *
 * @param {string=} translate language that will be negotiated.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div>

        <div>
            <h1 translate>HELLO</h1>
        </div>

        <div translate-language="de">
            <h1 translate>HELLO</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateLanguage', translateLanguageDirective);

function translateLanguageDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return function linkFn(scope, iElement, iAttrs) {

        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
          scope.translateLanguage = newTranslateLanguage;
        });

        scope.$watch('translateLanguage', function(){
          scope.$broadcast('translateLanguageChanged');
        });
      };
    }
  };
}

translateLanguageDirective.displayName = 'translateLanguageDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */
.filter('translate', translateFilterFactory);

function translateFilterFactory($parse, $translate) {

  'use strict';

  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
    if (!angular.isObject(interpolateParams)) {
      var ctx = this || {
        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
        };
      interpolateParams = $parse(interpolateParams)(ctx);
    }

    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
  };

  if ($translate.statefulFilter()) {
    translateFilter.$stateful = true;
  }

  return translateFilter;
}

translateFilterFactory.displayName = 'translateFilterFactory';

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */
  .factory('$translationCache', $translationCache);

function $translationCache($cacheFactory) {

  'use strict';

  return $cacheFactory('translations');
}

$translationCache.displayName = '$translationCache';
return 'pascalprecht.translate';

}));

/*!
 * angular-translate - v2.19.1 - 2024-01-21
 * 
 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateStaticFilesLoader.$inject = ['$q', '$http'];
angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateStaticFilesLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical static file url pattern:
 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
 * the response of these urls must be an object of key-value pairs.
 *
 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
 */
.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);

function $translateStaticFilesLoader($q, $http) {

  'use strict';

  return function (options) {

    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix
      }];
    }

    var load = function (file) {
      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      var fileUrl = [
        file.prefix,
        options.key,
        file.suffix
      ].join('');

      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
        fileUrl = options.fileMap[fileUrl];
      }

      return $http(angular.extend({
        url: fileUrl,
        method: 'GET'
      }, options.$http))
        .then(function(result) {
          return result.data;
        }, function () {
          return $q.reject(options.key);
        });
    };

    var promises = [],
        length = options.files.length;

    for (var i = 0; i < length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix
      }));
    }

    return $q.all(promises)
      .then(function (data) {
        var length = data.length,
            mergedData = {};

        for (var i = 0; i < length; i++) {
          for (var key in data[i]) {
            mergedData[key] = data[i][key];
          }
        }

        return mergedData;
      });
  };
}

$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
return 'pascalprecht.translate';

}));

/*!
 * angular-translate - v2.19.1 - 2024-01-21
 * 
 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateCookieStorageFactory.$inject = ['$injector'];
angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateCookieStorage
 * @requires $cookieStore
 *
 * @description
 * Abstraction layer for cookieStore. This service is used when telling angular-translate
 * to use cookieStore as storage.
 *
 */
  .factory('$translateCookieStorage', $translateCookieStorageFactory);

function $translateCookieStorageFactory($injector) {

  'use strict';

  // Since AngularJS 1.4, $cookieStore is deprecated
  var delegate;
  if (angular.version.major === 1 && angular.version.minor >= 4) {
    var $cookies = $injector.get('$cookies');
    delegate = {
      get : function (key) {
        return $cookies.get(key);
      },
      put : function (key, value) {
        $cookies.put(key, value, { samesite: 'lax' });
      }
    };
  } else {
    var $cookieStore = $injector.get('$cookieStore');
    delegate = {
      get : function (key) {
        return $cookieStore.get(key);
      },
      put : function (key, value) {
        $cookieStore.put(key, value);
      }
    };
  }

  var $translateCookieStorage = {

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#get
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Returns an item from cookieStorage by given name.
     *
     * @param {string} name Item name
     * @return {string} Value of item name
     */
    get : function (name) {
      return delegate.get(name);
    },

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#set
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Sets an item in cookieStorage by given name.
     *
     * @deprecated use #put
     *
     * @param {string} name Item name
     * @param {string} value Item value
     */
    set : function (name, value) {
      delegate.put(name, value);
    },

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#put
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Sets an item in cookieStorage by given name.
     *
     * @param {string} name Item name
     * @param {string} value Item value
     */
    put : function (name, value) {
      delegate.put(name, value);
    }
  };

  return $translateCookieStorage;
}

$translateCookieStorageFactory.displayName = '$translateCookieStorage';
return 'pascalprecht.translate';

}));

/**
 * State-based routing for AngularJS
 * @version v0.2.18
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="ui.router"),function(a,b,c){"use strict";function d(a,b){return R(new(R(function(){},{prototype:a})),b)}function e(a){return Q(arguments,function(b){b!==a&&Q(b,function(b,c){a.hasOwnProperty(c)||(a[c]=b)})}),a}function f(a,b){var c=[];for(var d in a.path){if(a.path[d]!==b.path[d])break;c.push(a.path[d])}return c}function g(a){if(Object.keys)return Object.keys(a);var b=[];return Q(a,function(a,c){b.push(c)}),b}function h(a,b){if(Array.prototype.indexOf)return a.indexOf(b,Number(arguments[2])||0);var c=a.length>>>0,d=Number(arguments[2])||0;for(d=0>d?Math.ceil(d):Math.floor(d),0>d&&(d+=c);c>d;d++)if(d in a&&a[d]===b)return d;return-1}function i(a,b,c,d){var e,i=f(c,d),j={},k=[];for(var l in i)if(i[l]&&i[l].params&&(e=g(i[l].params),e.length))for(var m in e)h(k,e[m])>=0||(k.push(e[m]),j[e[m]]=a[e[m]]);return R({},j,b)}function j(a,b,c){if(!c){c=[];for(var d in a)c.push(d)}for(var e=0;e<c.length;e++){var f=c[e];if(a[f]!=b[f])return!1}return!0}function k(a,b){var c={};return Q(a,function(a){c[a]=b[a]}),c}function l(a){var b={},c=Array.prototype.concat.apply(Array.prototype,Array.prototype.slice.call(arguments,1));return Q(c,function(c){c in a&&(b[c]=a[c])}),b}function m(a){var b={},c=Array.prototype.concat.apply(Array.prototype,Array.prototype.slice.call(arguments,1));for(var d in a)-1==h(c,d)&&(b[d]=a[d]);return b}function n(a,b){var c=P(a),d=c?[]:{};return Q(a,function(a,e){b(a,e)&&(d[c?d.length:e]=a)}),d}function o(a,b){var c=P(a)?[]:{};return Q(a,function(a,d){c[d]=b(a,d)}),c}function p(a,b){var d=1,f=2,i={},j=[],k=i,l=R(a.when(i),{$$promises:i,$$values:i});this.study=function(i){function n(a,c){if(s[c]!==f){if(r.push(c),s[c]===d)throw r.splice(0,h(r,c)),new Error("Cyclic dependency: "+r.join(" -> "));if(s[c]=d,N(a))q.push(c,[function(){return b.get(a)}],j);else{var e=b.annotate(a);Q(e,function(a){a!==c&&i.hasOwnProperty(a)&&n(i[a],a)}),q.push(c,a,e)}r.pop(),s[c]=f}}function o(a){return O(a)&&a.then&&a.$$promises}if(!O(i))throw new Error("'invocables' must be an object");var p=g(i||{}),q=[],r=[],s={};return Q(i,n),i=r=s=null,function(d,f,g){function h(){--u||(v||e(t,f.$$values),r.$$values=t,r.$$promises=r.$$promises||!0,delete r.$$inheritedValues,n.resolve(t))}function i(a){r.$$failure=a,n.reject(a)}function j(c,e,f){function j(a){l.reject(a),i(a)}function k(){if(!L(r.$$failure))try{l.resolve(b.invoke(e,g,t)),l.promise.then(function(a){t[c]=a,h()},j)}catch(a){j(a)}}var l=a.defer(),m=0;Q(f,function(a){s.hasOwnProperty(a)&&!d.hasOwnProperty(a)&&(m++,s[a].then(function(b){t[a]=b,--m||k()},j))}),m||k(),s[c]=l.promise}if(o(d)&&g===c&&(g=f,f=d,d=null),d){if(!O(d))throw new Error("'locals' must be an object")}else d=k;if(f){if(!o(f))throw new Error("'parent' must be a promise returned by $resolve.resolve()")}else f=l;var n=a.defer(),r=n.promise,s=r.$$promises={},t=R({},d),u=1+q.length/3,v=!1;if(L(f.$$failure))return i(f.$$failure),r;f.$$inheritedValues&&e(t,m(f.$$inheritedValues,p)),R(s,f.$$promises),f.$$values?(v=e(t,m(f.$$values,p)),r.$$inheritedValues=m(f.$$values,p),h()):(f.$$inheritedValues&&(r.$$inheritedValues=m(f.$$inheritedValues,p)),f.then(h,i));for(var w=0,x=q.length;x>w;w+=3)d.hasOwnProperty(q[w])?h():j(q[w],q[w+1],q[w+2]);return r}},this.resolve=function(a,b,c,d){return this.study(a)(b,c,d)}}function q(a,b,c){this.fromConfig=function(a,b,c){return L(a.template)?this.fromString(a.template,b):L(a.templateUrl)?this.fromUrl(a.templateUrl,b):L(a.templateProvider)?this.fromProvider(a.templateProvider,b,c):null},this.fromString=function(a,b){return M(a)?a(b):a},this.fromUrl=function(c,d){return M(c)&&(c=c(d)),null==c?null:a.get(c,{cache:b,headers:{Accept:"text/html"}}).then(function(a){return a.data})},this.fromProvider=function(a,b,d){return c.invoke(a,null,d||{params:b})}}function r(a,b,e){function f(b,c,d,e){if(q.push(b),o[b])return o[b];if(!/^\w+([-.]+\w+)*(?:\[\])?$/.test(b))throw new Error("Invalid parameter name '"+b+"' in pattern '"+a+"'");if(p[b])throw new Error("Duplicate parameter name '"+b+"' in pattern '"+a+"'");return p[b]=new U.Param(b,c,d,e),p[b]}function g(a,b,c,d){var e=["",""],f=a.replace(/[\\\[\]\^$*+?.()|{}]/g,"\\$&");if(!b)return f;switch(c){case!1:e=["(",")"+(d?"?":"")];break;case!0:f=f.replace(/\/$/,""),e=["(?:/(",")|/)?"];break;default:e=["("+c+"|",")?"]}return f+e[0]+b+e[1]}function h(e,f){var g,h,i,j,k;return g=e[2]||e[3],k=b.params[g],i=a.substring(m,e.index),h=f?e[4]:e[4]||("*"==e[1]?".*":null),h&&(j=U.type(h)||d(U.type("string"),{pattern:new RegExp(h,b.caseInsensitive?"i":c)})),{id:g,regexp:h,segment:i,type:j,cfg:k}}b=R({params:{}},O(b)?b:{});var i,j=/([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,k=/([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,l="^",m=0,n=this.segments=[],o=e?e.params:{},p=this.params=e?e.params.$$new():new U.ParamSet,q=[];this.source=a;for(var r,s,t;(i=j.exec(a))&&(r=h(i,!1),!(r.segment.indexOf("?")>=0));)s=f(r.id,r.type,r.cfg,"path"),l+=g(r.segment,s.type.pattern.source,s.squash,s.isOptional),n.push(r.segment),m=j.lastIndex;t=a.substring(m);var u=t.indexOf("?");if(u>=0){var v=this.sourceSearch=t.substring(u);if(t=t.substring(0,u),this.sourcePath=a.substring(0,m+u),v.length>0)for(m=0;i=k.exec(v);)r=h(i,!0),s=f(r.id,r.type,r.cfg,"search"),m=j.lastIndex}else this.sourcePath=a,this.sourceSearch="";l+=g(t)+(b.strict===!1?"/?":"")+"$",n.push(t),this.regexp=new RegExp(l,b.caseInsensitive?"i":c),this.prefix=n[0],this.$$paramNames=q}function s(a){R(this,a)}function t(){function a(a){return null!=a?a.toString().replace(/~/g,"~~").replace(/\//g,"~2F"):a}function e(a){return null!=a?a.toString().replace(/~2F/g,"/").replace(/~~/g,"~"):a}function f(){return{strict:p,caseInsensitive:m}}function i(a){return M(a)||P(a)&&M(a[a.length-1])}function j(){for(;w.length;){var a=w.shift();if(a.pattern)throw new Error("You cannot override a type's .pattern at runtime.");b.extend(u[a.name],l.invoke(a.def))}}function k(a){R(this,a||{})}U=this;var l,m=!1,p=!0,q=!1,u={},v=!0,w=[],x={string:{encode:a,decode:e,is:function(a){return null==a||!L(a)||"string"==typeof a},pattern:/[^\/]*/},"int":{encode:a,decode:function(a){return parseInt(a,10)},is:function(a){return L(a)&&this.decode(a.toString())===a},pattern:/\d+/},bool:{encode:function(a){return a?1:0},decode:function(a){return 0!==parseInt(a,10)},is:function(a){return a===!0||a===!1},pattern:/0|1/},date:{encode:function(a){return this.is(a)?[a.getFullYear(),("0"+(a.getMonth()+1)).slice(-2),("0"+a.getDate()).slice(-2)].join("-"):c},decode:function(a){if(this.is(a))return a;var b=this.capture.exec(a);return b?new Date(b[1],b[2]-1,b[3]):c},is:function(a){return a instanceof Date&&!isNaN(a.valueOf())},equals:function(a,b){return this.is(a)&&this.is(b)&&a.toISOString()===b.toISOString()},pattern:/[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,capture:/([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/},json:{encode:b.toJson,decode:b.fromJson,is:b.isObject,equals:b.equals,pattern:/[^\/]*/},any:{encode:b.identity,decode:b.identity,equals:b.equals,pattern:/.*/}};t.$$getDefaultValue=function(a){if(!i(a.value))return a.value;if(!l)throw new Error("Injectable functions cannot be called at configuration time");return l.invoke(a.value)},this.caseInsensitive=function(a){return L(a)&&(m=a),m},this.strictMode=function(a){return L(a)&&(p=a),p},this.defaultSquashPolicy=function(a){if(!L(a))return q;if(a!==!0&&a!==!1&&!N(a))throw new Error("Invalid squash policy: "+a+". Valid policies: false, true, arbitrary-string");return q=a,a},this.compile=function(a,b){return new r(a,R(f(),b))},this.isMatcher=function(a){if(!O(a))return!1;var b=!0;return Q(r.prototype,function(c,d){M(c)&&(b=b&&L(a[d])&&M(a[d]))}),b},this.type=function(a,b,c){if(!L(b))return u[a];if(u.hasOwnProperty(a))throw new Error("A type named '"+a+"' has already been defined.");return u[a]=new s(R({name:a},b)),c&&(w.push({name:a,def:c}),v||j()),this},Q(x,function(a,b){u[b]=new s(R({name:b},a))}),u=d(u,{}),this.$get=["$injector",function(a){return l=a,v=!1,j(),Q(x,function(a,b){u[b]||(u[b]=new s(a))}),this}],this.Param=function(a,d,e,f){function j(a){var b=O(a)?g(a):[],c=-1===h(b,"value")&&-1===h(b,"type")&&-1===h(b,"squash")&&-1===h(b,"array");return c&&(a={value:a}),a.$$fn=i(a.value)?a.value:function(){return a.value},a}function k(c,d,e){if(c.type&&d)throw new Error("Param '"+a+"' has two type configurations.");return d?d:c.type?b.isString(c.type)?u[c.type]:c.type instanceof s?c.type:new s(c.type):"config"===e?u.any:u.string}function m(){var b={array:"search"===f?"auto":!1},c=a.match(/\[\]$/)?{array:!0}:{};return R(b,c,e).array}function p(a,b){var c=a.squash;if(!b||c===!1)return!1;if(!L(c)||null==c)return q;if(c===!0||N(c))return c;throw new Error("Invalid squash policy: '"+c+"'. Valid policies: false, true, or arbitrary string")}function r(a,b,d,e){var f,g,i=[{from:"",to:d||b?c:""},{from:null,to:d||b?c:""}];return f=P(a.replace)?a.replace:[],N(e)&&f.push({from:e,to:c}),g=o(f,function(a){return a.from}),n(i,function(a){return-1===h(g,a.from)}).concat(f)}function t(){if(!l)throw new Error("Injectable functions cannot be called at configuration time");var a=l.invoke(e.$$fn);if(null!==a&&a!==c&&!x.type.is(a))throw new Error("Default value ("+a+") for parameter '"+x.id+"' is not an instance of Type ("+x.type.name+")");return a}function v(a){function b(a){return function(b){return b.from===a}}function c(a){var c=o(n(x.replace,b(a)),function(a){return a.to});return c.length?c[0]:a}return a=c(a),L(a)?x.type.$normalize(a):t()}function w(){return"{Param:"+a+" "+d+" squash: '"+A+"' optional: "+z+"}"}var x=this;e=j(e),d=k(e,d,f);var y=m();d=y?d.$asArray(y,"search"===f):d,"string"!==d.name||y||"path"!==f||e.value!==c||(e.value="");var z=e.value!==c,A=p(e,z),B=r(e,y,z,A);R(this,{id:a,type:d,location:f,array:y,squash:A,replace:B,isOptional:z,value:v,dynamic:c,config:e,toString:w})},k.prototype={$$new:function(){return d(this,R(new k,{$$parent:this}))},$$keys:function(){for(var a=[],b=[],c=this,d=g(k.prototype);c;)b.push(c),c=c.$$parent;return b.reverse(),Q(b,function(b){Q(g(b),function(b){-1===h(a,b)&&-1===h(d,b)&&a.push(b)})}),a},$$values:function(a){var b={},c=this;return Q(c.$$keys(),function(d){b[d]=c[d].value(a&&a[d])}),b},$$equals:function(a,b){var c=!0,d=this;return Q(d.$$keys(),function(e){var f=a&&a[e],g=b&&b[e];d[e].type.equals(f,g)||(c=!1)}),c},$$validates:function(a){var d,e,f,g,h,i=this.$$keys();for(d=0;d<i.length&&(e=this[i[d]],f=a[i[d]],f!==c&&null!==f||!e.isOptional);d++){if(g=e.type.$normalize(f),!e.type.is(g))return!1;if(h=e.type.encode(g),b.isString(h)&&!e.type.pattern.exec(h))return!1}return!0},$$parent:c},this.ParamSet=k}function u(a,d){function e(a){var b=/^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(a.source);return null!=b?b[1].replace(/\\(.)/g,"$1"):""}function f(a,b){return a.replace(/\$(\$|\d{1,2})/,function(a,c){return b["$"===c?0:Number(c)]})}function g(a,b,c){if(!c)return!1;var d=a.invoke(b,b,{$match:c});return L(d)?d:!0}function h(d,e,f,g,h){function m(a,b,c){return"/"===q?a:b?q.slice(0,-1)+a:c?q.slice(1)+a:a}function n(a){function b(a){var b=a(f,d);return b?(N(b)&&d.replace().url(b),!0):!1}if(!a||!a.defaultPrevented){p&&d.url()===p;p=c;var e,g=j.length;for(e=0;g>e;e++)if(b(j[e]))return;k&&b(k)}}function o(){return i=i||e.$on("$locationChangeSuccess",n)}var p,q=g.baseHref(),r=d.url();return l||o(),{sync:function(){n()},listen:function(){return o()},update:function(a){return a?void(r=d.url()):void(d.url()!==r&&(d.url(r),d.replace()))},push:function(a,b,e){var f=a.format(b||{});null!==f&&b&&b["#"]&&(f+="#"+b["#"]),d.url(f),p=e&&e.$$avoidResync?d.url():c,e&&e.replace&&d.replace()},href:function(c,e,f){if(!c.validates(e))return null;var g=a.html5Mode();b.isObject(g)&&(g=g.enabled),g=g&&h.history;var i=c.format(e);if(f=f||{},g||null===i||(i="#"+a.hashPrefix()+i),null!==i&&e&&e["#"]&&(i+="#"+e["#"]),i=m(i,g,f.absolute),!f.absolute||!i)return i;var j=!g&&i?"/":"",k=d.port();return k=80===k||443===k?"":":"+k,[d.protocol(),"://",d.host(),k,j,i].join("")}}}var i,j=[],k=null,l=!1;this.rule=function(a){if(!M(a))throw new Error("'rule' must be a function");return j.push(a),this},this.otherwise=function(a){if(N(a)){var b=a;a=function(){return b}}else if(!M(a))throw new Error("'rule' must be a function");return k=a,this},this.when=function(a,b){var c,h=N(b);if(N(a)&&(a=d.compile(a)),!h&&!M(b)&&!P(b))throw new Error("invalid 'handler' in when()");var i={matcher:function(a,b){return h&&(c=d.compile(b),b=["$match",function(a){return c.format(a)}]),R(function(c,d){return g(c,b,a.exec(d.path(),d.search()))},{prefix:N(a.prefix)?a.prefix:""})},regex:function(a,b){if(a.global||a.sticky)throw new Error("when() RegExp must not be global or sticky");return h&&(c=b,b=["$match",function(a){return f(c,a)}]),R(function(c,d){return g(c,b,a.exec(d.path()))},{prefix:e(a)})}},j={matcher:d.isMatcher(a),regex:a instanceof RegExp};for(var k in j)if(j[k])return this.rule(i[k](a,b));throw new Error("invalid 'what' in when()")},this.deferIntercept=function(a){a===c&&(a=!0),l=a},this.$get=h,h.$inject=["$location","$rootScope","$injector","$browser","$sniffer"]}function v(a,e){function f(a){return 0===a.indexOf(".")||0===a.indexOf("^")}function m(a,b){if(!a)return c;var d=N(a),e=d?a:a.name,g=f(e);if(g){if(!b)throw new Error("No reference point given for path '"+e+"'");b=m(b);for(var h=e.split("."),i=0,j=h.length,k=b;j>i;i++)if(""!==h[i]||0!==i){if("^"!==h[i])break;if(!k.parent)throw new Error("Path '"+e+"' not valid for state '"+b.name+"'");k=k.parent}else k=b;h=h.slice(i).join("."),e=k.name+(k.name&&h?".":"")+h}var l=z[e];return!l||!d&&(d||l!==a&&l.self!==a)?c:l}function n(a,b){A[a]||(A[a]=[]),A[a].push(b)}function p(a){for(var b=A[a]||[];b.length;)q(b.shift())}function q(b){b=d(b,{self:b,resolve:b.resolve||{},toString:function(){return this.name}});var c=b.name;if(!N(c)||c.indexOf("@")>=0)throw new Error("State must have a valid name");if(z.hasOwnProperty(c))throw new Error("State '"+c+"' is already defined");var e=-1!==c.indexOf(".")?c.substring(0,c.lastIndexOf(".")):N(b.parent)?b.parent:O(b.parent)&&N(b.parent.name)?b.parent.name:"";if(e&&!z[e])return n(e,b.self);for(var f in C)M(C[f])&&(b[f]=C[f](b,C.$delegates[f]));return z[c]=b,!b[B]&&b.url&&a.when(b.url,["$match","$stateParams",function(a,c){y.$current.navigable==b&&j(a,c)||y.transitionTo(b,a,{inherit:!0,location:!1})}]),p(c),b}function r(a){return a.indexOf("*")>-1}function s(a){for(var b=a.split("."),c=y.$current.name.split("."),d=0,e=b.length;e>d;d++)"*"===b[d]&&(c[d]="*");return"**"===b[0]&&(c=c.slice(h(c,b[1])),c.unshift("**")),"**"===b[b.length-1]&&(c.splice(h(c,b[b.length-2])+1,Number.MAX_VALUE),c.push("**")),b.length!=c.length?!1:c.join("")===b.join("")}function t(a,b){return N(a)&&!L(b)?C[a]:M(b)&&N(a)?(C[a]&&!C.$delegates[a]&&(C.$delegates[a]=C[a]),C[a]=b,this):this}function u(a,b){return O(a)?b=a:b.name=a,q(b),this}function v(a,e,f,h,l,n,p,q,t){function u(b,c,d,f){var g=a.$broadcast("$stateNotFound",b,c,d);if(g.defaultPrevented)return p.update(),D;if(!g.retry)return null;if(f.$retry)return p.update(),E;var h=y.transition=e.when(g.retry);return h.then(function(){return h!==y.transition?A:(b.options.$retry=!0,y.transitionTo(b.to,b.toParams,b.options))},function(){return D}),p.update(),h}function v(a,c,d,g,i,j){function m(){var c=[];return Q(a.views,function(d,e){var g=d.resolve&&d.resolve!==a.resolve?d.resolve:{};g.$template=[function(){return f.load(e,{view:d,locals:i.globals,params:n,notify:j.notify})||""}],c.push(l.resolve(g,i.globals,i.resolve,a).then(function(c){if(M(d.controllerProvider)||P(d.controllerProvider)){var f=b.extend({},g,i.globals);c.$$controller=h.invoke(d.controllerProvider,null,f)}else c.$$controller=d.controller;c.$$state=a,c.$$controllerAs=d.controllerAs,i[e]=c}))}),e.all(c).then(function(){return i.globals})}var n=d?c:k(a.params.$$keys(),c),o={$stateParams:n};i.resolve=l.resolve(a.resolve,o,i.resolve,a);var p=[i.resolve.then(function(a){i.globals=a})];return g&&p.push(g),e.all(p).then(m).then(function(a){return i})}var A=e.reject(new Error("transition superseded")),C=e.reject(new Error("transition prevented")),D=e.reject(new Error("transition aborted")),E=e.reject(new Error("transition failed"));return x.locals={resolve:null,globals:{$stateParams:{}}},y={params:{},current:x.self,$current:x,transition:null},y.reload=function(a){return y.transitionTo(y.current,n,{reload:a||!0,inherit:!1,notify:!0})},y.go=function(a,b,c){return y.transitionTo(a,b,R({inherit:!0,relative:y.$current},c))},y.transitionTo=function(b,c,f){c=c||{},f=R({location:!0,inherit:!1,relative:null,notify:!0,reload:!1,$retry:!1},f||{});var g,j=y.$current,l=y.params,o=j.path,q=m(b,f.relative),r=c["#"];if(!L(q)){var s={to:b,toParams:c,options:f},t=u(s,j.self,l,f);if(t)return t;if(b=s.to,c=s.toParams,f=s.options,q=m(b,f.relative),!L(q)){if(!f.relative)throw new Error("No such state '"+b+"'");throw new Error("Could not resolve '"+b+"' from state '"+f.relative+"'")}}if(q[B])throw new Error("Cannot transition to abstract state '"+b+"'");if(f.inherit&&(c=i(n,c||{},y.$current,q)),!q.params.$$validates(c))return E;c=q.params.$$values(c),b=q;var z=b.path,D=0,F=z[D],G=x.locals,H=[];if(f.reload){if(N(f.reload)||O(f.reload)){if(O(f.reload)&&!f.reload.name)throw new Error("Invalid reload state object");var I=f.reload===!0?o[0]:m(f.reload);if(f.reload&&!I)throw new Error("No such reload state '"+(N(f.reload)?f.reload:f.reload.name)+"'");for(;F&&F===o[D]&&F!==I;)G=H[D]=F.locals,D++,F=z[D]}}else for(;F&&F===o[D]&&F.ownParams.$$equals(c,l);)G=H[D]=F.locals,D++,F=z[D];if(w(b,c,j,l,G,f))return r&&(c["#"]=r),y.params=c,S(y.params,n),S(k(b.params.$$keys(),n),b.locals.globals.$stateParams),f.location&&b.navigable&&b.navigable.url&&(p.push(b.navigable.url,c,{$$avoidResync:!0,replace:"replace"===f.location}),p.update(!0)),y.transition=null,e.when(y.current);if(c=k(b.params.$$keys(),c||{}),r&&(c["#"]=r),f.notify&&a.$broadcast("$stateChangeStart",b.self,c,j.self,l,f).defaultPrevented)return a.$broadcast("$stateChangeCancel",b.self,c,j.self,l),null==y.transition&&p.update(),C;for(var J=e.when(G),K=D;K<z.length;K++,F=z[K])G=H[K]=d(G),J=v(F,c,F===b,J,G,f);var M=y.transition=J.then(function(){var d,e,g;if(y.transition!==M)return A;for(d=o.length-1;d>=D;d--)g=o[d],g.self.onExit&&h.invoke(g.self.onExit,g.self,g.locals.globals),g.locals=null;for(d=D;d<z.length;d++)e=z[d],e.locals=H[d],e.self.onEnter&&h.invoke(e.self.onEnter,e.self,e.locals.globals);return y.transition!==M?A:(y.$current=b,y.current=b.self,y.params=c,S(y.params,n),y.transition=null,f.location&&b.navigable&&p.push(b.navigable.url,b.navigable.locals.globals.$stateParams,{$$avoidResync:!0,replace:"replace"===f.location}),f.notify&&a.$broadcast("$stateChangeSuccess",b.self,c,j.self,l),p.update(!0),y.current)},function(d){return y.transition!==M?A:(y.transition=null,g=a.$broadcast("$stateChangeError",b.self,c,j.self,l,d),g.defaultPrevented||p.update(),e.reject(d))});return M},y.is=function(a,b,d){d=R({relative:y.$current},d||{});var e=m(a,d.relative);return L(e)?y.$current!==e?!1:b?j(e.params.$$values(b),n):!0:c},y.includes=function(a,b,d){if(d=R({relative:y.$current},d||{}),N(a)&&r(a)){if(!s(a))return!1;a=y.$current.name}var e=m(a,d.relative);return L(e)?L(y.$current.includes[e.name])?b?j(e.params.$$values(b),n,g(b)):!0:!1:c},y.href=function(a,b,d){d=R({lossy:!0,inherit:!0,absolute:!1,relative:y.$current},d||{});var e=m(a,d.relative);if(!L(e))return null;d.inherit&&(b=i(n,b||{},y.$current,e));var f=e&&d.lossy?e.navigable:e;return f&&f.url!==c&&null!==f.url?p.href(f.url,k(e.params.$$keys().concat("#"),b||{}),{absolute:d.absolute}):null},y.get=function(a,b){if(0===arguments.length)return o(g(z),function(a){return z[a].self});var c=m(a,b||y.$current);return c&&c.self?c.self:null},y}function w(a,b,c,d,e,f){function g(a,b,c){function d(b){return"search"!=a.params[b].location}var e=a.params.$$keys().filter(d),f=l.apply({},[a.params].concat(e)),g=new U.ParamSet(f);return g.$$equals(b,c)}return!f.reload&&a===c&&(e===c.locals||a.self.reloadOnSearch===!1&&g(c,d,b))?!0:void 0}var x,y,z={},A={},B="abstract",C={parent:function(a){if(L(a.parent)&&a.parent)return m(a.parent);var b=/^(.+)\.[^.]+$/.exec(a.name);return b?m(b[1]):x},data:function(a){return a.parent&&a.parent.data&&(a.data=a.self.data=d(a.parent.data,a.data)),a.data},url:function(a){var b=a.url,c={params:a.params||{}};if(N(b))return"^"==b.charAt(0)?e.compile(b.substring(1),c):(a.parent.navigable||x).url.concat(b,c);if(!b||e.isMatcher(b))return b;throw new Error("Invalid url '"+b+"' in state '"+a+"'")},navigable:function(a){return a.url?a:a.parent?a.parent.navigable:null},ownParams:function(a){var b=a.url&&a.url.params||new U.ParamSet;return Q(a.params||{},function(a,c){b[c]||(b[c]=new U.Param(c,null,a,"config"))}),b},params:function(a){var b=l(a.ownParams,a.ownParams.$$keys());return a.parent&&a.parent.params?R(a.parent.params.$$new(),b):new U.ParamSet},views:function(a){var b={};return Q(L(a.views)?a.views:{"":a},function(c,d){d.indexOf("@")<0&&(d+="@"+a.parent.name),b[d]=c}),b},path:function(a){return a.parent?a.parent.path.concat(a):[]},includes:function(a){var b=a.parent?R({},a.parent.includes):{};return b[a.name]=!0,b},$delegates:{}};x=q({name:"",url:"^",views:null,"abstract":!0}),x.navigable=null,this.decorator=t,this.state=u,this.$get=v,v.$inject=["$rootScope","$q","$view","$injector","$resolve","$stateParams","$urlRouter","$location","$urlMatcherFactory"]}function w(){function a(a,b){return{load:function(a,c){var d,e={template:null,controller:null,view:null,locals:null,notify:!0,async:!0,params:{}};return c=R(e,c),c.view&&(d=b.fromConfig(c.view,c.params,c.locals)),d}}}this.$get=a,a.$inject=["$rootScope","$templateFactory"]}function x(){var a=!1;this.useAnchorScroll=function(){a=!0},this.$get=["$anchorScroll","$timeout",function(b,c){return a?b:function(a){return c(function(){a[0].scrollIntoView()},0,!1)}}]}function y(a,c,d,e){function f(){return c.has?function(a){return c.has(a)?c.get(a):null}:function(a){try{return c.get(a)}catch(b){return null}}}function g(a,c){function d(a){return 1===V&&W>=4?!!j.enabled(a):1===V&&W>=2?!!j.enabled():!!i}var e={enter:function(a,b,c){b.after(a),c()},leave:function(a,b){a.remove(),b()}};if(a.noanimation)return e;if(j)return{enter:function(a,c,f){d(a)?b.version.minor>2?j.enter(a,null,c).then(f):j.enter(a,null,c,f):e.enter(a,c,f)},leave:function(a,c){d(a)?b.version.minor>2?j.leave(a).then(c):j.leave(a,c):e.leave(a,c)}};if(i){var f=i&&i(c,a);return{enter:function(a,b,c){f.enter(a,null,b),c()},leave:function(a,b){f.leave(a),b()}}}return e}var h=f(),i=h("$animator"),j=h("$animate"),k={restrict:"ECA",terminal:!0,priority:400,transclude:"element",compile:function(c,f,h){return function(c,f,i){function j(){function a(){b&&b.remove(),c&&c.$destroy()}var b=l,c=n;c&&(c._willBeDestroyed=!0),m?(r.leave(m,function(){a(),l=null}),l=m):(a(),l=null),m=null,n=null}function k(g){var k,l=A(c,i,f,e),s=l&&a.$current&&a.$current.locals[l];if((g||s!==o)&&!c._willBeDestroyed){k=c.$new(),o=a.$current.locals[l],k.$emit("$viewContentLoading",l);var t=h(k,function(a){r.enter(a,f,function(){n&&n.$emit("$viewContentAnimationEnded"),(b.isDefined(q)&&!q||c.$eval(q))&&d(a)}),j()});m=t,n=k,n.$emit("$viewContentLoaded",l),n.$eval(p)}}var l,m,n,o,p=i.onload||"",q=i.autoscroll,r=g(i,c);c.$on("$stateChangeSuccess",function(){k(!1)}),k(!0)}}};return k}function z(a,b,c,d){return{restrict:"ECA",priority:-400,compile:function(e){var f=e.html();return function(e,g,h){var i=c.$current,j=A(e,h,g,d),k=i&&i.locals[j];if(k){g.data("$uiView",{name:j,state:k.$$state}),g.html(k.$template?k.$template:f);var l=a(g.contents());if(k.$$controller){k.$scope=e,k.$element=g;var m=b(k.$$controller,k);k.$$controllerAs&&(e[k.$$controllerAs]=m),g.data("$ngControllerController",m),g.children().data("$ngControllerController",m)}l(e)}}}}}function A(a,b,c,d){var e=d(b.uiView||b.name||"")(a),f=c.inheritedData("$uiView");return e.indexOf("@")>=0?e:e+"@"+(f?f.state.name:"")}function B(a,b){var c,d=a.match(/^\s*({[^}]*})\s*$/);if(d&&(a=b+"("+d[1]+")"),c=a.replace(/\n/g," ").match(/^([^(]+?)\s*(\((.*)\))?$/),!c||4!==c.length)throw new Error("Invalid state ref '"+a+"'");return{state:c[1],paramExpr:c[3]||null}}function C(a){var b=a.parent().inheritedData("$uiView");return b&&b.state&&b.state.name?b.state:void 0}function D(a){var b="[object SVGAnimatedString]"===Object.prototype.toString.call(a.prop("href")),c="FORM"===a[0].nodeName;return{attr:c?"action":b?"xlink:href":"href",isAnchor:"A"===a.prop("tagName").toUpperCase(),clickable:!c}}function E(a,b,c,d,e){return function(f){var g=f.which||f.button,h=e();if(!(g>1||f.ctrlKey||f.metaKey||f.shiftKey||a.attr("target"))){var i=c(function(){b.go(h.state,h.params,h.options)});f.preventDefault();var j=d.isAnchor&&!h.href?1:0;f.preventDefault=function(){j--<=0&&c.cancel(i)}}}}function F(a,b){return{relative:C(a)||b.$current,inherit:!0}}function G(a,c){return{restrict:"A",require:["?^uiSrefActive","?^uiSrefActiveEq"],link:function(d,e,f,g){var h=B(f.uiSref,a.current.name),i={state:h.state,href:null,params:null},j=D(e),k=g[1]||g[0];i.options=R(F(e,a),f.uiSrefOpts?d.$eval(f.uiSrefOpts):{});var l=function(c){c&&(i.params=b.copy(c)),i.href=a.href(h.state,i.params,i.options),k&&k.$$addStateInfo(h.state,i.params),null!==i.href&&f.$set(j.attr,i.href)};h.paramExpr&&(d.$watch(h.paramExpr,function(a){a!==i.params&&l(a)},!0),i.params=b.copy(d.$eval(h.paramExpr))),l(),j.clickable&&e.bind("click",E(e,a,c,j,function(){return i}))}}}function H(a,b){return{restrict:"A",require:["?^uiSrefActive","?^uiSrefActiveEq"],link:function(c,d,e,f){function g(b){l.state=b[0],l.params=b[1],l.options=b[2],l.href=a.href(l.state,l.params,l.options),i&&i.$$addStateInfo(l.state,l.params),l.href&&e.$set(h.attr,l.href)}var h=D(d),i=f[1]||f[0],j=[e.uiState,e.uiStateParams||null,e.uiStateOpts||null],k="["+j.map(function(a){return a||"null"}).join(", ")+"]",l={state:null,params:null,options:null,href:null};c.$watch(k,g,!0),g(c.$eval(k)),h.clickable&&d.bind("click",E(d,a,b,h,function(){return l}))}}}function I(a,b,c){return{restrict:"A",controller:["$scope","$element","$attrs","$timeout",function(b,d,e,f){function g(b,c,e){var f=a.get(b,C(d)),g=h(b,c);p.push({state:f||{name:b},params:c,hash:g}),q[g]=e}function h(a,c){if(!N(a))throw new Error("state should be a string");return O(c)?a+T(c):(c=b.$eval(c),O(c)?a+T(c):a)}function i(){for(var a=0;a<p.length;a++)l(p[a].state,p[a].params)?j(d,q[p[a].hash]):k(d,q[p[a].hash]),m(p[a].state,p[a].params)?j(d,n):k(d,n)}function j(a,b){f(function(){a.addClass(b)})}function k(a,b){a.removeClass(b)}function l(b,c){return a.includes(b.name,c)}function m(b,c){return a.is(b.name,c)}var n,o,p=[],q={};n=c(e.uiSrefActiveEq||"",!1)(b);try{o=b.$eval(e.uiSrefActive)}catch(r){}o=o||c(e.uiSrefActive||"",!1)(b),O(o)&&Q(o,function(c,d){if(N(c)){var e=B(c,a.current.name);g(e.state,b.$eval(e.paramExpr),d)}}),this.$$addStateInfo=function(a,b){O(o)&&p.length>0||(g(a,b,o),i())},b.$on("$stateChangeSuccess",i),i()}]}}function J(a){var b=function(b,c){return a.is(b,c)};return b.$stateful=!0,b}function K(a){var b=function(b,c,d){return a.includes(b,c,d)};return b.$stateful=!0,b}var L=b.isDefined,M=b.isFunction,N=b.isString,O=b.isObject,P=b.isArray,Q=b.forEach,R=b.extend,S=b.copy,T=b.toJson;b.module("ui.router.util",["ng"]),b.module("ui.router.router",["ui.router.util"]),b.module("ui.router.state",["ui.router.router","ui.router.util"]),b.module("ui.router",["ui.router.state"]),b.module("ui.router.compat",["ui.router"]),p.$inject=["$q","$injector"],b.module("ui.router.util").service("$resolve",p),q.$inject=["$http","$templateCache","$injector"],b.module("ui.router.util").service("$templateFactory",q);var U;r.prototype.concat=function(a,b){var c={caseInsensitive:U.caseInsensitive(),strict:U.strictMode(),squash:U.defaultSquashPolicy()};return new r(this.sourcePath+a+this.sourceSearch,R(c,b),this)},r.prototype.toString=function(){return this.source},r.prototype.exec=function(a,b){function c(a){function b(a){return a.split("").reverse().join("")}function c(a){return a.replace(/\\-/g,"-")}var d=b(a).split(/-(?!\\)/),e=o(d,b);return o(e,c).reverse()}var d=this.regexp.exec(a);if(!d)return null;b=b||{};var e,f,g,h=this.parameters(),i=h.length,j=this.segments.length-1,k={};if(j!==d.length-1)throw new Error("Unbalanced capture group in route '"+this.source+"'");var l,m;for(e=0;j>e;e++){for(g=h[e],l=this.params[g],m=d[e+1],f=0;f<l.replace.length;f++)l.replace[f].from===m&&(m=l.replace[f].to);m&&l.array===!0&&(m=c(m)),L(m)&&(m=l.type.decode(m)),k[g]=l.value(m)}for(;i>e;e++){for(g=h[e],k[g]=this.params[g].value(b[g]),l=this.params[g],m=b[g],f=0;f<l.replace.length;f++)l.replace[f].from===m&&(m=l.replace[f].to);L(m)&&(m=l.type.decode(m)),k[g]=l.value(m)}return k},r.prototype.parameters=function(a){return L(a)?this.params[a]||null:this.$$paramNames},r.prototype.validates=function(a){return this.params.$$validates(a)},r.prototype.format=function(a){function b(a){return encodeURIComponent(a).replace(/-/g,function(a){return"%5C%"+a.charCodeAt(0).toString(16).toUpperCase()})}a=a||{};var c=this.segments,d=this.parameters(),e=this.params;if(!this.validates(a))return null;var f,g=!1,h=c.length-1,i=d.length,j=c[0];for(f=0;i>f;f++){var k=h>f,l=d[f],m=e[l],n=m.value(a[l]),p=m.isOptional&&m.type.equals(m.value(),n),q=p?m.squash:!1,r=m.type.encode(n);if(k){var s=c[f+1],t=f+1===h;if(q===!1)null!=r&&(j+=P(r)?o(r,b).join("-"):encodeURIComponent(r)),j+=s;else if(q===!0){var u=j.match(/\/$/)?/\/?(.*)/:/(.*)/;j+=s.match(u)[1]}else N(q)&&(j+=q+s);t&&m.squash===!0&&"/"===j.slice(-1)&&(j=j.slice(0,-1))}else{if(null==r||p&&q!==!1)continue;if(P(r)||(r=[r]),0===r.length)continue;r=o(r,encodeURIComponent).join("&"+l+"="),j+=(g?"&":"?")+(l+"="+r),g=!0}}return j},s.prototype.is=function(a,b){return!0},s.prototype.encode=function(a,b){return a},s.prototype.decode=function(a,b){return a},s.prototype.equals=function(a,b){return a==b},s.prototype.$subPattern=function(){var a=this.pattern.toString();return a.substr(1,a.length-2)},s.prototype.pattern=/.*/,s.prototype.toString=function(){return"{Type:"+this.name+"}"},s.prototype.$normalize=function(a){return this.is(a)?a:this.decode(a)},s.prototype.$asArray=function(a,b){function d(a,b){function d(a,b){return function(){return a[b].apply(a,arguments)}}function e(a){return P(a)?a:L(a)?[a]:[]}function f(a){switch(a.length){case 0:return c;case 1:return"auto"===b?a[0]:a;default:return a}}function g(a){return!a}function h(a,b){return function(c){if(P(c)&&0===c.length)return c;c=e(c);var d=o(c,a);return b===!0?0===n(d,g).length:f(d)}}function i(a){return function(b,c){var d=e(b),f=e(c);if(d.length!==f.length)return!1;for(var g=0;g<d.length;g++)if(!a(d[g],f[g]))return!1;return!0}}this.encode=h(d(a,"encode")),this.decode=h(d(a,"decode")),this.is=h(d(a,"is"),!0),this.equals=i(d(a,"equals")),this.pattern=a.pattern,this.$normalize=h(d(a,"$normalize")),this.name=a.name,this.$arrayMode=b}if(!a)return this;if("auto"===a&&!b)throw new Error("'auto' array mode is for query parameters only");return new d(this,a)},b.module("ui.router.util").provider("$urlMatcherFactory",t),b.module("ui.router.util").run(["$urlMatcherFactory",function(a){}]),u.$inject=["$locationProvider","$urlMatcherFactoryProvider"],b.module("ui.router.router").provider("$urlRouter",u),v.$inject=["$urlRouterProvider","$urlMatcherFactoryProvider"],b.module("ui.router.state").factory("$stateParams",function(){return{}}).provider("$state",v),w.$inject=[],b.module("ui.router.state").provider("$view",w),b.module("ui.router.state").provider("$uiViewScroll",x);var V=b.version.major,W=b.version.minor;y.$inject=["$state","$injector","$uiViewScroll","$interpolate"],z.$inject=["$compile","$controller","$state","$interpolate"],b.module("ui.router.state").directive("uiView",y),b.module("ui.router.state").directive("uiView",z),G.$inject=["$state","$timeout"],H.$inject=["$state","$timeout"],I.$inject=["$state","$stateParams","$interpolate"],b.module("ui.router.state").directive("uiSref",G).directive("uiSrefActive",I).directive("uiSrefActiveEq",I).directive("uiState",H),
J.$inject=["$state"],K.$inject=["$state"],b.module("ui.router.state").filter("isState",J).filter("includedByState",K)}(window,window.angular);
/*!
 * ui-select
 * http://github.com/angular-ui/ui-select
 * Version: 0.13.1 - 2015-09-30T05:39:26.655Z
 * License: MIT
 */
!function(){"use strict";var e={TAB:9,ENTER:13,ESC:27,SPACE:32,LEFT:37,UP:38,RIGHT:39,DOWN:40,SHIFT:16,CTRL:17,ALT:18,PAGE_UP:33,PAGE_DOWN:34,HOME:36,END:35,BACKSPACE:8,DELETE:46,COMMAND:91,MAP:{91:"COMMAND",8:"BACKSPACE",9:"TAB",13:"ENTER",16:"SHIFT",17:"CTRL",18:"ALT",19:"PAUSEBREAK",20:"CAPSLOCK",27:"ESC",32:"SPACE",33:"PAGE_UP",34:"PAGE_DOWN",35:"END",36:"HOME",37:"LEFT",38:"UP",39:"RIGHT",40:"DOWN",43:"+",44:"PRINTSCREEN",45:"INSERT",46:"DELETE",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",59:";",61:"=",65:"A",66:"B",67:"C",68:"D",69:"E",70:"F",71:"G",72:"H",73:"I",74:"J",75:"K",76:"L",77:"M",78:"N",79:"O",80:"P",81:"Q",82:"R",83:"S",84:"T",85:"U",86:"V",87:"W",88:"X",89:"Y",90:"Z",96:"0",97:"1",98:"2",99:"3",100:"4",101:"5",102:"6",103:"7",104:"8",105:"9",106:"*",107:"+",109:"-",110:".",111:"/",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NUMLOCK",145:"SCROLLLOCK",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'"},isControl:function(t){var i=t.which;switch(i){case e.COMMAND:case e.SHIFT:case e.CTRL:case e.ALT:return!0}return t.metaKey?!0:!1},isFunctionKey:function(e){return e=e.which?e.which:e,e>=112&&123>=e},isVerticalMovement:function(t){return~[e.UP,e.DOWN].indexOf(t)},isHorizontalMovement:function(t){return~[e.LEFT,e.RIGHT,e.BACKSPACE,e.DELETE].indexOf(t)}};void 0===angular.element.prototype.querySelectorAll&&(angular.element.prototype.querySelectorAll=function(e){return angular.element(this[0].querySelectorAll(e))}),void 0===angular.element.prototype.closest&&(angular.element.prototype.closest=function(e){for(var t=this[0],i=t.matches||t.webkitMatchesSelector||t.mozMatchesSelector||t.msMatchesSelector;t;){if(i.bind(t)(e))return t;t=t.parentElement}return!1});var t=0,i=angular.module("ui.select",[]).constant("uiSelectConfig",{theme:"bootstrap",searchEnabled:!0,sortable:!1,placeholder:"",refreshDelay:1e3,closeOnSelect:!0,dropdownPosition:"auto",generateId:function(){return t++},appendToBody:!1}).service("uiSelectMinErr",function(){var e=angular.$$minErr("ui.select");return function(){var t=e.apply(this,arguments),i=t.message.replace(new RegExp("\nhttp://errors.angularjs.org/.*"),"");return new Error(i)}}).directive("uisTranscludeAppend",function(){return{link:function(e,t,i,s,c){c(e,function(e){t.append(e)})}}}).filter("highlight",function(){function e(e){return e.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}return function(t,i){return i&&t?t.replace(new RegExp(e(i),"gi"),'<span class="ui-select-highlight">$&</span>'):t}}).factory("uisOffset",["$document","$window",function(e,t){return function(i){var s=i[0].getBoundingClientRect();return{width:s.width||i.prop("offsetWidth"),height:s.height||i.prop("offsetHeight"),top:s.top+(t.pageYOffset||e[0].documentElement.scrollTop),left:s.left+(t.pageXOffset||e[0].documentElement.scrollLeft)}}}]);i.directive("uiSelectChoices",["uiSelectConfig","uisRepeatParser","uiSelectMinErr","$compile",function(e,t,i,s){return{restrict:"EA",require:"^uiSelect",replace:!0,transclude:!0,templateUrl:function(t){var i=t.parent().attr("theme")||e.theme;return i+"/choices.tpl.html"},compile:function(c,l){if(!l.repeat)throw i("repeat","Expected 'repeat' expression.");return function(c,l,n,a,r){var o=n.groupBy,u=n.groupFilter;if(a.parseRepeatAttr(n.repeat,o,u),a.disableChoiceExpression=n.uiDisableChoice,a.onHighlightCallback=n.onHighlight,a.dropdownPosition=n.position?n.position.toLowerCase():e.dropdownPosition,o){var d=l.querySelectorAll(".ui-select-choices-group");if(1!==d.length)throw i("rows","Expected 1 .ui-select-choices-group but got '{0}'.",d.length);d.attr("ng-repeat",t.getGroupNgRepeatExpression())}var p=l.querySelectorAll(".ui-select-choices-row");if(1!==p.length)throw i("rows","Expected 1 .ui-select-choices-row but got '{0}'.",p.length);p.attr("ng-repeat",a.parserResult.repeatExpression(o)).attr("ng-if","$select.open").attr("ng-click","$select.select("+a.parserResult.itemName+",false,$event)");var h=l.querySelectorAll(".ui-select-choices-row-inner");if(1!==h.length)throw i("rows","Expected 1 .ui-select-choices-row-inner but got '{0}'.",h.length);h.attr("uis-transclude-append",""),s(l,r)(c),c.$watch("$select.search",function(e){e&&!a.open&&a.multiple&&a.activate(!1,!0),a.activeIndex=a.tagging.isActivated?-1:0,a.refresh(n.refresh)}),n.$observe("refreshDelay",function(){var t=c.$eval(n.refreshDelay);a.refreshDelay=void 0!==t?t:e.refreshDelay})}}}}]),i.controller("uiSelectCtrl",["$scope","$element","$timeout","$filter","uisRepeatParser","uiSelectMinErr","uiSelectConfig","$parse",function(t,i,s,c,l,n,a,r){function o(){(h.resetSearchInput||void 0===h.resetSearchInput&&a.resetSearchInput)&&(h.search=g,h.selected&&h.items.length&&!h.multiple&&(h.activeIndex=h.items.indexOf(h.selected)))}function u(e,t){var i,s,c=[];for(i=0;i<t.length;i++)for(s=0;s<e.length;s++)e[s].name==[t[i]]&&c.push(e[s]);return c}function d(t){var i=!0;switch(t){case e.DOWN:!h.open&&h.multiple?h.activate(!1,!0):h.activeIndex<h.items.length-1&&h.activeIndex++;break;case e.UP:!h.open&&h.multiple?h.activate(!1,!0):(h.activeIndex>0||0===h.search.length&&h.tagging.isActivated&&h.activeIndex>-1)&&h.activeIndex--;break;case e.TAB:(!h.multiple||h.open)&&h.select(h.items[h.activeIndex],!0);break;case e.ENTER:h.open&&(h.tagging.isActivated||h.activeIndex>=0)?h.select(h.items[h.activeIndex]):h.activate(!1,!0);break;case e.ESC:h.close();break;default:i=!1}return i}function p(){var e=i.querySelectorAll(".ui-select-choices-content"),t=e.querySelectorAll(".ui-select-choices-row");if(t.length<1)throw n("choices","Expected multiple .ui-select-choices-row but got '{0}'.",t.length);if(!(h.activeIndex<0)){var s=t[h.activeIndex],c=s.offsetTop+s.clientHeight-e[0].scrollTop,l=e[0].offsetHeight;c>l?e[0].scrollTop+=c-l:c<s.clientHeight&&(h.isGrouped&&0===h.activeIndex?e[0].scrollTop=0:e[0].scrollTop-=s.clientHeight-c)}}var h=this,g="";if(h.placeholder=a.placeholder,h.searchEnabled=a.searchEnabled,h.sortable=a.sortable,h.refreshDelay=a.refreshDelay,h.removeSelected=!1,h.closeOnSelect=!0,h.search=g,h.activeIndex=0,h.items=[],h.open=!1,h.focus=!1,h.disabled=!1,h.selected=void 0,h.dropdownPosition="auto",h.focusser=void 0,h.resetSearchInput=!0,h.multiple=void 0,h.disableChoiceExpression=void 0,h.tagging={isActivated:!1,fct:void 0},h.taggingTokens={isActivated:!1,tokens:void 0},h.lockChoiceExpression=void 0,h.clickTriggeredSelect=!1,h.$filter=c,h.searchInput=i.querySelectorAll("input.ui-select-search"),1!==h.searchInput.length)throw n("searchInput","Expected 1 input.ui-select-search but got '{0}'.",h.searchInput.length);h.isEmpty=function(){return angular.isUndefined(h.selected)||null===h.selected||""===h.selected},h.activate=function(e,i){h.disabled||h.open||(i||o(),t.$broadcast("uis:activate"),h.open=!0,h.activeIndex=h.activeIndex>=h.items.length?0:h.activeIndex,-1===h.activeIndex&&h.taggingLabel!==!1&&(h.activeIndex=0),s(function(){h.search=e||h.search,h.searchInput[0].focus(),!h.tagging.isActivated&&h.items.length>1&&p()}))},h.findGroupByName=function(e){return h.groups&&h.groups.filter(function(t){return t.name===e})[0]},h.parseRepeatAttr=function(e,i,s){function c(e){var c=t.$eval(i);if(h.groups=[],angular.forEach(e,function(e){var t=angular.isFunction(c)?c(e):e[c],i=h.findGroupByName(t);i?i.items.push(e):h.groups.push({name:t,items:[e]})}),s){var l=t.$eval(s);angular.isFunction(l)?h.groups=l(h.groups):angular.isArray(l)&&(h.groups=u(h.groups,l))}h.items=[],h.groups.forEach(function(e){h.items=h.items.concat(e.items)})}function a(e){h.items=e}h.setItemsFn=i?c:a,h.parserResult=l.parse(e),h.isGrouped=!!i,h.itemProperty=h.parserResult.itemName;var o=h.parserResult.source,d=function(){t.$uisSource=Object.keys(o(t)).map(function(e){var i={};return i[h.parserResult.keyName]=e,i.value=t.peopleObj[e],i})};h.parserResult.keyName&&(d(),h.parserResult.source=r("$uisSource"+h.parserResult.filters),t.$watch(o,function(e,t){e!==t&&d()},!0)),h.refreshItems=function(e){e=e||h.parserResult.source(t);var i=h.selected;if(h.isEmpty()||angular.isArray(i)&&!i.length||!h.removeSelected)h.setItemsFn(e);else if(void 0!==e){var s=e.filter(function(e){return i&&i.indexOf(e)<0});h.setItemsFn(s)}("auto"===h.dropdownPosition||"up"===h.dropdownPosition)&&t.calculateDropdownPos()},t.$watchCollection(h.parserResult.source,function(e){if(void 0===e||null===e)h.items=[];else{if(!angular.isArray(e))throw n("items","Expected an array but got '{0}'.",e);h.refreshItems(e),h.ngModel.$modelValue=null}})};var f;h.refresh=function(e){void 0!==e&&(f&&s.cancel(f),f=s(function(){t.$eval(e)},h.refreshDelay))},h.isActive=function(e){if(!h.open)return!1;var t=h.items.indexOf(e[h.itemProperty]),i=t===h.activeIndex;return!i||0>t&&h.taggingLabel!==!1||0>t&&h.taggingLabel===!1?!1:(i&&!angular.isUndefined(h.onHighlightCallback)&&e.$eval(h.onHighlightCallback),i)},h.isDisabled=function(e){if(h.open){var t,i=h.items.indexOf(e[h.itemProperty]),s=!1;return i>=0&&!angular.isUndefined(h.disableChoiceExpression)&&(t=h.items[i],s=!!e.$eval(h.disableChoiceExpression),t._uiSelectChoiceDisabled=s),s}},h.select=function(e,i,c){if(void 0===e||!e._uiSelectChoiceDisabled){if(!h.items&&!h.search)return;if(!e||!e._uiSelectChoiceDisabled){if(h.tagging.isActivated){if(h.taggingLabel===!1)if(h.activeIndex<0){if(e=void 0!==h.tagging.fct?h.tagging.fct(h.search):h.search,!e||angular.equals(h.items[0],e))return}else e=h.items[h.activeIndex];else if(0===h.activeIndex){if(void 0===e)return;if(void 0!==h.tagging.fct&&"string"==typeof e){if(e=h.tagging.fct(h.search),!e)return}else"string"==typeof e&&(e=e.replace(h.taggingLabel,"").trim())}if(h.selected&&angular.isArray(h.selected)&&h.selected.filter(function(t){return angular.equals(t,e)}).length>0)return h.close(i),void 0}t.$broadcast("uis:select",e);var l={};l[h.parserResult.itemName]=e,s(function(){h.onSelectCallback(t,{$item:e,$model:h.parserResult.modelMapper(t,l)})}),h.closeOnSelect&&h.close(i),c&&"click"===c.type&&(h.clickTriggeredSelect=!0)}}},h.close=function(e){h.open&&(h.ngModel&&h.ngModel.$setTouched&&h.ngModel.$setTouched(),o(),h.open=!1,t.$broadcast("uis:close",e))},h.setFocus=function(){h.focus||h.focusInput[0].focus()},h.clear=function(e){h.select(void 0),e.stopPropagation(),s(function(){h.focusser[0].focus()},0,!1)},h.toggle=function(e){h.open?(h.close(),e.preventDefault(),e.stopPropagation()):h.activate()},h.isLocked=function(e,t){var i,s=h.selected[t];return s&&!angular.isUndefined(h.lockChoiceExpression)&&(i=!!e.$eval(h.lockChoiceExpression),s._uiSelectChoiceLocked=i),i};var v=null;h.sizeSearchInput=function(){var e=h.searchInput[0],i=h.searchInput.parent().parent()[0],c=function(){return i.clientWidth*!!e.offsetParent},l=function(t){if(0===t)return!1;var i=t-e.offsetLeft-10;return 50>i&&(i=t),h.searchInput.css("width",i+"px"),!0};h.searchInput.css("width","10px"),s(function(){null!==v||l(c())||(v=t.$watch(c,function(e){l(e)&&(v(),v=null)}))})},h.searchInput.on("keydown",function(i){var c=i.which;t.$apply(function(){var t=!1;if((h.items.length>0||h.tagging.isActivated)&&(d(c),h.taggingTokens.isActivated)){for(var l=0;l<h.taggingTokens.tokens.length;l++)h.taggingTokens.tokens[l]===e.MAP[i.keyCode]&&h.search.length>0&&(t=!0);t&&s(function(){h.searchInput.triggerHandler("tagged");var t=h.search.replace(e.MAP[i.keyCode],"").trim();h.tagging.fct&&(t=h.tagging.fct(t)),t&&h.select(t,!0)})}}),e.isVerticalMovement(c)&&h.items.length>0&&p(),(c===e.ENTER||c===e.ESC)&&(i.preventDefault(),i.stopPropagation())}),h.searchInput.on("paste",function(e){var t=e.originalEvent.clipboardData.getData("text/plain");if(t&&t.length>0&&h.taggingTokens.isActivated&&h.tagging.fct){var i=t.split(h.taggingTokens.tokens[0]);i&&i.length>0&&(angular.forEach(i,function(e){var t=h.tagging.fct(e);t&&h.select(t,!0)}),e.preventDefault(),e.stopPropagation())}}),h.searchInput.on("tagged",function(){s(function(){o()})}),t.$on("$destroy",function(){h.searchInput.off("keyup keydown tagged blur paste")})}]),i.directive("uiSelect",["$document","uiSelectConfig","uiSelectMinErr","uisOffset","$compile","$parse","$timeout",function(e,t,i,s,c,l,n){return{restrict:"EA",templateUrl:function(e,i){var s=i.theme||t.theme;return s+(angular.isDefined(i.multiple)?"/select-multiple.tpl.html":"/select.tpl.html")},replace:!0,transclude:!0,require:["uiSelect","^ngModel"],scope:!0,controller:"uiSelectCtrl",controllerAs:"$select",compile:function(c,a){return angular.isDefined(a.multiple)?c.append("<ui-select-multiple/>").removeAttr("multiple"):c.append("<ui-select-single/>"),function(c,a,r,o,u){function d(e){if(g.open){var t=!1;if(t=window.jQuery?window.jQuery.contains(a[0],e.target):a[0].contains(e.target),!t&&!g.clickTriggeredSelect){var i=["input","button","textarea"],s=angular.element(e.target).controller("uiSelect"),l=s&&s!==g;l||(l=~i.indexOf(e.target.tagName.toLowerCase())),g.close(l),c.$digest()}g.clickTriggeredSelect=!1}}function p(){var t=s(a);m=angular.element('<div class="ui-select-placeholder"></div>'),m[0].style.width=t.width+"px",m[0].style.height=t.height+"px",a.after(m),$=a[0].style.width,e.find("body").append(a),a[0].style.position="absolute",a[0].style.left=t.left+"px",a[0].style.top=t.top+"px",a[0].style.width=t.width+"px"}function h(){null!==m&&(m.replaceWith(a),m=null,a[0].style.position="",a[0].style.left="",a[0].style.top="",a[0].style.width=$)}var g=o[0],f=o[1];g.generatedId=t.generateId(),g.baseTitle=r.title||"Select box",g.focusserTitle=g.baseTitle+" focus",g.focusserId="focusser-"+g.generatedId,g.closeOnSelect=function(){return angular.isDefined(r.closeOnSelect)?l(r.closeOnSelect)():t.closeOnSelect}(),g.onSelectCallback=l(r.onSelect),g.onRemoveCallback=l(r.onRemove),g.limit=angular.isDefined(r.limit)?parseInt(r.limit,10):void 0,g.ngModel=f,g.choiceGrouped=function(e){return g.isGrouped&&e&&e.name},r.tabindex&&r.$observe("tabindex",function(e){g.focusInput.attr("tabindex",e),a.removeAttr("tabindex")}),c.$watch("searchEnabled",function(){var e=c.$eval(r.searchEnabled);g.searchEnabled=void 0!==e?e:t.searchEnabled}),c.$watch("sortable",function(){var e=c.$eval(r.sortable);g.sortable=void 0!==e?e:t.sortable}),r.$observe("disabled",function(){g.disabled=void 0!==r.disabled?r.disabled:!1}),r.$observe("resetSearchInput",function(){var e=c.$eval(r.resetSearchInput);g.resetSearchInput=void 0!==e?e:!0}),r.$observe("tagging",function(){if(void 0!==r.tagging){var e=c.$eval(r.tagging);g.tagging={isActivated:!0,fct:e!==!0?e:void 0}}else g.tagging={isActivated:!1,fct:void 0}}),r.$observe("taggingLabel",function(){void 0!==r.tagging&&(g.taggingLabel="false"===r.taggingLabel?!1:void 0!==r.taggingLabel?r.taggingLabel:"(new)")}),r.$observe("taggingTokens",function(){if(void 0!==r.tagging){var e=void 0!==r.taggingTokens?r.taggingTokens.split("|"):[",","ENTER"];g.taggingTokens={isActivated:!0,tokens:e}}}),angular.isDefined(r.autofocus)&&n(function(){g.setFocus()}),angular.isDefined(r.focusOn)&&c.$on(r.focusOn,function(){n(function(){g.setFocus()})}),e.on("click",d),c.$on("$destroy",function(){e.off("click",d)}),u(c,function(e){var t=angular.element("<div>").append(e),s=t.querySelectorAll(".ui-select-match");if(s.removeAttr("ui-select-match"),s.removeAttr("data-ui-select-match"),1!==s.length)throw i("transcluded","Expected 1 .ui-select-match but got '{0}'.",s.length);a.querySelectorAll(".ui-select-match").replaceWith(s);var c=t.querySelectorAll(".ui-select-choices");if(c.removeAttr("ui-select-choices"),c.removeAttr("data-ui-select-choices"),1!==c.length)throw i("transcluded","Expected 1 .ui-select-choices but got '{0}'.",c.length);a.querySelectorAll(".ui-select-choices").replaceWith(c)});var v=c.$eval(r.appendToBody);(void 0!==v?v:t.appendToBody)&&(c.$watch("$select.open",function(e){e?p():h()}),c.$on("$destroy",function(){h()}));var m=null,$="",b=null,w="direction-up";c.$watch("$select.open",function(){("auto"===g.dropdownPosition||"up"===g.dropdownPosition)&&c.calculateDropdownPos()});var x=function(e,t){e=e||s(a),t=t||s(b),b[0].style.position="absolute",b[0].style.top=-1*t.height+"px",a.addClass(w)},y=function(e,t){a.removeClass(w),e=e||s(a),t=t||s(b),b[0].style.position="",b[0].style.top=""};c.calculateDropdownPos=function(){if(g.open){if(b=angular.element(a).querySelectorAll(".ui-select-dropdown"),0===b.length)return;b[0].style.opacity=0,n(function(){if("up"===g.dropdownPosition)x(t,i);else{a.removeClass(w);var t=s(a),i=s(b),c=e[0].documentElement.scrollTop||e[0].body.scrollTop;t.top+t.height+i.height>c+e[0].documentElement.clientHeight?x(t,i):y(t,i)}b[0].style.opacity=1})}else{if(null===b||0===b.length)return;b[0].style.position="",b[0].style.top="",a.removeClass(w)}}}}}}]),i.directive("uiSelectMatch",["uiSelectConfig",function(e){return{restrict:"EA",require:"^uiSelect",replace:!0,transclude:!0,templateUrl:function(t){var i=t.parent().attr("theme")||e.theme,s=t.parent().attr("multiple");return i+(s?"/match-multiple.tpl.html":"/match.tpl.html")},link:function(t,i,s,c){function l(e){c.allowClear=angular.isDefined(e)?""===e?!0:"true"===e.toLowerCase():!1}c.lockChoiceExpression=s.uiLockChoice,s.$observe("placeholder",function(t){c.placeholder=void 0!==t?t:e.placeholder}),s.$observe("allowClear",l),l(s.allowClear),c.multiple&&c.sizeSearchInput()}}}]),i.directive("uiSelectMultiple",["uiSelectMinErr","$timeout",function(t,i){return{restrict:"EA",require:["^uiSelect","^ngModel"],controller:["$scope","$timeout",function(e,t){var i,s=this,c=e.$select;e.$evalAsync(function(){i=e.ngModel}),s.activeMatchIndex=-1,s.updateModel=function(){i.$setViewValue(Date.now()),s.refreshComponent()},s.refreshComponent=function(){c.refreshItems(),c.sizeSearchInput()},s.removeChoice=function(i){var l=c.selected[i];if(!l._uiSelectChoiceLocked){var n={};n[c.parserResult.itemName]=l,c.selected.splice(i,1),s.activeMatchIndex=-1,c.sizeSearchInput(),t(function(){c.onRemoveCallback(e,{$item:l,$model:c.parserResult.modelMapper(e,n)})}),s.updateModel()}},s.getPlaceholder=function(){return c.selected&&c.selected.length?void 0:c.placeholder}}],controllerAs:"$selectMultiple",link:function(s,c,l,n){function a(e){return angular.isNumber(e.selectionStart)?e.selectionStart:e.value.length}function r(t){function i(){switch(t){case e.LEFT:return~h.activeMatchIndex?u:n;case e.RIGHT:return~h.activeMatchIndex&&r!==n?o:(d.activate(),!1);case e.BACKSPACE:return~h.activeMatchIndex?(h.removeChoice(r),u):n;case e.DELETE:return~h.activeMatchIndex?(h.removeChoice(h.activeMatchIndex),r):!1}}var s=a(d.searchInput[0]),c=d.selected.length,l=0,n=c-1,r=h.activeMatchIndex,o=h.activeMatchIndex+1,u=h.activeMatchIndex-1,p=r;return s>0||d.search.length&&t==e.RIGHT?!1:(d.close(),p=i(),h.activeMatchIndex=d.selected.length&&p!==!1?Math.min(n,Math.max(l,p)):-1,!0)}function o(e){if(void 0===e||void 0===d.search)return!1;var t=e.filter(function(e){return void 0===d.search.toUpperCase()||void 0===e?!1:e.toUpperCase()===d.search.toUpperCase()}).length>0;return t}function u(e,t){var i=-1;if(angular.isArray(e))for(var s=angular.copy(e),c=0;c<s.length;c++)if(void 0===d.tagging.fct)s[c]+" "+d.taggingLabel===t&&(i=c);else{var l=s[c];l.isTag=!0,angular.equals(l,t)&&(i=c)}return i}var d=n[0],p=s.ngModel=n[1],h=s.$selectMultiple;d.multiple=!0,d.removeSelected=!0,d.focusInput=d.searchInput,p.$parsers.unshift(function(){for(var e,t={},i=[],c=d.selected.length-1;c>=0;c--)t={},t[d.parserResult.itemName]=d.selected[c],e=d.parserResult.modelMapper(s,t),i.unshift(e);return i}),p.$formatters.unshift(function(e){var t,i=d.parserResult.source(s,{$select:{search:""}}),c={};if(!i)return e;var l=[],n=function(e,i){if(e&&e.length){for(var n=e.length-1;n>=0;n--){if(c[d.parserResult.itemName]=e[n],t=d.parserResult.modelMapper(s,c),d.parserResult.trackByExp){var a=/\.(.+)/.exec(d.parserResult.trackByExp);if(a.length>0&&t[a[1]]==i[a[1]])return l.unshift(e[n]),!0}if(angular.equals(t,i))return l.unshift(e[n]),!0}return!1}};if(!e)return l;for(var a=e.length-1;a>=0;a--)n(d.selected,e[a])||n(i,e[a])||l.unshift(e[a]);return l}),s.$watchCollection(function(){return p.$modelValue},function(e,t){t!=e&&(p.$modelValue=null,h.refreshComponent())}),p.$render=function(){if(!angular.isArray(p.$viewValue)){if(!angular.isUndefined(p.$viewValue)&&null!==p.$viewValue)throw t("multiarr","Expected model value to be array but got '{0}'",p.$viewValue);d.selected=[]}d.selected=p.$viewValue,s.$evalAsync()},s.$on("uis:select",function(e,t){d.selected.length>=d.limit||(d.selected.push(t),h.updateModel())}),s.$on("uis:activate",function(){h.activeMatchIndex=-1}),s.$watch("$select.disabled",function(e,t){t&&!e&&d.sizeSearchInput()}),d.searchInput.on("keydown",function(t){var i=t.which;s.$apply(function(){var s=!1;e.isHorizontalMovement(i)&&(s=r(i)),s&&i!=e.TAB&&(t.preventDefault(),t.stopPropagation())})}),d.searchInput.on("keyup",function(t){if(e.isVerticalMovement(t.which)||s.$evalAsync(function(){d.activeIndex=d.taggingLabel===!1?-1:0}),d.tagging.isActivated&&d.search.length>0){if(t.which===e.TAB||e.isControl(t)||e.isFunctionKey(t)||t.which===e.ESC||e.isVerticalMovement(t.which))return;if(d.activeIndex=d.taggingLabel===!1?-1:0,d.taggingLabel===!1)return;var i,c,l,n,a=angular.copy(d.items),r=angular.copy(d.items),p=!1,h=-1;if(void 0!==d.tagging.fct){if(l=d.$filter("filter")(a,{isTag:!0}),l.length>0&&(n=l[0]),a.length>0&&n&&(p=!0,a=a.slice(1,a.length),r=r.slice(1,r.length)),i=d.tagging.fct(d.search),i.isTag=!0,r.filter(function(e){return angular.equals(e,d.tagging.fct(d.search))}).length>0)return;i.isTag=!0}else{if(l=d.$filter("filter")(a,function(e){return e.match(d.taggingLabel)}),l.length>0&&(n=l[0]),c=a[0],void 0!==c&&a.length>0&&n&&(p=!0,a=a.slice(1,a.length),r=r.slice(1,r.length)),i=d.search+" "+d.taggingLabel,u(d.selected,d.search)>-1)return;if(o(r.concat(d.selected)))return p&&(a=r,s.$evalAsync(function(){d.activeIndex=0,d.items=a})),void 0;if(o(r))return p&&(d.items=r.slice(1,r.length)),void 0}p&&(h=u(d.selected,i)),h>-1?a=a.slice(h+1,a.length-1):(a=[],a.push(i),a=a.concat(r)),s.$evalAsync(function(){d.activeIndex=0,d.items=a})}}),d.searchInput.on("blur",function(){i(function(){h.activeMatchIndex=-1})})}}}]),i.directive("uiSelectSingle",["$timeout","$compile",function(t,i){return{restrict:"EA",require:["^uiSelect","^ngModel"],link:function(s,c,l,n){var a=n[0],r=n[1];r.$parsers.unshift(function(e){var t,i={};return i[a.parserResult.itemName]=e,t=a.parserResult.modelMapper(s,i)}),r.$formatters.unshift(function(e){var t,i=a.parserResult.source(s,{$select:{search:""}}),c={};if(i){var l=function(i){return c[a.parserResult.itemName]=i,t=a.parserResult.modelMapper(s,c),t==e};if(a.selected&&l(a.selected))return a.selected;for(var n=i.length-1;n>=0;n--)if(l(i[n]))return i[n]}return e}),s.$watch("$select.selected",function(e){r.$viewValue!==e&&r.$setViewValue(e)}),r.$render=function(){a.selected=r.$viewValue},s.$on("uis:select",function(e,t){a.selected=t}),s.$on("uis:close",function(e,i){t(function(){a.focusser.prop("disabled",!1),i||a.focusser[0].focus()},0,!1)}),s.$on("uis:activate",function(){o.prop("disabled",!0)});var o=angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");i(o)(s),a.focusser=o,a.focusInput=o,c.parent().append(o),o.bind("focus",function(){s.$evalAsync(function(){a.focus=!0})}),o.bind("blur",function(){s.$evalAsync(function(){a.focus=!1})}),o.bind("keydown",function(t){return t.which===e.BACKSPACE?(t.preventDefault(),t.stopPropagation(),a.select(void 0),s.$apply(),void 0):(t.which===e.TAB||e.isControl(t)||e.isFunctionKey(t)||t.which===e.ESC||((t.which==e.DOWN||t.which==e.UP||t.which==e.ENTER||t.which==e.SPACE)&&(t.preventDefault(),t.stopPropagation(),a.activate()),s.$digest()),void 0)}),o.bind("keyup input",function(t){t.which===e.TAB||e.isControl(t)||e.isFunctionKey(t)||t.which===e.ESC||t.which==e.ENTER||t.which===e.BACKSPACE||(a.activate(o.val()),o.val(""),s.$digest())})}}}]),i.directive("uiSelectSort",["$timeout","uiSelectConfig","uiSelectMinErr",function(e,t,i){return{require:"^uiSelect",link:function(t,s,c,l){if(null===t[c.uiSelectSort])throw i("sort","Expected a list to sort");var n=angular.extend({axis:"horizontal"},t.$eval(c.uiSelectSortOptions)),a=n.axis,r="dragging",o="dropping",u="dropping-before",d="dropping-after";t.$watch(function(){return l.sortable},function(e){e?s.attr("draggable",!0):s.removeAttr("draggable")}),s.on("dragstart",function(e){s.addClass(r),(e.dataTransfer||e.originalEvent.dataTransfer).setData("text/plain",t.$index)}),s.on("dragend",function(){s.removeClass(r)});var p,h=function(e,t){this.splice(t,0,this.splice(e,1)[0])},g=function(e){e.preventDefault();var t="vertical"===a?e.offsetY||e.layerY||(e.originalEvent?e.originalEvent.offsetY:0):e.offsetX||e.layerX||(e.originalEvent?e.originalEvent.offsetX:0);t<this["vertical"===a?"offsetHeight":"offsetWidth"]/2?(s.removeClass(d),s.addClass(u)):(s.removeClass(u),s.addClass(d))},f=function(t){t.preventDefault();var i=parseInt((t.dataTransfer||t.originalEvent.dataTransfer).getData("text/plain"),10);e.cancel(p),p=e(function(){v(i)},20)},v=function(e){var i=t.$eval(c.uiSelectSort),l=i[e],n=null;n=s.hasClass(u)?e<t.$index?t.$index-1:t.$index:e<t.$index?t.$index:t.$index+1,h.apply(i,[e,n]),t.$apply(function(){t.$emit("uiSelectSort:change",{array:i,item:l,from:e,to:n})}),s.removeClass(o),s.removeClass(u),s.removeClass(d),s.off("drop",f)};s.on("dragenter",function(){s.hasClass(r)||(s.addClass(o),s.on("dragover",g),s.on("drop",f))}),s.on("dragleave",function(e){e.target==s&&(s.removeClass(o),s.removeClass(u),s.removeClass(d),s.off("dragover",g),s.off("drop",f))})}}}]),i.service("uisRepeatParser",["uiSelectMinErr","$parse",function(e,t){var i=this;i.parse=function(i){var s,c=/\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(i);if(s=i.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(([\w]+)?\s*(|\s*[\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/),!s)throw e("iexp","Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",i);if(!s[6]&&c)throw e("iexp","Expected expression in form of '_item_ as (_key_, _item_) in _ObjCollection_ [ track by _id_]' but got '{0}'.",i);return{itemName:s[4]||s[2],keyName:s[3],source:t(s[3]?s[6]:s[5]),sourceName:s[6],filters:s[7],trackByExp:s[8],modelMapper:t(s[1]||s[4]||s[2]),repeatExpression:function(e){var t=this.itemName+" in "+(e?"$group.items":"$select.items");return this.trackByExp&&(t+=" track by "+this.trackByExp),t}}},i.getGroupNgRepeatExpression=function(){return"$group in $select.groups"}}])}(),angular.module("ui.select").run(["$templateCache",function(e){e.put("bootstrap/choices.tpl.html",'<ul class="ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu" role="listbox" ng-show="$select.items.length > 0"><li class="ui-select-choices-group" id="ui-select-choices-{{ $select.generatedId }}"><div class="divider" ng-show="$select.isGrouped && $index > 0"></div><div ng-show="$select.isGrouped" class="ui-select-choices-group-label dropdown-header" ng-bind="$group.name"></div><div id="ui-select-choices-row-{{ $select.generatedId }}-{{$index}}" class="ui-select-choices-row" ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}" role="option"><a href="javascript:void(0)" class="ui-select-choices-row-inner"></a></div></li></ul>'),e.put("bootstrap/match-multiple.tpl.html",'<span class="ui-select-match"><span ng-repeat="$item in $select.selected"><span class="ui-select-match-item btn btn-default btn-xs" tabindex="-1" type="button" ng-disabled="$select.disabled" ng-click="$selectMultiple.activeMatchIndex = $index;" ng-class="{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected"><span class="close ui-select-match-close" ng-hide="$select.disabled" ng-click="$selectMultiple.removeChoice($index)">&nbsp;&times;</span> <span uis-transclude-append=""></span></span></span></span>'),e.put("bootstrap/match.tpl.html",'<div class="ui-select-match" ng-hide="$select.open" ng-disabled="$select.disabled" ng-class="{\'btn-default-focus\':$select.focus}"><span tabindex="-1" class="btn btn-default form-control ui-select-toggle" aria-label="{{ $select.baseTitle }} activate" ng-disabled="$select.disabled" ng-click="$select.activate()" style="outline: 0;"><span ng-show="$select.isEmpty()" class="ui-select-placeholder text-muted">{{$select.placeholder}}</span> <span ng-hide="$select.isEmpty()" class="ui-select-match-text pull-left" ng-class="{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}" ng-transclude=""></span> <i class="caret pull-right" ng-click="$select.toggle($event)"></i> <a ng-show="$select.allowClear && !$select.isEmpty()" aria-label="{{ $select.baseTitle }} clear" style="margin-right: 10px" ng-click="$select.clear($event)" class="btn btn-xs btn-link pull-right"><i class="glyphicon glyphicon-remove" aria-hidden="true"></i></a></span></div>'),e.put("bootstrap/select-multiple.tpl.html",'<div class="ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control" ng-class="{open: $select.open}"><div><div class="ui-select-match"></div><input type="text" autocomplete="false" autocorrect="off" autocapitalize="off" spellcheck="false" class="ui-select-search input-xs" placeholder="{{$selectMultiple.getPlaceholder()}}" ng-disabled="$select.disabled" ng-hide="$select.disabled" ng-click="$select.activate()" ng-model="$select.search" role="combobox" aria-label="{{ $select.baseTitle }}" ondrop="return false;"></div><div class="ui-select-choices"></div></div>'),e.put("bootstrap/select.tpl.html",'<div class="ui-select-container ui-select-bootstrap dropdown" ng-class="{open: $select.open}"><div class="ui-select-match"></div><input type="text" autocomplete="false" tabindex="-1" aria-expanded="true" aria-label="{{ $select.baseTitle }}" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}" class="form-control ui-select-search" placeholder="{{$select.placeholder}}" ng-model="$select.search" ng-show="$select.searchEnabled && $select.open"><div class="ui-select-choices"></div></div>'),e.put("select2/choices.tpl.html",'<ul class="ui-select-choices ui-select-choices-content select2-results"><li class="ui-select-choices-group" ng-class="{\'select2-result-with-children\': $select.choiceGrouped($group) }"><div ng-show="$select.choiceGrouped($group)" class="ui-select-choices-group-label select2-result-label" ng-bind="$group.name"></div><ul role="listbox" id="ui-select-choices-{{ $select.generatedId }}" ng-class="{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }"><li role="option" id="ui-select-choices-row-{{ $select.generatedId }}-{{$index}}" class="ui-select-choices-row" ng-class="{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}"><div class="select2-result-label ui-select-choices-row-inner"></div></li></ul></li></ul>'),e.put("select2/match-multiple.tpl.html",'<span class="ui-select-match"><li class="ui-select-match-item select2-search-choice" ng-repeat="$item in $select.selected" ng-class="{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected"><span uis-transclude-append=""></span> <a href="javascript:;" class="ui-select-match-close select2-search-choice-close" ng-click="$selectMultiple.removeChoice($index)" tabindex="-1"></a></li></span>'),e.put("select2/match.tpl.html",'<a class="select2-choice ui-select-match" ng-class="{\'select2-default\': $select.isEmpty()}" ng-click="$select.toggle($event)" aria-label="{{ $select.baseTitle }} select"><span ng-show="$select.isEmpty()" class="select2-chosen">{{$select.placeholder}}</span> <span ng-hide="$select.isEmpty()" class="select2-chosen" ng-transclude=""></span> <abbr ng-if="$select.allowClear && !$select.isEmpty()" class="select2-search-choice-close" ng-click="$select.clear($event)"></abbr> <span class="select2-arrow ui-select-toggle"><b></b></span></a>'),e.put("select2/select-multiple.tpl.html",'<div class="ui-select-container ui-select-multiple select2 select2-container select2-container-multi" ng-class="{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}"><ul class="select2-choices"><span class="ui-select-match"></span><li class="select2-search-field"><input type="text" autocomplete="false" autocorrect="off" autocapitalize="off" spellcheck="false" role="combobox" aria-expanded="true" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-label="{{ $select.baseTitle }}" aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}" class="select2-input ui-select-search" placeholder="{{$selectMultiple.getPlaceholder()}}" ng-disabled="$select.disabled" ng-hide="$select.disabled" ng-model="$select.search" ng-click="$select.activate()" style="width: 34px;" ondrop="return false;"></li></ul><div class="ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active" ng-class="{\'select2-display-none\': !$select.open}"><div class="ui-select-choices"></div></div></div>'),e.put("select2/select.tpl.html",'<div class="ui-select-container select2 select2-container" ng-class="{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}"><div class="ui-select-match"></div><div class="ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active" ng-class="{\'select2-display-none\': !$select.open}"><div class="select2-search" ng-show="$select.searchEnabled"><input type="text" autocomplete="false" autocorrect="false" autocapitalize="off" spellcheck="false" role="combobox" aria-expanded="true" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-label="{{ $select.baseTitle }}" aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}" class="ui-select-search select2-input" ng-model="$select.search"></div><div class="ui-select-choices"></div></div></div>'),e.put("selectize/choices.tpl.html",'<div ng-show="$select.open" class="ui-select-choices ui-select-dropdown selectize-dropdown single"><div class="ui-select-choices-content selectize-dropdown-content"><div class="ui-select-choices-group optgroup" role="listbox"><div ng-show="$select.isGrouped" class="ui-select-choices-group-label optgroup-header" ng-bind="$group.name"></div><div role="option" class="ui-select-choices-row" ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}"><div class="option ui-select-choices-row-inner" data-selectable=""></div></div></div></div></div>'),e.put("selectize/match.tpl.html",'<div ng-hide="($select.open || $select.isEmpty())" class="ui-select-match" ng-transclude=""></div>'),e.put("selectize/select.tpl.html",'<div class="ui-select-container selectize-control single" ng-class="{\'open\': $select.open}"><div class="selectize-input" ng-class="{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}" ng-click="$select.activate()"><div class="ui-select-match"></div><input type="text" autocomplete="false" tabindex="-1" class="ui-select-search ui-select-toggle" ng-click="$select.toggle($event)" placeholder="{{$select.placeholder}}" ng-model="$select.search" ng-hide="!$select.searchEnabled || ($select.selected && !$select.open)" ng-disabled="$select.disabled" aria-label="{{ $select.baseTitle }}"></div><div class="ui-select-choices"></div></div>')
}]);
/**
 * angular-ui-utils - Swiss-Army-Knife of AngularJS tools (with no external dependencies!)
 * @version v0.2.3 - 2015-03-30
 * @link http://angular-ui.github.com
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
function uiUploader(a){"use strict";function b(a){for(var b=0;b<a.length;b++)i.files.push(a[b])}function c(){return i.files}function d(a){i.options=a;for(var b=0;b<i.files.length&&i.activeUploads!=i.options.concurrency;b++)i.files[b].active||h(i.files[b],i.options.url)}function e(a){i.files.splice(i.files.indexOf(a),1)}function f(){i.files.splice(0,i.files.length)}function g(a){var b=["n/a","bytes","KiB","MiB","GiB","TB","PB","EiB","ZiB","YiB"],c=+Math.floor(Math.log(a)/Math.log(1024));return(a/Math.pow(1024,c)).toFixed(c?1:0)+" "+b[isNaN(a)?0:c+1]}function h(a,b){var c,e,f,h="",j="file";if(i.activeUploads+=1,a.active=!0,c=new window.XMLHttpRequest,e=new window.FormData,c.open("POST",b),c.upload.onloadstart=function(){},c.upload.onprogress=function(b){b.lengthComputable&&(a.loaded=b.loaded,a.humanSize=g(b.loaded),i.options.onProgress(a))},c.onload=function(){i.activeUploads-=1,d(i.options),i.options.onCompleted(a,c.responseText)},c.onerror=function(){},h)for(f in h)h.hasOwnProperty(f)&&e.append(f,h[f]);return e.append(j,a,a.name),c.send(e),c}var i=this;return i.files=[],i.options={},i.activeUploads=0,a.info("uiUploader loaded"),{addFiles:b,getFiles:c,files:i.files,startUpload:d,removeFile:e,removeAll:f}}angular.module("ui.alias",[]).config(["$compileProvider","uiAliasConfig",function(a,b){"use strict";b=b||{},angular.forEach(b,function(b,c){angular.isString(b)&&(b={replace:!0,template:b}),a.directive(c,function(){return b})})}]),angular.module("ui.event",[]).directive("uiEvent",["$parse",function(a){"use strict";return function(b,c,d){var e=b.$eval(d.uiEvent);angular.forEach(e,function(d,e){var f=a(d);c.bind(e,function(a){var c=Array.prototype.slice.call(arguments);c=c.splice(1),f(b,{$event:a,$params:c}),b.$$phase||b.$apply()})})}}]),angular.module("ui.format",[]).filter("format",function(){"use strict";return function(a,b){var c=a;if(angular.isString(c)&&void 0!==b)if(angular.isArray(b)||angular.isObject(b)||(b=[b]),angular.isArray(b)){var d=b.length,e=function(a,c){return c=parseInt(c,10),c>=0&&d>c?b[c]:a};c=c.replace(/\$([0-9]+)/g,e)}else angular.forEach(b,function(a,b){c=c.split(":"+b).join(a)});return c}}),angular.module("ui.highlight",[]).filter("highlight",function(){"use strict";return function(a,b,c){return a&&(b||angular.isNumber(b))?(a=a.toString(),b=b.toString(),c?a.split(b).join('<span class="ui-match">'+b+"</span>"):a.replace(new RegExp(b,"gi"),'<span class="ui-match">$&</span>')):a}}),angular.module("ui.include",[]).directive("uiInclude",["$http","$templateCache","$anchorScroll","$compile",function(a,b,c,d){"use strict";return{restrict:"ECA",terminal:!0,compile:function(e,f){var g=f.uiInclude||f.src,h=f.fragment||"",i=f.onload||"",j=f.autoscroll;return function(e,f){function k(){var k=++m,o=e.$eval(g),p=e.$eval(h);o?a.get(o,{cache:b}).success(function(a){if(k===m){l&&l.$destroy(),l=e.$new();var b;b=p?angular.element("<div/>").html(a).find(p):angular.element("<div/>").html(a).contents(),f.html(b),d(b)(l),!angular.isDefined(j)||j&&!e.$eval(j)||c(),l.$emit("$includeContentLoaded"),e.$eval(i)}}).error(function(){k===m&&n()}):n()}var l,m=0,n=function(){l&&(l.$destroy(),l=null),f.html("")};e.$watch(h,k),e.$watch(g,k)}}}}]),angular.module("ui.indeterminate",[]).directive("uiIndeterminate",[function(){"use strict";return{compile:function(a,b){return b.type&&"checkbox"===b.type.toLowerCase()?function(a,b,c){a.$watch(c.uiIndeterminate,function(a){b[0].indeterminate=!!a})}:angular.noop}}}]),angular.module("ui.inflector",[]).filter("inflector",function(){"use strict";function a(a){return a=a.replace(/([A-Z])|([\-|\_])/g,function(a,b){return" "+(b||"")}),a.replace(/\s\s+/g," ").trim().toLowerCase().split(" ")}function b(a){var b=[];return angular.forEach(a,function(a){b.push(a.charAt(0).toUpperCase()+a.substr(1))}),b}var c={humanize:function(c){return b(a(c)).join(" ")},underscore:function(b){return a(b).join("_")},variable:function(c){return c=a(c),c=c[0]+b(c.slice(1)).join("")}};return function(a,b){return b!==!1&&angular.isString(a)?(b=b||"humanize",c[b](a)):a}}),angular.module("ui.jq",[]).value("uiJqConfig",{}).directive("uiJq",["uiJqConfig","$timeout",function(a,b){"use strict";return{restrict:"A",compile:function(c,d){if(!angular.isFunction(c[d.uiJq]))throw new Error('ui-jq: The "'+d.uiJq+'" function does not exist');var e=a&&a[d.uiJq];return function(a,c,d){function f(){var b=[];return d.uiOptions?(b=a.$eval("["+d.uiOptions+"]"),angular.isObject(e)&&angular.isObject(b[0])&&(b[0]=angular.extend({},e,b[0]))):e&&(b=[e]),b}function g(){b(function(){c[d.uiJq].apply(c,f())},0,!1)}d.ngModel&&c.is("select,input,textarea")&&c.bind("change",function(){c.trigger("input")}),d.uiRefresh&&a.$watch(d.uiRefresh,function(){g()}),g()}}}}]),angular.module("ui.keypress",[]).factory("keypressHelper",["$parse",function(a){"use strict";var b={8:"backspace",9:"tab",13:"enter",27:"esc",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down",45:"insert",46:"delete"},c=function(a){return a.charAt(0).toUpperCase()+a.slice(1)};return function(d,e,f,g){var h,i=[];h=e.$eval(g["ui"+c(d)]),angular.forEach(h,function(b,c){var d,e;e=a(b),angular.forEach(c.split(" "),function(a){d={expression:e,keys:{}},angular.forEach(a.split("-"),function(a){d.keys[a]=!0}),i.push(d)})}),f.bind(d,function(a){var c=!(!a.metaKey||a.ctrlKey),f=!!a.altKey,g=!!a.ctrlKey,h=!!a.shiftKey,j=a.keyCode;"keypress"===d&&!h&&j>=97&&122>=j&&(j-=32),angular.forEach(i,function(d){var i=d.keys[b[j]]||d.keys[j.toString()],k=!!d.keys.meta,l=!!d.keys.alt,m=!!d.keys.ctrl,n=!!d.keys.shift;i&&k===c&&l===f&&m===g&&n===h&&e.$apply(function(){d.expression(e,{$event:a})})})})}}]),angular.module("ui.keypress").directive("uiKeydown",["keypressHelper",function(a){"use strict";return{link:function(b,c,d){a("keydown",b,c,d)}}}]),angular.module("ui.keypress").directive("uiKeypress",["keypressHelper",function(a){"use strict";return{link:function(b,c,d){a("keypress",b,c,d)}}}]),angular.module("ui.keypress").directive("uiKeyup",["keypressHelper",function(a){"use strict";return{link:function(b,c,d){a("keyup",b,c,d)}}}]),angular.module("ui.mask",[]).value("uiMaskConfig",{maskDefinitions:{9:/\d/,A:/[a-zA-Z]/,"*":/[a-zA-Z0-9]/},clearOnBlur:!0}).directive("uiMask",["uiMaskConfig","$parse",function(a,b){"use strict";return{priority:100,require:"ngModel",restrict:"A",compile:function(){var c=a;return function(a,d,e,f){function g(a){return angular.isDefined(a)?(t(a),O?(l(),m(),!0):k()):k()}function h(a){angular.isDefined(a)&&(E=a,O&&x())}function i(a){return O?(H=p(a||""),J=o(H),f.$setValidity("mask",J),J&&H.length?q(H):void 0):a}function j(a){return O?(H=p(a||""),J=o(H),f.$viewValue=H.length?q(H):"",f.$setValidity("mask",J),""===H&&e.required&&f.$setValidity("required",!f.$error.required),J?H:void 0):a}function k(){return O=!1,n(),angular.isDefined(Q)?d.attr("placeholder",Q):d.removeAttr("placeholder"),angular.isDefined(R)?d.attr("maxlength",R):d.removeAttr("maxlength"),d.val(f.$modelValue),f.$viewValue=f.$modelValue,!1}function l(){H=L=p(f.$viewValue||""),I=K=q(H),J=o(H);var a=J&&H.length?I:"";e.maxlength&&d.attr("maxlength",2*C[C.length-1]),d.attr("placeholder",E),d.val(a),f.$viewValue=a}function m(){P||(d.bind("blur",u),d.bind("mousedown mouseup",v),d.bind("input keyup click focus",x),P=!0)}function n(){P&&(d.unbind("blur",u),d.unbind("mousedown",v),d.unbind("mouseup",v),d.unbind("input",x),d.unbind("keyup",x),d.unbind("click",x),d.unbind("focus",x),P=!1)}function o(a){return a.length?a.length>=G:!0}function p(a){var b="",c=D.slice();return a=a.toString(),angular.forEach(F,function(b){a=a.replace(b,"")}),angular.forEach(a.split(""),function(a){c.length&&c[0].test(a)&&(b+=a,c.shift())}),b}function q(a){var b="",c=C.slice();return angular.forEach(E.split(""),function(d,e){a.length&&e===c[0]?(b+=a.charAt(0)||"_",a=a.substr(1),c.shift()):b+=d}),b}function r(a){var b=e.placeholder;return"undefined"!=typeof b&&b[a]?b[a]:"_"}function s(){return E.replace(/[_]+/g,"_").replace(/([^_]+)([a-zA-Z0-9])([^_])/g,"$1$2_$3").split("_")}function t(a){var b=0;if(C=[],D=[],E="","string"==typeof a){G=0;var c=!1,d=0,e=a.split("");angular.forEach(e,function(a,e){S.maskDefinitions[a]?(C.push(b),E+=r(e-d),D.push(S.maskDefinitions[a]),b++,c||G++):"?"===a?(c=!0,d++):(E+=a,b++)})}C.push(C.slice().pop()+1),F=s(),O=C.length>1?!0:!1}function u(){S.clearOnBlur&&(M=0,N=0,J&&0!==H.length||(I="",d.val(""),a.$apply(function(){f.$setViewValue("")})))}function v(a){"mousedown"===a.type?d.bind("mouseout",w):d.unbind("mouseout",w)}function w(){N=B(this),d.unbind("mouseout",w)}function x(b){b=b||{};var c=b.which,e=b.type;if(16!==c&&91!==c){var g,h=d.val(),i=K,j=p(h),k=L,l=!1,m=z(this)||0,n=M||0,o=m-n,r=C[0],s=C[j.length]||C.slice().shift(),t=N||0,u=B(this)>0,v=t>0,w=h.length>i.length||t&&h.length>i.length-t,x=h.length<i.length||t&&h.length===i.length-t,D=c>=37&&40>=c&&b.shiftKey,E=37===c,F=8===c||"keyup"!==e&&x&&-1===o,G=46===c||"keyup"!==e&&x&&0===o&&!v,H=(E||F||"click"===e)&&m>r;if(N=B(this),!D&&(!u||"click"!==e&&"keyup"!==e)){if("input"===e&&x&&!v&&j===k){for(;F&&m>r&&!y(m);)m--;for(;G&&s>m&&-1===C.indexOf(m);)m++;var I=C.indexOf(m);j=j.substring(0,I)+j.substring(I+1),l=!0}for(g=q(j),K=g,L=j,d.val(g),l&&a.$apply(function(){f.$setViewValue(j)}),w&&r>=m&&(m=r+1),H&&m--,m=m>s?s:r>m?r:m;!y(m)&&m>r&&s>m;)m+=H?-1:1;(H&&s>m||w&&!y(n))&&m++,M=m,A(this,m)}}}function y(a){return C.indexOf(a)>-1}function z(a){if(!a)return 0;if(void 0!==a.selectionStart)return a.selectionStart;if(document.selection){a.focus();var b=document.selection.createRange();return b.moveStart("character",a.value?-a.value.length:0),b.text.length}return 0}function A(a,b){if(!a)return 0;if(0!==a.offsetWidth&&0!==a.offsetHeight)if(a.setSelectionRange)a.focus(),a.setSelectionRange(b,b);else if(a.createTextRange){var c=a.createTextRange();c.collapse(!0),c.moveEnd("character",b),c.moveStart("character",b),c.select()}}function B(a){return a?void 0!==a.selectionStart?a.selectionEnd-a.selectionStart:document.selection?document.selection.createRange().text.length:0:0}var C,D,E,F,G,H,I,J,K,L,M,N,O=!1,P=!1,Q=e.placeholder,R=e.maxlength,S={};e.uiOptions?(S=a.$eval("["+e.uiOptions+"]"),angular.isObject(S[0])&&(S=function(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(void 0===b[c]?b[c]=angular.copy(a[c]):angular.extend(b[c],a[c]));return b}(c,S[0]))):S=c,e.$observe("uiMask",g),e.$observe("placeholder",h);var T=!1;e.$observe("modelViewValue",function(a){"true"===a&&(T=!0)}),a.$watch(e.ngModel,function(c){if(T&&c){var d=b(e.ngModel);d.assign(a,f.$viewValue)}}),f.$formatters.push(i),f.$parsers.push(j),d.bind("mousedown mouseup",v),Array.prototype.indexOf||(Array.prototype.indexOf=function(a){if(null===this)throw new TypeError;var b=Object(this),c=b.length>>>0;if(0===c)return-1;var d=0;if(arguments.length>1&&(d=Number(arguments[1]),d!==d?d=0:0!==d&&d!==1/0&&d!==-(1/0)&&(d=(d>0||-1)*Math.floor(Math.abs(d)))),d>=c)return-1;for(var e=d>=0?d:Math.max(c-Math.abs(d),0);c>e;e++)if(e in b&&b[e]===a)return e;return-1})}}}}]),angular.module("ui.reset",[]).value("uiResetConfig",null).directive("uiReset",["uiResetConfig",function(a){"use strict";var b=null;return void 0!==a&&(b=a),{require:"ngModel",link:function(a,c,d,e){var f;f=angular.element('<a class="ui-reset" />'),c.wrap('<span class="ui-resetwrap" />').after(f),f.bind("click",function(c){c.preventDefault(),a.$apply(function(){e.$setViewValue(d.uiReset?a.$eval(d.uiReset):b),e.$render()})})}}}]),angular.module("ui.route",[]).directive("uiRoute",["$location","$parse",function(a,b){"use strict";return{restrict:"AC",scope:!0,compile:function(c,d){var e;if(d.uiRoute)e="uiRoute";else if(d.ngHref)e="ngHref";else{if(!d.href)throw new Error("uiRoute missing a route or href property on "+c[0]);e="href"}return function(c,d,f){function g(b){var d=b.indexOf("#");d>-1&&(b=b.substr(d+1)),(j=function(){i(c,a.path().indexOf(b)>-1)})()}function h(b){var d=b.indexOf("#");d>-1&&(b=b.substr(d+1)),(j=function(){var d=new RegExp("^"+b+"$",["i"]);i(c,d.test(a.path()))})()}var i=b(f.ngModel||f.routeModel||"$uiRoute").assign,j=angular.noop;switch(e){case"uiRoute":f.uiRoute?h(f.uiRoute):f.$observe("uiRoute",h);break;case"ngHref":f.ngHref?g(f.ngHref):f.$observe("ngHref",g);break;case"href":g(f.href)}c.$on("$routeChangeSuccess",function(){j()}),c.$on("$stateChangeSuccess",function(){j()})}}}}]),angular.module("ui.scroll.jqlite",["ui.scroll"]).service("jqLiteExtras",["$log","$window",function(a,b){"use strict";return{registerFor:function(a){var c,d,e,f,g,h,i;return d=angular.element.prototype.css,a.prototype.css=function(a,b){var c,e;return e=this,c=e[0],c&&3!==c.nodeType&&8!==c.nodeType&&c.style?d.call(e,a,b):void 0},h=function(a){return a&&a.document&&a.location&&a.alert&&a.setInterval},i=function(a,b,c){var d,e,f,g,i;return d=a[0],i={top:["scrollTop","pageYOffset","scrollLeft"],left:["scrollLeft","pageXOffset","scrollTop"]}[b],e=i[0],g=i[1],f=i[2],h(d)?angular.isDefined(c)?d.scrollTo(a[f].call(a),c):g in d?d[g]:d.document.documentElement[e]:angular.isDefined(c)?d[e]=c:d[e]},b.getComputedStyle?(f=function(a){return b.getComputedStyle(a,null)},c=function(a,b){return parseFloat(b)}):(f=function(a){return a.currentStyle},c=function(a,b){var c,d,e,f,g,h,i;return c=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,f=new RegExp("^("+c+")(?!px)[a-z%]+$","i"),f.test(b)?(i=a.style,d=i.left,g=a.runtimeStyle,h=g&&g.left,g&&(g.left=i.left),i.left=b,e=i.pixelLeft,i.left=d,h&&(g.left=h),e):parseFloat(b)}),e=function(a,b){var d,e,g,i,j,k,l,m,n,o,p,q,r;return h(a)?(d=document.documentElement[{height:"clientHeight",width:"clientWidth"}[b]],{base:d,padding:0,border:0,margin:0}):(r={width:[a.offsetWidth,"Left","Right"],height:[a.offsetHeight,"Top","Bottom"]}[b],d=r[0],l=r[1],m=r[2],k=f(a),p=c(a,k["padding"+l])||0,q=c(a,k["padding"+m])||0,e=c(a,k["border"+l+"Width"])||0,g=c(a,k["border"+m+"Width"])||0,i=k["margin"+l],j=k["margin"+m],n=c(a,i)||0,o=c(a,j)||0,{base:d,padding:p+q,border:e+g,margin:n+o})},g=function(a,b,c){var d,g,h;return g=e(a,b),g.base>0?{base:g.base-g.padding-g.border,outer:g.base,outerfull:g.base+g.margin}[c]:(d=f(a),h=d[b],(0>h||null===h)&&(h=a.style[b]||0),h=parseFloat(h)||0,{base:h-g.padding-g.border,outer:h,outerfull:h+g.padding+g.border+g.margin}[c])},angular.forEach({before:function(a){var b,c,d,e,f,g,h;if(f=this,c=f[0],e=f.parent(),b=e.contents(),b[0]===c)return e.prepend(a);for(d=g=1,h=b.length-1;h>=1?h>=g:g>=h;d=h>=1?++g:--g)if(b[d]===c)return void angular.element(b[d-1]).after(a);throw new Error("invalid DOM structure "+c.outerHTML)},height:function(a){var b;return b=this,angular.isDefined(a)?(angular.isNumber(a)&&(a+="px"),d.call(b,"height",a)):g(this[0],"height","base")},outerHeight:function(a){return g(this[0],"height",a?"outerfull":"outer")},offset:function(a){var b,c,d,e,f,g;if(f=this,arguments.length){if(void 0===a)return f;throw new Error("offset setter method is not implemented")}return b={top:0,left:0},e=f[0],(c=e&&e.ownerDocument)?(d=c.documentElement,null!=e.getBoundingClientRect&&(b=e.getBoundingClientRect()),g=c.defaultView||c.parentWindow,{top:b.top+(g.pageYOffset||d.scrollTop)-(d.clientTop||0),left:b.left+(g.pageXOffset||d.scrollLeft)-(d.clientLeft||0)}):void 0},scrollTop:function(a){return i(this,"top",a)},scrollLeft:function(a){return i(this,"left",a)}},function(b,c){return a.prototype[c]?void 0:a.prototype[c]=b})}}}]).run(["$log","$window","jqLiteExtras",function(a,b,c){"use strict";return b.jQuery?void 0:c.registerFor(angular.element)}]),angular.module("ui.scroll",[]).directive("uiScrollViewport",["$log",function(){"use strict";return{controller:["$scope","$element",function(a,b){return this.viewport=b,this}]}}]).directive("uiScroll",["$log","$injector","$rootScope","$timeout",function(a,b,c,d){"use strict";return{require:["?^uiScrollViewport"],transclude:"element",priority:1e3,terminal:!0,compile:function(e,f,g){return function(e,f,h,i){var j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,$,_,aa,ba,ca,da;if(O=a.debug||a.log,P=h.uiScroll.match(/^\s*(\w+)\s+in\s+([\w\.]+)\s*$/),!P)throw new Error("Expected uiScroll in form of '_item_ in _datasource_' but got '"+h.uiScroll+"'");if(M=P[1],x=P[2],I=function(a,b){var c;if(a)return c=b.match(/^([\w]+)\.(.+)$/),c&&3===c.length?I(a[c[1]],c[2]):a[b]},X=function(a,b,c,d){var e;if(a&&b&&((e=b.match(/^([\w]+)\.(.+)$/))||-1===b.indexOf(".")))return e&&3===e.length?(angular.isObject(a[e[1]])||d||(a[e[1]]={}),X(a[e[1]],e[2],c,d)):a[b]=angular.isObject(a[b])||d?c:c},w=I(e,x),L=function(){return angular.isObject(w)&&"function"==typeof w.get},!L()&&(w=b.get(x),!L()))throw new Error(""+x+" is not a valid datasource");return s=Math.max(3,+h.bufferSize||10),r=function(){return ba.outerHeight()*Math.max(.1,+h.padding||.1)},W=function(a){var b;return null!=(b=a[0].scrollHeight)?b:a[0].document.documentElement.scrollHeight},t=null,g(e.$new(),function(a){var b,c,d,g,h,j;if(g=a[0].localName,"dl"===g)throw new Error("ui-scroll directive does not support <"+a[0].localName+"> as a repeating tag: "+a[0].outerHTML);return"li"!==g&&"tr"!==g&&(g="div"),j=i[0]&&i[0].viewport?i[0].viewport:angular.element(window),j.css({"overflow-y":"auto",display:"block"}),d=function(a){var b,c,d;switch(a){case"tr":return d=angular.element("<table><tr><td><div></div></td></tr></table>"),b=d.find("div"),c=d.find("tr"),c.paddingHeight=function(){return b.height.apply(b,arguments)},c;default:return c=angular.element("<"+a+"></"+a+">"),c.paddingHeight=c.height,c}},c=function(a,b,c){return b[{top:"before",bottom:"after"}[c]](a),{paddingHeight:function(){return a.paddingHeight.apply(a,arguments)},insert:function(b){return a[{top:"after",bottom:"before"}[c]](b)}}},h=c(d(g),f,"top"),b=c(d(g),f,"bottom"),e.$on("$destroy",a.remove),t={viewport:j,topPadding:h.paddingHeight,bottomPadding:b.paddingHeight,append:b.insert,prepend:h.insert,bottomDataPos:function(){return W(j)-b.paddingHeight()},topDataPos:function(){return h.paddingHeight()}}}),ba=t.viewport,ca=ba.scope()||c,_=function(a){return j.topVisible=a.scope[M],j.topVisibleElement=a.element,j.topVisibleScope=a.scope,h.topVisible&&X(ca,h.topVisible,j.topVisible),h.topVisibleElement&&X(ca,h.topVisibleElement,j.topVisibleElement),h.topVisibleScope&&X(ca,h.topVisibleScope,j.topVisibleScope),"function"==typeof w.topVisible?w.topVisible(a):void 0},N=function(a){return j.isLoading=a,h.isLoading&&X(e,h.isLoading,a),"function"==typeof w.loading?w.loading(a):void 0},V=0,H=1,Q=1,q=[],R=[],D=!1,o=!1,T=function(a,b){var c,d;for(c=d=a;b>=a?b>d:d>b;c=b>=a?++d:--d)q[c].scope.$destroy(),q[c].element.remove();return q.splice(a,b-a)},S=function(){return V++,H=1,Q=1,T(0,q.length),t.topPadding(0),t.bottomPadding(0),R=[],D=!1,o=!1,l(V)},p=function(){return ba.scrollTop()+ba.outerHeight()},aa=function(){return ba.scrollTop()},Y=function(){return!D&&t.bottomDataPos()<p()+r()},u=function(){var a,b,c,d,e,f,g,h,i,j;for(a=0,g=0,b=i=j=q.length-1;0>=j?0>=i:i>=0;b=0>=j?++i:--i)if(c=q[b],e=c.element.offset().top,f=h!==e,h=e,f&&(d=c.element.outerHeight(!0)),t.bottomDataPos()-a-d>p()+r())f&&(a+=d),g++,D=!1;else{if(f)break;g++}return g>0?(t.bottomPadding(t.bottomPadding()+a),T(q.length-g,q.length),Q-=g):void 0},Z=function(){return!o&&t.topDataPos()>aa()-r()},v=function(){var a,b,c,d,e,f,g,h,i;for(g=0,e=0,h=0,i=q.length;i>h;h++)if(a=q[h],c=a.element.offset().top,d=f!==c,f=c,d&&(b=a.element.outerHeight(!0)),t.topDataPos()+g+b<aa()-r())d&&(g+=b),e++,o=!1;else{if(d)break;e++}return e>0?(t.topPadding(t.topPadding()+g),T(0,e),H+=e):void 0},C=function(a,b){return j.isLoading||N(!0),1===R.push(b)?F(a):void 0},J=function(a){return a.displayTemp=a.css("display"),a.css("display","none")},$=function(a){return a.hasOwnProperty("displayTemp")?a.css("display",a.displayTemp):void 0},K=function(a,b){var c,d,f;return c=e.$new(),c[M]=b,d=a>H,c.$index=a,d&&c.$index--,f={scope:c},g(c,function(b){return f.element=b,d?a===Q?(J(b),t.append(b),q.push(f)):(q[a-H].element.after(b),q.splice(a-H+1,0,f)):(J(b),t.prepend(b),q.unshift(f))}),{appended:d,wrapper:f}},m=function(a,b){var c;return a?t.bottomPadding(Math.max(0,t.bottomPadding()-b.element.outerHeight(!0))):(c=t.topPadding()-b.element.outerHeight(!0),c>=0?t.topPadding(c):ba.scrollTop(ba.scrollTop()+b.element.outerHeight(!0)))},y=function(a,b){var c,d,e,f,g,h,i,j,k;if(Y()?C(a,!0):Z()&&C(a,!1),b&&b(a),0===R.length){for(h=0,k=[],i=0,j=q.length;j>i;i++){if(c=q[i],e=c.element.offset().top,f=g!==e,g=e,f&&(d=c.element.outerHeight(!0)),!(f&&t.topDataPos()+h+d<aa())){f&&_(c);break}k.push(h+=d)}return k}},l=function(a,b,c){return b&&b.length?d(function(){var d,e,f,g,h,i,j,k,l;for(h=[],i=0,k=b.length;k>i;i++)f=b[i],d=f.wrapper.element,$(d),e=d.offset().top,g!==e&&(h.push(f),g=e);for(j=0,l=h.length;l>j;j++)f=h[j],m(f.appended,f.wrapper);return y(a,c)}):y(a,c)},G=function(a,b){return l(a,b,function(){return R.shift(),0===R.length?N(!1):F(a)})},F=function(a){var b;return b=R[0],b?q.length&&!Y()?G(a):w.get(Q,s,function(b){var c,d,f,g;if(!(a&&a!==V||e.$$destroyed)){if(d=[],b.length<s&&(D=!0,t.bottomPadding(0)),b.length>0)for(v(),f=0,g=b.length;g>f;f++)c=b[f],d.push(K(++Q,c));return G(a,d)}}):q.length&&!Z()?G(a):w.get(H-s,s,function(b){var c,d,f,g;if(!(a&&a!==V||e.$$destroyed)){if(d=[],b.length<s&&(o=!0,t.topPadding(0)),b.length>0)for(q.length&&u(),c=f=g=b.length-1;0>=g?0>=f:f>=0;c=0>=g?++f:--f)d.unshift(K(--H,b[c]));return G(a,d)}})},U=function(){return c.$$phase||j.isLoading?void 0:(l(),e.$apply())},da=function(a){var b,c;return b=ba[0].scrollTop,c=ba[0].scrollHeight-ba[0].clientHeight,0===b&&!o||b===c&&!D?a.preventDefault():void 0},ba.bind("resize",U),ba.bind("scroll",U),ba.bind("mousewheel",da),e.$watch(w.revision,S),E=w.scope?w.scope.$new():e.$new(),e.$on("$destroy",function(){var a,b,c;for(b=0,c=q.length;c>b;b++)a=q[b],a.scope.$destroy(),a.element.remove();return ba.unbind("resize",U),ba.unbind("scroll",U),ba.unbind("mousewheel",da)}),j={},j.isLoading=!1,n=function(a,b){var c,d,e,f,g,h,i,j,k,l,m,n;if(d=[],angular.isArray(b))if(b.length){if(1===b.length&&b[0]===a.scope[M])return d;for(f=a.scope.$index,h=f>H?f-H:1,c=i=0,l=b.length;l>i;c=++i)g=b[c],d.push(K(f+c,g));for(T(h,h+1),c=j=0,m=q.length;m>j;c=++j)e=q[c],e.scope.$index=H+c}else for(T(a.scope.$index-H,a.scope.$index-H+1),Q--,c=k=0,n=q.length;n>k;c=++k)e=q[c],e.scope.$index=H+c;return d},j.applyUpdates=function(a,b){var c,d,e,f,g,h;if(c=[],V++,angular.isFunction(a))for(g=q.slice(0),e=0,f=g.length;f>e;e++)d=g[e],c.concat(c,n(d,a(d.scope[M],d.scope,d.element)));else{if(a%1!==0)throw new Error("applyUpdates - "+a+" is not a valid index or outside of range");0<=(h=a-H-1)&&h<q.length&&(c=n(q[a-H],b))}return l(V,c)},h.adapter&&(k=I(e,h.adapter),k||(X(e,h.adapter,{}),k=I(e,h.adapter)),angular.extend(k,j),j=k),B=function(a,b){var c,d,e,f,g;if(angular.isFunction(a))for(d=function(b){return a(b.scope)},e=0,f=q.length;f>e;e++)c=q[e],d(c);else 0<=(g=a-H-1)&&g<q.length&&(q[a-H-1].scope[M]=b);return null},z=function(a){var b,c,d,e,f,g,h,i,j,k,m,n;if(angular.isFunction(a)){for(d=[],g=0,j=q.length;j>g;g++)c=q[g],d.unshift(c);for(f=function(c){return a(c.scope)?(T(d.length-1-b,d.length-b),Q--):void 0},b=h=0,k=d.length;k>h;b=++h)e=d[b],f(e)}else 0<=(n=a-H-1)&&n<q.length&&(T(a-H-1,a-H),Q--);for(b=i=0,m=q.length;m>i;b=++i)c=q[b],c.scope.$index=H+b;return l()},A=function(a,b){var c,d,e,f,g;if(d=[],angular.isFunction(a))throw new Error("not implemented - Insert with locator function");for(0<=(g=a-H-1)&&g<q.length&&(d.push(K(a,b)),Q++),c=e=0,f=q.length;f>e;c=++e)b=q[c],b.scope.$index=H+c;return l(null,d)},E.$on("insert.item",function(a,b,c){return A(b,c)}),E.$on("update.items",function(a,b,c){return B(b,c)}),E.$on("delete.items",function(a,b){return z(b)})}}}}]),angular.module("ui.scrollfix",[]).directive("uiScrollfix",["$window",function(a){"use strict";function b(){if(angular.isDefined(a.pageYOffset))return a.pageYOffset;var b=document.compatMode&&"BackCompat"!==document.compatMode?document.documentElement:document.body;return b.scrollTop}return{require:"^?uiScrollfixTarget",link:function(c,d,e,f){function g(){var a=i?e.uiScrollfix:d[0].offsetTop+j,c=f?k[0].scrollTop:b();!d.hasClass("ui-scrollfix")&&c>a?(d.addClass("ui-scrollfix"),h=a):d.hasClass("ui-scrollfix")&&h>c&&d.removeClass("ui-scrollfix")}var h,i=!0,j=0,k=f&&f.$element||angular.element(a);e.uiScrollfix?"string"==typeof e.uiScrollfix&&("-"===e.uiScrollfix.charAt(0)?(i=!1,j=-parseFloat(e.uiScrollfix.substr(1))):"+"===e.uiScrollfix.charAt(0)&&(i=!1,j=parseFloat(e.uiScrollfix.substr(1)))):i=!1,h=i?e.uiScrollfix:d[0].offsetTop+j,k.on("scroll",g),c.$on("$destroy",function(){k.off("scroll",g)})}}}]).directive("uiScrollfixTarget",[function(){"use strict";return{controller:["$element",function(a){this.$element=a}]}}]),angular.module("ui.showhide",[]).directive("uiShow",[function(){"use strict";return function(a,b,c){a.$watch(c.uiShow,function(a){a?b.addClass("ui-show"):b.removeClass("ui-show")})}}]).directive("uiHide",[function(){"use strict";return function(a,b,c){a.$watch(c.uiHide,function(a){a?b.addClass("ui-hide"):b.removeClass("ui-hide")})}}]).directive("uiToggle",[function(){"use strict";return function(a,b,c){a.$watch(c.uiToggle,function(a){a?b.removeClass("ui-hide").addClass("ui-show"):b.removeClass("ui-show").addClass("ui-hide")})}}]),angular.module("ui.unique",[]).filter("unique",["$parse",function(a){"use strict";return function(b,c){if(c===!1)return b;if((c||angular.isUndefined(c))&&angular.isArray(b)){var d=[],e=angular.isString(c)?a(c):function(a){return a},f=function(a){return angular.isObject(a)?e(a):a};angular.forEach(b,function(a){for(var b=!1,c=0;c<d.length;c++)if(angular.equals(f(d[c]),f(a))){b=!0;break}b||d.push(a)}),b=d}return b}}]),angular.module("ui.uploader",[]).service("uiUploader",uiUploader),uiUploader.$inject=["$log"],angular.module("ui.validate",[]).directive("uiValidate",function(){"use strict";return{restrict:"A",require:"ngModel",link:function(a,b,c,d){function e(b){return angular.isString(b)?void a.$watch(b,function(){angular.forEach(g,function(a){a(d.$modelValue)})}):angular.isArray(b)?void angular.forEach(b,function(b){a.$watch(b,function(){angular.forEach(g,function(a){a(d.$modelValue)})})}):void(angular.isObject(b)&&angular.forEach(b,function(b,c){angular.isString(b)&&a.$watch(b,function(){g[c](d.$modelValue)}),angular.isArray(b)&&angular.forEach(b,function(b){a.$watch(b,function(){g[c](d.$modelValue)})})}))}var f,g={},h=a.$eval(c.uiValidate);h&&(angular.isString(h)&&(h={validator:h}),angular.forEach(h,function(b,c){f=function(e){var f=a.$eval(b,{$value:e});return angular.isObject(f)&&angular.isFunction(f.then)?(f.then(function(){d.$setValidity(c,!0)},function(){d.$setValidity(c,!1)}),e):f?(d.$setValidity(c,!0),e):(d.$setValidity(c,!1),e)},g[c]=f,d.$formatters.push(f),d.$parsers.push(f)}),c.uiValidateWatch&&e(a.$eval(c.uiValidateWatch)))}}}),angular.module("ui.utils",["ui.event","ui.format","ui.highlight","ui.include","ui.indeterminate","ui.inflector","ui.jq","ui.keypress","ui.mask","ui.reset","ui.route","ui.scrollfix","ui.scroll","ui.scroll.jqlite","ui.showhide","ui.unique","ui.validate"]);
var Triarc;
(function (Triarc) {
    Triarc.generateGuid = (typeof (crypto) != 'undefined' &&
        typeof (crypto.getRandomValues) != 'undefined') ?
        function () {
            // If we have a cryptographically secure PRNG, use that
            // http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
            var buf = new Uint16Array(8);
            crypto.getRandomValues(buf);
            var S4 = function (num) {
                var ret = num.toString(16);
                while (ret.length < 4) {
                    ret = "0" + ret;
                }
                return ret;
            };
            return (S4(buf[0]) + S4(buf[1]) + "-" + S4(buf[2]) + "-" + S4(buf[3]) + "-" + S4(buf[4]) + "-" + S4(buf[5]) + S4(buf[6]) + S4(buf[7]));
        }
        :
            function () { return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            }); };
    function hasValue(value) {
        return value !== undefined && value !== null;
    }
    Triarc.hasValue = hasValue;
    function hasNoValue(value) {
        return !Triarc.hasValue(value);
    }
    Triarc.hasNoValue = hasNoValue;
    function isTrue(value) {
        if (Triarc.hasNoValue(value))
            return false;
        return value;
    }
    Triarc.isTrue = isTrue;
    function getOrdinals(anEnum) {
        return Enum.getOrdinals(anEnum);
    }
    Triarc.getOrdinals = getOrdinals;
    function getEnumValue(anEnum, index) {
        return Enum.getEnumValue(anEnum, index);
    }
    Triarc.getEnumValue = getEnumValue;
    function getNames(anEnum) {
        return Enum.getNames(anEnum);
    }
    Triarc.getNames = getNames;
    var Enum;
    (function (Enum) {
        function getNames(anEnum) {
            var enumNames = [];
            Enum.forEach(anEnum, function (val, name) {
                enumNames.push(name);
            });
            return enumNames;
        }
        Enum.getNames = getNames;
        function getEnumValue(anEnum, index) {
            var ordinals = getOrdinals(anEnum);
            return ordinals[index];
        }
        Enum.getEnumValue = getEnumValue;
        function getOrdinals(anEnum) {
            var enumValues = [];
            Enum.forEach(anEnum, function (val, name) {
                enumValues.push(val);
            });
            return enumValues;
        }
        Enum.getOrdinals = getOrdinals;
        function forEach(anEnum, callback) {
            for (var val in anEnum) {
                var name = anEnum[val];
                if (typeof (name) === "string") {
                    callback(anEnum[name], name);
                }
            }
        }
        Enum.forEach = forEach;
        function containsFlag(flag, enumValue) {
            return (flag & enumValue) === flag;
        }
        Enum.containsFlag = containsFlag;
        function addFlag(flag, enumValue) {
            return flag | enumValue;
        }
        Enum.addFlag = addFlag;
        function removeFlag(flag, enumValue) {
            return (flag ^ enumValue) & enumValue;
        }
        Enum.removeFlag = removeFlag;
    })(Enum = Triarc.Enum || (Triarc.Enum = {}));
    function arrayHasValues(array) {
        return angular.isArray(array) && array.length > 0;
    }
    Triarc.arrayHasValues = arrayHasValues;
    //export function contains(array: any[], value: any): boolean {
    //    for (var i = 0; i < array.length; i++) {
    //        if (array[i] === value) {
    //            return true;
    //        }
    //    }
    //    return false;
    //}
    function strContains(str, value) {
        return angular.isString(str) && str.indexOf(value) !== -1;
    }
    Triarc.strContains = strContains;
    function randomNumber(start, end) {
        return Math.floor(Math.random() * end) + start;
    }
    Triarc.randomNumber = randomNumber;
    function strNotEmpty(str) {
        return angular.isString(str) && str.length > 0;
    }
    Triarc.strNotEmpty = strNotEmpty;
    function strIsEmpty(str) {
        return !angular.isString(str) || str.length === 0;
    }
    Triarc.strIsEmpty = strIsEmpty;
    var FLOAT_REGEXP = /^(\-|\+)?\d+((\.|\,)\d+)?$/;
    function validFloat(value, greaterThan) {
        return FLOAT_REGEXP.test(value) && (Triarc.hasValue(greaterThan) ? value > 0 : true);
    }
    Triarc.validFloat = validFloat;
    function validNumber(value, greaterThan) {
        return angular.isNumber(value) && (Triarc.hasValue(greaterThan) ? value > 0 : true);
    }
    Triarc.validNumber = validNumber;
    function getRandomChars(valueStr, numberOf) {
        var returnValue = "";
        // cycle through n number of times and get random bytes from the contents of the file
        for (var i = 0; i < numberOf; i++) {
            var randomPosition = Triarc.randomNumber(0, valueStr.length);
            returnValue += valueStr.charAt(randomPosition);
        }
        return returnValue;
    }
    Triarc.getRandomChars = getRandomChars;
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Dom;
    (function (Dom) {
        function maintainHeightWithWindowSizeHandler(element, eventType, percentage, resizeComponentFn, offsetFactor) {
            element[0].addEventListener(eventType, function () {
                resizeComponentFn($(element).height(), calculateHeightPercentageElement(element, percentage, offsetFactor));
            }, true);
            return calculateHeightPercentageElement(element, percentage, offsetFactor);
        }
        Dom.maintainHeightWithWindowSizeHandler = maintainHeightWithWindowSizeHandler;
        function calculateHeightPercentageElement(element, percentage, offsetFactor) {
            var elementHeight = Triarc.hasValue(offsetFactor) ? $(element).height() - offsetFactor : $(element).height();
            return (percentage / 100) * elementHeight;
        }
        Dom.calculateHeightPercentageElement = calculateHeightPercentageElement;
        function maintainWidthWithWindowSizeHandler(element, eventType, percentage, resizeComponentFn, offsetFactor) {
            element[0].addEventListener(eventType, function () {
                resizeComponentFn($(element).width(), calculateWidthPercentageElement(element, percentage, offsetFactor));
            }, true);
            return calculateWidthPercentageElement(element, percentage, offsetFactor);
        }
        Dom.maintainWidthWithWindowSizeHandler = maintainWidthWithWindowSizeHandler;
        function calculateWidthPercentageElement(element, percentage, offsetFactor) {
            var elementWidth = Triarc.hasValue(offsetFactor) ? $(element).width() - offsetFactor : $(element).width();
            return (percentage / 100) * elementWidth;
        }
        Dom.calculateWidthPercentageElement = calculateWidthPercentageElement;
        function isCloseToTop(element, scrollingElement, withinPx) {
            var top = $(element).offset().top;
            return top >= 0 && (top <= (withinPx));
        }
        Dom.isCloseToTop = isCloseToTop;
        function isCloseToLeft(element, scrollingElement, withinPx) {
            var left = $(element).offset().left - $(scrollingElement).offset().left;
            return (left >= 0) && (left <= (withinPx));
        }
        Dom.isCloseToLeft = isCloseToLeft;
        function isCloseToRight(element, scrollingElement, withinPx) {
            var width = scrollingElement.width() - scrollingElement.scrollLeft();
            var bounds = element.getBoundingClientRect();
            return (width + withinPx) < bounds.right;
        }
        Dom.isCloseToRight = isCloseToRight;
        function isCloseToBottom(element, scrollingElement, withinPx) {
            var jqScrollingElem = $(scrollingElement);
            var height = jqScrollingElem.height();
            var top = $(element).offset().top - jqScrollingElem.offset().top;
            return (height > top) && (top >= (height - withinPx));
        }
        Dom.isCloseToBottom = isCloseToBottom;
    })(Dom = Triarc.Dom || (Triarc.Dom = {}));
})(Triarc || (Triarc = {}));


(function(B,p){var r=function(a){return a},C=function(){return!0},k=function(){},x=typeof p,A={"":r},e={createLambda:function(a){if(null==a)return r;if("string"===typeof a){var b=A[a];if(null!=b)return b;if(-1===a.indexOf("=>")){for(var c=RegExp("[$]+","g"),b=0,f;null!=(f=c.exec(a));)f=f[0].length,f>b&&(b=f);c=[];for(f=1;f<=b;f++){for(var d="",e=0;e<f;e++)d+="$";c.push(d)}b=Array.prototype.join.call(c,",");b=new Function(b,"return "+a)}else b=a.match(/^[(\s]*([^()]*?)[)\s]*=>(.*)/),b=new Function(b[1],
"return "+b[2]);return A[a]=b}return a},isIEnumerable:function(a){if(typeof Enumerator!==x)try{return new Enumerator(a),!0}catch(b){}return!1},defineProperty:null!=Object.defineProperties?function(a,b,c){Object.defineProperty(a,b,{enumerable:!1,configurable:!0,writable:!0,value:c})}:function(a,b,c){a[b]=c},compare:function(a,b){return a===b?0:a>b?1:-1},dispose:function(a){null!=a&&a.dispose()}},g=function(a,b,c){var f=new D,d=0;this.current=f.current;this.moveNext=function(){try{switch(d){case 0:d=
1,a();case 1:if(b.apply(f))return!0;this.dispose();return!1;case 2:return!1}}catch(c){throw this.dispose(),c;}};this.dispose=function(){if(1==d)try{c()}finally{d=2}}},D=function(){var a=null;this.current=function(){return a};this.yieldReturn=function(b){a=b;return!0};this.yieldBreak=function(){return!1}},d=function(a){this.getEnumerator=a};d.Utils={};d.Utils.createLambda=function(a){return e.createLambda(a)};d.Utils.createEnumerable=function(a){return new d(a)};d.Utils.createEnumerator=function(a,
b,c){return new g(a,b,c)};d.Utils.extendTo=function(a){var b=a.prototype;a===Array?(a=m.prototype,e.defineProperty(b,"getSource",function(){return this})):(a=d.prototype,e.defineProperty(b,"getEnumerator",function(){return d.from(this).getEnumerator()}));for(var c in a){var f=a[c];if(b[c]!=f){if(null!=b[c]&&(c+="ByLinq",b[c]==f))continue;f instanceof Function&&e.defineProperty(b,c,f)}}};d.choice=function(){var a=arguments;return new d(function(){return new g(function(){a=a[0]instanceof Array?a[0]:
null!=a[0].getEnumerator?a[0].toArray():a},function(){return this.yieldReturn(a[Math.floor(Math.random()*a.length)])},k)})};d.cycle=function(){var a=arguments;return new d(function(){var b=0;return new g(function(){a=a[0]instanceof Array?a[0]:null!=a[0].getEnumerator?a[0].toArray():a},function(){b>=a.length&&(b=0);return this.yieldReturn(a[b++])},k)})};d.empty=function(){return new d(function(){return new g(k,function(){return!1},k)})};d.from=function(a){if(null==a)return d.empty();if(a instanceof
d)return a;if("number"==typeof a||"boolean"==typeof a)return d.repeat(a,1);if("string"==typeof a)return new d(function(){var b=0;return new g(k,function(){return b<a.length?this.yieldReturn(a.charAt(b++)):!1},k)});if("function"!=typeof a){if("number"==typeof a.length)return new m(a);if(!(a instanceof Object)&&e.isIEnumerable(a))return new d(function(){var b=!0,c;return new g(function(){c=new Enumerator(a)},function(){b?b=!1:c.moveNext();return c.atEnd()?!1:this.yieldReturn(c.item())},k)});if("object"===
typeof Windows&&"function"===typeof a.first)return new d(function(){var b=!0,c;return new g(function(){c=a.first()},function(){b?b=!1:c.moveNext();return c.hasCurrent?this.yieldReturn(c.current):this.yieldBreak()},k)})}return new d(function(){var b=[],c=0;return new g(function(){for(var c in a){var d=a[c];d instanceof Function||!Object.prototype.hasOwnProperty.call(a,c)||b.push({key:c,value:d})}},function(){return c<b.length?this.yieldReturn(b[c++]):!1},k)})};d.make=function(a){return d.repeat(a,
1)};d.matches=function(a,b,c){null==c&&(c="");b instanceof RegExp&&(c+=b.ignoreCase?"i":"",c+=b.multiline?"m":"",b=b.source);-1===c.indexOf("g")&&(c+="g");return new d(function(){var f;return new g(function(){f=RegExp(b,c)},function(){var b=f.exec(a);return b?this.yieldReturn(b):!1},k)})};d.range=function(a,b,c){null==c&&(c=1);return new d(function(){var f,d=0;return new g(function(){f=a-c},function(){return d++<b?this.yieldReturn(f+=c):this.yieldBreak()},k)})};d.rangeDown=function(a,b,c){null==c&&
(c=1);return new d(function(){var f,d=0;return new g(function(){f=a+c},function(){return d++<b?this.yieldReturn(f-=c):this.yieldBreak()},k)})};d.rangeTo=function(a,b,c){null==c&&(c=1);return a<b?new d(function(){var f;return new g(function(){f=a-c},function(){var a=f+=c;return a<=b?this.yieldReturn(a):this.yieldBreak()},k)}):new d(function(){var f;return new g(function(){f=a+c},function(){var a=f-=c;return a>=b?this.yieldReturn(a):this.yieldBreak()},k)})};d.repeat=function(a,b){return null!=b?d.repeat(a).take(b):
new d(function(){return new g(k,function(){return this.yieldReturn(a)},k)})};d.repeatWithFinalize=function(a,b){a=e.createLambda(a);b=e.createLambda(b);return new d(function(){var c;return new g(function(){c=a()},function(){return this.yieldReturn(c)},function(){null!=c&&(b(c),c=null)})})};d.generate=function(a,b){if(null!=b)return d.generate(a).take(b);a=e.createLambda(a);return new d(function(){return new g(k,function(){return this.yieldReturn(a())},k)})};d.toInfinity=function(a,b){null==a&&(a=
0);null==b&&(b=1);return new d(function(){var c;return new g(function(){c=a-b},function(){return this.yieldReturn(c+=b)},k)})};d.toNegativeInfinity=function(a,b){null==a&&(a=0);null==b&&(b=1);return new d(function(){var c;return new g(function(){c=a+b},function(){return this.yieldReturn(c-=b)},k)})};d.unfold=function(a,b){b=e.createLambda(b);return new d(function(){var c=!0,f;return new g(k,function(){if(c)return c=!1,f=a,this.yieldReturn(f);f=b(f);return this.yieldReturn(f)},k)})};d.defer=function(a){return new d(function(){var b;
return new g(function(){b=d.from(a()).getEnumerator()},function(){return b.moveNext()?this.yieldReturn(b.current()):this.yieldBreak()},function(){e.dispose(b)})})};d.prototype.traverseBreadthFirst=function(a,b){var c=this;a=e.createLambda(a);b=e.createLambda(b);return new d(function(){var f,h=0,l=[];return new g(function(){f=c.getEnumerator()},function(){for(;;){if(f.moveNext())return l.push(f.current()),this.yieldReturn(b(f.current(),h));var c=d.from(l).selectMany(function(b){return a(b)});if(c.any())h++,
l=[],e.dispose(f),f=c.getEnumerator();else return!1}},function(){e.dispose(f)})})};d.prototype.traverseDepthFirst=function(a,b){var c=this;a=e.createLambda(a);b=e.createLambda(b);return new d(function(){var f=[],h;return new g(function(){h=c.getEnumerator()},function(){for(;;){if(h.moveNext()){var c=b(h.current(),f.length);f.push(h);h=d.from(a(h.current())).getEnumerator();return this.yieldReturn(c)}if(0>=f.length)return!1;e.dispose(h);h=f.pop()}},function(){try{e.dispose(h)}finally{d.from(f).forEach(function(a){a.dispose()})}})})};
d.prototype.flatten=function(){var a=this;return new d(function(){var b,c=null;return new g(function(){b=a.getEnumerator()},function(){for(;;){if(null!=c){if(c.moveNext())return this.yieldReturn(c.current());c=null}if(b.moveNext())if(b.current()instanceof Array){e.dispose(c);c=d.from(b.current()).selectMany(r).flatten().getEnumerator();continue}else return this.yieldReturn(b.current());return!1}},function(){try{e.dispose(b)}finally{e.dispose(c)}})})};d.prototype.pairwise=function(a){var b=this;a=
e.createLambda(a);return new d(function(){var c;return new g(function(){c=b.getEnumerator();c.moveNext()},function(){var b=c.current();return c.moveNext()?this.yieldReturn(a(b,c.current())):!1},function(){e.dispose(c)})})};d.prototype.scan=function(a,b){var c;null==b?(b=e.createLambda(a),c=!1):(b=e.createLambda(b),c=!0);var f=this;return new d(function(){var d,l,n=!0;return new g(function(){d=f.getEnumerator()},function(){if(n){n=!1;if(c)return this.yieldReturn(l=a);if(d.moveNext())return this.yieldReturn(l=
d.current())}return d.moveNext()?this.yieldReturn(l=b(l,d.current())):!1},function(){e.dispose(d)})})};d.prototype.select=function(a){a=e.createLambda(a);if(1>=a.length)return new t(this,null,a);var b=this;return new d(function(){var c,d=0;return new g(function(){c=b.getEnumerator()},function(){return c.moveNext()?this.yieldReturn(a(c.current(),d++)):!1},function(){e.dispose(c)})})};d.prototype.selectMany=function(a,b){var c=this;a=e.createLambda(a);null==b&&(b=function(a,b){return b});b=e.createLambda(b);
return new d(function(){var f,h=p,l=0;return new g(function(){f=c.getEnumerator()},function(){if(h===p&&!f.moveNext())return!1;do{if(null==h){var c=a(f.current(),l++);h=d.from(c).getEnumerator()}if(h.moveNext())return this.yieldReturn(b(f.current(),h.current()));e.dispose(h);h=null}while(f.moveNext());return!1},function(){try{e.dispose(f)}finally{e.dispose(h)}})})};d.prototype.where=function(a){a=e.createLambda(a);if(1>=a.length)return new u(this,a);var b=this;return new d(function(){var c,d=0;return new g(function(){c=
b.getEnumerator()},function(){for(;c.moveNext();)if(a(c.current(),d++))return this.yieldReturn(c.current());return!1},function(){e.dispose(c)})})};d.prototype.choose=function(a){a=e.createLambda(a);var b=this;return new d(function(){var c,d=0;return new g(function(){c=b.getEnumerator()},function(){for(;c.moveNext();){var b=a(c.current(),d++);if(null!=b)return this.yieldReturn(b)}return this.yieldBreak()},function(){e.dispose(c)})})};d.prototype.ofType=function(a){var b;switch(a){case Number:b="number";
break;case String:b="string";break;case Boolean:b="boolean";break;case Function:b="function";break;default:b=null}return null===b?this.where(function(b){return b instanceof a}):this.where(function(a){return typeof a===b})};d.prototype.zip=function(){var a=arguments,b=e.createLambda(arguments[arguments.length-1]),c=this;if(2==arguments.length){var f=arguments[0];return new d(function(){var a,l,n=0;return new g(function(){a=c.getEnumerator();l=d.from(f).getEnumerator()},function(){return a.moveNext()&&
l.moveNext()?this.yieldReturn(b(a.current(),l.current(),n++)):!1},function(){try{e.dispose(a)}finally{e.dispose(l)}})})}return new d(function(){var f,l=0;return new g(function(){var b=d.make(c).concat(d.from(a).takeExceptLast().select(d.from)).select(function(a){return a.getEnumerator()}).toArray();f=d.from(b)},function(){if(f.all(function(a){return a.moveNext()})){var a=f.select(function(a){return a.current()}).toArray();a.push(l++);return this.yieldReturn(b.apply(null,a))}return this.yieldBreak()},
function(){d.from(f).forEach(e.dispose)})})};d.prototype.merge=function(){var a=arguments,b=this;return new d(function(){var c,f=-1;return new g(function(){c=d.make(b).concat(d.from(a).select(d.from)).select(function(a){return a.getEnumerator()}).toArray()},function(){for(;0<c.length;){f=f>=c.length-1?0:f+1;var a=c[f];if(a.moveNext())return this.yieldReturn(a.current());a.dispose();c.splice(f--,1)}return this.yieldBreak()},function(){d.from(c).forEach(e.dispose)})})};d.prototype.join=function(a,b,
c,f,h){b=e.createLambda(b);c=e.createLambda(c);f=e.createLambda(f);h=e.createLambda(h);var l=this;return new d(function(){var n,q,k=null,m=0;return new g(function(){n=l.getEnumerator();q=d.from(a).toLookup(c,r,h)},function(){for(;;){if(null!=k){var a=k[m++];if(a!==p)return this.yieldReturn(f(n.current(),a));m=0}if(n.moveNext())a=b(n.current()),k=q.get(a).toArray();else return!1}},function(){e.dispose(n)})})};d.prototype.groupJoin=function(a,b,c,f,h){b=e.createLambda(b);c=e.createLambda(c);f=e.createLambda(f);
h=e.createLambda(h);var l=this;return new d(function(){var n=l.getEnumerator(),q=null;return new g(function(){n=l.getEnumerator();q=d.from(a).toLookup(c,r,h)},function(){if(n.moveNext()){var a=q.get(b(n.current()));return this.yieldReturn(f(n.current(),a))}return!1},function(){e.dispose(n)})})};d.prototype.all=function(a){a=e.createLambda(a);var b=!0;this.forEach(function(c){if(!a(c))return b=!1});return b};d.prototype.any=function(a){a=e.createLambda(a);var b=this.getEnumerator();try{if(0==arguments.length)return b.moveNext();
for(;b.moveNext();)if(a(b.current()))return!0;return!1}finally{e.dispose(b)}};d.prototype.isEmpty=function(){return!this.any()};d.prototype.concat=function(){var a=this;if(1==arguments.length){var b=arguments[0];return new d(function(){var c,h;return new g(function(){c=a.getEnumerator()},function(){if(null==h){if(c.moveNext())return this.yieldReturn(c.current());h=d.from(b).getEnumerator()}return h.moveNext()?this.yieldReturn(h.current()):!1},function(){try{e.dispose(c)}finally{e.dispose(h)}})})}var c=
arguments;return new d(function(){var b;return new g(function(){b=d.make(a).concat(d.from(c).select(d.from)).select(function(a){return a.getEnumerator()}).toArray()},function(){for(;0<b.length;){var a=b[0];if(a.moveNext())return this.yieldReturn(a.current());a.dispose();b.splice(0,1)}return this.yieldBreak()},function(){d.from(b).forEach(e.dispose)})})};d.prototype.insert=function(a,b){var c=this;return new d(function(){var f,h,l=0,n=!1;return new g(function(){f=c.getEnumerator();h=d.from(b).getEnumerator()},
function(){return l==a&&h.moveNext()?(n=!0,this.yieldReturn(h.current())):f.moveNext()?(l++,this.yieldReturn(f.current())):!n&&h.moveNext()?this.yieldReturn(h.current()):!1},function(){try{e.dispose(f)}finally{e.dispose(h)}})})};d.prototype.alternate=function(a){var b=this;return new d(function(){var c,f,h,l;return new g(function(){h=a instanceof Array||null!=a.getEnumerator?d.from(d.from(a).toArray()):d.make(a);f=b.getEnumerator();f.moveNext()&&(c=f.current())},function(){for(;;){if(null!=l){if(l.moveNext())return this.yieldReturn(l.current());
l=null}if(null==c&&f.moveNext())c=f.current(),l=h.getEnumerator();else{if(null!=c){var a=c;c=null;return this.yieldReturn(a)}return this.yieldBreak()}}},function(){try{e.dispose(f)}finally{e.dispose(l)}})})};d.prototype.contains=function(a,b){b=e.createLambda(b);var c=this.getEnumerator();try{for(;c.moveNext();)if(b(c.current())===a)return!0;return!1}finally{e.dispose(c)}};d.prototype.defaultIfEmpty=function(a){var b=this;a===p&&(a=null);return new d(function(){var c,d=!0;return new g(function(){c=
b.getEnumerator()},function(){return c.moveNext()?(d=!1,this.yieldReturn(c.current())):d?(d=!1,this.yieldReturn(a)):!1},function(){e.dispose(c)})})};d.prototype.distinct=function(a){return this.except(d.empty(),a)};d.prototype.distinctUntilChanged=function(a){a=e.createLambda(a);var b=this;return new d(function(){var c,d,h;return new g(function(){c=b.getEnumerator()},function(){for(;c.moveNext();){var b=a(c.current());if(h)return h=!1,d=b,this.yieldReturn(c.current());if(d!==b)return d=b,this.yieldReturn(c.current())}return this.yieldBreak()},
function(){e.dispose(c)})})};d.prototype.except=function(a,b){b=e.createLambda(b);var c=this;return new d(function(){var f,h;return new g(function(){f=c.getEnumerator();h=new v(b);d.from(a).forEach(function(a){h.add(a)})},function(){for(;f.moveNext();){var a=f.current();if(!h.contains(a))return h.add(a),this.yieldReturn(a)}return!1},function(){e.dispose(f)})})};d.prototype.intersect=function(a,b){b=e.createLambda(b);var c=this;return new d(function(){var f,h,l;return new g(function(){f=c.getEnumerator();
h=new v(b);d.from(a).forEach(function(a){h.add(a)});l=new v(b)},function(){for(;f.moveNext();){var a=f.current();if(!l.contains(a)&&h.contains(a))return l.add(a),this.yieldReturn(a)}return!1},function(){e.dispose(f)})})};d.prototype.sequenceEqual=function(a,b){b=e.createLambda(b);var c=this.getEnumerator();try{var f=d.from(a).getEnumerator();try{for(;c.moveNext();)if(!f.moveNext()||b(c.current())!==b(f.current()))return!1;return f.moveNext()?!1:!0}finally{e.dispose(f)}}finally{e.dispose(c)}};d.prototype.union=
function(a,b){b=e.createLambda(b);var c=this;return new d(function(){var f,h,l;return new g(function(){f=c.getEnumerator();l=new v(b)},function(){var b;if(h===p){for(;f.moveNext();)if(b=f.current(),!l.contains(b))return l.add(b),this.yieldReturn(b);h=d.from(a).getEnumerator()}for(;h.moveNext();)if(b=h.current(),!l.contains(b))return l.add(b),this.yieldReturn(b);return!1},function(){try{e.dispose(f)}finally{e.dispose(h)}})})};d.prototype.orderBy=function(a){return new s(this,a,!1)};d.prototype.orderByDescending=
function(a){return new s(this,a,!0)};d.prototype.reverse=function(){var a=this;return new d(function(){var b,c;return new g(function(){b=a.toArray();c=b.length},function(){return 0<c?this.yieldReturn(b[--c]):!1},k)})};d.prototype.shuffle=function(){var a=this;return new d(function(){var b;return new g(function(){b=a.toArray()},function(){if(0<b.length){var a=Math.floor(Math.random()*b.length);return this.yieldReturn(b.splice(a,1)[0])}return!1},k)})};d.prototype.weightedSample=function(a){a=e.createLambda(a);
var b=this;return new d(function(){var c,d=0;return new g(function(){c=b.choose(function(b){var c=a(b);if(0>=c)return null;d+=c;return{value:b,bound:d}}).toArray()},function(){if(0<c.length){for(var a=Math.floor(Math.random()*d)+1,b=-1,e=c.length;1<e-b;){var g=Math.floor((b+e)/2);c[g].bound>=a?e=g:b=g}return this.yieldReturn(c[e].value)}return this.yieldBreak()},k)})};d.prototype.groupBy=function(a,b,c,f){var h=this;a=e.createLambda(a);b=e.createLambda(b);null!=c&&(c=e.createLambda(c));f=e.createLambda(f);
return new d(function(){var d;return new g(function(){d=h.toLookup(a,b,f).toEnumerable().getEnumerator()},function(){for(;d.moveNext();)return null==c?this.yieldReturn(d.current()):this.yieldReturn(c(d.current().key(),d.current()));return!1},function(){e.dispose(d)})})};d.prototype.partitionBy=function(a,b,c,f){var h=this;a=e.createLambda(a);b=e.createLambda(b);f=e.createLambda(f);var l;null==c?(l=!1,c=function(a,b){return new y(a,b)}):(l=!0,c=e.createLambda(c));return new d(function(){var n,q,k,
m=[];return new g(function(){n=h.getEnumerator();n.moveNext()&&(q=a(n.current()),k=f(q),m.push(b(n.current())))},function(){for(var h;!0==(h=n.moveNext());)if(k===f(a(n.current())))m.push(b(n.current()));else break;if(0<m.length){var e=l?c(q,d.from(m)):c(q,m);h?(q=a(n.current()),k=f(q),m=[b(n.current())]):m=[];return this.yieldReturn(e)}return!1},function(){e.dispose(n)})})};d.prototype.buffer=function(a){var b=this;return new d(function(){var c;return new g(function(){c=b.getEnumerator()},function(){for(var b=
[],d=0;c.moveNext();)if(b.push(c.current()),++d>=a)return this.yieldReturn(b);return 0<b.length?this.yieldReturn(b):!1},function(){e.dispose(c)})})};d.prototype.aggregate=function(a,b,c){c=e.createLambda(c);return c(this.scan(a,b,c).last())};d.prototype.average=function(a){a=e.createLambda(a);var b=0,c=0;this.forEach(function(d){b+=a(d);++c});return b/c};d.prototype.count=function(a){a=null==a?C:e.createLambda(a);var b=0;this.forEach(function(c,d){a(c,d)&&++b});return b};d.prototype.max=function(a){null==
a&&(a=r);return this.select(a).aggregate(function(a,c){return a>c?a:c})};d.prototype.min=function(a){null==a&&(a=r);return this.select(a).aggregate(function(a,c){return a<c?a:c})};d.prototype.maxBy=function(a){a=e.createLambda(a);return this.aggregate(function(b,c){return a(b)>a(c)?b:c})};d.prototype.minBy=function(a){a=e.createLambda(a);return this.aggregate(function(b,c){return a(b)<a(c)?b:c})};d.prototype.sum=function(a){null==a&&(a=r);return this.select(a).aggregate(0,function(a,c){return a+c})};
d.prototype.elementAt=function(a){var b,c=!1;this.forEach(function(d,h){if(h==a)return b=d,c=!0,!1});if(!c)throw Error("index is less than 0 or greater than or equal to the number of elements in source.");return b};d.prototype.elementAtOrDefault=function(a,b){b===p&&(b=null);var c,d=!1;this.forEach(function(b,e){if(e==a)return c=b,d=!0,!1});return d?c:b};d.prototype.first=function(a){if(null!=a)return this.where(a).first();var b,c=!1;this.forEach(function(a){b=a;c=!0;return!1});if(!c)throw Error("first:No element satisfies the condition.");
return b};d.prototype.firstOrDefault=function(a,b){b===p&&(b=null);if(null!=a)return this.where(a).firstOrDefault(null,b);var c,d=!1;this.forEach(function(a){c=a;d=!0;return!1});return d?c:b};d.prototype.last=function(a){if(null!=a)return this.where(a).last();var b,c=!1;this.forEach(function(a){c=!0;b=a});if(!c)throw Error("last:No element satisfies the condition.");return b};d.prototype.lastOrDefault=function(a,b){b===p&&(b=null);if(null!=a)return this.where(a).lastOrDefault(null,b);var c,d=!1;this.forEach(function(a){d=
!0;c=a});return d?c:b};d.prototype.single=function(a){if(null!=a)return this.where(a).single();var b,c=!1;this.forEach(function(a){if(c)throw Error("single:sequence contains more than one element.");c=!0;b=a});if(!c)throw Error("single:No element satisfies the condition.");return b};d.prototype.singleOrDefault=function(a,b){b===p&&(b=null);if(null!=a)return this.where(a).singleOrDefault(null,b);var c,d=!1;this.forEach(function(a){if(d)throw Error("single:sequence contains more than one element.");
d=!0;c=a});return d?c:b};d.prototype.skip=function(a){var b=this;return new d(function(){var c,d=0;return new g(function(){for(c=b.getEnumerator();d++<a&&c.moveNext(););},function(){return c.moveNext()?this.yieldReturn(c.current()):!1},function(){e.dispose(c)})})};d.prototype.skipWhile=function(a){a=e.createLambda(a);var b=this;return new d(function(){var c,d=0,h=!1;return new g(function(){c=b.getEnumerator()},function(){for(;!h;)if(c.moveNext()){if(!a(c.current(),d++))return h=!0,this.yieldReturn(c.current())}else return!1;
return c.moveNext()?this.yieldReturn(c.current()):!1},function(){e.dispose(c)})})};d.prototype.take=function(a){var b=this;return new d(function(){var c,d=0;return new g(function(){c=b.getEnumerator()},function(){return d++<a&&c.moveNext()?this.yieldReturn(c.current()):!1},function(){e.dispose(c)})})};d.prototype.takeWhile=function(a){a=e.createLambda(a);var b=this;return new d(function(){var c,d=0;return new g(function(){c=b.getEnumerator()},function(){return c.moveNext()&&a(c.current(),d++)?this.yieldReturn(c.current()):
!1},function(){e.dispose(c)})})};d.prototype.takeExceptLast=function(a){null==a&&(a=1);var b=this;return new d(function(){if(0>=a)return b.getEnumerator();var c,d=[];return new g(function(){c=b.getEnumerator()},function(){for(;c.moveNext();){if(d.length==a)return d.push(c.current()),this.yieldReturn(d.shift());d.push(c.current())}return!1},function(){e.dispose(c)})})};d.prototype.takeFromLast=function(a){if(0>=a||null==a)return d.empty();var b=this;return new d(function(){var c,f,h=[];return new g(function(){c=
b.getEnumerator()},function(){for(;c.moveNext();)h.length==a&&h.shift(),h.push(c.current());null==f&&(f=d.from(h).getEnumerator());return f.moveNext()?this.yieldReturn(f.current()):!1},function(){e.dispose(f)})})};d.prototype.indexOf=function(a){var b=null;"function"===typeof a?this.forEach(function(c,d){if(a(c,d))return b=d,!1}):this.forEach(function(c,d){if(c===a)return b=d,!1});return null!==b?b:-1};d.prototype.lastIndexOf=function(a){var b=-1;"function"===typeof a?this.forEach(function(c,d){a(c,
d)&&(b=d)}):this.forEach(function(c,d){c===a&&(b=d)});return b};d.prototype.cast=function(){return this};d.prototype.asEnumerable=function(){return d.from(this)};d.prototype.toArray=function(){var a=[];this.forEach(function(b){a.push(b)});return a};d.prototype.toLookup=function(a,b,c){a=e.createLambda(a);b=e.createLambda(b);c=e.createLambda(c);var d=new v(c);this.forEach(function(c){var e=a(c);c=b(c);var g=d.get(e);g!==p?g.push(c):d.add(e,[c])});return new E(d)};d.prototype.toObject=function(a,b){a=
e.createLambda(a);b=e.createLambda(b);var c={};this.forEach(function(d){c[a(d)]=b(d)});return c};d.prototype.toDictionary=function(a,b,c){a=e.createLambda(a);b=e.createLambda(b);c=e.createLambda(c);var d=new v(c);this.forEach(function(c){d.add(a(c),b(c))});return d};d.prototype.toJSONString=function(a,b){if(typeof JSON===x||null==JSON.stringify)throw Error("toJSONString can't find JSON.stringify. This works native JSON support Browser or include json2.js");return JSON.stringify(this.toArray(),a,b)};
d.prototype.toJoinedString=function(a,b){null==a&&(a="");null==b&&(b=r);return this.select(b).toArray().join(a)};d.prototype.doAction=function(a){var b=this;a=e.createLambda(a);return new d(function(){var c,d=0;return new g(function(){c=b.getEnumerator()},function(){return c.moveNext()?(a(c.current(),d++),this.yieldReturn(c.current())):!1},function(){e.dispose(c)})})};d.prototype.forEach=function(a){a=e.createLambda(a);var b=0,c=this.getEnumerator();try{for(;c.moveNext()&&!1!==a(c.current(),b++););
}finally{e.dispose(c)}};d.prototype.write=function(a,b){null==a&&(a="");b=e.createLambda(b);var c=!0;this.forEach(function(d){c?c=!1:document.write(a);document.write(b(d))})};d.prototype.writeLine=function(a){a=e.createLambda(a);this.forEach(function(b){document.writeln(a(b)+"<br />")})};d.prototype.force=function(){var a=this.getEnumerator();try{for(;a.moveNext(););}finally{e.dispose(a)}};d.prototype.letBind=function(a){a=e.createLambda(a);var b=this;return new d(function(){var c;return new g(function(){c=
d.from(a(b)).getEnumerator()},function(){return c.moveNext()?this.yieldReturn(c.current()):!1},function(){e.dispose(c)})})};d.prototype.share=function(){var a=this,b,c=!1;return new z(function(){return new g(function(){null==b&&(b=a.getEnumerator())},function(){if(c)throw Error("enumerator is disposed");return b.moveNext()?this.yieldReturn(b.current()):!1},k)},function(){c=!0;e.dispose(b)})};d.prototype.memoize=function(){var a=this,b,c,d=!1;return new z(function(){var e=-1;return new g(function(){null==
c&&(c=a.getEnumerator(),b=[])},function(){if(d)throw Error("enumerator is disposed");e++;return b.length<=e?c.moveNext()?this.yieldReturn(b[e]=c.current()):!1:this.yieldReturn(b[e])},k)},function(){d=!0;e.dispose(c);b=null})};d.prototype.catchError=function(a){a=e.createLambda(a);var b=this;return new d(function(){var c;return new g(function(){c=b.getEnumerator()},function(){try{return c.moveNext()?this.yieldReturn(c.current()):!1}catch(b){return a(b),!1}},function(){e.dispose(c)})})};d.prototype.finallyAction=
function(a){a=e.createLambda(a);var b=this;return new d(function(){var c;return new g(function(){c=b.getEnumerator()},function(){return c.moveNext()?this.yieldReturn(c.current()):!1},function(){try{e.dispose(c)}finally{a()}})})};d.prototype.log=function(a){a=e.createLambda(a);return this.doAction(function(b){typeof console!==x&&console.log(a(b))})};d.prototype.trace=function(a,b){null==a&&(a="Trace");b=e.createLambda(b);return this.doAction(function(c){typeof console!==x&&console.log(a,b(c))})};var s=
function(a,b,c,d){this.source=a;this.keySelector=e.createLambda(b);this.descending=c;this.parent=d};s.prototype=new d;s.prototype.createOrderedEnumerable=function(a,b){return new s(this.source,a,b,this)};s.prototype.thenBy=function(a){return this.createOrderedEnumerable(a,!1)};s.prototype.thenByDescending=function(a){return this.createOrderedEnumerable(a,!0)};s.prototype.getEnumerator=function(){var a=this,b,c,d=0;return new g(function(){b=[];c=[];a.source.forEach(function(a,d){b.push(a);c.push(d)});
var d=w.create(a,null);d.GenerateKeys(b);c.sort(function(a,b){return d.compare(a,b)})},function(){return d<c.length?this.yieldReturn(b[c[d++]]):!1},k)};var w=function(a,b,c){this.keySelector=a;this.descending=b;this.child=c;this.keys=null};w.create=function(a,b){var c=new w(a.keySelector,a.descending,b);return null!=a.parent?w.create(a.parent,c):c};w.prototype.GenerateKeys=function(a){for(var b=a.length,c=this.keySelector,d=Array(b),e=0;e<b;e++)d[e]=c(a[e]);this.keys=d;null!=this.child&&this.child.GenerateKeys(a)};
w.prototype.compare=function(a,b){var c=e.compare(this.keys[a],this.keys[b]);return 0==c?null!=this.child?this.child.compare(a,b):e.compare(a,b):this.descending?-c:c};var z=function(a,b){this.dispose=b;this.getEnumerator=a};z.prototype=new d;var m=function(a){this.getSource=function(){return a}};m.prototype=new d;m.prototype.any=function(a){return null==a?0<this.getSource().length:d.prototype.any.apply(this,arguments)};m.prototype.count=function(a){return null==a?this.getSource().length:d.prototype.count.apply(this,
arguments)};m.prototype.elementAt=function(a){var b=this.getSource();return 0<=a&&a<b.length?b[a]:d.prototype.elementAt.apply(this,arguments)};m.prototype.elementAtOrDefault=function(a,b){b===p&&(b=null);var c=this.getSource();return 0<=a&&a<c.length?c[a]:b};m.prototype.first=function(a){var b=this.getSource();return null==a&&0<b.length?b[0]:d.prototype.first.apply(this,arguments)};m.prototype.firstOrDefault=function(a,b){b===p&&(b=null);if(null!=a)return d.prototype.firstOrDefault.apply(this,arguments);
var c=this.getSource();return 0<c.length?c[0]:b};m.prototype.last=function(a){var b=this.getSource();return null==a&&0<b.length?b[b.length-1]:d.prototype.last.apply(this,arguments)};m.prototype.lastOrDefault=function(a,b){b===p&&(b=null);if(null!=a)return d.prototype.lastOrDefault.apply(this,arguments);var c=this.getSource();return 0<c.length?c[c.length-1]:b};m.prototype.skip=function(a){var b=this.getSource();return new d(function(){var c;return new g(function(){c=0>a?0:a},function(){return c<b.length?
this.yieldReturn(b[c++]):!1},k)})};m.prototype.takeExceptLast=function(a){null==a&&(a=1);return this.take(this.getSource().length-a)};m.prototype.takeFromLast=function(a){return this.skip(this.getSource().length-a)};m.prototype.reverse=function(){var a=this.getSource();return new d(function(){var b;return new g(function(){b=a.length},function(){return 0<b?this.yieldReturn(a[--b]):!1},k)})};m.prototype.sequenceEqual=function(a,b){return(a instanceof m||a instanceof Array)&&null==b&&d.from(a).count()!=
this.count()?!1:d.prototype.sequenceEqual.apply(this,arguments)};m.prototype.toJoinedString=function(a,b){var c=this.getSource();if(null!=b||!(c instanceof Array))return d.prototype.toJoinedString.apply(this,arguments);null==a&&(a="");return c.join(a)};m.prototype.getEnumerator=function(){var a=this.getSource(),b=-1;return{current:function(){return a[b]},moveNext:function(){return++b<a.length},dispose:k}};var u=function(a,b){this.prevSource=a;this.prevPredicate=b};u.prototype=new d;u.prototype.where=
function(a){a=e.createLambda(a);if(1>=a.length){var b=this.prevPredicate;return new u(this.prevSource,function(c){return b(c)&&a(c)})}return d.prototype.where.call(this,a)};u.prototype.select=function(a){a=e.createLambda(a);return 1>=a.length?new t(this.prevSource,this.prevPredicate,a):d.prototype.select.call(this,a)};u.prototype.getEnumerator=function(){var a=this.prevPredicate,b=this.prevSource,c;return new g(function(){c=b.getEnumerator()},function(){for(;c.moveNext();)if(a(c.current()))return this.yieldReturn(c.current());
return!1},function(){e.dispose(c)})};var t=function(a,b,c){this.prevSource=a;this.prevPredicate=b;this.prevSelector=c};t.prototype=new d;t.prototype.where=function(a){a=e.createLambda(a);return 1>=a.length?new u(this,a):d.prototype.where.call(this,a)};t.prototype.select=function(a){a=e.createLambda(a);if(1>=a.length){var b=this.prevSelector;return new t(this.prevSource,this.prevPredicate,function(c){return a(b(c))})}return d.prototype.select.call(this,a)};t.prototype.getEnumerator=function(){var a=
this.prevPredicate,b=this.prevSelector,c=this.prevSource,d;return new g(function(){d=c.getEnumerator()},function(){for(;d.moveNext();)if(null==a||a(d.current()))return this.yieldReturn(b(d.current()));return!1},function(){e.dispose(d)})};var v=function(){var a=function(a){return null===a?"null":a===p?"undefined":"function"===typeof a.toString?a.toString():Object.prototype.toString.call(a)},b=function(a,b){this.key=a;this.value=b;this.next=this.prev=null},c=function(){this.last=this.first=null};c.prototype=
{addLast:function(a){null!=this.last?(this.last.next=a,a.prev=this.last,this.last=a):this.first=this.last=a},replace:function(a,b){null!=a.prev?(a.prev.next=b,b.prev=a.prev):this.first=b;null!=a.next?(a.next.prev=b,b.next=a.next):this.last=b},remove:function(a){null!=a.prev?a.prev.next=a.next:this.first=a.next;null!=a.next?a.next.prev=a.prev:this.last=a.prev}};var e=function(a){this.countField=0;this.entryList=new c;this.buckets={};this.compareSelector=null==a?r:a};e.prototype={add:function(c,d){var e=
this.compareSelector(c),f=a(e),g=new b(c,d);if(Object.prototype.hasOwnProperty.call(this.buckets,f)){for(var f=this.buckets[f],k=0;k<f.length;k++)if(this.compareSelector(f[k].key)===e){this.entryList.replace(f[k],g);f[k]=g;return}f.push(g)}else this.buckets[f]=[g];this.countField++;this.entryList.addLast(g)},get:function(b){b=this.compareSelector(b);var c=a(b);if(!Object.prototype.hasOwnProperty.call(this.buckets,c))return p;for(var c=this.buckets[c],d=0;d<c.length;d++){var e=c[d];if(this.compareSelector(e.key)===
b)return e.value}return p},set:function(c,d){var e=this.compareSelector(c),f=a(e);if(Object.prototype.hasOwnProperty.call(this.buckets,f))for(var f=this.buckets[f],g=0;g<f.length;g++)if(this.compareSelector(f[g].key)===e)return e=new b(c,d),this.entryList.replace(f[g],e),f[g]=e,!0;return!1},contains:function(b){b=this.compareSelector(b);var c=a(b);if(!Object.prototype.hasOwnProperty.call(this.buckets,c))return!1;for(var c=this.buckets[c],d=0;d<c.length;d++)if(this.compareSelector(c[d].key)===b)return!0;
return!1},clear:function(){this.countField=0;this.buckets={};this.entryList=new c},remove:function(b){b=this.compareSelector(b);var c=a(b);if(Object.prototype.hasOwnProperty.call(this.buckets,c))for(var d=this.buckets[c],e=0;e<d.length;e++)if(this.compareSelector(d[e].key)===b){this.entryList.remove(d[e]);d.splice(e,1);0==d.length&&delete this.buckets[c];this.countField--;break}},count:function(){return this.countField},toEnumerable:function(){var a=this;return new d(function(){var b;return new g(function(){b=
a.entryList.first},function(){if(null!=b){var a={key:b.key,value:b.value};b=b.next;return this.yieldReturn(a)}return!1},k)})}};return e}(),E=function(a){this.count=function(){return a.count()};this.get=function(b){return d.from(a.get(b))};this.contains=function(b){return a.contains(b)};this.toEnumerable=function(){return a.toEnumerable().select(function(a){return new y(a.key,a.value)})}},y=function(a,b){this.key=function(){return a};m.call(this,b)};y.prototype=new m;"function"===typeof define&&define.amd?
define("linqjs",[],function(){return d}):typeof module!==x&&module.exports?module.exports=d:B.Enumerable=d})(this);

Array.prototype.any = function () {
    return Triarc.arrayHasValues(this);
};
Array.prototype.get = function (index) {
    return Triarc.arrayHasValues(this) && this.length >= index ? this[index] : null;
};
Array.prototype.first = function () {
    return this.get(0);
};
Array.prototype.last = function () {
    return this.get(this.length - 1);
};
Array.prototype.add = function (object) {
    this.push(object);
};
Array.prototype.addRange = function (objects, prepend) {
    var _this = this;
    if (prepend === void 0) { prepend = false; }
    if (!Triarc.arrayHasValues(objects))
        return;
    if (prepend) {
        objects.unshift(0);
        this.unshift(objects);
    }
    else {
        objects.forEach(function (object) {
            _this.add(object);
        });
    }
};
Array.prototype.clear = function () {
    if (!Triarc.arrayHasValues(this))
        return;
    this.splice(0, this.length);
};
Array.prototype.insert = function (index, object) {
    if (!Triarc.arrayHasValues(this))
        throw "MuttableArray: IndexOutOfBoundsException";
    if (this.length < index)
        throw "MuttableArray: IndexOutOfBoundsException";
    this.splice(index, 0, object);
};
Array.prototype.indexOfObj = function (compareFn, value) {
    var actualObj = this.toEnumerable().firstOrDefault(function (obj) {
        return compareFn(obj) === value;
    });
    return this.indexOf(actualObj);
};
Array.prototype.remove = function (object) {
    var position = this.indexOf(object);
    if (position === -1)
        return true;
    this.splice(position, 1);
    return false;
};
Array.prototype.removeRange = function (objects) {
    var _this = this;
    var found = false;
    if (Triarc.arrayHasValues(objects)) {
        objects.forEach(function (obj) {
            found = found || _this.remove(obj);
        });
    }
    return false;
};
Array.prototype.removeAt = function (index) {
    if (!Triarc.arrayHasValues(this))
        throw "MuttableArray: IndexOutOfBoundsException";
    if (this.length < index)
        throw "MuttableArray: IndexOutOfBoundsException";
    this.splice(index, 1);
};
Array.prototype.removeWhereMatch = function (compareFn) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] != null) {
            if (compareFn(this[i])) {
                this.removeAt(i);
                return true;
            }
        }
    }
    // didnt find it
    return false;
};
Array.prototype.removeWhere = function (compareFn, object) {
    if (!angular.isFunction(compareFn)) {
        throw "MuttableArray: (removeWhere(compareFn: (object: T) => any, object: T): boolean;) accessFn is not a function";
    }
    var identifier = compareFn(object);
    for (var i = 0; i < this.length; i++) {
        if (this[i] != null) {
            var nextIdentifer = compareFn(this[i]);
            if (identifier === nextIdentifer) {
                this.removeAt(i);
                return true;
            }
        }
    }
    // didnt find it
    return false;
};
Array.prototype.clone = function () {
    return angular.copy(this);
};
Array.prototype.replaceAt = function (index, object) {
    if (!Triarc.arrayHasValues(this))
        throw "MuttableArray: IndexOutOfBoundsException";
    if (this.length < index)
        throw "MuttableArray: IndexOutOfBoundsException";
    this[index] = object;
};
Array.prototype.addOrUpdate = function (accessFn, object, allFn) {
    if (!angular.isFunction(accessFn)) {
        throw "MuttableArray: (addOrUpdate(accessFn: (object: T) => any, object: T): boolean;) accessFn is not a function";
    }
    var found = false;
    var identifier = accessFn(object);
    for (var i = 0; i < this.length; i++) {
        if (this[i] != null) {
            var nextIdentifer = accessFn(this[i]);
            if (identifier === nextIdentifer) {
                this[i] = object;
                if (!allFn) {
                    return true;
                }
                found = true;
            }
        }
    }
    if (!found) {
        this.add(object);
    }
    // no update made so add the object
    return false;
};
Array.prototype.contains = function (object) {
    return this.indexOf(object) !== -1;
};
Array.prototype.containsWhere = function (compareFn, object) {
    if (!angular.isFunction(compareFn)) {
        throw "MuttableArray: (removeWhere(compareFn: (object: T) => any, object: T): boolean;) accessFn is not a function";
    }
    var identifier = compareFn(object);
    for (var i = 0; i < this.length; i++) {
        if (this[i] != null) {
            var nextIdentifer = compareFn(this[i]);
            if (identifier === nextIdentifer) {
                return true;
            }
        }
    }
    // didnt find it
    return false;
};
Array.prototype.getUnique = function () {
    var u = {};
    var a = [];
    for (var i = 0, l = this.length; i < l; ++i) {
        if (u.hasOwnProperty(this[i])) {
            continue;
        }
        a.push(this[i]);
        u[this[i]] = 1;
    }
    return a;
};
Array.prototype.replaceWhere = function (compareFn, object) {
    var identifier = compareFn(object);
    for (var i = 0; i < this.length; i++) {
        if (this[i] != null) {
            var nextIdentifer = compareFn(this[i]);
            if (identifier === nextIdentifer) {
                this.replaceAt(this.indexOf(this[i]), object);
                break;
            }
        }
    }
};
Array.prototype.toEnumerable = function () {
    return Enumerable.from(this);
};
Map.prototype.getValues = function () {
    var values = [];
    this.forEach(function (val) {
        values.push(val);
    });
    return values;
};


var Triarc;
(function (Triarc) {
    var Data;
    (function (Data) {
        var DataRequest = (function () {
            function DataRequest(method, url, data, managedType, returnType, sendData) {
                this.method = method;
                this.url = url;
                this.data = data;
                this.managedType = managedType;
                this.returnType = returnType;
                this.sendData = sendData;
            }
            return DataRequest;
        }());
        Data.DataRequest = DataRequest;
    })(Data = Triarc.Data || (Triarc.Data = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Data;
    (function (Data) {
        var DataResponse = (function () {
            function DataResponse(data, status, httpReponse) {
                if (status === void 0) { status = Data.RequestStatus.Success; }
                this.data = data;
                this.status = status;
                this.httpReponse = httpReponse;
            }
            DataResponse.prototype.isSuccessful = function () {
                return this.status == RequestStatus.Success;
            };
            DataResponse.prototype.isFailure = function () {
                return this.status = RequestStatus.Failure;
            };
            DataResponse.prototype.isValidationSuccessful = function () {
                return this.status == RequestStatus.ValidationSuccess;
            };
            DataResponse.prototype.isValidationFailure = function () {
                return this.status == RequestStatus.ValidationFailure;
            };
            return DataResponse;
        }());
        Data.DataResponse = DataResponse;
        (function (RequestStatus) {
            RequestStatus[RequestStatus["Success"] = 0] = "Success";
            RequestStatus[RequestStatus["Failure"] = 1] = "Failure";
            RequestStatus[RequestStatus["ValidationFailure"] = 2] = "ValidationFailure";
            RequestStatus[RequestStatus["ValidationSuccess"] = 3] = "ValidationSuccess";
            RequestStatus[RequestStatus["Unknown"] = 4] = "Unknown";
        })(Data.RequestStatus || (Data.RequestStatus = {}));
        var RequestStatus = Data.RequestStatus;
    })(Data = Triarc.Data || (Triarc.Data = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Data;
    (function (Data) {
        function appendUrlParameter(url, key, value) {
            // best guess, just check the url to see if we already have a ? for parameters
            if (url.indexOf("?") == -1) {
                url = url + "?";
            }
            key = encodeURI(key);
            value = encodeURI(value);
            var kvp = url.split('&');
            var i = kvp.length;
            var x;
            while (i--) {
                x = kvp[i].split('=');
                if (x[0] == key) {
                    x[1] = value;
                    kvp[i] = x.join('=');
                    break;
                }
            }
            if (i < 0) {
                kvp[kvp.length] = [key, value].join('=');
            }
            //this will reload the page, it's likely better to store this until finished
            return kvp.join('&');
        }
        Data.appendUrlParameter = appendUrlParameter;
    })(Data = Triarc.Data || (Triarc.Data = {}));
})(Triarc || (Triarc = {}));
/// <reference path="datarequest.ts" />
/// <reference path="dataresponse.ts" />
/// <reference path="urlfunctions.ts" />
var Triarc;
(function (Triarc) {
    var Data;
    (function (Data) {
        angular.module('ng').config([
            "$httpProvider", function ($httpProvider) {
                $httpProvider.defaults.transformResponse.push(function (responseData) {
                    convertDateStringsToDates(responseData);
                    return responseData;
                });
            }
        ]);
        // fixed
        var regexIso8601 = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z$)/;
        function convertDateStringsToDates(input) {
            // Ignore things that aren't objects.
            if (typeof input !== "object")
                return input;
            for (var key in input) {
                if (!input.hasOwnProperty(key))
                    continue;
                var value = input[key];
                var match;
                if (typeof value === "string" && (match = value.match(regexIso8601))) {
                    var parsedDate = Date.parse(match[0]);
                    if (!isNaN(parsedDate)) {
                        input[key] = new Date(parsedDate);
                    }
                }
                else if (typeof value === "object") {
                    // Recurse into object
                    convertDateStringsToDates(value);
                }
            }
            return input;
        }
        Data.convertDateStringsToDates = convertDateStringsToDates;
        Data.mod = angular.module("tlDataServices", []);
        Data.mod.config([
            '$httpProvider', function ($httpProvider) {
                $httpProvider.defaults.headers.post = {
                    'Content-Type': 'application/json'
                };
            }
        ]);
        var RequestSenderService = (function () {
            function RequestSenderService(urlByService, $http, $q, $location) {
                this.urlByService = urlByService;
                this.$http = $http;
                this.$q = $q;
                this.$location = $location;
            }
            RequestSenderService.prototype.getUrl = function (serviceName) {
                var url = this.urlByService[serviceName];
                if (typeof url === "string") {
                    return url;
                }
                else if (typeof url === "function") {
                    return url();
                }
                return "api";
            };
            RequestSenderService.prototype.requestValue = function (dataRequest) {
                var deferred = this.$q.defer();
                // make the http call
                this.$http({
                    method: dataRequest.method,
                    url: dataRequest.url,
                    data: dataRequest.sendData ? dataRequest.data : null
                }).then(function (response) {
                    var responseData = response.data;
                    if (dataRequest.returnType == "boolean")
                        responseData = (responseData == "true" || responseData === true);
                    else if (dataRequest.returnType == "number")
                        responseData = +responseData;
                    else if (dataRequest.returnType != "string" && responseData == "null")
                        responseData = null;
                    deferred.resolve(new Data.DataResponse(responseData, Data.RequestStatus.Success, response));
                }, function (response) {
                    deferred.reject(new Data.DataResponse(response.data, Data.RequestStatus.Failure, response));
                });
                return deferred.promise;
            };
            return RequestSenderService;
        }());
        Data.RequestSenderService = RequestSenderService;
        var RequestSenderProvider = (function () {
            function RequestSenderProvider() {
                var _this = this;
                this.$get = ['$http', '$q', '$location', function ($http, $q, $location) {
                        return new RequestSenderService(_this.urlPerService, $http, $q, $location);
                    }
                ];
                this.urlPerService = {};
            }
            RequestSenderProvider.prototype.setUrl = function (newUrl, proxyServiceName) {
                this.urlPerService[proxyServiceName] = newUrl;
            };
            return RequestSenderProvider;
        }());
        Data.RequestSenderProvider = RequestSenderProvider;
        Data.mod.provider('$requestSender', [RequestSenderProvider]);
    })(Data = Triarc.Data || (Triarc.Data = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Auth;
    (function (Auth) {
        var Events = (function () {
            function Events() {
            }
            Events.Login = "Login";
            Events.Logout = "Logout";
            return Events;
        })();
        Auth.Events = Events;
    })(Auth = Triarc.Auth || (Triarc.Auth = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Auth;
    (function (Auth) {
        ;
        ;
    })(Auth = Triarc.Auth || (Triarc.Auth = {}));
})(Triarc || (Triarc = {}));
/// <reference path="events.ts" />
/// <reference path="iauthproxy.ts" />
var Triarc;
(function (Triarc) {
    var Auth;
    (function (Auth) {
        Auth.mod = angular.module("tlAuth", []);
    })(Auth = Triarc.Auth || (Triarc.Auth = {}));
})(Triarc || (Triarc = {}));
/// <reference path="tlauth.module.ts" />
var Triarc;
(function (Triarc) {
    var Auth;
    (function (Auth) {
        var AuthService = (function () {
            function AuthService($http, $q, $proxy, $rootScope, applicationUrl) {
                this.$http = $http;
                this.$q = $q;
                this.$proxy = $proxy;
                this.$rootScope = $rootScope;
                this.applicationUrl = applicationUrl;
                this._userDeferred = null;
            }
            AuthService.prototype.login = function (userName, password) {
                var _this = this;
                var deffered = this.$q.defer();
                this.$proxy.login({ username: userName, password: password, rememberMe: true }).then(function (response) {
                    _this.$rootScope.$broadcast(Auth.Events.Login);
                    deffered.resolve(response);
                }, function (error) {
                    deffered.reject(error);
                });
                return deffered.promise;
            };
            AuthService.prototype.logout = function () {
                localStorage.removeItem(AuthService.authKey);
                this.$proxy.logout();
                this.$rootScope.$broadcast(Auth.Events.Logout);
            };
            AuthService.prototype.getUser = function () {
                var _this = this;
                if (this._userDeferred == null) {
                    this._userDeferred = this.$q.defer();
                    this.$proxy.getAppUser().then(function (response) {
                        _this._currentUser = response.data;
                        var userDeferred = _this._userDeferred;
                        if (_this._currentUser == null) {
                            _this._userDeferred = null;
                        }
                        userDeferred.resolve(_this._currentUser);
                    }, function (req) {
                        _this._userDeferred.reject(req);
                    });
                }
                return this._userDeferred.promise;
            };
            AuthService.serviceId = "$auth";
            //static $inject = ['$http', '$proxy', '$rootScope', JurDesk.ServiceContainer.serviceId];
            AuthService.authKey = "authorizationData";
            return AuthService;
        })();
        Auth.AuthService = AuthService;
        Auth.mod.service(AuthService.serviceId, AuthService);
    })(Auth = Triarc.Auth || (Triarc.Auth = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Web;
    (function (Web) {
        angular.module("tlAutofocus", []).directive("tlAutofocus", ["$timeout", function ($timeout) {
            return {
                restrict: "A",
                link: function ($scope, $element) {
                    $timeout(function () {
                        $element[0].focus();
                        $element[0].select();
                    });
                }
            };
        }]);
    })(Web = Triarc.Web || (Triarc.Web = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Web;
    (function (Web) {
        angular.module("tlAutoselect", []).directive("tlAutoselect", function () {
            return {
                restrict: "A",
                link: function (scope, element) {
                    var focusedElement;
                    var elements = element.find("input").addBack("input");
                    elements.on("click", function (event) {
                        if (focusedElement !== event.target) {
                            $(event.target).select();
                            focusedElement = event.target;
                        }
                    });
                    elements.on("blur", function () {
                        focusedElement = null;
                    });
                }
            };
        });
    })(Web = Triarc.Web || (Triarc.Web = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod = angular.module("tlUtils", []);
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.directive('includeReplace', function () {
            return {
                require: 'ngInclude',
                restrict: 'A',
                link: function (scope, el, attrs) {
                    el.replaceWith(el.children());
                }
            };
        });
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.directive('tlBackButton', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    element.addClass("back-button");
                    element.bind('click', function () {
                        window.history.back();
                    });
                }
            };
        });
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.filter('tlDecimalPlaces', function ($filter) { return function (input, places) {
            if (isNaN(input))
                return input;
            var decimalPlaces = angular.isNumber(places) ? places : 2;
            return parseFloat((input * 100 / 100)).toFixed(decimalPlaces);
        }; });
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.directive('tlFullHeight', ['$window', function ($window) {
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        element.css('overflow-y', 'auto');
                        var update = function () {
                            var margins = scope.$eval(attrs.tlFullHeight);
                            var margin = 0;
                            if (angular.isNumber(margins)) {
                                margin = margins;
                            }
                            $(element).css('height', $window.innerHeight - element.offset().top - margin);
                        };
                        scope.$watch(function () { return element.offset().top; }, function (val) {
                            update();
                        });
                        scope.$watch(attrs.tlFullHeight, function () {
                            update();
                        });
                        angular.element($window).bind('resize', function () {
                            update();
                        });
                    }
                };
            }]);
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.directive('tlHasScrollContent', function () {
            return {
                restrict: 'A',
                scope: {
                    tlHasScrollContent: '='
                },
                link: function (scope, element, attrs) {
                    var child;
                    scope.checkHeight = function () {
                        if (!child) {
                            child = element.first().children("div").first();
                        }
                        if (!child)
                            return;
                        if (child.height() > element.first().height()) {
                            if (!scope.tlHasScrollContent) {
                                scope.tlHasScrollContent = true;
                            }
                        }
                        else {
                            if (scope.tlHasScrollContent) {
                                scope.tlHasScrollContent = false;
                            }
                        }
                    };
                    element.bind('DOMNodeInserted', function () {
                        scope.checkHeight();
                    });
                    element.bind('DOMNodeRemoved', function () {
                        scope.checkHeight();
                    });
                }
            };
        });
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.service("tlIntelligentDebouncer", [
            "$rootScope", "tlIntelligentDebouncer.config", function ($rootScope, globalConfig) {
                function lightTimeout(callback, timeoutMs) {
                    var timeoutNumber = null;
                    var prom = new Promise(function (resolve) {
                        timeoutNumber = setTimeout(function () {
                            resolve(callback());
                        }, timeoutMs);
                    });
                    prom.cancel = function () {
                        clearTimeout(timeoutNumber);
                    };
                    return prom;
                }
                return {
                    getDebouncer: function (func, config) {
                        if (!config) {
                            config = {};
                        }
                        var immediate = Triarc.hasValue(config.initialLoad) ? config.initialLoad : true;
                        var initialMs = Triarc.hasValue(config.initialMs) ? config.initialMs : globalConfig.initialDebounce;
                        var debounceMs = Triarc.hasValue(config.debounceMs) ? config.debounceMs : globalConfig.debounceInterval;
                        var safeCall = function () {
                            if (!$rootScope.$$phase) {
                                $rootScope.$apply(function () { return safeCall(); });
                            }
                            else {
                                func();
                            }
                        };
                        var timeout;
                        var debounce = function () {
                            var later = function () {
                                var timeout = null;
                                safeCall();
                            };
                            if (timeout) {
                                timeout.cancel();
                            }
                            timeout = lightTimeout(later, debounceMs);
                        };
                        if (immediate) {
                            lightTimeout(function () { return safeCall(); }, initialMs);
                        }
                        return {
                            debounce: debounce
                        };
                    }
                };
            }
        ]);
        Utils.mod.constant("tlIntelligentDebouncer.config", {
            initialDebounce: 1000,
            debounceInterval: 15000
        });
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.filter('tlSplit', function () {
            return function (input, splitChar, splitIndex) {
                if (Triarc.hasValue(splitIndex)) {
                    return input.split(splitChar)[splitIndex];
                }
                input.split(splitChar);
            };
        });
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.directive('tlWhenScrolled', function () { return function (scope, elm, attr) {
            var raw = elm[0];
            var scrollLimitFactor = 10;
            var maybePromise = null;
            var isRegistered = false;
            if (Triarc.hasValue(attr.tlScrollLimit)) {
                var parsed = parseInt(attr.tlScrollLimit);
                if (!isNaN(parsed))
                    scrollLimitFactor = parsed;
            }
            var handleScroll = function () {
                if ((raw.scrollTop + raw.offsetHeight + scrollLimitFactor) >= raw.scrollHeight) {
                    if (maybePromise == null) {
                        // if the scroll is bound to a promise then wait for the promise before trying to 
                        // fire it off again
                        // console.log("1. blocking promise");
                        maybePromise = scope.$apply(attr.tlWhenScrolled);
                        if (maybePromise != null) {
                            // console.log("2. promise is undefined");
                            maybePromise.finally(function () {
                                maybePromise = null;
                                // console.log("3. promise has returned");
                            });
                        }
                    }
                }
            };
            var unregister = function () {
                elm.unbind('scroll', handleScroll);
                isRegistered = false;
            };
            var register = function () {
                if (!isRegistered) {
                    elm.bind('scroll', handleScroll);
                    isRegistered = true;
                }
            };
            if (angular.isString(attr.tlScrollEnabled)) {
                scope.$watch(attr.tlScrollEnabled, function (newValue) {
                    if (newValue === false) {
                        unregister();
                    }
                    else {
                        register();
                    }
                });
            }
            register();
        }; });
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Utils;
    (function (Utils) {
        Utils.mod.directive('tlWhenScrolledTop', function () { return function (scope, elm, attr) {
            var raw = elm[0];
            var scrollLimitFactor = Triarc.hasValue(attr.tlScrollTopLimit) ? attr.tlScrollTopLimit : 10;
            var previousScrollTop = raw.scrollTop;
            var maybePromise = null;
            elm.bind('scroll', function () {
                if (raw.scrollTop <= scrollLimitFactor && raw.scrollTop < previousScrollTop) {
                    if (maybePromise == null) {
                        // if the scroll is bound to a promise then wait for the promise before trying to 
                        // fire it off again
                        // console.log("1. blocking promise");
                        maybePromise = scope.$apply(attr.tlWhenScrolledTop);
                        elm.scrollTop(raw.scrollTop + 1);
                        if (maybePromise != null) {
                            // console.log("2. promise is undefined");
                            maybePromise.then(function () {
                                maybePromise = null;
                                // console.log("3. promise has returned");
                            });
                        }
                    }
                }
                previousScrollTop = raw.scrollTop;
            });
        }; });
    })(Utils = Triarc.Utils || (Triarc.Utils = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Web;
    (function (Web) {
        var mod = angular.module('tlContinuousScroll', []);
        var ContinuousScrollController = (function () {
            function ContinuousScrollController($scope) {
                this.$scope = $scope;
                this.init();
            }
            ContinuousScrollController.prototype.init = function () {
                var _this = this;
                this.currentCancellationToken = {
                    isCancelRequested: false
                };
                this.$scope.$watch(function (scope) { return scope.config() ? scope.config().searchArg : undefined; }, function () {
                    _this.reload();
                });
            };
            ContinuousScrollController.prototype.search = function () {
                var _this = this;
                this.$scope.config().searchArg.skip = this.$scope.config().items.length;
                this.$scope.config().searchArg.take = this.$scope.config().searchLimit + 1;
                var requestCancellationToken = this.currentCancellationToken;
                return this.$scope.config().searchFn({ arg: this.$scope.config().searchArg }).then(function (items) {
                    if (requestCancellationToken.isCancelRequested)
                        return false;
                    _this.loaded = true;
                    _this.$scope.config().items.addRange(items.toEnumerable().take(_this.$scope.config().searchLimit).toArray());
                    return items.length > _this.$scope.config().searchLimit;
                });
            };
            ContinuousScrollController.prototype.reload = function () {
                this.currentCancellationToken.isCancelRequested = true;
                this.currentCancellationToken = {
                    isCancelRequested: false
                };
                this.loaded = false;
                this.isScrolling = false;
                this.$scope.config().items = [];
                this.recursiveSearch();
            };
            ContinuousScrollController.prototype.recursiveSearch = function () {
                var _this = this;
                this.search().then(function (hasMore) {
                    if (!_this.isScrolling && hasMore) {
                        _this.recursiveSearch();
                    }
                });
            };
            ContinuousScrollController.controllerId = "ContinuousScrollController";
            ContinuousScrollController.$inject = [
                "$scope"
            ];
            return ContinuousScrollController;
        }());
        Web.ContinuousScrollController = ContinuousScrollController;
        mod.controller(ContinuousScrollController.controllerId, ContinuousScrollController);
        mod.directive("tlContinuousScroll", function () {
            return {
                restrict: "E",
                replace: true,
                transclude: true,
                controller: ContinuousScrollController.controllerId,
                controllerAs: "scrollCtrl",
                templateUrl: "tlContinuousScroll/continuousScroll.html",
                scope: {
                    config: "&"
                }
            };
        });
    })(Web = Triarc.Web || (Triarc.Web = {}));
})(Triarc || (Triarc = {}));

angular.module('tlContinuousScroll').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('tlContinuousScroll/continuousScroll.html',
    "<div tl-full-height><div tl-when-scrolled=\"scrollCtrl.search()\" tl-has-scroll-content=\"scrollCtrl.isScrolling\" style=\"overflow-x: hidden; height: 100%\"><div ng-transclude></div><ng-include src=\"config().noItemTemplate\" ng-if=\"scrollCtrl.loaded && config().items.length === 0\"></ng-include><div class=\"text-center\" ng-if=\"!scrollCtrl.loaded && config().items.length === 0\">{{'_loading' | translate }}...</div></div></div>"
  );

}]);

var mod = angular.module("tlDisablers", []);
mod.directive("tlAjaxDisable", [
    '$parse',
    function ($parse) { return function (scope, element, attrs) {
        restrict: 'A', 'Click Mousedown Mouseup Mouseover Mouseout Mousemove Mouseenter Mouseleave Keydown Keyup Keypress Submit Focus Blur Copy Cut Paste'.split(' ').forEach(function (action) {
            var fn = $parse(attrs["ng" + action]);
            if (angular.isFunction(fn) && fn !== angular.noop) {
                action = action.toLowerCase();
                element.unbind(action).bind(action, function () {
                    event.preventDefault();
                    var promise = fn(scope, { $event: event });
                    if (Triarc.hasValue(promise)) {
                        element.prop("disabled", true);
                        promise.finally(function () {
                            element.prop("disabled", false);
                        });
                    }
                });
            }
        });
    }; }
]);


var Triarc;
(function (Triarc) {
    var FileUploaderWrapper = (function () {
        function FileUploaderWrapper($fileUploader, $scope, supportedDocumentTypes) {
            var _this = this;
            this.supportedDocumentTypes = supportedDocumentTypes;
            this.uploader = $fileUploader.create();
            if (Triarc.hasValue(this.supportedDocumentTypes && this.supportedDocumentTypes.length > 0)) {
                this.uploader.filters.push({
                    name: 'supportedImageTypes',
                    fn: function (item) {
                        var type = _this.uploader.isHTML5 ? item.type : '/' + item.value.slice(item.value.lastIndexOf('.') + 1);
                        var ext = item.name.toLowerCase().substring(item.name.lastIndexOf('.'), item.name.length);
                        return supportedDocumentTypes.split(",").contains(ext);
                    }
                });
            }
            // this.uploader.addToQueue();
            this.uploader.progress = 100;
        }
        FileUploaderWrapper.prototype.removeFromQueue = function (file) {
            this.uploader.removeFromQueue(file);
        };
        FileUploaderWrapper.prototype.cancelAll = function () {
            this.uploader.cancelAll();
        };
        FileUploaderWrapper.$inject = ["$fileUploader", "$scope"];
        return FileUploaderWrapper;
    })();
    Triarc.FileUploaderWrapper = FileUploaderWrapper;
})(Triarc || (Triarc = {}));
/// <reference path="fileuploaderwrapper.ts" />
var Triarc;
(function (Triarc) {
    var FileUploader;
    (function (FileUploader_1) {
        var FileUploaderService = (function () {
            function FileUploaderService(FileUploader, $rootScope) {
                this.FileUploader = FileUploader;
                this.$rootScope = $rootScope;
            }
            FileUploaderService.prototype.create = function () {
                return new this.FileUploader({
                    scope: this.$rootScope
                });
            };
            FileUploaderService.serviceId = "$fileUploader";
            FileUploaderService.$inject = ['FileUploader', '$rootScope'];
            return FileUploaderService;
        })();
        FileUploader_1.FileUploaderService = FileUploaderService;
        angular.module("tlFileUploader", ["angularFileUpload"])
            .service(FileUploaderService.serviceId, FileUploaderService)
            .directive('tlFileSelect', [
            '$parse', 'FileUploader', function ($parse, FileUploader) {
                return {
                    scope: {
                        tlFileSelect: '='
                    },
                    link: function (scope, element, attributes) {
                        scope.$watch('tlFileSelect', function (newVal, oldVal) {
                            if (newVal instanceof FileUploader) {
                                var object = new FileUploader.FileSelect({
                                    uploader: scope.tlFileSelect,
                                    element: element
                                });
                                object.getOptions = $parse(attributes.options).bind(object, scope);
                                object.getFilters = function () { return attributes.filters; };
                            }
                            else {
                                return;
                            }
                        });
                    }
                };
            }
        ])
            .directive('tlFileDrop', [
            '$parse', 'FileUploader', function ($parse, FileUploader) {
                FileUploader.FileDrop.prototype.events = {
                    $destroy: 'destroy',
                    drop: 'onDrop',
                    dragover: 'onDragOver',
                    dragbetterenter: 'dummy',
                    dragbetterleave: 'onDragLeave'
                };
                // needed, else the dragbetter complains
                FileUploader.FileDrop.prototype.dummy = function () { };
                FileUploader.FileDrop.prototype.onDragLeave = function (event) {
                    if (event.target !== this.element[0]) {
                        return;
                    }
                    console.log("remove leave");
                    this._preventAndStop(event);
                    angular.forEach(this.uploader._directives.over, this._removeOverClass, this);
                };
                return {
                    scope: {
                        tlFileDrop: '='
                    },
                    link: function (scope, element, attributes) {
                        scope.$watch('tlFileDrop', function (newVal, oldVal) {
                            if (newVal instanceof FileUploader) {
                                if (!scope.tlFileDrop.isHTML5)
                                    return;
                                var object = new FileUploader.FileDrop({
                                    uploader: scope.tlFileDrop,
                                    element: scope.$eval(attributes.fullBody) ? $(document) : element
                                });
                                object.getOptions = $parse(attributes.options).bind(object, scope);
                                object.getFilters = function () { return attributes.filters; };
                            }
                            else {
                                return;
                            }
                        });
                    }
                };
            }
        ])
            .directive('tlFileOver', [
            'FileUploader', function (FileUploader) {
                return {
                    scope: {
                        tlFileOver: '='
                    },
                    link: function (scope, element, attributes) {
                        scope.$watch('tlFileOver', function (newVal, oldVal) {
                            if (newVal instanceof FileUploader) {
                                var object = new FileUploader.FileOver({
                                    uploader: scope.tlFileOver,
                                    element: element
                                });
                                object.getOverClass = function () { return (attributes.overClass || "tl-file-over"); };
                            }
                            else {
                                return;
                            }
                        });
                    }
                };
            }
        ]);
        ;
        (function ($) {
            "use strict";
            $.event.special.dragbetterenter = {
                setup: function () {
                    var _this = this;
                    var self = this, $self = $(self);
                    self.dragbetterCollection = [];
                    $self.on('dragenter.dragbetterenter', function (event) {
                        if (_this.dragbetterCollection.length === 0) {
                            $self.triggerHandler('dragbetterenter');
                        }
                        _this.dragbetterCollection.push(event.target);
                    });
                    $self.on('drop.dragbetterenter dragend.dragbetterenter', function () {
                        _this.dragbetterCollection = [];
                        $self.triggerHandler('dragbetterleave');
                    });
                },
                teardown: function () {
                    $(this).off('.dragbetterenter');
                }
            };
            $.event.special.dragbetterleave = {
                setup: function () {
                    if (!this.dragbetterCollection)
                        throw "Triggered dragbetterleave without dragbetterenter. Do you listen to dragbetterenter?";
                    var self = this, $self = $(self);
                    $self.on('dragleave.dragbetterleave', function (event) {
                        // Timeout is needed to ensure that the leave event on the previous element
                        // fires AFTER the enter event on the next element.
                        setTimeout(function () {
                            var currentElementIndex = this.dragbetterCollection.indexOf(event.target);
                            if (currentElementIndex > -1)
                                this.dragbetterCollection.splice(currentElementIndex, 1);
                            if (this.dragbetterCollection.length === 0) {
                                $self.triggerHandler('dragbetterleave');
                            }
                        }, 1);
                    });
                },
                teardown: function () {
                    $(this).off('.dragbetterleave');
                }
            };
        })($);
    })(FileUploader = Triarc.FileUploader || (Triarc.FileUploader = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Web;
    (function (Web) {
        var DragAndDropImageArea = (function () {
            function DragAndDropImageArea($fileUploader, $translate) {
                this.$fileUploader = $fileUploader;
                this.$translate = $translate;
                this.templateUrl = "Client/triarc/Views/Template/DragAndDropImageAreaTemplate.html";
                this.require = "ngModel";
                this.scope = {
                    ngModel: '=',
                    buttonBinding: '=',
                    css: '=',
                    buttonCss: '=',
                    buttonText: '=',
                    supportedFileTypes: '=',
                    removePrefix: '=',
                };
                this.link = this.unboundLink.bind(this);
            }
            // use an unbound link so that you can access the variables in the class
            DragAndDropImageArea.prototype.unboundLink = function (scope, elem, attributes, ngModel) {
                var _this = this;
                // set defaults if not passed in
                Triarc.hasNoValue(scope.css) ? elem.addClass(scope.css) : elem.addClass("drag-and-drop-image-area");
                Triarc.hasNoValue(scope.buttonCss) ? elem.find('.selection-button').addClass(scope.buttonCss) : elem.find('.selection-button').addClass("btn-success");
                var fileTypes;
                Triarc.hasNoValue(scope.supportedFileTypes) ? fileTypes = scope.supportedFileTypes : fileTypes = ".png,.jpg,.jpeg,.gif";
                this.watchMe(scope, elem);
                var setButtonText = function () {
                    if (Triarc.hasNoValue(scope.buttonText)) {
                        elem.find('.selection-button').text(scope.buttonText);
                    }
                    else {
                        elem.find('.selection-button').text(_this.$translate.instant("_bt_select"));
                    }
                };
                // initial call to set the text
                setButtonText();
                scope.$watch('buttonText', function () {
                    setButtonText();
                });
                var fileSelected = function (file) {
                    var reader = new FileReader();
                    reader.onload = (function (e) {
                        scope.ngModel = e.target.result;
                        scope.$apply();
                    });
                    reader.readAsDataURL(file);
                };
                scope.fileUploaderWrapper = new Triarc.FileUploaderWrapper(this.$fileUploader, scope, fileTypes);
                scope.fileUploaderWrapper.uploader.onAfterAddingFile = function (item) {
                    fileSelected(item._file);
                };
                scope.fileUploaderWrapper.uploader.clearQueue = function () {
                    while (scope.fileUploaderWrapper.uploader.queue.length) {
                        scope.fileUploaderWrapper.uploader.queue[0].remove();
                    }
                    scope.fileUploaderWrapper.uploader.progress = 0;
                    scope.ngModel = null;
                    elem.find('input[type="file"]').prop('value', null);
                };
            };
            DragAndDropImageArea.prototype.watchMe = function (scope, elem) {
                var _this = this;
                if (Triarc.hasNoValue(this.watchRegistration)) {
                    this.watchRegistration();
                }
                this.watchRegistration = scope.$watch('ngModel', function (newVal, oldVal) {
                    if (Triarc.hasNoValue(scope.ngModel)) {
                        if (newVal != oldVal) {
                            if (!Triarc.strContains(scope.ngModel, ",")) {
                                elem.find(".image").css('background-image', 'url(' + 'data:image/jpeg;base64,' + scope.ngModel + ')');
                            }
                            else {
                                if (scope.removePrefix == true) {
                                    var prefix = scope.ngModel.split(',', 1);
                                    scope.ngModel = scope.ngModel.substring(scope.ngModel.indexOf(',') + 1);
                                    elem.find(".image").css('background-image', 'url(' + prefix + ',' + scope.ngModel + ')');
                                }
                                else {
                                    elem.find(".image").css('background-image', 'url(' + scope.ngModel + ')');
                                }
                                _this.watchMe(scope, elem);
                            }
                            elem.find('.selection-button').hide();
                            elem.find('.remove-button').show();
                        }
                    }
                    else {
                        elem.find(".image").css('background-image', 'none');
                        elem.find('.selection-button').show();
                        elem.find('.remove-button').hide();
                    }
                });
            };
            DragAndDropImageArea.prototype.stopWatch = function () {
                this.watchRegistration();
            };
            DragAndDropImageArea.directiveId = "tlDragAndDropImageArea";
            return DragAndDropImageArea;
        })();
        Web.DragAndDropImageArea = DragAndDropImageArea;
    })(Web = Triarc.Web || (Triarc.Web = {}));
})(Triarc || (Triarc = {}));
/// <reference path="draganddropimagearea.ts" />
var Triarc;
(function (Triarc) {
    var Image;
    (function (Image) {
        var mod = angular.module('tlImage', []);
        mod.directive(Triarc.Web.DragAndDropImageArea.directiveId, function ($fileUploader, $translate) { return new Triarc.Web.DragAndDropImageArea($fileUploader, $translate); });
        mod.directive("tlImage", function () {
            return {
                link: function (scope, element, attrs) {
                    scope.$watch(function () {
                        var imageString = attrs.tlImage;
                        if (angular.isString(imageString))
                            return scope.$eval(imageString);
                        return null;
                    }, function (newVal) {
                        if (angular.isString(newVal))
                            element.css("background-image", "url(data:image/png;base64," + newVal + ")");
                        else
                            element.css("background-image", "");
                    });
                }
            };
        });
    })(Image = Triarc.Image || (Triarc.Image = {}));
})(Triarc || (Triarc = {}));


var mod = angular.module("tlKeyPresses", []);
mod.directive("tlEnter", [
    "$timeout",
    function ($timeout) { return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                $timeout(function () {
                    scope.$eval(attrs.tlEnter);
                }, 0);
                event.preventDefault();
            }
        });
    }; }
]);


var Triarc;
(function (Triarc) {
    var Layout;
    (function (Layout) {
        Layout.mod = angular.module('tlLayout', []);
    })(Layout = Triarc.Layout || (Triarc.Layout = {}));
})(Triarc || (Triarc = {}));
/// <reference path="tllayout.module.ts" />
var Triarc;
(function (Triarc) {
    var Layout;
    (function (Layout) {
        Layout.mod.directive('tlHeightOf', ["$rootScope", function ($rootScope) {
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        element.css('overflow-y', 'auto');
                        var owningClass = attrs.tlHeightOf;
                        var owningElement = $(owningClass);
                        var update = function () {
                            var previousOverflow = owningElement.css("overflow-y");
                            owningElement.css({ 'overflow': 'visible' });
                            var height = owningElement[0].scrollHeight;
                            if (attrs.tlHeightOfOffset) {
                                height += +attrs.tlHeightOfOffset;
                            }
                            element.css('height', height);
                            owningElement.css({ 'overflow': previousOverflow });
                        };
                        scope.$watch(function () { return owningElement[0].scrollHeight; }, function (val) {
                            update();
                        });
                        attrs.$observe(attrs.tlHeightOf, function (newVal) {
                            owningClass = attrs.tlHeightOf;
                            owningElement = $(owningClass);
                            update();
                        });
                        if (attrs.tlHeightOfOnEvent) {
                            var eventName = scope.$eval(attrs.tlHeightOfOnEvent);
                            scope.$on(eventName, function () {
                                update();
                            });
                        }
                    }
                };
            }]);
    })(Layout = Triarc.Layout || (Triarc.Layout = {}));
})(Triarc || (Triarc = {}));
/// <reference path="tllayout.module.ts" />
// Update the most local relative references and declare this directive.
var Triarc;
(function (Triarc) {
    var Layout;
    (function (Layout) {
        // declare correct angularjs module
        Layout.mod.directive('tlWindowHeight', [
            function () {
                return {
                    restrict: "A",
                    link: function (scope, element, attrs) {
                        var windowsListener = null;
                        attrs.$observe("tlWindowHeight", function (offset) {
                            var setHeight = function (offSetHeight) {
                                var timeout = setTimeout(function () {
                                    clearTimeout(timeout);
                                    var containerHeight = element.closest(attrs["tlWindowHeightContainerClass"]).height();
                                    element.height(containerHeight - +offSetHeight);
                                }, 10);
                            };
                            if (angular.isString(offset) && attrs["tlWindowHeightContainerClass"]) {
                                setHeight(offset);
                                if (Triarc.hasNoValue(windowsListener)) {
                                    windowsListener = $(window)[0].addEventListener("resize", function () {
                                        setHeight(offset);
                                    }, true);
                                }
                            }
                        });
                    }
                };
            }
        ]);
    })(Layout = Triarc.Layout || (Triarc.Layout = {}));
})(Triarc || (Triarc = {}));


var mod = angular.module('tlLocalization', []);
/// <reference path="tllocalization.ts" />
var Triarc;
(function (Triarc) {
    var Localization;
    (function (Localization) {
        var Row = (function () {
            function Row(key) {
                this.rowKey = key;
                this.rowColumns = [];
            }
            return Row;
        })();
        Localization.Row = Row;
        var LocalizationService = (function () {
            function LocalizationService($q, resource) {
                var _this = this;
                this.$q = $q;
                this.resource = resource;
                this.newResource = "";
                this.refresh = function () {
                    _this.resource.getLanguagesMultiple({}).then(function (response) {
                        response.data.forEach(function (l) {
                            _this.languages.push(l);
                        });
                    }, function () {
                    });
                    _this.resource.getResourceKeysMultiple({}).then(function (response) {
                        response.data.forEach(function (k) {
                            _this.rows.push(new Row(k));
                        });
                    }, function () {
                    });
                    _this.hasLoaded = true;
                };
                this.selectLanguage = function (language) {
                    language.Selected = true;
                    var add = false;
                    for (var i = 0; i < _this.languages.length; i++) {
                        if (_this.languages[i].LanguageIdentifier == language.LanguageIdentifier) {
                            add = true;
                            break;
                        }
                    }
                    if (add) {
                        _this.loadLanguage(language.LanguageIdentifier);
                        _this.selectedLanguages.push(language);
                    }
                };
                this.deselectLanguage = function (language) {
                    language.Selected = false;
                    for (var i = 0; i < _this.selectedLanguages.length; i++) {
                        if (_this.selectedLanguages[i].LanguageIdentifier === language.LanguageIdentifier) {
                            _this.selectedLanguages.splice(i, 1);
                            break;
                        }
                    }
                    _this.unloadLanguage(language.LanguageIdentifier);
                };
                this.addKey = function (key) {
                    var row = new Row(key);
                    for (var i = 0; i < _this.languages.length; i++) {
                        if (_this.languages[i].Selected) {
                            row.rowColumns.push({ LanguageKey: _this.languages[i].LanguageIdentifier, Value: "", ResourceKey: key, Id: 0 });
                        }
                    }
                    _this.rows.push(row);
                };
                this.removeRow = function (rowKey) {
                    for (var i = 0; i < _this.rows.length; i++) {
                        if (_this.rows[i].rowKey == rowKey) {
                            _this.rows.splice(i, 1);
                            _this.keysToDelete.push(rowKey);
                            break;
                        }
                    }
                };
                this.updateEntry = function (entry, del) {
                    var index = -1;
                    if (del) {
                        entry.Value = "";
                        entry.Delete = true;
                    }
                    else {
                        entry.Delete = false;
                    }
                    for (var i = 0; i < _this.entriesToUpdate.length; i++) {
                        var e = _this.entriesToUpdate[i];
                        if (entry.ResourceKey === e.ResourceKey && entry.LanguageKey === e.LanguageKey) {
                            index = i;
                            break;
                        }
                    }
                    if (index === -1) {
                        _this.entriesToUpdate.push(entry);
                    }
                    console.log(_this.entriesToUpdate);
                };
                this.save = function () {
                    console.log(_this.entriesToUpdate);
                    _this.resource.updateEntries({ UpdatedEntries: _this.entriesToUpdate, DeletedKeys: _this.keysToDelete }).then(function (response) {
                        _this.entriesToUpdate = [];
                        _this.keysToDelete = [];
                    }, function () {
                    });
                };
                this.loadLanguage = function (key) {
                    _this.resource.getLocaleEntriesMultiple({ languageKey: key }).then(function (response) {
                        for (var i = 0; i < _this.rows.length; i++) {
                            var entry;
                            for (var j = 0; j < response.data.length; j++) {
                                if (response.data[j].ResourceKey == _this.rows[i].rowKey) {
                                    entry = response.data[j];
                                    break;
                                }
                            }
                            if (!entry) {
                                entry = { ResourceKey: _this.rows[i].rowKey, LanguageKey: key, Value: "" };
                            }
                            _this.rows[i].rowColumns.push(entry);
                            entry = null;
                        }
                    }, function () {
                    });
                };
                this.unloadLanguage = function (key) {
                    for (var i = 0; i < _this.rows.length; i++) {
                        var row = _this.rows[i];
                        for (var j = 0; j < row.rowColumns.length; j++) {
                            if (row.rowColumns[j].LanguageKey == key) {
                                row.rowColumns.splice(j, 1);
                                break;
                            }
                        }
                    }
                    _this.entriesToUpdate = _this.entriesToUpdate.filter(function (entry) {
                        return entry.LanguageKey != key;
                    });
                };
                this.hasLoaded = false;
                this.languages = [];
                this.rows = [];
                this.selectedLanguages = [];
                this.entriesToUpdate = [];
                this.keysToDelete = [];
            }
            LocalizationService.serviceId = "localizationService";
            return LocalizationService;
        })();
        Localization.LocalizationService = LocalizationService;
        var LocalizationServiceProvider = (function () {
            function LocalizationServiceProvider() {
                var _this = this;
                this.resource = "Localization";
                this.$get = ["$q", "$proxy", function ($q, $proxy) {
                    return new LocalizationService($q, $proxy[_this.resource]);
                }];
            }
            LocalizationServiceProvider.prototype.setLocalizationResource = function (resourceName) {
                this.resource = resourceName;
            };
            LocalizationServiceProvider.providerId = "localizationServiceProvider";
            return LocalizationServiceProvider;
        })();
        Localization.LocalizationServiceProvider = LocalizationServiceProvider;
        mod.provider(LocalizationService.serviceId, LocalizationServiceProvider);
    })(Localization = Triarc.Localization || (Triarc.Localization = {}));
})(Triarc || (Triarc = {}));
/// <reference path="tllocalization.ts" />
/// <reference path="localizationservice.ts" />
var Triarc;
(function (Triarc) {
    var Localization;
    (function (Localization) {
        var LocalizationController = (function () {
            function LocalizationController($scope, $localization) {
                var _this = this;
                this.$scope = $scope;
                this.$localization = $localization;
                this.filter = "";
                this.maxLanguagesToSelect = 2;
                this.getFilteredEntries = function () {
                    if (_this.filter === "") {
                        return _this.$localization.rows;
                    }
                    return _this.$localization.rows.filter(function (row) {
                        return (row.rowKey.toLowerCase().indexOf(_this.filter.toLowerCase()) > -1);
                    });
                };
                this.toggleLanguage = function (language) {
                    if (language.Selected) {
                        _this.$localization.selectLanguage(language);
                    }
                    else {
                        _this.$localization.deselectLanguage(language);
                    }
                };
                this.addRow = function () {
                    if (_this.$localization.newResource) {
                        _this.$localization.addKey(_this.$localization.newResource);
                        _this.$localization.newResource = "";
                    }
                };
                this.valueChange = function (entry, del) {
                    _this.$localization.updateEntry(entry, del);
                };
                this.removeResource = function (rowKey) {
                    _this.$localization.removeRow(rowKey);
                };
                this.save = function () {
                    _this.$localization.save();
                };
                if (!this.$localization.hasLoaded) {
                    this.$localization.refresh();
                }
            }
            LocalizationController.controllerId = "localizationController";
            LocalizationController.$inject = ["$scope", Localization.LocalizationService.serviceId];
            return LocalizationController;
        })();
        Localization.LocalizationController = LocalizationController;
        mod.controller(LocalizationController.controllerId, LocalizationController);
    })(Localization = Triarc.Localization || (Triarc.Localization = {}));
})(Triarc || (Triarc = {}));
/// <reference path="tllocalization.ts" />
var Triarc;
(function (Triarc) {
    var Localization;
    (function (Localization) {
        var LocalizationTable = (function () {
            function LocalizationTable() {
                this.restrict = 'E';
                this.templateUrl = "LocalizationTableTemplate.html";
            }
            LocalizationTable.directiveId = "tlLocalizationTable";
            return LocalizationTable;
        })();
        Localization.LocalizationTable = LocalizationTable;
        mod.directive(LocalizationTable.directiveId, function () { return new LocalizationTable(); });
    })(Localization = Triarc.Localization || (Triarc.Localization = {}));
})(Triarc || (Triarc = {}));

angular.module('tlLocalization').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('tlLocalization/LocalizationTableTemplate.html',
    "<style>.input-lang {\r" +
    "\n" +
    "\t\tborder: 0;\r" +
    "\n" +
    "\t\theight: 30px;\r" +
    "\n" +
    "\t\tborder-right: 1px solid lightgrey;\r" +
    "\n" +
    "\t\tborder-left: 1px solid lightgrey;\r" +
    "\n" +
    "\t\tpadding: 0 0 0 3px;\r" +
    "\n" +
    "\t\twidth: 90%;\r" +
    "\n" +
    "\t\tpadding-right: 35px;\r" +
    "\n" +
    "\t}\r" +
    "\n" +
    "\r" +
    "\n" +
    "\t.splash {\r" +
    "\n" +
    "\t\tdisplay: none;\r" +
    "\n" +
    "\t}\r" +
    "\n" +
    "\r" +
    "\n" +
    "\t.ellipsis {\r" +
    "\n" +
    "\t\ttext-overflow: ellipsis;\r" +
    "\n" +
    "\t}</style><div ng-controller=\"localizationController as ctrl\"><div class=\"well\"><h1>Localization</h1></div><div class=\"well\" style=\"height: 60px\"><div class=\"row-fluid\"><div class=\"col-xs-4\" ng-repeat=\"lang in ctrl.$localization.languages\"><label><input ng-model=\"lang.Selected\" ng-disabled=\"ctrl.$localization.selectedLanguages.length >= ctrl.maxLanguagesToSelect && !lang.Selected\" type=\"checkbox\" ng-change=\"ctrl.toggleLanguage(lang)\"><text>{{lang.Name}}</text></label></div></div></div><div class=\"well\" style=\"height: 81px\"><input type=\"text\" style=\"height: 43px;padding-left: 3px;float: left\" ng-model=\"ctrl.filter\" placeholder=\"Filter by Key\"><div style=\"height: 10px;float:left;width: 60px\"></div><input type=\"text\" style=\"height: 43px;padding-left: 3px\" ng-model=\"ctrl.$localization.newResource\" placeholder=\"New Key\"><div class=\"btn btn-primary\" ng-click=\"ctrl.addRow();\" ng-class=\"{disabled : !ctrl.$localization.newResource} \">Add Key</div><div style=\"float: right\" class=\"btn btn-primary\" ng-click=\"ctrl.save()\" ng-class=\"{disabled: ctrl.$localization.entriesToUpdate.length == 0 && ctrl.$localization.keysToDelete.length == 0}\">Save</div></div><div class=\"row-fluid\" style=\"border-bottom: 1px solid lightgrey\"><div class=\"col-xs-4\"><h4>Keys</h4></div><div class=\"col-xs-4\" ng-repeat=\"lang in ctrl.$localization.selectedLanguages\"><h4>{{lang.Name}}</h4></div><div style=\"clear: both\"></div></div><div class=\"row-fluid\" style=\"border-bottom: 1px solid lightgrey\" ng-repeat=\"row in ctrl.$localization.rows |filter:ctrl.filter |orderBy: row.rowKey\"><div class=\"col-xs-4 ellipsis\" style=\"height: 30px\"><span ng-click=\"ctrl.removeResource(row.rowKey)\" class=\"glyphicon glyphicon-remove\" style=\"margin-top: 7px;cursor: pointer\"></span>&nbsp;&nbsp; {{row.rowKey}}</div><div class=\"col-xs-4\" style=\"height: 30px\" ng-repeat=\"col in row.rowColumns\"><input class=\"input-lang\" placeholder=\"No Entry\" type=\"text\" ng-change=\"ctrl.valueChange(col, false)\" ng-model=\"col.Value\"><div ng-show=\"col.Value\" ng-click=\"ctrl.valueChange(col,true)\" class=\"glyphicon glyphicon-remove\" style=\"cursor: pointer;margin-left:-25px;top:3px\"></div></div><div style=\"clear:both\"></div></div><div style=\"margin-bottom: 50px\"></div></div>"
  );

}]);

var Triarc;
(function (Triarc) {
    var Web;
    (function (Web) {
        var Modal;
        (function (Modal) {
            Modal.mod = angular.module('tlModal', ['ui.bootstrap.modal']);
            var templateCache;
            //mod.run([
            //  '$templateCache', ($templateCache: ng.ITemplateCacheService) => {
            //    templateCache = $templateCache;
            //  }
            //]);
            function openConfirmModal(message, $modal, title, ok, cancel, showCancel) {
                if (title === void 0) { title = "_defaultNotificationTitle"; }
                if (ok === void 0) { ok = "_ok"; }
                if (cancel === void 0) { cancel = "_cancel"; }
                if (showCancel === void 0) { showCancel = true; }
                var modalInstance = $modal.open({
                    templateUrl: "tlModal/notificationModal.html",
                    size: 'md',
                    controller: ModalInstanceCtrl,
                    resolve: {
                        message: function () {
                            return message;
                        },
                        title: function () {
                            return title;
                        },
                        ok: function () {
                            return ok;
                        },
                        cancel: function () {
                            return cancel;
                        },
                        showCancel: function () {
                            return showCancel;
                        }
                    }
                });
                return modalInstance.result.then(function () {
                    return true;
                }, function () {
                    return false;
                });
            }
            Modal.openConfirmModal = openConfirmModal;
            var ModalInstanceCtrl = function ($scope, $modalInstance, message, title, ok, cancel, showCancel) {
                $scope.message = message;
                $scope.title = title;
                $scope.ok = ok;
                $scope.cancel = cancel;
                $scope.showCancel = showCancel;
            };
        })(Modal = Web.Modal || (Web.Modal = {}));
    })(Web = Triarc.Web || (Triarc.Web = {}));
})(Triarc || (Triarc = {}));

angular.module('tlModal').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('tlModal/notificationModal.html',
    "<div class=\"modal-header\"><h4 class=\"modal-title\" translate>{{title}}</h4></div><div class=\"modal-body\"><div translate>{{message}}</div></div><div class=\"modal-footer\"><button ng-if=\"showCancel\" class=\"btn btn-primary\" ng-click=\"$dismiss('cancel')\" translate>{{cancel}}</button> <button class=\"btn btn-success\" ng-click=\"$close(result)\" translate>{{ok}}</button></div>"
  );

}]);

var Triarc;
(function (Triarc) {
    var PageLock;
    (function (PageLock) {
        var Modal = Triarc.Web.Modal;
        var PageLockService = (function () {
            function PageLockService($browser, $state, $location, $rootScope, $filter, $modal) {
                var _this = this;
                this.$browser = $browser;
                this.$state = $state;
                this.$location = $location;
                this.$rootScope = $rootScope;
                this.$filter = $filter;
                this.$modal = $modal;
                this.$locks = [];
                this.$rootScope.$on("$stateChangeStart", function (event, next, current) {
                    if (_this.promiseLock) {
                        event.preventDefault();
                        Modal.openConfirmModal(_this.$filter('translate')(_this.promiseLockConfirmMessage), _this.$modal).then(function (confirm) {
                            if (confirm) {
                                _this.releaseBlockNavigation();
                                if (Triarc.hasValue(_this.watchRegistration)) {
                                    _this.watchRegistration();
                                }
                                if (Triarc.hasValue(_this.watchDirtyFormVar)) {
                                }
                                console.log(_this.buttonLock);
                                _this.$state.transitionTo(next, current);
                            }
                        }, angular.noop);
                    }
                    if (_this.watchMeLock) {
                        event.preventDefault();
                        Modal.openConfirmModal(_this.$filter('translate')(_this.watchMeLockConfirmMessage), _this.$modal).then(function (confirm) {
                            if (confirm) {
                                _this.stopWatchingMe();
                                _this.$state.transitionTo(next, current);
                            }
                        }, angular.noop);
                    }
                    if (_this.watchDirtyFormVar && _this.form.$dirty) {
                        event.preventDefault();
                        _this.buttonLock = true;
                        Modal.openConfirmModal(_this.watchFormLockConfirmMessage, _this.$modal).then(function (confirm) {
                            if (confirm) {
                                _this.stopWatchingDirtyForm();
                                _this.$state.transitionTo(next, current);
                            }
                            _this.buttonLock = false;
                        }, angular.noop);
                    }
                    _this.$locks.every(function (lock) {
                        if (!lock.form[lock.field])
                            return true;
                        event.preventDefault();
                        Modal.openConfirmModal(lock.message, _this.$modal).then(function (confirm) {
                            if (confirm) {
                                _this.$locks.toEnumerable().toArray().forEach(function (l) { return l.release(); });
                                _this.$state.transitionTo(next, current);
                            }
                        });
                        return false;
                    });
                });
            }
            PageLockService.prototype.blockNavigation = function (toasterMessage, promise, confirmationMessage) {
                var _this = this;
                if (confirmationMessage === void 0) { confirmationMessage = "_defaultOperationNotFinishedMessage"; }
                this.buttonLock = this.promiseLock = true;
                this.promiseLockConfirmMessage = this.$filter('translate')(confirmationMessage);
                this.inProgressToaster(this.$filter('translate')(toasterMessage));
                var update = function () {
                    _this.buttonLock = _this.watchDirtyFormVar = _this.promiseLock = false, _this.clearToaster();
                    _this.releaseBlockNavigation();
                };
                promise.then(update, update);
                return promise;
            };
            PageLockService.prototype.showToaster = function (toasterMessage, promise) {
                var toast = this.createToastr(this.$filter('translate')(toasterMessage));
                promise.finally(function () {
                    toastr.clear(toast);
                });
            };
            PageLockService.prototype.releaseBlockNavigation = function () {
                this.promiseLock = false;
            };
            PageLockService.prototype.watchMe = function ($scope, watchValue, watchResult, message) {
                var _this = this;
                if (message === void 0) { message = "_defaultLooseDataMessage"; }
                this.watchMeLockConfirmMessage = this.$filter('translate')(message);
                this.watchRegistration = $scope.$watch(watchValue, function (newValue, oldValue) {
                    _this.watchMeLock = false;
                    if (newValue !== oldValue && newValue === watchResult) {
                        _this.watchMeLock = true;
                    }
                    else if (newValue !== oldValue && newValue !== watchResult) {
                        _this.watchMeLock = false;
                    }
                });
                if (Triarc.hasValue(this.watchRegistration)) {
                    this.watchRegistration();
                }
            };
            PageLockService.prototype.stopWatchingMe = function () {
                this.watchMeLock = false;
                this.watchRegistration();
            };
            PageLockService.prototype.createFormLock = function ($scope, formName, field, message) {
                var _this = this;
                if (field === void 0) { field = "$dirty"; }
                if (message === void 0) { message = "_defaultLooseDataMessage"; }
                var unwatch = $scope.$watch(formName, function (form) {
                    if (Triarc.hasValue(form)) {
                        lock.form = form;
                        unwatch();
                    }
                    else {
                        lock.form = null;
                    }
                });
                var lock = {
                    message: this.$filter('translate')(message),
                    field: field,
                    release: function () {
                        unwatch();
                        _this.$locks.remove(lock);
                    },
                    form: null
                };
                this.$locks.add(lock);
                return lock;
            };
            PageLockService.prototype.watchMyDirtyForm = function ($scope, formName, message) {
                var _this = this;
                if (message === void 0) { message = "_defaultLooseDataMessage"; }
                this.watchFormLockConfirmMessage = this.$filter('translate')(message);
                if (Triarc.hasValue(this.dirtyFormRegistration)) {
                    this.dirtyFormRegistration();
                }
                this.watchDirtyFormVar = false;
                this.watchRegistration = $scope.$watch(formName, function (form) {
                    if (Triarc.hasValue(form)) {
                        _this.form = form;
                        _this.watchDirtyFormVar = true;
                        _this.watchRegistration();
                    }
                    else {
                        _this.form = null;
                        _this.watchDirtyFormVar = false;
                    }
                });
            };
            PageLockService.prototype.stopWatchingDirtyForm = function () {
                if (Triarc.hasValue(this.dirtyFormRegistration)) {
                    this.dirtyFormRegistration();
                }
                this.watchDirtyFormVar = false;
                this.form = null;
            };
            PageLockService.prototype.inProgressToaster = function (message) {
                this.$waitToaster = this.createToastr(message);
            };
            PageLockService.prototype.createToastr = function (message) {
                return toastr['info'](message, "", {
                    closeButton: false,
                    debug: false,
                    positionClass: "toast-top-right",
                    tapToDismiss: false,
                    showDuration: 300,
                    hideDuration: 1000,
                    timeOut: 0,
                    extendedTimeOut: 0,
                    showEasing: "swing",
                    hideEasing: "linear",
                    showMethod: "fadeIn",
                    hideMethod: "fadeOut"
                });
            };
            PageLockService.prototype.clearToaster = function () {
                toastr.clear(this.$waitToaster);
            };
            PageLockService.serviceId = "$pageLockService";
            PageLockService.$inject = ['$browser', '$state', '$location', '$rootScope', '$filter', '$modal'];
            return PageLockService;
        })();
        PageLock.PageLockService = PageLockService;
        angular.module("tlPageLock", ["ui.bootstrap.modal"]).service(PageLockService.serviceId, PageLockService);
    })(PageLock = Triarc.PageLock || (Triarc.PageLock = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Web;
    (function (Web) {
        var mod = angular.module("tlPrint", []);
        mod.directive("ngPrint", [function () {
                var printSection = document.getElementById("printSection");
                // if there is no printing section, create one
                if (!printSection) {
                    printSection = document.createElement("div");
                    printSection.id = "printSection";
                    $(printSection).addClass("printable-container");
                    document.body.appendChild(printSection);
                }
                function printElement(elem) {
                    // clones the element you want to print
                    var domClone = elem.cloneNode(true);
                    printSection.appendChild(domClone);
                    window.print();
                    // remove the contents of the print!
                    $("#printSection").empty();
                }
                return {
                    restrict: "A",
                    link: function (scope, elem, attrs) {
                        elem.on("click", function () {
                            var elemToPrint = document.getElementById(attrs.printElementId);
                            if (elemToPrint) {
                                printElement(elemToPrint);
                            }
                        });
                        window.onafterprint = function () {
                            // clean the print section before adding new content
                            printSection.innerHTML = "";
                        };
                    }
                };
            }]);
    })(Web = Triarc.Web || (Triarc.Web = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var RemoteDataStore;
    (function (_RemoteDataStore) {
        "use strict";
        var LocalDataStorage = (function () {
            function LocalDataStorage() {
            }
            LocalDataStorage.prototype.remove = function (key) {
                localStorage.removeItem(key);
            };
            LocalDataStorage.prototype.get = function (key) {
                var item = localStorage.getItem(key);
                if (item !== null) {
                    try {
                        return angular.fromJson(item);
                    }
                    catch (e) {
                    }
                }
                return null;
            };
            LocalDataStorage.prototype.set = function (key, storageItem) {
                if (!angular.isDate(storageItem.creationDate)) {
                    storageItem.creationDate = new Date();
                }
                var item = localStorage.getItem(key);
                if (item == null) {
                    this.addNew(key, storageItem);
                }
                else {
                    try {
                        var fromJson = angular.fromJson(item);
                        if (angular.isObject(fromJson)) {
                            fromJson.localUpdateDate = new Date();
                            fromJson.data = storageItem.data;
                            fromJson.eTag = storageItem.eTag;
                            this.setItem(key, fromJson);
                        }
                        else {
                            // todo log
                            this.addNew(key, storageItem);
                        }
                    }
                    catch (e) {
                        // todo log
                        this.addNew(key, storageItem);
                    }
                }
            };
            LocalDataStorage.prototype.addNew = function (key, storageItem) {
                storageItem.localUpdateDate = new Date();
                this.setItem(key, storageItem);
            };
            LocalDataStorage.prototype.setItem = function (key, storageItem) {
                var json = angular.toJson(storageItem, false);
                localStorage.setItem(key, json);
            };
            return LocalDataStorage;
        })();
        _RemoteDataStore.LocalDataStorage = LocalDataStorage;
        var WebSqlDataStorage = (function () {
            function WebSqlDataStorage() {
            }
            WebSqlDataStorage.prototype.remove = function (key) {
            };
            WebSqlDataStorage.prototype.get = function (url) {
                return null;
            };
            WebSqlDataStorage.prototype.set = function (key, storageItem) {
            };
            return WebSqlDataStorage;
        })();
        _RemoteDataStore.WebSqlDataStorage = WebSqlDataStorage;
        (function (DataStorageType) {
            DataStorageType[DataStorageType["LocalStorage"] = 0] = "LocalStorage";
            DataStorageType[DataStorageType["WebSql"] = 1] = "WebSql";
        })(_RemoteDataStore.DataStorageType || (_RemoteDataStore.DataStorageType = {}));
        var DataStorageType = _RemoteDataStore.DataStorageType;
        var RemoteDataStore = (function () {
            function RemoteDataStore($http, $q, $requestSender) {
                this.$http = $http;
                this.$q = $q;
                this.$requestSender = $requestSender;
                this._transactions = [];
                this._dataStorage = new LocalDataStorage();
            }
            RemoteDataStore.prototype.get = function (dataRequest, getOptions) {
                var _this = this;
                var defer = this.$q.defer();
                var loadedHandler = angular.noop;
                var changedHandler = angular.noop;
                if (angular.isObject(getOptions)) {
                    if (angular.isFunction(getOptions.changed))
                        changedHandler = getOptions.changed;
                }
                var startTime = new Date();
                var storageItem = this.getLocal(dataRequest);
                if (storageItem == null) {
                    var reqPromise = this.$requestSender.requestValue(dataRequest);
                    return this.updateStore(dataRequest, reqPromise).then(function (r) {
                        _this._transactions.push({
                            dataRequest: dataRequest,
                            ended: new Date(),
                            result: r,
                            source: "initial server",
                            started: startTime,
                            storageItem: _this.getLocal(dataRequest)
                        });
                        return r;
                    }, function (e) { return e; });
                }
                else {
                    var response = new Triarc.Data.DataResponse(storageItem.data, 0 /* Success */);
                    defer.resolve(response);
                    // todo start triggering update
                    var reqPromise = this.$requestSender.requestValue(dataRequest);
                    this._transactions.push({
                        dataRequest: dataRequest,
                        ended: new Date(),
                        result: response,
                        source: "local",
                        started: startTime,
                        storageItem: storageItem
                    });
                    this.updateStore(dataRequest, reqPromise).then(function (p) {
                        _this._transactions.push({
                            dataRequest: dataRequest,
                            ended: new Date(),
                            result: p,
                            source: "update server",
                            started: startTime,
                            storageItem: _this.getLocal(dataRequest)
                        });
                        changedHandler(p.data);
                    }, function (err) {
                        // todo
                    });
                }
                return defer.promise;
            };
            RemoteDataStore.prototype.getLocal = function (dataRequest) {
                return this._dataStorage.get(this.getKey(dataRequest));
            };
            RemoteDataStore.prototype.removeLocal = function (dataRequest) {
                return this._dataStorage.remove(this.getKey(dataRequest));
            };
            RemoteDataStore.prototype.getTransactions = function () {
                return this._transactions;
            };
            RemoteDataStore.prototype.getKey = function (dataRequest) {
                // todo add post support
                return dataRequest.url;
            };
            RemoteDataStore.prototype.setDataStorage = function (dataStorage) {
                if (dataStorage == 0 /* LocalStorage */) {
                    this._dataStorage = new LocalDataStorage();
                }
                else {
                    this._dataStorage = new WebSqlDataStorage();
                }
            };
            RemoteDataStore.prototype.enqueueRequest = function (request, requestOptions) {
            };
            RemoteDataStore.prototype.updateStore = function (dataRequest, reqPromise) {
                var _this = this;
                return reqPromise.then(function (req) {
                    if (req.isSuccessful()) {
                        _this.storeData(RemoteDataStore.getKey(dataRequest), req);
                    }
                    else {
                    }
                    return req;
                }, function (err) {
                    return err;
                    // todo define
                });
            };
            RemoteDataStore.getKey = function (dataRequest) {
                // todo check verb
                if (dataRequest.method.toUpperCase() == "GET") {
                    return dataRequest.url;
                }
                else {
                    throw "not supported http verb for remote storage";
                }
            };
            RemoteDataStore.prototype.storeData = function (key, response) {
                var storageItem = {
                    creationDate: new Date(),
                    data: response.data,
                    eTag: response.httpReponse.headers["etag"],
                    localUpdateDate: new Date()
                };
                this._dataStorage.set(key, storageItem);
            };
            RemoteDataStore.serviceId = "$remoteData";
            RemoteDataStore.$inject = ["$http", "$q", "$requestSender"];
            return RemoteDataStore;
        })();
        _RemoteDataStore.RemoteDataStore = RemoteDataStore;
        var tlRemoteDataStoreModule = angular.module("tlRemoteDataStore", ["tlDataServices"]);
        tlRemoteDataStoreModule.service(RemoteDataStore.serviceId, RemoteDataStore);
    })(RemoteDataStore = Triarc.RemoteDataStore || (Triarc.RemoteDataStore = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Scroll;
    (function (Scroll) {
        Scroll.scroll = angular.module("tlScroll", []);
    })(Scroll = Triarc.Scroll || (Triarc.Scroll = {}));
})(Triarc || (Triarc = {}));
/// <reference path="scroll.module.ts" />
var Triarc;
(function (Triarc) {
    var Scroll;
    (function (Scroll) {
        Scroll.scroll.directive('horizontalScrollReceiver', function () {
            // The element with this attribute will scroll at the same time as the scrollSender element
            return {
                restrict: 'A',
                require: '^scrollManager',
                link: function (scope, element, attrs, scrollManagerCtrl) {
                    scrollManagerCtrl.registerHorizontalReceiver(element);
                }
            };
        });
    })(Scroll = Triarc.Scroll || (Triarc.Scroll = {}));
})(Triarc || (Triarc = {}));
/// <reference path="scroll.module.ts" />
var Triarc;
(function (Triarc) {
    var Scroll;
    (function (Scroll) {
        Scroll.scroll.directive('scrollManager', function () {
            // The element with this attribute will scroll at the same time as the scrollSender element
            return {
                restrict: 'A',
                scope: {},
                controller: [
                    '$scope',
                    function ($scope) {
                        $scope.horizontal = [];
                        $scope.vertical = [];
                        this.registerVerticalReceiver = function (element) {
                            element.css('position', 'relative');
                            $scope.vertical.push(element[0]);
                        };
                        this.registerHorizontalReceiver = function (element) {
                            element.css('position', 'relative');
                            $scope.horizontal.push(element[0]);
                        };
                        this.getHorizontalRecievers = function () { return $scope.horizontal; };
                        this.getVerticalRecievers = function () { return $scope.vertical; };
                    }
                ]
            };
        });
    })(Scroll = Triarc.Scroll || (Triarc.Scroll = {}));
})(Triarc || (Triarc = {}));
/// <reference path="scroll.module.ts" />
var Triarc;
(function (Triarc) {
    var Scroll;
    (function (Scroll) {
        Scroll.scroll.directive('scrollSender', [
            function () {
                // Updates the element which are registered for the horizontal or vertical scroll event
                return {
                    restrict: 'A',
                    require: ['^scrollManager'],
                    link: function (scope, element, attrs, controllers) {
                        var el = element[0];
                        var updateListeners = function (value) {
                            var i, l;
                            var vertical = controllers[0].getVerticalRecievers();
                            for (i = 0, l = vertical.length; i < l; i++) {
                                var vElement = vertical[i];
                                if (value) {
                                    vElement.scrollTop += value;
                                }
                                else if (vElement.scrollTop !== el.scrollTop) {
                                    vElement.scrollTop = el.scrollTop;
                                }
                            }
                            var horizontal = controllers[0].getHorizontalRecievers();
                            for (i = 0, l = horizontal.length; i < l; i++) {
                                var hElement = horizontal[i];
                                if (hElement.scrollLeft !== el.scrollLeft) {
                                    hElement.scrollLeft = el.scrollLeft;
                                }
                            }
                        };
                        element.bind('scroll', function () { return updateListeners(null); });
                        element.on('mousewheel', function (event) {
                            var wheelDelta = -event.originalEvent.wheelDelta;
                            updateListeners(wheelDelta);
                            element.children('*[scroll-sender]')[0].scrollTop += wheelDelta;
                        });
                    }
                };
            }
        ]);
    })(Scroll = Triarc.Scroll || (Triarc.Scroll = {}));
})(Triarc || (Triarc = {}));
//dispoClientMod.directive('scrollable', ['GanttDirectiveBuilder', '$timeout', 'debounce', 'moment',
//  function (Builder, $timeout, debounce, moment) {
//  var builder = new Builder('ganttScrollable');
//  builder.controller = ($scope, $element) => {
//    $scope.gantt.scroll.$element = $element;
//    var lastScrollLeft;
//
//    $element.bind('scroll', debounce(() => {
//      var el = $element[0];
//      var currentScrollLeft = el.scrollLeft;
//      var direction;
//      var date;
//
//      $scope.gantt.scroll.cachedScrollLeft = currentScrollLeft;
//      $scope.gantt.columnsManager.updateVisibleColumns();
//      $scope.gantt.rowsManager.updateVisibleTasks();
//
//      if (currentScrollLeft < lastScrollLeft && currentScrollLeft === 0) {
//        direction = 'left';
//        date = $scope.gantt.columnsManager.from;
//      } else if (currentScrollLeft > lastScrollLeft && el.offsetWidth + currentScrollLeft >= el.scrollWidth - 1) {
//        direction = 'right';
//        date = $scope.gantt.columnsManager.to;
//      }
//
//      lastScrollLeft = currentScrollLeft;
//
//      if (date !== undefined) {
//        autoExpandColumns(el, date, direction);
//      } else {
//        $scope.gantt.api.scroll.raise.scroll(currentScrollLeft);
//      }
//    }, 5));
//
//    $scope.getScrollableCss = function () {
//      var css = {};
//
//      var maxHeight = $scope.gantt.options.value('maxHeight');
//      if (maxHeight > 0) {
//        css['max-height'] = maxHeight - $scope.gantt.header.getHeight() + 'px';
//        css['overflow-y'] = 'auto';
//
//        if ($scope.gantt.scroll.isVScrollbarVisible()) {
//          css['border-right'] = 'none';
//        }
//      }
//
//      var columnWidth = this.gantt.options.value('columnWidth');
//      var bodySmallerThanGantt = $scope.gantt.width === 0 ? false : $scope.gantt.width < $scope.gantt.getWidth() - $scope.gantt.side.getWidth();
//      if (columnWidth !== undefined && bodySmallerThanGantt) {
//        css.width = ($scope.gantt.width + this.gantt.scroll.getBordersWidth()) + 'px';
//      }
//
//      return css;
//    };
//  };
//  return builder.build();
//}]); 
/// <reference path="scroll.module.ts" />
var Triarc;
(function (Triarc) {
    var Scroll;
    (function (Scroll) {
        Scroll.scroll.directive('tlIsScrolling', [
            '$parse',
            function ($parse) {
                return {
                    restrict: 'E',
                    scope: {
                        scrollingVariable: "="
                    },
                    link: function (scope, element, attrs) {
                        scope.$watch(function () { return element.height(); }, function (newVal, oldVal) {
                            if (element.get(0).scrollHeight > element.height()) {
                                scope.scrollingVariable = true;
                            }
                            else {
                                scope.scrollingVariable = false;
                            }
                        });
                    }
                };
            }
        ]);
    })(Scroll = Triarc.Scroll || (Triarc.Scroll = {}));
})(Triarc || (Triarc = {}));
/// <reference path="scroll.module.ts" />
var Triarc;
(function (Triarc) {
    var Scroll;
    (function (Scroll) {
        Scroll.scroll.directive('verticalScrollReceiver', function () {
            // The element with this attribute will scroll at the same time as the scrollSender element
            return {
                restrict: 'A',
                require: '^scrollManager',
                link: function (scope, element, attrs, scrollManagerCtrl) {
                    scrollManagerCtrl.registerVerticalReceiver(element);
                }
            };
        });
    })(Scroll = Triarc.Scroll || (Triarc.Scroll = {}));
})(Triarc || (Triarc = {}));


var mod = angular.module("tlText", []);
mod.filter("tlEnum", [
    '$translate', function ($translate) {
        return function (val, enumType) {
            if (!angular.isNumber(val))
                return '';
            var enumValues = eval(enumType);
            var result = enumValues[val];
            if (!angular.isString(result))
                return '';
            return $translate.instant(result);
        };
    }
]);
mod.filter("tlEnumOrdinals", [function () {
        return function (val, enumType) {
            return Triarc.getOrdinals(eval(enumType));
        };
    }
]);
mod.directive("tlDotted", [
    '$animate', '$timeout', function ($animate, $timeout) {
        return {
            restricted: "A",
            scope: {
                dotted: '=',
                dottedShow: '=',
            },
            link: function (scope, element, attr) {
                var getClass = function () {
                    var cl = "dotted";
                    if (angular.isString(attr.dottedAnimate)) {
                        cl = attr.dottedAnimate;
                    }
                    return cl;
                };
                var update = function () {
                    element[0].innerText = scope.dotted;
                    //element.text(scope.dotted);
                    if (scope.dottedShow == true) {
                        $animate.addClass(element, getClass());
                    }
                    else {
                        $animate.removeClass(element, getClass(), function () {
                            element.dotdotdot();
                        });
                    }
                };
                scope.$watch("tl-dotted", function () {
                    update();
                });
                scope.$watch("tl-dottedShow", function () {
                    update();
                });
            }
        };
    }]);


var Triarc;
(function (Triarc) {
    var Web;
    (function (Web) {
        var mod = angular.module("tlTimepicker", ["ui.bootstrap"]);
        mod.directive("tlTimepickerFocus", ["$timeout", function ($timeout) {
            return {
                require: ["timepicker"],
                restrict: "A",
                link: function (scope, element, attrs) {
                    $timeout(function () {
                        element.find("input").first().focus().select();
                    }, 200);
                }
            };
        }]);
        mod.directive("tlTimepickerNumeric", function () {
            return {
                require: ["timepicker"],
                restrict: "A",
                link: function (scope, element, attrs) {
                    var inputs = element.find("input:lt(2)");
                    inputs.attr("pattern", "[0-9]*").attr("type", "number").css("padding-right", "14px");
                }
            };
        });
        mod.directive("tlTimepickerPrune", function () {
            return {
                restrict: "A",
                require: ["timepicker", "?^ngModel"],
                link: function (scope, element, attrs, ctrls) {
                    var ngModelCtrl = ctrls[1];
                    if (ngModelCtrl) {
                        scope.$watch(function () {
                            return ngModelCtrl.$modelValue;
                        }, function (newVal) {
                            if (newVal !== undefined && newVal !== null) {
                                newVal.setMilliseconds(0);
                                newVal.setSeconds(0);
                            }
                        });
                    }
                }
            };
        });
    })(Web = Triarc.Web || (Triarc.Web = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Web;
    (function (Web) {
        var mod = angular.module("tlTreeView", []);
        mod.factory("cirrusTreeViewService", function () {
            var factory = {
                selectedNode: null,
                unselectNode: function () {
                    if (factory.selectedNode)
                        factory.selectedNode.selected = undefined;
                    factory.selectedNode = null;
                },
                selectNode: function (node) {
                    if (factory.selectedNode)
                        factory.selectedNode.selected = undefined;
                    factory.selectedNode = node;
                    node.selected = true;
                },
                toggleNode: function (node) {
                    // no node selected
                    if (!node)
                        return;
                    // no children
                    if (!node.children)
                        return;
                    // collapse / expand
                    if (node.children && node.children.length > 0) {
                        node.$$opened = !node.$$opened;
                    }
                },
                openNode: function (node) {
                    node.$$opened = true;
                },
                closeNode: function (node) {
                    node.$$opened = false;
                },
                toggleAll: function (node) {
                    // no node selected
                    if (!node)
                        return;
                    // set all children equal to what the parent will be, 
                    // else can get out of sync
                    var $$opened = !node.$$opened;
                    var iterate = function (child) {
                        if (!child.children) {
                            return;
                        }
                        else {
                            child.$$opened = $$opened;
                            for (var i = 0; i < child.children.length; i++) {
                                iterate(child.children[i]);
                            }
                        }
                    };
                    iterate(node);
                }
            };
            return factory;
        });
        mod.directive("treeView", ["$compile", "$parse", "cirrusTreeViewService", function ($compile, $parse, treeViewService) {
                return {
                    restrict: "A",
                    link: function (scope, elem, attrs) {
                        var canSelectCallbackFn = $parse(attrs.canSelectCallbackFn);
                        var model = attrs.treeView;
                        var nodeTemplate = "<div class=\"node\" ng-include=\"'" + attrs.nodeTemplate + "'\"></div>";
                        // template
                        var template = '<ul class="cirrus-tl-tree-view">' +
                            '<li ng-repeat="node in ' + model + '">' +
                            '<div>' +
                            '<div>' +
                            '<span ng-click="toggleNode(node)" ng-style="{\'visibility\': (node.children && node.children.length > 0)?\'visible\':\'hidden\'}" ng-class="!node.$$opened ? \'has-child glyphicon glyphicon-chevron-right\' : \'has-child-open glyphicon glyphicon-chevron-down\'"></span>' +
                            '<span ng-click="selectNode(node)" class=\'template-container\' ng-class="{\'selected\' : node.selected}">' +
                            nodeTemplate +
                            '</span>' +
                            '</div>' +
                            '</div>' +
                            '<div class="cirrus-tl-tree-view" ng-if="node.$$opened" tree-view="node.children" tree-root="false" node-template="' + attrs.nodeTemplate + '"></div>' +
                            '</li>' +
                            '</ul>';
                        // root node
                        if (!Triarc.hasValue(attrs.treeRoot) || attrs.treeRoot !== "false") {
                            // toggle when icon clicked
                            scope.toggleNode = function (node) {
                                treeViewService.toggleNode(node);
                            };
                            // select when name clicked
                            scope.selectNode = function (node) {
                                var response = canSelectCallbackFn(scope, { node: node });
                                if (Triarc.hasValue(response)) {
                                    response.then(function (result) {
                                        if (result) {
                                            treeViewService.selectNode(node);
                                        }
                                    });
                                }
                                else {
                                    treeViewService.selectNode(node);
                                }
                            };
                        }
                        var compiledHtml = $compile(template)(scope);
                        elem.append(compiledHtml);
                    }
                };
            }]);
    })(Web = Triarc.Web || (Triarc.Web = {}));
})(Triarc || (Triarc = {}));


var Triarc;
(function (Triarc) {
    var Vm;
    (function (Vm) {
        /**
         *
         */
        var ViewModel = (function () {
            function ViewModel(vmImpl, cm) {
                this.vmImpl = vmImpl;
                /**
                 *
                 */
                this.lazyMap = new Map();
                this.$cm = cm;
            }
            Object.defineProperty(ViewModel.prototype, "id", {
                /**
                 *
                 * @returns {}
                 */
                get: function () {
                    return this.$cm.id;
                },
                enumerable: true,
                configurable: true
            });
            /**
             *
             * @param cm
             * @returns {}
             */
            ViewModel.prototype.update = function (cm) {
                this.vmImpl(this).updateCm(cm);
            };
            Object.defineProperty(ViewModel.prototype, "timestamp", {
                /**
                 *
                 * @returns {}
                 */
                get: function () {
                    return this.$cm.timestamp;
                },
                enumerable: true,
                configurable: true
            });
            /**
             *
             * @returns {}
             */
            ViewModel.prototype.resetLazies = function () {
                this.lazyMap.clear();
            };
            /**
             *
             * @param key
             * @param resolve
             * @param emptyDefault
             * @returns {}
             */
            ViewModel.prototype.lazyLoad = function (key, resolve, emptyDefault) {
                var result = this.lazyMap.get(key);
                if (angular.isUndefined(result)) {
                    result = resolve();
                    if (angular.isDefined(result) && result !== null) {
                        this.lazyMap.set(key, result);
                    }
                    else {
                        result = emptyDefault || null;
                    }
                }
                return result;
            };
            return ViewModel;
        }());
        Vm.ViewModel = ViewModel;
    })(Vm = Triarc.Vm || (Triarc.Vm = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Vm;
    (function (Vm) {
        /**
         *
         * An enum that represents the current state of the ViewModelPromise
         */
        (function (EPromiseState) {
            EPromiseState[EPromiseState["NotResolved"] = 0] = "NotResolved";
            EPromiseState[EPromiseState["Resolving"] = 1] = "Resolving";
            EPromiseState[EPromiseState["Resolved"] = 2] = "Resolved";
            EPromiseState[EPromiseState["Failed"] = 3] = "Failed";
        })(Vm.EPromiseState || (Vm.EPromiseState = {}));
        var EPromiseState = Vm.EPromiseState;
        /**
         *
         */
        var ViewModelPromise = (function () {
            function ViewModelPromise(resolveFn) {
                this.resolveFn = resolveFn;
                /**
                 * The result(s) of the fetched promise value
                 */
                this.value = null;
                this.clear();
            }
            Object.defineProperty(ViewModelPromise.prototype, "state", {
                /**
                 * Returns the current state of the ViewModelPromise
                 * @returns {}
                 */
                get: function () {
                    return this.$state;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ViewModelPromise.prototype, "promise", {
                /**
                 * The promise fetching the results
                 * @returns {}
                 */
                get: function () {
                    return this.$promise;
                },
                /**
                 * Sets the promise for the asynchronous fetch and will controll all appropriate states of the ViewModelPromise
                 * @param val
                 * @returns {}
                 */
                set: function (val) {
                    var _this = this;
                    this.$state = EPromiseState.Resolving;
                    this.value = null;
                    this.$promise = val;
                    this.$promise.then(function () { return _this.$state = EPromiseState.Resolved; }, function () { return _this.$state = EPromiseState.Failed; });
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Clears down the ViewModel promise to its default values
             * @returns {}
             */
            ViewModelPromise.prototype.clear = function () {
                this.$state = EPromiseState.NotResolved;
                this.$promise = null;
            };
            ViewModelPromise.prototype.resolveManually = function ($q, result) {
                this.$promise = $q.when(result);
                this.value = result;
                this.$state = EPromiseState.Resolved;
            };
            /**
             * Performs the fetch for the results using the function (returning a promise) and then sets the values
             * @param resolve
             * @returns {}
             */
            ViewModelPromise.prototype.resolve = function () {
                var _this = this;
                if (Triarc.hasNoValue(this.$promise)) {
                    this.promise = this.resolveFn().then(function (result) { return _this.value = result; });
                }
                return this;
            };
            return ViewModelPromise;
        }());
        Vm.ViewModelPromise = ViewModelPromise;
    })(Vm = Triarc.Vm || (Triarc.Vm = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Vm;
    (function (Vm) {
        var ViewModelLoadRegistry = (function () {
            function ViewModelLoadRegistry($q, loadCallback, entityStoreAdapter, debounceIntervall) {
                this.$q = $q;
                this.loadCallback = loadCallback;
                this.entityStoreAdapter = entityStoreAdapter;
                this.debounceIntervall = debounceIntervall;
                this.$promises = new Map();
                this.timeoutRunning = null;
                this.debounceDefer = null;
                this.debouncedIds = [];
            }
            ViewModelLoadRegistry.prototype.get = function (ids, options) {
                var _this = this;
                if (options === void 0) { options = {}; }
                if (angular.isUndefined(options.forceReload)) {
                    options.forceReload = false;
                }
                if (angular.isUndefined(options.preventDebounce)) {
                    options.preventDebounce = false;
                }
                var notLoaded = [];
                var loadedIds = [];
                ids.forEach(function (id) {
                    if (!_this.entityStoreAdapter.has(id) || options.forceReload) {
                        notLoaded.add(id);
                    }
                    else {
                        loadedIds.add(id);
                    }
                });
                var alreadyLoadedEntities = loadedIds.toEnumerable().select(function (id) { return _this.entityStoreAdapter.get(id); }).toArray();
                if (!notLoaded.any()) {
                    return this.$q.when(alreadyLoadedEntities);
                }
                var notRequested = new Array();
                var existingPromises = new Array();
                notLoaded.forEach(function (id) {
                    var existinPromise = _this.$promises.get(id);
                    if (angular.isObject(existinPromise)) {
                        existingPromises.add(existinPromise);
                    }
                    else {
                        notRequested.add(id);
                    }
                });
                if (notRequested.any()) {
                    var newPromise = this.startLoadingIds(notLoaded, options);
                    existingPromises.add(newPromise);
                }
                return this.$q.all(existingPromises).then(function (promisResults) {
                    var entities = promisResults
                        .toEnumerable()
                        .selectMany(function (e) { return e; })
                        .where(function (e) { return ids.toEnumerable().any(function (id) { return _this.entityStoreAdapter.isKey(e, id); }); })
                        .toArray();
                    return _this.entityStoreAdapter.attachMultipleAndGet(entities).toEnumerable().concat(alreadyLoadedEntities).toArray();
                });
            };
            ViewModelLoadRegistry.prototype.startLoadingIds = function (ids, options) {
                if (angular.isNumber(this.debounceIntervall) && !options.preventDebounce) {
                    return this.debounceLoading(ids, options);
                }
                else {
                    return this.loadIds(ids, options);
                }
            };
            ViewModelLoadRegistry.prototype.debounceLoading = function (ids, options) {
                var _this = this;
                this.debouncedIds.addRange(ids);
                if (angular.isNumber(this.timeoutRunning)) {
                    // cancel
                    clearTimeout(this.timeoutRunning);
                }
                if (!angular.isObject(this.debounceDefer)) {
                    this.debounceDefer = this.$q.defer();
                }
                // since making http request anyway triggers a global digest, don't use $apply
                this.timeoutRunning = setTimeout(function () {
                    var defer = _this.debounceDefer;
                    _this.loadIds(_this.debouncedIds.toEnumerable().distinct().toArray(), options).then(function (e) {
                        defer.resolve(e);
                    }, _this.debounceDefer.reject);
                    _this.resetDebounce();
                }, this.debounceIntervall);
                return this.debounceDefer.promise.then(function (r) {
                    _this.entityStoreAdapter.attachMultipleAndGet(r);
                    return r.toEnumerable().where(function (e) { return ids.toEnumerable().any(function (id) { return _this.entityStoreAdapter.isKey(e, id); }); }).toArray();
                });
            };
            ViewModelLoadRegistry.prototype.resetDebounce = function () {
                this.debounceDefer = null;
                this.debouncedIds.clear();
                this.timeoutRunning = null;
            };
            ViewModelLoadRegistry.prototype.loadIds = function (ids, options) {
                var _this = this;
                var newPromise = this.loadCallback(ids, options.additionalRequestArgs);
                ids.forEach(function (id) {
                    _this.$promises.set(id, newPromise);
                });
                newPromise.finally(function () {
                    ids.forEach(function (id) {
                        _this.$promises.delete(id);
                    });
                });
                return newPromise;
            };
            return ViewModelLoadRegistry;
        }());
        Vm.ViewModelLoadRegistry = ViewModelLoadRegistry;
    })(Vm = Triarc.Vm || (Triarc.Vm = {}));
})(Triarc || (Triarc = {}));
var Triarc;
(function (Triarc) {
    var Vm;
    (function (Vm) {
        /**
         *
         */
        var ViewModelRefStore = (function () {
            function ViewModelRefStore(defaultFactoryFn) {
                this.defaultFactoryFn = defaultFactoryFn;
                this.referenceMap = new Map();
            }
            ViewModelRefStore.prototype.getTimestampFromVm = function (entity) {
                return entity.timestamp;
            };
            /**
             *
             * @param entity
             * @returns {}
             */
            ViewModelRefStore.prototype.getTimestampFromCm = function (entity) {
                return entity.timestamp;
            };
            /**
             *
             * @param entityCm
             * @param viewModel
             * @param createVmCallback
             * @returns {}
             */
            ViewModelRefStore.prototype.updateViewModel = function (entityCm, viewModel, createVmCallback) {
                viewModel.update(entityCm);
                //angular.extend(viewModel, createVmCallback(entityCm));
            };
            /**
             *
             * @param entities
             * @param createVmCallback
             * @param isChanged
             * @returns {}
             */
            ViewModelRefStore.prototype.attachMultipleAndGet = function (entities, createVmCallback, isChanged) {
                var _this = this;
                var result = [];
                var createVmFn = angular.isFunction(createVmCallback) ? createVmCallback : this.defaultFactoryFn;
                if (angular.isArray(entities)) {
                    entities.forEach(function (e) { return result.push(_this.attachAndGet(e, createVmFn, isChanged)); });
                }
                return result;
            };
            /**
             *
             * @param entityCm
             * @param createVmCallback
             * @param isChanged
             * @param updateOnSameTimestamp
             * @returns {}
             */
            ViewModelRefStore.prototype.attachAndGet = function (entityCm, createVmCallback, isChanged, updateOnSameTimestamp) {
                if (updateOnSameTimestamp === void 0) { updateOnSameTimestamp = false; }
                var createVmFn = angular.isFunction(createVmCallback) ? createVmCallback : this.defaultFactoryFn;
                var entityId = entityCm.id;
                if (angular.isObject(isChanged)) {
                    isChanged.isChanged = true;
                }
                else {
                    isChanged = {
                        isChanged: true
                    };
                }
                var existingVm = this.referenceMap.get(entityId);
                if (angular.isObject(existingVm)) {
                    var existingTimestamp = this.getTimestampFromVm(existingVm);
                    var newTimestamp = this.getTimestampFromCm(entityCm);
                    if (existingTimestamp == null || existingTimestamp < newTimestamp) {
                        console.log('override loaded entity:' + entityId + "   old:" + existingTimestamp + "   new:" + newTimestamp);
                        this.updateViewModel(entityCm, existingVm, createVmFn);
                    }
                    else if (existingTimestamp === newTimestamp) {
                        if (updateOnSameTimestamp) {
                            this.updateViewModel(entityCm, existingVm, createVmFn);
                        }
                        else {
                            isChanged.isChanged = false;
                        }
                    }
                    else {
                        console.warn("existing entity " + entityId + " is newer than new one, reject");
                        isChanged.isChanged = false;
                    }
                    return existingVm;
                }
                var newVm = createVmFn(entityCm);
                this.referenceMap.set(entityId, newVm);
                return newVm;
            };
            /**
             *
             * @param changeSet
             * @param createVmCallback
             * @param filterUnchaged
             * @returns {}
             */
            ViewModelRefStore.prototype.attachChangeSet = function (changeSet, createVmCallback, filterUnchaged) {
                var _this = this;
                if (filterUnchaged === void 0) { filterUnchaged = true; }
                var createVmFn = angular.isFunction(createVmCallback) ? createVmCallback : this.defaultFactoryFn;
                var added = [];
                if (angular.isArray(changeSet.added)) {
                    changeSet.added.forEach(function (t) {
                        var isChanged = {
                            isChanged: false
                        };
                        var attachClientModel = _this.attachAndGet(t, createVmFn, isChanged);
                        if (isChanged.isChanged || !filterUnchaged)
                            added.push(attachClientModel);
                    });
                }
                var updated = [];
                if (angular.isArray(changeSet.updated)) {
                    changeSet.updated.forEach(function (t) {
                        var isChanged = {
                            isChanged: false
                        };
                        var attachClientModel = _this.attachAndGet(t, createVmFn, isChanged);
                        if (isChanged.isChanged || !filterUnchaged)
                            updated.push(attachClientModel);
                    });
                }
                changeSet.deleted.forEach(function (id) {
                    _this.referenceMap.delete(id);
                });
                return {
                    deleted: changeSet.deleted,
                    added: added,
                    updated: updated
                };
            };
            /**
             *
             * @param id
             * @returns {}
             */
            ViewModelRefStore.prototype.get = function (id) {
                var vm = this.referenceMap.get(id);
                if (angular.isObject(vm))
                    return vm;
                return null;
            };
            ViewModelRefStore.prototype.isKey = function (entity, id) {
                return entity.id === id;
            };
            /**
             *
             * @param id
             * @returns {}
             */
            ViewModelRefStore.prototype.has = function (id) {
                return this.referenceMap.has(id);
            };
            ViewModelRefStore.prototype.remove = function (id) {
                return this.referenceMap.delete(id);
            };
            /**
             * Returns all entities. Remember, that "With great power comes great responsibility"
             * @returns {}
             */
            ViewModelRefStore.prototype.getAll = function () {
                return this.referenceMap.getValues();
            };
            /**
             * Allows the full injection. TODO remove if replaced in wettstein
             * @param changeSet
             * @param dataControllerId
             * @returns {}
             */
            ViewModelRefStore.inject = function (changeSet, dataControllerId) {
                Triarc.Data.convertDateStringsToDates(changeSet);
                var injector = $("#app").injector();
                if (!angular.isObject(injector))
                    return;
                injector.invoke([
                    dataControllerId, function (datadataController) {
                        datadataController.applyChangeSet(changeSet);
                    }
                ]);
            };
            return ViewModelRefStore;
        }());
        Vm.ViewModelRefStore = ViewModelRefStore;
    })(Vm = Triarc.Vm || (Triarc.Vm = {}));
})(Triarc || (Triarc = {}));


/*
 *	jQuery dotdotdot 1.6.16
 *
 *	Copyright (c) Fred Heusschen
 *	www.frebsite.nl
 *
 *	Plugin website:
 *	dotdotdot.frebsite.nl
 *
 *	Dual licensed under the MIT and GPL licenses.
 *	http://en.wikipedia.org/wiki/MIT_License
 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
 */
!function(t,e){function n(t,e,n){var r=t.children(),o=!1;t.empty();for(var i=0,d=r.length;d>i;i++){var l=r.eq(i);if(t.append(l),n&&t.append(n),a(t,e)){l.remove(),o=!0;break}n&&n.detach()}return o}function r(e,n,i,d,l){var s=!1,c="table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style",u="script, .dotdotdot-keep";return e.contents().detach().each(function(){var f=this,h=t(f);if("undefined"==typeof f||3==f.nodeType&&0==t.trim(f.data).length)return!0;if(h.is(u))e.append(h);else{if(s)return!0;e.append(h),l&&e[e.is(c)?"after":"append"](l),a(i,d)&&(s=3==f.nodeType?o(h,n,i,d,l):r(h,n,i,d,l),s||(h.detach(),s=!0)),s||l&&l.detach()}}),s}function o(e,n,r,o,d){var c=e[0];if(!c)return!1;var f=s(c),h=-1!==f.indexOf(" ")?" ":"　",p="letter"==o.wrap?"":h,g=f.split(p),v=-1,w=-1,b=0,y=g.length-1;for(o.fallbackToLetter&&0==b&&0==y&&(p="",g=f.split(p),y=g.length-1);y>=b&&(0!=b||0!=y);){var m=Math.floor((b+y)/2);if(m==w)break;w=m,l(c,g.slice(0,w+1).join(p)+o.ellipsis),a(r,o)?(y=w,o.fallbackToLetter&&0==b&&0==y&&(p="",g=g[0].split(p),v=-1,w=-1,b=0,y=g.length-1)):(v=w,b=w)}if(-1==v||1==g.length&&0==g[0].length){var x=e.parent();e.detach();var T=d&&d.closest(x).length?d.length:0;x.contents().length>T?c=u(x.contents().eq(-1-T),n):(c=u(x,n,!0),T||x.detach()),c&&(f=i(s(c),o),l(c,f),T&&d&&t(c).parent().append(d))}else f=i(g.slice(0,v+1).join(p),o),l(c,f);return!0}function a(t,e){return t.innerHeight()>e.maxHeight}function i(e,n){for(;t.inArray(e.slice(-1),n.lastCharacter.remove)>-1;)e=e.slice(0,-1);return t.inArray(e.slice(-1),n.lastCharacter.noEllipsis)<0&&(e+=n.ellipsis),e}function d(t){return{width:t.innerWidth(),height:t.innerHeight()}}function l(t,e){t.innerText?t.innerText=e:t.nodeValue?t.nodeValue=e:t.textContent&&(t.textContent=e)}function s(t){return t.innerText?t.innerText:t.nodeValue?t.nodeValue:t.textContent?t.textContent:""}function c(t){do t=t.previousSibling;while(t&&1!==t.nodeType&&3!==t.nodeType);return t}function u(e,n,r){var o,a=e&&e[0];if(a){if(!r){if(3===a.nodeType)return a;if(t.trim(e.text()))return u(e.contents().last(),n)}for(o=c(a);!o;){if(e=e.parent(),e.is(n)||!e.length)return!1;o=c(e[0])}if(o)return u(t(o),n)}return!1}function f(e,n){return e?"string"==typeof e?(e=t(e,n),e.length?e:!1):e.jquery?e:!1:!1}function h(t){for(var e=t.innerHeight(),n=["paddingTop","paddingBottom"],r=0,o=n.length;o>r;r++){var a=parseInt(t.css(n[r]),10);isNaN(a)&&(a=0),e-=a}return e}if(!t.fn.dotdotdot){t.fn.dotdotdot=function(e){if(0==this.length)return t.fn.dotdotdot.debug('No element found for "'+this.selector+'".'),this;if(this.length>1)return this.each(function(){t(this).dotdotdot(e)});var o=this;o.data("dotdotdot")&&o.trigger("destroy.dot"),o.data("dotdotdot-style",o.attr("style")||""),o.css("word-wrap","break-word"),"nowrap"===o.css("white-space")&&o.css("white-space","normal"),o.bind_events=function(){return o.bind("update.dot",function(e,d){e.preventDefault(),e.stopPropagation(),l.maxHeight="number"==typeof l.height?l.height:h(o),l.maxHeight+=l.tolerance,"undefined"!=typeof d&&(("string"==typeof d||d instanceof HTMLElement)&&(d=t("<div />").append(d).contents()),d instanceof t&&(i=d)),g=o.wrapInner('<div class="dotdotdot" />').children(),g.contents().detach().end().append(i.clone(!0)).find("br").replaceWith("  <br />  ").end().css({height:"auto",width:"auto",border:"none",padding:0,margin:0});var c=!1,u=!1;return s.afterElement&&(c=s.afterElement.clone(!0),c.show(),s.afterElement.detach()),a(g,l)&&(u="children"==l.wrap?n(g,l,c):r(g,o,g,l,c)),g.replaceWith(g.contents()),g=null,t.isFunction(l.callback)&&l.callback.call(o[0],u,i),s.isTruncated=u,u}).bind("isTruncated.dot",function(t,e){return t.preventDefault(),t.stopPropagation(),"function"==typeof e&&e.call(o[0],s.isTruncated),s.isTruncated}).bind("originalContent.dot",function(t,e){return t.preventDefault(),t.stopPropagation(),"function"==typeof e&&e.call(o[0],i),i}).bind("destroy.dot",function(t){t.preventDefault(),t.stopPropagation(),o.unwatch().unbind_events().contents().detach().end().append(i).attr("style",o.data("dotdotdot-style")||"").data("dotdotdot",!1)}),o},o.unbind_events=function(){return o.unbind(".dot"),o},o.watch=function(){if(o.unwatch(),"window"==l.watch){var e=t(window),n=e.width(),r=e.height();e.bind("resize.dot"+s.dotId,function(){n==e.width()&&r==e.height()&&l.windowResizeFix||(n=e.width(),r=e.height(),u&&clearInterval(u),u=setTimeout(function(){o.trigger("update.dot")},100))})}else c=d(o),u=setInterval(function(){if(o.is(":visible")){var t=d(o);(c.width!=t.width||c.height!=t.height)&&(o.trigger("update.dot"),c=t)}},500);return o},o.unwatch=function(){return t(window).unbind("resize.dot"+s.dotId),u&&clearInterval(u),o};var i=o.contents(),l=t.extend(!0,{},t.fn.dotdotdot.defaults,e),s={},c={},u=null,g=null;return l.lastCharacter.remove instanceof Array||(l.lastCharacter.remove=t.fn.dotdotdot.defaultArrays.lastCharacter.remove),l.lastCharacter.noEllipsis instanceof Array||(l.lastCharacter.noEllipsis=t.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis),s.afterElement=f(l.after,o),s.isTruncated=!1,s.dotId=p++,o.data("dotdotdot",!0).bind_events().trigger("update.dot"),l.watch&&o.watch(),o},t.fn.dotdotdot.defaults={ellipsis:"... ",wrap:"word",fallbackToLetter:!0,lastCharacter:{},tolerance:0,callback:null,after:null,height:null,watch:!1,windowResizeFix:!0},t.fn.dotdotdot.defaultArrays={lastCharacter:{remove:[" ","　",",",";",".","!","?"],noEllipsis:[]}},t.fn.dotdotdot.debug=function(){};var p=1,g=t.fn.html;t.fn.html=function(n){return n!=e&&!t.isFunction(n)&&this.data("dotdotdot")?this.trigger("update",[n]):g.apply(this,arguments)};var v=t.fn.text;t.fn.text=function(n){return n!=e&&!t.isFunction(n)&&this.data("dotdotdot")?(n=t("<div />").text(n).html(),this.trigger("update",[n])):v.apply(this,arguments)}}}(jQuery);
//! moment.js
//! version : 2.10.6
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
!function(a,b){"object"==typeof exports&&"undefined"!=typeof module?module.exports=b():"function"==typeof define&&define.amd?define(b):a.moment=b()}(this,function(){"use strict";function a(){return Hc.apply(null,arguments)}function b(a){Hc=a}function c(a){return"[object Array]"===Object.prototype.toString.call(a)}function d(a){return a instanceof Date||"[object Date]"===Object.prototype.toString.call(a)}function e(a,b){var c,d=[];for(c=0;c<a.length;++c)d.push(b(a[c],c));return d}function f(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function g(a,b){for(var c in b)f(b,c)&&(a[c]=b[c]);return f(b,"toString")&&(a.toString=b.toString),f(b,"valueOf")&&(a.valueOf=b.valueOf),a}function h(a,b,c,d){return Ca(a,b,c,d,!0).utc()}function i(){return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1}}function j(a){return null==a._pf&&(a._pf=i()),a._pf}function k(a){if(null==a._isValid){var b=j(a);a._isValid=!(isNaN(a._d.getTime())||!(b.overflow<0)||b.empty||b.invalidMonth||b.invalidWeekday||b.nullInput||b.invalidFormat||b.userInvalidated),a._strict&&(a._isValid=a._isValid&&0===b.charsLeftOver&&0===b.unusedTokens.length&&void 0===b.bigHour)}return a._isValid}function l(a){var b=h(NaN);return null!=a?g(j(b),a):j(b).userInvalidated=!0,b}function m(a,b){var c,d,e;if("undefined"!=typeof b._isAMomentObject&&(a._isAMomentObject=b._isAMomentObject),"undefined"!=typeof b._i&&(a._i=b._i),"undefined"!=typeof b._f&&(a._f=b._f),"undefined"!=typeof b._l&&(a._l=b._l),"undefined"!=typeof b._strict&&(a._strict=b._strict),"undefined"!=typeof b._tzm&&(a._tzm=b._tzm),"undefined"!=typeof b._isUTC&&(a._isUTC=b._isUTC),"undefined"!=typeof b._offset&&(a._offset=b._offset),"undefined"!=typeof b._pf&&(a._pf=j(b)),"undefined"!=typeof b._locale&&(a._locale=b._locale),Jc.length>0)for(c in Jc)d=Jc[c],e=b[d],"undefined"!=typeof e&&(a[d]=e);return a}function n(b){m(this,b),this._d=new Date(null!=b._d?b._d.getTime():NaN),Kc===!1&&(Kc=!0,a.updateOffset(this),Kc=!1)}function o(a){return a instanceof n||null!=a&&null!=a._isAMomentObject}function p(a){return 0>a?Math.ceil(a):Math.floor(a)}function q(a){var b=+a,c=0;return 0!==b&&isFinite(b)&&(c=p(b)),c}function r(a,b,c){var d,e=Math.min(a.length,b.length),f=Math.abs(a.length-b.length),g=0;for(d=0;e>d;d++)(c&&a[d]!==b[d]||!c&&q(a[d])!==q(b[d]))&&g++;return g+f}function s(){}function t(a){return a?a.toLowerCase().replace("_","-"):a}function u(a){for(var b,c,d,e,f=0;f<a.length;){for(e=t(a[f]).split("-"),b=e.length,c=t(a[f+1]),c=c?c.split("-"):null;b>0;){if(d=v(e.slice(0,b).join("-")))return d;if(c&&c.length>=b&&r(e,c,!0)>=b-1)break;b--}f++}return null}function v(a){var b=null;if(!Lc[a]&&"undefined"!=typeof module&&module&&module.exports)try{b=Ic._abbr,require("./locale/"+a),w(b)}catch(c){}return Lc[a]}function w(a,b){var c;return a&&(c="undefined"==typeof b?y(a):x(a,b),c&&(Ic=c)),Ic._abbr}function x(a,b){return null!==b?(b.abbr=a,Lc[a]=Lc[a]||new s,Lc[a].set(b),w(a),Lc[a]):(delete Lc[a],null)}function y(a){var b;if(a&&a._locale&&a._locale._abbr&&(a=a._locale._abbr),!a)return Ic;if(!c(a)){if(b=v(a))return b;a=[a]}return u(a)}function z(a,b){var c=a.toLowerCase();Mc[c]=Mc[c+"s"]=Mc[b]=a}function A(a){return"string"==typeof a?Mc[a]||Mc[a.toLowerCase()]:void 0}function B(a){var b,c,d={};for(c in a)f(a,c)&&(b=A(c),b&&(d[b]=a[c]));return d}function C(b,c){return function(d){return null!=d?(E(this,b,d),a.updateOffset(this,c),this):D(this,b)}}function D(a,b){return a._d["get"+(a._isUTC?"UTC":"")+b]()}function E(a,b,c){return a._d["set"+(a._isUTC?"UTC":"")+b](c)}function F(a,b){var c;if("object"==typeof a)for(c in a)this.set(c,a[c]);else if(a=A(a),"function"==typeof this[a])return this[a](b);return this}function G(a,b,c){var d=""+Math.abs(a),e=b-d.length,f=a>=0;return(f?c?"+":"":"-")+Math.pow(10,Math.max(0,e)).toString().substr(1)+d}function H(a,b,c,d){var e=d;"string"==typeof d&&(e=function(){return this[d]()}),a&&(Qc[a]=e),b&&(Qc[b[0]]=function(){return G(e.apply(this,arguments),b[1],b[2])}),c&&(Qc[c]=function(){return this.localeData().ordinal(e.apply(this,arguments),a)})}function I(a){return a.match(/\[[\s\S]/)?a.replace(/^\[|\]$/g,""):a.replace(/\\/g,"")}function J(a){var b,c,d=a.match(Nc);for(b=0,c=d.length;c>b;b++)Qc[d[b]]?d[b]=Qc[d[b]]:d[b]=I(d[b]);return function(e){var f="";for(b=0;c>b;b++)f+=d[b]instanceof Function?d[b].call(e,a):d[b];return f}}function K(a,b){return a.isValid()?(b=L(b,a.localeData()),Pc[b]=Pc[b]||J(b),Pc[b](a)):a.localeData().invalidDate()}function L(a,b){function c(a){return b.longDateFormat(a)||a}var d=5;for(Oc.lastIndex=0;d>=0&&Oc.test(a);)a=a.replace(Oc,c),Oc.lastIndex=0,d-=1;return a}function M(a){return"function"==typeof a&&"[object Function]"===Object.prototype.toString.call(a)}function N(a,b,c){dd[a]=M(b)?b:function(a){return a&&c?c:b}}function O(a,b){return f(dd,a)?dd[a](b._strict,b._locale):new RegExp(P(a))}function P(a){return a.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(a,b,c,d,e){return b||c||d||e}).replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function Q(a,b){var c,d=b;for("string"==typeof a&&(a=[a]),"number"==typeof b&&(d=function(a,c){c[b]=q(a)}),c=0;c<a.length;c++)ed[a[c]]=d}function R(a,b){Q(a,function(a,c,d,e){d._w=d._w||{},b(a,d._w,d,e)})}function S(a,b,c){null!=b&&f(ed,a)&&ed[a](b,c._a,c,a)}function T(a,b){return new Date(Date.UTC(a,b+1,0)).getUTCDate()}function U(a){return this._months[a.month()]}function V(a){return this._monthsShort[a.month()]}function W(a,b,c){var d,e,f;for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),d=0;12>d;d++){if(e=h([2e3,d]),c&&!this._longMonthsParse[d]&&(this._longMonthsParse[d]=new RegExp("^"+this.months(e,"").replace(".","")+"$","i"),this._shortMonthsParse[d]=new RegExp("^"+this.monthsShort(e,"").replace(".","")+"$","i")),c||this._monthsParse[d]||(f="^"+this.months(e,"")+"|^"+this.monthsShort(e,""),this._monthsParse[d]=new RegExp(f.replace(".",""),"i")),c&&"MMMM"===b&&this._longMonthsParse[d].test(a))return d;if(c&&"MMM"===b&&this._shortMonthsParse[d].test(a))return d;if(!c&&this._monthsParse[d].test(a))return d}}function X(a,b){var c;return"string"==typeof b&&(b=a.localeData().monthsParse(b),"number"!=typeof b)?a:(c=Math.min(a.date(),T(a.year(),b)),a._d["set"+(a._isUTC?"UTC":"")+"Month"](b,c),a)}function Y(b){return null!=b?(X(this,b),a.updateOffset(this,!0),this):D(this,"Month")}function Z(){return T(this.year(),this.month())}function $(a){var b,c=a._a;return c&&-2===j(a).overflow&&(b=c[gd]<0||c[gd]>11?gd:c[hd]<1||c[hd]>T(c[fd],c[gd])?hd:c[id]<0||c[id]>24||24===c[id]&&(0!==c[jd]||0!==c[kd]||0!==c[ld])?id:c[jd]<0||c[jd]>59?jd:c[kd]<0||c[kd]>59?kd:c[ld]<0||c[ld]>999?ld:-1,j(a)._overflowDayOfYear&&(fd>b||b>hd)&&(b=hd),j(a).overflow=b),a}function _(b){a.suppressDeprecationWarnings===!1&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+b)}function aa(a,b){var c=!0;return g(function(){return c&&(_(a+"\n"+(new Error).stack),c=!1),b.apply(this,arguments)},b)}function ba(a,b){od[a]||(_(b),od[a]=!0)}function ca(a){var b,c,d=a._i,e=pd.exec(d);if(e){for(j(a).iso=!0,b=0,c=qd.length;c>b;b++)if(qd[b][1].exec(d)){a._f=qd[b][0];break}for(b=0,c=rd.length;c>b;b++)if(rd[b][1].exec(d)){a._f+=(e[6]||" ")+rd[b][0];break}d.match(ad)&&(a._f+="Z"),va(a)}else a._isValid=!1}function da(b){var c=sd.exec(b._i);return null!==c?void(b._d=new Date(+c[1])):(ca(b),void(b._isValid===!1&&(delete b._isValid,a.createFromInputFallback(b))))}function ea(a,b,c,d,e,f,g){var h=new Date(a,b,c,d,e,f,g);return 1970>a&&h.setFullYear(a),h}function fa(a){var b=new Date(Date.UTC.apply(null,arguments));return 1970>a&&b.setUTCFullYear(a),b}function ga(a){return ha(a)?366:365}function ha(a){return a%4===0&&a%100!==0||a%400===0}function ia(){return ha(this.year())}function ja(a,b,c){var d,e=c-b,f=c-a.day();return f>e&&(f-=7),e-7>f&&(f+=7),d=Da(a).add(f,"d"),{week:Math.ceil(d.dayOfYear()/7),year:d.year()}}function ka(a){return ja(a,this._week.dow,this._week.doy).week}function la(){return this._week.dow}function ma(){return this._week.doy}function na(a){var b=this.localeData().week(this);return null==a?b:this.add(7*(a-b),"d")}function oa(a){var b=ja(this,1,4).week;return null==a?b:this.add(7*(a-b),"d")}function pa(a,b,c,d,e){var f,g=6+e-d,h=fa(a,0,1+g),i=h.getUTCDay();return e>i&&(i+=7),c=null!=c?1*c:e,f=1+g+7*(b-1)-i+c,{year:f>0?a:a-1,dayOfYear:f>0?f:ga(a-1)+f}}function qa(a){var b=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==a?b:this.add(a-b,"d")}function ra(a,b,c){return null!=a?a:null!=b?b:c}function sa(a){var b=new Date;return a._useUTC?[b.getUTCFullYear(),b.getUTCMonth(),b.getUTCDate()]:[b.getFullYear(),b.getMonth(),b.getDate()]}function ta(a){var b,c,d,e,f=[];if(!a._d){for(d=sa(a),a._w&&null==a._a[hd]&&null==a._a[gd]&&ua(a),a._dayOfYear&&(e=ra(a._a[fd],d[fd]),a._dayOfYear>ga(e)&&(j(a)._overflowDayOfYear=!0),c=fa(e,0,a._dayOfYear),a._a[gd]=c.getUTCMonth(),a._a[hd]=c.getUTCDate()),b=0;3>b&&null==a._a[b];++b)a._a[b]=f[b]=d[b];for(;7>b;b++)a._a[b]=f[b]=null==a._a[b]?2===b?1:0:a._a[b];24===a._a[id]&&0===a._a[jd]&&0===a._a[kd]&&0===a._a[ld]&&(a._nextDay=!0,a._a[id]=0),a._d=(a._useUTC?fa:ea).apply(null,f),null!=a._tzm&&a._d.setUTCMinutes(a._d.getUTCMinutes()-a._tzm),a._nextDay&&(a._a[id]=24)}}function ua(a){var b,c,d,e,f,g,h;b=a._w,null!=b.GG||null!=b.W||null!=b.E?(f=1,g=4,c=ra(b.GG,a._a[fd],ja(Da(),1,4).year),d=ra(b.W,1),e=ra(b.E,1)):(f=a._locale._week.dow,g=a._locale._week.doy,c=ra(b.gg,a._a[fd],ja(Da(),f,g).year),d=ra(b.w,1),null!=b.d?(e=b.d,f>e&&++d):e=null!=b.e?b.e+f:f),h=pa(c,d,e,g,f),a._a[fd]=h.year,a._dayOfYear=h.dayOfYear}function va(b){if(b._f===a.ISO_8601)return void ca(b);b._a=[],j(b).empty=!0;var c,d,e,f,g,h=""+b._i,i=h.length,k=0;for(e=L(b._f,b._locale).match(Nc)||[],c=0;c<e.length;c++)f=e[c],d=(h.match(O(f,b))||[])[0],d&&(g=h.substr(0,h.indexOf(d)),g.length>0&&j(b).unusedInput.push(g),h=h.slice(h.indexOf(d)+d.length),k+=d.length),Qc[f]?(d?j(b).empty=!1:j(b).unusedTokens.push(f),S(f,d,b)):b._strict&&!d&&j(b).unusedTokens.push(f);j(b).charsLeftOver=i-k,h.length>0&&j(b).unusedInput.push(h),j(b).bigHour===!0&&b._a[id]<=12&&b._a[id]>0&&(j(b).bigHour=void 0),b._a[id]=wa(b._locale,b._a[id],b._meridiem),ta(b),$(b)}function wa(a,b,c){var d;return null==c?b:null!=a.meridiemHour?a.meridiemHour(b,c):null!=a.isPM?(d=a.isPM(c),d&&12>b&&(b+=12),d||12!==b||(b=0),b):b}function xa(a){var b,c,d,e,f;if(0===a._f.length)return j(a).invalidFormat=!0,void(a._d=new Date(NaN));for(e=0;e<a._f.length;e++)f=0,b=m({},a),null!=a._useUTC&&(b._useUTC=a._useUTC),b._f=a._f[e],va(b),k(b)&&(f+=j(b).charsLeftOver,f+=10*j(b).unusedTokens.length,j(b).score=f,(null==d||d>f)&&(d=f,c=b));g(a,c||b)}function ya(a){if(!a._d){var b=B(a._i);a._a=[b.year,b.month,b.day||b.date,b.hour,b.minute,b.second,b.millisecond],ta(a)}}function za(a){var b=new n($(Aa(a)));return b._nextDay&&(b.add(1,"d"),b._nextDay=void 0),b}function Aa(a){var b=a._i,e=a._f;return a._locale=a._locale||y(a._l),null===b||void 0===e&&""===b?l({nullInput:!0}):("string"==typeof b&&(a._i=b=a._locale.preparse(b)),o(b)?new n($(b)):(c(e)?xa(a):e?va(a):d(b)?a._d=b:Ba(a),a))}function Ba(b){var f=b._i;void 0===f?b._d=new Date:d(f)?b._d=new Date(+f):"string"==typeof f?da(b):c(f)?(b._a=e(f.slice(0),function(a){return parseInt(a,10)}),ta(b)):"object"==typeof f?ya(b):"number"==typeof f?b._d=new Date(f):a.createFromInputFallback(b)}function Ca(a,b,c,d,e){var f={};return"boolean"==typeof c&&(d=c,c=void 0),f._isAMomentObject=!0,f._useUTC=f._isUTC=e,f._l=c,f._i=a,f._f=b,f._strict=d,za(f)}function Da(a,b,c,d){return Ca(a,b,c,d,!1)}function Ea(a,b){var d,e;if(1===b.length&&c(b[0])&&(b=b[0]),!b.length)return Da();for(d=b[0],e=1;e<b.length;++e)(!b[e].isValid()||b[e][a](d))&&(d=b[e]);return d}function Fa(){var a=[].slice.call(arguments,0);return Ea("isBefore",a)}function Ga(){var a=[].slice.call(arguments,0);return Ea("isAfter",a)}function Ha(a){var b=B(a),c=b.year||0,d=b.quarter||0,e=b.month||0,f=b.week||0,g=b.day||0,h=b.hour||0,i=b.minute||0,j=b.second||0,k=b.millisecond||0;this._milliseconds=+k+1e3*j+6e4*i+36e5*h,this._days=+g+7*f,this._months=+e+3*d+12*c,this._data={},this._locale=y(),this._bubble()}function Ia(a){return a instanceof Ha}function Ja(a,b){H(a,0,0,function(){var a=this.utcOffset(),c="+";return 0>a&&(a=-a,c="-"),c+G(~~(a/60),2)+b+G(~~a%60,2)})}function Ka(a){var b=(a||"").match(ad)||[],c=b[b.length-1]||[],d=(c+"").match(xd)||["-",0,0],e=+(60*d[1])+q(d[2]);return"+"===d[0]?e:-e}function La(b,c){var e,f;return c._isUTC?(e=c.clone(),f=(o(b)||d(b)?+b:+Da(b))-+e,e._d.setTime(+e._d+f),a.updateOffset(e,!1),e):Da(b).local()}function Ma(a){return 15*-Math.round(a._d.getTimezoneOffset()/15)}function Na(b,c){var d,e=this._offset||0;return null!=b?("string"==typeof b&&(b=Ka(b)),Math.abs(b)<16&&(b=60*b),!this._isUTC&&c&&(d=Ma(this)),this._offset=b,this._isUTC=!0,null!=d&&this.add(d,"m"),e!==b&&(!c||this._changeInProgress?bb(this,Ya(b-e,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,a.updateOffset(this,!0),this._changeInProgress=null)),this):this._isUTC?e:Ma(this)}function Oa(a,b){return null!=a?("string"!=typeof a&&(a=-a),this.utcOffset(a,b),this):-this.utcOffset()}function Pa(a){return this.utcOffset(0,a)}function Qa(a){return this._isUTC&&(this.utcOffset(0,a),this._isUTC=!1,a&&this.subtract(Ma(this),"m")),this}function Ra(){return this._tzm?this.utcOffset(this._tzm):"string"==typeof this._i&&this.utcOffset(Ka(this._i)),this}function Sa(a){return a=a?Da(a).utcOffset():0,(this.utcOffset()-a)%60===0}function Ta(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function Ua(){if("undefined"!=typeof this._isDSTShifted)return this._isDSTShifted;var a={};if(m(a,this),a=Aa(a),a._a){var b=a._isUTC?h(a._a):Da(a._a);this._isDSTShifted=this.isValid()&&r(a._a,b.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted}function Va(){return!this._isUTC}function Wa(){return this._isUTC}function Xa(){return this._isUTC&&0===this._offset}function Ya(a,b){var c,d,e,g=a,h=null;return Ia(a)?g={ms:a._milliseconds,d:a._days,M:a._months}:"number"==typeof a?(g={},b?g[b]=a:g.milliseconds=a):(h=yd.exec(a))?(c="-"===h[1]?-1:1,g={y:0,d:q(h[hd])*c,h:q(h[id])*c,m:q(h[jd])*c,s:q(h[kd])*c,ms:q(h[ld])*c}):(h=zd.exec(a))?(c="-"===h[1]?-1:1,g={y:Za(h[2],c),M:Za(h[3],c),d:Za(h[4],c),h:Za(h[5],c),m:Za(h[6],c),s:Za(h[7],c),w:Za(h[8],c)}):null==g?g={}:"object"==typeof g&&("from"in g||"to"in g)&&(e=_a(Da(g.from),Da(g.to)),g={},g.ms=e.milliseconds,g.M=e.months),d=new Ha(g),Ia(a)&&f(a,"_locale")&&(d._locale=a._locale),d}function Za(a,b){var c=a&&parseFloat(a.replace(",","."));return(isNaN(c)?0:c)*b}function $a(a,b){var c={milliseconds:0,months:0};return c.months=b.month()-a.month()+12*(b.year()-a.year()),a.clone().add(c.months,"M").isAfter(b)&&--c.months,c.milliseconds=+b-+a.clone().add(c.months,"M"),c}function _a(a,b){var c;return b=La(b,a),a.isBefore(b)?c=$a(a,b):(c=$a(b,a),c.milliseconds=-c.milliseconds,c.months=-c.months),c}function ab(a,b){return function(c,d){var e,f;return null===d||isNaN(+d)||(ba(b,"moment()."+b+"(period, number) is deprecated. Please use moment()."+b+"(number, period)."),f=c,c=d,d=f),c="string"==typeof c?+c:c,e=Ya(c,d),bb(this,e,a),this}}function bb(b,c,d,e){var f=c._milliseconds,g=c._days,h=c._months;e=null==e?!0:e,f&&b._d.setTime(+b._d+f*d),g&&E(b,"Date",D(b,"Date")+g*d),h&&X(b,D(b,"Month")+h*d),e&&a.updateOffset(b,g||h)}function cb(a,b){var c=a||Da(),d=La(c,this).startOf("day"),e=this.diff(d,"days",!0),f=-6>e?"sameElse":-1>e?"lastWeek":0>e?"lastDay":1>e?"sameDay":2>e?"nextDay":7>e?"nextWeek":"sameElse";return this.format(b&&b[f]||this.localeData().calendar(f,this,Da(c)))}function db(){return new n(this)}function eb(a,b){var c;return b=A("undefined"!=typeof b?b:"millisecond"),"millisecond"===b?(a=o(a)?a:Da(a),+this>+a):(c=o(a)?+a:+Da(a),c<+this.clone().startOf(b))}function fb(a,b){var c;return b=A("undefined"!=typeof b?b:"millisecond"),"millisecond"===b?(a=o(a)?a:Da(a),+a>+this):(c=o(a)?+a:+Da(a),+this.clone().endOf(b)<c)}function gb(a,b,c){return this.isAfter(a,c)&&this.isBefore(b,c)}function hb(a,b){var c;return b=A(b||"millisecond"),"millisecond"===b?(a=o(a)?a:Da(a),+this===+a):(c=+Da(a),+this.clone().startOf(b)<=c&&c<=+this.clone().endOf(b))}function ib(a,b,c){var d,e,f=La(a,this),g=6e4*(f.utcOffset()-this.utcOffset());return b=A(b),"year"===b||"month"===b||"quarter"===b?(e=jb(this,f),"quarter"===b?e/=3:"year"===b&&(e/=12)):(d=this-f,e="second"===b?d/1e3:"minute"===b?d/6e4:"hour"===b?d/36e5:"day"===b?(d-g)/864e5:"week"===b?(d-g)/6048e5:d),c?e:p(e)}function jb(a,b){var c,d,e=12*(b.year()-a.year())+(b.month()-a.month()),f=a.clone().add(e,"months");return 0>b-f?(c=a.clone().add(e-1,"months"),d=(b-f)/(f-c)):(c=a.clone().add(e+1,"months"),d=(b-f)/(c-f)),-(e+d)}function kb(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")}function lb(){var a=this.clone().utc();return 0<a.year()&&a.year()<=9999?"function"==typeof Date.prototype.toISOString?this.toDate().toISOString():K(a,"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"):K(a,"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]")}function mb(b){var c=K(this,b||a.defaultFormat);return this.localeData().postformat(c)}function nb(a,b){return this.isValid()?Ya({to:this,from:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function ob(a){return this.from(Da(),a)}function pb(a,b){return this.isValid()?Ya({from:this,to:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function qb(a){return this.to(Da(),a)}function rb(a){var b;return void 0===a?this._locale._abbr:(b=y(a),null!=b&&(this._locale=b),this)}function sb(){return this._locale}function tb(a){switch(a=A(a)){case"year":this.month(0);case"quarter":case"month":this.date(1);case"week":case"isoWeek":case"day":this.hours(0);case"hour":this.minutes(0);case"minute":this.seconds(0);case"second":this.milliseconds(0)}return"week"===a&&this.weekday(0),"isoWeek"===a&&this.isoWeekday(1),"quarter"===a&&this.month(3*Math.floor(this.month()/3)),this}function ub(a){return a=A(a),void 0===a||"millisecond"===a?this:this.startOf(a).add(1,"isoWeek"===a?"week":a).subtract(1,"ms")}function vb(){return+this._d-6e4*(this._offset||0)}function wb(){return Math.floor(+this/1e3)}function xb(){return this._offset?new Date(+this):this._d}function yb(){var a=this;return[a.year(),a.month(),a.date(),a.hour(),a.minute(),a.second(),a.millisecond()]}function zb(){var a=this;return{years:a.year(),months:a.month(),date:a.date(),hours:a.hours(),minutes:a.minutes(),seconds:a.seconds(),milliseconds:a.milliseconds()}}function Ab(){return k(this)}function Bb(){return g({},j(this))}function Cb(){return j(this).overflow}function Db(a,b){H(0,[a,a.length],0,b)}function Eb(a,b,c){return ja(Da([a,11,31+b-c]),b,c).week}function Fb(a){var b=ja(this,this.localeData()._week.dow,this.localeData()._week.doy).year;return null==a?b:this.add(a-b,"y")}function Gb(a){var b=ja(this,1,4).year;return null==a?b:this.add(a-b,"y")}function Hb(){return Eb(this.year(),1,4)}function Ib(){var a=this.localeData()._week;return Eb(this.year(),a.dow,a.doy)}function Jb(a){return null==a?Math.ceil((this.month()+1)/3):this.month(3*(a-1)+this.month()%3)}function Kb(a,b){return"string"!=typeof a?a:isNaN(a)?(a=b.weekdaysParse(a),"number"==typeof a?a:null):parseInt(a,10)}function Lb(a){return this._weekdays[a.day()]}function Mb(a){return this._weekdaysShort[a.day()]}function Nb(a){return this._weekdaysMin[a.day()]}function Ob(a){var b,c,d;for(this._weekdaysParse=this._weekdaysParse||[],b=0;7>b;b++)if(this._weekdaysParse[b]||(c=Da([2e3,1]).day(b),d="^"+this.weekdays(c,"")+"|^"+this.weekdaysShort(c,"")+"|^"+this.weekdaysMin(c,""),this._weekdaysParse[b]=new RegExp(d.replace(".",""),"i")),this._weekdaysParse[b].test(a))return b}function Pb(a){var b=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=a?(a=Kb(a,this.localeData()),this.add(a-b,"d")):b}function Qb(a){var b=(this.day()+7-this.localeData()._week.dow)%7;return null==a?b:this.add(a-b,"d")}function Rb(a){return null==a?this.day()||7:this.day(this.day()%7?a:a-7)}function Sb(a,b){H(a,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),b)})}function Tb(a,b){return b._meridiemParse}function Ub(a){return"p"===(a+"").toLowerCase().charAt(0)}function Vb(a,b,c){return a>11?c?"pm":"PM":c?"am":"AM"}function Wb(a,b){b[ld]=q(1e3*("0."+a))}function Xb(){return this._isUTC?"UTC":""}function Yb(){return this._isUTC?"Coordinated Universal Time":""}function Zb(a){return Da(1e3*a)}function $b(){return Da.apply(null,arguments).parseZone()}function _b(a,b,c){var d=this._calendar[a];return"function"==typeof d?d.call(b,c):d}function ac(a){var b=this._longDateFormat[a],c=this._longDateFormat[a.toUpperCase()];return b||!c?b:(this._longDateFormat[a]=c.replace(/MMMM|MM|DD|dddd/g,function(a){return a.slice(1)}),this._longDateFormat[a])}function bc(){return this._invalidDate}function cc(a){return this._ordinal.replace("%d",a)}function dc(a){return a}function ec(a,b,c,d){var e=this._relativeTime[c];return"function"==typeof e?e(a,b,c,d):e.replace(/%d/i,a)}function fc(a,b){var c=this._relativeTime[a>0?"future":"past"];return"function"==typeof c?c(b):c.replace(/%s/i,b)}function gc(a){var b,c;for(c in a)b=a[c],"function"==typeof b?this[c]=b:this["_"+c]=b;this._ordinalParseLenient=new RegExp(this._ordinalParse.source+"|"+/\d{1,2}/.source)}function hc(a,b,c,d){var e=y(),f=h().set(d,b);return e[c](f,a)}function ic(a,b,c,d,e){if("number"==typeof a&&(b=a,a=void 0),a=a||"",null!=b)return hc(a,b,c,e);var f,g=[];for(f=0;d>f;f++)g[f]=hc(a,f,c,e);return g}function jc(a,b){return ic(a,b,"months",12,"month")}function kc(a,b){return ic(a,b,"monthsShort",12,"month")}function lc(a,b){return ic(a,b,"weekdays",7,"day")}function mc(a,b){return ic(a,b,"weekdaysShort",7,"day")}function nc(a,b){return ic(a,b,"weekdaysMin",7,"day")}function oc(){var a=this._data;return this._milliseconds=Wd(this._milliseconds),this._days=Wd(this._days),this._months=Wd(this._months),a.milliseconds=Wd(a.milliseconds),a.seconds=Wd(a.seconds),a.minutes=Wd(a.minutes),a.hours=Wd(a.hours),a.months=Wd(a.months),a.years=Wd(a.years),this}function pc(a,b,c,d){var e=Ya(b,c);return a._milliseconds+=d*e._milliseconds,a._days+=d*e._days,a._months+=d*e._months,a._bubble()}function qc(a,b){return pc(this,a,b,1)}function rc(a,b){return pc(this,a,b,-1)}function sc(a){return 0>a?Math.floor(a):Math.ceil(a)}function tc(){var a,b,c,d,e,f=this._milliseconds,g=this._days,h=this._months,i=this._data;return f>=0&&g>=0&&h>=0||0>=f&&0>=g&&0>=h||(f+=864e5*sc(vc(h)+g),g=0,h=0),i.milliseconds=f%1e3,a=p(f/1e3),i.seconds=a%60,b=p(a/60),i.minutes=b%60,c=p(b/60),i.hours=c%24,g+=p(c/24),e=p(uc(g)),h+=e,g-=sc(vc(e)),d=p(h/12),h%=12,i.days=g,i.months=h,i.years=d,this}function uc(a){return 4800*a/146097}function vc(a){return 146097*a/4800}function wc(a){var b,c,d=this._milliseconds;if(a=A(a),"month"===a||"year"===a)return b=this._days+d/864e5,c=this._months+uc(b),"month"===a?c:c/12;switch(b=this._days+Math.round(vc(this._months)),a){case"week":return b/7+d/6048e5;case"day":return b+d/864e5;case"hour":return 24*b+d/36e5;case"minute":return 1440*b+d/6e4;case"second":return 86400*b+d/1e3;case"millisecond":return Math.floor(864e5*b)+d;default:throw new Error("Unknown unit "+a)}}function xc(){return this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*q(this._months/12)}function yc(a){return function(){return this.as(a)}}function zc(a){return a=A(a),this[a+"s"]()}function Ac(a){return function(){return this._data[a]}}function Bc(){return p(this.days()/7)}function Cc(a,b,c,d,e){return e.relativeTime(b||1,!!c,a,d)}function Dc(a,b,c){var d=Ya(a).abs(),e=ke(d.as("s")),f=ke(d.as("m")),g=ke(d.as("h")),h=ke(d.as("d")),i=ke(d.as("M")),j=ke(d.as("y")),k=e<le.s&&["s",e]||1===f&&["m"]||f<le.m&&["mm",f]||1===g&&["h"]||g<le.h&&["hh",g]||1===h&&["d"]||h<le.d&&["dd",h]||1===i&&["M"]||i<le.M&&["MM",i]||1===j&&["y"]||["yy",j];return k[2]=b,k[3]=+a>0,k[4]=c,Cc.apply(null,k)}function Ec(a,b){return void 0===le[a]?!1:void 0===b?le[a]:(le[a]=b,!0)}function Fc(a){var b=this.localeData(),c=Dc(this,!a,b);return a&&(c=b.pastFuture(+this,c)),b.postformat(c)}function Gc(){var a,b,c,d=me(this._milliseconds)/1e3,e=me(this._days),f=me(this._months);a=p(d/60),b=p(a/60),d%=60,a%=60,c=p(f/12),f%=12;var g=c,h=f,i=e,j=b,k=a,l=d,m=this.asSeconds();return m?(0>m?"-":"")+"P"+(g?g+"Y":"")+(h?h+"M":"")+(i?i+"D":"")+(j||k||l?"T":"")+(j?j+"H":"")+(k?k+"M":"")+(l?l+"S":""):"P0D"}var Hc,Ic,Jc=a.momentProperties=[],Kc=!1,Lc={},Mc={},Nc=/(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,Oc=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,Pc={},Qc={},Rc=/\d/,Sc=/\d\d/,Tc=/\d{3}/,Uc=/\d{4}/,Vc=/[+-]?\d{6}/,Wc=/\d\d?/,Xc=/\d{1,3}/,Yc=/\d{1,4}/,Zc=/[+-]?\d{1,6}/,$c=/\d+/,_c=/[+-]?\d+/,ad=/Z|[+-]\d\d:?\d\d/gi,bd=/[+-]?\d+(\.\d{1,3})?/,cd=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,dd={},ed={},fd=0,gd=1,hd=2,id=3,jd=4,kd=5,ld=6;H("M",["MM",2],"Mo",function(){return this.month()+1}),H("MMM",0,0,function(a){return this.localeData().monthsShort(this,a)}),H("MMMM",0,0,function(a){return this.localeData().months(this,a)}),z("month","M"),N("M",Wc),N("MM",Wc,Sc),N("MMM",cd),N("MMMM",cd),Q(["M","MM"],function(a,b){b[gd]=q(a)-1}),Q(["MMM","MMMM"],function(a,b,c,d){var e=c._locale.monthsParse(a,d,c._strict);null!=e?b[gd]=e:j(c).invalidMonth=a});var md="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),nd="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),od={};a.suppressDeprecationWarnings=!1;var pd=/^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,qd=[["YYYYYY-MM-DD",/[+-]\d{6}-\d{2}-\d{2}/],["YYYY-MM-DD",/\d{4}-\d{2}-\d{2}/],["GGGG-[W]WW-E",/\d{4}-W\d{2}-\d/],["GGGG-[W]WW",/\d{4}-W\d{2}/],["YYYY-DDD",/\d{4}-\d{3}/]],rd=[["HH:mm:ss.SSSS",/(T| )\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss",/(T| )\d\d:\d\d:\d\d/],["HH:mm",/(T| )\d\d:\d\d/],["HH",/(T| )\d\d/]],sd=/^\/?Date\((\-?\d+)/i;a.createFromInputFallback=aa("moment construction falls back to js Date. This is discouraged and will be removed in upcoming major release. Please refer to https://github.com/moment/moment/issues/1407 for more info.",function(a){a._d=new Date(a._i+(a._useUTC?" UTC":""))}),H(0,["YY",2],0,function(){return this.year()%100}),H(0,["YYYY",4],0,"year"),H(0,["YYYYY",5],0,"year"),H(0,["YYYYYY",6,!0],0,"year"),z("year","y"),N("Y",_c),N("YY",Wc,Sc),N("YYYY",Yc,Uc),N("YYYYY",Zc,Vc),N("YYYYYY",Zc,Vc),Q(["YYYYY","YYYYYY"],fd),Q("YYYY",function(b,c){c[fd]=2===b.length?a.parseTwoDigitYear(b):q(b)}),Q("YY",function(b,c){c[fd]=a.parseTwoDigitYear(b)}),a.parseTwoDigitYear=function(a){return q(a)+(q(a)>68?1900:2e3)};var td=C("FullYear",!1);H("w",["ww",2],"wo","week"),H("W",["WW",2],"Wo","isoWeek"),z("week","w"),z("isoWeek","W"),N("w",Wc),N("ww",Wc,Sc),N("W",Wc),N("WW",Wc,Sc),R(["w","ww","W","WW"],function(a,b,c,d){b[d.substr(0,1)]=q(a)});var ud={dow:0,doy:6};H("DDD",["DDDD",3],"DDDo","dayOfYear"),z("dayOfYear","DDD"),N("DDD",Xc),N("DDDD",Tc),Q(["DDD","DDDD"],function(a,b,c){c._dayOfYear=q(a)}),a.ISO_8601=function(){};var vd=aa("moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548",function(){var a=Da.apply(null,arguments);return this>a?this:a}),wd=aa("moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548",function(){var a=Da.apply(null,arguments);return a>this?this:a});Ja("Z",":"),Ja("ZZ",""),N("Z",ad),N("ZZ",ad),Q(["Z","ZZ"],function(a,b,c){c._useUTC=!0,c._tzm=Ka(a)});var xd=/([\+\-]|\d\d)/gi;a.updateOffset=function(){};var yd=/(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/,zd=/^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;Ya.fn=Ha.prototype;var Ad=ab(1,"add"),Bd=ab(-1,"subtract");a.defaultFormat="YYYY-MM-DDTHH:mm:ssZ";var Cd=aa("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(a){return void 0===a?this.localeData():this.locale(a)});H(0,["gg",2],0,function(){return this.weekYear()%100}),H(0,["GG",2],0,function(){return this.isoWeekYear()%100}),Db("gggg","weekYear"),Db("ggggg","weekYear"),Db("GGGG","isoWeekYear"),Db("GGGGG","isoWeekYear"),z("weekYear","gg"),z("isoWeekYear","GG"),N("G",_c),N("g",_c),N("GG",Wc,Sc),N("gg",Wc,Sc),N("GGGG",Yc,Uc),N("gggg",Yc,Uc),N("GGGGG",Zc,Vc),N("ggggg",Zc,Vc),R(["gggg","ggggg","GGGG","GGGGG"],function(a,b,c,d){b[d.substr(0,2)]=q(a)}),R(["gg","GG"],function(b,c,d,e){c[e]=a.parseTwoDigitYear(b)}),H("Q",0,0,"quarter"),z("quarter","Q"),N("Q",Rc),Q("Q",function(a,b){b[gd]=3*(q(a)-1)}),H("D",["DD",2],"Do","date"),z("date","D"),N("D",Wc),N("DD",Wc,Sc),N("Do",function(a,b){return a?b._ordinalParse:b._ordinalParseLenient}),Q(["D","DD"],hd),Q("Do",function(a,b){b[hd]=q(a.match(Wc)[0],10)});var Dd=C("Date",!0);H("d",0,"do","day"),H("dd",0,0,function(a){return this.localeData().weekdaysMin(this,a)}),H("ddd",0,0,function(a){return this.localeData().weekdaysShort(this,a)}),H("dddd",0,0,function(a){return this.localeData().weekdays(this,a)}),H("e",0,0,"weekday"),H("E",0,0,"isoWeekday"),z("day","d"),z("weekday","e"),z("isoWeekday","E"),N("d",Wc),N("e",Wc),N("E",Wc),N("dd",cd),N("ddd",cd),N("dddd",cd),R(["dd","ddd","dddd"],function(a,b,c){var d=c._locale.weekdaysParse(a);null!=d?b.d=d:j(c).invalidWeekday=a}),R(["d","e","E"],function(a,b,c,d){b[d]=q(a)});var Ed="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),Fd="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Gd="Su_Mo_Tu_We_Th_Fr_Sa".split("_");H("H",["HH",2],0,"hour"),H("h",["hh",2],0,function(){return this.hours()%12||12}),Sb("a",!0),Sb("A",!1),z("hour","h"),N("a",Tb),N("A",Tb),N("H",Wc),N("h",Wc),N("HH",Wc,Sc),N("hh",Wc,Sc),Q(["H","HH"],id),Q(["a","A"],function(a,b,c){c._isPm=c._locale.isPM(a),c._meridiem=a}),Q(["h","hh"],function(a,b,c){b[id]=q(a),j(c).bigHour=!0});var Hd=/[ap]\.?m?\.?/i,Id=C("Hours",!0);H("m",["mm",2],0,"minute"),z("minute","m"),N("m",Wc),N("mm",Wc,Sc),Q(["m","mm"],jd);var Jd=C("Minutes",!1);H("s",["ss",2],0,"second"),z("second","s"),N("s",Wc),N("ss",Wc,Sc),Q(["s","ss"],kd);var Kd=C("Seconds",!1);H("S",0,0,function(){return~~(this.millisecond()/100)}),H(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),H(0,["SSS",3],0,"millisecond"),H(0,["SSSS",4],0,function(){return 10*this.millisecond()}),H(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),H(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),H(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),H(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),H(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),z("millisecond","ms"),N("S",Xc,Rc),N("SS",Xc,Sc),N("SSS",Xc,Tc);var Ld;for(Ld="SSSS";Ld.length<=9;Ld+="S")N(Ld,$c);for(Ld="S";Ld.length<=9;Ld+="S")Q(Ld,Wb);var Md=C("Milliseconds",!1);H("z",0,0,"zoneAbbr"),H("zz",0,0,"zoneName");var Nd=n.prototype;Nd.add=Ad,Nd.calendar=cb,Nd.clone=db,Nd.diff=ib,Nd.endOf=ub,Nd.format=mb,Nd.from=nb,Nd.fromNow=ob,Nd.to=pb,Nd.toNow=qb,Nd.get=F,Nd.invalidAt=Cb,Nd.isAfter=eb,Nd.isBefore=fb,Nd.isBetween=gb,Nd.isSame=hb,Nd.isValid=Ab,Nd.lang=Cd,Nd.locale=rb,Nd.localeData=sb,Nd.max=wd,Nd.min=vd,Nd.parsingFlags=Bb,Nd.set=F,Nd.startOf=tb,Nd.subtract=Bd,Nd.toArray=yb,Nd.toObject=zb,Nd.toDate=xb,Nd.toISOString=lb,Nd.toJSON=lb,Nd.toString=kb,Nd.unix=wb,Nd.valueOf=vb,Nd.year=td,Nd.isLeapYear=ia,Nd.weekYear=Fb,Nd.isoWeekYear=Gb,Nd.quarter=Nd.quarters=Jb,Nd.month=Y,Nd.daysInMonth=Z,Nd.week=Nd.weeks=na,Nd.isoWeek=Nd.isoWeeks=oa,Nd.weeksInYear=Ib,Nd.isoWeeksInYear=Hb,Nd.date=Dd,Nd.day=Nd.days=Pb,Nd.weekday=Qb,Nd.isoWeekday=Rb,Nd.dayOfYear=qa,Nd.hour=Nd.hours=Id,Nd.minute=Nd.minutes=Jd,Nd.second=Nd.seconds=Kd,
Nd.millisecond=Nd.milliseconds=Md,Nd.utcOffset=Na,Nd.utc=Pa,Nd.local=Qa,Nd.parseZone=Ra,Nd.hasAlignedHourOffset=Sa,Nd.isDST=Ta,Nd.isDSTShifted=Ua,Nd.isLocal=Va,Nd.isUtcOffset=Wa,Nd.isUtc=Xa,Nd.isUTC=Xa,Nd.zoneAbbr=Xb,Nd.zoneName=Yb,Nd.dates=aa("dates accessor is deprecated. Use date instead.",Dd),Nd.months=aa("months accessor is deprecated. Use month instead",Y),Nd.years=aa("years accessor is deprecated. Use year instead",td),Nd.zone=aa("moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779",Oa);var Od=Nd,Pd={sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},Qd={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},Rd="Invalid date",Sd="%d",Td=/\d{1,2}/,Ud={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},Vd=s.prototype;Vd._calendar=Pd,Vd.calendar=_b,Vd._longDateFormat=Qd,Vd.longDateFormat=ac,Vd._invalidDate=Rd,Vd.invalidDate=bc,Vd._ordinal=Sd,Vd.ordinal=cc,Vd._ordinalParse=Td,Vd.preparse=dc,Vd.postformat=dc,Vd._relativeTime=Ud,Vd.relativeTime=ec,Vd.pastFuture=fc,Vd.set=gc,Vd.months=U,Vd._months=md,Vd.monthsShort=V,Vd._monthsShort=nd,Vd.monthsParse=W,Vd.week=ka,Vd._week=ud,Vd.firstDayOfYear=ma,Vd.firstDayOfWeek=la,Vd.weekdays=Lb,Vd._weekdays=Ed,Vd.weekdaysMin=Nb,Vd._weekdaysMin=Gd,Vd.weekdaysShort=Mb,Vd._weekdaysShort=Fd,Vd.weekdaysParse=Ob,Vd.isPM=Ub,Vd._meridiemParse=Hd,Vd.meridiem=Vb,w("en",{ordinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(a){var b=a%10,c=1===q(a%100/10)?"th":1===b?"st":2===b?"nd":3===b?"rd":"th";return a+c}}),a.lang=aa("moment.lang is deprecated. Use moment.locale instead.",w),a.langData=aa("moment.langData is deprecated. Use moment.localeData instead.",y);var Wd=Math.abs,Xd=yc("ms"),Yd=yc("s"),Zd=yc("m"),$d=yc("h"),_d=yc("d"),ae=yc("w"),be=yc("M"),ce=yc("y"),de=Ac("milliseconds"),ee=Ac("seconds"),fe=Ac("minutes"),ge=Ac("hours"),he=Ac("days"),ie=Ac("months"),je=Ac("years"),ke=Math.round,le={s:45,m:45,h:22,d:26,M:11},me=Math.abs,ne=Ha.prototype;ne.abs=oc,ne.add=qc,ne.subtract=rc,ne.as=wc,ne.asMilliseconds=Xd,ne.asSeconds=Yd,ne.asMinutes=Zd,ne.asHours=$d,ne.asDays=_d,ne.asWeeks=ae,ne.asMonths=be,ne.asYears=ce,ne.valueOf=xc,ne._bubble=tc,ne.get=zc,ne.milliseconds=de,ne.seconds=ee,ne.minutes=fe,ne.hours=ge,ne.days=he,ne.weeks=Bc,ne.months=ie,ne.years=je,ne.humanize=Fc,ne.toISOString=Gc,ne.toString=Gc,ne.toJSON=Gc,ne.locale=rb,ne.localeData=sb,ne.toIsoString=aa("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",Gc),ne.lang=Cd,H("X",0,0,"unix"),H("x",0,0,"valueOf"),N("x",_c),N("X",bd),Q("X",function(a,b,c){c._d=new Date(1e3*parseFloat(a,10))}),Q("x",function(a,b,c){c._d=new Date(q(a))}),a.version="2.10.6",b(Da),a.fn=Od,a.min=Fa,a.max=Ga,a.utc=h,a.unix=Zb,a.months=jc,a.isDate=d,a.locale=w,a.invalid=l,a.duration=Ya,a.isMoment=o,a.weekdays=lc,a.parseZone=$b,a.localeData=y,a.isDuration=Ia,a.monthsShort=kc,a.weekdaysMin=nc,a.defineLocale=x,a.weekdaysShort=mc,a.normalizeUnits=A,a.relativeTimeThreshold=Ec;var oe=a;return oe});
/*global
   angular
 */

(function filters() {
  'use strict';


  function getProperty(value, propName) {
    var property = value[propName];
    var propValue;
    if (typeof(property) === 'function') {
      propValue = property.call(value);
    } else {
      propValue = property;
    }
    return propValue;
  }


  angular.module('ng.group', [])


  /*
   * Group the input objects by a named field: e.g.
   * <div ng-repeat="group in people | groupBy:'homeTown':'peopleByTown'">
   *   <h2>{{group.homeTown}}</h2>
   *   <p ng-repeat="person in group.items">{{person.name}}</p>
   *
   * N.B. to use this with ng-repeat, you need to supply a second argument
   * ('peopleByTown' in the above example) which identifies the grouping being
   * calculated.  It should be unique within your app.  It is used to cache the
   * group objects returned by the filter, so that subsequent invocations can
   * return the same objects, so that ng-repeat's digest cycle will correctly
   * recognise the output has not changed.
   */
  .filter('groupBy', function () {
    var poolCache = {};
    poolCache.poolFor = function poolFor(memoKey, groupField) {
      var groupPool;
      if (memoKey === undefined) {
        // don't memoise, assume caller doesn't care about digest tracking
        return new GroupPool(groupField);
      } else if (this.hasOwnProperty(memoKey)) {
        groupPool = this[memoKey];
        if (groupPool.groupField !== groupField) {
          throw new Error('expected grouping "' + memoKey + '" to group by ' + groupPool.groupField + ' but asked to group by ' + groupField + ' instead!');
        }
        return groupPool;
      } else {
        this[memoKey] = groupPool = new GroupPool(groupField);
        return groupPool;
      }
    };

    function Group(initialItem, poolGen) {
      this.items = [initialItem];
      this._poolGen = poolGen;
    }

    function GroupPool(groupField) {
      this.groupField = groupField;
      this.poolGen = 0;
    }
    GroupPool.prototype.addItem = function addItem(item) {
      var groupValue = getProperty(item, this.groupField);
      var group;
      if (this.hasOwnProperty(groupValue)) group = this[groupValue];
      if (group === undefined) {
        group = this.makeGroup(item);
        group[this.groupField] = groupValue;
        this[groupValue] = group;
        return group;
      } else {
        var isNewGroup = this.addToGroup(group, item);
        if (isNewGroup) return group;
      }
    };
    GroupPool.prototype.makeGroup = function makeGroup(initialItem) {
      return new Group(initialItem, this.poolGen);
    };
    GroupPool.prototype.addToGroup = function addToGroup(group, item) {
      if (group._poolGen < this.poolGen) {
        // reuse group object from cached previous run
        Group.call(group, item, this.poolGen);
        return true;
      } else {
        group.items.push(item);
        return false;
      }
    };
    GroupPool.prototype.newGen = function newGen() {
      this.deleteOldGroups();
      ++this.poolGen;
    };
    GroupPool.prototype.deleteOldGroups = function deleteOldGroups() {
      for (var groupKey in this) {
        if (this.hasOwnProperty(groupKey)) {
          var group = this[groupKey];
          if (group._poolGen < this.poolGen) {
            delete this[groupKey];
          }
        }
      }
    };

    return function groupByFilter(items, groupField, memoKey) {
      var groupPool = poolCache.poolFor(memoKey, groupField);

      var filtered = [];
      angular.forEach(items, function (item) {
        var newGroup = groupPool.addItem(item);
        if (newGroup) filtered.push(newGroup);
      });

      groupPool.newGen();

      return filtered;
    };
  });
})();

!function(){"use strict";angular.module("ui.sortable",[]).constant("sortableConfig",{itemClass:"as-sortable-item",handleClass:"as-sortable-item-handle",placeHolderClass:"as-sortable-placeholder",dragClass:"as-sortable-drag",hiddenClass:"as-sortable-hidden"})}(),function(){"use strict";var mainModule=angular.module("ui.sortable");mainModule.factory("$helper",["$document","$window",function($document,$window){return{height:function(element){return element.prop("offsetHeight")},width:function(element){return element.prop("offsetWidth")},offset:function(element,scrollableContainer){var boundingClientRect=element[0].getBoundingClientRect();return scrollableContainer||(scrollableContainer=$document[0].documentElement),{width:boundingClientRect.width||element.prop("offsetWidth"),height:boundingClientRect.height||element.prop("offsetHeight"),top:boundingClientRect.top+($window.pageYOffset||scrollableContainer.scrollTop-scrollableContainer.offsetTop),left:boundingClientRect.left+($window.pageXOffset||scrollableContainer.scrollLeft-scrollableContainer.offsetLeft)}},eventObj:function(event){var obj=event;return void 0!==event.targetTouches?obj=event.targetTouches.item(0):void 0!==event.originalEvent&&void 0!==event.originalEvent.targetTouches&&(obj=event.originalEvent.targetTouches.item(0)),obj},isTouchInvalid:function(event){var touchInvalid=!1;return void 0!==event.touches&&event.touches.length>1?touchInvalid=!0:void 0!==event.originalEvent&&void 0!==event.originalEvent.touches&&event.originalEvent.touches.length>1&&(touchInvalid=!0),touchInvalid},positionStarted:function(event,target,scrollableContainer){var pos={};return pos.offsetX=event.pageX-this.offset(target,scrollableContainer).left,pos.offsetY=event.pageY-this.offset(target,scrollableContainer).top,pos.startX=pos.lastX=event.pageX,pos.startY=pos.lastY=event.pageY,pos.nowX=pos.nowY=pos.distX=pos.distY=pos.dirAx=0,pos.dirX=pos.dirY=pos.lastDirX=pos.lastDirY=pos.distAxX=pos.distAxY=0,pos},calculatePosition:function(pos,event){pos.lastX=pos.nowX,pos.lastY=pos.nowY,pos.nowX=event.pageX,pos.nowY=event.pageY,pos.distX=pos.nowX-pos.lastX,pos.distY=pos.nowY-pos.lastY,pos.lastDirX=pos.dirX,pos.lastDirY=pos.dirY,pos.dirX=0===pos.distX?0:pos.distX>0?1:-1,pos.dirY=0===pos.distY?0:pos.distY>0?1:-1;var newAx=Math.abs(pos.distX)>Math.abs(pos.distY)?1:0;pos.dirAx!==newAx?(pos.distAxX=0,pos.distAxY=0):(pos.distAxX+=Math.abs(pos.distX),0!==pos.dirX&&pos.dirX!==pos.lastDirX&&(pos.distAxX=0),pos.distAxY+=Math.abs(pos.distY),0!==pos.dirY&&pos.dirY!==pos.lastDirY&&(pos.distAxY=0)),pos.dirAx=newAx},movePosition:function(event,element,pos,container,containerPositioning,scrollableContainer){var bounds,useRelative="relative"===containerPositioning;element.x=event.pageX-pos.offsetX,element.y=event.pageY-pos.offsetY,container&&(bounds=this.offset(container,scrollableContainer),useRelative&&(element.x-=bounds.left,element.y-=bounds.top,bounds.left=0,bounds.top=0),element.x<bounds.left?element.x=bounds.left:element.x>=bounds.width+bounds.left-this.offset(element).width&&(element.x=bounds.width+bounds.left-this.offset(element).width),element.y<bounds.top?element.y=bounds.top:element.y>=bounds.height+bounds.top-this.offset(element).height&&(element.y=bounds.height+bounds.top-this.offset(element).height)),element.css({left:element.x+"px",top:element.y+"px"}),this.calculatePosition(pos,event)},dragItem:function(item){return{index:item.index(),parent:item.sortableScope,source:item,sourceInfo:{index:item.index(),itemScope:item.itemScope,sortableScope:item.sortableScope},moveTo:function(parent,index){this.parent=parent,this.isSameParent()&&this.source.index()<index&&(index-=1),this.index=index},isSameParent:function(){return this.parent.element===this.sourceInfo.sortableScope.element},isOrderChanged:function(){return this.index!==this.sourceInfo.index},eventArgs:function(){return{source:this.sourceInfo,dest:{index:this.index,sortableScope:this.parent}}},apply:function(){this.sourceInfo.sortableScope.removeItem(this.sourceInfo.index),this.parent.insertItem(this.index,this.source.modelValue)}}},noDrag:function(element){return void 0!==element.attr("no-drag")||void 0!==element.attr("data-no-drag")}}}])}(),function(){"use strict";var mainModule=angular.module("ui.sortable");mainModule.controller("ui.sortable.sortableController",["$scope",function($scope){this.scope=$scope,$scope.modelValue=null,$scope.callbacks=null,$scope.type="sortable",$scope.options={},$scope.isDisabled=!1,$scope.insertItem=function(index,itemData){$scope.safeApply(function(){$scope.modelValue.splice(index,0,itemData)})},$scope.removeItem=function(index){var removedItem=null;return index>-1&&$scope.safeApply(function(){removedItem=$scope.modelValue.splice(index,1)[0]}),removedItem},$scope.isEmpty=function(){return $scope.modelValue&&0===$scope.modelValue.length},$scope.accept=function(sourceItemHandleScope,destScope,destItemScope){return $scope.callbacks.accept(sourceItemHandleScope,destScope,destItemScope)},$scope.safeApply=function(fn){var phase=this.$root.$$phase;"$apply"===phase||"$digest"===phase?fn&&"function"==typeof fn&&fn():this.$apply(fn)}}]),mainModule.directive("asSortable",function(){return{require:"ngModel",restrict:"A",scope:!0,controller:"ui.sortable.sortableController",link:function(scope,element,attrs,ngModelController){var ngModel,callbacks;ngModel=ngModelController,ngModel&&(ngModel.$render=function(){ngModel.$modelValue&&angular.isArray(ngModel.$modelValue)||ngModel.$setViewValue([]),scope.modelValue=ngModel.$modelValue},scope.element=element,callbacks={accept:null,orderChanged:null,itemMoved:null,dragStart:null,dragCancel:null,dragEnd:null},callbacks.accept=function(){return!0},callbacks.orderChanged=function(){},callbacks.itemMoved=function(){},callbacks.dragStart=function(){},callbacks.dragCancel=function(){},callbacks.dragEnd=function(){},scope.$watch(attrs.asSortable,function(newVal){angular.forEach(newVal,function(value,key){callbacks[key]?"function"==typeof value&&(callbacks[key]=value):scope.options[key]=value}),scope.callbacks=callbacks},!0),angular.isDefined(attrs.isDisabled)&&scope.$watch(attrs.isDisabled,function(newVal){angular.isUndefined(newVal)||(scope.isDisabled=newVal)},!0))}}})}(),function(){"use strict";var mainModule=angular.module("ui.sortable");mainModule.controller("ui.sortable.sortableItemHandleController",["$scope",function($scope){this.scope=$scope,$scope.itemScope=null,$scope.type="handle"}]),mainModule.directive("asSortableItemHandle",["sortableConfig","$helper","$window","$document",function(sortableConfig,$helper,$window,$document){return{require:"^asSortableItem",scope:!0,restrict:"A",controller:"ui.sortable.sortableItemHandleController",link:function(scope,element,attrs,itemController){function insertBefore(targetElement,targetScope){targetElement[0].parentNode.insertBefore(placeHolder[0],targetElement[0]),dragItemInfo.moveTo(targetScope.sortableScope,targetScope.index())}function insertAfter(targetElement,targetScope){targetElement.after(placeHolder),dragItemInfo.moveTo(targetScope.sortableScope,targetScope.index()+1)}function rollbackDragChanges(){placeElement.replaceWith(scope.itemScope.element),placeHolder.remove(),dragElement.remove(),dragElement=null,dragHandled=!1,containment.css("cursor","")}var dragElement,placeHolder,placeElement,itemPosition,dragItemInfo,containment,containerPositioning,dragListen,scrollableContainer,dragStart,dragMove,dragEnd,dragCancel,isDraggable,isDragBefore,isPlaceHolderPresent,bindDrag,unbindDrag,bindEvents,unBindEvents,hasTouch,dragHandled,isDisabled=!1;hasTouch=$window.hasOwnProperty("ontouchstart"),sortableConfig.handleClass&&element.addClass(sortableConfig.handleClass),scope.itemScope=itemController.scope,scope.$watch("sortableScope.isDisabled",function(newVal){isDisabled!==newVal&&(isDisabled=newVal,isDisabled?unbindDrag():bindDrag())}),dragListen=function(event){var startPosition,unbindMoveListen=function(){angular.element($document).unbind("mousemove",moveListen),angular.element($document).unbind("touchmove",moveListen),element.unbind("mouseup",unbindMoveListen),element.unbind("touchend",unbindMoveListen),element.unbind("touchcancel",unbindMoveListen)},moveListen=function(e){e.preventDefault();var eventObj=$helper.eventObj(e);startPosition||(startPosition={clientX:eventObj.clientX,clientY:eventObj.clientY}),Math.abs(eventObj.clientX-startPosition.clientX)+Math.abs(eventObj.clientY-startPosition.clientY)>10&&(unbindMoveListen(),dragStart(event))};angular.element($document).bind("mousemove",moveListen),angular.element($document).bind("touchmove",moveListen),element.bind("mouseup",unbindMoveListen),element.bind("touchend",unbindMoveListen),element.bind("touchcancel",unbindMoveListen)},dragStart=function(event){var eventObj,tagName;(hasTouch||2!==event.button&&3!==event.which)&&(hasTouch&&$helper.isTouchInvalid(event)||!dragHandled&&isDraggable(event)&&(dragHandled=!0,event.preventDefault(),eventObj=$helper.eventObj(event),scrollableContainer=angular.element($document[0].querySelector(scope.sortableScope.options.scrollableContainer)).length>0?$document[0].querySelector(scope.sortableScope.options.scrollableContainer):$document[0].documentElement,containment=angular.element(angular.element($document[0].querySelector(scope.sortableScope.options.containment)).length>0?$document[0].querySelector(scope.sortableScope.options.containment):$document[0].body),containment.css("cursor","move"),containerPositioning=scope.sortableScope.options.containerPositioning||"absolute",dragItemInfo=$helper.dragItem(scope),tagName=scope.itemScope.element.prop("tagName"),dragElement=angular.element($document[0].createElement(scope.sortableScope.element.prop("tagName"))).addClass(scope.sortableScope.element.attr("class")).addClass(sortableConfig.dragClass),dragElement.css("width",$helper.width(scope.itemScope.element)+"px"),dragElement.css("height",$helper.height(scope.itemScope.element)+"px"),placeHolder=angular.element($document[0].createElement(tagName)).addClass(sortableConfig.placeHolderClass).addClass(scope.sortableScope.options.additionalPlaceholderClass),placeHolder.css("width",$helper.width(scope.itemScope.element)+"px"),placeHolder.css("height",$helper.height(scope.itemScope.element)+"px"),placeElement=angular.element($document[0].createElement(tagName)),sortableConfig.hiddenClass&&placeElement.addClass(sortableConfig.hiddenClass),itemPosition=$helper.positionStarted(eventObj,scope.itemScope.element,scrollableContainer),scope.itemScope.element.after(placeHolder),scope.itemScope.element.after(placeElement),dragElement.append(scope.itemScope.element),containment.append(dragElement),$helper.movePosition(eventObj,dragElement,itemPosition,containment,containerPositioning,scrollableContainer),scope.sortableScope.$apply(function(){scope.callbacks.dragStart(dragItemInfo.eventArgs())}),bindEvents()))},isDraggable=function(event){var elementClicked,sourceScope,isDraggable;for(elementClicked=angular.element(event.target),sourceScope=elementClicked.scope(),isDraggable=!1;!isDraggable&&void 0!==sourceScope;)sourceScope.type&&"handle"===sourceScope.type?isDraggable=!0:sourceScope=sourceScope.$parent;for(;isDraggable&&elementClicked[0]!==element[0];)$helper.noDrag(elementClicked)&&(isDraggable=!1),elementClicked=elementClicked.parent();return isDraggable},dragMove=function(event){var eventObj,targetX,targetY,targetScope,targetElement;if((!hasTouch||!$helper.isTouchInvalid(event))&&dragHandled&&dragElement){if(event.preventDefault(),eventObj=$helper.eventObj(event),$helper.movePosition(eventObj,dragElement,itemPosition,containment,containerPositioning,scrollableContainer),targetX=eventObj.pageX-$document[0].documentElement.scrollLeft,targetY=eventObj.pageY-($window.pageYOffset||$document[0].documentElement.scrollTop),dragElement.addClass(sortableConfig.hiddenClass),$document[0].elementFromPoint(targetX,targetY),targetElement=angular.element($document[0].elementFromPoint(targetX,targetY)),dragElement.removeClass(sortableConfig.hiddenClass),targetScope=targetElement.scope(),!targetScope||!targetScope.type)return;if("handle"===targetScope.type&&(targetScope=targetScope.itemScope),"item"!==targetScope.type&&"sortable"!==targetScope.type)return;"item"===targetScope.type&&(targetElement=targetScope.element,targetScope.sortableScope.accept(scope,targetScope.sortableScope,targetScope)&&(itemPosition.dirAx&&scope.itemScope.sortableScope.$id===targetScope.sortableScope.$id?(itemPosition.distAxX=0,itemPosition.distX<0?insertBefore(targetElement,targetScope):itemPosition.distX>0&&insertAfter(targetElement,targetScope)):isDragBefore(eventObj,targetElement)?insertBefore(targetElement,targetScope):insertAfter(targetElement,targetScope))),"sortable"===targetScope.type&&targetScope.accept(scope,targetScope)&&targetElement[0].parentNode!==targetScope.element[0]&&(isPlaceHolderPresent(targetElement)||(targetElement[0].appendChild(placeHolder[0]),dragItemInfo.moveTo(targetScope,targetScope.modelValue.length)))}},isPlaceHolderPresent=function(targetElement){var itemElements,hasPlaceHolder,i;for(itemElements=targetElement.children(),i=0;i<itemElements.length;i+=1)if(angular.element(itemElements[i]).hasClass(sortableConfig.placeHolderClass)){hasPlaceHolder=!0;break}return hasPlaceHolder},isDragBefore=function(eventObj,targetElement){var dragBefore,targetOffset;return dragBefore=!1,targetOffset=$helper.offset(targetElement),dragBefore=$helper.offset(placeHolder).top>targetOffset.top?$helper.offset(dragElement).top<targetOffset.top+$helper.height(targetElement)/2:eventObj.pageY<targetOffset.top},dragEnd=function(event){dragHandled&&(event.preventDefault(),dragElement&&(rollbackDragChanges(),dragItemInfo.apply(),scope.sortableScope.$apply(function(){dragItemInfo.isSameParent()?dragItemInfo.isOrderChanged()&&scope.callbacks.orderChanged(dragItemInfo.eventArgs()):scope.callbacks.itemMoved(dragItemInfo.eventArgs())}),scope.sortableScope.$apply(function(){scope.callbacks.dragEnd(dragItemInfo.eventArgs())}),dragItemInfo=null),unBindEvents())},dragCancel=function(event){dragHandled&&(event.preventDefault(),dragElement&&(rollbackDragChanges(),scope.sortableScope.$apply(function(){scope.callbacks.dragCancel(dragItemInfo.eventArgs())}),dragItemInfo=null),unBindEvents())},bindDrag=function(){element.bind("touchstart",dragListen),element.bind("mousedown",dragListen)},unbindDrag=function(){element.unbind("touchstart",dragListen),element.unbind("mousedown",dragListen)},bindDrag(),angular.element($document[0].body).bind("keydown",function(event){27===event.keyCode&&dragCancel(event)}),bindEvents=function(){angular.element($document).bind("touchmove",dragMove),angular.element($document).bind("touchend",dragEnd),angular.element($document).bind("touchcancel",dragCancel),angular.element($document).bind("mousemove",dragMove),angular.element($document).bind("mouseup",dragEnd)},unBindEvents=function(){angular.element($document).unbind("touchend",dragEnd),angular.element($document).unbind("touchcancel",dragCancel),angular.element($document).unbind("touchmove",dragMove),angular.element($document).unbind("mouseup",dragEnd),angular.element($document).unbind("mousemove",dragMove)}}}}])}(),function(){"use strict";var mainModule=angular.module("ui.sortable");mainModule.controller("ui.sortable.sortableItemController",["$scope",function($scope){this.scope=$scope,$scope.sortableScope=null,$scope.modelValue=null,$scope.type="item",$scope.index=function(){return $scope.sortableScope.modelValue.indexOf($scope.modelValue)},$scope.itemData=function(){return $scope.sortableScope.modelValue[$scope.$index]}}]),mainModule.directive("asSortableItem",["sortableConfig",function(sortableConfig){return{require:"^asSortable",restrict:"A",controller:"ui.sortable.sortableItemController",link:function(scope,element,attrs,sortableController){sortableConfig.itemClass&&element.addClass(sortableConfig.itemClass),scope.sortableScope=sortableController.scope,scope.modelValue=sortableController.scope.modelValue[scope.$index],scope.element=element}}}])}();
/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v1.0.10
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */
!function(e,n){"use strict";var r=["ng","oc.lazyLoad"],o={},t=[],i=[],a=[],s=[],u=e.noop,c={},d=[],l=e.module("oc.lazyLoad",["ng"]);l.provider("$ocLazyLoad",["$controllerProvider","$provide","$compileProvider","$filterProvider","$injector","$animateProvider",function(l,f,p,m,v,y){function L(n,o,t){if(o){var i,s,l,f=[];for(i=o.length-1;i>=0;i--)if(s=o[i],e.isString(s)||(s=E(s)),s&&-1===d.indexOf(s)&&(!w[s]||-1!==a.indexOf(s))){var h=-1===r.indexOf(s);if(l=g(s),h&&(r.push(s),L(n,l.requires,t)),l._runBlocks.length>0)for(c[s]=[];l._runBlocks.length>0;)c[s].push(l._runBlocks.shift());e.isDefined(c[s])&&(h||t.rerun)&&(f=f.concat(c[s])),j(n,l._invokeQueue,s,t.reconfig),j(n,l._configBlocks,s,t.reconfig),u(h?"ocLazyLoad.moduleLoaded":"ocLazyLoad.moduleReloaded",s),o.pop(),d.push(s)}var p=n.getInstanceInjector();e.forEach(f,function(e){p.invoke(e)})}}function $(n,r){function t(n,r){var o,t=!0;return r.length&&(o=i(n),e.forEach(r,function(e){t=t&&i(e)!==o})),t}function i(n){return e.isArray(n)?M(n.toString()):e.isObject(n)?M(S(n)):e.isDefined(n)&&null!==n?M(n.toString()):n}var a=n[2][0],s=n[1],c=!1;e.isUndefined(o[r])&&(o[r]={}),e.isUndefined(o[r][s])&&(o[r][s]={});var d=function(e,n){o[r][s].hasOwnProperty(e)||(o[r][s][e]=[]),t(n,o[r][s][e])&&(c=!0,o[r][s][e].push(n),u("ocLazyLoad.componentLoaded",[r,s,e]))};if(e.isString(a))d(a,n[2][1]);else{if(!e.isObject(a))return!1;e.forEach(a,function(n,r){e.isString(n)?d(n,a[1]):d(r,n)})}return c}function j(n,r,o,i){if(r){var a,s,u,c;for(a=0,s=r.length;s>a;a++)if(u=r[a],e.isArray(u)){if(null!==n){if(!n.hasOwnProperty(u[0]))throw new Error("unsupported provider "+u[0]);c=n[u[0]]}var d=$(u,o);if("invoke"!==u[1])d&&e.isDefined(c)&&c[u[1]].apply(c,u[2]);else{var l=function(n){var r=t.indexOf(o+"-"+n);(-1===r||i)&&(-1===r&&t.push(o+"-"+n),e.isDefined(c)&&c[u[1]].apply(c,u[2]))};if(e.isFunction(u[2][0]))l(u[2][0]);else if(e.isArray(u[2][0]))for(var f=0,h=u[2][0].length;h>f;f++)e.isFunction(u[2][0][f])&&l(u[2][0][f])}}}}function E(n){var r=null;return e.isString(n)?r=n:e.isObject(n)&&n.hasOwnProperty("name")&&e.isString(n.name)&&(r=n.name),r}function _(n){if(!e.isString(n))return!1;try{return g(n)}catch(r){if(/No module/.test(r)||r.message.indexOf("$injector:nomod")>-1)return!1}}var w={},O={$controllerProvider:l,$compileProvider:p,$filterProvider:m,$provide:f,$injector:v,$animateProvider:y},x=!1,b=!1,z=[],D={};z.push=function(e){-1===this.indexOf(e)&&Array.prototype.push.apply(this,arguments)},this.config=function(n){e.isDefined(n.modules)&&(e.isArray(n.modules)?e.forEach(n.modules,function(e){w[e.name]=e}):w[n.modules.name]=n.modules),e.isDefined(n.debug)&&(x=n.debug),e.isDefined(n.events)&&(b=n.events)},this._init=function(o){if(0===i.length){var t=[o],a=["ng:app","ng-app","x-ng-app","data-ng-app"],u=/\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,c=function(e){return e&&t.push(e)};e.forEach(a,function(n){a[n]=!0,c(document.getElementById(n)),n=n.replace(":","\\:"),"undefined"!=typeof o[0]&&o[0].querySelectorAll&&(e.forEach(o[0].querySelectorAll("."+n),c),e.forEach(o[0].querySelectorAll("."+n+"\\:"),c),e.forEach(o[0].querySelectorAll("["+n+"]"),c))}),e.forEach(t,function(n){if(0===i.length){var r=" "+o.className+" ",t=u.exec(r);t?i.push((t[2]||"").replace(/\s+/g,",")):e.forEach(n.attributes,function(e){0===i.length&&a[e.name]&&i.push(e.value)})}})}0!==i.length||(n.jasmine||n.mocha)&&e.isDefined(e.mock)||console.error("No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.");var d=function l(n){if(-1===r.indexOf(n)){r.push(n);var o=e.module(n);j(null,o._invokeQueue,n),j(null,o._configBlocks,n),e.forEach(o.requires,l)}};e.forEach(i,function(e){d(e)}),i=[],s.pop()};var S=function(n){try{return JSON.stringify(n)}catch(r){var o=[];return JSON.stringify(n,function(n,r){if(e.isObject(r)&&null!==r){if(-1!==o.indexOf(r))return;o.push(r)}return r})}},M=function(e){var n,r,o,t=0;if(0==e.length)return t;for(n=0,o=e.length;o>n;n++)r=e.charCodeAt(n),t=(t<<5)-t+r,t|=0;return t};this.$get=["$log","$rootElement","$rootScope","$cacheFactory","$q",function(n,t,a,c,l){function f(e){var r=l.defer();return n.error(e.message),r.reject(e),r.promise}var p,m=c("ocLazyLoad");return x||(n={},n.error=e.noop,n.warn=e.noop,n.info=e.noop),O.getInstanceInjector=function(){return p?p:p=t.data("$injector")||e.injector()},u=function(e,r){b&&a.$broadcast(e,r),x&&n.info(e,r)},{_broadcast:u,_$log:n,_getFilesCache:function(){return m},toggleWatch:function(e){e?s.push(!0):s.pop()},getModuleConfig:function(n){if(!e.isString(n))throw new Error("You need to give the name of the module to get");return w[n]?e.copy(w[n]):null},setModuleConfig:function(n){if(!e.isObject(n))throw new Error("You need to give the module config object to set");return w[n.name]=n,n},getModules:function(){return r},isLoaded:function(n){var o=function(e){var n=r.indexOf(e)>-1;return n||(n=!!_(e)),n};if(e.isString(n)&&(n=[n]),e.isArray(n)){var t,i;for(t=0,i=n.length;i>t;t++)if(!o(n[t]))return!1;return!0}throw new Error("You need to define the module(s) name(s)")},_getModuleName:E,_getModule:function(e){try{return g(e)}catch(n){throw(/No module/.test(n)||n.message.indexOf("$injector:nomod")>-1)&&(n.message='The module "'+S(e)+'" that you are trying to load does not exist. '+n.message),n}},moduleExists:_,_loadDependencies:function(n,r){var o,t,i,a=[],s=this;if(n=s._getModuleName(n),null===n)return l.when();try{o=s._getModule(n)}catch(u){return f(u)}return t=s.getRequires(o),e.forEach(t,function(o){if(e.isString(o)){var t=s.getModuleConfig(o);if(null===t)return void z.push(o);o=t,t.name=void 0}if(s.moduleExists(o.name))return i=o.files.filter(function(e){return s.getModuleConfig(o.name).files.indexOf(e)<0}),0!==i.length&&s._$log.warn('Module "',n,'" attempted to redefine configuration for dependency. "',o.name,'"\n Additional Files Loaded:',i),e.isDefined(s.filesLoader)?void a.push(s.filesLoader(o,r).then(function(){return s._loadDependencies(o)})):f(new Error("Error: New dependencies need to be loaded from external files ("+o.files+"), but no loader has been defined."));if(e.isArray(o)){var u=[];e.forEach(o,function(e){var n=s.getModuleConfig(e);null===n?u.push(e):n.files&&(u=u.concat(n.files))}),u.length>0&&(o={files:u})}else e.isObject(o)&&o.hasOwnProperty("name")&&o.name&&(s.setModuleConfig(o),z.push(o.name));if(e.isDefined(o.files)&&0!==o.files.length){if(!e.isDefined(s.filesLoader))return f(new Error('Error: the module "'+o.name+'" is defined in external files ('+o.files+"), but no loader has been defined."));a.push(s.filesLoader(o,r).then(function(){return s._loadDependencies(o)}))}}),l.all(a)},inject:function(n){var r=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],o=arguments.length<=2||void 0===arguments[2]?!1:arguments[2],t=this,a=l.defer();if(e.isDefined(n)&&null!==n){if(e.isArray(n)){var s=[];return e.forEach(n,function(e){s.push(t.inject(e,r,o))}),l.all(s)}t._addToLoadList(t._getModuleName(n),!0,o)}if(i.length>0){var u=i.slice(),c=function f(e){z.push(e),D[e]=a.promise,t._loadDependencies(e,r).then(function(){try{d=[],L(O,z,r)}catch(e){return t._$log.error(e.message),void a.reject(e)}i.length>0?f(i.shift()):a.resolve(u)},function(e){a.reject(e)})};c(i.shift())}else{if(r&&r.name&&D[r.name])return D[r.name];a.resolve()}return a.promise},getRequires:function(n){var o=[];return e.forEach(n.requires,function(e){-1===r.indexOf(e)&&o.push(e)}),o},_invokeQueue:j,_registerInvokeList:$,_register:L,_addToLoadList:h,_unregister:function(n){e.isDefined(n)&&e.isArray(n)&&e.forEach(n,function(e){o[e]=void 0})}}}],this._init(e.element(n.document))}]);var f=e.bootstrap;e.bootstrap=function(n,l,g){return r=["ng","oc.lazyLoad"],o={},t=[],i=[],a=[],s=[],u=e.noop,c={},d=[],e.forEach(l.slice(),function(e){h(e,!0,!0)}),f(n,l,g)};var h=function(n,r,o){(s.length>0||r)&&e.isString(n)&&-1===i.indexOf(n)&&(i.push(n),o&&a.push(n))},g=e.module;e.module=function(e,n,r){return h(e,!1,!0),g(e,n,r)},"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="oc.lazyLoad")}(angular,window),function(e){"use strict";e.module("oc.lazyLoad").directive("ocLazyLoad",["$ocLazyLoad","$compile","$animate","$parse","$timeout",function(n,r,o,t,i){return{restrict:"A",terminal:!0,priority:1e3,compile:function(i,a){var s=i[0].innerHTML;return i.html(""),function(i,a,u){var c=t(u.ocLazyLoad);i.$watch(function(){return c(i)||u.ocLazyLoad},function(t){e.isDefined(t)&&n.load(t).then(function(){o.enter(s,a),r(a.contents())(i)})},!0)}}}}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q","$window","$interval",function(n,r,o,t){var i=!1,a=!1,s=o.document.getElementsByTagName("head")[0]||o.document.getElementsByTagName("body")[0];return n.buildElement=function(u,c,d){var l,f,h=r.defer(),g=n._getFilesCache(),p=function(e){var n=(new Date).getTime();return e.indexOf("?")>=0?"&"===e.substring(0,e.length-1)?e+"_dc="+n:e+"&_dc="+n:e+"?_dc="+n};switch(e.isUndefined(g.get(c))&&g.put(c,h.promise),u){case"css":l=o.document.createElement("link"),l.type="text/css",l.rel="stylesheet",l.href=d.cache===!1?p(c):c;break;case"js":l=o.document.createElement("script"),l.src=d.cache===!1?p(c):c;break;default:g.remove(c),h.reject(new Error('Requested type "'+u+'" is not known. Could not inject "'+c+'"'))}l.onload=l.onreadystatechange=function(e){l.readyState&&!/^c|loade/.test(l.readyState)||f||(l.onload=l.onreadystatechange=null,f=1,n._broadcast("ocLazyLoad.fileLoaded",c),h.resolve(l))},l.onerror=function(){g.remove(c),h.reject(new Error("Unable to load "+c))},l.async=d.serie?0:1;var m=s.lastChild;if(d.insertBefore){var v=e.element(e.isDefined(window.jQuery)?d.insertBefore:document.querySelector(d.insertBefore));v&&v.length>0&&(m=v[0])}if(m.parentNode.insertBefore(l,m),"css"==u){if(!i){var y=o.navigator.userAgent.toLowerCase();if(y.indexOf("phantomjs/1.9")>-1)a=!0;else if(/iP(hone|od|ad)/.test(o.navigator.platform)){var L=o.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),$=parseFloat([parseInt(L[1],10),parseInt(L[2],10),parseInt(L[3]||0,10)].join("."));a=6>$}else if(y.indexOf("android")>-1){var j=parseFloat(y.slice(y.indexOf("android")+8));a=4.4>j}else if(y.indexOf("safari")>-1){var E=y.match(/version\/([\.\d]+)/i);a=E&&E[1]&&parseFloat(E[1])<6}}if(a)var _=1e3,w=t(function(){try{l.sheet.cssRules,t.cancel(w),l.onload()}catch(e){--_<=0&&l.onerror()}},20)}return h.promise},n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.filesLoader=function(o){var t=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],i=[],a=[],s=[],u=[],c=null,d=n._getFilesCache();n.toggleWatch(!0),e.extend(t,o);var l=function(r){var o,l=null;if(e.isObject(r)&&(l=r.type,r=r.path),c=d.get(r),e.isUndefined(c)||t.cache===!1){if(null!==(o=/^(css|less|html|htm|js)?(?=!)/.exec(r))&&(l=o[1],r=r.substr(o[1].length+1,r.length)),!l)if(null!==(o=/[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(r)))l=o[1];else{if(n.jsLoader.hasOwnProperty("ocLazyLoadLoader")||!n.jsLoader.hasOwnProperty("requirejs"))return void n._$log.error("File type could not be determined. "+r);l="js"}"css"!==l&&"less"!==l||-1!==i.indexOf(r)?"html"!==l&&"htm"!==l||-1!==a.indexOf(r)?"js"===l||-1===s.indexOf(r)?s.push(r):n._$log.error("File type is not valid. "+r):a.push(r):i.push(r)}else c&&u.push(c)};if(t.serie?l(t.files.shift()):e.forEach(t.files,function(e){l(e)}),i.length>0){var f=r.defer();n.cssLoader(i,function(r){e.isDefined(r)&&n.cssLoader.hasOwnProperty("ocLazyLoadLoader")?(n._$log.error(r),f.reject(r)):f.resolve()},t),u.push(f.promise)}if(a.length>0){var h=r.defer();n.templatesLoader(a,function(r){e.isDefined(r)&&n.templatesLoader.hasOwnProperty("ocLazyLoadLoader")?(n._$log.error(r),h.reject(r)):h.resolve()},t),u.push(h.promise)}if(s.length>0){var g=r.defer();n.jsLoader(s,function(r){e.isDefined(r)&&(n.jsLoader.hasOwnProperty("ocLazyLoadLoader")||n.jsLoader.hasOwnProperty("requirejs"))?(n._$log.error(r),g.reject(r)):g.resolve()},t),u.push(g.promise)}if(0===u.length){var p=r.defer(),m="Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";return n._$log.error(m),p.reject(m),p.promise}return t.serie&&t.files.length>0?r.all(u).then(function(){return n.filesLoader(o,t)}):r.all(u)["finally"](function(e){return n.toggleWatch(!1),e})},n.load=function(o){var t,i=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],a=this,s=null,u=[],c=r.defer(),d=e.copy(o),l=e.copy(i);if(e.isArray(d))return e.forEach(d,function(e){u.push(a.load(e,l))}),r.all(u).then(function(e){c.resolve(e)},function(e){c.reject(e)}),c.promise;if(e.isString(d)?(s=a.getModuleConfig(d),s||(s={files:[d]})):e.isObject(d)&&(s=e.isDefined(d.path)&&e.isDefined(d.type)?{files:[d]}:a.setModuleConfig(d)),null===s){var f=a._getModuleName(d);return t='Module "'+(f||"unknown")+'" is not configured, cannot load.',n._$log.error(t),c.reject(new Error(t)),c.promise}e.isDefined(s.template)&&(e.isUndefined(s.files)&&(s.files=[]),e.isString(s.template)?s.files.push(s.template):e.isArray(s.template)&&s.files.concat(s.template));var h=e.extend({},l,s);return e.isUndefined(s.files)&&e.isDefined(s.name)&&n.moduleExists(s.name)?n.inject(s.name,h,!0):(n.filesLoader(s,h).then(function(){n.inject(null,h).then(function(e){c.resolve(e)},function(e){c.reject(e)})},function(e){c.reject(e)}),c.promise)},n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.cssLoader=function(o,t,i){var a=[];e.forEach(o,function(e){a.push(n.buildElement("css",e,i))}),r.all(a).then(function(){t()},function(e){t(e)})},n.cssLoader.ocLazyLoadLoader=!0,n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.jsLoader=function(o,t,i){var a=[];e.forEach(o,function(e){a.push(n.buildElement("js",e,i))}),r.all(a).then(function(){t()},function(e){t(e)})},n.jsLoader.ocLazyLoadLoader=!0,n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$templateCache","$q","$http",function(n,r,o,t){return n.templatesLoader=function(i,a,s){var u=[],c=n._getFilesCache();return e.forEach(i,function(n){var i=o.defer();u.push(i.promise),t.get(n,s).then(function(o){var t=o.data;e.isString(t)&&t.length>0&&e.forEach(e.element(t),function(e){"SCRIPT"===e.nodeName&&"text/ng-template"===e.type&&r.put(e.id,e.innerHTML)}),e.isUndefined(c.get(n))&&c.put(n,!0),i.resolve()})["catch"](function(e){i.reject(new Error('Unable to load template file "'+n+'": '+e.data))})}),o.all(u).then(function(){a()},function(e){a(e)})},n.templatesLoader.ocLazyLoadLoader=!0,n}])}])}(angular),Array.prototype.indexOf||(Array.prototype.indexOf=function(e,n){var r;if(null==this)throw new TypeError('"this" is null or not defined');var o=Object(this),t=o.length>>>0;if(0===t)return-1;var i=+n||0;if(Math.abs(i)===1/0&&(i=0),i>=t)return-1;for(r=Math.max(i>=0?i:t-Math.abs(i),0);t>r;){if(r in o&&o[r]===e)return r;r++}return-1});
!function(e){e(["jquery"],function(e){return function(){function t(e,t,n){return g({type:O.error,iconClass:m().iconClasses.error,message:e,optionsOverride:n,title:t})}function n(t,n){return t||(t=m()),v=e("#"+t.containerId),v.length?v:(n&&(v=d(t)),v)}function o(e,t,n){return g({type:O.info,iconClass:m().iconClasses.info,message:e,optionsOverride:n,title:t})}function s(e){C=e}function i(e,t,n){return g({type:O.success,iconClass:m().iconClasses.success,message:e,optionsOverride:n,title:t})}function a(e,t,n){return g({type:O.warning,iconClass:m().iconClasses.warning,message:e,optionsOverride:n,title:t})}function r(e,t){var o=m();v||n(o),u(e,o,t)||l(o)}function c(t){var o=m();return v||n(o),t&&0===e(":focus",t).length?void h(t):void(v.children().length&&v.remove())}function l(t){for(var n=v.children(),o=n.length-1;o>=0;o--)u(e(n[o]),t)}function u(t,n,o){var s=!(!o||!o.force)&&o.force;return!(!t||!s&&0!==e(":focus",t).length)&&(t[n.hideMethod]({duration:n.hideDuration,easing:n.hideEasing,complete:function(){h(t)}}),!0)}function d(t){return v=e("<div/>").attr("id",t.containerId).addClass(t.positionClass),v.appendTo(e(t.target)),v}function p(){return{tapToDismiss:!0,toastClass:"toast",containerId:"toast-container",debug:!1,showMethod:"fadeIn",showDuration:300,showEasing:"swing",onShown:void 0,hideMethod:"fadeOut",hideDuration:1e3,hideEasing:"swing",onHidden:void 0,closeMethod:!1,closeDuration:!1,closeEasing:!1,closeOnHover:!0,extendedTimeOut:1e3,iconClasses:{error:"toast-error",info:"toast-info",success:"toast-success",warning:"toast-warning"},iconClass:"toast-info",positionClass:"toast-top-right",timeOut:5e3,titleClass:"toast-title",messageClass:"toast-message",escapeHtml:!1,target:"body",closeHtml:'<button type="button">&times;</button>',closeClass:"toast-close-button",newestOnTop:!0,preventDuplicates:!1,progressBar:!1,progressClass:"toast-progress",rtl:!1}}function f(e){C&&C(e)}function g(t){function o(e){return null==e&&(e=""),e.replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/'/g,"&#39;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}function s(){c(),u(),d(),p(),g(),C(),l(),i()}function i(){var e="";switch(t.iconClass){case"toast-success":case"toast-info":e="polite";break;default:e="assertive"}I.attr("aria-live",e)}function a(){E.closeOnHover&&I.hover(H,D),!E.onclick&&E.tapToDismiss&&I.click(b),E.closeButton&&j&&j.click(function(e){e.stopPropagation?e.stopPropagation():void 0!==e.cancelBubble&&e.cancelBubble!==!0&&(e.cancelBubble=!0),E.onCloseClick&&E.onCloseClick(e),b(!0)}),E.onclick&&I.click(function(e){E.onclick(e),b()})}function r(){I.hide(),I[E.showMethod]({duration:E.showDuration,easing:E.showEasing,complete:E.onShown}),E.timeOut>0&&(k=setTimeout(b,E.timeOut),F.maxHideTime=parseFloat(E.timeOut),F.hideEta=(new Date).getTime()+F.maxHideTime,E.progressBar&&(F.intervalId=setInterval(x,10)))}function c(){t.iconClass&&I.addClass(E.toastClass).addClass(y)}function l(){E.newestOnTop?v.prepend(I):v.append(I)}function u(){if(t.title){var e=t.title;E.escapeHtml&&(e=o(t.title)),M.append(e).addClass(E.titleClass),I.append(M)}}function d(){if(t.message){var e=t.message;E.escapeHtml&&(e=o(t.message)),B.append(e).addClass(E.messageClass),I.append(B)}}function p(){E.closeButton&&(j.addClass(E.closeClass).attr("role","button"),I.prepend(j))}function g(){E.progressBar&&(q.addClass(E.progressClass),I.prepend(q))}function C(){E.rtl&&I.addClass("rtl")}function O(e,t){if(e.preventDuplicates){if(t.message===w)return!0;w=t.message}return!1}function b(t){var n=t&&E.closeMethod!==!1?E.closeMethod:E.hideMethod,o=t&&E.closeDuration!==!1?E.closeDuration:E.hideDuration,s=t&&E.closeEasing!==!1?E.closeEasing:E.hideEasing;if(!e(":focus",I).length||t)return clearTimeout(F.intervalId),I[n]({duration:o,easing:s,complete:function(){h(I),clearTimeout(k),E.onHidden&&"hidden"!==P.state&&E.onHidden(),P.state="hidden",P.endTime=new Date,f(P)}})}function D(){(E.timeOut>0||E.extendedTimeOut>0)&&(k=setTimeout(b,E.extendedTimeOut),F.maxHideTime=parseFloat(E.extendedTimeOut),F.hideEta=(new Date).getTime()+F.maxHideTime)}function H(){clearTimeout(k),F.hideEta=0,I.stop(!0,!0)[E.showMethod]({duration:E.showDuration,easing:E.showEasing})}function x(){var e=(F.hideEta-(new Date).getTime())/F.maxHideTime*100;q.width(e+"%")}var E=m(),y=t.iconClass||E.iconClass;if("undefined"!=typeof t.optionsOverride&&(E=e.extend(E,t.optionsOverride),y=t.optionsOverride.iconClass||y),!O(E,t)){T++,v=n(E,!0);var k=null,I=e("<div/>"),M=e("<div/>"),B=e("<div/>"),q=e("<div/>"),j=e(E.closeHtml),F={intervalId:null,hideEta:null,maxHideTime:null},P={toastId:T,state:"visible",startTime:new Date,options:E,map:t};return s(),r(),a(),f(P),E.debug&&console&&console.log(P),I}}function m(){return e.extend({},p(),b.options)}function h(e){v||(v=n()),e.is(":visible")||(e.remove(),e=null,0===v.children().length&&(v.remove(),w=void 0))}var v,C,w,T=0,O={error:"error",info:"info",success:"success",warning:"warning"},b={clear:r,remove:c,error:t,getContainer:n,info:o,options:{},subscribe:s,success:i,version:"2.1.3",warning:a};return b}()})}("function"==typeof define&&define.amd?define:function(e,t){"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):window.toastr=t(window.jQuery)});
// sourceMappingURL=toastr.js.map

/**
 * Modules in this bundle
 * @license
 * 
 * zlib-asm:
 *   license: zlib (http://opensource.org/licenses/zlib)
 *   author: Syu Kato
 *   version: 1.0.7
 * 
 * This header is generated by licensify (https://github.com/twada/licensify)
 */
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var common=require("../lib/common"),zlib=window.zlib=window.zlib||{};common.assign(zlib,require("../lib/def"),require("../lib/inf"));
},{"../lib/common":8,"../lib/def":9,"../lib/inf":10}],2:[function(require,module,exports){
function BaseDeflate(e,t){if(t=common.assign({},common.defaultParams,t),this.chunkSize=t.chunkSize,t.level&&(this.compressionLevel=t.level),this.compressionLevel=Math.min(Math.max(this.compressionLevel,0),9),this.ctxPtr=Module._ZLIBJS_createDeflateContext(t.compressionLevel,e),!this.ctxPtr)throw common.zerror("ZLIBJS_createDeflateContext");Module.ZLIBJS_instances[this.ctxPtr]=this,Module._ZLIBJS_init(this.chunkSize)}var Module=require("./Module"),common=require("./common");BaseDeflate.prototype.deflate=function(e){var t=common.validate(Module._ZLIBJS_deflate(this.ctxPtr,this.chunkSize,+e));if(!t.valid)throw this.cleanup(),common.zerror(t.error)},BaseDeflate.prototype.cleanup=function(){this.ctxPtr&&Module._ZLIBJS_freeDeflateContext(this.ctxPtr),delete Module.ZLIBJS_instances[this.ctxPtr]},module.exports=BaseDeflate;
},{"./Module":6,"./common":8}],3:[function(require,module,exports){
function BaseInflate(t,e){if(e=common.assign({},common.defaultParams,e),this.chunkSize=e.chunkSize,this.ctxPtr=Module._ZLIBJS_createInflateContext(t),!this.ctxPtr)throw common.zerror("ZLIBJS_createDeflateContext");Module.ZLIBJS_instances[this.ctxPtr]=this,Module._ZLIBJS_init(this.chunkSize)}var Module=require("./Module"),common=require("./common");BaseInflate.prototype.inflate=function(){var t=common.validate(Module._ZLIBJS_inflate(this.ctxPtr,this.chunkSize));if(!t.valid)throw this.cleanup(),common.zerror(t.error)},BaseInflate.prototype.cleanup=function(){this.ctxPtr&&Module._ZLIBJS_freeInflateContext(this.ctxPtr),delete Module.ZLIBJS_instances[this.ctxPtr]},module.exports=BaseInflate;
},{"./Module":6,"./common":8}],4:[function(require,module,exports){
function Deflate(e,t){BaseDeflate.call(this,e,t),this.src=t.input,this.streamFn=t.streamFn,this.shareMemory=t.shareMemory,this.offset=0,this.srcSize=0}var common=require("./common"),BaseDeflate=require("./BaseDeflate"),ReaderWriterMixin=require("./ReaderWriterMixin");common.assign(Deflate.prototype,BaseDeflate.prototype,ReaderWriterMixin),Deflate.prototype.constructor=Deflate,Deflate.prototype.deflateAll=function(){for(;this.offset<this.src.length;this.offset+=this.chunkSize)this.srcSize=Math.min(this.src.length-this.offset,this.chunkSize),this.deflate(this.src.length-this.offset<=this.chunkSize);this.cleanup()},module.exports=Deflate;
},{"./BaseDeflate":2,"./ReaderWriterMixin":7,"./common":8}],5:[function(require,module,exports){
function Inflate(e,t){BaseInflate.call(this,e,t),this.src=t.input,this.streamFn=t.streamFn,this.shareMemory=t.shareMemory,this.offset=0,this.srcSize=0}var common=require("./common"),BaseInflate=require("./BaseInflate"),ReaderWriterMixin=require("./ReaderWriterMixin");common.assign(Inflate.prototype,BaseInflate.prototype,ReaderWriterMixin),Inflate.prototype.constructor=Inflate,Inflate.prototype.inflateAll=function(){for(;this.offset<this.src.length;this.offset+=this.chunkSize)this.srcSize=Math.min(this.src.length-this.offset,this.chunkSize),this.inflate();this.cleanup()},module.exports=Inflate;
},{"./BaseInflate":3,"./ReaderWriterMixin":7,"./common":8}],6:[function(require,module,exports){
(function (__dirname){
var b;b||(b=eval("(function() { try { return Module || {} } catch(e) { return {} } })()"));var f={},k;for(k in b)b.hasOwnProperty(k)&&(f[k]=b[k]);var n=!1,q=!1,r=!1,t=!1;
if(b.ENVIRONMENT)if("WEB"===b.ENVIRONMENT)n=!0;else if("WORKER"===b.ENVIRONMENT)q=!0;else if("NODE"===b.ENVIRONMENT)r=!0;else if("SHELL"===b.ENVIRONMENT)t=!0;else throw Error("The provided Module['ENVIRONMENT'] value is not valid. It must be one of: WEB|WORKER|NODE|SHELL.");else n="object"===typeof window,q="function"===typeof importScripts,r="object"===typeof process&&"function"===typeof require&&!n&&!q,t=!n&&!r&&!q;
if(r){b.print||(b.print=console.log);b.printErr||(b.printErr=console.warn);var u,v;b.read=function(a,c){u||(u=require("fs"));v||(v=require("path"));a=v.normalize(a);var d=u.readFileSync(a);d||a==v.resolve(a)||(a=path.join(__dirname,"..","src",a),d=u.readFileSync(a));d&&!c&&(d=d.toString());return d};b.readBinary=function(a){a=b.read(a,!0);a.buffer||(a=new Uint8Array(a));assert(a.buffer);return a};b.load=function(a){w(read(a))};b.thisProgram||(b.thisProgram=1<process.argv.length?process.argv[1].replace(/\\/g,
"/"):"unknown-program");b.arguments=process.argv.slice(2);"undefined"!==typeof module&&(module.exports=b);process.on("uncaughtException",function(a){if(!(a instanceof y))throw a;});b.inspect=function(){return"[Emscripten Module object]"}}else if(t)b.print||(b.print=print),"undefined"!=typeof printErr&&(b.printErr=printErr),b.read="undefined"!=typeof read?read:function(){throw"no read() available (jsc?)";},b.readBinary=function(a){if("function"===typeof readbuffer)return new Uint8Array(readbuffer(a));
a=read(a,"binary");assert("object"===typeof a);return a},"undefined"!=typeof scriptArgs?b.arguments=scriptArgs:"undefined"!=typeof arguments&&(b.arguments=arguments),eval("if (typeof gc === 'function' && gc.toString().indexOf('[native code]') > 0) var gc = undefined");else if(n||q)b.read=function(a){var c=new XMLHttpRequest;c.open("GET",a,!1);c.send(null);return c.responseText},b.readAsync=function(a,c,d){var e=new XMLHttpRequest;e.open("GET",a,!0);e.responseType="arraybuffer";e.onload=function(){200==
e.status||0==e.status&&e.response?c(e.response):d()};e.onerror=d;e.send(null)},"undefined"!=typeof arguments&&(b.arguments=arguments),"undefined"!==typeof console?(b.print||(b.print=function(a){console.log(a)}),b.printErr||(b.printErr=function(a){console.warn(a)})):b.print||(b.print=function(){}),q&&(b.load=importScripts),"undefined"===typeof b.setWindowTitle&&(b.setWindowTitle=function(a){document.title=a});else throw"Unknown runtime environment. Where are we?";function w(a){eval.call(null,a)}
!b.load&&b.read&&(b.load=function(a){w(b.read(a))});b.print||(b.print=function(){});b.printErr||(b.printErr=b.print);b.arguments||(b.arguments=[]);b.thisProgram||(b.thisProgram="./this.program");b.print=b.print;b.h=b.printErr;b.preRun=[];b.postRun=[];for(k in f)f.hasOwnProperty(k)&&(b[k]=f[k]);
var f=void 0,B={w:function(a){tempRet0=a},u:function(){return tempRet0},B:function(){return z},A:function(a){z=a},l:function(a){switch(a){case "i1":case "i8":return 1;case "i16":return 2;case "i32":return 4;case "i64":return 8;case "float":return 4;case "double":return 8;default:return"*"===a[a.length-1]?B.d:"i"===a[0]?(a=parseInt(a.substr(1)),assert(0===a%8),a/8):0}},t:function(a){return Math.max(B.l(a),B.d)},C:16,P:function(a,c){"double"===c||"i64"===c?a&7&&(assert(4===(a&7)),a+=4):assert(0===(a&
3));return a},J:function(a,c,d){return d||"i64"!=a&&"double"!=a?a?Math.min(c||(a?B.t(a):0),B.d):Math.min(c,8):8},f:function(a,c,d){return d&&d.length?(d.splice||(d=Array.prototype.slice.call(d)),d.splice(0,0,c),b["dynCall_"+a].apply(null,d)):b["dynCall_"+a].call(null,c)},c:[],p:function(a){for(var c=0;c<B.c.length;c++)if(!B.c[c])return B.c[c]=a,2*(1+c);throw"Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.";},v:function(a){B.c[(a-2)/2]=null},a:function(a){B.a.i||
(B.a.i={});B.a.i[a]||(B.a.i[a]=1,b.h(a))},g:{},L:function(a,c){assert(c);B.g[c]||(B.g[c]={});var d=B.g[c];d[a]||(d[a]=function(){return B.f(c,a,arguments)});return d[a]},K:function(){throw"You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work";},m:function(a){var c=z;z=z+a|0;z=z+15&-16;return c},n:function(a){var c=C;C=C+a|0;C=C+15&-16;return c},b:function(a){var c=D;D=D+a|0;D=D+15&-16;if(a=D>=E)F("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value "+
E+", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which adjusts the size at runtime but prevents some optimizations, (3) set Module.TOTAL_MEMORY to a higher value before the program runs, or if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 "),a=!0;return a?(D=c,0):c},k:function(a,c){return Math.ceil(a/(c?c:16))*(c?c:16)},O:function(a,c,d){return d?+(a>>>0)+4294967296*+(c>>>0):+(a>>>0)+4294967296*+(c|0)},j:8,d:4,D:0};B.addFunction=B.p;
B.removeFunction=B.v;var G=!1;function assert(a,c){a||F("Assertion failed: "+c)}function aa(a){var c;c="i32";"*"===c.charAt(c.length-1)&&(c="i32");switch(c){case "i1":return H[a>>0];case "i8":return H[a>>0];case "i16":return I[a>>1];case "i32":return J[a>>2];case "i64":return J[a>>2];case "float":return K[a>>2];case "double":return L[a>>3];default:F("invalid type for setValue: "+c)}return null}
function M(a,c,d,e){var g,l;"number"===typeof a?(g=!0,l=a):(g=!1,l=a.length);var m="string"===typeof c?c:null;d=4==d?e:["function"===typeof N?N:B.n,B.m,B.n,B.b][void 0===d?2:d](Math.max(l,m?1:c.length));if(g){e=d;assert(0==(d&3));for(a=d+(l&-4);e<a;e+=4)J[e>>2]=0;for(a=d+l;e<a;)H[e++>>0]=0;return d}if("i8"===m)return a.subarray||a.slice?O.set(a,d):O.set(new Uint8Array(a),d),d;e=0;for(var h,T;e<l;){var p=a[e];"function"===typeof p&&(p=B.M(p));g=m||c[e];if(0===g)e++;else{"i64"==g&&(g="i32");var x=d+
e,A=g,A=A||"i8";"*"===A.charAt(A.length-1)&&(A="i32");switch(A){case "i1":H[x>>0]=p;break;case "i8":H[x>>0]=p;break;case "i16":I[x>>1]=p;break;case "i32":J[x>>2]=p;break;case "i64":tempI64=[p>>>0,(tempDouble=p,1<=+ba(tempDouble)?0<tempDouble?(ca(+da(tempDouble/4294967296),4294967295)|0)>>>0:~~+ea((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)];J[x>>2]=tempI64[0];J[x+4>>2]=tempI64[1];break;case "float":K[x>>2]=p;break;case "double":L[x>>3]=p;break;default:F("invalid type for setValue: "+A)}T!==
g&&(h=B.l(g),T=g);e+=h}}return d}function fa(a){var c;if(0===c||!a)return"";for(var d=0,e,g=0;;){e=O[a+g>>0];d|=e;if(0==e&&!c)break;g++;if(c&&g==c)break}c||(c=g);e="";if(128>d){for(;0<c;)d=String.fromCharCode.apply(String,O.subarray(a,a+Math.min(c,1024))),e=e?e+d:d,a+=1024,c-=1024;return e}return b.UTF8ToString(a)}
function ga(){return ha().replace(/__Z[\w\d_]+/g,function(a){var c;a:{if(b.___cxa_demangle)try{for(var d=N(a.length),e=d,g=P(a.substr(1),void 0),l=0;l<g.length;)H[e+l>>0]=g[l],l+=1;var m=N(4),h=b.___cxa_demangle(d,0,0,m);if(0===aa(m)&&h){c=fa(h);break a}}catch(T){c=a;break a}finally{d&&Q(d),m&&Q(m),h&&Q(h)}B.a("warning: build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling");c=a}return a===c?a:a+" ["+c+"]"})}
function ha(){var a=Error();if(!a.stack){try{throw Error(0);}catch(c){a=c}if(!a.stack)return"(no stack trace available)"}return a.stack.toString()}function ia(){var a=D;0<a%4096&&(a+=4096-a%4096);return a}for(var buffer,H,O,I,R,J,ja,K,L,ka=0,C=0,la=0,z=0,S=0,D=0,ma=b.TOTAL_STACK||5242880,E=b.TOTAL_MEMORY||16777216,U=65536;U<E||U<2*ma;)U=16777216>U?2*U:U+16777216;U!==E&&(E=U);b.buffer?buffer=b.buffer:buffer=new ArrayBuffer(E);b.HEAP8=H=new Int8Array(buffer);b.HEAP16=I=new Int16Array(buffer);
b.HEAP32=J=new Int32Array(buffer);b.HEAPU8=O=new Uint8Array(buffer);b.HEAPU16=R=new Uint16Array(buffer);b.HEAPU32=ja=new Uint32Array(buffer);b.HEAPF32=K=new Float32Array(buffer);b.HEAPF64=L=new Float64Array(buffer);J[0]=255;if(255!==O[0]||0!==O[3])throw"Typed arrays 2 must be run on a little-endian system";b.HEAP=void 0;b.buffer=buffer;b.HEAP8=H;b.HEAP16=I;b.HEAP32=J;b.HEAPU8=O;b.HEAPU16=R;b.HEAPU32=ja;b.HEAPF32=K;b.HEAPF64=L;
function V(a){for(;0<a.length;){var c=a.shift();if("function"==typeof c)c();else{var d=c.I;"number"===typeof d?void 0===c.e?B.f("v",d):B.f("vi",d,[c.e]):d(void 0===c.e?null:c.e)}}}var na=[],W=[],oa=[],pa=[],qa=[],X=!1;function ra(){var a=b.preRun.shift();na.unshift(a)}
function P(a,c){for(var d=0,e=0;e<a.length;++e){var g=a.charCodeAt(e);55296<=g&&57343>=g&&(g=65536+((g&1023)<<10)|a.charCodeAt(++e)&1023);127>=g?++d:d=2047>=g?d+2:65535>=g?d+3:2097151>=g?d+4:67108863>=g?d+5:d+6}d=Array(d+1);var l=d.length,e=0;if(0<l){for(var g=e,l=e+l-1,m=0;m<a.length;++m){var h=a.charCodeAt(m);55296<=h&&57343>=h&&(h=65536+((h&1023)<<10)|a.charCodeAt(++m)&1023);if(127>=h){if(e>=l)break;d[e++]=h}else{if(2047>=h){if(e+1>=l)break;d[e++]=192|h>>6}else{if(65535>=h){if(e+2>=l)break;d[e++]=
224|h>>12}else{if(2097151>=h){if(e+3>=l)break;d[e++]=240|h>>18}else{if(67108863>=h){if(e+4>=l)break;d[e++]=248|h>>24}else{if(e+5>=l)break;d[e++]=252|h>>30;d[e++]=128|h>>24&63}d[e++]=128|h>>18&63}d[e++]=128|h>>12&63}d[e++]=128|h>>6&63}d[e++]=128|h&63}}d[e]=0;e=e-g}else e=0;c&&(d.length=e);return d}Math.imul&&-5===Math.imul(4294967295,5)||(Math.imul=function(a,c){var d=a&65535,e=c&65535;return d*e+((a>>>16)*e+d*(c>>>16)<<16)|0});Math.N=Math.imul;
Math.clz32||(Math.clz32=function(a){a=a>>>0;for(var c=0;32>c;c++)if(a&1<<31-c)return c;return 32});Math.G=Math.clz32;Math.trunc||(Math.trunc=function(a){return 0>a?Math.ceil(a):Math.floor(a)});Math.trunc=Math.trunc;var ba=Math.abs,ea=Math.ceil,da=Math.floor,ca=Math.min;b.preloadedImages={};b.preloadedAudios={};var ta=[function(a,c,d){return sa[a].$read(c,d)},function(a,c,d){sa[a].$write(c,d)}],ka=8,C=ka+14592;W.push();
M([0,0,0,0,0,0,0,0,1,0,0,0,4,0,4,0,8,0,4,0,2,0,0,0,4,0,5,0,16,0,8,0,2,0,0,0,4,0,6,0,32,0,32,0,2,0,0,0,4,0,4,0,16,0,16,0,3,0,0,0,8,0,16,0,32,0,32,0,3,0,0,0,8,0,16,0,128,0,128,0,3,0,0,0,8,0,32,0,128,0,0,1,3,0,0,0,32,0,128,0,2,1,0,4,3,0,0,0,32,0,2,1,2,1,0,16,3,0,0,0,130,44,0,0,148,0,0,0,1,1,0,0,30,1,0,0,15,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,3,0,0,0,3,0,0,0,3,0,0,0,4,0,0,0,4,0,0,0,4,0,0,0,4,0,0,
0,5,0,0,0,5,0,0,0,5,0,0,0,5,0,0,0,0,0,0,0,2,49,0,0,28,1,0,0,0,0,0,0,30,0,0,0,15,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,3,0,0,0,4,0,0,0,4,0,0,0,5,0,0,0,5,0,0,0,6,0,0,0,6,0,0,0,7,0,0,0,7,0,0,0,8,0,0,0,8,0,0,0,9,0,0,0,9,0,0,0,10,0,0,0,10,0,0,0,11,0,0,0,11,0,0,0,12,0,0,0,12,0,0,0,13,0,0,0,13,0,0,0,0,0,0,0,168,1,0,0,0,0,0,0,19,0,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
0,0,2,0,0,0,3,0,0,0,7,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,5,0,0,0,6,0,0,0,7,0,0,0,8,0,0,0,10,0,0,0,12,0,0,0,14,0,0,0,16,0,0,0,20,0,0,0,24,0,0,0,28,0,0,0,32,0,0,0,40,0,0,0,48,0,0,0,56,0,0,0,64,0,0,0,80,0,0,0,96,0,0,0,112,0,0,0,128,0,0,0,160,0,0,0,192,0,0,0,224,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,6,0,0,0,8,0,0,0,12,0,0,0,16,0,0,0,24,0,0,0,32,0,0,0,48,0,0,0,64,0,0,0,96,0,0,0,128,0,0,0,192,0,0,0,0,1,0,0,128,1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,6,0,0,0,8,0,0,0,12,0,0,0,16,0,0,0,
24,0,0,0,32,0,0,0,48,0,0,0,64,0,0,0,96,0,0,0,0,0,0,150,48,7,119,44,97,14,238,186,81,9,153,25,196,109,7,143,244,106,112,53,165,99,233,163,149,100,158,50,136,219,14,164,184,220,121,30,233,213,224,136,217,210,151,43,76,182,9,189,124,177,126,7,45,184,231,145,29,191,144,100,16,183,29,242,32,176,106,72,113,185,243,222,65,190,132,125,212,218,26,235,228,221,109,81,181,212,244,199,133,211,131,86,152,108,19,192,168,107,100,122,249,98,253,236,201,101,138,79,92,1,20,217,108,6,99,99,61,15,250,245,13,8,141,200,
32,110,59,94,16,105,76,228,65,96,213,114,113,103,162,209,228,3,60,71,212,4,75,253,133,13,210,107,181,10,165,250,168,181,53,108,152,178,66,214,201,187,219,64,249,188,172,227,108,216,50,117,92,223,69,207,13,214,220,89,61,209,171,172,48,217,38,58,0,222,81,128,81,215,200,22,97,208,191,181,244,180,33,35,196,179,86,153,149,186,207,15,165,189,184,158,184,2,40,8,136,5,95,178,217,12,198,36,233,11,177,135,124,111,47,17,76,104,88,171,29,97,193,61,45,102,182,144,65,220,118,6,113,219,1,188,32,210,152,42,16,213,
239,137,133,177,113,31,181,182,6,165,228,191,159,51,212,184,232,162,201,7,120,52,249,0,15,142,168,9,150,24,152,14,225,187,13,106,127,45,61,109,8,151,108,100,145,1,92,99,230,244,81,107,107,98,97,108,28,216,48,101,133,78,0,98,242,237,149,6,108,123,165,1,27,193,244,8,130,87,196,15,245,198,217,176,101,80,233,183,18,234,184,190,139,124,136,185,252,223,29,221,98,73,45,218,21,243,124,211,140,101,76,212,251,88,97,178,77,206,81,181,58,116,0,188,163,226,48,187,212,65,165,223,74,215,149,216,61,109,196,209,164,
251,244,214,211,106,233,105,67,252,217,110,52,70,136,103,173,208,184,96,218,115,45,4,68,229,29,3,51,95,76,10,170,201,124,13,221,60,113,5,80,170,65,2,39,16,16,11,190,134,32,12,201,37,181,104,87,179,133,111,32,9,212,102,185,159,228,97,206,14,249,222,94,152,201,217,41,34,152,208,176,180,168,215,199,23,61,179,89,129,13,180,46,59,92,189,183,173,108,186,192,32,131,184,237,182,179,191,154,12,226,182,3,154,210,177,116,57,71,213,234,175,119,210,157,21,38,219,4,131,22,220,115,18,11,99,227,132,59,100,148,62,
106,109,13,168,90,106,122,11,207,14,228,157,255,9,147,39,174,0,10,177,158,7,125,68,147,15,240,210,163,8,135,104,242,1,30,254,194,6,105,93,87,98,247,203,103,101,128,113,54,108,25,231,6,107,110,118,27,212,254,224,43,211,137,90,122,218,16,204,74,221,103,111,223,185,249,249,239,190,142,67,190,183,23,213,142,176,96,232,163,214,214,126,147,209,161,196,194,216,56,82,242,223,79,241,103,187,209,103,87,188,166,221,6,181,63,75,54,178,72,218,43,13,216,76,27,10,175,246,74,3,54,96,122,4,65,195,239,96,223,85,223,
103,168,239,142,110,49,121,190,105,70,140,179,97,203,26,131,102,188,160,210,111,37,54,226,104,82,149,119,12,204,3,71,11,187,185,22,2,34,47,38,5,85,190,59,186,197,40,11,189,178,146,90,180,43,4,106,179,92,167,255,215,194,49,207,208,181,139,158,217,44,29,174,222,91,176,194,100,155,38,242,99,236,156,163,106,117,10,147,109,2,169,6,9,156,63,54,14,235,133,103,7,114,19,87,0,5,130,74,191,149,20,122,184,226,174,43,177,123,56,27,182,12,155,142,210,146,13,190,213,229,183,239,220,124,33,223,219,11,212,210,211,
134,66,226,212,241,248,179,221,104,110,131,218,31,205,22,190,129,91,38,185,246,225,119,176,111,119,71,183,24,230,90,8,136,112,106,15,255,202,59,6,102,92,11,1,17,255,158,101,143,105,174,98,248,211,255,107,97,69,207,108,22,120,226,10,160,238,210,13,215,84,131,4,78,194,179,3,57,97,38,103,167,247,22,96,208,77,71,105,73,219,119,110,62,74,106,209,174,220,90,214,217,102,11,223,64,240,59,216,55,83,174,188,169,197,158,187,222,127,207,178,71,233,255,181,48,28,242,189,189,138,194,186,202,48,147,179,83,166,163,
180,36,5,54,208,186,147,6,215,205,41,87,222,84,191,103,217,35,46,122,102,179,184,74,97,196,2,27,104,93,148,43,111,42,55,190,11,180,161,142,12,195,27,223,5,90,141,239,2,45,0,0,0,0,65,49,27,25,130,98,54,50,195,83,45,43,4,197,108,100,69,244,119,125,134,167,90,86,199,150,65,79,8,138,217,200,73,187,194,209,138,232,239,250,203,217,244,227,12,79,181,172,77,126,174,181,142,45,131,158,207,28,152,135,81,18,194,74,16,35,217,83,211,112,244,120,146,65,239,97,85,215,174,46,20,230,181,55,215,181,152,28,150,132,
131,5,89,152,27,130,24,169,0,155,219,250,45,176,154,203,54,169,93,93,119,230,28,108,108,255,223,63,65,212,158,14,90,205,162,36,132,149,227,21,159,140,32,70,178,167,97,119,169,190,166,225,232,241,231,208,243,232,36,131,222,195,101,178,197,218,170,174,93,93,235,159,70,68,40,204,107,111,105,253,112,118,174,107,49,57,239,90,42,32,44,9,7,11,109,56,28,18,243,54,70,223,178,7,93,198,113,84,112,237,48,101,107,244,247,243,42,187,182,194,49,162,117,145,28,137,52,160,7,144,251,188,159,23,186,141,132,14,121,222,
169,37,56,239,178,60,255,121,243,115,190,72,232,106,125,27,197,65,60,42,222,88,5,79,121,240,68,126,98,233,135,45,79,194,198,28,84,219,1,138,21,148,64,187,14,141,131,232,35,166,194,217,56,191,13,197,160,56,76,244,187,33,143,167,150,10,206,150,141,19,9,0,204,92,72,49,215,69,139,98,250,110,202,83,225,119,84,93,187,186,21,108,160,163,214,63,141,136,151,14,150,145,80,152,215,222,17,169,204,199,210,250,225,236,147,203,250,245,92,215,98,114,29,230,121,107,222,181,84,64,159,132,79,89,88,18,14,22,25,35,21,
15,218,112,56,36,155,65,35,61,167,107,253,101,230,90,230,124,37,9,203,87,100,56,208,78,163,174,145,1,226,159,138,24,33,204,167,51,96,253,188,42,175,225,36,173,238,208,63,180,45,131,18,159,108,178,9,134,171,36,72,201,234,21,83,208,41,70,126,251,104,119,101,226,246,121,63,47,183,72,36,54,116,27,9,29,53,42,18,4,242,188,83,75,179,141,72,82,112,222,101,121,49,239,126,96,254,243,230,231,191,194,253,254,124,145,208,213,61,160,203,204,250,54,138,131,187,7,145,154,120,84,188,177,57,101,167,168,75,152,131,
59,10,169,152,34,201,250,181,9,136,203,174,16,79,93,239,95,14,108,244,70,205,63,217,109,140,14,194,116,67,18,90,243,2,35,65,234,193,112,108,193,128,65,119,216,71,215,54,151,6,230,45,142,197,181,0,165,132,132,27,188,26,138,65,113,91,187,90,104,152,232,119,67,217,217,108,90,30,79,45,21,95,126,54,12,156,45,27,39,221,28,0,62,18,0,152,185,83,49,131,160,144,98,174,139,209,83,181,146,22,197,244,221,87,244,239,196,148,167,194,239,213,150,217,246,233,188,7,174,168,141,28,183,107,222,49,156,42,239,42,133,237,
121,107,202,172,72,112,211,111,27,93,248,46,42,70,225,225,54,222,102,160,7,197,127,99,84,232,84,34,101,243,77,229,243,178,2,164,194,169,27,103,145,132,48,38,160,159,41,184,174,197,228,249,159,222,253,58,204,243,214,123,253,232,207,188,107,169,128,253,90,178,153,62,9,159,178,127,56,132,171,176,36,28,44,241,21,7,53,50,70,42,30,115,119,49,7,180,225,112,72,245,208,107,81,54,131,70,122,119,178,93,99,78,215,250,203,15,230,225,210,204,181,204,249,141,132,215,224,74,18,150,175,11,35,141,182,200,112,160,157,
137,65,187,132,70,93,35,3,7,108,56,26,196,63,21,49,133,14,14,40,66,152,79,103,3,169,84,126,192,250,121,85,129,203,98,76,31,197,56,129,94,244,35,152,157,167,14,179,220,150,21,170,27,0,84,229,90,49,79,252,153,98,98,215,216,83,121,206,23,79,225,73,86,126,250,80,149,45,215,123,212,28,204,98,19,138,141,45,82,187,150,52,145,232,187,31,208,217,160,6,236,243,126,94,173,194,101,71,110,145,72,108,47,160,83,117,232,54,18,58,169,7,9,35,106,84,36,8,43,101,63,17,228,121,167,150,165,72,188,143,102,27,145,164,39,
42,138,189,224,188,203,242,161,141,208,235,98,222,253,192,35,239,230,217,189,225,188,20,252,208,167,13,63,131,138,38,126,178,145,63,185,36,208,112,248,21,203,105,59,70,230,66,122,119,253,91,181,107,101,220,244,90,126,197,55,9,83,238,118,56,72,247,177,174,9,184,240,159,18,161,51,204,63,138,114,253,36,147,0,0,0,0,55,106,194,1,110,212,132,3,89,190,70,2,220,168,9,7,235,194,203,6,178,124,141,4,133,22,79,5,184,81,19,14,143,59,209,15,214,133,151,13,225,239,85,12,100,249,26,9,83,147,216,8,10,45,158,10,61,
71,92,11,112,163,38,28,71,201,228,29,30,119,162,31,41,29,96,30,172,11,47,27,155,97,237,26,194,223,171,24,245,181,105,25,200,242,53,18,255,152,247,19,166,38,177,17,145,76,115,16,20,90,60,21,35,48,254,20,122,142,184,22,77,228,122,23,224,70,77,56,215,44,143,57,142,146,201,59,185,248,11,58,60,238,68,63,11,132,134,62,82,58,192,60,101,80,2,61,88,23,94,54,111,125,156,55,54,195,218,53,1,169,24,52,132,191,87,49,179,213,149,48,234,107,211,50,221,1,17,51,144,229,107,36,167,143,169,37,254,49,239,39,201,91,45,
38,76,77,98,35,123,39,160,34,34,153,230,32,21,243,36,33,40,180,120,42,31,222,186,43,70,96,252,41,113,10,62,40,244,28,113,45,195,118,179,44,154,200,245,46,173,162,55,47,192,141,154,112,247,231,88,113,174,89,30,115,153,51,220,114,28,37,147,119,43,79,81,118,114,241,23,116,69,155,213,117,120,220,137,126,79,182,75,127,22,8,13,125,33,98,207,124,164,116,128,121,147,30,66,120,202,160,4,122,253,202,198,123,176,46,188,108,135,68,126,109,222,250,56,111,233,144,250,110,108,134,181,107,91,236,119,106,2,82,49,
104,53,56,243,105,8,127,175,98,63,21,109,99,102,171,43,97,81,193,233,96,212,215,166,101,227,189,100,100,186,3,34,102,141,105,224,103,32,203,215,72,23,161,21,73,78,31,83,75,121,117,145,74,252,99,222,79,203,9,28,78,146,183,90,76,165,221,152,77,152,154,196,70,175,240,6,71,246,78,64,69,193,36,130,68,68,50,205,65,115,88,15,64,42,230,73,66,29,140,139,67,80,104,241,84,103,2,51,85,62,188,117,87,9,214,183,86,140,192,248,83,187,170,58,82,226,20,124,80,213,126,190,81,232,57,226,90,223,83,32,91,134,237,102,89,
177,135,164,88,52,145,235,93,3,251,41,92,90,69,111,94,109,47,173,95,128,27,53,225,183,113,247,224,238,207,177,226,217,165,115,227,92,179,60,230,107,217,254,231,50,103,184,229,5,13,122,228,56,74,38,239,15,32,228,238,86,158,162,236,97,244,96,237,228,226,47,232,211,136,237,233,138,54,171,235,189,92,105,234,240,184,19,253,199,210,209,252,158,108,151,254,169,6,85,255,44,16,26,250,27,122,216,251,66,196,158,249,117,174,92,248,72,233,0,243,127,131,194,242,38,61,132,240,17,87,70,241,148,65,9,244,163,43,203,
245,250,149,141,247,205,255,79,246,96,93,120,217,87,55,186,216,14,137,252,218,57,227,62,219,188,245,113,222,139,159,179,223,210,33,245,221,229,75,55,220,216,12,107,215,239,102,169,214,182,216,239,212,129,178,45,213,4,164,98,208,51,206,160,209,106,112,230,211,93,26,36,210,16,254,94,197,39,148,156,196,126,42,218,198,73,64,24,199,204,86,87,194,251,60,149,195,162,130,211,193,149,232,17,192,168,175,77,203,159,197,143,202,198,123,201,200,241,17,11,201,116,7,68,204,67,109,134,205,26,211,192,207,45,185,2,
206,64,150,175,145,119,252,109,144,46,66,43,146,25,40,233,147,156,62,166,150,171,84,100,151,242,234,34,149,197,128,224,148,248,199,188,159,207,173,126,158,150,19,56,156,161,121,250,157,36,111,181,152,19,5,119,153,74,187,49,155,125,209,243,154,48,53,137,141,7,95,75,140,94,225,13,142,105,139,207,143,236,157,128,138,219,247,66,139,130,73,4,137,181,35,198,136,136,100,154,131,191,14,88,130,230,176,30,128,209,218,220,129,84,204,147,132,99,166,81,133,58,24,23,135,13,114,213,134,160,208,226,169,151,186,32,
168,206,4,102,170,249,110,164,171,124,120,235,174,75,18,41,175,18,172,111,173,37,198,173,172,24,129,241,167,47,235,51,166,118,85,117,164,65,63,183,165,196,41,248,160,243,67,58,161,170,253,124,163,157,151,190,162,208,115,196,181,231,25,6,180,190,167,64,182,137,205,130,183,12,219,205,178,59,177,15,179,98,15,73,177,85,101,139,176,104,34,215,187,95,72,21,186,6,246,83,184,49,156,145,185,180,138,222,188,131,224,28,189,218,94,90,191,237,52,152,190,0,0,0,0,101,103,188,184,139,200,9,170,238,175,181,18,87,
151,98,143,50,240,222,55,220,95,107,37,185,56,215,157,239,40,180,197,138,79,8,125,100,224,189,111,1,135,1,215,184,191,214,74,221,216,106,242,51,119,223,224,86,16,99,88,159,87,25,80,250,48,165,232,20,159,16,250,113,248,172,66,200,192,123,223,173,167,199,103,67,8,114,117,38,111,206,205,112,127,173,149,21,24,17,45,251,183,164,63,158,208,24,135,39,232,207,26,66,143,115,162,172,32,198,176,201,71,122,8,62,175,50,160,91,200,142,24,181,103,59,10,208,0,135,178,105,56,80,47,12,95,236,151,226,240,89,133,135,
151,229,61,209,135,134,101,180,224,58,221,90,79,143,207,63,40,51,119,134,16,228,234,227,119,88,82,13,216,237,64,104,191,81,248,161,248,43,240,196,159,151,72,42,48,34,90,79,87,158,226,246,111,73,127,147,8,245,199,125,167,64,213,24,192,252,109,78,208,159,53,43,183,35,141,197,24,150,159,160,127,42,39,25,71,253,186,124,32,65,2,146,143,244,16,247,232,72,168,61,88,20,155,88,63,168,35,182,144,29,49,211,247,161,137,106,207,118,20,15,168,202,172,225,7,127,190,132,96,195,6,210,112,160,94,183,23,28,230,89,184,
169,244,60,223,21,76,133,231,194,209,224,128,126,105,14,47,203,123,107,72,119,195,162,15,13,203,199,104,177,115,41,199,4,97,76,160,184,217,245,152,111,68,144,255,211,252,126,80,102,238,27,55,218,86,77,39,185,14,40,64,5,182,198,239,176,164,163,136,12,28,26,176,219,129,127,215,103,57,145,120,210,43,244,31,110,147,3,247,38,59,102,144,154,131,136,63,47,145,237,88,147,41,84,96,68,180,49,7,248,12,223,168,77,30,186,207,241,166,236,223,146,254,137,184,46,70,103,23,155,84,2,112,39,236,187,72,240,113,222,47,
76,201,48,128,249,219,85,231,69,99,156,160,63,107,249,199,131,211,23,104,54,193,114,15,138,121,203,55,93,228,174,80,225,92,64,255,84,78,37,152,232,246,115,136,139,174,22,239,55,22,248,64,130,4,157,39,62,188,36,31,233,33,65,120,85,153,175,215,224,139,202,176,92,51,59,182,89,237,94,209,229,85,176,126,80,71,213,25,236,255,108,33,59,98,9,70,135,218,231,233,50,200,130,142,142,112,212,158,237,40,177,249,81,144,95,86,228,130,58,49,88,58,131,9,143,167,230,110,51,31,8,193,134,13,109,166,58,181,164,225,64,
189,193,134,252,5,47,41,73,23,74,78,245,175,243,118,34,50,150,17,158,138,120,190,43,152,29,217,151,32,75,201,244,120,46,174,72,192,192,1,253,210,165,102,65,106,28,94,150,247,121,57,42,79,151,150,159,93,242,241,35,229,5,25,107,77,96,126,215,245,142,209,98,231,235,182,222,95,82,142,9,194,55,233,181,122,217,70,0,104,188,33,188,208,234,49,223,136,143,86,99,48,97,249,214,34,4,158,106,154,189,166,189,7,216,193,1,191,54,110,180,173,83,9,8,21,154,78,114,29,255,41,206,165,17,134,123,183,116,225,199,15,205,
217,16,146,168,190,172,42,70,17,25,56,35,118,165,128,117,102,198,216,16,1,122,96,254,174,207,114,155,201,115,202,34,241,164,87,71,150,24,239,169,57,173,253,204,94,17,69,6,238,77,118,99,137,241,206,141,38,68,220,232,65,248,100,81,121,47,249,52,30,147,65,218,177,38,83,191,214,154,235,233,198,249,179,140,161,69,11,98,14,240,25,7,105,76,161,190,81,155,60,219,54,39,132,53,153,146,150,80,254,46,46,153,185,84,38,252,222,232,158,18,113,93,140,119,22,225,52,206,46,54,169,171,73,138,17,69,230,63,3,32,129,131,
187,118,145,224,227,19,246,92,91,253,89,233,73,152,62,85,241,33,6,130,108,68,97,62,212,170,206,139,198,207,169,55,126,56,65,127,214,93,38,195,110,179,137,118,124,214,238,202,196,111,214,29,89,10,177,161,225,228,30,20,243,129,121,168,75,215,105,203,19,178,14,119,171,92,161,194,185,57,198,126,1,128,254,169,156,229,153,21,36,11,54,160,54,110,81,28,142,167,22,102,134,194,113,218,62,44,222,111,44,73,185,211,148,240,129,4,9,149,230,184,177,123,73,13,163,30,46,177,27,72,62,210,67,45,89,110,251,195,246,219,
233,166,145,103,81,31,169,176,204,122,206,12,116,148,97,185,102,241,6,5,222,0,0,0,0,119,7,48,150,238,14,97,44,153,9,81,186,7,109,196,25,112,106,244,143,233,99,165,53,158,100,149,163,14,219,136,50,121,220,184,164,224,213,233,30,151,210,217,136,9,182,76,43,126,177,124,189,231,184,45,7,144,191,29,145,29,183,16,100,106,176,32,242,243,185,113,72,132,190,65,222,26,218,212,125,109,221,228,235,244,212,181,81,131,211,133,199,19,108,152,86,100,107,168,192,253,98,249,122,138,101,201,236,20,1,92,79,99,6,108,
217,250,15,61,99,141,8,13,245,59,110,32,200,76,105,16,94,213,96,65,228,162,103,113,114,60,3,228,209,75,4,212,71,210,13,133,253,165,10,181,107,53,181,168,250,66,178,152,108,219,187,201,214,172,188,249,64,50,216,108,227,69,223,92,117,220,214,13,207,171,209,61,89,38,217,48,172,81,222,0,58,200,215,81,128,191,208,97,22,33,180,244,181,86,179,196,35,207,186,149,153,184,189,165,15,40,2,184,158,95,5,136,8,198,12,217,178,177,11,233,36,47,111,124,135,88,104,76,17,193,97,29,171,182,102,45,61,118,220,65,144,1,
219,113,6,152,210,32,188,239,213,16,42,113,177,133,137,6,182,181,31,159,191,228,165,232,184,212,51,120,7,201,162,15,0,249,52,150,9,168,142,225,14,152,24,127,106,13,187,8,109,61,45,145,100,108,151,230,99,92,1,107,107,81,244,28,108,97,98,133,101,48,216,242,98,0,78,108,6,149,237,27,1,165,123,130,8,244,193,245,15,196,87,101,176,217,198,18,183,233,80,139,190,184,234,252,185,136,124,98,221,29,223,21,218,45,73,140,211,124,243,251,212,76,101,77,178,97,88,58,181,81,206,163,188,0,116,212,187,48,226,74,223,
165,65,61,216,149,215,164,209,196,109,211,214,244,251,67,105,233,106,52,110,217,252,173,103,136,70,218,96,184,208,68,4,45,115,51,3,29,229,170,10,76,95,221,13,124,201,80,5,113,60,39,2,65,170,190,11,16,16,201,12,32,134,87,104,181,37,32,111,133,179,185,102,212,9,206,97,228,159,94,222,249,14,41,217,201,152,176,208,152,34,199,215,168,180,89,179,61,23,46,180,13,129,183,189,92,59,192,186,108,173,237,184,131,32,154,191,179,182,3,182,226,12,116,177,210,154,234,213,71,57,157,210,119,175,4,219,38,21,115,220,
22,131,227,99,11,18,148,100,59,132,13,109,106,62,122,106,90,168,228,14,207,11,147,9,255,157,10,0,174,39,125,7,158,177,240,15,147,68,135,8,163,210,30,1,242,104,105,6,194,254,247,98,87,93,128,101,103,203,25,108,54,113,110,107,6,231,254,212,27,118,137,211,43,224,16,218,122,90,103,221,74,204,249,185,223,111,142,190,239,249,23,183,190,67,96,176,142,213,214,214,163,232,161,209,147,126,56,216,194,196,79,223,242,82,209,187,103,241,166,188,87,103,63,181,6,221,72,178,54,75,216,13,43,218,175,10,27,76,54,3,74,
246,65,4,122,96,223,96,239,195,168,103,223,85,49,110,142,239,70,105,190,121,203,97,179,140,188,102,131,26,37,111,210,160,82,104,226,54,204,12,119,149,187,11,71,3,34,2,22,185,85,5,38,47,197,186,59,190,178,189,11,40,43,180,90,146,92,179,106,4,194,215,255,167,181,208,207,49,44,217,158,139,91,222,174,29,155,100,194,176,236,99,242,38,117,106,163,156,2,109,147,10,156,9,6,169,235,14,54,63,114,7,103,133,5,0,87,19,149,191,74,130,226,184,122,20,123,177,43,174,12,182,27,56,146,210,142,155,229,213,190,13,124,
220,239,183,11,219,223,33,134,211,210,212,241,212,226,66,104,221,179,248,31,218,131,110,129,190,22,205,246,185,38,91,111,176,119,225,24,183,71,119,136,8,90,230,255,15,106,112,102,6,59,202,17,1,11,92,143,101,158,255,248,98,174,105,97,107,255,211,22,108,207,69,160,10,226,120,215,13,210,238,78,4,131,84,57,3,179,194,167,103,38,97,208,96,22,247,73,105,71,77,62,110,119,219,174,209,106,74,217,214,90,220,64,223,11,102,55,216,59,240,169,188,174,83,222,187,158,197,71,178,207,127,48,181,255,233,189,189,242,
28,202,186,194,138,83,179,147,48,36,180,163,166,186,208,54,5,205,215,6,147,84,222,87,41,35,217,103,191,179,102,122,46,196,97,74,184,93,104,27,2,42,111,43,148,180,11,190,55,195,12,142,161,90,5,223,27,45,2,239,141,0,0,0,0,25,27,49,65,50,54,98,130,43,45,83,195,100,108,197,4,125,119,244,69,86,90,167,134,79,65,150,199,200,217,138,8,209,194,187,73,250,239,232,138,227,244,217,203,172,181,79,12,181,174,126,77,158,131,45,142,135,152,28,207,74,194,18,81,83,217,35,16,120,244,112,211,97,239,65,146,46,174,215,
85,55,181,230,20,28,152,181,215,5,131,132,150,130,27,152,89,155,0,169,24,176,45,250,219,169,54,203,154,230,119,93,93,255,108,108,28,212,65,63,223,205,90,14,158,149,132,36,162,140,159,21,227,167,178,70,32,190,169,119,97,241,232,225,166,232,243,208,231,195,222,131,36,218,197,178,101,93,93,174,170,68,70,159,235,111,107,204,40,118,112,253,105,57,49,107,174,32,42,90,239,11,7,9,44,18,28,56,109,223,70,54,243,198,93,7,178,237,112,84,113,244,107,101,48,187,42,243,247,162,49,194,182,137,28,145,117,144,7,160,
52,23,159,188,251,14,132,141,186,37,169,222,121,60,178,239,56,115,243,121,255,106,232,72,190,65,197,27,125,88,222,42,60,240,121,79,5,233,98,126,68,194,79,45,135,219,84,28,198,148,21,138,1,141,14,187,64,166,35,232,131,191,56,217,194,56,160,197,13,33,187,244,76,10,150,167,143,19,141,150,206,92,204,0,9,69,215,49,72,110,250,98,139,119,225,83,202,186,187,93,84,163,160,108,21,136,141,63,214,145,150,14,151,222,215,152,80,199,204,169,17,236,225,250,210,245,250,203,147,114,98,215,92,107,121,230,29,64,84,181,
222,89,79,132,159,22,14,18,88,15,21,35,25,36,56,112,218,61,35,65,155,101,253,107,167,124,230,90,230,87,203,9,37,78,208,56,100,1,145,174,163,24,138,159,226,51,167,204,33,42,188,253,96,173,36,225,175,180,63,208,238,159,18,131,45,134,9,178,108,201,72,36,171,208,83,21,234,251,126,70,41,226,101,119,104,47,63,121,246,54,36,72,183,29,9,27,116,4,18,42,53,75,83,188,242,82,72,141,179,121,101,222,112,96,126,239,49,231,230,243,254,254,253,194,191,213,208,145,124,204,203,160,61,131,138,54,250,154,145,7,187,177,
188,84,120,168,167,101,57,59,131,152,75,34,152,169,10,9,181,250,201,16,174,203,136,95,239,93,79,70,244,108,14,109,217,63,205,116,194,14,140,243,90,18,67,234,65,35,2,193,108,112,193,216,119,65,128,151,54,215,71,142,45,230,6,165,0,181,197,188,27,132,132,113,65,138,26,104,90,187,91,67,119,232,152,90,108,217,217,21,45,79,30,12,54,126,95,39,27,45,156,62,0,28,221,185,152,0,18,160,131,49,83,139,174,98,144,146,181,83,209,221,244,197,22,196,239,244,87,239,194,167,148,246,217,150,213,174,7,188,233,183,28,141,
168,156,49,222,107,133,42,239,42,202,107,121,237,211,112,72,172,248,93,27,111,225,70,42,46,102,222,54,225,127,197,7,160,84,232,84,99,77,243,101,34,2,178,243,229,27,169,194,164,48,132,145,103,41,159,160,38,228,197,174,184,253,222,159,249,214,243,204,58,207,232,253,123,128,169,107,188,153,178,90,253,178,159,9,62,171,132,56,127,44,28,36,176,53,7,21,241,30,42,70,50,7,49,119,115,72,112,225,180,81,107,208,245,122,70,131,54,99,93,178,119,203,250,215,78,210,225,230,15,249,204,181,204,224,215,132,141,175,
150,18,74,182,141,35,11,157,160,112,200,132,187,65,137,3,35,93,70,26,56,108,7,49,21,63,196,40,14,14,133,103,79,152,66,126,84,169,3,85,121,250,192,76,98,203,129,129,56,197,31,152,35,244,94,179,14,167,157,170,21,150,220,229,84,0,27,252,79,49,90,215,98,98,153,206,121,83,216,73,225,79,23,80,250,126,86,123,215,45,149,98,204,28,212,45,141,138,19,52,150,187,82,31,187,232,145,6,160,217,208,94,126,243,236,71,101,194,173,108,72,145,110,117,83,160,47,58,18,54,232,35,9,7,169,8,36,84,106,17,63,101,43,150,167,
121,228,143,188,72,165,164,145,27,102,189,138,42,39,242,203,188,224,235,208,141,161,192,253,222,98,217,230,239,35,20,188,225,189,13,167,208,252,38,138,131,63,63,145,178,126,112,208,36,185,105,203,21,248,66,230,70,59,91,253,119,122,220,101,107,181,197,126,90,244,238,83,9,55,247,72,56,118,184,9,174,177,161,18,159,240,138,63,204,51,147,36,253,114,0,0,0,0,1,194,106,55,3,132,212,110,2,70,190,89,7,9,168,220,6,203,194,235,4,141,124,178,5,79,22,133,14,19,81,184,15,209,59,143,13,151,133,214,12,85,239,225,
9,26,249,100,8,216,147,83,10,158,45,10,11,92,71,61,28,38,163,112,29,228,201,71,31,162,119,30,30,96,29,41,27,47,11,172,26,237,97,155,24,171,223,194,25,105,181,245,18,53,242,200,19,247,152,255,17,177,38,166,16,115,76,145,21,60,90,20,20,254,48,35,22,184,142,122,23,122,228,77,56,77,70,224,57,143,44,215,59,201,146,142,58,11,248,185,63,68,238,60,62,134,132,11,60,192,58,82,61,2,80,101,54,94,23,88,55,156,125,111,53,218,195,54,52,24,169,1,49,87,191,132,48,149,213,179,50,211,107,234,51,17,1,221,36,107,229,
144,37,169,143,167,39,239,49,254,38,45,91,201,35,98,77,76,34,160,39,123,32,230,153,34,33,36,243,21,42,120,180,40,43,186,222,31,41,252,96,70,40,62,10,113,45,113,28,244,44,179,118,195,46,245,200,154,47,55,162,173,112,154,141,192,113,88,231,247,115,30,89,174,114,220,51,153,119,147,37,28,118,81,79,43,116,23,241,114,117,213,155,69,126,137,220,120,127,75,182,79,125,13,8,22,124,207,98,33,121,128,116,164,120,66,30,147,122,4,160,202,123,198,202,253,108,188,46,176,109,126,68,135,111,56,250,222,110,250,144,
233,107,181,134,108,106,119,236,91,104,49,82,2,105,243,56,53,98,175,127,8,99,109,21,63,97,43,171,102,96,233,193,81,101,166,215,212,100,100,189,227,102,34,3,186,103,224,105,141,72,215,203,32,73,21,161,23,75,83,31,78,74,145,117,121,79,222,99,252,78,28,9,203,76,90,183,146,77,152,221,165,70,196,154,152,71,6,240,175,69,64,78,246,68,130,36,193,65,205,50,68,64,15,88,115,66,73,230,42,67,139,140,29,84,241,104,80,85,51,2,103,87,117,188,62,86,183,214,9,83,248,192,140,82,58,170,187,80,124,20,226,81,190,126,213,
90,226,57,232,91,32,83,223,89,102,237,134,88,164,135,177,93,235,145,52,92,41,251,3,94,111,69,90,95,173,47,109,225,53,27,128,224,247,113,183,226,177,207,238,227,115,165,217,230,60,179,92,231,254,217,107,229,184,103,50,228,122,13,5,239,38,74,56,238,228,32,15,236,162,158,86,237,96,244,97,232,47,226,228,233,237,136,211,235,171,54,138,234,105,92,189,253,19,184,240,252,209,210,199,254,151,108,158,255,85,6,169,250,26,16,44,251,216,122,27,249,158,196,66,248,92,174,117,243,0,233,72,242,194,131,127,240,132,
61,38,241,70,87,17,244,9,65,148,245,203,43,163,247,141,149,250,246,79,255,205,217,120,93,96,216,186,55,87,218,252,137,14,219,62,227,57,222,113,245,188,223,179,159,139,221,245,33,210,220,55,75,229,215,107,12,216,214,169,102,239,212,239,216,182,213,45,178,129,208,98,164,4,209,160,206,51,211,230,112,106,210,36,26,93,197,94,254,16,196,156,148,39,198,218,42,126,199,24,64,73,194,87,86,204,195,149,60,251,193,211,130,162,192,17,232,149,203,77,175,168,202,143,197,159,200,201,123,198,201,11,17,241,204,68,7,
116,205,134,109,67,207,192,211,26,206,2,185,45,145,175,150,64,144,109,252,119,146,43,66,46,147,233,40,25,150,166,62,156,151,100,84,171,149,34,234,242,148,224,128,197,159,188,199,248,158,126,173,207,156,56,19,150,157,250,121,161,152,181,111,36,153,119,5,19,155,49,187,74,154,243,209,125,141,137,53,48,140,75,95,7,142,13,225,94,143,207,139,105,138,128,157,236,139,66,247,219,137,4,73,130,136,198,35,181,131,154,100,136,130,88,14,191,128,30,176,230,129,220,218,209,132,147,204,84,133,81,166,99,135,23,24,
58,134,213,114,13,169,226,208,160,168,32,186,151,170,102,4,206,171,164,110,249,174,235,120,124,175,41,18,75,173,111,172,18,172,173,198,37,167,241,129,24,166,51,235,47,164,117,85,118,165,183,63,65,160,248,41,196,161,58,67,243,163,124,253,170,162,190,151,157,181,196,115,208,180,6,25,231,182,64,167,190,183,130,205,137,178,205,219,12,179,15,177,59,177,73,15,98,176,139,101,85,187,215,34,104,186,21,72,95,184,83,246,6,185,145,156,49,188,222,138,180,189,28,224,131,191,90,94,218,190,152,52,237,0,0,0,0,184,
188,103,101,170,9,200,139,18,181,175,238,143,98,151,87,55,222,240,50,37,107,95,220,157,215,56,185,197,180,40,239,125,8,79,138,111,189,224,100,215,1,135,1,74,214,191,184,242,106,216,221,224,223,119,51,88,99,16,86,80,25,87,159,232,165,48,250,250,16,159,20,66,172,248,113,223,123,192,200,103,199,167,173,117,114,8,67,205,206,111,38,149,173,127,112,45,17,24,21,63,164,183,251,135,24,208,158,26,207,232,39,162,115,143,66,176,198,32,172,8,122,71,201,160,50,175,62,24,142,200,91,10,59,103,181,178,135,0,208,47,
80,56,105,151,236,95,12,133,89,240,226,61,229,151,135,101,134,135,209,221,58,224,180,207,143,79,90,119,51,40,63,234,228,16,134,82,88,119,227,64,237,216,13,248,81,191,104,240,43,248,161,72,151,159,196,90,34,48,42,226,158,87,79,127,73,111,246,199,245,8,147,213,64,167,125,109,252,192,24,53,159,208,78,141,35,183,43,159,150,24,197,39,42,127,160,186,253,71,25,2,65,32,124,16,244,143,146,168,72,232,247,155,20,88,61,35,168,63,88,49,29,144,182,137,161,247,211,20,118,207,106,172,202,168,15,190,127,7,225,6,195,
96,132,94,160,112,210,230,28,23,183,244,169,184,89,76,21,223,60,209,194,231,133,105,126,128,224,123,203,47,14,195,119,72,107,203,13,15,162,115,177,104,199,97,4,199,41,217,184,160,76,68,111,152,245,252,211,255,144,238,102,80,126,86,218,55,27,14,185,39,77,182,5,64,40,164,176,239,198,28,12,136,163,129,219,176,26,57,103,215,127,43,210,120,145,147,110,31,244,59,38,247,3,131,154,144,102,145,47,63,136,41,147,88,237,180,68,96,84,12,248,7,49,30,77,168,223,166,241,207,186,254,146,223,236,70,46,184,137,84,155,
23,103,236,39,112,2,113,240,72,187,201,76,47,222,219,249,128,48,99,69,231,85,107,63,160,156,211,131,199,249,193,54,104,23,121,138,15,114,228,93,55,203,92,225,80,174,78,84,255,64,246,232,152,37,174,139,136,115,22,55,239,22,4,130,64,248,188,62,39,157,33,233,31,36,153,85,120,65,139,224,215,175,51,92,176,202,237,89,182,59,85,229,209,94,71,80,126,176,255,236,25,213,98,59,33,108,218,135,70,9,200,50,233,231,112,142,142,130,40,237,158,212,144,81,249,177,130,228,86,95,58,88,49,58,167,143,9,131,31,51,110,230,
13,134,193,8,181,58,166,109,189,64,225,164,5,252,134,193,23,73,41,47,175,245,78,74,50,34,118,243,138,158,17,150,152,43,190,120,32,151,217,29,120,244,201,75,192,72,174,46,210,253,1,192,106,65,102,165,247,150,94,28,79,42,57,121,93,159,150,151,229,35,241,242,77,107,25,5,245,215,126,96,231,98,209,142,95,222,182,235,194,9,142,82,122,181,233,55,104,0,70,217,208,188,33,188,136,223,49,234,48,99,86,143,34,214,249,97,154,106,158,4,7,189,166,189,191,1,193,216,173,180,110,54,21,8,9,83,29,114,78,154,165,206,41,
255,183,123,134,17,15,199,225,116,146,16,217,205,42,172,190,168,56,25,17,70,128,165,118,35,216,198,102,117,96,122,1,16,114,207,174,254,202,115,201,155,87,164,241,34,239,24,150,71,253,173,57,169,69,17,94,204,118,77,238,6,206,241,137,99,220,68,38,141,100,248,65,232,249,47,121,81,65,147,30,52,83,38,177,218,235,154,214,191,179,249,198,233,11,69,161,140,25,240,14,98,161,76,105,7,60,155,81,190,132,39,54,219,150,146,153,53,46,46,254,80,38,84,185,153,158,232,222,252,140,93,113,18,52,225,22,119,169,54,46,
206,17,138,73,171,3,63,230,69,187,131,129,32,227,224,145,118,91,92,246,19,73,233,89,253,241,85,62,152,108,130,6,33,212,62,97,68,198,139,206,170,126,55,169,207,214,127,65,56,110,195,38,93,124,118,137,179,196,202,238,214,89,29,214,111,225,161,177,10,243,20,30,228,75,168,121,129,19,203,105,215,171,119,14,178,185,194,161,92,1,126,198,57,156,169,254,128,36,21,153,229,54,160,54,11,142,28,81,110,134,102,22,167,62,218,113,194,44,111,222,44,148,211,185,73,9,4,129,240,177,184,230,149,163,13,73,123,27,177,46,
30,67,210,62,72,251,110,89,45,233,219,246,195,81,103,145,166,204,176,169,31,116,12,206,122,102,185,97,148,222,5,6,241,96,7,0,0,0,8,80,0,0,8,16,0,20,8,115,0,18,7,31,0,0,8,112,0,0,8,48,0,0,9,192,0,16,7,10,0,0,8,96,0,0,8,32,0,0,9,160,0,0,8,0,0,0,8,128,0,0,8,64,0,0,9,224,0,16,7,6,0,0,8,88,0,0,8,24,0,0,9,144,0,19,7,59,0,0,8,120,0,0,8,56,0,0,9,208,0,17,7,17,0,0,8,104,0,0,8,40,0,0,9,176,0,0,8,8,0,0,8,136,0,0,8,72,0,0,9,240,0,16,7,4,0,0,8,84,0,0,8,20,0,21,8,227,0,19,7,43,0,0,8,116,0,0,8,52,0,0,9,200,0,17,
7,13,0,0,8,100,0,0,8,36,0,0,9,168,0,0,8,4,0,0,8,132,0,0,8,68,0,0,9,232,0,16,7,8,0,0,8,92,0,0,8,28,0,0,9,152,0,20,7,83,0,0,8,124,0,0,8,60,0,0,9,216,0,18,7,23,0,0,8,108,0,0,8,44,0,0,9,184,0,0,8,12,0,0,8,140,0,0,8,76,0,0,9,248,0,16,7,3,0,0,8,82,0,0,8,18,0,21,8,163,0,19,7,35,0,0,8,114,0,0,8,50,0,0,9,196,0,17,7,11,0,0,8,98,0,0,8,34,0,0,9,164,0,0,8,2,0,0,8,130,0,0,8,66,0,0,9,228,0,16,7,7,0,0,8,90,0,0,8,26,0,0,9,148,0,20,7,67,0,0,8,122,0,0,8,58,0,0,9,212,0,18,7,19,0,0,8,106,0,0,8,42,0,0,9,180,0,0,8,10,0,
0,8,138,0,0,8,74,0,0,9,244,0,16,7,5,0,0,8,86,0,0,8,22,0,64,8,0,0,19,7,51,0,0,8,118,0,0,8,54,0,0,9,204,0,17,7,15,0,0,8,102,0,0,8,38,0,0,9,172,0,0,8,6,0,0,8,134,0,0,8,70,0,0,9,236,0,16,7,9,0,0,8,94,0,0,8,30,0,0,9,156,0,20,7,99,0,0,8,126,0,0,8,62,0,0,9,220,0,18,7,27,0,0,8,110,0,0,8,46,0,0,9,188,0,0,8,14,0,0,8,142,0,0,8,78,0,0,9,252,0,96,7,0,0,0,8,81,0,0,8,17,0,21,8,131,0,18,7,31,0,0,8,113,0,0,8,49,0,0,9,194,0,16,7,10,0,0,8,97,0,0,8,33,0,0,9,162,0,0,8,1,0,0,8,129,0,0,8,65,0,0,9,226,0,16,7,6,0,0,8,89,
0,0,8,25,0,0,9,146,0,19,7,59,0,0,8,121,0,0,8,57,0,0,9,210,0,17,7,17,0,0,8,105,0,0,8,41,0,0,9,178,0,0,8,9,0,0,8,137,0,0,8,73,0,0,9,242,0,16,7,4,0,0,8,85,0,0,8,21,0,16,8,2,1,19,7,43,0,0,8,117,0,0,8,53,0,0,9,202,0,17,7,13,0,0,8,101,0,0,8,37,0,0,9,170,0,0,8,5,0,0,8,133,0,0,8,69,0,0,9,234,0,16,7,8,0,0,8,93,0,0,8,29,0,0,9,154,0,20,7,83,0,0,8,125,0,0,8,61,0,0,9,218,0,18,7,23,0,0,8,109,0,0,8,45,0,0,9,186,0,0,8,13,0,0,8,141,0,0,8,77,0,0,9,250,0,16,7,3,0,0,8,83,0,0,8,19,0,21,8,195,0,19,7,35,0,0,8,115,0,0,8,
51,0,0,9,198,0,17,7,11,0,0,8,99,0,0,8,35,0,0,9,166,0,0,8,3,0,0,8,131,0,0,8,67,0,0,9,230,0,16,7,7,0,0,8,91,0,0,8,27,0,0,9,150,0,20,7,67,0,0,8,123,0,0,8,59,0,0,9,214,0,18,7,19,0,0,8,107,0,0,8,43,0,0,9,182,0,0,8,11,0,0,8,139,0,0,8,75,0,0,9,246,0,16,7,5,0,0,8,87,0,0,8,23,0,64,8,0,0,19,7,51,0,0,8,119,0,0,8,55,0,0,9,206,0,17,7,15,0,0,8,103,0,0,8,39,0,0,9,174,0,0,8,7,0,0,8,135,0,0,8,71,0,0,9,238,0,16,7,9,0,0,8,95,0,0,8,31,0,0,9,158,0,20,7,99,0,0,8,127,0,0,8,63,0,0,9,222,0,18,7,27,0,0,8,111,0,0,8,47,0,0,
9,190,0,0,8,15,0,0,8,143,0,0,8,79,0,0,9,254,0,96,7,0,0,0,8,80,0,0,8,16,0,20,8,115,0,18,7,31,0,0,8,112,0,0,8,48,0,0,9,193,0,16,7,10,0,0,8,96,0,0,8,32,0,0,9,161,0,0,8,0,0,0,8,128,0,0,8,64,0,0,9,225,0,16,7,6,0,0,8,88,0,0,8,24,0,0,9,145,0,19,7,59,0,0,8,120,0,0,8,56,0,0,9,209,0,17,7,17,0,0,8,104,0,0,8,40,0,0,9,177,0,0,8,8,0,0,8,136,0,0,8,72,0,0,9,241,0,16,7,4,0,0,8,84,0,0,8,20,0,21,8,227,0,19,7,43,0,0,8,116,0,0,8,52,0,0,9,201,0,17,7,13,0,0,8,100,0,0,8,36,0,0,9,169,0,0,8,4,0,0,8,132,0,0,8,68,0,0,9,233,
0,16,7,8,0,0,8,92,0,0,8,28,0,0,9,153,0,20,7,83,0,0,8,124,0,0,8,60,0,0,9,217,0,18,7,23,0,0,8,108,0,0,8,44,0,0,9,185,0,0,8,12,0,0,8,140,0,0,8,76,0,0,9,249,0,16,7,3,0,0,8,82,0,0,8,18,0,21,8,163,0,19,7,35,0,0,8,114,0,0,8,50,0,0,9,197,0,17,7,11,0,0,8,98],"i8",4,B.j);
M([8,34,0,0,9,165,0,0,8,2,0,0,8,130,0,0,8,66,0,0,9,229,0,16,7,7,0,0,8,90,0,0,8,26,0,0,9,149,0,20,7,67,0,0,8,122,0,0,8,58,0,0,9,213,0,18,7,19,0,0,8,106,0,0,8,42,0,0,9,181,0,0,8,10,0,0,8,138,0,0,8,74,0,0,9,245,0,16,7,5,0,0,8,86,0,0,8,22,0,64,8,0,0,19,7,51,0,0,8,118,0,0,8,54,0,0,9,205,0,17,7,15,0,0,8,102,0,0,8,38,0,0,9,173,0,0,8,6,0,0,8,134,0,0,8,70,0,0,9,237,0,16,7,9,0,0,8,94,0,0,8,30,0,0,9,157,0,20,7,99,0,0,8,126,0,0,8,62,0,0,9,221,0,18,7,27,0,0,8,110,0,0,8,46,0,0,9,189,0,0,8,14,0,0,8,142,0,0,8,78,
0,0,9,253,0,96,7,0,0,0,8,81,0,0,8,17,0,21,8,131,0,18,7,31,0,0,8,113,0,0,8,49,0,0,9,195,0,16,7,10,0,0,8,97,0,0,8,33,0,0,9,163,0,0,8,1,0,0,8,129,0,0,8,65,0,0,9,227,0,16,7,6,0,0,8,89,0,0,8,25,0,0,9,147,0,19,7,59,0,0,8,121,0,0,8,57,0,0,9,211,0,17,7,17,0,0,8,105,0,0,8,41,0,0,9,179,0,0,8,9,0,0,8,137,0,0,8,73,0,0,9,243,0,16,7,4,0,0,8,85,0,0,8,21,0,16,8,2,1,19,7,43,0,0,8,117,0,0,8,53,0,0,9,203,0,17,7,13,0,0,8,101,0,0,8,37,0,0,9,171,0,0,8,5,0,0,8,133,0,0,8,69,0,0,9,235,0,16,7,8,0,0,8,93,0,0,8,29,0,0,9,155,
0,20,7,83,0,0,8,125,0,0,8,61,0,0,9,219,0,18,7,23,0,0,8,109,0,0,8,45,0,0,9,187,0,0,8,13,0,0,8,141,0,0,8,77,0,0,9,251,0,16,7,3,0,0,8,83,0,0,8,19,0,21,8,195,0,19,7,35,0,0,8,115,0,0,8,51,0,0,9,199,0,17,7,11,0,0,8,99,0,0,8,35,0,0,9,167,0,0,8,3,0,0,8,131,0,0,8,67,0,0,9,231,0,16,7,7,0,0,8,91,0,0,8,27,0,0,9,151,0,20,7,67,0,0,8,123,0,0,8,59,0,0,9,215,0,18,7,19,0,0,8,107,0,0,8,43,0,0,9,183,0,0,8,11,0,0,8,139,0,0,8,75,0,0,9,247,0,16,7,5,0,0,8,87,0,0,8,23,0,64,8,0,0,19,7,51,0,0,8,119,0,0,8,55,0,0,9,207,0,17,
7,15,0,0,8,103,0,0,8,39,0,0,9,175,0,0,8,7,0,0,8,135,0,0,8,71,0,0,9,239,0,16,7,9,0,0,8,95,0,0,8,31,0,0,9,159,0,20,7,99,0,0,8,127,0,0,8,63,0,0,9,223,0,18,7,27,0,0,8,111,0,0,8,47,0,0,9,191,0,0,8,15,0,0,8,143,0,0,8,79,0,0,9,255,0,16,5,1,0,23,5,1,1,19,5,17,0,27,5,1,16,17,5,5,0,25,5,1,4,21,5,65,0,29,5,1,64,16,5,3,0,24,5,1,2,20,5,33,0,28,5,1,32,18,5,9,0,26,5,1,8,22,5,129,0,64,5,0,0,16,5,2,0,23,5,129,1,19,5,25,0,27,5,1,24,17,5,7,0,25,5,1,6,21,5,97,0,29,5,1,96,16,5,4,0,24,5,1,3,20,5,49,0,28,5,1,48,18,5,13,
0,26,5,1,12,22,5,193,0,64,5,0,0,16,0,17,0,18,0,0,0,8,0,7,0,9,0,6,0,10,0,5,0,11,0,4,0,12,0,3,0,13,0,2,0,14,0,1,0,15,0,3,0,4,0,5,0,6,0,7,0,8,0,9,0,10,0,11,0,13,0,15,0,17,0,19,0,23,0,27,0,31,0,35,0,43,0,51,0,59,0,67,0,83,0,99,0,115,0,131,0,163,0,195,0,227,0,2,1,0,0,0,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,17,0,17,0,17,0,17,0,18,0,18,0,18,0,18,0,19,0,19,0,19,0,19,0,20,0,20,0,20,0,20,0,21,0,21,0,21,0,21,0,16,0,72,0,78,0,1,0,2,0,3,0,4,0,5,0,7,0,9,0,13,0,17,0,25,0,33,0,49,0,65,0,97,0,129,0,193,0,1,1,
129,1,1,2,1,3,1,4,1,6,1,8,1,12,1,16,1,24,1,32,1,48,1,64,1,96,0,0,0,0,16,0,16,0,16,0,16,0,17,0,17,0,18,0,18,0,19,0,19,0,20,0,20,0,21,0,21,0,22,0,22,0,23,0,23,0,24,0,24,0,25,0,25,0,26,0,26,0,27,0,27,0,28,0,28,0,29,0,29,0,64,0,64,0,12,0,8,0,140,0,8,0,76,0,8,0,204,0,8,0,44,0,8,0,172,0,8,0,108,0,8,0,236,0,8,0,28,0,8,0,156,0,8,0,92,0,8,0,220,0,8,0,60,0,8,0,188,0,8,0,124,0,8,0,252,0,8,0,2,0,8,0,130,0,8,0,66,0,8,0,194,0,8,0,34,0,8,0,162,0,8,0,98,0,8,0,226,0,8,0,18,0,8,0,146,0,8,0,82,0,8,0,210,0,8,0,50,0,
8,0,178,0,8,0,114,0,8,0,242,0,8,0,10,0,8,0,138,0,8,0,74,0,8,0,202,0,8,0,42,0,8,0,170,0,8,0,106,0,8,0,234,0,8,0,26,0,8,0,154,0,8,0,90,0,8,0,218,0,8,0,58,0,8,0,186,0,8,0,122,0,8,0,250,0,8,0,6,0,8,0,134,0,8,0,70,0,8,0,198,0,8,0,38,0,8,0,166,0,8,0,102,0,8,0,230,0,8,0,22,0,8,0,150,0,8,0,86,0,8,0,214,0,8,0,54,0,8,0,182,0,8,0,118,0,8,0,246,0,8,0,14,0,8,0,142,0,8,0,78,0,8,0,206,0,8,0,46,0,8,0,174,0,8,0,110,0,8,0,238,0,8,0,30,0,8,0,158,0,8,0,94,0,8,0,222,0,8,0,62,0,8,0,190,0,8,0,126,0,8,0,254,0,8,0,1,0,8,
0,129,0,8,0,65,0,8,0,193,0,8,0,33,0,8,0,161,0,8,0,97,0,8,0,225,0,8,0,17,0,8,0,145,0,8,0,81,0,8,0,209,0,8,0,49,0,8,0,177,0,8,0,113,0,8,0,241,0,8,0,9,0,8,0,137,0,8,0,73,0,8,0,201,0,8,0,41,0,8,0,169,0,8,0,105,0,8,0,233,0,8,0,25,0,8,0,153,0,8,0,89,0,8,0,217,0,8,0,57,0,8,0,185,0,8,0,121,0,8,0,249,0,8,0,5,0,8,0,133,0,8,0,69,0,8,0,197,0,8,0,37,0,8,0,165,0,8,0,101,0,8,0,229,0,8,0,21,0,8,0,149,0,8,0,85,0,8,0,213,0,8,0,53,0,8,0,181,0,8,0,117,0,8,0,245,0,8,0,13,0,8,0,141,0,8,0,77,0,8,0,205,0,8,0,45,0,8,0,173,
0,8,0,109,0,8,0,237,0,8,0,29,0,8,0,157,0,8,0,93,0,8,0,221,0,8,0,61,0,8,0,189,0,8,0,125,0,8,0,253,0,8,0,19,0,9,0,19,1,9,0,147,0,9,0,147,1,9,0,83,0,9,0,83,1,9,0,211,0,9,0,211,1,9,0,51,0,9,0,51,1,9,0,179,0,9,0,179,1,9,0,115,0,9,0,115,1,9,0,243,0,9,0,243,1,9,0,11,0,9,0,11,1,9,0,139,0,9,0,139,1,9,0,75,0,9,0,75,1,9,0,203,0,9,0,203,1,9,0,43,0,9,0,43,1,9,0,171,0,9,0,171,1,9,0,107,0,9,0,107,1,9,0,235,0,9,0,235,1,9,0,27,0,9,0,27,1,9,0,155,0,9,0,155,1,9,0,91,0,9,0,91,1,9,0,219,0,9,0,219,1,9,0,59,0,9,0,59,1,
9,0,187,0,9,0,187,1,9,0,123,0,9,0,123,1,9,0,251,0,9,0,251,1,9,0,7,0,9,0,7,1,9,0,135,0,9,0,135,1,9,0,71,0,9,0,71,1,9,0,199,0,9,0,199,1,9,0,39,0,9,0,39,1,9,0,167,0,9,0,167,1,9,0,103,0,9,0,103,1,9,0,231,0,9,0,231,1,9,0,23,0,9,0,23,1,9,0,151,0,9,0,151,1,9,0,87,0,9,0,87,1,9,0,215,0,9,0,215,1,9,0,55,0,9,0,55,1,9,0,183,0,9,0,183,1,9,0,119,0,9,0,119,1,9,0,247,0,9,0,247,1,9,0,15,0,9,0,15,1,9,0,143,0,9,0,143,1,9,0,79,0,9,0,79,1,9,0,207,0,9,0,207,1,9,0,47,0,9,0,47,1,9,0,175,0,9,0,175,1,9,0,111,0,9,0,111,1,9,
0,239,0,9,0,239,1,9,0,31,0,9,0,31,1,9,0,159,0,9,0,159,1,9,0,95,0,9,0,95,1,9,0,223,0,9,0,223,1,9,0,63,0,9,0,63,1,9,0,191,0,9,0,191,1,9,0,127,0,9,0,127,1,9,0,255,0,9,0,255,1,9,0,0,0,7,0,64,0,7,0,32,0,7,0,96,0,7,0,16,0,7,0,80,0,7,0,48,0,7,0,112,0,7,0,8,0,7,0,72,0,7,0,40,0,7,0,104,0,7,0,24,0,7,0,88,0,7,0,56,0,7,0,120,0,7,0,4,0,7,0,68,0,7,0,36,0,7,0,100,0,7,0,20,0,7,0,84,0,7,0,52,0,7,0,116,0,7,0,3,0,8,0,131,0,8,0,67,0,8,0,195,0,8,0,35,0,8,0,163,0,8,0,99,0,8,0,227,0,8,0,0,0,5,0,16,0,5,0,8,0,5,0,24,0,5,
0,4,0,5,0,20,0,5,0,12,0,5,0,28,0,5,0,2,0,5,0,18,0,5,0,10,0,5,0,26,0,5,0,6,0,5,0,22,0,5,0,14,0,5,0,30,0,5,0,1,0,5,0,17,0,5,0,9,0,5,0,25,0,5,0,5,0,5,0,21,0,5,0,13,0,5,0,29,0,5,0,3,0,5,0,19,0,5,0,11,0,5,0,27,0,5,0,7,0,5,0,23,0,5,0,123,114,101,116,117,114,110,32,90,76,73,66,74,83,95,114,101,97,100,40,36,48,44,32,36,49,44,32,36,50,41,125,0,123,90,76,73,66,74,83,95,119,114,105,116,101,40,36,48,44,32,36,49,44,32,36,50,41,125,0,49,46,50,46,56,0,105,110,99,111,114,114,101,99,116,32,104,101,97,100,101,114,
32,99,104,101,99,107,0,117,110,107,110,111,119,110,32,99,111,109,112,114,101,115,115,105,111,110,32,109,101,116,104,111,100,0,105,110,118,97,108,105,100,32,119,105,110,100,111,119,32,115,105,122,101,0,117,110,107,110,111,119,110,32,104,101,97,100,101,114,32,102,108,97,103,115,32,115,101,116,0,104,101,97,100,101,114,32,99,114,99,32,109,105,115,109,97,116,99,104,0,105,110,118,97,108,105,100,32,98,108,111,99,107,32,116,121,112,101,0,105,110,118,97,108,105,100,32,115,116,111,114,101,100,32,98,108,111,
99,107,32,108,101,110,103,116,104,115,0,116,111,111,32,109,97,110,121,32,108,101,110,103,116,104,32,111,114,32,100,105,115,116,97,110,99,101,32,115,121,109,98,111,108,115,0,105,110,118,97,108,105,100,32,99,111,100,101,32,108,101,110,103,116,104,115,32,115,101,116,0,105,110,118,97,108,105,100,32,98,105,116,32,108,101,110,103,116,104,32,114,101,112,101,97,116,0,105,110,118,97,108,105,100,32,99,111,100,101,32,45,45,32,109,105,115,115,105,110,103,32,101,110,100,45,111,102,45,98,108,111,99,107,0,105,110,
118,97,108,105,100,32,108,105,116,101,114,97,108,47,108,101,110,103,116,104,115,32,115,101,116,0,105,110,118,97,108,105,100,32,100,105,115,116,97,110,99,101,115,32,115,101,116,0,105,110,99,111,114,114,101,99,116,32,100,97,116,97,32,99,104,101,99,107,0,105,110,99,111,114,114,101,99,116,32,108,101,110,103,116,104,32,99,104,101,99,107,0,0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,
12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,
15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,
28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,
19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,
27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15,115,116,114,101,97,109,32,101,114,114,111,114,0,105,110,115,117,102,102,105,99,105,101,110,116,32,109,101,109,111,114,121,0,98,117,102,102,101,114,32,101,114,114,111,114,0,105,110,118,97,108,105,100,32,100,105,115,116,97,110,99,101,32,116,111,111,32,102,97,114,32,98,97,99,107,0,105,110,118,97,108,105,100,32,100,105,115,116,97,110,99,101,32,99,111,100,101,0,105,110,
118,97,108,105,100,32,108,105,116,101,114,97,108,47,108,101,110,103,116,104,32,99,111,100,101,0],"i8",4,B.j+10241);var ua=C,C=C+16;function Y(a){Y.s||(D=ia(),Y.s=!0,assert(B.b),Y.o=B.b,B.b=function(){F("cannot dynamically allocate, sbrk now has control")});var c=D;return 0==a||Y.o(a)?c:4294967295}b._memset=va;b._llvm_bswap_i32=wa;b._pthread_self=xa;b._memcpy=ya;la=z=B.k(C);S=la+ma;D=B.k(S);
b.q={Math:Math,Int8Array:Int8Array,Int16Array:Int16Array,Int32Array:Int32Array,Uint8Array:Uint8Array,Uint16Array:Uint16Array,Uint32Array:Uint32Array,Float32Array:Float32Array,Float64Array:Float64Array,NaN:NaN,Infinity:Infinity};
b.r={abort:F,assert:assert,invoke_iiii:function(a,c,d,e){try{return b.dynCall_iiii(a,c,d,e)}catch(g){if("number"!==typeof g&&"longjmp"!==g)throw g;Z.setThrew(1,0)}},invoke_vii:function(a,c,d){try{b.dynCall_vii(a,c,d)}catch(e){if("number"!==typeof e&&"longjmp"!==e)throw e;Z.setThrew(1,0)}},invoke_iii:function(a,c,d){try{return b.dynCall_iii(a,c,d)}catch(e){if("number"!==typeof e&&"longjmp"!==e)throw e;Z.setThrew(1,0)}},_sbrk:Y,_emscripten_memcpy_big:function(a,c,d){O.set(O.subarray(c,c+d),a);return a},
_abort:function(){b.abort()},_emscripten_asm_const_iiii:function(a,c,d,e){return ta[a](c,d,e)},STACKTOP:z,STACK_MAX:S,tempDoublePtr:ua,ABORT:G};// EMSCRIPTEN_START_ASM
var Z=(function(global,env,buffer) {
"use asm";var a=new global.Int8Array(buffer);var b=new global.Int16Array(buffer);var c=new global.Int32Array(buffer);var d=new global.Uint8Array(buffer);var e=new global.Uint16Array(buffer);var f=new global.Uint32Array(buffer);var g=new global.Float32Array(buffer);var h=new global.Float64Array(buffer);var i=env.STACKTOP|0;var j=env.STACK_MAX|0;var k=env.tempDoublePtr|0;var l=env.ABORT|0;var m=0;var n=0;var o=0;var p=0;var q=global.NaN,r=global.Infinity;var s=0,t=0,u=0,v=0,w=0.0,x=0,y=0,z=0,A=0.0;var B=0;var C=0;var D=0;var E=0;var F=0;var G=0;var H=0;var I=0;var J=0;var K=0;var L=global.Math.floor;var M=global.Math.abs;var N=global.Math.sqrt;var O=global.Math.pow;var P=global.Math.cos;var Q=global.Math.sin;var R=global.Math.tan;var S=global.Math.acos;var T=global.Math.asin;var U=global.Math.atan;var V=global.Math.atan2;var W=global.Math.exp;var X=global.Math.log;var Y=global.Math.ceil;var Z=global.Math.imul;var _=global.Math.min;var $=global.Math.clz32;var aa=env.abort;var ba=env.assert;var ca=env.invoke_iiii;var da=env.invoke_vii;var ea=env.invoke_iii;var fa=env._sbrk;var ga=env._emscripten_memcpy_big;var ha=env._abort;var ia=env._emscripten_asm_const_iiii;var ja=0.0;
// EMSCRIPTEN_START_FUNCS
function na(a){a=a|0;var b=0;b=i;i=i+a|0;i=i+15&-16;return b|0}function oa(){return i|0}function pa(a){a=a|0;i=a}function qa(a,b){a=a|0;b=b|0;i=a;j=b}function ra(a,b){a=a|0;b=b|0;if(!m){m=a;n=b}}function sa(b){b=b|0;a[k>>0]=a[b>>0];a[k+1>>0]=a[b+1>>0];a[k+2>>0]=a[b+2>>0];a[k+3>>0]=a[b+3>>0]}function ta(b){b=b|0;a[k>>0]=a[b>>0];a[k+1>>0]=a[b+1>>0];a[k+2>>0]=a[b+2>>0];a[k+3>>0]=a[b+3>>0];a[k+4>>0]=a[b+4>>0];a[k+5>>0]=a[b+5>>0];a[k+6>>0]=a[b+6>>0];a[k+7>>0]=a[b+7>>0]}function ua(a){a=a|0;B=a}function va(){return B|0}function wa(a){a=a|0;if((c[3507]|0)>>>0>=a>>>0)return;c[3507]=a;Za(c[3508]|0);Za(c[3509]|0);a=c[3507]|0;c[3508]=Ya(a)|0;c[3509]=Ya(a)|0;return}function xa(a,b){a=a|0;b=b|0;var d=0;d=Ya(56)|0;c[d+32>>2]=0;c[d+36>>2]=0;c[d+40>>2]=0;if(!(Da(d,a,8,b*15|0,9,0,12726,56)|0)){b=d;return b|0}Ea(d)|0;b=0;return b|0}function ya(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;c[a+4>>2]=ia(0,a|0,c[3508]|0,b|0)|0;c[a>>2]=c[3508];f=a+16|0;g=a+12|0;e=d|0?4:0;while(1){c[f>>2]=b;c[g>>2]=c[3509];d=Ka(a,e)|0;if((d|0)==-2){d=-2;e=4;break}ia(1,a|0,c[3509]|0,b-(c[f>>2]|0)|0)|0;if(c[f>>2]|0){e=4;break}}if((e|0)==4)return d|0;return 0}function za(a){a=a|0;Ea(a)|0;return}function Aa(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0;k=Ya(56)|0;b=k+32|0;c[b>>2]=0;l=k+36|0;c[l>>2]=0;n=k+40|0;c[n>>2]=0;c[k+4>>2]=0;c[k>>2]=0;d=a*15|0;if(!k){n=0;return n|0}i=k+24|0;c[i>>2]=0;c[b>>2]=1;c[n>>2]=0;c[l>>2]=1;h=Ua(0,1,7116)|0;m=k+28|0;if(!h){b=c[m>>2]|0;if(!b){n=0;return n|0}a=c[l>>2]|0;if(!a){n=0;return n|0}d=c[b+52>>2]|0;if(d){la[a&1](c[n>>2]|0,d);a=c[l>>2]|0;b=c[m>>2]|0}la[a&1](c[n>>2]|0,b);c[m>>2]=0;n=0;return n|0}c[m>>2]=h;c[h+52>>2]=0;g=c[m>>2]|0;do if(g|0){if((a|0)<0){b=0-d|0;f=0}else{if((d|0)>=48)break;b=d&15;f=(d>>4)+1|0}if(b){if((b&-8|0)!=8)break}else b=0;a=g+52|0;d=c[a>>2]|0;e=g+36|0;if(d|0?(c[e>>2]|0)!=(b|0):0){la[c[l>>2]&1](c[n>>2]|0,d);c[a>>2]=0}c[g+8>>2]=f;c[e>>2]=b;b=c[m>>2]|0;if(b|0?(c[b+40>>2]=0,c[b+44>>2]=0,c[b+48>>2]=0,j=c[m>>2]|0,j|0):0){c[j+28>>2]=0;c[k+20>>2]=0;c[k+8>>2]=0;c[i>>2]=0;b=c[j+8>>2]|0;if(b|0)c[k+48>>2]=b&1;c[j>>2]=0;c[j+4>>2]=0;c[j+12>>2]=0;c[j+20>>2]=32768;c[j+32>>2]=0;c[j+56>>2]=0;c[j+60>>2]=0;n=j+1328|0;c[j+108>>2]=n;c[j+80>>2]=n;c[j+76>>2]=n;c[j+7104>>2]=1;c[j+7108>>2]=-1;n=k;return n|0}}while(0);la[c[l>>2]&1](c[n>>2]|0,h);c[m>>2]=0;n=0;return n|0}function Ba(f,g){f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,$=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ja=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0,Ia=0,Ja=0,Ka=0,Ma=0,Na=0,Oa=0,Pa=0,Qa=0,Ra=0,Sa=0,Ta=0,Ua=0,Va=0,Ya=0;Ya=i;i=i+16|0;Ua=Ya;Sa=f+4|0;c[Sa>>2]=ia(0,f|0,c[3508]|0,g|0)|0;c[f>>2]=c[3508];Ta=f+16|0;Va=f+12|0;Ea=f+28|0;Ka=f+24|0;Ma=f+48|0;Na=Ua+1|0;Oa=f+20|0;Pa=Ua+2|0;Qa=Ua+3|0;Ra=f+8|0;Ba=f+44|0;Ca=f+32|0;Da=f+40|0;a:while(1){c[Ta>>2]=g;za=c[3509]|0;c[Va>>2]=za;Aa=c[Ea>>2]|0;j=za;b:do if(!((Aa|0)==0|(za|0)==0)){k=c[f>>2]|0;if((k|0)==0?c[Sa>>2]|0:0){h=-2;P=368;break}h=c[Aa>>2]|0;if((h|0)==11){c[Aa>>2]=12;h=12;j=c[Va>>2]|0;k=c[f>>2]|0;p=c[Ta>>2]|0}else p=g;wa=c[Sa>>2]|0;xa=Aa+60|0;ra=Aa+56|0;ta=Aa+8|0;va=Aa+16|0;R=Aa+32|0;S=Aa+36|0;T=Aa+20|0;ya=Aa+24|0;U=Aa+64|0;V=Aa+12|0;za=Aa+4|0;W=Aa+76|0;X=Aa+84|0;Y=Aa+80|0;Z=Aa+88|0;_=Aa+104|0;$=Aa+96|0;aa=Aa+100|0;ba=Aa+624|0;ca=Aa+1328|0;da=Aa+108|0;Q=ca;ea=Aa+112|0;fa=Aa+752|0;ga=Aa+7108|0;ha=Aa+72|0;ja=Aa+7112|0;la=Aa+68|0;ma=Aa+44|0;na=Aa+7104|0;oa=Aa+48|0;pa=Aa+52|0;sa=Aa+40|0;ua=Aa+28|0;qa=Aa+92|0;q=h;m=c[xa>>2]|0;o=wa;l=c[ra>>2]|0;n=p;r=p;h=0;c:while(1){d:do switch(q|0){case 30:break a;case 28:{h=1;P=347;break c}case 29:{h=-3;break c}case 0:{p=c[ta>>2]|0;if(!p){c[Aa>>2]=12;s=n;break d}while(1){if(m>>>0>=16)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}if((p&2|0)!=0&(l|0)==35615){c[ya>>2]=0;a[Ua>>0]=31;a[Na>>0]=-117;c[ya>>2]=Xa(c[ya>>2]|0,Ua,2)|0;c[Aa>>2]=1;m=0;l=0;s=n;break d}c[va>>2]=0;q=c[R>>2]|0;if(q){c[q+48>>2]=-1;p=c[ta>>2]|0}if(p&1|0?((((l<<8&65280)+(l>>>8)|0)>>>0)%31|0|0)==0:0){if((l&15|0)!=8){c[Ka>>2]=12755;c[Aa>>2]=29;s=n;break d}s=l>>>4;m=m+-4|0;p=(s&15)+8|0;q=c[S>>2]|0;if(q){if(p>>>0>q>>>0){c[Ka>>2]=12782;c[Aa>>2]=29;l=s;s=n;break d}}else c[S>>2]=p;c[T>>2]=1<<p;c[ya>>2]=1;c[Ma>>2]=1;c[Aa>>2]=l>>>12&2^11;m=0;l=0;s=n;break d}c[Ka>>2]=12732;c[Aa>>2]=29;s=n;break}case 1:{while(1){if(m>>>0>=16)break;if(!o){o=0;break c}l=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;k=k+1|0}c[va>>2]=l;if((l&255|0)!=8){c[Ka>>2]=12755;c[Aa>>2]=29;s=n;break d}if(l&57344|0){c[Ka>>2]=12802;c[Aa>>2]=29;s=n;break d}m=c[R>>2]|0;if(!m)m=l;else{c[m>>2]=l>>>8&1;m=c[va>>2]|0}if(m&512|0){a[Ua>>0]=l;a[Na>>0]=l>>>8;c[ya>>2]=Xa(c[ya>>2]|0,Ua,2)|0}c[Aa>>2]=2;m=0;l=0;P=44;break}case 2:{P=44;break}case 3:{P=52;break}case 4:{P=60;break}case 5:{P=71;break}case 6:{p=c[va>>2]|0;P=81;break}case 7:{P=94;break}case 8:{P=107;break}case 9:{while(1){if(m>>>0>=32)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}m=ab(l|0)|0;c[ya>>2]=m;c[Ma>>2]=m;c[Aa>>2]=10;m=0;l=0;P=120;break}case 10:{P=120;break}case 12:case 11:{p=m;P=123;break}case 13:{p=m&-8;l=l>>>(m&7);while(1){if(p>>>0>=32)break;if(!o){m=p;o=0;break c}O=l+(d[k>>0]<<p)|0;p=p+8|0;o=o+-1|0;l=O;k=k+1|0}m=l&65535;if((m|0)==(l>>>16^65535|0)){c[U>>2]=m;c[Aa>>2]=14;m=0;l=0;P=142;break d}else{c[Ka>>2]=12866;c[Aa>>2]=29;m=p;s=n;break d}}case 14:{P=142;break}case 15:{P=143;break}case 16:{while(1){if(m>>>0>=14)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}N=(l&31)+257|0;c[$>>2]=N;O=(l>>>5&31)+1|0;c[aa>>2]=O;p=(l>>>10&15)+4|0;c[qa>>2]=p;l=l>>>14;m=m+-14|0;if(N>>>0>286|O>>>0>30){c[Ka>>2]=12895;c[Aa>>2]=29;s=n;break d}else{c[_>>2]=0;c[Aa>>2]=17;q=0;P=153;break d}}case 17:{q=c[_>>2]|0;p=c[qa>>2]|0;P=153;break}case 18:{P=164;break}case 19:{P=203;break}case 20:{P=204;break}case 21:{q=c[ha>>2]|0;P=283;break}case 22:{P=290;break}case 23:{p=c[ha>>2]|0;P=304;break}case 24:{P=310;break}case 25:{if(!n){n=0;P=347;break c}a[j>>0]=c[U>>2];c[Aa>>2]=20;s=n+-1|0;j=j+1|0;break}case 26:{if(c[ta>>2]|0){while(1){if(m>>>0>=32)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}s=r-n|0;c[Oa>>2]=(c[Oa>>2]|0)+s;c[ua>>2]=(c[ua>>2]|0)+s;if((r|0)!=(n|0)){p=c[ya>>2]|0;q=j+(0-s)|0;if(!(c[va>>2]|0))p=Wa(p,q,s)|0;else p=Xa(p,q,s)|0;c[ya>>2]=p;c[Ma>>2]=p}N=(c[va>>2]|0)==0;O=ab(l|0)|0;if(((N?O:l)|0)==(c[ya>>2]|0)){m=0;l=0;r=n}else{c[Ka>>2]=13069;c[Aa>>2]=29;s=n;r=n;break d}}c[Aa>>2]=27;P=339;break}case 27:{P=339;break}default:{h=-2;P=368;break b}}while(0);do if((P|0)==44){while(1){P=0;if(m>>>0>=32)break;if(!o){o=0;break c}P=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=P;k=k+1|0;P=44}m=c[R>>2]|0;if(m|0)c[m+4>>2]=l;if(c[va>>2]&512|0){a[Ua>>0]=l;a[Na>>0]=l>>>8;a[Pa>>0]=l>>>16;a[Qa>>0]=l>>>24;c[ya>>2]=Xa(c[ya>>2]|0,Ua,4)|0}c[Aa>>2]=3;m=0;l=0;P=52}else if((P|0)==120){if(!(c[V>>2]|0)){P=121;break a}c[ya>>2]=1;c[Ma>>2]=1;c[Aa>>2]=11;p=m;P=123}else if((P|0)==142){c[Aa>>2]=15;P=143}else if((P|0)==153){P=0;while(1){if(q>>>0>=p>>>0){h=q;break}while(1){if(m>>>0>=3)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}O=q+1|0;c[_>>2]=O;b[Aa+112+(e[11104+(q<<1)>>1]<<1)>>1]=l&7;q=O;m=m+-3|0;l=l>>>3}while(1){if(h>>>0>=19)break;O=h+1|0;c[_>>2]=O;b[Aa+112+(e[11104+(h<<1)>>1]<<1)>>1]=0;h=O}c[da>>2]=ca;c[W>>2]=Q;c[X>>2]=7;h=La(0,ea,19,da,X,fa)|0;if(!h){c[_>>2]=0;c[Aa>>2]=18;h=0;P=164;break}else{c[Ka>>2]=12931;c[Aa>>2]=29;s=n;break}}else if((P|0)==339){P=0;if(!(c[ta>>2]|0)){h=o;P=346;break c}if(!(c[va>>2]|0)){h=o;P=346;break c}while(1){if(m>>>0>=32)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}if((l|0)==(c[ua>>2]|0)){m=0;h=o;l=0;P=346;break c}c[Ka>>2]=13090;c[Aa>>2]=29;s=n}while(0);do if((P|0)==52){while(1){P=0;if(m>>>0>=16)break;if(!o){o=0;break c}P=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=P;k=k+1|0;P=52}m=c[R>>2]|0;if(m|0){c[m+8>>2]=l&255;c[(c[R>>2]|0)+12>>2]=l>>>8}if(c[va>>2]&512|0){a[Ua>>0]=l;a[Na>>0]=l>>>8;c[ya>>2]=Xa(c[ya>>2]|0,Ua,2)|0}c[Aa>>2]=4;m=0;l=0;P=60}else if((P|0)==123){P=0;if(!(c[za>>2]|0))m=p;else{c[Aa>>2]=26;m=p&-8;l=l>>>(p&7);s=n;break}while(1){if(m>>>0>=3)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}c[za>>2]=l&1;switch(l>>>1&3|0){case 0:{c[Aa>>2]=13;break}case 1:{c[W>>2]=8928;c[X>>2]=9;c[Y>>2]=10976;c[Z>>2]=5;c[Aa>>2]=19;break}case 2:{c[Aa>>2]=16;break}case 3:{c[Ka>>2]=12847;c[Aa>>2]=29;break}default:{P=133;break a}}m=m+-3|0;l=l>>>3;s=n}else if((P|0)==143){P=0;p=c[U>>2]|0;if(!p){c[Aa>>2]=11;s=n;break}p=p>>>0>o>>>0?o:p;p=p>>>0>n>>>0?n:p;if(!p){P=347;break c}cb(j|0,k|0,p|0)|0;c[U>>2]=(c[U>>2]|0)-p;o=o-p|0;s=n-p|0;k=k+p|0;j=j+p|0}else if((P|0)==164){P=0;e:while(1){u=c[_>>2]|0;v=(c[$>>2]|0)+(c[aa>>2]|0)|0;if(u>>>0>=v>>>0){P=195;break}q=(1<<c[X>>2])+-1|0;s=c[W>>2]|0;while(1){p=s+((l&q)<<2)|0;p=e[p>>1]|e[p+2>>1]<<16;t=p>>>8&255;if(m>>>0>=t>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}p=p>>>16&65535;if((p&65535)<16){c[_>>2]=u+1;b[Aa+112+(u<<1)>>1]=p;m=m-t|0;l=l>>>t;continue}switch(p<<16>>16){case 16:{p=t+2|0;while(1){if(m>>>0>=p>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}l=l>>>t;m=m-t|0;if(!u){P=178;break e}m=m+-2|0;p=(l&3)+3|0;l=l>>>2;q=e[Aa+112+(u+-1<<1)>>1]|0;break}case 17:{p=t+3|0;while(1){if(m>>>0>=p>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}l=l>>>t;m=m-t+-3|0;p=(l&7)+3|0;l=l>>>3;q=0;break}default:{p=t+7|0;while(1){if(m>>>0>=p>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}l=l>>>t;m=m-t+-7|0;p=(l&127)+11|0;l=l>>>7;q=0}}if((u+p|0)>>>0>v>>>0){P=192;break}q=q&65535;while(1){if(!p)continue e;O=c[_>>2]|0;c[_>>2]=O+1;b[Aa+112+(O<<1)>>1]=q;p=p+-1|0}}if((P|0)==178){P=0;c[Ka>>2]=12956;c[Aa>>2]=29;s=n;break}else if((P|0)==192){P=0;c[Ka>>2]=12956;c[Aa>>2]=29;s=n;break}else if((P|0)==195){P=0;if((c[Aa>>2]|0)==29){s=n;break}if(!(b[ba>>1]|0)){c[Ka>>2]=12982;c[Aa>>2]=29;s=n;break}c[da>>2]=ca;c[W>>2]=Q;c[X>>2]=9;h=La(1,ea,c[$>>2]|0,da,X,fa)|0;if(h|0){c[Ka>>2]=13019;c[Aa>>2]=29;s=n;break}c[Y>>2]=c[da>>2];c[Z>>2]=6;h=La(2,Aa+112+(c[$>>2]<<1)|0,c[aa>>2]|0,da,Z,fa)|0;if(!h){c[Aa>>2]=19;h=0;P=203;break}else{c[Ka>>2]=13047;c[Aa>>2]=29;s=n;break}}}while(0);if((P|0)==60){P=0;p=c[va>>2]|0;if(!(p&1024)){p=c[R>>2]|0;if(p)c[p+16>>2]=0}else{while(1){if(m>>>0>=16)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}c[U>>2]=l;m=c[R>>2]|0;if(!m)m=p;else{c[m+20>>2]=l;m=c[va>>2]|0}if(!(m&512)){m=0;l=0}else{a[Ua>>0]=l;a[Na>>0]=l>>>8;c[ya>>2]=Xa(c[ya>>2]|0,Ua,2)|0;m=0;l=0}}c[Aa>>2]=5;P=71}else if((P|0)==203){c[Aa>>2]=20;P=204}do if((P|0)==71){p=c[va>>2]|0;if(p&1024){s=c[U>>2]|0;t=s>>>0>o>>>0?o:s;if(t){q=c[R>>2]|0;if((q|0)!=0?(Fa=c[q+16>>2]|0,(Fa|0)!=0):0){p=(c[q+20>>2]|0)-s|0;P=c[q+24>>2]|0;cb(Fa+p|0,k|0,((p+t|0)>>>0>P>>>0?P-p|0:t)|0)|0;p=c[va>>2]|0}if(p&512|0)c[ya>>2]=Xa(c[ya>>2]|0,k,t)|0;s=(c[U>>2]|0)-t|0;c[U>>2]=s;o=o-t|0;k=k+t|0}if(s){P=347;break c}}c[U>>2]=0;c[Aa>>2]=6;P=81}else if((P|0)==204){P=0;if(!(o>>>0>5&n>>>0>257)){c[ga>>2]=0;q=(1<<c[X>>2])+-1|0;u=c[W>>2]|0;while(1){p=u+((l&q)<<2)|0;p=e[p>>1]|e[p+2>>1]<<16;s=p>>>8;v=s&255;if(v>>>0<=m>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}q=p&255;t=p>>>16;if(q<<24>>24)if((q&255)<16){q=p>>>16;p=(1<<v+(p&255))+-1|0;while(1){t=u+(q+((l&p)>>>v)<<2)|0;t=e[t>>1]|e[t+2>>1]<<16;s=t>>>8;if((v+(s&255)|0)>>>0<=m>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}c[ga>>2]=v;u=v;m=m-v|0;q=t&255;p=t>>>16;l=l>>>v}else{u=0;p=t}else{u=0;q=0;p=t}O=s&255;l=l>>>O;m=m-O|0;c[ga>>2]=u+O;c[U>>2]=p;if(!(q<<24>>24)){c[Aa>>2]=25;s=n;break}if(q&32){c[ga>>2]=-1;c[Aa>>2]=11;s=n;break}if(!(q&64)){q=q&15;c[ha>>2]=q;c[Aa>>2]=21;P=283;break}else{c[Ka>>2]=13998;c[Aa>>2]=29;s=n;break}}c[Va>>2]=j;c[Ta>>2]=n;c[f>>2]=k;c[Sa>>2]=o;c[ra>>2]=l;c[xa>>2]=m;x=c[Ea>>2]|0;k=(c[f>>2]|0)+-1|0;L=k+((c[Sa>>2]|0)+-5)|0;j=(c[Va>>2]|0)+-1|0;F=c[Ta>>2]|0;M=j+(F+-257)|0;y=c[x+40>>2]|0;z=c[x+44>>2]|0;A=c[x+48>>2]|0;N=x+56|0;O=x+60|0;B=c[x+76>>2]|0;C=c[x+80>>2]|0;D=(1<<c[x+84>>2])+-1|0;E=(1<<c[x+88>>2])+-1|0;F=j+(F-r)|0;G=x+7104|0;H=(c[x+52>>2]|0)+-1|0;I=(A|0)==0;J=y+A|0;K=F-A|0;n=c[O>>2]|0;l=c[N>>2]|0;f:while(1){if(n>>>0<15){P=k+2|0;m=n+16|0;l=l+(d[k+1>>0]<<n)+(d[P>>0]<<n+8)|0;k=P}else m=n;n=l&D;while(1){n=B+(n<<2)|0;n=e[n>>1]|e[n+2>>1]<<16;p=n>>>16;P=n>>>8&255;l=l>>>P;m=m-P|0;if(!((n&255)<<24>>24)){P=210;break}if(n&16|0){P=212;break}if(n&64|0){P=259;break f}n=p+(l&(1<<(n&255))+-1)|0}do if((P|0)==210){P=0;j=j+1|0;a[j>>0]=p}else if((P|0)==212){P=0;q=n&15;if(!q)o=l;else{if(m>>>0<q>>>0){k=k+1|0;n=m+8|0;l=l+(d[k>>0]<<m)|0}else n=m;m=n-q|0;o=l>>>q;p=p+(l&(1<<q)+-1)|0}if(m>>>0<15){q=k+2|0;n=m+16|0;l=o+(d[k+1>>0]<<m)+(d[q>>0]<<m+8)|0}else{n=m;l=o;q=k}k=l&E;m=n;while(1){k=C+(k<<2)|0;k=e[k>>1]|e[k+2>>1]<<16;v=k>>>16;w=k>>>8&255;l=l>>>w;m=m-w|0;if(k&16|0)break;if(k&64|0){P=256;break f}k=v+(l&(1<<(k&255))+-1)|0}o=k&15;if(m>>>0<o>>>0){k=q+1|0;l=l+(d[k>>0]<<m)|0;n=m+8|0;if(n>>>0<o>>>0){k=q+2|0;m=m+16|0;l=l+(d[k>>0]<<n)|0}else m=n}else k=q;u=l&(1<<o)+-1;w=v+u|0;l=l>>>o;m=m-o|0;t=j;n=t-F|0;if(w>>>0<=n>>>0){q=j+(0-w)|0;o=j;while(1){a[o+1>>0]=a[q+1>>0]|0;a[o+2>>0]=a[q+2>>0]|0;n=q+3|0;j=o+3|0;a[j>>0]=a[n>>0]|0;p=p+-3|0;if(p>>>0<=2)break;else{q=n;o=j}}if(!p)break;j=o+4|0;a[j>>0]=a[q+4>>0]|0;if(p>>>0<=1)break;j=o+5|0;a[j>>0]=a[q+5>>0]|0;break}o=w-n|0;if(o>>>0>z>>>0?c[G>>2]|0:0){P=226;break f}do if(I){q=H+(y-o)|0;if(p>>>0>o>>>0){n=p-o|0;s=u+v-t|0;p=j;do{q=q+1|0;p=p+1|0;a[p>>0]=a[q>>0]|0;o=o+-1|0}while((o|0)!=0);j=j+F+s|0;q=j+(0-w)|0}else n=p}else{if(A>>>0>=o>>>0){q=H+(A-o)|0;if(p>>>0<=o>>>0){n=p;break}n=p-o|0;s=u+v-t|0;p=j;do{q=q+1|0;p=p+1|0;a[p>>0]=a[q>>0]|0;o=o+-1|0}while((o|0)!=0);j=j+F+s|0;q=j+(0-w)|0;break}q=H+(J-o)|0;o=o-A|0;if(p>>>0>o>>>0){n=p-o|0;s=u+v-t|0;p=j;do{q=q+1|0;p=p+1|0;a[p>>0]=a[q>>0]|0;o=o+-1|0}while((o|0)!=0);o=j+K+s|0;if(n>>>0<=A>>>0){q=H;j=o;break}n=n-A|0;p=u+v-t|0;q=H;s=A;do{q=q+1|0;o=o+1|0;a[o>>0]=a[q>>0]|0;s=s+-1|0}while((s|0)!=0);j=j+F+p|0;q=j+(0-w)|0}else n=p}while(0);while(1){if(n>>>0<=2)break;a[j+1>>0]=a[q+1>>0]|0;a[j+2>>0]=a[q+2>>0]|0;v=q+3|0;w=j+3|0;a[w>>0]=a[v>>0]|0;q=v;n=n+-3|0;j=w}if(n){o=j+1|0;a[o>>0]=a[q+1>>0]|0;if(n>>>0>1){j=j+2|0;a[j>>0]=a[q+2>>0]|0}else j=o}}while(0);if(k>>>0<L>>>0&j>>>0<M>>>0)n=m;else break}do if((P|0)==226){P=0;c[Ka>>2]=13946;c[x>>2]=29}else if((P|0)==256){P=0;c[Ka>>2]=13976;c[x>>2]=29;k=q}else if((P|0)==259){P=0;if(!(n&32)){c[Ka>>2]=13998;c[x>>2]=29;break}else{c[x>>2]=11;break}}while(0);n=m>>>3;k=k+(0-n)|0;n=m-(n<<3)|0;c[f>>2]=k+1;c[Va>>2]=j+1;c[Sa>>2]=(k>>>0<L>>>0?L-k|0:L-k|0)+5;c[Ta>>2]=(j>>>0<M>>>0?M-j|0:M-j|0)+257;c[N>>2]=l&(1<<n)+-1;c[O>>2]=n;j=c[Va>>2]|0;n=c[Ta>>2]|0;k=c[f>>2]|0;o=c[Sa>>2]|0;l=c[ra>>2]|0;m=c[xa>>2]|0;if((c[Aa>>2]|0)==11){c[ga>>2]=-1;s=n}else s=n}while(0);if((P|0)==81){if(!(p&2048)){p=c[R>>2]|0;if(p)c[p+28>>2]=0}else{if(!o){o=0;P=347;break}else q=0;do{s=q;q=q+1|0;s=a[k+s>>0]|0;p=c[R>>2]|0;if((p|0?(Ga=p+28|0,c[Ga>>2]|0):0)?(Ha=c[U>>2]|0,Ha>>>0<(c[p+32>>2]|0)>>>0):0){c[U>>2]=Ha+1;a[(c[Ga>>2]|0)+Ha>>0]=s}}while(s<<24>>24!=0&o>>>0>q>>>0);if(c[va>>2]&512|0)c[ya>>2]=Xa(c[ya>>2]|0,k,q)|0;o=o-q|0;k=k+q|0;if(s<<24>>24){P=347;break}}c[U>>2]=0;c[Aa>>2]=7;P=94}else if((P|0)==283){P=0;if(!q)p=c[U>>2]|0;else{while(1){if(m>>>0>=q>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}p=(c[U>>2]|0)+(l&(1<<q)+-1)|0;c[U>>2]=p;c[ga>>2]=(c[ga>>2]|0)+q;m=m-q|0;l=l>>>q}c[ja>>2]=p;c[Aa>>2]=22;P=290}do if((P|0)==94){if(!(c[va>>2]&4096)){p=c[R>>2]|0;if(p)c[p+36>>2]=0}else{if(!o){o=0;P=347;break c}else q=0;do{s=q;q=q+1|0;s=a[k+s>>0]|0;p=c[R>>2]|0;if((p|0?(Ia=p+36|0,c[Ia>>2]|0):0)?(Ja=c[U>>2]|0,Ja>>>0<(c[p+40>>2]|0)>>>0):0){c[U>>2]=Ja+1;a[(c[Ia>>2]|0)+Ja>>0]=s}}while(s<<24>>24!=0&o>>>0>q>>>0);if(c[va>>2]&512|0)c[ya>>2]=Xa(c[ya>>2]|0,k,q)|0;o=o-q|0;k=k+q|0;if(s<<24>>24){P=347;break c}}c[Aa>>2]=8;P=107}else if((P|0)==290){P=0;p=(1<<c[Z>>2])+-1|0;u=c[Y>>2]|0;while(1){s=u+((l&p)<<2)|0;s=e[s>>1]|e[s+2>>1]<<16;q=s>>>8;v=q&255;if(v>>>0<=m>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}p=s&255;if((p&255)<16){t=s>>>16;p=(1<<v+(s&255))+-1|0;while(1){s=u+(t+((l&p)>>>v)<<2)|0;s=e[s>>1]|e[s+2>>1]<<16;q=s>>>8;if((v+(q&255)|0)>>>0<=m>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}t=(c[ga>>2]|0)+v|0;c[ga>>2]=t;m=m-v|0;p=s&255;l=l>>>v}else t=c[ga>>2]|0;O=q&255;l=l>>>O;m=m-O|0;c[ga>>2]=t+O;if(!(p&64)){c[la>>2]=s>>>16;p=p&15;c[ha>>2]=p;c[Aa>>2]=23;P=304;break}else{c[Ka>>2]=13976;c[Aa>>2]=29;s=n;break}}while(0);do if((P|0)==107){P=0;q=c[va>>2]|0;if(q&512){while(1){if(m>>>0>=16)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}if((l|0)==(c[ya>>2]&65535|0)){m=0;l=0}else{c[Ka>>2]=12827;c[Aa>>2]=29;s=n;break}}p=c[R>>2]|0;if(p|0){c[p+44>>2]=q>>>9&1;c[(c[R>>2]|0)+48>>2]=1}c[ya>>2]=0;c[Ma>>2]=0;c[Aa>>2]=11;s=n}else if((P|0)==304){P=0;if(p){while(1){if(m>>>0>=p>>>0)break;if(!o){o=0;break c}O=l+(d[k>>0]<<m)|0;m=m+8|0;o=o+-1|0;l=O;k=k+1|0}c[la>>2]=(c[la>>2]|0)+(l&(1<<p)+-1);c[ga>>2]=(c[ga>>2]|0)+p;m=m-p|0;l=l>>>p}c[Aa>>2]=24;P=310}while(0);do if((P|0)==310){P=0;if(!n){n=0;P=347;break c}p=r-n|0;q=c[la>>2]|0;if(q>>>0>p>>>0){p=q-p|0;if(p>>>0>(c[ma>>2]|0)>>>0?c[na>>2]|0:0){c[Ka>>2]=13946;c[Aa>>2]=29;s=n;break}q=c[oa>>2]|0;if(p>>>0>q>>>0){p=p-q|0;s=p;p=(c[pa>>2]|0)+((c[sa>>2]|0)-p)|0}else{s=p;p=(c[pa>>2]|0)+(q-p)|0}O=c[U>>2]|0;t=O;s=s>>>0>O>>>0?O:s}else{s=c[U>>2]|0;t=s;p=j+(0-q)|0}s=s>>>0>n>>>0?n:s;c[U>>2]=t-s;q=s;while(1){O=j;j=j+1|0;a[O>>0]=a[p>>0]|0;q=q+-1|0;if(!q)break;else p=p+1|0}n=n-s|0;if(!(c[U>>2]|0)){c[Aa>>2]=20;s=n}else s=n}while(0);q=c[Aa>>2]|0;n=s}if((P|0)==346){P=0;c[Aa>>2]=28;o=h;h=1}else if((P|0)==347)P=0;c[Va>>2]=j;c[Ta>>2]=n;c[f>>2]=k;c[Sa>>2]=o;c[ra>>2]=l;c[xa>>2]=m;j=c[Ta>>2]|0;if(!(c[sa>>2]|0)){if((r|0)!=(j|0)?(c[Aa>>2]|0)>>>0<29:0)P=351}else P=351;do if((P|0)==351){P=0;p=c[Va>>2]|0;q=r-j|0;n=c[Ea>>2]|0;o=n+52|0;j=c[o>>2]|0;if(!j){j=ka[c[Ca>>2]&1](c[Da>>2]|0,1<<c[n+36>>2],1)|0;c[o>>2]=j;if(!j){P=361;break a}}m=n+40|0;k=c[m>>2]|0;if(!k){k=1<<c[n+36>>2];c[m>>2]=k;c[n+48>>2]=0;c[n+44>>2]=0}if(k>>>0<=q>>>0){cb(j|0,p+(0-k)|0,k|0)|0;c[n+48>>2]=0;c[n+44>>2]=c[m>>2];break}l=n+48|0;ra=c[l>>2]|0;sa=k-ra|0;sa=sa>>>0>q>>>0?q:sa;cb(j+ra|0,p+(0-q)|0,sa|0)|0;j=q-sa|0;if((q|0)!=(sa|0)){cb(c[o>>2]|0,p+(0-j)|0,j|0)|0;c[l>>2]=j;c[n+44>>2]=c[m>>2];break}j=(c[l>>2]|0)+q|0;c[l>>2]=j;sa=c[m>>2]|0;c[l>>2]=(j|0)==(sa|0)?0:j;j=n+44|0;k=c[j>>2]|0;if(k>>>0<sa>>>0)c[j>>2]=k+q}while(0);m=c[Sa>>2]|0;n=c[Ta>>2]|0;l=r-n|0;c[Ra>>2]=(c[Ra>>2]|0)+(wa-m);c[Oa>>2]=(c[Oa>>2]|0)+l;c[ua>>2]=(c[ua>>2]|0)+l;if(!((c[ta>>2]|0)==0|(r|0)==(n|0))){j=c[ya>>2]|0;k=(c[Va>>2]|0)+(0-l)|0;if(!(c[va>>2]|0))j=Wa(j,k,l)|0;else j=Xa(j,k,l)|0;c[ya>>2]=j;c[Ma>>2]=j}Aa=c[Aa>>2]|0;c[Ba>>2]=(c[xa>>2]|0)+(c[za>>2]|0?64:0)+((Aa|0)==11?128:0)+((Aa|0)==19|(Aa|0)==14?256:0);if((wa|0)==(m|0)&(r|0)==(n|0)&(h|0)==0){h=-5;P=368}else switch(h|0){case 2:{P=372;break a}case -4:case -3:{P=373;break a}default:{}}}else{h=-2;P=368}while(0);if((P|0)==368)P=0;ia(1,f|0,c[3509]|0,g-(c[Ta>>2]|0)|0)|0;if(c[Ta>>2]|0){P=373;break}}if((P|0)==121){c[Va>>2]=j;c[Ta>>2]=n;c[f>>2]=k;c[Sa>>2]=o;c[ra>>2]=l;c[xa>>2]=m;f=-3;i=Ya;return f|0}else if((P|0)!=133)if((P|0)==361)c[Aa>>2]=30;else if((P|0)==372){f=-3;i=Ya;return f|0}else if((P|0)==373){i=Ya;return h|0}f=-4;i=Ya;return f|0}function Ca(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;if(!a)return;g=a+28|0;b=c[g>>2]|0;if(!b)return;e=a+36|0;d=c[e>>2]|0;if(!d)return;f=c[b+52>>2]|0;a=a+40|0;if(f){la[d&1](c[a>>2]|0,f);d=c[e>>2]|0;b=c[g>>2]|0}la[d&1](c[a>>2]|0,b);c[g>>2]=0;return}function Da(d,f,g,h,i,j,k,l){d=d|0;f=f|0;g=g|0;h=h|0;i=i|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0,q=0,r=0,s=0;if(!k){d=-6;return d|0}if(!((a[k>>0]|0)==49&(l|0)==56)){d=-6;return d|0}if(!d){d=-2;return d|0}p=d+24|0;c[p>>2]=0;q=d+32|0;l=c[q>>2]|0;if(!l){c[q>>2]=1;c[d+40>>2]=0;l=1}o=d+36|0;if(!(c[o>>2]|0))c[o>>2]=1;n=(f|0)==-1?6:f;if((h|0)<0){k=0-h|0;m=0}else{m=(h|0)>15;k=m?h+-16|0:h;m=m?2:1}if(j>>>0>4|(n>>>0>9|((k&-8|0)!=8|((g|0)!=8|(i+-1|0)>>>0>8)))){d=-2;return d|0}k=(k|0)==8?9:k;f=d+40|0;h=ka[l&1](c[f>>2]|0,1,5828)|0;if(!h){d=-4;return d|0}g=d+28|0;c[g>>2]=h;c[h>>2]=d;c[h+24>>2]=m;c[h+28>>2]=0;c[h+48>>2]=k;r=1<<k;m=h+44|0;c[m>>2]=r;c[h+52>>2]=r+-1;s=i+7|0;c[h+80>>2]=s;s=1<<s;l=h+76|0;c[l>>2]=s;c[h+84>>2]=s+-1;c[h+88>>2]=((i+9|0)>>>0)/3|0;s=h+56|0;c[s>>2]=ka[c[q>>2]&1](c[f>>2]|0,r,2)|0;r=h+64|0;c[r>>2]=ka[c[q>>2]&1](c[f>>2]|0,c[m>>2]|0,2)|0;m=h+68|0;c[m>>2]=ka[c[q>>2]&1](c[f>>2]|0,c[l>>2]|0,2)|0;c[h+5824>>2]=0;l=1<<i+6;k=h+5788|0;c[k>>2]=l;l=ka[c[q>>2]&1](c[f>>2]|0,l,4)|0;c[h+8>>2]=l;k=c[k>>2]|0;c[h+12>>2]=k<<2;if((c[s>>2]|0?c[r>>2]|0:0)?!((c[m>>2]|0)==0|(l|0)==0):0){c[h+5796>>2]=l+(k>>>1<<1);c[h+5784>>2]=l+(k*3|0);c[h+132>>2]=n;c[h+136>>2]=j;a[h+36>>0]=8;f=c[g>>2]|0;if(!f){s=-2;return s|0}if(!(c[q>>2]|0)){s=-2;return s|0}if(!(c[o>>2]|0)){s=-2;return s|0}c[d+20>>2]=0;c[d+8>>2]=0;c[p>>2]=0;c[d+44>>2]=2;c[f+20>>2]=0;c[f+16>>2]=c[f+8>>2];k=f+24|0;l=c[k>>2]|0;if((l|0)<0){l=0-l|0;c[k>>2]=l}c[f+4>>2]=l|0?42:113;c[d+48>>2]=(l|0)!=2&1;c[f+40>>2]=0;c[f+2840>>2]=f+148;c[f+2848>>2]=128;c[f+2852>>2]=f+2440;c[f+2860>>2]=264;c[f+2864>>2]=f+2684;c[f+2872>>2]=404;b[f+5816>>1]=0;c[f+5820>>2]=0;l=0;while(1){if((l|0)==286){l=0;break}b[f+148+(l<<2)>>1]=0;l=l+1|0}while(1){if((l|0)==30){l=0;break}b[f+2440+(l<<2)>>1]=0;l=l+1|0}while(1){if((l|0)==19)break;b[f+2684+(l<<2)>>1]=0;l=l+1|0}b[f+1172>>1]=1;c[f+5804>>2]=0;c[f+5800>>2]=0;c[f+5808>>2]=0;c[f+5792>>2]=0;s=c[g>>2]|0;c[s+60>>2]=c[s+44>>2]<<1;r=s+76|0;d=s+68|0;b[(c[d>>2]|0)+((c[r>>2]|0)+-1<<1)>>1]=0;$a(c[d>>2]|0,0,(c[r>>2]<<1)+-2|0)|0;r=c[s+132>>2]|0;c[s+128>>2]=e[8+(r*12|0)+2>>1];c[s+140>>2]=e[8+(r*12|0)>>1];c[s+144>>2]=e[8+(r*12|0)+4>>1];c[s+124>>2]=e[8+(r*12|0)+6>>1];c[s+108>>2]=0;c[s+92>>2]=0;c[s+116>>2]=0;c[s+5812>>2]=0;c[s+120>>2]=2;c[s+96>>2]=2;c[s+104>>2]=0;c[s+72>>2]=0;s=0;return s|0}c[h+4>>2]=666;c[p>>2]=13913;Ea(d)|0;s=-4;return s|0}function Ea(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;if(!a){g=-2;return g|0}f=a+28|0;b=c[f>>2]|0;if(!b){g=-2;return g|0}g=c[b+4>>2]|0;switch(g|0){case 666:case 113:case 103:case 91:case 73:case 69:case 42:break;default:{g=-2;return g|0}}d=c[b+8>>2]|0;if(d){la[c[a+36>>2]&1](c[a+40>>2]|0,d);b=c[f>>2]|0}d=c[b+68>>2]|0;if(d){la[c[a+36>>2]&1](c[a+40>>2]|0,d);b=c[f>>2]|0}d=c[b+64>>2]|0;if(d){la[c[a+36>>2]&1](c[a+40>>2]|0,d);b=c[f>>2]|0}d=c[b+56>>2]|0;if(!d){e=a+40|0;d=a+36|0}else{b=a+36|0;e=a+40|0;la[c[b>>2]&1](c[e>>2]|0,d);d=b;b=c[f>>2]|0}la[c[d>>2]&1](c[e>>2]|0,b);c[f>>2]=0;g=(g|0)==113?-3:0;return g|0}function Fa(d,f){d=d|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;l=(c[d+12>>2]|0)+-5|0;l=l>>>0<65535?l:65535;n=d+116|0;r=d+108|0;s=d+92|0;q=d+56|0;p=d+44|0;while(1){g=c[n>>2]|0;if(g>>>0<2){Ga(d);g=c[n>>2]|0;h=(g|0)==0;if(!((f|0)!=0|h^1)){g=0;h=55;break}if(h){h=30;break}}g=(c[r>>2]|0)+g|0;c[r>>2]=g;c[n>>2]=0;i=c[s>>2]|0;h=i+l|0;if(!((g|0)!=0&g>>>0<h>>>0)){c[n>>2]=g-h;c[r>>2]=h;if((i|0)>-1)g=(c[q>>2]|0)+i|0;else g=0;Oa(d,g,l,0);c[s>>2]=c[r>>2];j=c[d>>2]|0;k=c[j+28>>2]|0;g=k+5820|0;h=c[g>>2]|0;do if((h|0)!=16)if((h|0)>7){i=k+5816|0;v=b[i>>1]&255;h=k+20|0;u=c[h>>2]|0;c[h>>2]=u+1;a[(c[k+8>>2]|0)+u>>0]=v;b[i>>1]=(e[i>>1]|0)>>>8;c[g>>2]=(c[g>>2]|0)+-8;break}else{h=k+20|0;break}else{v=k+5816|0;u=b[v>>1]&255;h=k+20|0;w=c[h>>2]|0;c[h>>2]=w+1;i=k+8|0;a[(c[i>>2]|0)+w>>0]=u;w=(e[v>>1]|0)>>>8&255;u=c[h>>2]|0;c[h>>2]=u+1;a[(c[i>>2]|0)+u>>0]=w;b[v>>1]=0;c[g>>2]=0}while(0);g=c[h>>2]|0;i=j+16|0;w=c[i>>2]|0;g=g>>>0>w>>>0?w:g;if(g|0?(w=j+12|0,o=k+16|0,cb(c[w>>2]|0,c[o>>2]|0,g|0)|0,c[w>>2]=(c[w>>2]|0)+g,c[o>>2]=(c[o>>2]|0)+g,w=j+20|0,c[w>>2]=(c[w>>2]|0)+g,c[i>>2]=(c[i>>2]|0)-g,w=c[h>>2]|0,c[h>>2]=w-g,(w|0)==(g|0)):0)c[o>>2]=c[k+8>>2];if(!(c[(c[d>>2]|0)+16>>2]|0)){g=0;h=55;break}g=c[r>>2]|0;i=c[s>>2]|0}h=g-i|0;if(h>>>0<((c[p>>2]|0)+-262|0)>>>0)continue;if((i|0)>-1)g=(c[q>>2]|0)+i|0;else g=0;Oa(d,g,h,0);c[s>>2]=c[r>>2];j=c[d>>2]|0;k=c[j+28>>2]|0;g=k+5820|0;h=c[g>>2]|0;do if((h|0)!=16)if((h|0)>7){w=k+5816|0;u=b[w>>1]&255;h=k+20|0;v=c[h>>2]|0;c[h>>2]=v+1;a[(c[k+8>>2]|0)+v>>0]=u;b[w>>1]=(e[w>>1]|0)>>>8;c[g>>2]=(c[g>>2]|0)+-8;break}else{h=k+20|0;break}else{w=k+5816|0;v=b[w>>1]&255;h=k+20|0;i=c[h>>2]|0;c[h>>2]=i+1;u=k+8|0;a[(c[u>>2]|0)+i>>0]=v;i=(e[w>>1]|0)>>>8&255;v=c[h>>2]|0;c[h>>2]=v+1;a[(c[u>>2]|0)+v>>0]=i;b[w>>1]=0;c[g>>2]=0}while(0);g=c[h>>2]|0;i=j+16|0;w=c[i>>2]|0;g=g>>>0>w>>>0?w:g;if(g|0?(w=j+12|0,m=k+16|0,cb(c[w>>2]|0,c[m>>2]|0,g|0)|0,c[w>>2]=(c[w>>2]|0)+g,c[m>>2]=(c[m>>2]|0)+g,w=j+20|0,c[w>>2]=(c[w>>2]|0)+g,c[i>>2]=(c[i>>2]|0)-g,w=c[h>>2]|0,c[h>>2]=w-g,(w|0)==(g|0)):0)c[m>>2]=c[k+8>>2];if(!(c[(c[d>>2]|0)+16>>2]|0)){g=0;h=55;break}}if((h|0)==30){c[d+5812>>2]=0;if((f|0)==4){h=c[s>>2]|0;if((h|0)>-1)g=(c[q>>2]|0)+h|0;else g=0;Oa(d,g,(c[r>>2]|0)-h|0,1);c[s>>2]=c[r>>2];k=c[d>>2]|0;l=c[k+28>>2]|0;g=l+5820|0;h=c[g>>2]|0;do if((h|0)!=16)if((h|0)>7){w=l+5816|0;u=b[w>>1]&255;h=l+20|0;v=c[h>>2]|0;c[h>>2]=v+1;a[(c[l+8>>2]|0)+v>>0]=u;b[w>>1]=(e[w>>1]|0)>>>8;c[g>>2]=(c[g>>2]|0)+-8;break}else{h=l+20|0;break}else{w=l+5816|0;v=b[w>>1]&255;h=l+20|0;t=c[h>>2]|0;c[h>>2]=t+1;u=l+8|0;a[(c[u>>2]|0)+t>>0]=v;t=(e[w>>1]|0)>>>8&255;v=c[h>>2]|0;c[h>>2]=v+1;a[(c[u>>2]|0)+v>>0]=t;b[w>>1]=0;c[g>>2]=0}while(0);g=c[h>>2]|0;i=k+16|0;w=c[i>>2]|0;g=g>>>0>w>>>0?w:g;if(!g){w=c[d>>2]|0;w=w+16|0;w=c[w>>2]|0;w=(w|0)==0;w=w?2:3;return w|0}w=k+12|0;j=l+16|0;cb(c[w>>2]|0,c[j>>2]|0,g|0)|0;c[w>>2]=(c[w>>2]|0)+g;c[j>>2]=(c[j>>2]|0)+g;w=k+20|0;c[w>>2]=(c[w>>2]|0)+g;c[i>>2]=(c[i>>2]|0)-g;w=c[h>>2]|0;c[h>>2]=w-g;if((w|0)!=(g|0)){w=c[d>>2]|0;w=w+16|0;w=c[w>>2]|0;w=(w|0)==0;w=w?2:3;return w|0}c[j>>2]=c[l+8>>2];w=c[d>>2]|0;w=w+16|0;w=c[w>>2]|0;w=(w|0)==0;w=w?2:3;return w|0}h=c[r>>2]|0;i=c[s>>2]|0;if((h|0)>(i|0)){if((i|0)>-1)g=(c[q>>2]|0)+i|0;else g=0;Oa(d,g,h-i|0,0);c[s>>2]=c[r>>2];j=c[d>>2]|0;k=c[j+28>>2]|0;g=k+5820|0;h=c[g>>2]|0;do if((h|0)!=16)if((h|0)>7){w=k+5816|0;u=b[w>>1]&255;h=k+20|0;v=c[h>>2]|0;c[h>>2]=v+1;a[(c[k+8>>2]|0)+v>>0]=u;b[w>>1]=(e[w>>1]|0)>>>8;c[g>>2]=(c[g>>2]|0)+-8;break}else{h=k+20|0;break}else{w=k+5816|0;v=b[w>>1]&255;h=k+20|0;s=c[h>>2]|0;c[h>>2]=s+1;u=k+8|0;a[(c[u>>2]|0)+s>>0]=v;s=(e[w>>1]|0)>>>8&255;v=c[h>>2]|0;c[h>>2]=v+1;a[(c[u>>2]|0)+v>>0]=s;b[w>>1]=0;c[g>>2]=0}while(0);g=c[h>>2]|0;i=j+16|0;w=c[i>>2]|0;g=g>>>0>w>>>0?w:g;if(g|0?(w=j+12|0,t=k+16|0,cb(c[w>>2]|0,c[t>>2]|0,g|0)|0,c[w>>2]=(c[w>>2]|0)+g,c[t>>2]=(c[t>>2]|0)+g,w=j+20|0,c[w>>2]=(c[w>>2]|0)+g,c[i>>2]=(c[i>>2]|0)-g,w=c[h>>2]|0,c[h>>2]=w-g,(w|0)==(g|0)):0)c[t>>2]=c[k+8>>2];if(!(c[(c[d>>2]|0)+16>>2]|0)){w=0;return w|0}}w=1;return w|0}else if((h|0)==55)return g|0;return 0}function Ga(a){a=a|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;m=a+44|0;n=c[m>>2]|0;y=a+60|0;z=a+116|0;A=a+108|0;B=a+56|0;u=a+5812|0;v=a+72|0;w=a+88|0;x=a+84|0;o=a+68|0;p=a+52|0;q=a+64|0;r=a+112|0;s=a+92|0;t=a+76|0;f=c[z>>2]|0;g=n;while(1){l=c[A>>2]|0;h=(c[y>>2]|0)-f-l|0;if(l>>>0>=(n+(g+-262)|0)>>>0){g=c[B>>2]|0;cb(g|0,g+n|0,n|0)|0;c[r>>2]=(c[r>>2]|0)-n;c[A>>2]=(c[A>>2]|0)-n;c[s>>2]=(c[s>>2]|0)-n;g=c[t>>2]|0;f=g;g=(c[o>>2]|0)+(g<<1)|0;do{g=g+-2|0;l=e[g>>1]|0;b[g>>1]=l>>>0<n>>>0?0:l-n&65535;f=f+-1|0}while((f|0)!=0);f=n;g=(c[q>>2]|0)+(n<<1)|0;do{g=g+-2|0;l=e[g>>1]|0;b[g>>1]=l>>>0<n>>>0?0:l-n&65535;f=f+-1|0}while((f|0)!=0);h=h+n|0}i=c[a>>2]|0;j=i+4|0;k=c[j>>2]|0;if(!k)break;f=c[z>>2]|0;l=(c[B>>2]|0)+(c[A>>2]|0)+f|0;g=k>>>0>h>>>0?h:k;if(!g)g=0;else{c[j>>2]=k-g;cb(l|0,c[i>>2]|0,g|0)|0;switch(c[(c[i+28>>2]|0)+24>>2]|0){case 1:{k=i+48|0;c[k>>2]=Wa(c[k>>2]|0,l,g)|0;break}case 2:{k=i+48|0;c[k>>2]=Xa(c[k>>2]|0,l,g)|0;break}default:{}}c[i>>2]=(c[i>>2]|0)+g;f=i+8|0;c[f>>2]=(c[f>>2]|0)+g;f=c[z>>2]|0}f=f+g|0;c[z>>2]=f;g=c[u>>2]|0;a:do if((f+g|0)>>>0>2){h=(c[A>>2]|0)-g|0;l=c[B>>2]|0;k=d[l+h>>0]|0;c[v>>2]=k;c[v>>2]=(k<<c[w>>2]^(d[l+(h+1)>>0]|0))&c[x>>2];while(1){if(!g)break a;g=(c[v>>2]<<c[w>>2]^(d[(c[B>>2]|0)+(h+2)>>0]|0))&c[x>>2];c[v>>2]=g;b[(c[q>>2]|0)+((h&c[p>>2])<<1)>>1]=b[(c[o>>2]|0)+(g<<1)>>1]|0;b[(c[o>>2]|0)+(c[v>>2]<<1)>>1]=h;g=(c[u>>2]|0)+-1|0;c[u>>2]=g;f=c[z>>2]|0;if((f+g|0)>>>0<3)break a;h=h+1|0}}while(0);if(f>>>0>=262)break;if(!(c[(c[a>>2]|0)+4>>2]|0))break;g=c[m>>2]|0}h=a+5824|0;i=c[h>>2]|0;g=c[y>>2]|0;if(g>>>0<=i>>>0)return;f=(c[A>>2]|0)+(c[z>>2]|0)|0;if(i>>>0<f>>>0){A=g-f|0;A=A>>>0>258?258:A;$a((c[B>>2]|0)+f|0,0,A|0)|0;c[h>>2]=f+A;return}f=f+258|0;if(f>>>0<=i>>>0)return;A=f-i|0;z=g-i|0;A=A>>>0>z>>>0?z:A;$a((c[B>>2]|0)+i|0,0,A|0)|0;c[h>>2]=(c[h>>2]|0)+A;return}function Ha(f,g){f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;m=f+116|0;n=f+72|0;u=f+88|0;E=f+108|0;C=f+56|0;w=f+84|0;x=f+68|0;y=f+52|0;z=f+64|0;A=f+44|0;o=f+96|0;p=f+112|0;B=f+5792|0;q=f+5796|0;r=f+5784|0;s=f+5788|0;t=f+128|0;D=f+92|0;while(1){if((c[m>>2]|0)>>>0<262){Ga(f);h=c[m>>2]|0;if(!(h>>>0>261|(g|0)!=0)){h=0;i=54;break}if(!h){i=29;break}if(h>>>0<=2)i=9;else i=6}else i=6;if((i|0)==6){i=0;h=c[E>>2]|0;l=(c[n>>2]<<c[u>>2]^(d[(c[C>>2]|0)+(h+2)>>0]|0))&c[w>>2];c[n>>2]=l;l=b[(c[x>>2]|0)+(l<<1)>>1]|0;b[(c[z>>2]|0)+((h&c[y>>2])<<1)>>1]=l;h=l&65535;b[(c[x>>2]|0)+(c[n>>2]<<1)>>1]=c[E>>2];if(l<<16>>16!=0?((c[E>>2]|0)-h|0)>>>0<=((c[A>>2]|0)+-262|0)>>>0:0){h=Ia(f,h)|0;c[o>>2]=h}else i=9}if((i|0)==9)h=c[o>>2]|0;do if(h>>>0>2){i=h+253|0;h=(c[E>>2]|0)-(c[p>>2]|0)&65535;b[(c[q>>2]|0)+(c[B>>2]<<1)>>1]=h;l=c[B>>2]|0;c[B>>2]=l+1;a[(c[r>>2]|0)+l>>0]=i;h=h+-1<<16>>16;i=f+148+((d[13625+(i&255)>>0]|0|256)+1<<2)|0;b[i>>1]=(b[i>>1]|0)+1<<16>>16;i=h&65535;i=f+2440+((d[13113+((h&65535)<256?i:(i>>>7)+256|0)>>0]|0)<<2)|0;b[i>>1]=(b[i>>1]|0)+1<<16>>16;i=(c[B>>2]|0)==((c[s>>2]|0)+-1|0)&1;h=c[o>>2]|0;l=(c[m>>2]|0)-h|0;c[m>>2]=l;if(!(l>>>0>2?h>>>0<=(c[t>>2]|0)>>>0:0)){j=(c[E>>2]|0)+h|0;c[E>>2]=j;c[o>>2]=0;h=c[C>>2]|0;l=d[h+j>>0]|0;c[n>>2]=l;c[n>>2]=(l<<c[u>>2]^(d[h+(j+1)>>0]|0))&c[w>>2];h=i;break}c[o>>2]=h+-1;do{k=c[E>>2]|0;l=k+1|0;c[E>>2]=l;k=(c[n>>2]<<c[u>>2]^(d[(c[C>>2]|0)+(k+3)>>0]|0))&c[w>>2];c[n>>2]=k;b[(c[z>>2]|0)+((l&c[y>>2])<<1)>>1]=b[(c[x>>2]|0)+(k<<1)>>1]|0;b[(c[x>>2]|0)+(c[n>>2]<<1)>>1]=c[E>>2];l=(c[o>>2]|0)+-1|0;c[o>>2]=l}while((l|0)!=0);j=(c[E>>2]|0)+1|0;c[E>>2]=j;h=i}else{h=a[(c[C>>2]|0)+(c[E>>2]|0)>>0]|0;b[(c[q>>2]|0)+(c[B>>2]<<1)>>1]=0;j=c[B>>2]|0;c[B>>2]=j+1;a[(c[r>>2]|0)+j>>0]=h;h=f+148+((h&255)<<2)|0;b[h>>1]=(b[h>>1]|0)+1<<16>>16;h=(c[B>>2]|0)==((c[s>>2]|0)+-1|0)&1;c[m>>2]=(c[m>>2]|0)+-1;j=(c[E>>2]|0)+1|0;c[E>>2]=j}while(0);if(!h)continue;h=c[D>>2]|0;if((h|0)>-1)i=(c[C>>2]|0)+h|0;else i=0;Oa(f,i,j-h|0,0);c[D>>2]=c[E>>2];k=c[f>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){j=l+5816|0;H=b[j>>1]&255;i=l+20|0;G=c[i>>2]|0;c[i>>2]=G+1;a[(c[l+8>>2]|0)+G>>0]=H;b[j>>1]=(e[j>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{H=l+5816|0;G=b[H>>1]&255;i=l+20|0;I=c[i>>2]|0;c[i>>2]=I+1;j=l+8|0;a[(c[j>>2]|0)+I>>0]=G;I=(e[H>>1]|0)>>>8&255;G=c[i>>2]|0;c[i>>2]=G+1;a[(c[j>>2]|0)+G>>0]=I;b[H>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;I=c[j>>2]|0;h=h>>>0>I>>>0?I:h;if(h|0?(I=k+12|0,v=l+16|0,cb(c[I>>2]|0,c[v>>2]|0,h|0)|0,c[I>>2]=(c[I>>2]|0)+h,c[v>>2]=(c[v>>2]|0)+h,I=k+20|0,c[I>>2]=(c[I>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,I=c[i>>2]|0,c[i>>2]=I-h,(I|0)==(h|0)):0)c[v>>2]=c[l+8>>2];if(!(c[(c[f>>2]|0)+16>>2]|0)){h=0;i=54;break}}if((i|0)==29){j=c[E>>2]|0;c[f+5812>>2]=j>>>0<2?j:2;if((g|0)==4){i=c[D>>2]|0;if((i|0)>-1)h=(c[C>>2]|0)+i|0;else h=0;Oa(f,h,j-i|0,1);c[D>>2]=c[E>>2];l=c[f>>2]|0;m=c[l+28>>2]|0;h=m+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){I=m+5816|0;G=b[I>>1]&255;i=m+20|0;H=c[i>>2]|0;c[i>>2]=H+1;a[(c[m+8>>2]|0)+H>>0]=G;b[I>>1]=(e[I>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=m+20|0;break}else{I=m+5816|0;H=b[I>>1]&255;i=m+20|0;F=c[i>>2]|0;c[i>>2]=F+1;G=m+8|0;a[(c[G>>2]|0)+F>>0]=H;F=(e[I>>1]|0)>>>8&255;H=c[i>>2]|0;c[i>>2]=H+1;a[(c[G>>2]|0)+H>>0]=F;b[I>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=l+16|0;I=c[j>>2]|0;h=h>>>0>I>>>0?I:h;if(!h){I=c[f>>2]|0;I=I+16|0;I=c[I>>2]|0;I=(I|0)==0;I=I?2:3;return I|0}I=l+12|0;k=m+16|0;cb(c[I>>2]|0,c[k>>2]|0,h|0)|0;c[I>>2]=(c[I>>2]|0)+h;c[k>>2]=(c[k>>2]|0)+h;I=l+20|0;c[I>>2]=(c[I>>2]|0)+h;c[j>>2]=(c[j>>2]|0)-h;I=c[i>>2]|0;c[i>>2]=I-h;if((I|0)!=(h|0)){I=c[f>>2]|0;I=I+16|0;I=c[I>>2]|0;I=(I|0)==0;I=I?2:3;return I|0}c[k>>2]=c[m+8>>2];I=c[f>>2]|0;I=I+16|0;I=c[I>>2]|0;I=(I|0)==0;I=I?2:3;return I|0}if(c[B>>2]|0){i=c[D>>2]|0;if((i|0)>-1)h=(c[C>>2]|0)+i|0;else h=0;Oa(f,h,j-i|0,0);c[D>>2]=c[E>>2];k=c[f>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){I=l+5816|0;G=b[I>>1]&255;i=l+20|0;H=c[i>>2]|0;c[i>>2]=H+1;a[(c[l+8>>2]|0)+H>>0]=G;b[I>>1]=(e[I>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{I=l+5816|0;H=b[I>>1]&255;i=l+20|0;E=c[i>>2]|0;c[i>>2]=E+1;G=l+8|0;a[(c[G>>2]|0)+E>>0]=H;E=(e[I>>1]|0)>>>8&255;H=c[i>>2]|0;c[i>>2]=H+1;a[(c[G>>2]|0)+H>>0]=E;b[I>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;I=c[j>>2]|0;h=h>>>0>I>>>0?I:h;if(h|0?(I=k+12|0,F=l+16|0,cb(c[I>>2]|0,c[F>>2]|0,h|0)|0,c[I>>2]=(c[I>>2]|0)+h,c[F>>2]=(c[F>>2]|0)+h,I=k+20|0,c[I>>2]=(c[I>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,I=c[i>>2]|0,c[i>>2]=I-h,(I|0)==(h|0)):0)c[F>>2]=c[l+8>>2];if(!(c[(c[f>>2]|0)+16>>2]|0)){I=0;return I|0}}I=1;return I|0}else if((i|0)==54)return h|0;return 0}function Ia(b,d){b=b|0;d=d|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;j=c[b+124>>2]|0;q=c[b+56>>2]|0;n=c[b+108>>2]|0;h=q+n|0;i=c[b+120>>2]|0;m=c[b+144>>2]|0;l=(c[b+44>>2]|0)+-262|0;l=n>>>0>l>>>0?n-l|0:0;n=c[b+64>>2]|0;o=c[b+52>>2]|0;p=h+258|0;v=c[b+116>>2]|0;m=m>>>0>v>>>0?v:m;r=b+112|0;s=p;t=p+-258|0;k=d;g=i;j=i>>>0<(c[b+140>>2]|0)>>>0?j:j>>>2;b=h;f=a[h+i>>0]|0;i=a[h+(i+-1)>>0]|0;while(1){d=q+k|0;if((((a[d+g>>0]|0)==f<<24>>24?(a[d+(g+-1)>>0]|0)==i<<24>>24:0)?(a[d>>0]|0)==(a[b>>0]|0):0)?(u=d+1|0,(a[u>>0]|0)==(a[b+1>>0]|0)):0){h=u+1|0;b=b+2|0;while(1){d=b+1|0;if((a[d>>0]|0)!=(a[h+1>>0]|0))break;d=b+2|0;if((a[d>>0]|0)!=(a[h+2>>0]|0))break;d=b+3|0;if((a[d>>0]|0)!=(a[h+3>>0]|0))break;d=b+4|0;if((a[d>>0]|0)!=(a[h+4>>0]|0))break;d=b+5|0;if((a[d>>0]|0)!=(a[h+5>>0]|0))break;d=b+6|0;if((a[d>>0]|0)!=(a[h+6>>0]|0))break;d=b+7|0;if((a[d>>0]|0)!=(a[h+7>>0]|0))break;d=b+8|0;h=h+8|0;if(!(d>>>0<p>>>0?(a[d>>0]|0)==(a[h>>0]|0):0))break;else b=d}b=d-s|0;d=b+258|0;if((d|0)>(g|0)){c[r>>2]=k;if((d|0)>=(m|0)){b=20;break}g=d;h=t;f=a[t+d>>0]|0;d=a[t+(b+257)>>0]|0}else{h=t;d=i}}else{h=b;d=i}k=e[n+((k&o)<<1)>>1]|0;if(k>>>0<=l>>>0){d=g;b=20;break}j=j+-1|0;if(!j){d=g;b=20;break}else{b=h;i=d}}if((b|0)==20)return (d>>>0>v>>>0?v:d)|0;return 0}function Ja(f,g){f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0;n=f+116|0;o=f+72|0;x=f+88|0;L=f+108|0;J=f+56|0;C=f+84|0;D=f+68|0;E=f+52|0;F=f+64|0;G=f+96|0;p=f+120|0;q=f+112|0;r=f+100|0;H=f+5792|0;s=f+5796|0;t=f+5784|0;u=f+5788|0;v=f+104|0;K=f+92|0;w=f+128|0;y=f+44|0;A=f+136|0;a:while(1){h=c[n>>2]|0;while(1){if(h>>>0<262){Ga(f);h=c[n>>2]|0;if(!(h>>>0>261|(g|0)!=0)){h=0;I=74;break a}if(!h){I=47;break a}if(h>>>0<=2){c[p>>2]=c[G>>2];c[r>>2]=c[q>>2];c[G>>2]=2;h=2}else I=8}else I=8;do if((I|0)==8){I=0;m=c[L>>2]|0;h=(c[o>>2]<<c[x>>2]^(d[(c[J>>2]|0)+(m+2)>>0]|0))&c[C>>2];c[o>>2]=h;h=b[(c[D>>2]|0)+(h<<1)>>1]|0;b[(c[F>>2]|0)+((m&c[E>>2])<<1)>>1]=h;h=h&65535;b[(c[D>>2]|0)+(c[o>>2]<<1)>>1]=c[L>>2];m=c[G>>2]|0;c[p>>2]=m;c[r>>2]=c[q>>2];c[G>>2]=2;if(((h|0)!=0?m>>>0<(c[w>>2]|0)>>>0:0)?((c[L>>2]|0)-h|0)>>>0<=((c[y>>2]|0)+-262|0)>>>0:0){h=Ia(f,h)|0;c[G>>2]=h;if(h>>>0<6){if((c[A>>2]|0)!=1){if((h|0)!=3)break;if(((c[L>>2]|0)-(c[q>>2]|0)|0)>>>0<=4096){h=3;break}}c[G>>2]=2;h=2}}else h=2}while(0);i=c[p>>2]|0;if(!(i>>>0<3|h>>>0>i>>>0))break;if(!(c[v>>2]|0)){c[v>>2]=1;c[L>>2]=(c[L>>2]|0)+1;h=(c[n>>2]|0)+-1|0;c[n>>2]=h;continue}m=a[(c[J>>2]|0)+((c[L>>2]|0)+-1)>>0]|0;b[(c[s>>2]|0)+(c[H>>2]<<1)>>1]=0;l=c[H>>2]|0;c[H>>2]=l+1;a[(c[t>>2]|0)+l>>0]=m;m=f+148+((m&255)<<2)|0;b[m>>1]=(b[m>>1]|0)+1<<16>>16;if((c[H>>2]|0)==((c[u>>2]|0)+-1|0)){h=c[K>>2]|0;if((h|0)>-1)i=(c[J>>2]|0)+h|0;else i=0;Oa(f,i,(c[L>>2]|0)-h|0,0);c[K>>2]=c[L>>2];k=c[f>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){m=l+5816|0;N=b[m>>1]&255;i=l+20|0;j=c[i>>2]|0;c[i>>2]=j+1;a[(c[l+8>>2]|0)+j>>0]=N;b[m>>1]=(e[m>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{N=l+5816|0;m=b[N>>1]&255;i=l+20|0;O=c[i>>2]|0;c[i>>2]=O+1;j=l+8|0;a[(c[j>>2]|0)+O>>0]=m;O=(e[N>>1]|0)>>>8&255;m=c[i>>2]|0;c[i>>2]=m+1;a[(c[j>>2]|0)+m>>0]=O;b[N>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;O=c[j>>2]|0;h=h>>>0>O>>>0?O:h;if(h|0?(O=k+12|0,B=l+16|0,cb(c[O>>2]|0,c[B>>2]|0,h|0)|0,c[O>>2]=(c[O>>2]|0)+h,c[B>>2]=(c[B>>2]|0)+h,O=k+20|0,c[O>>2]=(c[O>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,O=c[i>>2]|0,c[i>>2]=O-h,(O|0)==(h|0)):0)c[B>>2]=c[l+8>>2]}c[L>>2]=(c[L>>2]|0)+1;h=(c[n>>2]|0)+-1|0;c[n>>2]=h;if(!(c[(c[f>>2]|0)+16>>2]|0)){h=0;I=74;break a}}l=c[L>>2]|0;m=l+(c[n>>2]|0)+-3|0;k=i+253|0;l=l+65535-(c[r>>2]|0)&65535;b[(c[s>>2]|0)+(c[H>>2]<<1)>>1]=l;h=c[H>>2]|0;c[H>>2]=h+1;a[(c[t>>2]|0)+h>>0]=k;l=l+-1<<16>>16;k=f+148+((d[13625+(k&255)>>0]|0|256)+1<<2)|0;b[k>>1]=(b[k>>1]|0)+1<<16>>16;k=l&65535;k=f+2440+((d[13113+((l&65535)<256?k:(k>>>7)+256|0)>>0]|0)<<2)|0;b[k>>1]=(b[k>>1]|0)+1<<16>>16;k=c[H>>2]|0;l=(c[u>>2]|0)+-1|0;h=c[p>>2]|0;c[n>>2]=(c[n>>2]|0)-(h+-1);h=h+-2|0;c[p>>2]=h;do{i=c[L>>2]|0;j=i+1|0;c[L>>2]=j;if(j>>>0<=m>>>0){h=(c[o>>2]<<c[x>>2]^(d[(c[J>>2]|0)+(i+3)>>0]|0))&c[C>>2];c[o>>2]=h;b[(c[F>>2]|0)+((j&c[E>>2])<<1)>>1]=b[(c[D>>2]|0)+(h<<1)>>1]|0;b[(c[D>>2]|0)+(c[o>>2]<<1)>>1]=c[L>>2];h=c[p>>2]|0}h=h+-1|0;c[p>>2]=h}while((h|0)!=0);c[v>>2]=0;c[G>>2]=2;j=(c[L>>2]|0)+1|0;c[L>>2]=j;if((k|0)!=(l|0))continue;h=c[K>>2]|0;if((h|0)>-1)i=(c[J>>2]|0)+h|0;else i=0;Oa(f,i,j-h|0,0);c[K>>2]=c[L>>2];k=c[f>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){O=l+5816|0;m=b[O>>1]&255;i=l+20|0;N=c[i>>2]|0;c[i>>2]=N+1;a[(c[l+8>>2]|0)+N>>0]=m;b[O>>1]=(e[O>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{O=l+5816|0;N=b[O>>1]&255;i=l+20|0;j=c[i>>2]|0;c[i>>2]=j+1;m=l+8|0;a[(c[m>>2]|0)+j>>0]=N;j=(e[O>>1]|0)>>>8&255;N=c[i>>2]|0;c[i>>2]=N+1;a[(c[m>>2]|0)+N>>0]=j;b[O>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;O=c[j>>2]|0;h=h>>>0>O>>>0?O:h;if(h|0?(O=k+12|0,z=l+16|0,cb(c[O>>2]|0,c[z>>2]|0,h|0)|0,c[O>>2]=(c[O>>2]|0)+h,c[z>>2]=(c[z>>2]|0)+h,O=k+20|0,c[O>>2]=(c[O>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,O=c[i>>2]|0,c[i>>2]=O-h,(O|0)==(h|0)):0)c[z>>2]=c[l+8>>2];if(!(c[(c[f>>2]|0)+16>>2]|0)){h=0;I=74;break}}if((I|0)==47){if(c[v>>2]|0){O=a[(c[J>>2]|0)+((c[L>>2]|0)+-1)>>0]|0;b[(c[s>>2]|0)+(c[H>>2]<<1)>>1]=0;N=c[H>>2]|0;c[H>>2]=N+1;a[(c[t>>2]|0)+N>>0]=O;O=f+148+((O&255)<<2)|0;b[O>>1]=(b[O>>1]|0)+1<<16>>16;c[v>>2]=0}j=c[L>>2]|0;c[f+5812>>2]=j>>>0<2?j:2;if((g|0)==4){i=c[K>>2]|0;if((i|0)>-1)h=(c[J>>2]|0)+i|0;else h=0;Oa(f,h,j-i|0,1);c[K>>2]=c[L>>2];l=c[f>>2]|0;m=c[l+28>>2]|0;h=m+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){O=m+5816|0;M=b[O>>1]&255;i=m+20|0;N=c[i>>2]|0;c[i>>2]=N+1;a[(c[m+8>>2]|0)+N>>0]=M;b[O>>1]=(e[O>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=m+20|0;break}else{O=m+5816|0;N=b[O>>1]&255;i=m+20|0;L=c[i>>2]|0;c[i>>2]=L+1;M=m+8|0;a[(c[M>>2]|0)+L>>0]=N;L=(e[O>>1]|0)>>>8&255;N=c[i>>2]|0;c[i>>2]=N+1;a[(c[M>>2]|0)+N>>0]=L;b[O>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=l+16|0;O=c[j>>2]|0;h=h>>>0>O>>>0?O:h;if(!h){O=c[f>>2]|0;O=O+16|0;O=c[O>>2]|0;O=(O|0)==0;O=O?2:3;return O|0}O=l+12|0;k=m+16|0;cb(c[O>>2]|0,c[k>>2]|0,h|0)|0;c[O>>2]=(c[O>>2]|0)+h;c[k>>2]=(c[k>>2]|0)+h;O=l+20|0;c[O>>2]=(c[O>>2]|0)+h;c[j>>2]=(c[j>>2]|0)-h;O=c[i>>2]|0;c[i>>2]=O-h;if((O|0)!=(h|0)){O=c[f>>2]|0;O=O+16|0;O=c[O>>2]|0;O=(O|0)==0;O=O?2:3;return O|0}c[k>>2]=c[m+8>>2];O=c[f>>2]|0;O=O+16|0;O=c[O>>2]|0;O=(O|0)==0;O=O?2:3;return O|0}if(c[H>>2]|0){i=c[K>>2]|0;if((i|0)>-1)h=(c[J>>2]|0)+i|0;else h=0;Oa(f,h,j-i|0,0);c[K>>2]=c[L>>2];k=c[f>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){O=l+5816|0;L=b[O>>1]&255;i=l+20|0;N=c[i>>2]|0;c[i>>2]=N+1;a[(c[l+8>>2]|0)+N>>0]=L;b[O>>1]=(e[O>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{O=l+5816|0;N=b[O>>1]&255;i=l+20|0;K=c[i>>2]|0;c[i>>2]=K+1;L=l+8|0;a[(c[L>>2]|0)+K>>0]=N;K=(e[O>>1]|0)>>>8&255;N=c[i>>2]|0;c[i>>2]=N+1;a[(c[L>>2]|0)+N>>0]=K;b[O>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;O=c[j>>2]|0;h=h>>>0>O>>>0?O:h;if(h|0?(O=k+12|0,M=l+16|0,cb(c[O>>2]|0,c[M>>2]|0,h|0)|0,c[O>>2]=(c[O>>2]|0)+h,c[M>>2]=(c[M>>2]|0)+h,O=k+20|0,c[O>>2]=(c[O>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,O=c[i>>2]|0,c[i>>2]=O-h,(O|0)==(h|0)):0)c[M>>2]=c[l+8>>2];if(!(c[(c[f>>2]|0)+16>>2]|0)){O=0;return O|0}}O=1;return O|0}else if((I|0)==74)return h|0;return 0}function Ka(f,g){f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0;if(!f){f=-2;return f|0}O=f+28|0;P=c[O>>2]|0;if(g>>>0>5|(P|0)==0){f=-2;return f|0}S=f+12|0;do if(c[S>>2]|0){if((c[f>>2]|0)==0?c[f+4>>2]|0:0)break;M=P+4|0;h=c[M>>2]|0;if((h|0)!=666|(g|0)==4){R=f+16|0;if(!(c[R>>2]|0)){c[f+24>>2]=13933;f=-5;return f|0}c[P>>2]=f;N=P+40|0;z=c[N>>2]|0;c[N>>2]=g;do if((h|0)==42){if((c[P+24>>2]|0)!=2){i=(c[P+48>>2]<<12)+-30720|0;if((c[P+136>>2]|0)<=1?(j=c[P+132>>2]|0,(j|0)>=2):0)if((j|0)<6)h=64;else h=(j|0)==6?128:192;else h=0;r=i|h;A=P+108|0;r=(c[A>>2]|0)==0?r:r|32;c[M>>2]=113;i=P+20|0;h=c[i>>2]|0;c[i>>2]=h+1;j=P+8|0;a[(c[j>>2]|0)+h>>0]=r>>>8;h=c[i>>2]|0;c[i>>2]=h+1;a[(c[j>>2]|0)+h>>0]=((r>>>0)%31|0|r)^31;h=f+48|0;if(c[A>>2]|0){A=c[h>>2]|0;r=c[i>>2]|0;c[i>>2]=r+1;a[(c[j>>2]|0)+r>>0]=A>>>24;r=c[i>>2]|0;c[i>>2]=r+1;a[(c[j>>2]|0)+r>>0]=A>>>16;r=c[h>>2]|0;A=c[i>>2]|0;c[i>>2]=A+1;a[(c[j>>2]|0)+A>>0]=r>>>8;A=c[i>>2]|0;c[i>>2]=A+1;a[(c[j>>2]|0)+A>>0]=r}c[h>>2]=1;h=c[M>>2]|0;A=30;break}j=f+48|0;c[j>>2]=0;l=P+20|0;i=c[l>>2]|0;c[l>>2]=i+1;m=P+8|0;a[(c[m>>2]|0)+i>>0]=31;i=c[l>>2]|0;c[l>>2]=i+1;a[(c[m>>2]|0)+i>>0]=-117;i=c[l>>2]|0;c[l>>2]=i+1;a[(c[m>>2]|0)+i>>0]=8;i=P+28|0;h=c[i>>2]|0;if(!h){h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=0;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=0;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=0;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=0;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=0;h=c[P+132>>2]|0;if((h|0)==9)h=2;else h=((h|0)<2?1:(c[P+136>>2]|0)>1)?4:0;x=c[l>>2]|0;c[l>>2]=x+1;a[(c[m>>2]|0)+x>>0]=h;x=c[l>>2]|0;c[l>>2]=x+1;a[(c[m>>2]|0)+x>>0]=3;c[M>>2]=113;break}A=((c[h>>2]|0)!=0|(c[h+44>>2]|0?2:0)|((c[h+16>>2]|0)==0?0:4)|((c[h+28>>2]|0)==0?0:8)|((c[h+36>>2]|0)==0?0:16))&255;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=A;h=c[(c[i>>2]|0)+4>>2]&255;A=c[l>>2]|0;c[l>>2]=A+1;a[(c[m>>2]|0)+A>>0]=h;A=(c[(c[i>>2]|0)+4>>2]|0)>>>8&255;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=A;h=(c[(c[i>>2]|0)+4>>2]|0)>>>16&255;A=c[l>>2]|0;c[l>>2]=A+1;a[(c[m>>2]|0)+A>>0]=h;A=(c[(c[i>>2]|0)+4>>2]|0)>>>24&255;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=A;h=c[P+132>>2]|0;if((h|0)==9)h=2;else h=((h|0)<2?1:(c[P+136>>2]|0)>1)?4:0;A=c[l>>2]|0;c[l>>2]=A+1;a[(c[m>>2]|0)+A>>0]=h;A=c[(c[i>>2]|0)+12>>2]&255;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=A;h=c[i>>2]|0;if(c[h+16>>2]|0){h=c[h+20>>2]&255;A=c[l>>2]|0;c[l>>2]=A+1;a[(c[m>>2]|0)+A>>0]=h;A=(c[(c[i>>2]|0)+20>>2]|0)>>>8&255;h=c[l>>2]|0;c[l>>2]=h+1;a[(c[m>>2]|0)+h>>0]=A;h=c[i>>2]|0}if(c[h+44>>2]|0)c[j>>2]=Xa(c[j>>2]|0,c[m>>2]|0,c[l>>2]|0)|0;c[P+32>>2]=0;c[M>>2]=69;A=31}else A=30;while(0);if((A|0)==30)if((h|0)==69)A=31;else A=56;do if((A|0)==31){n=P+28|0;h=c[n>>2]|0;if(!(c[h+16>>2]|0)){c[M>>2]=73;A=57;break}o=P+20|0;r=P+32|0;l=P+12|0;m=f+20|0;p=f+48|0;q=P+8|0;j=c[r>>2]|0;i=c[o>>2]|0;while(1){if(j>>>0>=(c[h+20>>2]&65535)>>>0)break;k=c[o>>2]|0;if((k|0)==(c[l>>2]|0)){if((c[h+44>>2]|0)!=0&k>>>0>i>>>0)c[p>>2]=Xa(c[p>>2]|0,(c[q>>2]|0)+i|0,k-i|0)|0;j=c[O>>2]|0;h=j+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){k=j+5816|0;U=b[k>>1]&255;i=j+20|0;T=c[i>>2]|0;c[i>>2]=T+1;a[(c[j+8>>2]|0)+T>>0]=U;b[k>>1]=(e[k>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=j+20|0;break}else{U=j+5816|0;T=b[U>>1]&255;i=j+20|0;V=c[i>>2]|0;c[i>>2]=V+1;k=j+8|0;a[(c[k>>2]|0)+V>>0]=T;V=(e[U>>1]|0)>>>8&255;T=c[i>>2]|0;c[i>>2]=T+1;a[(c[k>>2]|0)+T>>0]=V;b[U>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;V=c[R>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(s=j+16|0,cb(c[S>>2]|0,c[s>>2]|0,h|0)|0,c[S>>2]=(c[S>>2]|0)+h,c[s>>2]=(c[s>>2]|0)+h,c[m>>2]=(c[m>>2]|0)+h,c[R>>2]=(c[R>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[s>>2]=c[j+8>>2];i=c[o>>2]|0;if((i|0)==(c[l>>2]|0)){A=46;break}h=c[n>>2]|0;j=c[r>>2]|0;k=i}j=a[(c[h+16>>2]|0)+j>>0]|0;c[o>>2]=k+1;a[(c[q>>2]|0)+k>>0]=j;j=(c[r>>2]|0)+1|0;c[r>>2]=j;h=c[n>>2]|0}if((A|0)==46)h=c[n>>2]|0;if((c[h+44>>2]|0)!=0?(t=c[o>>2]|0,t>>>0>i>>>0):0){c[p>>2]=Xa(c[p>>2]|0,(c[q>>2]|0)+i|0,t-i|0)|0;h=c[n>>2]|0}if((c[r>>2]|0)==(c[h+20>>2]|0)){c[r>>2]=0;c[M>>2]=73;A=57;break}else{h=c[M>>2]|0;A=56;break}}while(0);if((A|0)==56)if((h|0)==73)A=57;else A=80;do if((A|0)==57){m=P+28|0;if(!(c[(c[m>>2]|0)+28>>2]|0)){c[M>>2]=91;A=81;break}n=P+20|0;i=c[n>>2]|0;k=P+12|0;l=f+20|0;o=f+48|0;p=P+8|0;q=P+32|0;h=i;while(1){if((h|0)==(c[k>>2]|0)){if(h>>>0>i>>>0?(c[(c[m>>2]|0)+44>>2]|0)!=0:0)c[o>>2]=Xa(c[o>>2]|0,(c[p>>2]|0)+i|0,h-i|0)|0;j=c[O>>2]|0;h=j+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=j+5816|0;T=b[V>>1]&255;i=j+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[j+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=j+20|0;break}else{V=j+5816|0;U=b[V>>1]&255;i=j+20|0;A=c[i>>2]|0;c[i>>2]=A+1;T=j+8|0;a[(c[T>>2]|0)+A>>0]=U;A=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=A;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;V=c[R>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(u=j+16|0,cb(c[S>>2]|0,c[u>>2]|0,h|0)|0,c[S>>2]=(c[S>>2]|0)+h,c[u>>2]=(c[u>>2]|0)+h,c[l>>2]=(c[l>>2]|0)+h,c[R>>2]=(c[R>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[u>>2]=c[j+8>>2];i=c[n>>2]|0;if((i|0)==(c[k>>2]|0)){h=1;break}else h=i}j=c[q>>2]|0;c[q>>2]=j+1;j=a[(c[(c[m>>2]|0)+28>>2]|0)+j>>0]|0;c[n>>2]=h+1;a[(c[p>>2]|0)+h>>0]=j;if(!(j<<24>>24)){h=j&255;break}h=c[n>>2]|0}if(c[(c[m>>2]|0)+44>>2]|0?(v=c[n>>2]|0,v>>>0>i>>>0):0)c[o>>2]=Xa(c[o>>2]|0,(c[p>>2]|0)+i|0,v-i|0)|0;if(!h){c[q>>2]=0;c[M>>2]=91;A=81;break}else{h=c[M>>2]|0;A=80;break}}while(0);if((A|0)==80)if((h|0)==91)A=81;else{k=h;A=104}do if((A|0)==81){n=P+28|0;if(!(c[(c[n>>2]|0)+36>>2]|0)){c[M>>2]=103;A=105;break}o=P+20|0;i=c[o>>2]|0;k=P+12|0;l=f+20|0;p=f+48|0;q=P+8|0;m=P+32|0;h=i;while(1){if((h|0)==(c[k>>2]|0)){if(h>>>0>i>>>0?(c[(c[n>>2]|0)+44>>2]|0)!=0:0)c[p>>2]=Xa(c[p>>2]|0,(c[q>>2]|0)+i|0,h-i|0)|0;j=c[O>>2]|0;h=j+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=j+5816|0;T=b[V>>1]&255;i=j+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[j+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=j+20|0;break}else{V=j+5816|0;U=b[V>>1]&255;i=j+20|0;A=c[i>>2]|0;c[i>>2]=A+1;T=j+8|0;a[(c[T>>2]|0)+A>>0]=U;A=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=A;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;V=c[R>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(w=j+16|0,cb(c[S>>2]|0,c[w>>2]|0,h|0)|0,c[S>>2]=(c[S>>2]|0)+h,c[w>>2]=(c[w>>2]|0)+h,c[l>>2]=(c[l>>2]|0)+h,c[R>>2]=(c[R>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[w>>2]=c[j+8>>2];i=c[o>>2]|0;if((i|0)==(c[k>>2]|0)){h=1;break}else h=i}j=c[m>>2]|0;c[m>>2]=j+1;j=a[(c[(c[n>>2]|0)+36>>2]|0)+j>>0]|0;c[o>>2]=h+1;a[(c[q>>2]|0)+h>>0]=j;if(!(j<<24>>24)){h=j&255;break}h=c[o>>2]|0}if(c[(c[n>>2]|0)+44>>2]|0?(x=c[o>>2]|0,x>>>0>i>>>0):0)c[p>>2]=Xa(c[p>>2]|0,(c[q>>2]|0)+i|0,x-i|0)|0;if(!h){c[M>>2]=103;A=105;break}else{k=c[M>>2]|0;A=104;break}}while(0);if((A|0)==104?(k|0)==103:0)A=105;do if((A|0)==105){if(!(c[(c[P+28>>2]|0)+44>>2]|0)){c[M>>2]=113;break}k=P+20|0;l=P+12|0;if(((c[k>>2]|0)+2|0)>>>0>(c[l>>2]|0)>>>0){j=c[O>>2]|0;h=j+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=j+5816|0;T=b[V>>1]&255;i=j+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[j+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=j+20|0;break}else{V=j+5816|0;U=b[V>>1]&255;i=j+20|0;A=c[i>>2]|0;c[i>>2]=A+1;T=j+8|0;a[(c[T>>2]|0)+A>>0]=U;A=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=A;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;V=c[R>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(y=j+16|0,cb(c[S>>2]|0,c[y>>2]|0,h|0)|0,c[S>>2]=(c[S>>2]|0)+h,c[y>>2]=(c[y>>2]|0)+h,V=f+20|0,c[V>>2]=(c[V>>2]|0)+h,c[R>>2]=(c[R>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[y>>2]=c[j+8>>2]}h=c[k>>2]|0;if((h+2|0)>>>0<=(c[l>>2]|0)>>>0){V=f+48|0;A=c[V>>2]&255;c[k>>2]=h+1;T=P+8|0;a[(c[T>>2]|0)+h>>0]=A;A=(c[V>>2]|0)>>>8&255;U=c[k>>2]|0;c[k>>2]=U+1;a[(c[T>>2]|0)+U>>0]=A;c[V>>2]=0;c[M>>2]=113}}while(0);w=P+20|0;if(!(c[w>>2]|0)){if((c[f+4>>2]|0)==0?!((g|0)==4?1:((g<<1)-((g|0)>4?9:0)|0)>((z<<1)-((z|0)>4?9:0)|0)):0){c[f+24>>2]=13933;V=-5;return V|0}}else{k=c[O>>2]|0;h=k+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=k+5816|0;T=b[V>>1]&255;j=k+20|0;U=c[j>>2]|0;c[j>>2]=U+1;a[(c[k+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{j=k+20|0;break}else{V=k+5816|0;U=b[V>>1]&255;j=k+20|0;A=c[j>>2]|0;c[j>>2]=A+1;T=k+8|0;a[(c[T>>2]|0)+A>>0]=U;A=(e[V>>1]|0)>>>8&255;U=c[j>>2]|0;c[j>>2]=U+1;a[(c[T>>2]|0)+U>>0]=A;b[V>>1]=0;c[h>>2]=0}while(0);i=c[j>>2]|0;h=c[R>>2]|0;i=i>>>0>h>>>0?h:i;if(i){h=k+16|0;cb(c[S>>2]|0,c[h>>2]|0,i|0)|0;c[S>>2]=(c[S>>2]|0)+i;c[h>>2]=(c[h>>2]|0)+i;V=f+20|0;c[V>>2]=(c[V>>2]|0)+i;c[R>>2]=(c[R>>2]|0)-i;V=c[j>>2]|0;c[j>>2]=V-i;if((V|0)==(i|0))c[h>>2]=c[k+8>>2];h=c[R>>2]|0}if(!h){c[N>>2]=-1;V=0;return V|0}}i=(c[M>>2]|0)==666;h=c[f+4>>2]|0;if(i)if(!h)A=137;else{c[f+24>>2]=13933;V=-5;return V|0}else if(!h)A=137;else A=140;do if((A|0)==137)if(!(c[P+116>>2]|0))if(g)if(i)break;else{A=140;break}else{V=0;return V|0}else A=140;while(0);a:do if((A|0)==140){b:do switch(c[P+136>>2]|0){case 2:{m=P+116|0;n=P+96|0;t=P+108|0;s=P+56|0;o=P+5792|0;p=P+5796|0;q=P+5784|0;r=P+5788|0;u=P+92|0;while(1){if((c[m>>2]|0)==0?(Ga(P),(c[m>>2]|0)==0):0)break;c[n>>2]=0;V=a[(c[s>>2]|0)+(c[t>>2]|0)>>0]|0;b[(c[p>>2]|0)+(c[o>>2]<<1)>>1]=0;h=c[o>>2]|0;c[o>>2]=h+1;a[(c[q>>2]|0)+h>>0]=V;V=P+148+((V&255)<<2)|0;b[V>>1]=(b[V>>1]|0)+1<<16>>16;V=(c[o>>2]|0)==((c[r>>2]|0)+-1|0);c[m>>2]=(c[m>>2]|0)+-1;h=(c[t>>2]|0)+1|0;c[t>>2]=h;if(!V)continue;i=c[u>>2]|0;if((i|0)>-1)j=(c[s>>2]|0)+i|0;else j=0;Oa(P,j,h-i|0,0);c[u>>2]=c[t>>2];k=c[P>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=l+5816|0;T=b[V>>1]&255;i=l+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[l+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{V=l+5816|0;U=b[V>>1]&255;i=l+20|0;L=c[i>>2]|0;c[i>>2]=L+1;T=l+8|0;a[(c[T>>2]|0)+L>>0]=U;L=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=L;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;V=c[j>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(V=k+12|0,B=l+16|0,cb(c[V>>2]|0,c[B>>2]|0,h|0)|0,c[V>>2]=(c[V>>2]|0)+h,c[B>>2]=(c[B>>2]|0)+h,V=k+20|0,c[V>>2]=(c[V>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[B>>2]=c[l+8>>2];if(!(c[(c[P>>2]|0)+16>>2]|0)){A=244;break b}}if(g){c[P+5812>>2]=0;if((g|0)==4){i=c[u>>2]|0;if((i|0)>-1)h=(c[s>>2]|0)+i|0;else h=0;Oa(P,h,(c[t>>2]|0)-i|0,1);c[u>>2]=c[t>>2];k=c[P>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=l+5816|0;T=b[V>>1]&255;i=l+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[l+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{V=l+5816|0;U=b[V>>1]&255;i=l+20|0;L=c[i>>2]|0;c[i>>2]=L+1;T=l+8|0;a[(c[T>>2]|0)+L>>0]=U;L=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=L;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;V=c[j>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(V=k+12|0,C=l+16|0,cb(c[V>>2]|0,c[C>>2]|0,h|0)|0,c[V>>2]=(c[V>>2]|0)+h,c[C>>2]=(c[C>>2]|0)+h,V=k+20|0,c[V>>2]=(c[V>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[C>>2]=c[l+8>>2];if(!(c[(c[P>>2]|0)+16>>2]|0)){h=2;A=242;break b}else{A=240;break b}}if(c[o>>2]|0){i=c[u>>2]|0;if((i|0)>-1)h=(c[s>>2]|0)+i|0;else h=0;Oa(P,h,(c[t>>2]|0)-i|0,0);c[u>>2]=c[t>>2];k=c[P>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=l+5816|0;T=b[V>>1]&255;i=l+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[l+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{V=l+5816|0;U=b[V>>1]&255;i=l+20|0;M=c[i>>2]|0;c[i>>2]=M+1;T=l+8|0;a[(c[T>>2]|0)+M>>0]=U;M=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=M;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;V=c[j>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(V=k+12|0,D=l+16|0,cb(c[V>>2]|0,c[D>>2]|0,h|0)|0,c[V>>2]=(c[V>>2]|0)+h,c[D>>2]=(c[D>>2]|0)+h,V=k+20|0,c[V>>2]=(c[V>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[D>>2]=c[l+8>>2];if(!(c[(c[P>>2]|0)+16>>2]|0))A=244}}else A=244;break}case 3:{m=P+116|0;n=P+96|0;u=P+108|0;t=P+56|0;o=P+5792|0;p=P+5796|0;q=P+5784|0;r=P+2440|0;s=P+5788|0;v=P+92|0;while(1){h=c[m>>2]|0;if(h>>>0<259){Ga(P);h=c[m>>2]|0;if(!(h>>>0>258|(g|0)!=0)){A=244;break b}if(!h)break;c[n>>2]=0;if(h>>>0>2)A=188;else A=203}else{c[n>>2]=0;A=188}if((A|0)==188){A=0;i=c[u>>2]|0;if((((i|0)!=0?(E=(c[t>>2]|0)+i|0,G=E+-1|0,F=a[G>>0]|0,G=G+1|0,F<<24>>24==(a[G>>0]|0)):0)?(H=G+1|0,F<<24>>24==(a[H>>0]|0)):0)?(I=H+1|0,F<<24>>24==(a[I>>0]|0)):0){k=E+258|0;i=I;do{j=i+1|0;if(F<<24>>24!=(a[j>>0]|0)){i=j;break}j=i+2|0;if(F<<24>>24!=(a[j>>0]|0)){i=j;break}j=i+3|0;if(F<<24>>24!=(a[j>>0]|0)){i=j;break}j=i+4|0;if(F<<24>>24!=(a[j>>0]|0)){i=j;break}j=i+5|0;if(F<<24>>24!=(a[j>>0]|0)){i=j;break}j=i+6|0;if(F<<24>>24!=(a[j>>0]|0)){i=j;break}j=i+7|0;if(F<<24>>24!=(a[j>>0]|0)){i=j;break}i=i+8|0}while(i>>>0<k>>>0?F<<24>>24==(a[i>>0]|0):0);V=i-k+258|0;U=V>>>0>h>>>0;c[n>>2]=U?h:V;h=U?h:V;if(h>>>0>2){h=h+253|0;b[(c[p>>2]|0)+(c[o>>2]<<1)>>1]=1;j=c[o>>2]|0;c[o>>2]=j+1;a[(c[q>>2]|0)+j>>0]=h;h=P+148+((d[13625+(h&255)>>0]|256)+1<<2)|0;b[h>>1]=(b[h>>1]|0)+1<<16>>16;b[r>>1]=(b[r>>1]|0)+1<<16>>16;h=(c[o>>2]|0)==((c[s>>2]|0)+-1|0)&1;j=c[n>>2]|0;c[m>>2]=(c[m>>2]|0)-j;j=(c[u>>2]|0)+j|0;c[u>>2]=j;c[n>>2]=0}else A=203}else A=203}if((A|0)==203){A=0;h=a[(c[t>>2]|0)+(c[u>>2]|0)>>0]|0;b[(c[p>>2]|0)+(c[o>>2]<<1)>>1]=0;j=c[o>>2]|0;c[o>>2]=j+1;a[(c[q>>2]|0)+j>>0]=h;h=P+148+((h&255)<<2)|0;b[h>>1]=(b[h>>1]|0)+1<<16>>16;h=(c[o>>2]|0)==((c[s>>2]|0)+-1|0)&1;c[m>>2]=(c[m>>2]|0)+-1;j=(c[u>>2]|0)+1|0;c[u>>2]=j}if(!h)continue;h=c[v>>2]|0;if((h|0)>-1)i=(c[t>>2]|0)+h|0;else i=0;Oa(P,i,j-h|0,0);c[v>>2]=c[u>>2];k=c[P>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=l+5816|0;T=b[V>>1]&255;i=l+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[l+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{V=l+5816|0;U=b[V>>1]&255;i=l+20|0;D=c[i>>2]|0;c[i>>2]=D+1;T=l+8|0;a[(c[T>>2]|0)+D>>0]=U;D=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=D;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;V=c[j>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(V=k+12|0,J=l+16|0,cb(c[V>>2]|0,c[J>>2]|0,h|0)|0,c[V>>2]=(c[V>>2]|0)+h,c[J>>2]=(c[J>>2]|0)+h,V=k+20|0,c[V>>2]=(c[V>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[J>>2]=c[l+8>>2];if(!(c[(c[P>>2]|0)+16>>2]|0)){A=244;break b}}c[P+5812>>2]=0;if((g|0)==4){i=c[v>>2]|0;if((i|0)>-1)h=(c[t>>2]|0)+i|0;else h=0;Oa(P,h,(c[u>>2]|0)-i|0,1);c[v>>2]=c[u>>2];k=c[P>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=l+5816|0;T=b[V>>1]&255;i=l+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[l+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{V=l+5816|0;U=b[V>>1]&255;i=l+20|0;L=c[i>>2]|0;c[i>>2]=L+1;T=l+8|0;a[(c[T>>2]|0)+L>>0]=U;L=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=L;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;V=c[j>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(V=k+12|0,K=l+16|0,cb(c[V>>2]|0,c[K>>2]|0,h|0)|0,c[V>>2]=(c[V>>2]|0)+h,c[K>>2]=(c[K>>2]|0)+h,V=k+20|0,c[V>>2]=(c[V>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[K>>2]=c[l+8>>2];if(!(c[(c[P>>2]|0)+16>>2]|0)){h=2;A=242;break b}else{A=240;break b}}if(c[o>>2]|0){i=c[v>>2]|0;if((i|0)>-1)h=(c[t>>2]|0)+i|0;else h=0;Oa(P,h,(c[u>>2]|0)-i|0,0);c[v>>2]=c[u>>2];k=c[P>>2]|0;l=c[k+28>>2]|0;h=l+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=l+5816|0;T=b[V>>1]&255;i=l+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[l+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=l+20|0;break}else{V=l+5816|0;U=b[V>>1]&255;i=l+20|0;M=c[i>>2]|0;c[i>>2]=M+1;T=l+8|0;a[(c[T>>2]|0)+M>>0]=U;M=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=M;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;j=k+16|0;V=c[j>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(V=k+12|0,L=l+16|0,cb(c[V>>2]|0,c[L>>2]|0,h|0)|0,c[V>>2]=(c[V>>2]|0)+h,c[L>>2]=(c[L>>2]|0)+h,V=k+20|0,c[V>>2]=(c[V>>2]|0)+h,c[j>>2]=(c[j>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[L>>2]=c[l+8>>2];if(!(c[(c[P>>2]|0)+16>>2]|0))A=244}break}default:{h=ma[c[8+((c[P+132>>2]|0)*12|0)+8>>2]&3](P,g)|0;if((h|0)==2){h=2;A=242}else switch(h|0){case 3:{h=3;A=242;break}case 0:{A=244;break}default:A=243}}}while(0);if((A|0)==240){h=3;A=242}if((A|0)==242){c[M>>2]=666;A=243}if((A|0)==243)switch(h|0){case 2:{A=244;break}case 1:break;default:break a}if((A|0)==244){if(c[R>>2]|0){V=0;return V|0}c[N>>2]=-1;V=0;return V|0}switch(g|0){case 1:{Na(P);break}case 5:break;default:{Ma(P,0,0,0);if((g|0)==3?(V=P+76|0,U=P+68|0,b[(c[U>>2]|0)+((c[V>>2]|0)+-1<<1)>>1]=0,$a(c[U>>2]|0,0,(c[V>>2]<<1)+-2|0)|0,(c[P+116>>2]|0)==0):0){c[P+108>>2]=0;c[P+92>>2]=0;c[P+5812>>2]=0}}}k=c[O>>2]|0;h=k+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=k+5816|0;T=b[V>>1]&255;j=k+20|0;U=c[j>>2]|0;c[j>>2]=U+1;a[(c[k+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{j=k+20|0;break}else{V=k+5816|0;U=b[V>>1]&255;j=k+20|0;M=c[j>>2]|0;c[j>>2]=M+1;T=k+8|0;a[(c[T>>2]|0)+M>>0]=U;M=(e[V>>1]|0)>>>8&255;U=c[j>>2]|0;c[j>>2]=U+1;a[(c[T>>2]|0)+U>>0]=M;b[V>>1]=0;c[h>>2]=0}while(0);i=c[j>>2]|0;h=c[R>>2]|0;i=i>>>0>h>>>0?h:i;if(i){h=k+16|0;cb(c[S>>2]|0,c[h>>2]|0,i|0)|0;c[S>>2]=(c[S>>2]|0)+i;c[h>>2]=(c[h>>2]|0)+i;V=f+20|0;c[V>>2]=(c[V>>2]|0)+i;c[R>>2]=(c[R>>2]|0)-i;V=c[j>>2]|0;c[j>>2]=V-i;if((V|0)==(i|0))c[h>>2]=c[k+8>>2];h=c[R>>2]|0}if(!h){c[N>>2]=-1;V=0;return V|0}}while(0);if((g|0)!=4){V=0;return V|0}k=P+24|0;h=c[k>>2]|0;if((h|0)<1){V=1;return V|0}i=f+48|0;j=c[i>>2]|0;if((h|0)==2){T=c[w>>2]|0;c[w>>2]=T+1;U=P+8|0;a[(c[U>>2]|0)+T>>0]=j;P=(c[i>>2]|0)>>>8&255;T=c[w>>2]|0;c[w>>2]=T+1;a[(c[U>>2]|0)+T>>0]=P;T=(c[i>>2]|0)>>>16&255;P=c[w>>2]|0;c[w>>2]=P+1;a[(c[U>>2]|0)+P>>0]=T;P=(c[i>>2]|0)>>>24&255;T=c[w>>2]|0;c[w>>2]=T+1;a[(c[U>>2]|0)+T>>0]=P;T=f+8|0;P=c[T>>2]&255;V=c[w>>2]|0;c[w>>2]=V+1;a[(c[U>>2]|0)+V>>0]=P;V=(c[T>>2]|0)>>>8&255;P=c[w>>2]|0;c[w>>2]=P+1;a[(c[U>>2]|0)+P>>0]=V;P=(c[T>>2]|0)>>>16&255;V=c[w>>2]|0;c[w>>2]=V+1;a[(c[U>>2]|0)+V>>0]=P;T=(c[T>>2]|0)>>>24&255;V=c[w>>2]|0;c[w>>2]=V+1;a[(c[U>>2]|0)+V>>0]=T}else{T=c[w>>2]|0;c[w>>2]=T+1;U=P+8|0;a[(c[U>>2]|0)+T>>0]=j>>>24;T=c[w>>2]|0;c[w>>2]=T+1;a[(c[U>>2]|0)+T>>0]=j>>>16;T=c[i>>2]|0;V=c[w>>2]|0;c[w>>2]=V+1;a[(c[U>>2]|0)+V>>0]=T>>>8;V=c[w>>2]|0;c[w>>2]=V+1;a[(c[U>>2]|0)+V>>0]=T}j=c[O>>2]|0;h=j+5820|0;i=c[h>>2]|0;do if((i|0)!=16)if((i|0)>7){V=j+5816|0;T=b[V>>1]&255;i=j+20|0;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[j+8>>2]|0)+U>>0]=T;b[V>>1]=(e[V>>1]|0)>>>8;c[h>>2]=(c[h>>2]|0)+-8;break}else{i=j+20|0;break}else{V=j+5816|0;U=b[V>>1]&255;i=j+20|0;P=c[i>>2]|0;c[i>>2]=P+1;T=j+8|0;a[(c[T>>2]|0)+P>>0]=U;P=(e[V>>1]|0)>>>8&255;U=c[i>>2]|0;c[i>>2]=U+1;a[(c[T>>2]|0)+U>>0]=P;b[V>>1]=0;c[h>>2]=0}while(0);h=c[i>>2]|0;V=c[R>>2]|0;h=h>>>0>V>>>0?V:h;if(h|0?(Q=j+16|0,cb(c[S>>2]|0,c[Q>>2]|0,h|0)|0,c[S>>2]=(c[S>>2]|0)+h,c[Q>>2]=(c[Q>>2]|0)+h,V=f+20|0,c[V>>2]=(c[V>>2]|0)+h,c[R>>2]=(c[R>>2]|0)-h,V=c[i>>2]|0,c[i>>2]=V-h,(V|0)==(h|0)):0)c[Q>>2]=c[j+8>>2];h=c[k>>2]|0;if((h|0)>0)c[k>>2]=0-h;V=(c[w>>2]|0)==0&1;return V|0}}while(0);c[f+24>>2]=13900;V=-2;return V|0}function La(d,f,g,h,j,k){d=d|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0;I=i;i=i+64|0;G=I+32|0;o=I;l=0;while(1){if((l|0)==16){l=0;break}b[G+(l<<1)>>1]=0;l=l+1|0}while(1){if((l|0)==(g|0))break;E=G+(e[f+(l<<1)>>1]<<1)|0;b[E>>1]=(b[E>>1]|0)+1<<16>>16;l=l+1|0}l=c[j>>2]|0;m=15;while(1){if(!m){p=11;break}if(b[G+(m<<1)>>1]|0){H=m;break}m=m+-1|0}if((p|0)==11){k=c[h>>2]|0;c[h>>2]=k+4;b[k>>1]=320;b[k+2>>1]=320>>>16;k=c[h>>2]|0;c[h>>2]=k+4;b[k>>1]=320;b[k+2>>1]=320>>>16;c[j>>2]=1;k=0;i=I;return k|0}l=l>>>0>H>>>0?H:l;q=1;while(1){if(q>>>0>=H>>>0)break;if(b[G+(q<<1)>>1]|0)break;q=q+1|0}E=l>>>0<q>>>0?q:l;m=1;n=1;while(1){if(n>>>0>=16)break;l=(m<<1)-(e[G+(n<<1)>>1]|0)|0;if((l|0)<0){F=-1;p=60;break}m=l;n=n+1|0}if((p|0)==60){i=I;return F|0}if((m|0)>0?!((d|0)!=0&(H|0)==1):0){k=-1;i=I;return k|0}b[o+2>>1]=0;l=0;m=1;while(1){if((m|0)==15){m=0;break}C=(l&65535)+(e[G+(m<<1)>>1]|0)|0;D=m+1|0;b[o+(D<<1)>>1]=C;l=C;m=D}while(1){if((m|0)==(g|0))break;l=b[f+(m<<1)>>1]|0;if(l<<16>>16){C=o+((l&65535)<<1)|0;D=b[C>>1]|0;b[C>>1]=D+1<<16>>16;b[k+((D&65535)<<1)>>1]=m}m=m+1|0}switch(d|0){case 0:{l=1<<E;z=k;A=19;B=k;break}case 1:{if(E>>>0>9){k=1;i=I;return k|0}else{l=1<<E;z=10628;A=256;B=10690}break}default:if((d|0)==2&E>>>0>9){k=1;i=I;return k|0}else{l=1<<E;z=11266;A=-1;B=11330}}x=l+-1|0;y=E&255;g=E;D=0;p=0;n=q;v=-1;C=c[h>>2]|0;m=0;a:while(1){u=1<<g;s=p;t=n;w=m;while(1){g=t-D|0;m=b[k+(w<<1)>>1]|0;n=m&65535;if((n|0)>=(A|0))if((n|0)>(A|0)){q=e[B+(n<<1)>>1]|0;m=b[z+(n<<1)>>1]|0}else{q=96;m=0}else q=0;o=1<<g;p=s>>>D;n=(m&65535)<<16|g<<8&65280|q&255;m=u;do{r=m;m=m-o|0;q=C+(p+m<<2)|0;b[q>>1]=n;b[q+2>>1]=n>>>16}while((r|0)!=(o|0));m=1<<t+-1;while(1){if(!(s&m))break;m=m>>>1}if(!m)s=0;else s=(s&m+-1)+m|0;w=w+1|0;q=G+(t<<1)|0;r=(b[q>>1]|0)+-1<<16>>16;b[q>>1]=r;if(!(r<<16>>16)){if((t|0)==(H|0)){p=57;break a}t=e[f+(e[k+(w<<1)>>1]<<1)>>1]|0}if(t>>>0<=E>>>0)continue;r=s&x;if((r|0)!=(v|0))break}p=(D|0)==0?E:D;q=C+(u<<2)|0;n=t-p|0;g=n;n=1<<n;while(1){m=g+p|0;if(m>>>0>=H>>>0)break;m=n-(e[G+(m<<1)>>1]|0)|0;if((m|0)<1)break;g=g+1|0;n=m<<1}o=l+(1<<g)|0;switch(d|0){case 1:{if(o>>>0>852){F=1;p=60;break a}break}case 2:{if(o>>>0>592){F=1;p=60;break a}break}default:{}}a[(c[h>>2]|0)+(r<<2)>>0]=g;a[(c[h>>2]|0)+(r<<2)+1>>0]=y;D=c[h>>2]|0;b[D+(r<<2)+2>>1]=(q-D|0)>>>2;D=p;p=s;n=t;v=r;C=q;m=w;l=o}if((p|0)==57){if(s|0){k=C+(s<<2)|0;d=H-D<<8&65280|64;b[k>>1]=d;b[k+2>>1]=d>>>16}c[h>>2]=(c[h>>2]|0)+(l<<2);c[j>>2]=E;k=0;i=I;return k|0}else if((p|0)==60){i=I;return F|0}return 0}function Ma(d,f,g,h){d=d|0;f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0;l=d+5820|0;k=c[l>>2]|0;i=h&65535;j=d+5816|0;h=e[j>>1]|0|i<<k;b[j>>1]=h;if((k|0)>13){n=d+20|0;k=c[n>>2]|0;c[n>>2]=k+1;m=d+8|0;a[(c[m>>2]|0)+k>>0]=h;h=(e[j>>1]|0)>>>8&255;k=c[n>>2]|0;c[n>>2]=k+1;a[(c[m>>2]|0)+k>>0]=h;k=c[l>>2]|0;h=i>>>(16-k|0);b[j>>1]=h;k=k+-13|0}else k=k+3|0;i=h&255;c[l>>2]=k;do if((k|0)<=8){h=d+5816|0;j=d+20|0;if((k|0)>0){m=c[j>>2]|0;c[j>>2]=m+1;n=d+8|0;a[(c[n>>2]|0)+m>>0]=i;i=n;break}else{i=d+8|0;break}}else{h=d+5816|0;j=d+20|0;m=c[j>>2]|0;c[j>>2]=m+1;n=d+8|0;a[(c[n>>2]|0)+m>>0]=i;m=(e[h>>1]|0)>>>8&255;i=c[j>>2]|0;c[j>>2]=i+1;a[(c[n>>2]|0)+i>>0]=m;i=n}while(0);b[h>>1]=0;c[l>>2]=0;m=c[j>>2]|0;c[j>>2]=m+1;a[(c[i>>2]|0)+m>>0]=g;m=g>>>8;n=c[j>>2]|0;c[j>>2]=n+1;a[(c[i>>2]|0)+n>>0]=m;n=c[j>>2]|0;c[j>>2]=n+1;a[(c[i>>2]|0)+n>>0]=g^255;n=c[j>>2]|0;c[j>>2]=n+1;a[(c[i>>2]|0)+n>>0]=m^255;while(1){if(!g)break;m=a[f>>0]|0;n=c[j>>2]|0;c[j>>2]=n+1;a[(c[i>>2]|0)+n>>0]=m;g=g+-1|0;f=f+1|0}return}function Na(d){d=d|0;var f=0,g=0,h=0,i=0,j=0,k=0;i=d+5820|0;h=c[i>>2]|0;g=d+5816|0;f=e[g>>1]|0|2<<h;b[g>>1]=f;if((h|0)>13){k=d+20|0;h=c[k>>2]|0;c[k>>2]=h+1;j=d+8|0;a[(c[j>>2]|0)+h>>0]=f;f=(e[g>>1]|0)>>>8&255;h=c[k>>2]|0;c[k>>2]=h+1;a[(c[j>>2]|0)+h>>0]=f;h=c[i>>2]|0;f=2>>>(16-h|0);b[g>>1]=f;g=h+-13|0}else g=h+3|0;f=f&255;c[i>>2]=g;if((g|0)>9){g=d+5816|0;h=d+20|0;j=c[h>>2]|0;c[h>>2]=j+1;k=d+8|0;a[(c[k>>2]|0)+j>>0]=f;j=(e[g>>1]|0)>>>8&255;f=c[h>>2]|0;c[h>>2]=f+1;a[(c[k>>2]|0)+f>>0]=j;b[g>>1]=0;f=0;g=(c[i>>2]|0)+-9|0}else g=g+7|0;c[i>>2]=g;if((g|0)==16){k=d+5816|0;g=d+20|0;h=c[g>>2]|0;c[g>>2]=h+1;d=d+8|0;a[(c[d>>2]|0)+h>>0]=f;h=(e[k>>1]|0)>>>8&255;j=c[g>>2]|0;c[g>>2]=j+1;a[(c[d>>2]|0)+j>>0]=h;b[k>>1]=0;c[i>>2]=0;return}if((g|0)<=7)return;k=d+5816|0;h=d+20|0;j=c[h>>2]|0;c[h>>2]=j+1;a[(c[d+8>>2]|0)+j>>0]=f;b[k>>1]=(e[k>>1]|0)>>>8;c[i>>2]=(c[i>>2]|0)+-8;return}function Oa(f,g,h,i){f=f|0;g=g|0;h=h|0;i=i|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;if((c[f+132>>2]|0)>0){m=(c[f>>2]|0)+44|0;if((c[m>>2]|0)==2){j=-201342849;k=0;while(1){if((k|0)>=32){l=7;break}if(j&1|0?b[f+148+(k<<2)>>1]|0:0){j=0;break}j=j>>>1;k=k+1|0}a:do if((l|0)==7)if(((b[f+184>>1]|0)==0?(b[f+188>>1]|0)==0:0)?(b[f+200>>1]|0)==0:0){j=32;while(1){if((j|0)>=256){j=0;break a}if(b[f+148+(j<<2)>>1]|0){j=1;break a}j=j+1|0}}else j=1;while(0);c[m>>2]=j}Pa(f,f+2840|0);Pa(f,f+2852|0);Ra(f,f+148|0,c[f+2844>>2]|0);Ra(f,f+2440|0,c[f+2856>>2]|0);Pa(f,f+2864|0);j=18;while(1){if((j|0)<=2)break;if(b[f+2684+(d[13881+j>>0]<<2)+2>>1]|0)break;j=j+-1|0}k=f+5800|0;r=(c[k>>2]|0)+((j*3|0)+17)|0;c[k>>2]=r;r=(r+10|0)>>>3;k=((c[f+5804>>2]|0)+10|0)>>>3;q=j+1|0;j=k>>>0>r>>>0?r:k}else{k=h+5|0;q=1;j=k}do if((h+4|0)>>>0>j>>>0|(g|0)==0){r=f+5820|0;g=c[r>>2]|0;m=(g|0)>13;if((k|0)==(j|0)?1:(c[f+136>>2]|0)==4){j=i+2&65535;k=f+5816|0;l=e[k>>1]|j<<g;b[k>>1]=l;if(m){n=f+20|0;o=c[n>>2]|0;c[n>>2]=o+1;p=f+8|0;a[(c[p>>2]|0)+o>>0]=l;o=(e[k>>1]|0)>>>8&255;q=c[n>>2]|0;c[n>>2]=q+1;a[(c[p>>2]|0)+q>>0]=o;q=c[r>>2]|0;b[k>>1]=j>>>(16-q|0);j=q+-13|0}else j=g+3|0;c[r>>2]=j;Sa(f,11394,12546);j=0;break}l=i+4&65535;j=f+5816|0;k=e[j>>1]|l<<g;b[j>>1]=k;if(m){o=f+20|0;g=c[o>>2]|0;c[o>>2]=g+1;p=f+8|0;a[(c[p>>2]|0)+g>>0]=k;k=(e[j>>1]|0)>>>8&255;g=c[o>>2]|0;c[o>>2]=g+1;a[(c[p>>2]|0)+g>>0]=k;g=c[r>>2]|0;k=l>>>(16-g|0);b[j>>1]=k;g=g+-13|0}else g=g+3|0;c[r>>2]=g;o=c[f+2844>>2]|0;p=c[f+2856>>2]|0;l=o+65280&65535;m=f+5816|0;j=k&65535|l<<g;b[m>>1]=j;if((g|0)>11){g=f+20|0;n=c[g>>2]|0;c[g>>2]=n+1;h=f+8|0;a[(c[h>>2]|0)+n>>0]=j;j=(e[m>>1]|0)>>>8&255;n=c[g>>2]|0;c[g>>2]=n+1;a[(c[h>>2]|0)+n>>0]=j;n=c[r>>2]|0;j=l>>>(16-n|0);b[m>>1]=j;m=n+-11|0}else m=g+5|0;c[r>>2]=m;k=p&65535;l=f+5816|0;j=j&65535|k<<m;b[l>>1]=j;if((m|0)>11){g=f+20|0;n=c[g>>2]|0;c[g>>2]=n+1;h=f+8|0;a[(c[h>>2]|0)+n>>0]=j;j=(e[l>>1]|0)>>>8&255;n=c[g>>2]|0;c[g>>2]=n+1;a[(c[h>>2]|0)+n>>0]=j;n=c[r>>2]|0;j=k>>>(16-n|0);b[l>>1]=j;l=n+-11|0}else l=m+5|0;c[r>>2]=l;k=q+65532&65535;n=f+5816|0;j=j&65535|k<<l;b[n>>1]=j;if((l|0)>12){h=f+20|0;m=c[h>>2]|0;c[h>>2]=m+1;g=f+8|0;a[(c[g>>2]|0)+m>>0]=j;m=(e[n>>1]|0)>>>8&255;j=c[h>>2]|0;c[h>>2]=j+1;a[(c[g>>2]|0)+j>>0]=m;j=c[r>>2]|0;k=k>>>(16-j|0);b[n>>1]=k;j=j+-12|0;c[r>>2]=j}else{m=l+4|0;c[r>>2]=m;g=f+8|0;h=f+20|0;k=j;j=m}m=0;while(1){if((m|0)>=(q|0))break;l=e[f+2684+(d[13881+m>>0]<<2)+2>>1]|0;k=k&65535|l<<j;b[n>>1]=k;if((j|0)>13){j=c[h>>2]|0;c[h>>2]=j+1;a[(c[g>>2]|0)+j>>0]=k;k=(e[n>>1]|0)>>>8&255;j=c[h>>2]|0;c[h>>2]=j+1;a[(c[g>>2]|0)+j>>0]=k;j=c[r>>2]|0;k=l>>>(16-j|0);b[n>>1]=k;j=j+-13|0}else j=j+3|0;c[r>>2]=j;m=m+1|0}r=f+148|0;Ta(f,r,o);j=f+2440|0;Ta(f,j,p);Sa(f,r,j);j=0}else{Ma(f,g,h,i);j=0}while(0);while(1){if((j|0)==286){j=0;break}b[f+148+(j<<2)>>1]=0;j=j+1|0}while(1){if((j|0)==30){j=0;break}b[f+2440+(j<<2)>>1]=0;j=j+1|0}while(1){if((j|0)==19)break;b[f+2684+(j<<2)>>1]=0;j=j+1|0}b[f+1172>>1]=1;c[f+5804>>2]=0;c[f+5800>>2]=0;c[f+5808>>2]=0;c[f+5792>>2]=0;if(!i)return;l=f+5820|0;k=c[l>>2]|0;if((k|0)<=8){j=f+5816|0;if((k|0)>0){r=b[j>>1]&255;q=f+20|0;i=c[q>>2]|0;c[q>>2]=i+1;a[(c[f+8>>2]|0)+i>>0]=r}}else{j=f+5816|0;p=b[j>>1]&255;q=f+20|0;r=c[q>>2]|0;c[q>>2]=r+1;i=f+8|0;a[(c[i>>2]|0)+r>>0]=p;r=(e[j>>1]|0)>>>8&255;f=c[q>>2]|0;c[q>>2]=f+1;a[(c[i>>2]|0)+f>>0]=r}b[j>>1]=0;c[l>>2]=0;return}function Pa(d,f){d=d|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;z=i;i=i+32|0;y=z;x=c[f>>2]|0;o=f+8|0;m=c[o>>2]|0;l=c[m>>2]|0;m=c[m+12>>2]|0;n=d+5200|0;c[n>>2]=0;r=d+5204|0;c[r>>2]=573;g=-1;h=0;while(1){if((h|0)>=(m|0))break;if(!(b[x+(h<<2)>>1]|0))b[x+(h<<2)+2>>1]=0;else{g=(c[n>>2]|0)+1|0;c[n>>2]=g;c[d+2908+(g<<2)>>2]=h;a[d+5208+h>>0]=0;g=h}h=h+1|0}v=d+5800|0;k=(l|0)==0;s=d+5804|0;w=g;while(1){j=c[n>>2]|0;if((j|0)>=2)break;u=(w|0)<2;g=w+1|0;h=u?g:w;g=u?g:0;w=j+1|0;c[n>>2]=w;c[d+2908+(w<<2)>>2]=g;b[x+(g<<2)>>1]=1;a[d+5208+g>>0]=0;c[v>>2]=(c[v>>2]|0)+-1;if(k){w=h;continue}c[s>>2]=(c[s>>2]|0)-(e[l+(g<<2)+2>>1]|0);w=h}k=f+4|0;c[k>>2]=w;g=(c[n>>2]|0)/2|0;while(1){if((g|0)<=0)break;Qa(d,x,g);g=g+-1|0}h=d+2912|0;j=c[n>>2]|0;g=m;while(1){u=c[h>>2]|0;c[n>>2]=j+-1;c[h>>2]=c[d+2908+(j<<2)>>2];Qa(d,x,1);q=c[h>>2]|0;t=(c[r>>2]|0)+-1|0;c[r>>2]=t;c[d+2908+(t<<2)>>2]=u;t=(c[r>>2]|0)+-1|0;c[r>>2]=t;c[d+2908+(t<<2)>>2]=q;b[x+(g<<2)>>1]=(e[x+(u<<2)>>1]|0)+(e[x+(q<<2)>>1]|0);t=a[d+5208+u>>0]|0;p=a[d+5208+q>>0]|0;a[d+5208+g>>0]=(((t&255)<(p&255)?p:t)&255)+1;t=g&65535;b[x+(q<<2)+2>>1]=t;b[x+(u<<2)+2>>1]=t;c[h>>2]=g;Qa(d,x,1);j=c[n>>2]|0;if((j|0)<=1)break;else g=g+1|0}t=c[h>>2]|0;u=(c[r>>2]|0)+-1|0;c[r>>2]=u;c[d+2908+(u<<2)>>2]=t;u=c[f>>2]|0;t=c[k>>2]|0;q=c[o>>2]|0;f=c[q>>2]|0;o=c[q+4>>2]|0;p=c[q+8>>2]|0;q=c[q+16>>2]|0;g=0;while(1){if((g|0)==16)break;b[d+2876+(g<<1)>>1]=0;g=g+1|0}b[u+(c[d+2908+(c[r>>2]<<2)>>2]<<2)+2>>1]=0;n=(f|0)==0;g=c[r>>2]|0;m=0;while(1){g=g+1|0;if((g|0)>=573)break;l=c[d+2908+(g<<2)>>2]|0;r=u+(l<<2)+2|0;k=e[u+(e[r>>1]<<2)+2>>1]|0;j=(k|0)<(q|0);k=j?k+1|0:q;m=m+(j&1^1)|0;b[r>>1]=k;if((l|0)>(t|0))continue;r=d+2876+(k<<1)|0;b[r>>1]=(b[r>>1]|0)+1<<16>>16;if((l|0)<(p|0))j=0;else j=c[o+(l-p<<2)>>2]|0;h=e[u+(l<<2)>>1]|0;r=Z(h,k+j|0)|0;c[v>>2]=(c[v>>2]|0)+r;if(n)continue;r=Z(h,(e[f+(l<<2)+2>>1]|0)+j|0)|0;c[s>>2]=(c[s>>2]|0)+r}a:do if(m|0){n=d+2876+(q<<1)|0;while(1){l=q;while(1){k=l+-1|0;h=d+2876+(k<<1)|0;j=b[h>>1]|0;if(!(j<<16>>16))l=k;else break}b[h>>1]=j+-1<<16>>16;s=d+2876+(l<<1)|0;b[s>>1]=(e[s>>1]|0)+2;b[n>>1]=(b[n>>1]|0)+-1<<16>>16;if((m|0)>2)m=m+-2|0;else{n=q;break}}while(1){if(!n)break a;m=n&65535;l=e[d+2876+(n<<1)>>1]|0;b:while(1){h=(l|0)==0;do{if(h)break b;g=g+-1|0;k=c[d+2908+(g<<2)>>2]|0}while((k|0)>(t|0));h=u+(k<<2)+2|0;j=e[h>>1]|0;if((n|0)!=(j|0)){s=Z(n-j|0,e[u+(k<<2)>>1]|0)|0;c[v>>2]=(c[v>>2]|0)+s;b[h>>1]=m}l=l+-1|0}n=n+-1|0}}while(0);g=1;h=0;while(1){if((g|0)==16){k=0;break}v=(h&65534)+(e[d+2876+(g+-1<<1)>>1]|0)<<1;b[y+(g<<1)>>1]=v;g=g+1|0;h=v}while(1){if((k|0)>(w|0))break;d=b[x+(k<<2)+2>>1]|0;g=d&65535;if(d<<16>>16){h=y+(g<<1)|0;j=b[h>>1]|0;b[h>>1]=j+1<<16>>16;j=j&65535;h=0;while(1){h=h|j&1;if((g|0)>1){j=j>>>1;g=g+-1|0;h=h<<1}else break}b[x+(k<<2)>>1]=h}k=k+1|0}i=z;return}function Qa(a,e,f){a=a|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;p=c[a+2908+(f<<2)>>2]|0;m=a+5208+p|0;n=a+5200|0;o=e+(p<<2)|0;l=f;while(1){k=l<<1;f=c[n>>2]|0;if((k|0)>(f|0)){f=12;break}do if((k|0)<(f|0)){i=k|1;f=c[a+2908+(i<<2)>>2]|0;g=b[e+(f<<2)>>1]|0;h=c[a+2908+(k<<2)>>2]|0;j=b[e+(h<<2)>>1]|0;if((g&65535)>=(j&65535)){if(g<<16>>16!=j<<16>>16){i=k;break}if((d[a+5208+f>>0]|0)>(d[a+5208+h>>0]|0)){i=k;break}}}else i=k;while(0);f=b[o>>1]|0;g=c[a+2908+(i<<2)>>2]|0;h=b[e+(g<<2)>>1]|0;if((f&65535)<(h&65535)){f=12;break}if(f<<16>>16==h<<16>>16?(d[m>>0]|0)<=(d[a+5208+g>>0]|0):0){f=12;break}c[a+2908+(l<<2)>>2]=g;l=i}if((f|0)==12){c[a+2908+(l<<2)>>2]=p;return}}function Ra(a,c,d){a=a|0;c=c|0;d=d|0;var f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;o=b[c+2>>1]|0;n=o<<16>>16==0;b[c+(d+1<<2)+2>>1]=-1;j=a+2752|0;k=a+2756|0;l=a+2748|0;g=0;m=n?138:7;n=n?3:4;f=0;o=o&65535;p=-1;while(1){if((f|0)>(d|0))break;f=f+1|0;h=b[c+(f<<2)+2>>1]|0;i=h&65535;g=g+1|0;if((g|0)<(m|0)&(o|0)==(i|0)){h=p;o=i;p=h;continue}do if((g|0)>=(n|0))if(!o)if((g|0)<11){b[j>>1]=(b[j>>1]|0)+1<<16>>16;break}else{b[k>>1]=(b[k>>1]|0)+1<<16>>16;break}else{if((o|0)!=(p|0)){p=a+2684+(o<<2)|0;b[p>>1]=(b[p>>1]|0)+1<<16>>16}b[l>>1]=(b[l>>1]|0)+1<<16>>16;break}else{p=a+2684+(o<<2)|0;b[p>>1]=(e[p>>1]|0)+g}while(0);if(!(h<<16>>16)){p=o;g=0;m=138;n=3;o=i;continue}n=(o|0)==(i|0);p=o;g=0;m=n?6:7;n=n?3:4;o=i}return}function Sa(f,g,h){f=f|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;r=f+5792|0;if(!(c[r>>2]|0)){m=f+5820|0;n=m;m=c[m>>2]|0}else{s=f+5796|0;t=f+5784|0;n=f+5820|0;u=f+5816|0;v=f+20|0;w=f+8|0;x=0;do{o=b[(c[s>>2]|0)+(x<<1)>>1]|0;q=o&65535;p=d[(c[t>>2]|0)+x>>0]|0;x=x+1|0;do if(!(o<<16>>16)){k=e[g+(p<<2)+2>>1]|0;l=c[n>>2]|0;i=e[g+(p<<2)>>1]|0;j=e[u>>1]|0|i<<l;b[u>>1]=j;if((l|0)>(16-k|0)){q=c[v>>2]|0;c[v>>2]=q+1;a[(c[w>>2]|0)+q>>0]=j;q=(e[u>>1]|0)>>>8&255;m=c[v>>2]|0;c[v>>2]=m+1;a[(c[w>>2]|0)+m>>0]=q;m=c[n>>2]|0;b[u>>1]=i>>>(16-m|0);m=m+(k+-16)|0;c[n>>2]=m;break}else{m=l+k|0;c[n>>2]=m;break}}else{o=d[13625+p>>0]|0;i=(o|256)+1|0;l=e[g+(i<<2)+2>>1]|0;m=c[n>>2]|0;i=e[g+(i<<2)>>1]|0;k=e[u>>1]|0|i<<m;j=k&65535;b[u>>1]=j;if((m|0)>(16-l|0)){j=c[v>>2]|0;c[v>>2]=j+1;a[(c[w>>2]|0)+j>>0]=k;j=(e[u>>1]|0)>>>8&255;m=c[v>>2]|0;c[v>>2]=m+1;a[(c[w>>2]|0)+m>>0]=j;m=c[n>>2]|0;j=i>>>(16-m|0)&65535;b[u>>1]=j;m=m+(l+-16)|0}else m=m+l|0;c[n>>2]=m;l=c[148+(o<<2)>>2]|0;do if((o+-8|0)>>>0<20){k=p-(c[500+(o<<2)>>2]|0)&65535;i=j&65535|k<<m;j=i&65535;b[u>>1]=j;if((m|0)>(16-l|0)){j=c[v>>2]|0;c[v>>2]=j+1;a[(c[w>>2]|0)+j>>0]=i;j=(e[u>>1]|0)>>>8&255;m=c[v>>2]|0;c[v>>2]=m+1;a[(c[w>>2]|0)+m>>0]=j;m=c[n>>2]|0;j=k>>>(16-m|0)&65535;b[u>>1]=j;m=m+(l+-16)|0;c[n>>2]=m;break}else{m=m+l|0;c[n>>2]=m;break}}while(0);o=q+-1|0;p=d[13113+(o>>>0<256?o:(o>>>7)+256|0)>>0]|0;l=e[h+(p<<2)+2>>1]|0;k=e[h+(p<<2)>>1]|0;i=j&65535|k<<m;b[u>>1]=i;if((m|0)>(16-l|0)){m=c[v>>2]|0;c[v>>2]=m+1;a[(c[w>>2]|0)+m>>0]=i;i=(e[u>>1]|0)>>>8&255;m=c[v>>2]|0;c[v>>2]=m+1;a[(c[w>>2]|0)+m>>0]=i;m=c[n>>2]|0;i=k>>>(16-m|0);b[u>>1]=i;m=m+(l+-16)|0}else m=m+l|0;c[n>>2]=m;k=c[284+(p<<2)>>2]|0;if((p+-4|0)>>>0<26){j=o-(c[616+(p<<2)>>2]|0)&65535;i=i&65535|j<<m;b[u>>1]=i;if((m|0)>(16-k|0)){q=c[v>>2]|0;c[v>>2]=q+1;a[(c[w>>2]|0)+q>>0]=i;q=(e[u>>1]|0)>>>8&255;m=c[v>>2]|0;c[v>>2]=m+1;a[(c[w>>2]|0)+m>>0]=q;m=c[n>>2]|0;b[u>>1]=j>>>(16-m|0);m=m+(k+-16)|0;c[n>>2]=m;break}else{m=m+k|0;c[n>>2]=m;break}}}while(0)}while(x>>>0<(c[r>>2]|0)>>>0)}l=e[g+1026>>1]|0;i=e[g+1024>>1]|0;j=f+5816|0;k=e[j>>1]|0|i<<m;b[j>>1]=k;if((m|0)>(16-l|0)){h=f+20|0;x=c[h>>2]|0;c[h>>2]=x+1;g=f+8|0;a[(c[g>>2]|0)+x>>0]=k;x=(e[j>>1]|0)>>>8&255;f=c[h>>2]|0;c[h>>2]=f+1;a[(c[g>>2]|0)+f>>0]=x;f=c[n>>2]|0;b[j>>1]=i>>>(16-f|0);f=f+(l+-16)|0;c[n>>2]=f;return}else{f=m+l|0;c[n>>2]=f;return}}function Ta(d,f,g){d=d|0;f=f|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;C=b[f+2>>1]|0;j=C<<16>>16==0;w=d+2754|0;x=d+5820|0;y=d+2752|0;z=d+5816|0;A=d+20|0;B=d+8|0;r=d+2758|0;s=d+2756|0;t=d+2750|0;u=d+2748|0;n=0;i=j?138:7;j=j?3:4;h=0;C=C&65535;k=-1;while(1){if((h|0)>(g|0))break;p=h+1|0;q=b[f+(p<<2)+2>>1]|0;v=q&65535;m=n+1|0;if((m|0)<(i|0)&(C|0)==(v|0)){q=k;n=m;h=p;C=v;k=q;continue}do if((m|0)>=(j|0)){if(C|0){do if((C|0)!=(k|0)){h=e[d+2684+(C<<2)+2>>1]|0;i=c[x>>2]|0;j=e[d+2684+(C<<2)>>1]|0;k=e[z>>1]|0|j<<i;b[z>>1]=k;if((i|0)>(16-h|0)){l=c[A>>2]|0;c[A>>2]=l+1;a[(c[B>>2]|0)+l>>0]=k;k=(e[z>>1]|0)>>>8&255;l=c[A>>2]|0;c[A>>2]=l+1;a[(c[B>>2]|0)+l>>0]=k;l=c[x>>2]|0;b[z>>1]=j>>>(16-l|0);l=l+(h+-16)|0;c[x>>2]=l;k=n;break}else{l=i+h|0;c[x>>2]=l;k=n;break}}else{l=c[x>>2]|0;k=m}while(0);j=e[t>>1]|0;i=e[u>>1]|0;h=e[z>>1]|0|i<<l;b[z>>1]=h;if((l|0)>(16-j|0)){o=c[A>>2]|0;c[A>>2]=o+1;a[(c[B>>2]|0)+o>>0]=h;h=(e[z>>1]|0)>>>8&255;o=c[A>>2]|0;c[A>>2]=o+1;a[(c[B>>2]|0)+o>>0]=h;o=c[x>>2]|0;h=i>>>(16-o|0);b[z>>1]=h;j=o+(j+-16)|0}else j=l+j|0;c[x>>2]=j;i=k+65533&65535;h=h&65535|i<<j;b[z>>1]=h;if((j|0)>14){n=c[A>>2]|0;c[A>>2]=n+1;a[(c[B>>2]|0)+n>>0]=h;n=(e[z>>1]|0)>>>8&255;o=c[A>>2]|0;c[A>>2]=o+1;a[(c[B>>2]|0)+o>>0]=n;o=c[x>>2]|0;b[z>>1]=i>>>(16-o|0);c[x>>2]=o+-14;break}else{c[x>>2]=j+2;break}}if((m|0)<11){j=e[w>>1]|0;k=c[x>>2]|0;h=e[y>>1]|0;i=e[z>>1]|0|h<<k;b[z>>1]=i;if((k|0)>(16-j|0)){m=c[A>>2]|0;c[A>>2]=m+1;a[(c[B>>2]|0)+m>>0]=i;m=(e[z>>1]|0)>>>8&255;o=c[A>>2]|0;c[A>>2]=o+1;a[(c[B>>2]|0)+o>>0]=m;o=c[x>>2]|0;h=h>>>(16-o|0);b[z>>1]=h;j=o+(j+-16)|0}else{h=i;j=k+j|0}c[x>>2]=j;i=n+65534&65535;h=h&65535|i<<j;b[z>>1]=h;if((j|0)>13){n=c[A>>2]|0;c[A>>2]=n+1;a[(c[B>>2]|0)+n>>0]=h;n=(e[z>>1]|0)>>>8&255;o=c[A>>2]|0;c[A>>2]=o+1;a[(c[B>>2]|0)+o>>0]=n;o=c[x>>2]|0;b[z>>1]=i>>>(16-o|0);c[x>>2]=o+-13;break}else{c[x>>2]=j+3;break}}else{j=e[r>>1]|0;k=c[x>>2]|0;h=e[s>>1]|0;i=e[z>>1]|0|h<<k;b[z>>1]=i;if((k|0)>(16-j|0)){m=c[A>>2]|0;c[A>>2]=m+1;a[(c[B>>2]|0)+m>>0]=i;m=(e[z>>1]|0)>>>8&255;o=c[A>>2]|0;c[A>>2]=o+1;a[(c[B>>2]|0)+o>>0]=m;o=c[x>>2]|0;h=h>>>(16-o|0);b[z>>1]=h;j=o+(j+-16)|0}else{h=i;j=k+j|0}c[x>>2]=j;i=n+65526&65535;h=h&65535|i<<j;b[z>>1]=h;if((j|0)>9){n=c[A>>2]|0;c[A>>2]=n+1;a[(c[B>>2]|0)+n>>0]=h;n=(e[z>>1]|0)>>>8&255;o=c[A>>2]|0;c[A>>2]=o+1;a[(c[B>>2]|0)+o>>0]=n;o=c[x>>2]|0;b[z>>1]=i>>>(16-o|0);c[x>>2]=o+-9;break}else{c[x>>2]=j+7;break}}}else{n=d+2684+(C<<2)+2|0;o=d+2684+(C<<2)|0;h=c[x>>2]|0;l=m;do{i=e[n>>1]|0;j=e[o>>1]|0;k=e[z>>1]|0|j<<h;b[z>>1]=k;if((h|0)>(16-i|0)){m=c[A>>2]|0;c[A>>2]=m+1;a[(c[B>>2]|0)+m>>0]=k;m=(e[z>>1]|0)>>>8&255;h=c[A>>2]|0;c[A>>2]=h+1;a[(c[B>>2]|0)+h>>0]=m;h=c[x>>2]|0;b[z>>1]=j>>>(16-h|0);h=h+(i+-16)|0}else h=h+i|0;c[x>>2]=h;l=l+-1|0}while((l|0)!=0)}while(0);if(!(q<<16>>16)){k=C;n=0;i=138;j=3;h=p;C=v;continue}j=(C|0)==(v|0);k=C;n=0;i=j?6:7;j=j?3:4;h=p;C=v}return}function Ua(a,b,c){a=a|0;b=b|0;c=c|0;return Ya(Z(b,c)|0)|0}function Va(a,b){a=a|0;b=b|0;Za(b);return}function Wa(a,b,c){a=a|0;b=b|0;c=c|0;var e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;e=a>>>16;a=a&65535;if((c|0)==1){g=a+(d[b>>0]|0)|0;g=g>>>0>65520?g+-65521|0:g;h=e+g|0;h=g|(h>>>0>65520?h+15|0:h)<<16;return h|0}if(!b){h=1;return h|0}if(c>>>0<16){while(1){if(!c)break;h=a+(d[b>>0]|0)|0;b=b+1|0;c=c+-1|0;a=h;e=e+h|0}h=(a>>>0>65520?a+-65521|0:a)|((e>>>0)%65521|0)<<16;return h|0}while(1){if(c>>>0<=5551)break;c=c+-5552|0;g=b;f=347;while(1){v=a+(d[g>>0]|0)|0;u=v+(d[g+1>>0]|0)|0;t=u+(d[g+2>>0]|0)|0;s=t+(d[g+3>>0]|0)|0;r=s+(d[g+4>>0]|0)|0;q=r+(d[g+5>>0]|0)|0;p=q+(d[g+6>>0]|0)|0;o=p+(d[g+7>>0]|0)|0;n=o+(d[g+8>>0]|0)|0;m=n+(d[g+9>>0]|0)|0;l=m+(d[g+10>>0]|0)|0;k=l+(d[g+11>>0]|0)|0;j=k+(d[g+12>>0]|0)|0;i=j+(d[g+13>>0]|0)|0;h=i+(d[g+14>>0]|0)|0;a=h+(d[g+15>>0]|0)|0;e=e+v+u+t+s+r+q+p+o+n+m+l+k+j+i+h+a|0;f=f+-1|0;if(!f)break;else g=g+16|0}b=b+5552|0;a=(a>>>0)%65521|0;e=(e>>>0)%65521|0}if(c){g=c+~(c>>>0<15?c:15)+16&-16;h=b+g|0;f=c;while(1){if(f>>>0<=15)break;x=a+(d[b>>0]|0)|0;w=x+(d[b+1>>0]|0)|0;i=w+(d[b+2>>0]|0)|0;j=i+(d[b+3>>0]|0)|0;k=j+(d[b+4>>0]|0)|0;l=k+(d[b+5>>0]|0)|0;m=l+(d[b+6>>0]|0)|0;n=m+(d[b+7>>0]|0)|0;o=n+(d[b+8>>0]|0)|0;p=o+(d[b+9>>0]|0)|0;q=p+(d[b+10>>0]|0)|0;r=q+(d[b+11>>0]|0)|0;s=r+(d[b+12>>0]|0)|0;t=s+(d[b+13>>0]|0)|0;u=t+(d[b+14>>0]|0)|0;v=u+(d[b+15>>0]|0)|0;f=f+-16|0;b=b+16|0;a=v;e=e+x+w+i+j+k+l+m+n+o+p+q+r+s+t+u+v|0}c=c-g|0;b=h;while(1){if(!c)break;x=a+(d[b>>0]|0)|0;c=c+-1|0;b=b+1|0;a=x;e=e+x|0}a=(a>>>0)%65521|0;e=(e>>>0)%65521|0}x=a|e<<16;return x|0}function Xa(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,g=0,h=0,i=0,j=0;if(!b){i=0;return i|0}h=b;b=~a;while(1){if(!e){e=0;break}if(!(h&3))break;i=c[736+((b&255^(d[h>>0]|0))<<2)>>2]^b>>>8;h=h+1|0;e=e+-1|0;b=i}g=e+~(e>>>0<31?e:31)+32&-32;i=h+g|0;f=e;a=h;while(1){if(f>>>0<=31)break;h=b^c[a>>2];h=c[3808+((h&255)<<2)>>2]^c[2784+((h>>>8&255)<<2)>>2]^c[1760+((h>>>16&255)<<2)>>2]^c[736+(h>>>24<<2)>>2]^c[a+4>>2];h=c[3808+((h&255)<<2)>>2]^c[2784+((h>>>8&255)<<2)>>2]^c[1760+((h>>>16&255)<<2)>>2]^c[736+(h>>>24<<2)>>2]^c[a+8>>2];h=c[3808+((h&255)<<2)>>2]^c[2784+((h>>>8&255)<<2)>>2]^c[1760+((h>>>16&255)<<2)>>2]^c[736+(h>>>24<<2)>>2]^c[a+12>>2];h=c[3808+((h&255)<<2)>>2]^c[2784+((h>>>8&255)<<2)>>2]^c[1760+((h>>>16&255)<<2)>>2]^c[736+(h>>>24<<2)>>2]^c[a+16>>2];h=c[3808+((h&255)<<2)>>2]^c[2784+((h>>>8&255)<<2)>>2]^c[1760+((h>>>16&255)<<2)>>2]^c[736+(h>>>24<<2)>>2]^c[a+20>>2];h=c[3808+((h&255)<<2)>>2]^c[2784+((h>>>8&255)<<2)>>2]^c[1760+((h>>>16&255)<<2)>>2]^c[736+(h>>>24<<2)>>2]^c[a+24>>2];h=c[3808+((h&255)<<2)>>2]^c[2784+((h>>>8&255)<<2)>>2]^c[1760+((h>>>16&255)<<2)>>2]^c[736+(h>>>24<<2)>>2]^c[a+28>>2];f=f+-32|0;a=a+32|0;b=c[3808+((h&255)<<2)>>2]^c[2784+((h>>>8&255)<<2)>>2]^c[1760+((h>>>16&255)<<2)>>2]^c[736+(h>>>24<<2)>>2]}g=e-g|0;a=(g+~(g>>>0<3?g:3)+4|0)>>>2;h=a<<2;e=g;f=i;while(1){if(e>>>0<=3)break;j=b^c[f>>2];e=e+-4|0;f=f+4|0;b=c[3808+((j&255)<<2)>>2]^c[2784+((j>>>8&255)<<2)>>2]^c[1760+((j>>>16&255)<<2)>>2]^c[736+(j>>>24<<2)>>2]}if((g|0)!=(h|0)){a=i+(a<<2)|0;e=g-h|0;while(1){b=c[736+((b&255^(d[a>>0]|0))<<2)>>2]^b>>>8;e=e+-1|0;if(!e)break;else a=a+1|0}}j=~b;return j|0}function Ya(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0;K=i;i=i+16|0;q=K;do if(a>>>0<245){p=a>>>0<11?16:a+11&-8;a=p>>>3;k=c[3522]|0;b=k>>>a;if(b&3|0){f=(b&1^1)+a|0;g=14128+(f<<1<<2)|0;b=g+8|0;d=c[b>>2]|0;h=d+8|0;e=c[h>>2]|0;do if((g|0)!=(e|0)){if(e>>>0<(c[3526]|0)>>>0)ha();a=e+12|0;if((c[a>>2]|0)==(d|0)){c[a>>2]=g;c[b>>2]=e;break}else ha()}else c[3522]=k&~(1<<f);while(0);J=f<<3;c[d+4>>2]=J|3;J=d+J+4|0;c[J>>2]=c[J>>2]|1;J=h;i=K;return J|0}h=c[3524]|0;if(p>>>0>h>>>0){if(b|0){f=2<<a;f=b<<a&(f|0-f);f=(f&0-f)+-1|0;j=f>>>12&16;f=f>>>j;b=f>>>5&8;f=f>>>b;g=f>>>2&4;f=f>>>g;d=f>>>1&2;f=f>>>d;e=f>>>1&1;e=(b|j|g|d|e)+(f>>>e)|0;f=14128+(e<<1<<2)|0;d=f+8|0;g=c[d>>2]|0;j=g+8|0;b=c[j>>2]|0;do if((f|0)!=(b|0)){if(b>>>0<(c[3526]|0)>>>0)ha();a=b+12|0;if((c[a>>2]|0)==(g|0)){c[a>>2]=f;c[d>>2]=b;l=c[3524]|0;break}else ha()}else{c[3522]=k&~(1<<e);l=h}while(0);h=(e<<3)-p|0;c[g+4>>2]=p|3;f=g+p|0;c[f+4>>2]=h|1;c[f+h>>2]=h;if(l|0){e=c[3527]|0;b=l>>>3;d=14128+(b<<1<<2)|0;a=c[3522]|0;b=1<<b;if(a&b){a=d+8|0;b=c[a>>2]|0;if(b>>>0<(c[3526]|0)>>>0)ha();else{m=a;n=b}}else{c[3522]=a|b;m=d+8|0;n=d}c[m>>2]=e;c[n+12>>2]=e;c[e+8>>2]=n;c[e+12>>2]=d}c[3524]=h;c[3527]=f;J=j;i=K;return J|0}a=c[3523]|0;if(a){j=(a&0-a)+-1|0;I=j>>>12&16;j=j>>>I;H=j>>>5&8;j=j>>>H;J=j>>>2&4;j=j>>>J;b=j>>>1&2;j=j>>>b;k=j>>>1&1;k=c[14392+((H|I|J|b|k)+(j>>>k)<<2)>>2]|0;j=(c[k+4>>2]&-8)-p|0;b=k;while(1){a=c[b+16>>2]|0;if(!a){a=c[b+20>>2]|0;if(!a)break}b=(c[a+4>>2]&-8)-p|0;J=b>>>0<j>>>0;j=J?b:j;b=a;k=J?a:k}f=c[3526]|0;if(k>>>0<f>>>0)ha();h=k+p|0;if(k>>>0>=h>>>0)ha();g=c[k+24>>2]|0;d=c[k+12>>2]|0;do if((d|0)==(k|0)){b=k+20|0;a=c[b>>2]|0;if(!a){b=k+16|0;a=c[b>>2]|0;if(!a){o=0;break}}while(1){e=a+20|0;d=c[e>>2]|0;if(d|0){a=d;b=e;continue}e=a+16|0;d=c[e>>2]|0;if(!d)break;else{a=d;b=e}}if(b>>>0<f>>>0)ha();else{c[b>>2]=0;o=a;break}}else{e=c[k+8>>2]|0;if(e>>>0<f>>>0)ha();a=e+12|0;if((c[a>>2]|0)!=(k|0))ha();b=d+8|0;if((c[b>>2]|0)==(k|0)){c[a>>2]=d;c[b>>2]=e;o=d;break}else ha()}while(0);do if(g|0){a=c[k+28>>2]|0;b=14392+(a<<2)|0;if((k|0)==(c[b>>2]|0)){c[b>>2]=o;if(!o){c[3523]=c[3523]&~(1<<a);break}}else{if(g>>>0<(c[3526]|0)>>>0)ha();a=g+16|0;if((c[a>>2]|0)==(k|0))c[a>>2]=o;else c[g+20>>2]=o;if(!o)break}b=c[3526]|0;if(o>>>0<b>>>0)ha();c[o+24>>2]=g;a=c[k+16>>2]|0;do if(a|0)if(a>>>0<b>>>0)ha();else{c[o+16>>2]=a;c[a+24>>2]=o;break}while(0);a=c[k+20>>2]|0;if(a|0)if(a>>>0<(c[3526]|0)>>>0)ha();else{c[o+20>>2]=a;c[a+24>>2]=o;break}}while(0);if(j>>>0<16){J=j+p|0;c[k+4>>2]=J|3;J=k+J+4|0;c[J>>2]=c[J>>2]|1}else{c[k+4>>2]=p|3;c[h+4>>2]=j|1;c[h+j>>2]=j;a=c[3524]|0;if(a|0){e=c[3527]|0;b=a>>>3;d=14128+(b<<1<<2)|0;a=c[3522]|0;b=1<<b;if(a&b){a=d+8|0;b=c[a>>2]|0;if(b>>>0<(c[3526]|0)>>>0)ha();else{r=a;s=b}}else{c[3522]=a|b;r=d+8|0;s=d}c[r>>2]=e;c[s+12>>2]=e;c[e+8>>2]=s;c[e+12>>2]=d}c[3524]=j;c[3527]=h}J=k+8|0;i=K;return J|0}}}else if(a>>>0<=4294967231){a=a+11|0;p=a&-8;k=c[3523]|0;if(k){b=0-p|0;a=a>>>8;if(a)if(p>>>0>16777215)j=31;else{s=(a+1048320|0)>>>16&8;C=a<<s;r=(C+520192|0)>>>16&4;C=C<<r;j=(C+245760|0)>>>16&2;j=14-(r|s|j)+(C<<j>>>15)|0;j=p>>>(j+7|0)&1|j<<1}else j=0;d=c[14392+(j<<2)>>2]|0;a:do if(!d){e=b;a=0;b=0;C=86}else{e=b;a=0;h=p<<((j|0)==31?0:25-(j>>>1)|0);b=0;while(1){f=c[d+4>>2]&-8;g=f-p|0;if(g>>>0<e>>>0)if((f|0)==(p|0)){e=g;a=d;b=d;C=90;break a}else{e=g;b=d}f=c[d+20>>2]|0;d=c[d+16+(h>>>31<<2)>>2]|0;a=(f|0)==0|(f|0)==(d|0)?a:f;f=(d|0)==0;if(f){C=86;break}else h=h<<(f&1^1)}}while(0);if((C|0)==86){if((a|0)==0&(b|0)==0){a=2<<j;a=k&(a|0-a);if(!a)break;s=(a&0-a)+-1|0;n=s>>>12&16;s=s>>>n;m=s>>>5&8;s=s>>>m;o=s>>>2&4;s=s>>>o;r=s>>>1&2;s=s>>>r;a=s>>>1&1;a=c[14392+((m|n|o|r|a)+(s>>>a)<<2)>>2]|0}if(!a){j=e;k=b}else C=90}if((C|0)==90)while(1){C=0;s=(c[a+4>>2]&-8)-p|0;d=s>>>0<e>>>0;e=d?s:e;b=d?a:b;d=c[a+16>>2]|0;if(d|0){a=d;C=90;continue}a=c[a+20>>2]|0;if(!a){j=e;k=b;break}else C=90}if((k|0)!=0?j>>>0<((c[3524]|0)-p|0)>>>0:0){f=c[3526]|0;if(k>>>0<f>>>0)ha();h=k+p|0;if(k>>>0>=h>>>0)ha();g=c[k+24>>2]|0;d=c[k+12>>2]|0;do if((d|0)==(k|0)){b=k+20|0;a=c[b>>2]|0;if(!a){b=k+16|0;a=c[b>>2]|0;if(!a){u=0;break}}while(1){e=a+20|0;d=c[e>>2]|0;if(d|0){a=d;b=e;continue}e=a+16|0;d=c[e>>2]|0;if(!d)break;else{a=d;b=e}}if(b>>>0<f>>>0)ha();else{c[b>>2]=0;u=a;break}}else{e=c[k+8>>2]|0;if(e>>>0<f>>>0)ha();a=e+12|0;if((c[a>>2]|0)!=(k|0))ha();b=d+8|0;if((c[b>>2]|0)==(k|0)){c[a>>2]=d;c[b>>2]=e;u=d;break}else ha()}while(0);do if(g|0){a=c[k+28>>2]|0;b=14392+(a<<2)|0;if((k|0)==(c[b>>2]|0)){c[b>>2]=u;if(!u){c[3523]=c[3523]&~(1<<a);break}}else{if(g>>>0<(c[3526]|0)>>>0)ha();a=g+16|0;if((c[a>>2]|0)==(k|0))c[a>>2]=u;else c[g+20>>2]=u;if(!u)break}b=c[3526]|0;if(u>>>0<b>>>0)ha();c[u+24>>2]=g;a=c[k+16>>2]|0;do if(a|0)if(a>>>0<b>>>0)ha();else{c[u+16>>2]=a;c[a+24>>2]=u;break}while(0);a=c[k+20>>2]|0;if(a|0)if(a>>>0<(c[3526]|0)>>>0)ha();else{c[u+20>>2]=a;c[a+24>>2]=u;break}}while(0);do if(j>>>0>=16){c[k+4>>2]=p|3;c[h+4>>2]=j|1;c[h+j>>2]=j;a=j>>>3;if(j>>>0<256){d=14128+(a<<1<<2)|0;b=c[3522]|0;a=1<<a;if(b&a){a=d+8|0;b=c[a>>2]|0;if(b>>>0<(c[3526]|0)>>>0)ha();else{w=a;x=b}}else{c[3522]=b|a;w=d+8|0;x=d}c[w>>2]=h;c[x+12>>2]=h;c[h+8>>2]=x;c[h+12>>2]=d;break}a=j>>>8;if(a)if(j>>>0>16777215)b=31;else{I=(a+1048320|0)>>>16&8;J=a<<I;H=(J+520192|0)>>>16&4;J=J<<H;b=(J+245760|0)>>>16&2;b=14-(H|I|b)+(J<<b>>>15)|0;b=j>>>(b+7|0)&1|b<<1}else b=0;e=14392+(b<<2)|0;c[h+28>>2]=b;a=h+16|0;c[a+4>>2]=0;c[a>>2]=0;a=c[3523]|0;d=1<<b;if(!(a&d)){c[3523]=a|d;c[e>>2]=h;c[h+24>>2]=e;c[h+12>>2]=h;c[h+8>>2]=h;break}b=j<<((b|0)==31?0:25-(b>>>1)|0);e=c[e>>2]|0;while(1){if((c[e+4>>2]&-8|0)==(j|0)){C=148;break}d=e+16+(b>>>31<<2)|0;a=c[d>>2]|0;if(!a){C=145;break}else{b=b<<1;e=a}}if((C|0)==145)if(d>>>0<(c[3526]|0)>>>0)ha();else{c[d>>2]=h;c[h+24>>2]=e;c[h+12>>2]=h;c[h+8>>2]=h;break}else if((C|0)==148){b=e+8|0;a=c[b>>2]|0;J=c[3526]|0;if(a>>>0>=J>>>0&e>>>0>=J>>>0){c[a+12>>2]=h;c[b>>2]=h;c[h+8>>2]=a;c[h+12>>2]=e;c[h+24>>2]=0;break}else ha()}}else{J=j+p|0;c[k+4>>2]=J|3;J=k+J+4|0;c[J>>2]=c[J>>2]|1}while(0);J=k+8|0;i=K;return J|0}}}else p=-1;while(0);d=c[3524]|0;if(d>>>0>=p>>>0){b=d-p|0;a=c[3527]|0;if(b>>>0>15){J=a+p|0;c[3527]=J;c[3524]=b;c[J+4>>2]=b|1;c[J+b>>2]=b;c[a+4>>2]=p|3}else{c[3524]=0;c[3527]=0;c[a+4>>2]=d|3;J=a+d+4|0;c[J>>2]=c[J>>2]|1}J=a+8|0;i=K;return J|0}a=c[3525]|0;if(a>>>0>p>>>0){H=a-p|0;c[3525]=H;J=c[3528]|0;I=J+p|0;c[3528]=I;c[I+4>>2]=H|1;c[J+4>>2]=p|3;J=J+8|0;i=K;return J|0}if(!(c[3640]|0)){c[3642]=4096;c[3641]=4096;c[3643]=-1;c[3644]=-1;c[3645]=0;c[3633]=0;x=q&-16^1431655768;c[q>>2]=x;c[3640]=x}g=p+48|0;e=c[3642]|0;h=p+47|0;d=e+h|0;e=0-e|0;j=d&e;if(j>>>0<=p>>>0){J=0;i=K;return J|0}a=c[3632]|0;if(a|0?(w=c[3630]|0,x=w+j|0,x>>>0<=w>>>0|x>>>0>a>>>0):0){J=0;i=K;return J|0}b:do if(!(c[3633]&4)){b=c[3528]|0;c:do if(b){f=14536;while(1){a=c[f>>2]|0;if(a>>>0<=b>>>0?(t=f+4|0,(a+(c[t>>2]|0)|0)>>>0>b>>>0):0)break;a=c[f+8>>2]|0;if(!a){C=171;break c}else f=a}a=d-(c[3525]|0)&e;if(a>>>0<2147483647){b=fa(a|0)|0;if((b|0)==((c[f>>2]|0)+(c[t>>2]|0)|0)){if((b|0)!=(-1|0)){h=b;g=a;C=191;break b}}else C=181}}else C=171;while(0);do if((C|0)==171?(v=fa(0)|0,(v|0)!=(-1|0)):0){a=v;b=c[3641]|0;d=b+-1|0;if(!(d&a))a=j;else a=j-a+(d+a&0-b)|0;b=c[3630]|0;d=b+a|0;if(a>>>0>p>>>0&a>>>0<2147483647){x=c[3632]|0;if(x|0?d>>>0<=b>>>0|d>>>0>x>>>0:0)break;b=fa(a|0)|0;if((b|0)==(v|0)){h=v;g=a;C=191;break b}else C=181}}while(0);d:do if((C|0)==181){d=0-a|0;do if(g>>>0>a>>>0&(a>>>0<2147483647&(b|0)!=(-1|0))?(y=c[3642]|0,y=h-a+y&0-y,y>>>0<2147483647):0)if((fa(y|0)|0)==(-1|0)){fa(d|0)|0;break d}else{a=y+a|0;break}while(0);if((b|0)!=(-1|0)){h=b;g=a;C=191;break b}}while(0);c[3633]=c[3633]|4;C=188}else C=188;while(0);if((((C|0)==188?j>>>0<2147483647:0)?(z=fa(j|0)|0,A=fa(0)|0,z>>>0<A>>>0&((z|0)!=(-1|0)&(A|0)!=(-1|0))):0)?(B=A-z|0,B>>>0>(p+40|0)>>>0):0){h=z;g=B;C=191}if((C|0)==191){a=(c[3630]|0)+g|0;c[3630]=a;if(a>>>0>(c[3631]|0)>>>0)c[3631]=a;l=c[3528]|0;do if(l){f=14536;while(1){a=c[f>>2]|0;e=f+4|0;b=c[e>>2]|0;if((h|0)==(a+b|0)){C=201;break}d=c[f+8>>2]|0;if(!d)break;else f=d}if(((C|0)==201?(c[f+12>>2]&8|0)==0:0)?l>>>0<h>>>0&l>>>0>=a>>>0:0){c[e>>2]=b+g;J=l+8|0;J=(J&7|0)==0?0:0-J&7;I=l+J|0;J=g-J+(c[3525]|0)|0;c[3528]=I;c[3525]=J;c[I+4>>2]=J|1;c[I+J+4>>2]=40;c[3529]=c[3644];break}a=c[3526]|0;if(h>>>0<a>>>0){c[3526]=h;j=h}else j=a;b=h+g|0;a=14536;while(1){if((c[a>>2]|0)==(b|0)){C=209;break}a=c[a+8>>2]|0;if(!a){b=14536;break}}if((C|0)==209)if(!(c[a+12>>2]&8)){c[a>>2]=h;n=a+4|0;c[n>>2]=(c[n>>2]|0)+g;n=h+8|0;n=h+((n&7|0)==0?0:0-n&7)|0;a=b+8|0;a=b+((a&7|0)==0?0:0-a&7)|0;m=n+p|0;k=a-n-p|0;c[n+4>>2]=p|3;do if((a|0)!=(l|0)){if((a|0)==(c[3527]|0)){J=(c[3524]|0)+k|0;c[3524]=J;c[3527]=m;c[m+4>>2]=J|1;c[m+J>>2]=J;break}b=c[a+4>>2]|0;if((b&3|0)==1){h=b&-8;f=b>>>3;e:do if(b>>>0>=256){g=c[a+24>>2]|0;e=c[a+12>>2]|0;do if((e|0)==(a|0)){e=a+16|0;d=e+4|0;b=c[d>>2]|0;if(!b){b=c[e>>2]|0;if(!b){H=0;break}else f=e}else f=d;while(1){e=b+20|0;d=c[e>>2]|0;if(d|0){b=d;f=e;continue}e=b+16|0;d=c[e>>2]|0;if(!d)break;else{b=d;f=e}}if(f>>>0<j>>>0)ha();else{c[f>>2]=0;H=b;break}}else{f=c[a+8>>2]|0;if(f>>>0<j>>>0)ha();b=f+12|0;if((c[b>>2]|0)!=(a|0))ha();d=e+8|0;if((c[d>>2]|0)==(a|0)){c[b>>2]=e;c[d>>2]=f;H=e;break}else ha()}while(0);if(!g)break;b=c[a+28>>2]|0;d=14392+(b<<2)|0;do if((a|0)!=(c[d>>2]|0)){if(g>>>0<(c[3526]|0)>>>0)ha();b=g+16|0;if((c[b>>2]|0)==(a|0))c[b>>2]=H;else c[g+20>>2]=H;if(!H)break e}else{c[d>>2]=H;if(H|0)break;c[3523]=c[3523]&~(1<<b);break e}while(0);e=c[3526]|0;if(H>>>0<e>>>0)ha();c[H+24>>2]=g;d=a+16|0;b=c[d>>2]|0;do if(b|0)if(b>>>0<e>>>0)ha();else{c[H+16>>2]=b;c[b+24>>2]=H;break}while(0);b=c[d+4>>2]|0;if(!b)break;if(b>>>0<(c[3526]|0)>>>0)ha();else{c[H+20>>2]=b;c[b+24>>2]=H;break}}else{d=c[a+8>>2]|0;e=c[a+12>>2]|0;b=14128+(f<<1<<2)|0;do if((d|0)!=(b|0)){if(d>>>0<j>>>0)ha();if((c[d+12>>2]|0)==(a|0))break;ha()}while(0);if((e|0)==(d|0)){c[3522]=c[3522]&~(1<<f);break}do if((e|0)==(b|0))E=e+8|0;else{if(e>>>0<j>>>0)ha();b=e+8|0;if((c[b>>2]|0)==(a|0)){E=b;break}ha()}while(0);c[d+12>>2]=e;c[E>>2]=d}while(0);a=a+h|0;f=h+k|0}else f=k;a=a+4|0;c[a>>2]=c[a>>2]&-2;c[m+4>>2]=f|1;c[m+f>>2]=f;a=f>>>3;if(f>>>0<256){d=14128+(a<<1<<2)|0;b=c[3522]|0;a=1<<a;do if(!(b&a)){c[3522]=b|a;I=d+8|0;J=d}else{a=d+8|0;b=c[a>>2]|0;if(b>>>0>=(c[3526]|0)>>>0){I=a;J=b;break}ha()}while(0);c[I>>2]=m;c[J+12>>2]=m;c[m+8>>2]=J;c[m+12>>2]=d;break}a=f>>>8;do if(!a)b=0;else{if(f>>>0>16777215){b=31;break}I=(a+1048320|0)>>>16&8;J=a<<I;H=(J+520192|0)>>>16&4;J=J<<H;b=(J+245760|0)>>>16&2;b=14-(H|I|b)+(J<<b>>>15)|0;b=f>>>(b+7|0)&1|b<<1}while(0);e=14392+(b<<2)|0;c[m+28>>2]=b;a=m+16|0;c[a+4>>2]=0;c[a>>2]=0;a=c[3523]|0;d=1<<b;if(!(a&d)){c[3523]=a|d;c[e>>2]=m;c[m+24>>2]=e;c[m+12>>2]=m;c[m+8>>2]=m;break}b=f<<((b|0)==31?0:25-(b>>>1)|0);e=c[e>>2]|0;while(1){if((c[e+4>>2]&-8|0)==(f|0)){C=279;break}d=e+16+(b>>>31<<2)|0;a=c[d>>2]|0;if(!a){C=276;break}else{b=b<<1;e=a}}if((C|0)==276)if(d>>>0<(c[3526]|0)>>>0)ha();else{c[d>>2]=m;c[m+24>>2]=e;c[m+12>>2]=m;c[m+8>>2]=m;break}else if((C|0)==279){b=e+8|0;a=c[b>>2]|0;J=c[3526]|0;if(a>>>0>=J>>>0&e>>>0>=J>>>0){c[a+12>>2]=m;c[b>>2]=m;c[m+8>>2]=a;c[m+12>>2]=e;c[m+24>>2]=0;break}else ha()}}else{J=(c[3525]|0)+k|0;c[3525]=J;c[3528]=m;c[m+4>>2]=J|1}while(0);J=n+8|0;i=K;return J|0}else b=14536;while(1){a=c[b>>2]|0;if(a>>>0<=l>>>0?(D=a+(c[b+4>>2]|0)|0,D>>>0>l>>>0):0)break;b=c[b+8>>2]|0}f=D+-47|0;b=f+8|0;b=f+((b&7|0)==0?0:0-b&7)|0;f=l+16|0;b=b>>>0<f>>>0?l:b;a=b+8|0;d=h+8|0;d=(d&7|0)==0?0:0-d&7;J=h+d|0;d=g+-40-d|0;c[3528]=J;c[3525]=d;c[J+4>>2]=d|1;c[J+d+4>>2]=40;c[3529]=c[3644];d=b+4|0;c[d>>2]=27;c[a>>2]=c[3634];c[a+4>>2]=c[3635];c[a+8>>2]=c[3636];c[a+12>>2]=c[3637];c[3634]=h;c[3635]=g;c[3637]=0;c[3636]=a;a=b+24|0;do{a=a+4|0;c[a>>2]=7}while((a+4|0)>>>0<D>>>0);if((b|0)!=(l|0)){g=b-l|0;c[d>>2]=c[d>>2]&-2;c[l+4>>2]=g|1;c[b>>2]=g;a=g>>>3;if(g>>>0<256){d=14128+(a<<1<<2)|0;b=c[3522]|0;a=1<<a;if(b&a){a=d+8|0;b=c[a>>2]|0;if(b>>>0<(c[3526]|0)>>>0)ha();else{F=a;G=b}}else{c[3522]=b|a;F=d+8|0;G=d}c[F>>2]=l;c[G+12>>2]=l;c[l+8>>2]=G;c[l+12>>2]=d;break}a=g>>>8;if(a)if(g>>>0>16777215)d=31;else{I=(a+1048320|0)>>>16&8;J=a<<I;H=(J+520192|0)>>>16&4;J=J<<H;d=(J+245760|0)>>>16&2;d=14-(H|I|d)+(J<<d>>>15)|0;d=g>>>(d+7|0)&1|d<<1}else d=0;e=14392+(d<<2)|0;c[l+28>>2]=d;c[l+20>>2]=0;c[f>>2]=0;a=c[3523]|0;b=1<<d;if(!(a&b)){c[3523]=a|b;c[e>>2]=l;c[l+24>>2]=e;c[l+12>>2]=l;c[l+8>>2]=l;break}b=g<<((d|0)==31?0:25-(d>>>1)|0);e=c[e>>2]|0;while(1){if((c[e+4>>2]&-8|0)==(g|0)){C=305;break}d=e+16+(b>>>31<<2)|0;a=c[d>>2]|0;if(!a){C=302;break}else{b=b<<1;e=a}}if((C|0)==302)if(d>>>0<(c[3526]|0)>>>0)ha();else{c[d>>2]=l;c[l+24>>2]=e;c[l+12>>2]=l;c[l+8>>2]=l;break}else if((C|0)==305){b=e+8|0;a=c[b>>2]|0;J=c[3526]|0;if(a>>>0>=J>>>0&e>>>0>=J>>>0){c[a+12>>2]=l;c[b>>2]=l;c[l+8>>2]=a;c[l+12>>2]=e;c[l+24>>2]=0;break}else ha()}}}else{J=c[3526]|0;if((J|0)==0|h>>>0<J>>>0)c[3526]=h;c[3634]=h;c[3635]=g;c[3637]=0;c[3531]=c[3640];c[3530]=-1;a=0;do{J=14128+(a<<1<<2)|0;c[J+12>>2]=J;c[J+8>>2]=J;a=a+1|0}while((a|0)!=32);J=h+8|0;J=(J&7|0)==0?0:0-J&7;I=h+J|0;J=g+-40-J|0;c[3528]=I;c[3525]=J;c[I+4>>2]=J|1;c[I+J+4>>2]=40;c[3529]=c[3644]}while(0);a=c[3525]|0;if(a>>>0>p>>>0){H=a-p|0;c[3525]=H;J=c[3528]|0;I=J+p|0;c[3528]=I;c[I+4>>2]=H|1;c[J+4>>2]=p|3;J=J+8|0;i=K;return J|0}}if(!(c[3510]|0))a=14084;else a=c[(bb()|0)+64>>2]|0;c[a>>2]=12;J=0;i=K;return J|0}
function Za(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;if(!a)return;d=a+-8|0;h=c[3526]|0;if(d>>>0<h>>>0)ha();a=c[a+-4>>2]|0;b=a&3;if((b|0)==1)ha();e=a&-8;n=d+e|0;do if(!(a&1)){a=c[d>>2]|0;if(!b)return;k=d+(0-a)|0;j=a+e|0;if(k>>>0<h>>>0)ha();if((k|0)==(c[3527]|0)){b=n+4|0;a=c[b>>2]|0;if((a&3|0)!=3){q=k;f=j;break}c[3524]=j;c[b>>2]=a&-2;c[k+4>>2]=j|1;c[k+j>>2]=j;return}e=a>>>3;if(a>>>0<256){b=c[k+8>>2]|0;d=c[k+12>>2]|0;a=14128+(e<<1<<2)|0;if((b|0)!=(a|0)){if(b>>>0<h>>>0)ha();if((c[b+12>>2]|0)!=(k|0))ha()}if((d|0)==(b|0)){c[3522]=c[3522]&~(1<<e);q=k;f=j;break}if((d|0)!=(a|0)){if(d>>>0<h>>>0)ha();a=d+8|0;if((c[a>>2]|0)==(k|0))g=a;else ha()}else g=d+8|0;c[b+12>>2]=d;c[g>>2]=b;q=k;f=j;break}g=c[k+24>>2]|0;d=c[k+12>>2]|0;do if((d|0)==(k|0)){d=k+16|0;b=d+4|0;a=c[b>>2]|0;if(!a){a=c[d>>2]|0;if(!a){i=0;break}else e=d}else e=b;while(1){d=a+20|0;b=c[d>>2]|0;if(b|0){a=b;e=d;continue}d=a+16|0;b=c[d>>2]|0;if(!b)break;else{a=b;e=d}}if(e>>>0<h>>>0)ha();else{c[e>>2]=0;i=a;break}}else{e=c[k+8>>2]|0;if(e>>>0<h>>>0)ha();a=e+12|0;if((c[a>>2]|0)!=(k|0))ha();b=d+8|0;if((c[b>>2]|0)==(k|0)){c[a>>2]=d;c[b>>2]=e;i=d;break}else ha()}while(0);if(g){a=c[k+28>>2]|0;b=14392+(a<<2)|0;if((k|0)==(c[b>>2]|0)){c[b>>2]=i;if(!i){c[3523]=c[3523]&~(1<<a);q=k;f=j;break}}else{if(g>>>0<(c[3526]|0)>>>0)ha();a=g+16|0;if((c[a>>2]|0)==(k|0))c[a>>2]=i;else c[g+20>>2]=i;if(!i){q=k;f=j;break}}d=c[3526]|0;if(i>>>0<d>>>0)ha();c[i+24>>2]=g;b=k+16|0;a=c[b>>2]|0;do if(a|0)if(a>>>0<d>>>0)ha();else{c[i+16>>2]=a;c[a+24>>2]=i;break}while(0);a=c[b+4>>2]|0;if(a)if(a>>>0<(c[3526]|0)>>>0)ha();else{c[i+20>>2]=a;c[a+24>>2]=i;q=k;f=j;break}else{q=k;f=j}}else{q=k;f=j}}else{q=d;f=e}while(0);if(q>>>0>=n>>>0)ha();a=n+4|0;b=c[a>>2]|0;if(!(b&1))ha();if(!(b&2)){if((n|0)==(c[3528]|0)){p=(c[3525]|0)+f|0;c[3525]=p;c[3528]=q;c[q+4>>2]=p|1;if((q|0)!=(c[3527]|0))return;c[3527]=0;c[3524]=0;return}if((n|0)==(c[3527]|0)){p=(c[3524]|0)+f|0;c[3524]=p;c[3527]=q;c[q+4>>2]=p|1;c[q+p>>2]=p;return}f=(b&-8)+f|0;e=b>>>3;do if(b>>>0>=256){g=c[n+24>>2]|0;a=c[n+12>>2]|0;do if((a|0)==(n|0)){d=n+16|0;b=d+4|0;a=c[b>>2]|0;if(!a){a=c[d>>2]|0;if(!a){m=0;break}else e=d}else e=b;while(1){d=a+20|0;b=c[d>>2]|0;if(b|0){a=b;e=d;continue}d=a+16|0;b=c[d>>2]|0;if(!b)break;else{a=b;e=d}}if(e>>>0<(c[3526]|0)>>>0)ha();else{c[e>>2]=0;m=a;break}}else{b=c[n+8>>2]|0;if(b>>>0<(c[3526]|0)>>>0)ha();d=b+12|0;if((c[d>>2]|0)!=(n|0))ha();e=a+8|0;if((c[e>>2]|0)==(n|0)){c[d>>2]=a;c[e>>2]=b;m=a;break}else ha()}while(0);if(g|0){a=c[n+28>>2]|0;b=14392+(a<<2)|0;if((n|0)==(c[b>>2]|0)){c[b>>2]=m;if(!m){c[3523]=c[3523]&~(1<<a);break}}else{if(g>>>0<(c[3526]|0)>>>0)ha();a=g+16|0;if((c[a>>2]|0)==(n|0))c[a>>2]=m;else c[g+20>>2]=m;if(!m)break}d=c[3526]|0;if(m>>>0<d>>>0)ha();c[m+24>>2]=g;b=n+16|0;a=c[b>>2]|0;do if(a|0)if(a>>>0<d>>>0)ha();else{c[m+16>>2]=a;c[a+24>>2]=m;break}while(0);a=c[b+4>>2]|0;if(a|0)if(a>>>0<(c[3526]|0)>>>0)ha();else{c[m+20>>2]=a;c[a+24>>2]=m;break}}}else{b=c[n+8>>2]|0;d=c[n+12>>2]|0;a=14128+(e<<1<<2)|0;if((b|0)!=(a|0)){if(b>>>0<(c[3526]|0)>>>0)ha();if((c[b+12>>2]|0)!=(n|0))ha()}if((d|0)==(b|0)){c[3522]=c[3522]&~(1<<e);break}if((d|0)!=(a|0)){if(d>>>0<(c[3526]|0)>>>0)ha();a=d+8|0;if((c[a>>2]|0)==(n|0))l=a;else ha()}else l=d+8|0;c[b+12>>2]=d;c[l>>2]=b}while(0);c[q+4>>2]=f|1;c[q+f>>2]=f;if((q|0)==(c[3527]|0)){c[3524]=f;return}}else{c[a>>2]=b&-2;c[q+4>>2]=f|1;c[q+f>>2]=f}a=f>>>3;if(f>>>0<256){d=14128+(a<<1<<2)|0;b=c[3522]|0;a=1<<a;if(b&a){a=d+8|0;b=c[a>>2]|0;if(b>>>0<(c[3526]|0)>>>0)ha();else{o=a;p=b}}else{c[3522]=b|a;o=d+8|0;p=d}c[o>>2]=q;c[p+12>>2]=q;c[q+8>>2]=p;c[q+12>>2]=d;return}a=f>>>8;if(a)if(f>>>0>16777215)b=31;else{o=(a+1048320|0)>>>16&8;p=a<<o;n=(p+520192|0)>>>16&4;p=p<<n;b=(p+245760|0)>>>16&2;b=14-(n|o|b)+(p<<b>>>15)|0;b=f>>>(b+7|0)&1|b<<1}else b=0;e=14392+(b<<2)|0;c[q+28>>2]=b;c[q+20>>2]=0;c[q+16>>2]=0;a=c[3523]|0;d=1<<b;do if(a&d){b=f<<((b|0)==31?0:25-(b>>>1)|0);e=c[e>>2]|0;while(1){if((c[e+4>>2]&-8|0)==(f|0)){a=130;break}d=e+16+(b>>>31<<2)|0;a=c[d>>2]|0;if(!a){a=127;break}else{b=b<<1;e=a}}if((a|0)==127)if(d>>>0<(c[3526]|0)>>>0)ha();else{c[d>>2]=q;c[q+24>>2]=e;c[q+12>>2]=q;c[q+8>>2]=q;break}else if((a|0)==130){b=e+8|0;a=c[b>>2]|0;p=c[3526]|0;if(a>>>0>=p>>>0&e>>>0>=p>>>0){c[a+12>>2]=q;c[b>>2]=q;c[q+8>>2]=a;c[q+12>>2]=e;c[q+24>>2]=0;break}else ha()}}else{c[3523]=a|d;c[e>>2]=q;c[q+24>>2]=e;c[q+12>>2]=q;c[q+8>>2]=q}while(0);q=(c[3530]|0)+-1|0;c[3530]=q;if(!q)a=14544;else return;while(1){a=c[a>>2]|0;if(!a)break;else a=a+8|0}c[3530]=-1;return}function _a(){}function $a(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;f=b+e|0;if((e|0)>=20){d=d&255;h=b&3;i=d|d<<8|d<<16|d<<24;g=f&~3;if(h){h=b+4-h|0;while((b|0)<(h|0)){a[b>>0]=d;b=b+1|0}}while((b|0)<(g|0)){c[b>>2]=i;b=b+4|0}}while((b|0)<(f|0)){a[b>>0]=d;b=b+1|0}return b-e|0}function ab(a){a=a|0;return (a&255)<<24|(a>>8&255)<<16|(a>>16&255)<<8|a>>>24|0}function bb(){return 0}function cb(b,d,e){b=b|0;d=d|0;e=e|0;var f=0;if((e|0)>=4096)return ga(b|0,d|0,e|0)|0;f=b|0;if((b&3)==(d&3)){while(b&3){if(!e)return f|0;a[b>>0]=a[d>>0]|0;b=b+1|0;d=d+1|0;e=e-1|0}while((e|0)>=4){c[b>>2]=c[d>>2];b=b+4|0;d=d+4|0;e=e-4|0}}while((e|0)>0){a[b>>0]=a[d>>0]|0;b=b+1|0;d=d+1|0;e=e-1|0}return f|0}function db(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return ka[a&1](b|0,c|0,d|0)|0}function eb(a,b,c){a=a|0;b=b|0;c=c|0;la[a&1](b|0,c|0)}function fb(a,b,c){a=a|0;b=b|0;c=c|0;return ma[a&3](b|0,c|0)|0}function gb(a,b,c){a=a|0;b=b|0;c=c|0;aa(0);return 0}function hb(a,b){a=a|0;b=b|0;aa(1)}function ib(a,b){a=a|0;b=b|0;aa(2);return 0}

// EMSCRIPTEN_END_FUNCS
var ka=[gb,Ua];var la=[hb,Va];var ma=[ib,Fa,Ha,Ja];return{_free:Za,_ZLIBJS_freeInflateContext:Ca,_ZLIBJS_createInflateContext:Aa,_pthread_self:bb,_memset:$a,_ZLIBJS_freeDeflateContext:za,_malloc:Ya,_ZLIBJS_deflate:ya,_memcpy:cb,_llvm_bswap_i32:ab,_ZLIBJS_inflate:Ba,_ZLIBJS_createDeflateContext:xa,_ZLIBJS_init:wa,runPostSets:_a,stackAlloc:na,stackSave:oa,stackRestore:pa,establishStackSpace:qa,setThrew:ra,setTempRet0:ua,getTempRet0:va,dynCall_iiii:db,dynCall_vii:eb,dynCall_iii:fb}})


// EMSCRIPTEN_END_ASM
(b.q,b.r,buffer),Q=b._free=Z._free;b._ZLIBJS_inflate=Z._ZLIBJS_inflate;b._ZLIBJS_createInflateContext=Z._ZLIBJS_createInflateContext;var xa=b._pthread_self=Z._pthread_self,va=b._memset=Z._memset;b._ZLIBJS_freeDeflateContext=Z._ZLIBJS_freeDeflateContext;var N=b._malloc=Z._malloc;
b._ZLIBJS_deflate=Z._ZLIBJS_deflate;var ya=b._memcpy=Z._memcpy;b._ZLIBJS_init=Z._ZLIBJS_init;b._ZLIBJS_freeInflateContext=Z._ZLIBJS_freeInflateContext;b._ZLIBJS_createDeflateContext=Z._ZLIBJS_createDeflateContext;var wa=b._llvm_bswap_i32=Z._llvm_bswap_i32;b.runPostSets=Z.runPostSets;b.dynCall_iiii=Z.dynCall_iiii;b.dynCall_vii=Z.dynCall_vii;b.dynCall_iii=Z.dynCall_iii;B.m=Z.stackAlloc;B.B=Z.stackSave;B.A=Z.stackRestore;B.H=Z.establishStackSpace;B.w=Z.setTempRet0;B.u=Z.getTempRet0;
function y(a){this.name="ExitStatus";this.message="Program terminated with exit("+a+")";this.status=a}y.prototype=Error();y.prototype.constructor=y;var za=null;
b.callMain=b.F=function(a){function c(){for(var a=0;3>a;a++)e.push(0)}a=a||[];X||(X=!0,V(W));var d=a.length+1,e=[M(P(b.thisProgram),"i8",0)];c();for(var g=0;g<d-1;g+=1)e.push(M(P(a[g]),"i8",0)),c();e.push(0);e=M(e,"i32",0);try{var l=b._main(d,e,0);Aa(l,!0)}catch(m){if(!(m instanceof y))if("SimulateInfiniteLoop"==m)b.noExitRuntime=!0;else throw m&&"object"===typeof m&&m.stack&&b.h("exception thrown: "+[m,m.stack]),m;}finally{}};
function Ba(a){function c(){if(!b.calledRun&&(b.calledRun=!0,!G)){X||(X=!0,V(W));V(oa);if(b.onRuntimeInitialized)b.onRuntimeInitialized();b._main&&Ca&&b.callMain(a);if(b.postRun)for("function"==typeof b.postRun&&(b.postRun=[b.postRun]);b.postRun.length;){var c=b.postRun.shift();qa.unshift(c)}V(qa)}}a=a||b.arguments;null===za&&(za=Date.now());if(b.preRun)for("function"==typeof b.preRun&&(b.preRun=[b.preRun]);b.preRun.length;)ra();V(na);b.calledRun||(b.setStatus?(b.setStatus("Running..."),setTimeout(function(){setTimeout(function(){b.setStatus("")},
1);c()},1)):c())}b.run=b.run=Ba;function Aa(a,c){if(!c||!b.noExitRuntime){if(!b.noExitRuntime&&(G=!0,z=void 0,V(pa),b.onExit))b.onExit(a);r?process.exit(a):t&&"function"===typeof quit&&quit(a);throw new y(a);}}b.exit=b.exit=Aa;var Da=[];function F(a){void 0!==a?(b.print(a),b.h(a),a=JSON.stringify(a)):a="";G=!0;var c="abort("+a+") at "+ga()+"\nIf this abort() is unexpected, build with -s ASSERTIONS=1 which can give more information.";Da&&Da.forEach(function(d){c=d(c,a)});throw c;}b.abort=b.abort=F;
if(b.preInit)for("function"==typeof b.preInit&&(b.preInit=[b.preInit]);0<b.preInit.length;)b.preInit.pop()();var Ca=!0;b.noInitialRun&&(Ca=!1);Ba();var sa=b.ZLIBJS_instances={};module.exports=b;


}).call(this,"/Users/ukyo/work/zlib-asm/lib")
},{"fs":undefined,"path":undefined}],7:[function(require,module,exports){
var Module=require("./Module"),ReaderWriterMixin={$read:function(r,e){return Module.HEAPU8.set(this.src.subarray(this.offset,this.offset+this.srcSize),r),this.srcSize},$write:function(r,e){var i=Module.HEAPU8.subarray(r,r+e);i=this.shareMemory?i:new Uint8Array(i),this.streamFn(i)}};ReaderWriterMixin.$read=ReaderWriterMixin.$read,ReaderWriterMixin.$write=ReaderWriterMixin.$write,module.exports=ReaderWriterMixin;
},{"./Module":6}],8:[function(require,module,exports){
function assign(r){return Array.prototype.slice.call(arguments,1).forEach(function(e){null!=e&&"object"==typeof e&&Object.keys(e).forEach(function(n){var R=e[n];null!=R&&("object"==typeof R?(r[n]=r[n]||{},assign(r[n],R)):r[n]=R)})}),r}function concat(r){var e,n,R=0;return e=r.map(function(r){return r.length}).reduce(function(r,e){return r+e},0),n=new Uint8Array(e),r.forEach(function(r){n.set(r,R),R+=r.length}),n}function zerror(r){return new Error("zlib-asm: "+r)}function validate(r){return{valid:r>=0,error:ERROR_TABLE[r]}}var Z_STREAM_ERROR=-2,Z_DATA_ERROR=-3,Z_MEM_ERROR=-4,Z_VERSION_ERROR=-6,ERROR_TABLE={};ERROR_TABLE[Z_STREAM_ERROR]="invalid compression level",ERROR_TABLE[Z_DATA_ERROR]="invalid or incomplete deflate data",ERROR_TABLE[Z_MEM_ERROR]="out of memory",ERROR_TABLE[Z_VERSION_ERROR]="zlib version mismatch";var defaultParams={compressionLevel:6,chunkSize:32768,shareMemory:!1,src:null,streamFn:function(){}};module.exports={defaultParams:defaultParams,assign:assign,concat:concat,zerror:zerror,validate:validate};
},{}],9:[function(require,module,exports){
function zlibDeflate(e,l,t,a){var n=[],r=new Deflate(e,{input:l,compressionLevel:t,chunkSize:a,shareMemory:!1,streamFn:function(e){n.push(e)}});return r.deflateAll(),common.concat(n)}function zlibOldDeflateStream(e,l){var t=new Deflate(e,l);t.deflateAll()}var common=require("./common"),Deflate=require("./Deflate"),oldStream=module.exports.stream={};module.exports.deflate=zlibDeflate.bind(null,1),module.exports.rawDeflate=zlibDeflate.bind(null,-1),oldStream.deflate=zlibOldDeflateStream.bind(null,1),oldStream.rawDeflate=zlibOldDeflateStream.bind(null,-1);
},{"./Deflate":4,"./common":8}],10:[function(require,module,exports){
function zlibInflate(l,e,n){var t=[],a=new Inflate(l,{input:e,chunkSize:n,shareMemory:!1,streamFn:function(l){t.push(l)}});return a.inflateAll(),common.concat(t)}function zlibOldInflateStream(l,e){var n=new Inflate(l,e);n.inflateAll()}var common=require("./common"),Inflate=require("./Inflate"),oldStream=module.exports.stream={};module.exports.inflate=zlibInflate.bind(null,1),module.exports.rawInflate=zlibInflate.bind(null,-1),oldStream.inflate=zlibOldInflateStream.bind(null,1),oldStream.rawInflate=zlibOldInflateStream.bind(null,-1);
},{"./Inflate":5,"./common":8}]},{},[1]);
